//js code packages
import React, { Component, useState } from 'react';
import { observer, inject } from 'mobx-react';

//generic components and js functions
import * as JSFUNC from '../../Library/JSFUNC.js';
import * as LibraryReact from '../../Library/LibraryReact.js';
import * as CEC from "../../CaptureExecGeneral/CEC.js";
import * as JSPHP from '../../CaptureExecLocalDatabaseMobx/JSPHP.js';
import * as CEGeneralReact from '../../CaptureExecGeneral/CEGeneralReact.js';
import * as CEComplexReact from '../../CaptureExecGeneral/CEComplexReact.js';
import * as CEIconsReact from '../../CaptureExecGeneral/CEIconsReact.js';

import * as CapturesReact from '../Captures/CapturesReact.js';
import * as ContactsReact from '../Contacts/ContactsReact.js';
import * as OpenCaptureReact from '../OpenCapture/OpenCaptureReact.js';
import * as RightPanelReact from '../RightPanel/RightPanelReact.js';
import * as TeammateContractsReact from '../TeammateContracts/TeammateContractsReact.js';

import DatabaseMobx from '../../CaptureExecLocalDatabaseMobx/DatabaseMobx.js';


export const AdminSubtabDivisions = inject("CaptureExecMobx", "CapturesMobx")(observer(
class AdminSubtabDivisions extends Component { //props: none
  constructor(props) {
    super(props);
    this.state = {
      s_creatingNewDivisionTF: false,
      s_editingDivisionSettingsTF: false
    };
  }

  onclick_open_create_new_division_floating_box = () => {
    this.setState({s_creatingNewDivisionTF:true});
  }

  onclick_close_create_new_division_floating_box = () => {
    this.setState({s_creatingNewDivisionTF:false});
  }

  onclick_open_edit_division_settings_floating_box = () => {
    this.setState({s_editingDivisionSettingsTF:true});
  }

  onclick_close_edit_division_settings_floating_box = () => {
    this.setState({s_editingDivisionSettingsTF:false});
  }

  render() {
    const s_creatingNewDivisionTF = this.state.s_creatingNewDivisionTF;
    const s_editingDivisionSettingsTF = this.state.s_editingDivisionSettingsTF;
    
    const c_productStylingObj = this.props.CaptureExecMobx.c_productStylingObj;
    const c_captureTableCurrentlyProcessingCapturesTF = this.props.CapturesMobx.c_captureTableCurrentlyProcessingCapturesTF;

    return (
      <div className="flex11a yScroll yScrollBottomPad">
        {(c_productStylingObj.setupCompanyCanCreateDivisionsTF || c_productStylingObj.setupCompanyCanEditDivisionSettingsTF) &&
          <div className="displayFlexRow bgLighterBlue borderB1ddd" style={{height:"4em"}}>
            <div className="flex11a displayFlexRowVc lrMedPad">
              {(c_productStylingObj.setupCompanyCanCreateDivisionsTF) &&
                <CEGeneralReact.CEButton
                  p_type="blue"
                  p_text="Create New Division"
                  f_onClick={this.onclick_open_create_new_division_floating_box}
                />
              }
            </div>
            {(c_productStylingObj.setupCompanyCanEditDivisionSettingsTF) &&
              <div className="flex00a displayFlexColumnHcVc lrMedPad borderL1ddd">
                <CEGeneralReact.CEButton
                  p_type="add"
                  p_text="Edit General Division Settings"
                  f_onClick={this.onclick_open_edit_division_settings_floating_box}
                />
              </div>
            }
          </div>
        }
        {(c_captureTableCurrentlyProcessingCapturesTF) ? (
          <CEGeneralReact.EmptyScreenGrayWithLoadingAnimation>
            {"Processing Captures"}
          </CEGeneralReact.EmptyScreenGrayWithLoadingAnimation>
        ) : (
          <DivisionsListWithUnassignedMatchingCapturesBox />
        )}
        {(s_creatingNewDivisionTF) &&
          <DivisionsCreateNewDivisionFloatingBox
            f_onClose={this.onclick_close_create_new_division_floating_box}
          />
        }
        {(s_editingDivisionSettingsTF) &&
          <DivisionsEditDivisionSettingsFloatingBox
            f_onClose={this.onclick_close_edit_division_settings_floating_box}
          />
        }
      </div>
    );
  }
}));

const DivisionsListWithUnassignedMatchingCapturesBox = inject("AdminMobx", "DatabaseMobx")(observer(
class DivisionsListWithUnassignedMatchingCapturesBox extends Component { //props: none
  render() {
    const c_adminAllDivisionsArrayOfObjs = this.props.AdminMobx.c_adminAllDivisionsArrayOfObjs;
    const c_divisionsUnassignedMatchingCapturesObj = this.props.AdminMobx.c_divisionsUnassignedMatchingCapturesObj;
    const c_fieldMapOfDivisionOwners = this.props.DatabaseMobx.c_fieldMapOfDivisionOwners;

    return (
      <>
        <div className="smallTopMargin" />
        {c_adminAllDivisionsArrayOfObjs.map((m_divisionObj) =>
          <AdminDivision
            key={m_divisionObj.id}
            p_divisionObj={m_divisionObj}
          />
        )}
        <div className="hugeTopMargin lrMedMargin">
          <CEComplexReact.UnassignedMatchingCapturesBoxAndCountButton
            p_unassignedMatchingCapturesObj={c_divisionsUnassignedMatchingCapturesObj}
            p_fieldDisplayName={c_fieldMapOfDivisionOwners.get("display_name")}
          />
        </div>
      </>
    );
  }
}));

const DivisionsEditDivisionSettingsFloatingBox = inject("CaptureExecMobx", "AdminMobx", "DatabaseMobx")(observer(
class DivisionsEditDivisionSettingsFloatingBox extends Component { //props: f_onClose
  onsave_company_prime_sb_certs_can_vary_per_division = () => {
    const c_companyPrimeSBCertsCanVaryPerDivisionTF = this.props.DatabaseMobx.c_companyPrimeSBCertsCanVaryPerDivisionTF;
    const newValue01 = ((c_companyPrimeSBCertsCanVaryPerDivisionTF) ? (0) : (1));
    this.props.AdminMobx.a_divisions_update_company_prime_sb_certs_can_vary_per_division(newValue01);
  }

  onsave_company_using_division_firewalling = () => {
    const c_companyUsingDivisionFirewallingTF = this.props.DatabaseMobx.c_companyUsingDivisionFirewallingTF;
    const newValue01 = ((c_companyUsingDivisionFirewallingTF) ? (0) : (1));
    this.props.AdminMobx.a_divisions_update_company_using_division_firewalling(newValue01);
  }

  render() {
    const f_onClose = this.props.f_onClose;

    const c_productStylingObj = this.props.CaptureExecMobx.c_productStylingObj;
    const c_companyPrimeSBCertsCanVaryPerDivisionTF = this.props.DatabaseMobx.c_companyPrimeSBCertsCanVaryPerDivisionTF;
    const c_companyUsingDivisionFirewallingTF = this.props.DatabaseMobx.c_companyUsingDivisionFirewallingTF;
    const c_cardNameTeammates = this.props.DatabaseMobx.c_cardNameTeammates;

    return (
      <CEGeneralReact.FloatingBoxWithSaveCancel
        p_trblFlag="addEditDeleteTableEditItem"
        p_title="Edit General Division Settings"
        f_onClickSave={f_onClose}>
        <div className="flex11a yScroll medFullPad">
          <div className="smallBottomMargin">
            <font className="font12 fontBold fontDarkBlue">
              {"Small Business Certifications per Division"}
            </font>
          </div>
          <div className="medBottomMargin">
            <div><font className="fontItalic fontTextLight">{"On the Capture " + c_cardNameTeammates + " Card, one of our Divisions can be selected to represent 'Our Company', whether it's the Prime, or a Sub based on the selected Capture Type. This switch determines the Small Business Certifications associated with each Division."}</font></div>
            <div className="lrMedPad"><font className="fontItalic fontTextLight">{"- When the switch is off, all divisions in " + c_productStylingObj.productName + " have the same SB Certs specified in the top level Division."}</font></div>
            <div className="lrMedPad"><font className="fontItalic fontTextLight">{"- When the switch is on, each division can define their own SB Certs."}</font></div>
            <div className="smallTopMargin"><font className="fontItalic fontTextLight">{"[Note: when turning this switch off, any unique SB Cert settings for each division will be lost and overwritten with the settings in the top level Division when turned back on]"}</font></div>
          </div>
          <div className="">
            <CEGeneralReact.SwitchWithTextAndConfirmBox
              p_isOnTF={c_companyPrimeSBCertsCanVaryPerDivisionTF}
              p_onText="When teaming, our Small Business Certifications can vary per division"
              p_offText="When teaming, our Small Business Certifications are the same for every division, as defined at the top level division"
              p_switchToOffMessage="Note: when turning this switch off, any unique SB Cert settings for each division will be lost and overwritten with the settings in the top level Division when turned back on"
              f_onSwitch={this.onsave_company_prime_sb_certs_can_vary_per_division}
            />
          </div>
          <div className="borderB1bbb hugeTopMargin hugeBottomMargin" />
          <div className="smallBottomMargin">
            <font className="font12 fontBold fontDarkBlue">
              {"Division Firewalling"}
            </font>
          </div>
          <div className="medBottomMargin">
            <div><font className="fontItalic fontTextLight">{"Every " + c_productStylingObj.productName + " user loads Captures from your database after entering their company code, email, and password during login."}</font></div>
            <div className="lrMedPad"><font className="fontItalic fontTextLight">{"- When this switch is off, every user always loads every Capture in the system upon login. This way, all current and historical Captures are available in searches and data summaries."}</font></div>
            <div className="lrMedPad"><font className="fontItalic fontTextLight">{"- When the switch is on, each Division has the option to 'firewall' which Captures are loaded when a user logs in. With firewalling active, as a rule, each user always loads every Capture they are listed as an owner of. Additionally, each user will load any Captures owned by the selected Divisions checked off for their Division's firewall settings."}</font></div>
            <div className="smallTopMargin"><font className="fontItalic fontTextLight">{"[Note: when turning this switch off, any unique firewalled division settings will be lost and overwritten by the default structure when turned back on]"}</font></div>
          </div>
          <div className="">
            <CEGeneralReact.SwitchWithTextAndConfirmBox
              p_isOnTF={c_companyUsingDivisionFirewallingTF}
              p_onText="Each Division chooses firewall preferences"
              p_offText="No firewalling, always load all captures"
              p_switchToOffMessage="Note: when turning this switch off, any unique firewalled division settings will be lost and overwritten by the default structure when turned back on"
              f_onSwitch={this.onsave_company_using_division_firewalling}
            />
          </div>
        </div>
      </CEGeneralReact.FloatingBoxWithSaveCancel>
    );
  }
}));

const AdminDivision = inject("CaptureExecMobx", "AdminMobx", "DatabaseMobx")(observer(
class AdminDivision extends Component { //props: p_divisionObj
  constructor(props) {
    super(props);
    this.state = {
      s_editingDivisionTF: false,
      s_findMySamUeiFloatingBoxIsOpenTF: false,
      s_showDivisionUsersFloatingBoxIsOpenTF: false
    };
  }

  onclick_division_edit = () => {
    this.setState({s_editingDivisionTF:true});
  }

  onclick_close_division_edit = () => {
    this.setState({s_editingDivisionTF:false});
  }

  onsave_division_name = (i_newValue) => { this.update_division_field("name", i_newValue, "s"); }
  onsave_division_nickname = (i_newValue) => { this.update_division_field("nickname", i_newValue, "s"); }
  onsave_division_color = (i_newValue) => { this.update_division_field("color", i_newValue, "s"); }
  onsave_business_type = (i_newValue) => { this.update_division_field("business_type_id", i_newValue, "i"); }
  onsave_prime_sb_certifications = (i_newValue) => { this.update_division_field("prime_sb_certifications_bm_set_aside_ids_comma", i_newValue, "s"); }
  onsave_firewalled_divisions = (i_newValue) => { this.update_division_field("firewalled_division_ids_comma", i_newValue, "s"); }
  onsave_integration_prefix = (i_newValue) => { this.update_division_field("integration_new_capture_integration_unique_id_prefix", i_newValue, "s"); }

  update_division_field = (i_fieldName, i_value, i_idsb) => {
    const p_divisionObj = this.props.p_divisionObj;

    const jsDescription = JSFUNC.js_description_from_action("AdminReact - AdminDivision", "update_division_field", ["i_fieldName", "i_value", "i_idsb"], [i_fieldName, i_value, i_idsb]);
    const C_CallPhpTblUID = new JSPHP.ClassCallPhpTblUID(jsDescription);

    //if changing the firewalled divisions for this division, if every division is selected, put "-1" in the database instead of listing every divisionID so that if new divisions are added by the admin, they are automatically included
    var updatedValue = i_value;
    if(i_fieldName === "firewalled_division_ids_comma") {
      const allDivisionIDsAreSelectedTF = JSFUNC.determine_if_every_id_within_mapOfMaps_is_preset_in_input_int_comma_list_tf(this.props.DatabaseMobx.o_tbl_a_divisions, "id", i_value);
      if(allDivisionIDsAreSelectedTF) {
        updatedValue = "-1";
      }
    }

    C_CallPhpTblUID.add_update("tbl_a_divisions", p_divisionObj.id, i_fieldName, updatedValue, i_idsb);

    C_CallPhpTblUID.execute();
  }

  onsave_division_parent_division = (i_newParentDivisionID) => {
    const p_divisionObj = this.props.p_divisionObj;

    const c_adminAllDivisionsArrayOfObjs = this.props.AdminMobx.c_adminAllDivisionsArrayOfObjs;

    var newParentDivisionTreeID = "00";
    for(let parentDivisionObj of c_adminAllDivisionsArrayOfObjs) {
      if(parentDivisionObj.id === i_newParentDivisionID) {
        newParentDivisionTreeID = parentDivisionObj.tree_id;
      }
    }

    const movedDivisionTreeID = p_divisionObj.tree_id;
    const movedDivisionTreeIDLength = movedDivisionTreeID.length;
    const newChildTreeID = JSFUNC.get_new_child_tree_id_from_arrayOfObjs(c_adminAllDivisionsArrayOfObjs, newParentDivisionTreeID);

    const jsDescription = JSFUNC.js_description_from_action("AdminReact - AdminDivision", "onsave_division_parent_division", ["i_newParentDivisionID"], [i_newParentDivisionID]);
    const C_CallPhpTblUID = new JSPHP.ClassCallPhpTblUID(jsDescription);

    for(let selfAndChildrenDivisionObj of c_adminAllDivisionsArrayOfObjs) {
      if(JSFUNC.in_array(selfAndChildrenDivisionObj.id, p_divisionObj.selfChildrenAndSubchildrenIDsArray)) {
        var updatedDivisionNewTreeID = newChildTreeID + selfAndChildrenDivisionObj.tree_id.substring(movedDivisionTreeIDLength, selfAndChildrenDivisionObj.tree_id.length);
        C_CallPhpTblUID.add_update("tbl_a_divisions", selfAndChildrenDivisionObj.id, "tree_id", updatedDivisionNewTreeID, "s");
      }
    }

    C_CallPhpTblUID.execute();
  }

  onsave_division_sibling_order = (i_newSiblingOrder) => {
    const p_divisionObj = this.props.p_divisionObj;
    const c_adminAllDivisionsArrayOfObjs = this.props.AdminMobx.c_adminAllDivisionsArrayOfObjs;

    const selectedParentDivisionID = JSFUNC.get_parent_item_id_from_child_tree_id(c_adminAllDivisionsArrayOfObjs, p_divisionObj.tree_id);
    const selectedParentDivisionMap = this.props.DatabaseMobx.o_tbl_a_divisions.get(selectedParentDivisionID);
    if(selectedParentDivisionMap !== undefined) {
      const selectedParentDivisionTreeID = selectedParentDivisionMap.get("tree_id");

      const jsDescription = JSFUNC.js_description_from_action("AdminReact - AdminDivision", "onsave_division_sibling_order", ["i_newSiblingOrder"], [i_newSiblingOrder]);
      const C_CallPhpTblUID = new JSPHP.ClassCallPhpTblUID(jsDescription);

      //all siblings that are not the one that was just resorted, leave a gap where the new one will be placed
      var oldSiblingOrder = 1;
      for(let siblingDivisionObj of c_adminAllDivisionsArrayOfObjs) {
        if(JSFUNC.tree_id_is_child_of_parent_tree_id_tf(selectedParentDivisionTreeID, siblingDivisionObj.tree_id, true)) {
          if(siblingDivisionObj.id !== p_divisionObj.id) {
            if(oldSiblingOrder === i_newSiblingOrder) {
              oldSiblingOrder++;
            }
            var updatedSiblingTreeID = selectedParentDivisionTreeID + JSFUNC.zero_pad_integer_from_left(oldSiblingOrder, 2);
            const updatedSiblingTreeIDLength = updatedSiblingTreeID.length;

            C_CallPhpTblUID.add_update("tbl_a_divisions", siblingDivisionObj.id, "tree_id", updatedSiblingTreeID, "s");

            for(let subchildrenDivisionObj of c_adminAllDivisionsArrayOfObjs) {
              if(JSFUNC.tree_id_is_child_of_parent_tree_id_tf(siblingDivisionObj.tree_id, subchildrenDivisionObj.tree_id, false)) {
                var updatedSubchildNewTreeID = updatedSiblingTreeID + subchildrenDivisionObj.tree_id.substring(updatedSiblingTreeIDLength, subchildrenDivisionObj.tree_id.length);
                C_CallPhpTblUID.add_update("tbl_a_divisions", subchildrenDivisionObj.id, "tree_id", updatedSubchildNewTreeID, "s");
              }
            }

            oldSiblingOrder++;
          }
        }
      }

      //put the moved division (and children/subchildren) into the gap at the newSiblingOrder
      var updatedSiblingTreeID = selectedParentDivisionTreeID + JSFUNC.zero_pad_integer_from_left(i_newSiblingOrder, 2);
      const updatedSiblingTreeIDLength = updatedSiblingTreeID.length;

      C_CallPhpTblUID.add_update("tbl_a_divisions", p_divisionObj.id, "tree_id", updatedSiblingTreeID, "s");

      for(let subchildrenDivisionObj of c_adminAllDivisionsArrayOfObjs) {
        if(JSFUNC.tree_id_is_child_of_parent_tree_id_tf(p_divisionObj.tree_id, subchildrenDivisionObj.tree_id, false)) {
          var updatedSubchildNewTreeID = updatedSiblingTreeID + subchildrenDivisionObj.tree_id.substring(updatedSiblingTreeIDLength, subchildrenDivisionObj.tree_id.length);
          C_CallPhpTblUID.add_update("tbl_a_divisions", subchildrenDivisionObj.id, "tree_id", updatedSubchildNewTreeID, "s");
        }
      }

      C_CallPhpTblUID.execute();
    }
  }

  onclick_open_find_my_sam_uei_floating_box = () => {
    this.setState({s_findMySamUeiFloatingBoxIsOpenTF:true});
  }

  onclick_close_find_my_sam_uei_floating_box = () => {
    this.setState({s_findMySamUeiFloatingBoxIsOpenTF:false});
  }

  onclick_select_sam_uei_company = (i_samUei, i_samUeiCompanyName) => {
    const p_divisionObj = this.props.p_divisionObj;

    const jsDescription = JSFUNC.js_description_from_action("AdminReact - AdminDivision", "onclick_select_sam_uei_company", ["i_samUei", "i_samUeiCompanyName"], [i_samUei, i_samUeiCompanyName]);
    const C_CallPhpTblUID = new JSPHP.ClassCallPhpTblUID(jsDescription);
    C_CallPhpTblUID.add_update("tbl_a_divisions", p_divisionObj.id, ["sam_uei", "sam_uei_company_name"], [i_samUei, i_samUeiCompanyName], ["s", "s"]);
    C_CallPhpTblUID.execute();

    this.onclick_close_find_my_sam_uei_floating_box();
  }

  onclick_open_show_division_users_floating_box = () => {
    this.setState({s_showDivisionUsersFloatingBoxIsOpenTF:true});
  }

  onclick_close_show_division_users_floating_box = () => {
    this.setState({s_showDivisionUsersFloatingBoxIsOpenTF:false});
  }

  ondelete_division = () => {
    const p_divisionObj = this.props.p_divisionObj;

    const jsDescription = JSFUNC.js_description_from_action("AdminReact - AdminDivision", "ondelete_division", [], []);
    const C_CallPhpTblUID = new JSPHP.ClassCallPhpTblUID(jsDescription);

    //delete the division record
    C_CallPhpTblUID.add_delete("tbl_a_divisions", p_divisionObj.id); //tree_id is the sort column, this delete does not resort and leaves a hole in the sorting, inserting a new division does the full recalculation of tree_ids

    const functionOnSuccess = (i_parseResponse) => {
      //insert an admin changelog entry
      const C_CallPhpTblUIDAfterDeleteDivision = new JSPHP.ClassCallPhpTblUID(jsDescription);
      const adminChangelogValue = p_divisionObj.name;
      C_CallPhpTblUIDAfterDeleteDivision.add_changelog_admin(CEC.adminLogObj.actionCodesObj.DELETE_DIVISION, "", adminChangelogValue);
      C_CallPhpTblUIDAfterDeleteDivision.execute();
    }
    C_CallPhpTblUID.add_function("onSuccess", functionOnSuccess);

    C_CallPhpTblUID.execute();
  }

  render() {
    const s_editingDivisionTF = this.state.s_editingDivisionTF;
    const s_findMySamUeiFloatingBoxIsOpenTF = this.state.s_findMySamUeiFloatingBoxIsOpenTF;
    const s_showDivisionUsersFloatingBoxIsOpenTF = this.state.s_showDivisionUsersFloatingBoxIsOpenTF;

    const p_divisionObj = this.props.p_divisionObj;

    const c_productStylingObj = this.props.CaptureExecMobx.c_productStylingObj;
    const c_adminAllDivisionsArrayOfObjs = this.props.AdminMobx.c_adminAllDivisionsArrayOfObjs;
    const c_notDeactivatedExpandedUpesWithUpowersArrayOfObjs = this.props.AdminMobx.c_notDeactivatedExpandedUpesWithUpowersArrayOfObjs;
    const c_bitUsing3rdPartyIntegrationTF = this.props.DatabaseMobx.c_bitUsing3rdPartyIntegrationTF;
    const c_companyUsingDivisionFirewallingTF = this.props.DatabaseMobx.c_companyUsingDivisionFirewallingTF;
    const c_companyPrimeSBCertsCanVaryPerDivisionTF = this.props.DatabaseMobx.c_companyPrimeSBCertsCanVaryPerDivisionTF;

    const canEditBusinessTypeTF = (p_divisionObj.isTopDivision00TF || c_companyPrimeSBCertsCanVaryPerDivisionTF);
    const canDeleteDivisionTF = (p_divisionObj.selfChildrenAndSubchildrenIDsArray.length === 1);
    const canMoveDivisionTF = (p_divisionObj.tree_id.length > 2);

    var selectedParentDivisionID = -1;
    var oldSiblingOrder = -1;
    var siblingOrderArray = [];
    var siblingOrderDisplayArray = [];
    if(s_editingDivisionTF && canMoveDivisionTF) {
      selectedParentDivisionID = JSFUNC.get_parent_item_id_from_child_tree_id(c_adminAllDivisionsArrayOfObjs, p_divisionObj.tree_id);
      const selectedParentDivisionMap = this.props.DatabaseMobx.o_tbl_a_divisions.get(selectedParentDivisionID);
      if(selectedParentDivisionMap !== undefined) {
        const selectedParentDivisionTreeID = selectedParentDivisionMap.get("tree_id");
        var siblingOrder = 1;
        for(let childrenDivisionObj of c_adminAllDivisionsArrayOfObjs) {
          if(JSFUNC.tree_id_is_child_of_parent_tree_id_tf(selectedParentDivisionTreeID, childrenDivisionObj.tree_id, true)) {
            if(p_divisionObj.id === childrenDivisionObj.id) {
              oldSiblingOrder = siblingOrder;
            }
            siblingOrderArray.push(siblingOrder);
            siblingOrderDisplayArray.push(JSFUNC.num2str(siblingOrder));
            siblingOrder++;
          }
        }
      }
    }

    const swsOptionsObj = undefined;
    const selectWithSearchDataObj = this.props.DatabaseMobx.create_sws_data_obj_from_value_array_and_display_array("Sibling Order", siblingOrderArray, false, siblingOrderDisplayArray, swsOptionsObj);
    const selectSiblingOrderFieldTypeObj = this.props.DatabaseMobx.create_field_type_obj("select", selectWithSearchDataObj);

    return (
      <div className="displayFlexRow lrMedMargin">
        {p_divisionObj.indentsArray.map((i_indentNum) =>
          <div key={"ind" + i_indentNum} className="flex00a" style={{flexBasis:"1.6em", borderLeft:"solid 1px #ddd", marginLeft:"0.8em"}} />
        )}
        <div
          className="flex11a displayFlexRow microTopMargin microBottomMargin lrPad hoverLighterBlueGradient cursorPointer"
          style={{flexBasis:"100em", height:"3em", backgroundColor:"#f5f2f0", border:"solid 1px #cba", borderRadius:"0.5em"}}
          onClick={this.onclick_division_edit}>
          <div className="flex00a smallFullMargin border bevelBorderColors" style={{flexBasis:"1em", background:"#" + p_divisionObj.color}} />
          <div className="flex11a displayFlexColumnVc lrPad" style={{flexBasis:"100em"}}>
            <div className="">
              <LibraryReact.NowrapEllipsis p_fontClass="font11">
                {p_divisionObj.name}
              </LibraryReact.NowrapEllipsis>
            </div>
            {(p_divisionObj.nickname !== "") &&
              <div style={{marginLeft:"1em"}}>
                <LibraryReact.NowrapEllipsis p_fontClass="fontItalic fontTextLighter">
                  {p_divisionObj.nickname}
                </LibraryReact.NowrapEllipsis>
              </div>
            }
          </div>
          {(canEditBusinessTypeTF) &&
            <div className="flex00a displayFlexColumnVc lrPad" style={{flexBasis:"20em"}}>
              <div>
                <LibraryReact.NowrapEllipsis p_fontClass="fontItalic fontTextLighter">
                  {((p_divisionObj.divisionIsSmallBusinessTF) ? ("Small Business Certifications:") : ("Large Business"))}
                </LibraryReact.NowrapEllipsis>
              </div>
              {(p_divisionObj.divisionIsSmallBusinessTF) &&
                <div className="microTopMargin">
                  <LibraryReact.NowrapEllipsis p_fontClass={"fontTextLight " + ((p_divisionObj.calcPrimeSBCertificationsIsFilledOutTF) ? ("") : ("fontItalic"))}>
                    {p_divisionObj.calcPrimeSBCertificationsShortNamesMask}
                  </LibraryReact.NowrapEllipsis>
                </div>
              }
            </div>
          }
          {(c_companyUsingDivisionFirewallingTF) &&
            <div className="flex00a displayFlexColumnVc lrPad" style={{flexBasis:"20em"}}>
              <div>
                <LibraryReact.NowrapEllipsis p_fontClass="fontItalic fontTextLighter">
                  {((p_divisionObj.isTopDivision00TF) ? ("Top Division always loads all Captures") : ("Firewalled Divisions:"))}
                </LibraryReact.NowrapEllipsis>
              </div>
              {(!p_divisionObj.isTopDivision00TF) &&
                <div className="microTopMargin">
                  <LibraryReact.NowrapEllipsis p_fontClass={"fontTextLight " + ((p_divisionObj.calcFirewalledDivisionsIsFilledOutTF) ? ("") : ("fontItalic"))}>
                    {p_divisionObj.calcFirewalledDivisionsMask}
                  </LibraryReact.NowrapEllipsis>
                </div>
              }
            </div>
          }
          <div
            className="flex00a displayFlexColumnVc lrPad"
            style={{flexBasis:"12em"}}
            title={"SAM UEI: '" + ((p_divisionObj.calcSamUeiWithUphillRollIsFilledOutTF) ? (p_divisionObj.calcSamUeiWithUphillRoll + "' [" + p_divisionObj.calcCompanyNameWithUphillRoll + "]" + ((p_divisionObj.calcSamUeiIsFromUphillTF) ? (" (inherited from '" + p_divisionObj.calcSamUeiIsFromUphillDivisionName + "'") : (""))) : ("--No SAM UEI Selected--")) + "\n\nThis is your company's SAM.gov 'Unique Entity ID', used in the " + c_productStylingObj.productName + " GovCon Smart Search for the AI powered CE.A.I. opportunities search tool"}>
            <div>
              <LibraryReact.NowrapEllipsis p_fontClass="fontItalic fontTextLighter">
                {"SAM UEI:"}
              </LibraryReact.NowrapEllipsis>
            </div>
            <div className="microTopMargin">
              <LibraryReact.NowrapEllipsis p_fontClass={((p_divisionObj.calcSamUeiIsFromUphillTF) ? ("fontTextLightester") : ("fontTextLight"))}>
                {((p_divisionObj.calcSamUeiWithUphillRollIsFilledOutTF) ? (p_divisionObj.calcSamUeiWithUphillRoll + " [" + p_divisionObj.calcCompanyNameWithUphillRoll + "]") : (""))}
              </LibraryReact.NowrapEllipsis>
            </div>
          </div>
          {(c_bitUsing3rdPartyIntegrationTF) &&
            <div className="flex00a displayFlexColumnVc lrPad" style={{flexBasis:"6em"}} title={((p_divisionObj.calcIntegrationPrefixIsFilledOutTF) ? ("3rd Party Integration system new capture unique ID prefix: '" + p_divisionObj.integration_new_capture_integration_unique_id_prefix + "'") : (""))}>
              <LibraryReact.NowrapEllipsis p_fontClass="fontItalic fontTextLighter">
                {((p_divisionObj.calcIntegrationPrefixIsFilledOutTF) ? ("[" + p_divisionObj.integration_new_capture_integration_unique_id_prefix + "]") : (""))}
              </LibraryReact.NowrapEllipsis>
            </div>
          }
          <div className="flex00a displayFlexColumnHcVc" style={{flexBasis:"10em"}}>
            <LibraryReact.DivFont p_class="" p_fontClass="fontItalic fontTextLighter">
              {"# Captures"}
            </LibraryReact.DivFont>
            <CapturesReact.NumberOfAssignedCapturesCountButton
              p_partialNumMatchingCaptures={p_divisionObj.numCapturesOwnedByDivision}
              p_matchingCaptureIDsArray={p_divisionObj.capturesOwnedByDivisionCaptureIDsArray}
              p_floatingBoxTitle={"Captures Owned by Division '" + p_divisionObj.name + "'"}
            />
          </div>
          <div
            className="flex00a displayFlexColumnHcVc"
            style={{flexBasis:"10em"}}
            title={p_divisionObj.numUsersAssigned + " " + c_productStylingObj.productName + " Users are assigned to division '" + p_divisionObj.name + "'"}>
            <LibraryReact.DivFont p_class="" p_fontClass="fontItalic fontTextLighter">
              {"# Users"}
            </LibraryReact.DivFont>
            <LibraryReact.InteractiveDiv
              p_class="displayFlexColumnHcVc border bevelBorderColors borderRadius10 bgLightGrayGradient hoverLighterGrayGradient cursorPointer textCenter"
              p_styleObj={{height:"1.3em", width:"3.5em"}}
              p_title={"View all Users assigned to Division '" + p_divisionObj.name + "'"}
              f_onClick={this.onclick_open_show_division_users_floating_box}>
              <font className="fontBold">
                {p_divisionObj.numUsersAssigned}
              </font>
            </LibraryReact.InteractiveDiv>
          </div>
          <div className="flex00a displayFlexColumnHcVc" style={{flexBasis:"2em"}}>
            {(p_divisionObj.tree_id.length > 2) &&
              <CEGeneralReact.DeleteMenu
                p_menuItemText="Delete"
                p_message={((canDeleteDivisionTF) ? ("Are you sure you want to delete Division '" + p_divisionObj.name + "'?") : ("Division '" + p_divisionObj.name + "' cannot be deleted until all of its child divisions have first been deleted."))}
                p_noDeleteTF={!canDeleteDivisionTF}
                f_onDelete={this.ondelete_division}
              />
            }
          </div>
        </div>
        {(s_editingDivisionTF) &&
          <CEGeneralReact.FloatingBoxWithSaveCancel
            p_trblFlag="addEditDeleteTableEditItem"
            p_title={"Editing Division " + p_divisionObj.name}
            f_onClickSave={this.onclick_close_division_edit}>
            <div className="flex11a yScroll medFullPad">
              <DivisionsAddEditFloatingBoxSectionLabel p_label="Attributes" p_dividerLineAboveTF={false} />
              <CEGeneralReact.CaptureExecFieldEditSaveCancel
                p_ceEditItemString={"adminDivisionEdit_dID" + p_divisionObj.id + "name"}
                p_fieldDisplayName="Division Name"
                p_fieldTypeObj={this.props.DatabaseMobx.c_genericTextFieldTypeObj}
                p_valueRaw={p_divisionObj.name}
                p_valueIsEditableTFU={true}
                p_containerClass="tbMargin"
                p_fieldClass="fontBlue"
                p_fieldWidth="17em"
                f_onSaveChanged={this.onsave_division_name}
              />
              <CEGeneralReact.CaptureExecFieldEditSaveCancel
                p_ceEditItemString={"adminDivisionEdit_dID" + p_divisionObj.id + "nickname"}
                p_fieldDisplayName="Division Abbr Name (optional)"
                p_fieldTypeObj={this.props.DatabaseMobx.c_genericTextFieldTypeObj}
                p_valueRaw={p_divisionObj.nickname}
                p_valueIsEditableTFU={true}
                p_containerClass="tbMargin"
                p_fieldClass="fontBlue"
                p_fieldWidth="17em"
                f_onSaveChanged={this.onsave_division_nickname}
              />
              <CEGeneralReact.CaptureExecFieldEditSaveCancel
                p_ceEditItemString={"adminDivisionEdit_dID" + p_divisionObj.id + "color"}
                p_fieldDisplayName="Color (represents division in graphs)"
                p_fieldTypeObj={this.props.DatabaseMobx.c_genericColorFieldTypeObj}
                p_valueRaw={p_divisionObj.color}
                p_valueIsEditableTFU={true}
                p_containerClass="tbMargin"
                p_fieldClass="fontBlue"
                p_fieldWidth="17em"
                f_onSaveChanged={this.onsave_division_color}
              />
              <CEGeneralReact.CaptureExecFieldEditSaveCancel
                p_ceEditItemString={"adminDivisionEdit_dID" + p_divisionObj.id + "businesstype"}
                p_fieldDisplayName="Division Business Type"
                p_fieldTypeObj={this.props.DatabaseMobx.c_selectBusinessTypeFieldTypeObj}
                p_valueRaw={p_divisionObj.business_type_id}
                p_valueMask={((canEditBusinessTypeTF) ? (undefined) : (this.props.DatabaseMobx.not_filled_out_font_html("Value is set at top level for all divisions")))}
                p_valueIsEditableTFU={canEditBusinessTypeTF}
                p_containerClass="tbMargin"
                p_fieldClass="fontBlue"
                p_fieldWidth="17em"
                f_onSaveChanged={this.onsave_business_type}
              />
              <CEGeneralReact.CaptureExecFieldEditSaveCancel
                p_ceEditItemString={"adminDivisionEdit_dID" + p_divisionObj.id + "sbcerts"}
                p_fieldDisplayName="Small Business Certifications"
                p_fieldTypeObj={this.props.DatabaseMobx.c_selectMultiBitMasterSetAsidesFieldTypeObj}
                p_valueRaw={p_divisionObj.prime_sb_certifications_bm_set_aside_ids_comma}
                p_valueMask={((canEditBusinessTypeTF) ? (((p_divisionObj.divisionIsSmallBusinessTF) ? (undefined) : (this.props.DatabaseMobx.not_filled_out_font_html("N/A")))) : (this.props.DatabaseMobx.not_filled_out_font_html("Value is set at top level for all divisions")))}
                p_valueIsEditableTFU={(canEditBusinessTypeTF && p_divisionObj.divisionIsSmallBusinessTF)}
                p_containerClass="tbMargin"
                p_fieldClass="fontBlue"
                p_fieldWidth="17em"
                f_onSaveChanged={this.onsave_prime_sb_certifications}
              />
              <div className="displayFlexRowVc">
                <div className="flex11a">
                  <CEGeneralReact.CaptureExecFieldEditSaveCancel
                    p_ceEditItemString={"adminDivisionEdit_dID" + p_divisionObj.id + "samuei"}
                    p_fieldDisplayName="SAM.gov Unique Entity ID (UEI)"
                    p_fieldTypeObj={this.props.DatabaseMobx.c_genericTextFieldTypeObj}
                    p_valueRaw={((p_divisionObj.calcSamUeiWithUphillRollIsFilledOutTF) ? (p_divisionObj.calcSamUeiWithUphillRoll + " [" + p_divisionObj.calcCompanyNameWithUphillRoll + "]") : (""))}
                    p_valueIsEditableTFU={false}
                    p_containerClass="tbMargin"
                    p_fieldClass="fontBlue"
                    p_fieldWidth="17em"
                  />
                </div>
                <div className="flex00a lrMedPad">
                  <CEGeneralReact.CEButton
                    p_type="add"
                    p_text="Find My UEI"
                    f_onClick={this.onclick_open_find_my_sam_uei_floating_box}
                  />
                  {(s_findMySamUeiFloatingBoxIsOpenTF) &&
                    <CEGeneralReact.FloatingBoxWithSaveCancel
                      p_trblFlag="large"
                      p_title={"Find My SAM.gov UEI for Division '" + p_divisionObj.name + "'"}
                      f_onClickCancel={this.onclick_close_find_my_sam_uei_floating_box}>
                      <DivisionsFindMyUeiFloatingBoxContents
                        p_divisionObj={p_divisionObj}
                        f_onClickSelectSamUeiCompany={this.onclick_select_sam_uei_company}
                      />
                    </CEGeneralReact.FloatingBoxWithSaveCancel>
                  }
                </div>
              </div>
              {(canMoveDivisionTF) &&
                <>
                  <DivisionsAddEditFloatingBoxSectionLabel p_label="Org Chart Positioning" p_dividerLineAboveTF={true} />
                  <CEGeneralReact.CaptureExecFieldEditSaveCancel
                    p_ceEditItemString={"adminDivisionEdit_dID" + p_divisionObj.id + "parentDiv"}
                    p_fieldDisplayName="Parent Division"
                    p_fieldTypeObj={this.props.DatabaseMobx.c_selectDivisionFieldTypeObj}
                    p_valueRaw={selectedParentDivisionID}
                    p_containerClass="tbMargin"
                    p_fieldClass="fontBlue"
                    p_fieldWidth="17em"
                    p_valueIsEditableTFU={true}
                    p_valuesToNotIncludeArray={p_divisionObj.selfChildrenAndSubchildrenIDsArray}
                    f_onSaveChanged={this.onsave_division_parent_division}
                  />
                  <CEGeneralReact.CaptureExecFieldEditSaveCancel
                    p_ceEditItemString={"adminDivisionEdit_dID" + p_divisionObj.id + "siblingOrder"}
                    p_fieldDisplayName="Order Among Sibling Divisions"
                    p_fieldTypeObj={selectSiblingOrderFieldTypeObj}
                    p_valueRaw={oldSiblingOrder}
                    p_containerClass="tbMargin"
                    p_fieldClass="fontBlue"
                    p_fieldWidth="17em"
                    p_valueIsEditableTFU={true}
                    f_onSaveChanged={this.onsave_division_sibling_order}
                  />
                </>
              }
              {(c_companyUsingDivisionFirewallingTF && !p_divisionObj.isTopDivision00TF) &&
                <>
                  <DivisionsAddEditFloatingBoxSectionLabel p_label="Firewalling" p_dividerLineAboveTF={true} />
                  <div className="microTopMargin">
                    <font className="fontItalic fontTextLighter">
                      {"Select every company/division/department that a user assigned to this division (assigned on the System Setup 'Users' subtab) can view, edit, or search for captures that have these divisions assigned to the '" + this.props.DatabaseMobx.c_fieldMapOfDivisionOwners.get("display_name") + "' field"}
                    </font>
                  </div>
                  <CEGeneralReact.CaptureExecFieldEditSaveCancel
                    p_ceEditItemString={"adminDivisionEdit_dID" + p_divisionObj.id + "firewalleddivisions"}
                    p_fieldDisplayName="Firewalled Divisions"
                    p_fieldTypeObj={this.props.DatabaseMobx.c_selectMultiAdminAllDivisionsIncludingFirewalledFieldTypeObj}
                    p_valueRaw={p_divisionObj.calcFirewalledDivisionIDsComma}
                    p_valueMask={p_divisionObj.calcFirewalledDivisionsMask}
                    p_valueIsEditableTFU={true}
                    p_containerClass="tbMargin"
                    p_fieldClass="fontBlue"
                    p_fieldWidth="17em"
                    f_onSaveChanged={this.onsave_firewalled_divisions}
                  />
                </>
              }
              {(c_bitUsing3rdPartyIntegrationTF) &&
                <>
                  <DivisionsAddEditFloatingBoxSectionLabel p_label="3rd Party Integration Options" p_dividerLineAboveTF={true} />
                  <div className="microTopMargin">
                    <font className="fontItalic fontTextLighter">
                      {"If using a 3rd Party Integration to synchronize systems like VantagePoint, this option per Division can specify a 'prefix' to apply to the unique ID in the integrated system when a new capture is created in " + c_productStylingObj.productName}
                    </font>
                  </div>
                  <CEGeneralReact.CaptureExecFieldEditSaveCancel
                    p_ceEditItemString={"adminDivisionEdit_dID" + p_divisionObj.id + "integrationPrefix"}
                    p_fieldDisplayName="Integration New Capture Prefix"
                    p_fieldTypeObj={this.props.DatabaseMobx.c_genericTextFieldTypeObj}
                    p_valueRaw={p_divisionObj.integration_new_capture_integration_unique_id_prefix}
                    p_valueIsEditableTFU={true}
                    p_containerClass="tbMargin"
                    p_fieldClass="fontBlue"
                    p_fieldWidth="17em"
                    f_onSaveChanged={this.onsave_integration_prefix}
                  />
                </>
              }
            </div>
          </CEGeneralReact.FloatingBoxWithSaveCancel>
        }
        {(s_showDivisionUsersFloatingBoxIsOpenTF) &&
          <CEGeneralReact.FloatingBoxWithSaveCancel
            p_trblFlag="smallVertical"
            p_title={"Viewing All Users assigned to Division " + p_divisionObj.name}
            f_onClickCancel={this.onclick_close_show_division_users_floating_box}>
            <div className="flex11a yScroll medFullPad">
              {c_notDeactivatedExpandedUpesWithUpowersArrayOfObjs.map((m_userPerEmailNotDeactivatedObj) =>
                m_userPerEmailNotDeactivatedObj.upeMultiLoginCombinedUsersArrayOfObjs.map((m_combinedUserObj) =>
                  (m_combinedUserObj.division_id === p_divisionObj.id) &&
                  <div className="displayFlexRowVc microBottomMargin border1ddd bgLightestBlue tbPad">
                    <div className="flex11a lrPad" style={{flexBasis:"100em"}}>
                      <font className="">
                        {m_combinedUserObj.upeFirstNameLastName}
                      </font>
                    </div>
                    <div className="flex11a lrPad" style={{flexBasis:"100em"}}>
                      <font className="fontItalic">
                        {m_combinedUserObj.powerDisplayName}
                      </font>
                    </div>
                  </div>
                )
              )}
            </div>
          </CEGeneralReact.FloatingBoxWithSaveCancel>
        }
      </div>
    );
  }
}));

function DivisionsAddEditFloatingBoxSectionLabel(props) { //props: p_label, p_dividerLineAboveTF
  const p_label = props.p_label;
  const p_dividerLineAboveTF = props.p_dividerLineAboveTF;

  return(
    <div className={((p_dividerLineAboveTF) ? ("bigTopMargin borderT1ddd smallTopPad") : (""))}>
      <font className="font13 fontBold fontItalic fontDarkBlue">
        {p_label}
      </font>
    </div>
  );
}


const DivisionsFindMyUeiFloatingBoxContents = inject("AdminMobx")(observer(
class DivisionsFindMyUeiFloatingBoxContents extends Component { //props: p_divisionObj, f_onClickSelectSamUeiCompany
  constructor(props) {
    super(props);
    this.state = {
      s_companyNameSearchTerm: ""
    };
  }

  onchange_company_name_search_term = (i_newValue) => {
    this.setState({s_companyNameSearchTerm:i_newValue})
  }

  onclick_conduct_search_button = () => {
    const s_companyNameSearchTerm = this.state.s_companyNameSearchTerm;
    this.props.AdminMobx.a_divisions_find_my_uei_search_sam_companies(s_companyNameSearchTerm);
  }

  onclick_clear_previous_sam_uei_and_company_name_values = () => {
    if(JSFUNC.is_function(this.props.f_onClickSelectSamUeiCompany)) {
      this.props.f_onClickSelectSamUeiCompany("", "");
    }
  }

  render() {
    const s_companyNameSearchTerm = this.state.s_companyNameSearchTerm;

    const p_divisionObj = this.props.p_divisionObj;
    const f_onClickSelectSamUeiCompany = this.props.f_onClickSelectSamUeiCompany;
    
    const o_divisionsFindMyUeiLoadingFlag = this.props.AdminMobx.o_divisionsFindMyUeiLoadingFlag;
    const o_divisionsFindMyUeiPreviousCompanyNameSearchTerm = this.props.AdminMobx.o_divisionsFindMyUeiPreviousCompanyNameSearchTerm;
    const o_divisionsFindMyUeiSamUeiCompaniesArrayOfObjs = this.props.AdminMobx.o_divisionsFindMyUeiSamUeiCompaniesArrayOfObjs;

    const samUeiTblColumnDbNamesArray = [
      "company_name", "sam_uei", "cage_codes_semi", "aac_codes_semi", "cities_semi", 
      "states_semi", "countries_semi", "entity_structures_semi", "primary_naics_codes_semi", "business_types_semi", 
      "naics_codes_semi", "product_service_codes_semi", "exception_naics_codes_semi", "history_departments_semi", "history_agency_ids_semi", 
      "history_office_ids_semi", "history_naics_codes_semi", "history_product_service_codes_semi", "history_setaside_codes_semi", "history_pop_states_semi", 
      "history_parent_description_semi"
    ];

    const samUeiTblColumnDisplayNamesArray = [
      "Company Name", "SAM UEI", "Cage Codes", "AAC Codes", "Cities", 
      "States", "Countries", "Entity Structures", "Primary NAICS Codes", "Business Types", 
      "NAICS codes", "Product Service Codes", "Exception NAICS Codes", "Departments (history)", "Agency IDs (history)", 
      "Office IDs (history)", "NAICS Codes (history)", "Product Service Codes (history)", "Set-Aside Codes (history)", "PoP States (history)", 
      "Parent Description (history)"
    ];

    const samUeiTblColumnWidthsArray = [
      25, 10, 10, 10, 10, 
      10, 10, 10, 10, 10, 
      10, 10, 10, 10, 10, 
      10, 10, 10, 10, 10, 
      25
    ];

    const numMatchingResults = o_divisionsFindMyUeiSamUeiCompaniesArrayOfObjs.length;

    var resultsComponent = null;
    if(o_divisionsFindMyUeiLoadingFlag === "results") { //normal search results table
      if(numMatchingResults === 0) {
        resultsComponent = (
          <CEGeneralReact.EmptyScreenWhite>
            <div className="smallBottomMargin">
              {"0 results match your search '" + o_divisionsFindMyUeiPreviousCompanyNameSearchTerm + "'"}
            </div>
          </CEGeneralReact.EmptyScreenWhite>
        );
      }
      else {
        resultsComponent = (
          <>
            <div className="flex00a medFullPad">
              <font className="">
                {numMatchingResults + " " + JSFUNC.plural(numMatchingResults, "Result", "Results") + " match Company Name search '" + o_divisionsFindMyUeiPreviousCompanyNameSearchTerm + "'"}
              </font>
            </div>
            <div className="flex11a displayFlexColumn medFullPad xyScroll">
              <div className="flex00a displayFlexRow" style={{flexBasis:"3em"}}>
                <div className="flex00a bgLightGrayGradient" style={{flexBasis:"8em"}} />
                {samUeiTblColumnDisplayNamesArray.map((m_samUeiTblColumnDisplayName, m_index) =>
                  <div className="flex00a displayFlexRowVc borderR1bbb bgLightGrayGradient textCenter" style={{flexBasis:samUeiTblColumnWidthsArray[m_index] + "em"}} title={m_samUeiTblColumnDisplayName}>
                    <LibraryReact.MaxHeightWrap p_maxHeight="2.7em" p_fontClass="fontBold fontTextLight">
                      {m_samUeiTblColumnDisplayName}
                    </LibraryReact.MaxHeightWrap>
                  </div>
                )}
              </div>
              {o_divisionsFindMyUeiSamUeiCompaniesArrayOfObjs.map((m_samUeiCompanyObj) =>
                <DivisionsFindMyUeiResultsSingleCompanyRow
                  p_samUeiCompanyObj={m_samUeiCompanyObj}
                  p_samUeiTblColumnDbNamesArray={samUeiTblColumnDbNamesArray}
                  p_samUeiTblColumnWidthsArray={samUeiTblColumnWidthsArray}
                  f_onClickSelectSamUeiCompany={f_onClickSelectSamUeiCompany}
                />
              )}
            </div>
          </>
        );
      }
    }
    else if(o_divisionsFindMyUeiLoadingFlag === "loading") { //loading
      resultsComponent = (
        <CEGeneralReact.EmptyScreenWhite>
          <div className="smallBottomMargin">
            {"Searching SAM.gov UEI Companies for '" + s_companyNameSearchTerm + "'..."}
          </div>
          <CEGeneralReact.LoadingAnimation />
        </CEGeneralReact.EmptyScreenWhite>
      );
    }
    else if(o_divisionsFindMyUeiLoadingFlag === "error") { //error conducting search
      resultsComponent = (
        <CEGeneralReact.EmptyScreenWhite>
          <font className="fontDarkRed">
            {"SAM UEI Companies database error occured during search"}
          </font>
        </CEGeneralReact.EmptyScreenWhite>
      );
    }
    else { //init
      resultsComponent = (
        <CEGeneralReact.EmptyScreenWhite>
          <div className="smallBottomMargin">
            {"Enter some or all of your Company Name and click 'Search' to begin. Only the first 100 matching results will be returned"}
          </div>
        </CEGeneralReact.EmptyScreenWhite>
      );
    }

    return(
      <>
        <div className="flex00a displayFlexRow borderB1bbb medFullPad">
          <div className="flex00a displayFlexColumnVc" style={{flexBasis:"10em"}}>
            <font className="">
              {"Search for your company by name: "}
            </font>
          </div>
          <div className="flex11a displayFlexColumnVc" style={{maxWidth:"30em"}}>
            <CEGeneralReact.SearchInputTextWithClearX
              p_inputText={s_companyNameSearchTerm}
              p_placeholderText="Search SAM.gov Companies on File..."
              p_includeSearchIconTF={true}
              p_heightEm={2.2}
              p_tabIndex={1}
              f_onKeyDownEnter={((o_divisionsFindMyUeiLoadingFlag === "loading") ? (undefined) : (this.onclick_conduct_search_button))}
              f_onChange={((o_divisionsFindMyUeiLoadingFlag === "loading") ? (undefined) : (this.onchange_company_name_search_term))}
            />
          </div>
          <div className="flex00a displayFlexColumnHcVc lrMedPad" title="Conduct a search to find the SAM UEI matching your Company">
            <CEGeneralReact.CEButton
              p_type="blue"
              p_text="Search"
              f_onClick={this.onclick_conduct_search_button}
            />
          </div>
          <div className="flex11a" />
          {(p_divisionObj.calcSamUeiWithUphillRollIsFilledOutTF && !p_divisionObj.calcSamUeiIsFromUphillTF) &&
            <div className="flex00a displayFlexColumnHcVc lrMedPad" title="Clear out the previously selected SAM UEI value for this Company/Division">
              <CEGeneralReact.CEButton
                p_type="add"
                p_text="Clear"
                f_onClick={this.onclick_clear_previous_sam_uei_and_company_name_values}
              />
            </div>
          }
        </div>
        {resultsComponent}
      </>
    );
  }
}));


const DivisionsFindMyUeiResultsSingleCompanyRow = inject("AdminMobx", "DatabaseMobx")(observer(
class DivisionsFindMyUeiResultsSingleCompanyRow extends Component { //props: p_samUeiCompanyObj, p_samUeiTblColumnDbNamesArray, p_samUeiTblColumnWidthsArray, f_onClickSelectSamUeiCompany
  onclick_select_sam_uei_company = () => {
    const p_samUeiCompanyObj = this.props.p_samUeiCompanyObj;
    const f_onClickSelectSamUeiCompany = this.props.f_onClickSelectSamUeiCompany;
    if(JSFUNC.is_function(f_onClickSelectSamUeiCompany)) {
      f_onClickSelectSamUeiCompany(p_samUeiCompanyObj.sam_uei, p_samUeiCompanyObj.company_name);
    }
  }

  render() {
    const p_samUeiCompanyObj = this.props.p_samUeiCompanyObj;
    const p_samUeiTblColumnDbNamesArray = this.props.p_samUeiTblColumnDbNamesArray;
    const p_samUeiTblColumnWidthsArray = this.props.p_samUeiTblColumnWidthsArray;
    const f_onClickSelectSamUeiCompany = this.props.f_onClickSelectSamUeiCompany;

    return(
      <div className="flex00a displayFlexRow borderB1ddd" style={{flexBasis:"2.5em"}}>
        <div className="flex00a displayFlexColumnHcVc" style={{flexBasis:"8em"}}>
          <CEGeneralReact.CEButton
            p_type="add"
            p_text="Select"
            f_onClick={this.onclick_select_sam_uei_company}
          />
        </div>
        {p_samUeiTblColumnDbNamesArray.map((m_samUeiTblColumnDbName, m_index) =>
          <div className="flex00a displayFlexRowVc lrPad" style={{flexBasis:p_samUeiTblColumnWidthsArray[m_index] + "em"}} title={p_samUeiCompanyObj[m_samUeiTblColumnDbName]}>
            <LibraryReact.NowrapEllipsis p_fontClass="">
              {p_samUeiCompanyObj[m_samUeiTblColumnDbName]}
            </LibraryReact.NowrapEllipsis>
          </div>
        )}
      </div>
    );
  }
}));



const DivisionsCreateNewDivisionFloatingBox = inject("AdminMobx", "DatabaseMobx")(observer(
class DivisionsCreateNewDivisionFloatingBox extends Component { //props: f_onClose
  constructor(props) {
    super(props);

    const c_firstBusinessTypeID = this.props.DatabaseMobx.c_firstBusinessTypeID;

    this.state = {
      s_divisionName: "",
      s_divisionNickname: "",
      s_divisionColor: "005da3",
      s_divisionBusinessTypeID: c_firstBusinessTypeID,
      s_divisionPrimeSBCertificationsBmSetAsideIDsComma: "",
      s_parentDivisionID: -1,
      s_siblingOrder: 1,
      s_showErrorsTF: false,
      s_isWorkingTF: false
    };
  }

  onchange_division_name = (i_newValue) => { this.setState({s_divisionName:i_newValue}); }
  onchange_division_nickname = (i_newValue) => { this.setState({s_divisionNickname:i_newValue}); }
  onchange_division_color = (i_newValue) => { this.setState({s_divisionColor:i_newValue}); }
  onchange_division_business_type = (i_newValue) => { this.setState({s_divisionBusinessTypeID:i_newValue}); }
  onchange_division_sb_certifications = (i_newValue) => { this.setState({s_divisionPrimeSBCertificationsBmSetAsideIDsComma:i_newValue}); }
  onchange_parent_division_id = (i_newValue) => {
    this.setState({
      s_parentDivisionID: i_newValue,
      s_siblingOrder: 1
    });
  }
  onchange_sibling_order = (i_newValue) => { this.setState({s_siblingOrder:i_newValue}); }

  onclick_create_new_division = () => {
    const s_divisionName = this.state.s_divisionName;
    const s_divisionNickname = this.state.s_divisionNickname;
    const s_divisionColor = this.state.s_divisionColor;
    const s_divisionBusinessTypeID = this.state.s_divisionBusinessTypeID;
    const s_divisionPrimeSBCertificationsBmSetAsideIDsComma = this.state.s_divisionPrimeSBCertificationsBmSetAsideIDsComma;
    const s_parentDivisionID = this.state.s_parentDivisionID;
    const s_siblingOrder = this.state.s_siblingOrder;

    const c_adminAllDivisionsArrayOfObjs = this.props.AdminMobx.c_adminAllDivisionsArrayOfObjs; //all old divisions
    const o_tbl_a_divisions = this.props.DatabaseMobx.o_tbl_a_divisions;

    const selectedParentDivisionMap = o_tbl_a_divisions.get(s_parentDivisionID);
    if(this.division_name_error_tf() || this.parent_division_error_tf() || this.sibling_order_error_tf() || (selectedParentDivisionMap === undefined)) {
      this.setState({s_showErrorsTF:true});
    }
    else {
      this.setState({s_isWorkingTF:true});

      //determine new division treeID (parent + selected order)
      const parentTreeID = selectedParentDivisionMap.get("tree_id");
      const newDivisionTreeID = parentTreeID + JSFUNC.zero_pad_integer_from_left(s_siblingOrder, 2);

      //determine all existing treeIDs that need to have their treeID changed
      var divisionsToUpdateArrayOfObjs = [];
      for(let oldDivisionObj of c_adminAllDivisionsArrayOfObjs) {
        var oldDivisionTreeID = oldDivisionObj.tree_id;
        if(JSFUNC.tree_id_is_child_of_parent_tree_id_tf(parentTreeID, oldDivisionTreeID, true)) { //verify that this division being checked is a direct child of the parent selected to assign the new one under
          var oldDivisionTreeIDLength = oldDivisionTreeID.length;
          var oldDivisionTreeIDLast2Digits = oldDivisionTreeID.substring(oldDivisionTreeIDLength - 2);
          var divisionSiblingOrder = JSFUNC.str2int(oldDivisionTreeIDLast2Digits);
          if(divisionSiblingOrder >= s_siblingOrder) { //same or further than the new sibling order needs to be changed by +1
            var changedSiblingOrder = (divisionSiblingOrder + 1);
            var changedSiblingTreeID = parentTreeID + JSFUNC.zero_pad_integer_from_left(changedSiblingOrder, 2);
            for(let changedDivisionObj of c_adminAllDivisionsArrayOfObjs) {
              if(changedDivisionObj.tree_id === oldDivisionTreeID) { //this is the sibling division being changed
                divisionsToUpdateArrayOfObjs.push({divisionID:changedDivisionObj.id, updatedTreeID:changedSiblingTreeID});
              }
              else if(JSFUNC.tree_id_is_child_of_parent_tree_id_tf(oldDivisionTreeID, changedDivisionObj.tree_id, false)) { //this is one of the children/subchildren of the changed division, needs the front part of the treeID changed
                var changedChildTreeID = changedSiblingTreeID + changedDivisionObj.tree_id.substring(oldDivisionTreeIDLength);
                divisionsToUpdateArrayOfObjs.push({divisionID:changedDivisionObj.id, updatedTreeID:changedChildTreeID});
              }
            }
          }
        }
      }

      const jsDescription = JSFUNC.js_description_from_action("AdminReact - DivisionsCreateNewDivisionFloatingBox", "onclick_create_new_division", [], []);
      const C_CallPhpTblUID = new JSPHP.ClassCallPhpTblUID(jsDescription);

      const fieldNamesArray = ["tree_id", "name", "nickname", "color", "business_type_id", "prime_sb_certifications_bm_set_aside_ids_comma", "firewalled_division_ids_comma", "sam_uei", "sam_uei_company_name", "integration_new_capture_integration_unique_id_prefix"];
      const valuesArray = [newDivisionTreeID, s_divisionName, s_divisionNickname, s_divisionColor, s_divisionBusinessTypeID, s_divisionPrimeSBCertificationsBmSetAsideIDsComma, "", "", "", ""];
      const idsbArray = ["s", "s", "s", "s", "i", "s", "s", "s", "s", "s"];
      C_CallPhpTblUID.add_insert("tbl_a_divisions", fieldNamesArray, valuesArray, idsbArray);

      for(let divisionToUpdateObj of divisionsToUpdateArrayOfObjs) {
        C_CallPhpTblUID.add_update("tbl_a_divisions", divisionToUpdateObj.divisionID, "tree_id", divisionToUpdateObj.updatedTreeID, "s");
      }

      const functionOnSuccess = (i_parseResponse) => {
        const newlyInsertedDivisionID = i_parseResponse.outputObj.i0;

        this.setState({s_isWorkingTF:false});
        
        const C_CallPhpTblUIDUpdateNewlyInsertedDivision = new JSPHP.ClassCallPhpTblUID(jsDescription);

        //after the new division is inserted, insert an admin changelog entry
        const adminChangelogValue = s_divisionName;
        C_CallPhpTblUIDUpdateNewlyInsertedDivision.add_changelog_admin(CEC.adminLogObj.actionCodesObj.CREATE_NEW_DIVISION, "", adminChangelogValue);
        
        //also, if this company is using firewalling, use the new divisionID created to fill in the firewalledDivisionIDsComma so that this new division can at least see itself
        if(this.props.DatabaseMobx.c_companyUsingDivisionFirewallingTF) {
          const newlyInsertedDivisionIDString = JSFUNC.num2str(newlyInsertedDivisionID); //must convert single int to a string as first entry into this comma list (doesn't matter for database, but needs to be correct type for internal memory)
          C_CallPhpTblUIDUpdateNewlyInsertedDivision.add_update("tbl_a_divisions", newlyInsertedDivisionID, "firewalled_division_ids_comma", newlyInsertedDivisionIDString, "s");
        }

        C_CallPhpTblUIDUpdateNewlyInsertedDivision.execute();

        this.onclick_close_create_new_division();
      }
      C_CallPhpTblUID.add_function("onSuccess", functionOnSuccess);

      C_CallPhpTblUID.execute();
    }
  }

  onclick_close_create_new_division = () => {
    if(JSFUNC.is_function(this.props.f_onClose)) {
      this.props.f_onClose();
    }
  }

  division_name_error_tf = () => { return(this.state.s_divisionName === ""); }
  parent_division_error_tf = () => { return(!JSFUNC.in_array(this.state.s_parentDivisionID, JSFUNC.get_column_vector_from_mapOfMaps(this.props.DatabaseMobx.o_tbl_a_divisions, "id"))); }
  sibling_order_error_tf = () => { return(this.state.s_siblingOrder <= 0); }

  render() {
    const s_divisionName = this.state.s_divisionName;
    const s_divisionNickname = this.state.s_divisionNickname;
    const s_divisionColor = this.state.s_divisionColor;
    const s_divisionBusinessTypeID = this.state.s_divisionBusinessTypeID;
    const s_divisionPrimeSBCertificationsBmSetAsideIDsComma = this.state.s_divisionPrimeSBCertificationsBmSetAsideIDsComma;
    const s_parentDivisionID = this.state.s_parentDivisionID;
    const s_siblingOrder = this.state.s_siblingOrder;
    const s_showErrorsTF = this.state.s_showErrorsTF;
    const s_isWorkingTF = this.state.s_isWorkingTF;

    const c_adminAllDivisionsArrayOfObjs = this.props.AdminMobx.c_adminAllDivisionsArrayOfObjs;
    const o_tbl_a_divisions = this.props.DatabaseMobx.o_tbl_a_divisions;
    const c_companyPrimeSBCertsCanVaryPerDivisionTF = this.props.DatabaseMobx.c_companyPrimeSBCertsCanVaryPerDivisionTF;

    const selectedDivisionBusinessTypeMap = this.props.DatabaseMobx.o_tbl_a_business_types.get(s_divisionBusinessTypeID);
    var selectedDivisionBusinessTypeIsSmallTF = false;
    if(selectedDivisionBusinessTypeMap !== undefined) {
      selectedDivisionBusinessTypeIsSmallTF = (selectedDivisionBusinessTypeMap.get("is_sb_type_01") === 1);
    }

    var divisionNameError = undefined;
    var parentDivisionError = undefined;
    var siblingOrderError = undefined;
    if(s_showErrorsTF) { //pushed the create button for the first time
      if(this.division_name_error_tf()) { divisionNameError = "New Division name cannot be blank"; }
      if(this.parent_division_error_tf()) { parentDivisionError = "A parent division (or the top position) must be selected for this new division"; }
      if(this.sibling_order_error_tf()) { siblingOrderError = "The new Division must have its sibling order selected"; }
    }

    //compute the number of sibling positions based on the selected parent
    const selectedParentDivisionMap = o_tbl_a_divisions.get(s_parentDivisionID);
    var order = 1;
    var childCount = 0;
    var siblingOrderArray = [];
    var siblingOrderDisplayArray = [];
    if(selectedParentDivisionMap !== undefined) {
      const parentTreeID = selectedParentDivisionMap.get("tree_id");
      for(let divisionObj of c_adminAllDivisionsArrayOfObjs) {
        if(JSFUNC.tree_id_is_child_of_parent_tree_id_tf(parentTreeID, divisionObj.tree_id, true)) {
          childCount++;

          if(childCount === 1) {
            siblingOrderArray.push(order);
            siblingOrderDisplayArray.push(order + " - before '" + divisionObj.name + "'");
            order++;
          }

          siblingOrderArray.push(order);
          siblingOrderDisplayArray.push(order + " - after '" + divisionObj.name + "'");
          order++;
        }
      }

      if(siblingOrderArray.length === 0) { //this selected parent division does not have any children yet
        siblingOrderArray.push(1);
        siblingOrderDisplayArray.push("1 - this will be the first subdivision under '" + selectedParentDivisionMap.get("name") + "'")
      }
    }

    const swsOptionsObj = undefined;
    const selectWithSearchDataObj = this.props.DatabaseMobx.create_sws_data_obj_from_value_array_and_display_array("Sibling Order", siblingOrderArray, false, siblingOrderDisplayArray, swsOptionsObj);
    const selectSiblingOrderFieldTypeObj = this.props.DatabaseMobx.create_field_type_obj("select", selectWithSearchDataObj);


    var order = 1;
    var childCount = 0;
    var visualDivisionsArrayOfObjs = undefined;
    if(selectedParentDivisionMap !== undefined) {
      const parentTreeID = selectedParentDivisionMap.get("tree_id");

      var numNewDivisionIndents = Math.ceil(parentTreeID.length / 2); //parent # indents + 1
      var indentsArray = [];
      for(let i = 0; i < numNewDivisionIndents; i++) {
        indentsArray.push(i);
      }
      var newDivisionObj = {id:-1, name:s_divisionName, color:s_divisionColor, indentsArray:indentsArray, tree_id:parentTreeID + "99"};

      visualDivisionsArrayOfObjs = [];
      for(let divisionObj of c_adminAllDivisionsArrayOfObjs) {
        if(JSFUNC.tree_id_is_child_of_parent_tree_id_tf(parentTreeID, divisionObj.tree_id, true)) {
          childCount++;

          if(childCount === 1) {
            if(s_siblingOrder === order) {
              newDivisionObj.tree_id = parentTreeID + "00";
            }
            order++;
          }

          visualDivisionsArrayOfObjs.push(divisionObj);

          if(s_siblingOrder === order) {
            newDivisionObj.tree_id = divisionObj.tree_id + "9999";
          }

          order++;
        }
        else {
          visualDivisionsArrayOfObjs.push(divisionObj);
        }
      }

      visualDivisionsArrayOfObjs.push(newDivisionObj);
      JSFUNC.sort_arrayOfObjs(visualDivisionsArrayOfObjs, "tree_id", true);
    }

    if(visualDivisionsArrayOfObjs === undefined) {
      visualDivisionsArrayOfObjs = c_adminAllDivisionsArrayOfObjs;
    }

    return(
      <CEGeneralReact.FloatingBoxWithSaveCancel
        p_trblFlag="addEditDeleteTableEditItem"
        p_title="Creating a New Division"
        f_onClickCancel={this.onclick_close_create_new_division}>
        <div className="flex11a displayFlexColumn">
          <div className="flex11a yScroll medFullPad">
            <DivisionsAddEditFloatingBoxSectionLabel p_label="Attributes" p_dividerLineAboveTF={false} />
            <div className="displayFlexRowVc tbMargin">
              <div className="flex11a" style={{flexBasis:"100em"}}>
                <font className="fontBlue">
                  {"Division Name"}
                </font>
              </div>
              <div className="flex11a" style={{flexBasis:"150em"}}>
                <LibraryReact.Text
                  p_value={s_divisionName}
                  p_styleObj={{width:"100%"}}
                  p_tabIndex={1}
                  p_errorTF={(divisionNameError !== undefined)}
                  f_onChange={this.onchange_division_name}
                />
                {(divisionNameError !== undefined) &&
                  <CEGeneralReact.ErrorText p_class="microTopMargin" p_text={divisionNameError} />
                }
              </div>
            </div>
            <div className="displayFlexRowVc tbMargin">
              <div className="flex11a" style={{flexBasis:"100em"}}>
                <font className="fontBlue">
                  {"Division Abbr Name (optional)"}
                </font>
              </div>
              <div className="flex11a" style={{flexBasis:"150em"}}>
                <LibraryReact.Text
                  p_value={s_divisionNickname}
                  p_styleObj={{width:"100%"}}
                  p_tabIndex={2}
                  p_errorTF={false}
                  f_onChange={this.onchange_division_nickname}
                />
              </div>
            </div>
            <div className="displayFlexRowVc tbMargin">
              <div className="flex11a" style={{flexBasis:"100em"}}>
                <font className="fontBlue">
                  {"Color (represents division in graphs)"}
                </font>
              </div>
              <div className="flex11a" style={{flexBasis:"150em"}}>
                <LibraryReact.Color
                  p_value={s_divisionColor}
                  p_styleObj={{width:"100%"}}
                  p_tabIndex={3}
                  p_errorTF={false}
                  f_onChange={this.onchange_division_color}
                />
              </div>
            </div>
            <div className="displayFlexRowVc tbMargin">
              <div className="flex11a" style={{flexBasis:"100em"}}>
                <font className="fontBlue">
                  {"Division Business Type"}
                </font>
              </div>
              <div className="flex11a" style={{flexBasis:"150em"}}>
                {(c_companyPrimeSBCertsCanVaryPerDivisionTF) ? (
                  <CEGeneralReact.GenericInputOrSelectFromInputType
                    p_fieldTypeObj={this.props.DatabaseMobx.c_selectBusinessTypeFieldTypeObj}
                    p_valueRaw={s_divisionBusinessTypeID}
                    p_tabIndex={4}
                    f_onChangeOrOnSelect={this.onchange_division_business_type}
                  />
                ) : (
                  <font className="fontItalic fontTextLighter">
                    {"Value is set at top level for all divisions"}
                  </font>
                )}
              </div>
            </div>
            <div className="displayFlexRowVc tbMargin">
              <div className="flex11a" style={{flexBasis:"100em"}}>
                <font className="fontBlue">
                  {"Small Business Certifications"}
                </font>
              </div>
              <div className="flex11a" style={{flexBasis:"150em"}}>
                {(c_companyPrimeSBCertsCanVaryPerDivisionTF) ? (
                  (selectedDivisionBusinessTypeIsSmallTF) ? (
                    <CEGeneralReact.GenericInputOrSelectFromInputType
                      p_fieldTypeObj={this.props.DatabaseMobx.c_selectMultiBitMasterSetAsidesFieldTypeObj}
                      p_valueRaw={s_divisionPrimeSBCertificationsBmSetAsideIDsComma}
                      p_tabIndex={5}
                      f_onChangeOrOnSelect={this.onchange_division_sb_certifications}
                    />
                  ) : (
                    <font className="fontItalic fontTextLighter">
                      {"N/A"}
                    </font>
                  )
                ) : (
                  <font className="fontItalic fontTextLighter">
                    {"Value is set at top level for all divisions"}
                  </font>
                )}
              </div>
            </div>
            <DivisionsAddEditFloatingBoxSectionLabel p_label="Org Chart Positioning" p_dividerLineAboveTF={true} />
            <div className="displayFlexRowVc tbMargin">
              <div className="flex11a" style={{flexBasis:"100em"}}>
                <font className="fontBlue">
                  {"Parent Division"}
                </font>
              </div>
              <div className="flex11a" style={{flexBasis:"150em"}}>
                <CEGeneralReact.GenericInputOrSelectFromInputType
                  p_fieldTypeObj={this.props.DatabaseMobx.c_selectDivisionFieldTypeObj}
                  p_valueRaw={s_parentDivisionID}
                  p_tabIndex={7}
                  p_errorTF={(parentDivisionError !== undefined)}
                  f_onChangeOrOnSelect={this.onchange_parent_division_id}
                />
                {(parentDivisionError !== undefined) &&
                  <CEGeneralReact.ErrorText p_class="microTopMargin" p_text={parentDivisionError} />
                }
              </div>
            </div>
            <div className="displayFlexRowVc tbMargin">
              <div className="flex11a" style={{flexBasis:"100em"}}>
                <font className="fontBlue">
                  {"Order Among Sibling Divisions"}
                </font>
              </div>
              <div className="flex11a" style={{flexBasis:"150em"}}>
                {(this.parent_division_error_tf()) ? (
                  <div className="flex11a" style={{flexBasis:"100em", height:"1.7em"}}>
                    <font className="fontItalic fontTextLighter">
                      {"--Select a Parent Division first--"}
                    </font>
                  </div>
                ) : (
                  <CEGeneralReact.GenericInputOrSelectFromInputType
                    p_fieldTypeObj={selectSiblingOrderFieldTypeObj}
                    p_valueRaw={s_siblingOrder}
                    p_tabIndex={8}
                    p_errorTF={(siblingOrderError !== undefined)}
                    f_onChangeOrOnSelect={this.onchange_sibling_order}
                  />
                )}
                {(siblingOrderError !== undefined) &&
                  <CEGeneralReact.ErrorText p_class="microTopMargin" p_text={siblingOrderError} />
                }
              </div>
            </div>
            <div className="hugeTopMargin hugeBottomMargin">
              {visualDivisionsArrayOfObjs.map((m_divisionObj) =>
                <div key={m_divisionObj.id} className="displayFlexRow lrMargin">
                  {m_divisionObj.indentsArray.map((i_indentNum) =>
                    <div className="flex00a" style={{flexBasis:"0.9em", borderLeft:"solid 1px #ddd", marginLeft:"0.6em"}} />
                  )}
                  <div
                    className="flex11a displayFlexRow microTopMargin microBottomMargin lrPad"
                    style={{height:"1.4em", background:((m_divisionObj.id > 0) ? ("#f5f2f0") : ("#cec")), border:"solid 1px " + ((m_divisionObj.id > 0) ? ("#cba") : ("#3b3")), borderRadius:"0.2em"}}>
                    <div className="flex00a microTopMargin microBottomMargin border bevelBorderColors" style={{flexBasis:"0.8em", background:"#" + m_divisionObj.color}} />
                    <div className="flex11a displayFlexRowVc lrPad" style={{flexBasis:"100em"}}>
                      <LibraryReact.NowrapEllipsis p_fontClass="">
                        {m_divisionObj.name}
                      </LibraryReact.NowrapEllipsis>
                    </div>
                  </div>
                </div>
              )}
          </div>
          </div>
        </div>
        <div className="flex00a displayFlexColumnHcVc tbMedPad borderT1ddd">
          {(s_isWorkingTF) ? (
            <CEGeneralReact.PhpWorkingMessage p_text="Creating Division..." />
          ) : (
            <CEGeneralReact.CEButton
              p_type="blue"
              p_text="Create New Division"
              p_tabIndex={9}
              f_onClick={this.onclick_create_new_division}
            />
          )}
        </div>
      </CEGeneralReact.FloatingBoxWithSaveCancel>
    );
  }
}));










//=================================================================================================================================================
//=================================================================================================================================================
//=================================================================================================================================================




export const AdminSubtabUsers = inject("CaptureExecMobx", "AdminMobx", "CapturesMobx", "DatabaseMobx")(observer(
class AdminSubtabUsers extends Component { //props: none
  constructor(props) {
    super(props);
    this.state = {
      s_editUserSettingsFloatingBoxIsOpenTF: false,
      s_creatingNewUserTF: false
    };
  }

  onclick_open_create_new_user_floating_box = () => {
    this.setState({s_creatingNewUserTF:true});
  }

  onclick_close_create_new_user_floating_box = () => {
    this.setState({s_creatingNewUserTF:false});
  }

  onclick_users_view_flag_tab = (i_newValue) => {
    this.props.AdminMobx.a_set_users_view_flag(i_newValue);
  }

  onclick_open_edit_user_settings_floating_box = () => {
    this.setState({s_editUserSettingsFloatingBoxIsOpenTF:true});
  }

  onclick_close_edit_user_settings_floating_box = () => {
    this.setState({s_editUserSettingsFloatingBoxIsOpenTF:false});
  }

  onsave_new_user_default_password = (i_newValue) => {
    this.props.AdminMobx.a_update_tbl_a_company_fields("new_user_default_password", i_newValue, "s");
  }

  onsave_days_between_user_password_change = (i_newValue) => {
    this.props.AdminMobx.a_update_tbl_a_company_fields("days_between_user_password_change", i_newValue, "i");
  }

  onsave_capture_consultants_can_view_parent_idiqs = (i_newValue) => {
    this.props.AdminMobx.a_update_tbl_a_company_fields("capture_consultants_can_view_parent_idiqs_01", i_newValue, "i");
  }

  render() {
    const s_editUserSettingsFloatingBoxIsOpenTF = this.state.s_editUserSettingsFloatingBoxIsOpenTF;
    const s_creatingNewUserTF = this.state.s_creatingNewUserTF;

    const c_productStylingObj = this.props.CaptureExecMobx.c_productStylingObj;
    const o_usersViewFlag = this.props.AdminMobx.o_usersViewFlag;
    const c_usersNumLicensesUsed = this.props.AdminMobx.c_usersNumLicensesUsed;
    const c_usersTotalNumNotDeactivatedSuperAdminsAdded = this.props.AdminMobx.c_usersTotalNumNotDeactivatedSuperAdminsAdded;
    const c_usersUsingMaxNumSuperAdminsTF = this.props.AdminMobx.c_usersUsingMaxNumSuperAdminsTF;
    const c_usersNumNotDeactivatedCaptureConsultantsUsed = this.props.AdminMobx.c_usersNumNotDeactivatedCaptureConsultantsUsed;
    const c_usersNumLicensesRemaining = this.props.AdminMobx.c_usersNumLicensesRemaining;
    const c_usersCanAddNewUserTF = this.props.AdminMobx.c_usersCanAddNewUserTF;
    const c_captureTableCurrentlyProcessingCapturesTF = this.props.CapturesMobx.c_captureTableCurrentlyProcessingCapturesTF;
    const c_bitNumLicensesPurchased = this.props.DatabaseMobx.c_bitNumLicensesPurchased;
    const c_bitEnterpriseLicenseTF = this.props.DatabaseMobx.c_bitEnterpriseLicenseTF;
    const c_bitConsultantsLicenseCost = this.props.DatabaseMobx.c_bitConsultantsLicenseCost;
    const c_bitLicenseNumMonths = this.props.DatabaseMobx.c_bitLicenseNumMonths;
    const c_bitLicenseStartDate = this.props.DatabaseMobx.c_bitLicenseStartDate;
    const c_bitSuperAdminsMaxNum = this.props.DatabaseMobx.c_bitSuperAdminsMaxNum;

    var licenseExpirationDateMask = undefined;
    if(c_bitLicenseStartDate !== undefined && c_bitLicenseNumMonths !== undefined) {
      const licenseExpirationDate = JSFUNC.compute_end_date_from_start_date_and_num_months(c_bitLicenseStartDate, c_bitLicenseNumMonths);
      licenseExpirationDateMask = this.props.DatabaseMobx.value_mask_from_value_raw_and_field_type_obj(licenseExpirationDate, this.props.DatabaseMobx.c_genericDateFieldTypeObj);
    }
    else {
      licenseExpirationDateMask = "--";
    }

    const totalLicensesPurchasedMask = ((c_bitEnterpriseLicenseTF) ? ("Enterprise License") : (c_bitNumLicensesPurchased + " User License"));

    var usersListComponent = null;
    if(c_captureTableCurrentlyProcessingCapturesTF) {
      usersListComponent = (
      <CEGeneralReact.EmptyScreenGrayWithLoadingAnimation>
        {"Processing Captures"}
      </CEGeneralReact.EmptyScreenGrayWithLoadingAnimation>);
    }
    else if(o_usersViewFlag === "DivisionTreeUsersSingleEdit") {
      usersListComponent = (<UsersNotDeactivatedUsersPerDivisionTree />);
    }
    else {
      usersListComponent = (<AdminUsersPerEmailList />);
    }

    return (
      <div className="flex11a yScroll yScrollBottomPad">
        <div className="displayFlexRow flexWrap">
          {(c_productStylingObj.setupUsersShowLicenseExpirationTF) &&
            <div className="flex00a displayFlexColumnHcVc lrMedPad">
              <LibraryReact.DivFont p_fontClass="font12 fontItalic fontTextLighter">
                {"License Expiration:"}
              </LibraryReact.DivFont>
              <LibraryReact.DivFont p_fontClass="font12 fontBold fontTextLight">
                {licenseExpirationDateMask}
              </LibraryReact.DivFont>
              <LibraryReact.DivFont p_fontClass="fontItalic fontTextLighter">
                {totalLicensesPurchasedMask}
              </LibraryReact.DivFont>
            </div>
          }
          <div className="flex00a displayFlexColumnHcVc lrMedPad">
            {(!c_bitEnterpriseLicenseTF) &&
              <>
                <LibraryReact.DivFont p_fontClass="fontItalic fontTextLighter">
                  {c_usersNumLicensesUsed + " / " + c_bitNumLicensesPurchased + " Licenses Used"}
                </LibraryReact.DivFont>
                {(c_usersUsingMaxNumSuperAdminsTF) &&
                  <LibraryReact.DivFont p_fontClass="fontItalic fontTextLighter">
                    {c_usersTotalNumNotDeactivatedSuperAdminsAdded + " / " + c_bitSuperAdminsMaxNum + " Super Admins Assigned"}
                  </LibraryReact.DivFont>
                }
                <LibraryReact.DivFont p_fontClass="font12 fontTextLight">
                  <span className="fontBold">{c_usersNumLicensesRemaining}</span>{" " + JSFUNC.plural(c_usersNumLicensesRemaining, "License", "Licenses") + " Remaining"}
                </LibraryReact.DivFont>
                {((c_bitConsultantsLicenseCost === 0) && (c_usersNumNotDeactivatedCaptureConsultantsUsed > 0)) &&
                  <LibraryReact.DivFont p_fontClass="font09 fontItalic fontTextLighter">
                    {c_usersNumNotDeactivatedCaptureConsultantsUsed + " Capture " + JSFUNC.plural(c_usersNumNotDeactivatedCaptureConsultantsUsed, "Consultant", "Consultants")}
                  </LibraryReact.DivFont>
                }
              </>
            }
          </div>
          <div className="flex11a displayFlexRowVc lrMedPad">
            {(c_usersCanAddNewUserTF) ? (
              <CEGeneralReact.CEButton
                p_type="blue"
                p_text="Add New User"
                f_onClick={this.onclick_open_create_new_user_floating_box}
              />
            ) : (
              <LibraryReact.DivFont p_class="border1 bevelBorderColorBlue borderRadius05 microFullPad textCenter" p_styleObj={{maxWidth:"17em"}} p_fontClass="fontBold">
                {"For additional licenses, contact support@bitsolutionsllc.com"}
              </LibraryReact.DivFont>
            )}
          </div>
          <div className="flex00a displayFlexColumnHcVc smallFullPad">
            <CEGeneralReact.TabsList
              p_tabDbNamesArray={["lastNameAlphabeticList", "DivisionTreeUsersSingleEdit"]}
              p_tabDisplayNamesArray={["View as List\n(Alphabetic by\nLast Name)", "View as\nDivision Tree"]}
              p_selectedTabDbName={o_usersViewFlag}
              p_tabHeight="4em"
              p_textMaxHeight="3.8em"
              p_tabWidth="8em"
              p_unselectedFontClass="fontTextLighter"
              p_unselectedBgClass="bgLightesterGrayGradient hoverLighterBlueGradient fontTextLight"
              p_selectedBgClass="bgLightGoldGradient"
              p_selectedFontClass="fontTextLight"
              f_onSelect={this.onclick_users_view_flag_tab}
            />
          </div>
          <UsersUnassignedMatchingCapturesBox />
          <div className="flex00a displayFlexColumnHcVc borderL1ddd lrMedPad">
            <CEGeneralReact.CEButton
              p_type="add"
              p_text="Edit General User Settings"
              f_onClick={this.onclick_open_edit_user_settings_floating_box}
            />
          </div>
        </div>
        {usersListComponent}
        <div className="flex00a" style={{marginBottom:"2em"}} />
        {(s_editUserSettingsFloatingBoxIsOpenTF) &&
          <CEGeneralReact.FloatingBoxWithSaveCancel
            p_trblFlag="smallVertical"
            p_title="Edit General User Settings"
            f_onClickSave={this.onclick_close_edit_user_settings_floating_box}>
            <div className="flex11a displayFlexColumn medFullPad yScroll">
              <LibraryReact.DivFont p_class="smallBottomMargin" p_fontClass="font12 fontBold fontDarkBlue">
                {"Passwords"}
              </LibraryReact.DivFont>
              <CEGeneralReact.CaptureExecFieldEditSaveCancel
                p_ceEditItemString="adminUsersUserDefaultPassword"
                p_fieldDisplayName="New User Default Password"
                p_fieldTypeObj={this.props.DatabaseMobx.c_genericTextFieldTypeObj}
                p_valueRaw={this.props.DatabaseMobx.c_companyNewUserDefaultPassword}
                p_valueIsEditableTFU={true}
                p_containerClass="microBottomMargin"
                p_fieldClass="fontBlue"
                p_fieldWidth="18em"
                f_onSaveChanged={this.onsave_new_user_default_password}
              />
              <CEGeneralReact.CaptureExecFieldEditSaveCancel
                p_ceEditItemString="adminUsersDaysBetweenUserPasswordChange"
                p_fieldDisplayName="Days Between User Password Change"
                p_fieldTypeObj={this.props.DatabaseMobx.c_genericIntPositiveFieldTypeObj}
                p_valueRaw={this.props.DatabaseMobx.c_companyDaysBetweenUserPasswordChange}
                p_valueIsEditableTFU={true}
                p_containerClass="microBottomMargin"
                p_fieldClass="fontBlue"
                p_fieldWidth="18em"
                f_onSaveChanged={this.onsave_days_between_user_password_change}
              />
              <LibraryReact.DivFont p_class="hugeTopMargin smallBottomMargin" p_fontClass="font12 fontBold fontDarkBlue">
                {"Capture Consultants"}
              </LibraryReact.DivFont>
              <CEGeneralReact.CaptureExecFieldEditSaveCancel
                p_ceEditItemString="adminUsers"
                p_fieldDisplayName="Capture Consultant IDIQ Visibility"
                p_fieldTypeObj={this.props.AdminMobx.c_usersSettingsSelectCaptureConsultantsCanViewParentIDIQsFieldTypeObj}
                p_valueRaw={this.props.DatabaseMobx.c_companyCaptureConsultantsCanViewParentIDIQs01}
                p_valueIsEditableTFU={true}
                p_containerClass="microBottomMargin"
                p_fieldClass="fontBlue"
                p_fieldWidth="18em"
                f_onSaveChanged={this.onsave_capture_consultants_can_view_parent_idiqs}
              />
            </div>
          </CEGeneralReact.FloatingBoxWithSaveCancel>
        }
        {(s_creatingNewUserTF) &&
          <UsersCreateNewUserPower
            p_includeUpeTF={true}
            p_userPerEmailObj={undefined}
            f_onClose={this.onclick_close_create_new_user_floating_box}
          />
        }
      </div>
    );
  }
}));



const UsersUnassignedMatchingCapturesBox = inject("AdminMobx", "DatabaseMobx")(observer(
class UsersUnassignedMatchingCapturesBox extends Component { //props: none
  render() {
    const c_usersUnassignedMatchingCapturesObj = this.props.AdminMobx.c_usersUnassignedMatchingCapturesObj;
    const c_fieldMapOfCaptureManagers = this.props.DatabaseMobx.c_fieldMapOfCaptureManagers;

    if(!JSFUNC.is_number_not_nan_gte_0(c_usersUnassignedMatchingCapturesObj.numMatchingCaptures)) {
      return(null);
    }

    return (
      <div className="flex00a displayFlexColumnVc borderL1ddd lrPad">
        <CEComplexReact.UnassignedMatchingCapturesBoxAndCountButton
          p_unassignedMatchingCapturesObj={c_usersUnassignedMatchingCapturesObj}
          p_fieldDisplayName={c_fieldMapOfCaptureManagers.get("display_name")}
        />
      </div>
    );
  }
}));


const UsersNotDeactivatedUsersPerDivisionTree = inject("AdminMobx", "DatabaseMobx")(observer(
class UsersNotDeactivatedUsersPerDivisionTree extends Component { //props: none
  constructor(props) {
    super(props);
    this.state = {
      s_divisionViewUserIDExpandedOrUndefined: false
    };
  }

  onclick_division_view_expand_user_row = (i_userID) => {
    this.setState({s_divisionViewUserIDExpandedOrUndefined:i_userID});
  }

  render() {
    const s_divisionViewUserIDExpandedOrUndefined = this.state.s_divisionViewUserIDExpandedOrUndefined;

    const c_userNotDeactivatedUsersPerDivisionTreeArrayOfObjs = this.props.AdminMobx.c_userNotDeactivatedUsersPerDivisionTreeArrayOfObjs;

    return (
      <>
        {c_userNotDeactivatedUsersPerDivisionTreeArrayOfObjs.map((m_expandedDivisionObj) =>
          <div key={m_expandedDivisionObj.id} className="displayFlexRow lrMedMargin">
            {m_expandedDivisionObj.indentsArray.map((i_indentNum) =>
              <div key={"ind" + i_indentNum} className="flex00a borderL1ddd" style={{flexBasis:"1.6em", marginLeft:"0.8em"}} />
            )}
            <div className="flex11a tbMicroMargin lrPad" style={{backgroundColor:"#f5f2f0", border:"solid 1px #cba", borderRadius:"0.5em"}}>
              <div className="displayFlexRow" style={{height:"2.5em"}}>
                <div className="flex00a smallFullMargin border bevelBorderColors" style={{flexBasis:"1em", background:"#" + m_expandedDivisionObj.color}} />
                <div className="flex11a displayFlexColumnVc lrPad" style={{flexBasis:"100em"}}>
                  <LibraryReact.NowrapEllipsis p_fontClass="font11">
                    <span className="fontBold fontTextLight">{m_expandedDivisionObj.name}</span>
                    <span className="fontTextLight">{" (Licenses: " + m_expandedDivisionObj.userLicensesUsed + " in division, " + m_expandedDivisionObj.allSubdivisionUserLicensesUsed + " including all subdivisions)"}</span>
                  </LibraryReact.NowrapEllipsis>
                </div>
              </div>
              {m_expandedDivisionObj.superExpandedUsersArrayOfObjs.map((m_superExpandedUserObj) =>
                <AdminDivisionViewSimpleUserRowWithClick
                  key={m_superExpandedUserObj.id}
                  p_isExpandedShowingFullUserPerEmailTF={(s_divisionViewUserIDExpandedOrUndefined === m_superExpandedUserObj.user_id)}
                  p_userPerEmailObj={m_superExpandedUserObj.userPerEmailObj}
                  p_expandedUserObj={m_superExpandedUserObj}
                  f_onClick={this.onclick_division_view_expand_user_row}
                />
              )}
            </div>
          </div>
        )}
        <AdminUsersPerEmailSectionList
          p_sectionFlagAc0Ps1DeAc2={2}
          p_editRowTrueDisplayNameOnlyFalse={false}
          p_isFirstSectionTF={false}
          p_showIfEmptyTF={true}
        />
      </>
    );
  }
}));


class AdminDivisionViewSimpleUserRowWithClick extends Component { //props: p_isExpandedShowingFullUserPerEmailTF, p_userPerEmailObj, p_expandedUserObj, f_onClick
  onclick_collapsed_user_row = () => {
    const p_isExpandedShowingFullUserPerEmailTF = this.props.p_isExpandedShowingFullUserPerEmailTF;
    const p_expandedUserObj = this.props.p_expandedUserObj;
    const f_onClick = this.props.f_onClick;

    if(JSFUNC.is_function(f_onClick)) {
      var updatedUserIDOrUndefined = undefined;
      if(!p_isExpandedShowingFullUserPerEmailTF) {
        updatedUserIDOrUndefined = p_expandedUserObj.user_id;
      }
      f_onClick(updatedUserIDOrUndefined);
    }
  }

  render() {
    const p_isExpandedShowingFullUserPerEmailTF = this.props.p_isExpandedShowingFullUserPerEmailTF;
    const p_userPerEmailObj = this.props.p_userPerEmailObj;
    const p_expandedUserObj = this.props.p_expandedUserObj;
    const f_onClick = this.props.f_onClick;

    var userPowerDisplayNameParenAndBitNonBillableUserText = "(" + p_expandedUserObj.powerDisplayName + ")";
    if(p_expandedUserObj.bitNonBillableUserTF) {
      userPowerDisplayNameParenAndBitNonBillableUserText += " [BIT Non-Billable User]";
    }

    return(
      <div className="tbMicroMargin lrMedMargin border bevelBorderColorBlue bgLightestBlue">
        <div
          className="displayFlexRowVc hoverLightBlueGradient smallFullPad cursorPointer"
          title={"Click to open/close edit for User '" + p_userPerEmailObj.upeFirstNameLastName + "'"}
          onClick={this.onclick_collapsed_user_row}>
          <div className="flex11a" style={{flexBasis:"100em"}}>
            <span className="fontBlue">{p_userPerEmailObj.upeFirstNameLastName + " "}</span>
            <span className="fontItalic fontTextLight">{userPowerDisplayNameParenAndBitNonBillableUserText}</span>
          </div>
          <div className="flex11a" style={{flexBasis:"200em"}}>
            <span className="fontTextLight">{"License: " + p_expandedUserObj.powerLicenseCost}</span>
          </div>
        </div>
        {(p_isExpandedShowingFullUserPerEmailTF) &&
          <AdminUserPerEmail p_userPerEmailObj={p_userPerEmailObj} />
        }
      </div>
    );
  }
}


function AdminUsersPerEmailList(props) { //props: none
  return(
    <>
      <AdminUsersPerEmailSectionList p_sectionFlagAc0Ps1DeAc2={0} p_editRowTrueDisplayNameOnlyFalse={true} p_isFirstSectionTF={true} p_showIfEmptyTF={true} />
      <AdminUsersPerEmailSectionList p_sectionFlagAc0Ps1DeAc2={1} p_editRowTrueDisplayNameOnlyFalse={true} p_isFirstSectionTF={false} p_showIfEmptyTF={false} />
      <AdminUsersPerEmailSectionList p_sectionFlagAc0Ps1DeAc2={2} p_editRowTrueDisplayNameOnlyFalse={true} p_isFirstSectionTF={false} p_showIfEmptyTF={true} />
    </>
  );
}


const AdminUsersPerEmailSectionList = inject("CaptureExecMobx", "AdminMobx")(observer(
class AdminUsersPerEmailSectionList extends Component { //props: p_sectionFlagAc0Ps1DeAc2, p_editRowTrueDisplayNameOnlyFalse, p_isFirstSectionTF, p_showIfEmptyTF
  render() {
    const p_sectionFlagAc0Ps1DeAc2 = this.props.p_sectionFlagAc0Ps1DeAc2;
    const p_editRowTrueDisplayNameOnlyFalse = this.props.p_editRowTrueDisplayNameOnlyFalse;
    const p_isFirstSectionTF = this.props.p_isFirstSectionTF;
    const p_showIfEmptyTF = this.props.p_showIfEmptyTF;

    const c_productStylingObj = this.props.CaptureExecMobx.c_productStylingObj;
    const c_notDeactivatedNotProposalSupportExpandedUpesWithUpowersArrayOfObjs = this.props.AdminMobx.c_notDeactivatedNotProposalSupportExpandedUpesWithUpowersArrayOfObjs;
    const c_notDeactivatedOnlyProposalSupportExpandedUpesWithUpowersArrayOfObjs = this.props.AdminMobx.c_notDeactivatedOnlyProposalSupportExpandedUpesWithUpowersArrayOfObjs;
    const c_deactivatedExpandedUpesWithUpowersArrayOfObjs = this.props.AdminMobx.c_deactivatedExpandedUpesWithUpowersArrayOfObjs;

    var expandedUsersPerEmailArrayOfObjs = [];
    var sectionTitle = "";
    var sectionSubTitle = "";
    if(p_sectionFlagAc0Ps1DeAc2 === 0) {
      expandedUsersPerEmailArrayOfObjs = c_notDeactivatedNotProposalSupportExpandedUpesWithUpowersArrayOfObjs;
      sectionTitle = "Active " + c_productStylingObj.productName + " Users";
      sectionSubTitle = "";
    }
    else if(p_sectionFlagAc0Ps1DeAc2 === 1) {
      expandedUsersPerEmailArrayOfObjs = c_notDeactivatedOnlyProposalSupportExpandedUpesWithUpowersArrayOfObjs;
      sectionTitle = "Proposal Support Users";
      sectionSubTitle = "These Users can only load the Captures they have been assigned to work on and have limited visibility into sensitive Capture Card information.";
    }
    else if(p_sectionFlagAc0Ps1DeAc2 === 2) {
      expandedUsersPerEmailArrayOfObjs = c_deactivatedExpandedUpesWithUpowersArrayOfObjs;
      sectionTitle = "Deactivated Users";
      sectionSubTitle = "These users can no longer log into " + c_productStylingObj.productName + " and do not take up any licenses, however, their names and past activity are kept intact throughout the system.";
    }

    const upeListIsValidTF = JSFUNC.is_array(expandedUsersPerEmailArrayOfObjs);
    const numUsersPerEmail = ((upeListIsValidTF) ? (expandedUsersPerEmailArrayOfObjs.length) : (0));

    //if there are no users in this section and the flag to show the section if empty is not true, return null to not render anything for this section
    if(!((numUsersPerEmail > 0) || p_showIfEmptyTF)) {
      return(null);
    }

    //draw the section with the list of users per email for this section
    return(
      <>
        <div className={((p_isFirstSectionTF) ? ("") : ("enormousTopMargin")) + " bigTopPad borderT1bbb"}>
          <div className="lrMedPad medBottomMargin">
            <LibraryReact.DivFont p_class="microBottomMargin" p_fontClass="font15 fontItalic fontTextLighter">
              {sectionTitle}
            </LibraryReact.DivFont>
            {JSFUNC.string_is_filled_out_tf(sectionSubTitle) &&
              <LibraryReact.DivFont p_class="tbMicroMargin" p_fontClass="fontItalic fontTextLighter">
                {sectionSubTitle}
              </LibraryReact.DivFont>
            }
          </div>
          {expandedUsersPerEmailArrayOfObjs.map((m_userPerEmailObj) =>
            ((p_editRowTrueDisplayNameOnlyFalse) ? (
              <AdminUserPerEmail
                key={m_userPerEmailObj.id}
                p_userPerEmailObj={m_userPerEmailObj}
              />
            ) : (
              <LibraryReact.DivFont key={m_userPerEmailObj.id} p_class="displayFlexRowVc tbMicroMargin lrMedMargin border1bbb bgLightestGray smallFullPad" p_fontClass="fontItalic fontTextLight">
                {m_userPerEmailObj.upeFirstNameLastName}
              </LibraryReact.DivFont>
            ))
          )}
        </div>
      </>
    );
  }
}));



const AdminUserPerEmail = inject("CaptureExecMobx", "AdminMobx", "DatabaseMobx", "UserMobx")(observer(
class AdminUserPerEmail extends Component { //props: p_userPerEmailObj
  constructor(props) {
    super(props);
    this.state = {
      s_editingUserPerEmailTF: false,
      s_creatingNewUserPowerTF: false,
      s_welcomeEmailSentSuccessMessageTF: false,
      s_reassignUserCustomCreationsFloatingBoxIsOpenTF: false
    };
  }

  onclick_upe_name_email_edit = () => {
    this.setState({s_editingUserPerEmailTF:true});
  }

  onclick_close_upe_name_email_edit = () => {
    this.setState({s_editingUserPerEmailTF:false});
  }

  onsave_upe_first_name = (i_newValue) => {
    this.update_upe_field("first_name", i_newValue, "s", "First Name", i_newValue);
  }

  onsave_upe_last_name = (i_newValue) => {
    this.update_upe_field("last_name", i_newValue, "s", "Last Name", i_newValue);
  }

  onsave_upe_email = (i_newValue) => {
    this.update_upe_field("email", i_newValue, "s", "Email", i_newValue);
  }

  onsave_upe_title_role = (i_newValue) => {
    this.update_upe_field("title_role", i_newValue, "s", "Title/Role", i_newValue);
  }

  onsave_upe_outside_company_name = (i_newValue) => {
    this.update_upe_field("outside_company_name", i_newValue, "s", "Outside Company Name", i_newValue);
  }

  onclick_lockedout_switch = () => {
    const newValue01 = ((this.props.p_userPerEmailObj.lockedout === 1) ? (0) : (1));
    const newValueDisplay = ((newValue01 === 1) ? ("Locked") : ("Unlocked"));
    this.update_upe_field("lockedout", newValue01, "i", "Locked Out", newValueDisplay);
  }

  onclick_deactivated_switch = () => {
    const p_userPerEmailObj = this.props.p_userPerEmailObj;
    
    const newValue01 = ((p_userPerEmailObj.disabled === 1) ? (0) : (1));

    //if switching from deactivated to activated, but this user has a reason blocking reactivation, display the reason and do not perform the update
    if((newValue01 === 0) && (p_userPerEmailObj.userCannotBeReactivatedReasonTextOrUndefined !== undefined)) {
      alert(p_userPerEmailObj.userCannotBeReactivatedReasonTextOrUndefined);
    }
    else { //otherwise update the deactivated field toggle
      const adminChangelogField = "Deactivation Switch";
      const adminChangelogValue = ((newValue01 === 0) ? ("Reactivated") : ("Deactivated")); //0-new value is 'not deactivated', so reactivation
      this.update_upe_field("disabled", newValue01, "i", adminChangelogField, adminChangelogValue);
    }
  }

  onclick_create_public_switch = () => {
    const p_userPerEmailObj = this.props.p_userPerEmailObj;
    const newValue01 = ((p_userPerEmailObj.can_create_public_01 === 1) ? (0) : (1));
    const newValueDisplay = ((newValue01 === 1) ? ("On") : ("Off"));
    this.update_upe_field("can_create_public_01", newValue01, "i", "Create Public Switch", newValueDisplay);
  }

  update_upe_field = (i_fieldName, i_value, i_idsb, i_adminChangelogField, i_adminChangelogValueMaskPlainText) => {
    const p_userPerEmailObj = this.props.p_userPerEmailObj;
    
    const c_userName = this.props.UserMobx.c_userName;
    
    const jsDescription = JSFUNC.js_description_from_action("AdminReact - AdminUserPerEmail", "update_upe_field", ["i_fieldName", "i_value", "i_idsb"], [i_fieldName, i_value, i_idsb]);
    const C_CallPhpTblUID = new JSPHP.ClassCallPhpTblUID(jsDescription);

    C_CallPhpTblUID.add_update("tbl_a_users_per_email", p_userPerEmailObj.id, i_fieldName, i_value, i_idsb);

    //insert an admin changelog entry
    const functionOnSuccess = (i_parseResponse) => {
      const adminChangelogField = "[Edited User '" + c_userName + "'] " + i_adminChangelogField;
      const C_CallPhpTblUIDAfterUpdateUserPerEmailField = new JSPHP.ClassCallPhpTblUID(jsDescription);
      C_CallPhpTblUIDAfterUpdateUserPerEmailField.add_changelog_admin(CEC.adminLogObj.actionCodesObj.EDIT_USER, adminChangelogField, i_adminChangelogValueMaskPlainText);
      C_CallPhpTblUIDAfterUpdateUserPerEmailField.execute();
    }
    C_CallPhpTblUID.add_function("onSuccess", functionOnSuccess);

    C_CallPhpTblUID.execute();
  }

  onclick_add_user_power = () => {
    this.setState({s_creatingNewUserPowerTF:true});
  }

  onclick_close_new_user_power = () => {
    this.setState({s_creatingNewUserPowerTF:false});
  }

  onconfirm_resend_user_per_email_welcome_email = () => {
    const c_companyNewUserDefaultPassword = this.props.DatabaseMobx.c_companyNewUserDefaultPassword;
    this.update_upe_field("password", c_companyNewUserDefaultPassword, "s", "Reset Password", "Reset User Password to Company Default '" + c_companyNewUserDefaultPassword + "'");
    this.onclick_send_user_welcome_email();
  }

  ondelete_user_per_email_and_all_powers = () => {
    const p_userPerEmailObj = this.props.p_userPerEmailObj;

    const jsDescription = JSFUNC.js_description_from_action("AdminReact - AdminUserPerEmail", "ondelete_user_per_email_and_all_powers", [], []);
    const C_CallPhpTblUID = new JSPHP.ClassCallPhpTblUID(jsDescription);

    //delete all user powers associated with this userPerEmail
    const userIDsToDeleteArray = JSFUNC.get_column_vector_from_arrayOfObjs(p_userPerEmailObj.upeMultiLoginCombinedUsersArrayOfObjs, "user_id");
    C_CallPhpTblUID.add_delete("tbl_a_users", userIDsToDeleteArray); //users are sorted by power sort and division_tree id, no resort needed when deleting

    //delete the userPerEmail record
    C_CallPhpTblUID.add_delete("tbl_a_users_per_email", this.props.p_userPerEmailObj.id); //users are sorted by power sort and division_tree id, no resort needed when deleting

    const functionOnSuccess = (i_parseResponse) => {
      //insert an admin changelog entry
      const C_CallPhpTblUIDAfterDeleteUserPerEmailWithUsers = new JSPHP.ClassCallPhpTblUID(jsDescription);
      const deletedUserPerEmailPowerDisplayNamesArray = JSFUNC.get_column_vector_from_arrayOfObjs(p_userPerEmailObj.upeMultiLoginCombinedUsersArrayOfObjs, "powerDisplayName");
      const deletedUserPerEmailPowerDisplayNamesDisplayComma = JSFUNC.convert_array_to_display_comma_list(deletedUserPerEmailPowerDisplayNamesArray);
      const adminChangelogValue = p_userPerEmailObj.upeFirstNameLastName + " (" + deletedUserPerEmailPowerDisplayNamesDisplayComma + ")";
      C_CallPhpTblUIDAfterDeleteUserPerEmailWithUsers.add_changelog_admin(CEC.adminLogObj.actionCodesObj.DELETE_USER, "", adminChangelogValue);
      C_CallPhpTblUIDAfterDeleteUserPerEmailWithUsers.execute();
    }
    C_CallPhpTblUID.add_function("onSuccess", functionOnSuccess);

    C_CallPhpTblUID.execute();
  }

  onclick_send_user_welcome_email = () => {
    const p_userPerEmailObj = this.props.p_userPerEmailObj;

    const c_computedUrlAndProductObj = this.props.CaptureExecMobx.c_computedUrlAndProductObj;
    const c_productStylingObj = this.props.CaptureExecMobx.c_productStylingObj;
    const c_companyNewUserDefaultPassword = this.props.DatabaseMobx.c_companyNewUserDefaultPassword;
    const o_userCompanyCode = this.props.UserMobx.o_userCompanyCode;
    const c_combinedUserObj = this.props.UserMobx.c_combinedUserObj;
    const c_userName = this.props.UserMobx.c_userName;

    if(p_userPerEmailObj.upeMultiLoginCombinedUsersArrayOfObjs.length > 0) {
      const upeCombinedUserObj = p_userPerEmailObj.upeMultiLoginCombinedUsersArrayOfObjs[0]; //use the first of any mulitlogins for the user power since they are ordered with admin first, divexec next, which are the most important, most likely brand new users will only have 1 power to send the email to

      const jsDescription = JSFUNC.js_description_from_action("AdminReact - AdminUserPerEmail", "onclick_send_user_welcome_email", [], []);
      const C_CallPhpTblUID = new JSPHP.ClassCallPhpTblUID(jsDescription);
      
      //captureexec.com (on-premise has a different URL so tell them to go there)
      const captureExecSiteLinkDisplay = ((CEC.onPremiseCustomer.ON_PREMISE_CUSTOMER_TF) ? (o_userCompanyCode + " Internal " + c_productStylingObj.productName + " Site") : (c_productStylingObj.productShortWebAddress));

      const welcomeEmailSubject = "Welcome to " + c_productStylingObj.productName + " - Leading the Innovation of Integrated Pipeline Management";

      var welcomeEmailBody = "Hello " + p_userPerEmailObj.first_name + "!<br /><br />";
      welcomeEmailBody += "The Admin of your " + c_productStylingObj.productName + " system has added you as " + ((upeCombinedUserObj.powerDisplayNameRequiresAnTrueAFalse) ? ("an") : ("a")) + " " + upeCombinedUserObj.powerDisplayName + ".";
      welcomeEmailBody += " We're really excited to begin this journey together with you and look forward to many wins in your future!";
      welcomeEmailBody += "<br /><br />Below is the link to " + c_productStylingObj.productName + ", along with your login credentials and a one-time password to get started:<br /><br /><br />";
      if(JSFUNC.string_is_filled_out_tf(c_computedUrlAndProductObj.productUrlDevRemovedEndingSlashRemoved)) {
        welcomeEmailBody += '<a href="' + c_computedUrlAndProductObj.productUrlDevRemovedEndingSlashRemoved + '">' + captureExecSiteLinkDisplay + '</a><br />';
      }
      else {
        welcomeEmailBody += captureExecSiteLinkDisplay + '<br />';
      }
      welcomeEmailBody += "Company Code: " + o_userCompanyCode + "<br />";
      welcomeEmailBody += "Email: " + p_userPerEmailObj.email + "<br />";
      welcomeEmailBody += "One-Time Password: " + c_companyNewUserDefaultPassword + "<br /><br /><br />";
      welcomeEmailBody += "We at BIT Solutions are here to provide your organization the most comprehensive, intuitive, and seamless experience that proactively guides each deal from inception to win.  ";
      welcomeEmailBody += "Our mission is simple, to never be satisfied as a simple data entry CRM, but to be so much more...to continuously automate, evolve, and collaborate with you to provide the most powerful, user-friendly software on the market.<br /><br />";
      welcomeEmailBody += " - BIT Solutions<br /><br /><br />";
      welcomeEmailBody += "Your " + c_productStylingObj.productName + " Admin:<br />";
      welcomeEmailBody += c_userName + " (" + c_combinedUserObj.email + ")";

      const fromEmail = "";
      const fromFullName = "";
      const notificationClickActionString = "";
      
      C_CallPhpTblUID.add_email(p_userPerEmailObj.email, "", welcomeEmailSubject, welcomeEmailBody, fromEmail, fromFullName, notificationClickActionString);

      C_CallPhpTblUID.add_update("tbl_a_users_per_email", p_userPerEmailObj.id, "welcome_email_sent_01", 1, "i");

      const functionOnFinish = () => {
        this.setState({s_welcomeEmailSentSuccessMessageTF:true});
      }
      C_CallPhpTblUID.add_function("onFinish", functionOnFinish);

      C_CallPhpTblUID.execute();
    }
  }

  onclick_dismiss_send_user_welcome_email = () => {
    const p_userPerEmailObj = this.props.p_userPerEmailObj;

    const jsDescription = JSFUNC.js_description_from_action("AdminReact - AdminUserPerEmail", "onclick_dismiss_send_user_welcome_email", [], []);
    const C_CallPhpTblUID = new JSPHP.ClassCallPhpTblUID(jsDescription);
    C_CallPhpTblUID.add_update("tbl_a_users_per_email", p_userPerEmailObj.id, "welcome_email_sent_01", 1, "i");
    C_CallPhpTblUID.execute();
  }

  onclick_open_reassign_user_custom_creations_floating_box = () => {
    this.setState({s_reassignUserCustomCreationsFloatingBoxIsOpenTF:true});
  }

  onclick_close_reassign_user_custom_creations_floating_box = () => {
    this.setState({s_reassignUserCustomCreationsFloatingBoxIsOpenTF:false});
  }

  render() {
    const s_editingUserPerEmailTF = this.state.s_editingUserPerEmailTF;
    const s_creatingNewUserPowerTF = this.state.s_creatingNewUserPowerTF;
    const s_welcomeEmailSentSuccessMessageTF = this.state.s_welcomeEmailSentSuccessMessageTF;
    const s_reassignUserCustomCreationsFloatingBoxIsOpenTF = this.state.s_reassignUserCustomCreationsFloatingBoxIsOpenTF;

    const p_userPerEmailObj = this.props.p_userPerEmailObj;

    const o_mediaQueryFlag = this.props.CaptureExecMobx.o_mediaQueryFlag;
    const c_productStylingObj = this.props.CaptureExecMobx.c_productStylingObj;
    const c_usersCanAddNewUserTF = this.props.AdminMobx.c_usersCanAddNewUserTF;
    const o_userPerEmailID = this.props.UserMobx.o_userPerEmailID;

    const userLockedOutTF = (p_userPerEmailObj.lockedout === 1);
    const userWelcomeEmailNotYetSentTF = (p_userPerEmailObj.welcome_email_sent_01 === 0);
    const upeNameAndSwitchesWideTrueStackedFalse = (o_mediaQueryFlag >= 5);

    const editingUserPerEmailFieldWidthEm = 16;

    var userPerEmailVerticalDotsMenuItemsArrayOfObjs = [];
    userPerEmailVerticalDotsMenuItemsArrayOfObjs.push({
      displayName: "Reset Password and Resend Welcome Email",
      confirmType: "confirm",
      confirmTitle: "Reset Password and Resend Welcome Email",
      confirmButton1Name: "Reset Password and Resend Welcome Email",
      confirmButton1Type: "green",
      confirmMessage: "This action will reset the password for '" + p_userPerEmailObj.upeFirstNameLastName + "' to the company default and resend them the " + c_productStylingObj.productName + " Welcome Email with instructions and a link to log in.",
      functionOnClickConfirmButton: this.onconfirm_resend_user_per_email_welcome_email
    });
    if(c_productStylingObj.setupUsersReassignUserCustomCreationsTF) {
      userPerEmailVerticalDotsMenuItemsArrayOfObjs.push({
        displayName: "Reassign User Custom Creations",
        functionOnClickMenuItem: this.onclick_open_reassign_user_custom_creations_floating_box
      });
    }
    if(p_userPerEmailObj.id !== o_userPerEmailID) { //can't delete yourself
      var deleteUserPerEmailMessage = "Are you sure you want to delete User '" + p_userPerEmailObj.upeFirstNameLastName + "'?";
      deleteUserPerEmailMessage += "\n\nThis will permanently erase any references of ownership and changelogs connected with their name. It is recommended to preserve history by instead Deactivating this User with the 'Deactivate' switch in this User row. This will free up the licenses while retaining their name referenced across the system.";
      userPerEmailVerticalDotsMenuItemsArrayOfObjs.push({
        displayName: "Delete User",
        confirmType: "confirmDelete",
        confirmTitle: "Delete User",
        confirmButton1Name: "Delete User",
        confirmMessage: deleteUserPerEmailMessage,
        functionOnClickConfirmButton: this.ondelete_user_per_email_and_all_powers
      });
    }

    const upeNameAndEmailComponent = (
      <div
        className="flex00a displayFlexColumn tbPad lrMedPad hoverLighterBlueGradient cursorPointer"
        style={{backgroundColor:((p_userPerEmailObj.upeDeactivatedTF) ? ("#e4e4e4") : ("#f5ebd0")), border:"solid 1px #cba", borderRadius:"0.5em"}}
        title={"Click to edit the Name, or Email used to log in, for '" + p_userPerEmailObj.upeFirstNameLastName + "'"}
        onClick={this.onclick_upe_name_email_edit}>
        <div className="flex00a displayFlexRow">
          <div className="flex11a displayFlexRowVc" style={{flexBasis:"100em"}}>
            <LibraryReact.NowrapEllipsis p_fontClass="fontBold fontTextLight">
              {p_userPerEmailObj.upeFirstNameLastName}
            </LibraryReact.NowrapEllipsis>
          </div>
          <div className="flex11a displayFlexRowVc" style={{flexBasis:"100em"}}>
            <LibraryReact.NowrapEllipsis p_fontClass="">
              {p_userPerEmailObj.email}
            </LibraryReact.NowrapEllipsis>
          </div>
        </div>
        {(p_userPerEmailObj.upeTitleRoleIsFilledOutTF || p_userPerEmailObj.upeOutsideCompanyNameIsFilledOutTF) &&
          <div className="smallTopMargin" />
        }
        {(p_userPerEmailObj.upeTitleRoleIsFilledOutTF) &&
          <LibraryReact.RowVcTextNowrapWithLabelNowrap p_class="bigLeftMargin" p_label="Title/Role:" p_labelWidthEm={9} p_labelFontClass="font09 fontBold fontItalic fontTextLightest" p_fontClass="fontItalic fontTextLight">
            {p_userPerEmailObj.title_role}
          </LibraryReact.RowVcTextNowrapWithLabelNowrap>
        }
        {(p_userPerEmailObj.upeOutsideCompanyNameIsFilledOutTF) &&
          <LibraryReact.RowVcTextNowrapWithLabelNowrap p_class="bigLeftMargin" p_label="Outside Company:" p_labelWidthEm={9} p_labelFontClass="font09 fontBold fontItalic fontTextLightest" p_fontClass="fontItalic fontTextLight">
            {p_userPerEmailObj.outside_company_name}
          </LibraryReact.RowVcTextNowrapWithLabelNowrap>
        }
      </div>
    );
    
    var lockedOutSwitchTitle = "";
    if(userLockedOutTF) {
      lockedOutSwitchTitle += p_userPerEmailObj.upeFirstNameLastName + " is currently locked out of the system and cannot log in.\n\n";
    }
    lockedOutSwitchTitle += "If this switch is on, the user entered the wrong password 5 times in a row and has locked their account. Turn this switch off to reset that and allow them to log in again.";

    var deactivatedSwitchTitle = p_userPerEmailObj.upeFirstNameLastName + " ";
    if(p_userPerEmailObj.upeDeactivatedTF) {
      deactivatedSwitchTitle += "has been deactivated from your CaptureExec system and cannot log in, however all of their data and previous changes remain in the system visible to other Users. They currently do not take up any licenses in the system.\n\nYou can reactivate " + p_userPerEmailObj.upeFirstNameLastName + " by turning off this deactivation switch, as long as there are enough licenses remaining to allow this."
    }
    else {
      deactivatedSwitchTitle += "is an active User of CaptureExec, taking up " + p_userPerEmailObj.upeNumLicensesUsed + " " + JSFUNC.plural(p_userPerEmailObj.upeNumLicensesUsed, "license", "licenses") + ".\n\nThey can be deactivated by turning on this switch, which prevents them from logging in and frees up their used licenses, while retaining their data and changes to the system. (deleteing a User, in contrast, would erase their name attached to changes they made in the system)";
    }

    var addNewUserPowerButtonTitle = "Add another User Power for '" + p_userPerEmailObj.upeFirstNameLastName + "'";
    addNewUserPowerButtonTitle += "\n(A user can have multiple power levels to choose from when logging in, for example a single user could log in as an admin, a divexec for Division A, a divexec for Division B, and a captureexec. Each multiple login counts towards the number of licenses used.)";

    const switchesAndAddUserPowerButtonComponent = (
      <>
        <UserPerEmailRowSwitchWithLabel
          p_isOnTF={userLockedOutTF}
          p_onColor="bd2326"
          p_switchToOnMessage={undefined}
          p_switchToOnButtonName={undefined}
          p_label="Locked Out"
          p_title={lockedOutSwitchTitle}
          f_onClick={this.onclick_lockedout_switch}
        />
        {(c_productStylingObj.setupUsersDeactivedSwitchTF) &&
          <UserPerEmailRowSwitchWithLabel
          p_isOnTF={p_userPerEmailObj.upeDeactivatedTF}
            p_onColor="222"
            p_switchToOnMessage={"You are about to deactivate User '" + p_userPerEmailObj.upeFirstNameLastName + "' from the system. This action will move their name to the bottom of this page under the 'Deactivated Users' section. This will make any licenses they were previously using available to give to other users.\n\nAll Captures and data throughout the system that this User interacted with in the past will continue to display their name for historical preservation (which would be erased if the User was deleted).\n\nIf you choose, you can reassign their Captures to other Capture Managers by clicking the blue capture count button on the right side of this User row."}
            p_switchToOnButtonName="Deactivate User"
            p_label="Deactivated"
            p_title={deactivatedSwitchTitle}
            f_onClick={this.onclick_deactivated_switch}
          />
        }
        {(c_productStylingObj.setupUsersCreatePublicSwitchTF) &&
          <UserPerEmailRowSwitchWithLabel
            p_isOnTF={(p_userPerEmailObj.can_create_public_01 === 1)}
            p_onColor="769"
            p_switchToOnMessage={undefined}
            p_switchToOnButtonName={undefined}
            p_label="Create Public"
            p_title="If this switch is off, the user cannot create Public buttons or graphs"
            f_onClick={this.onclick_create_public_switch}
          />
        }
        {(c_productStylingObj.setupUsersCanAddUserPowerTF) &&
          <div className="flex00a displayFlexColumnHcVc tbPad" style={{flexBasis:"11.5em"}}>
            {(c_usersCanAddNewUserTF && !p_userPerEmailObj.upeDeactivatedTF) &&
              <CEGeneralReact.CEButton
                p_type="add"
                p_text="Add User Power"
                p_title={addNewUserPowerButtonTitle}
                f_onClick={this.onclick_add_user_power}
              />
            }
          </div>
        }
      </>
    );

    var sendWelcomEmailWithDismissComponent = null;
    if(userWelcomeEmailNotYetSentTF && !p_userPerEmailObj.upeDeactivatedTF) {
      sendWelcomEmailWithDismissComponent = (
        <>
          <div className="flex00a displayFlexRowVc smallTopMargin">
            <div className="flex00a">
              <CEGeneralReact.CEButton
                p_type="green"
                p_text="Send Welcome Email"
                p_title={"Click to send a one time welcome email to '" + p_userPerEmailObj.email + "' giving them a link to the " + c_productStylingObj.productName + " along with their company code, email, and password to use to get started"}
                f_onClick={this.onclick_send_user_welcome_email}
              />
            </div>
            <div className="flex00a lrMedPad">
              <CEGeneralReact.CEButton
                p_type="hyperlinkUnderline"
                p_text="dismiss"
                p_title="Click 'dismiss' to skip sending a welcome email to this new user"
                f_onClick={this.onclick_dismiss_send_user_welcome_email}
              />
            </div>
            <div className="flex11a" />
          </div>
          {(s_welcomeEmailSentSuccessMessageTF) &&
            <div className="flex00a microTopMargin">
              <font className="fontItalic fontDarkGreen">
                {c_productStylingObj.productName + " Welcome Email has been sent to " + p_userPerEmailObj.email}
              </font>
            </div>
          }
        </>
      );
    }

    return(
      <>
        <div className="displayFlexRow tbMicroMargin lrMedMargin bgUserTan" style={{border:"solid 1px #cba", borderRadius:"0.5em"}}>
          {(upeNameAndSwitchesWideTrueStackedFalse) ? (
            <>
              <div className="flex11a displayFlexColumnVc tbMicroPad lrMedPad" style={{flexBasis:"100em"}}>
                {upeNameAndEmailComponent}
                {sendWelcomEmailWithDismissComponent}
              </div>
              {switchesAndAddUserPowerButtonComponent}
            </>
          ) : (
            <div className="flex11a displayFlexColumn tbPad lrMedPad" style={{flexBasis:"100em"}}>
              {upeNameAndEmailComponent}
              <div className="lrPad smallTopMargin">
                <div className="flex00a displayFlexRowVc flexWrap">
                  {switchesAndAddUserPowerButtonComponent}
                </div>
                {sendWelcomEmailWithDismissComponent}
              </div>
            </div>
          )}
          <div className="flex11a displayFlexColumnVc" style={{flexBasis:((upeNameAndSwitchesWideTrueStackedFalse) ? ("160") : ("180")) + "em"}}>
            {p_userPerEmailObj.upeMultiLoginCombinedUsersArrayOfObjs.map((m_upeCombinedUserObj) =>
              <UserPowerRow
                key={m_upeCombinedUserObj.user_id}
                p_userPerEmailObj={p_userPerEmailObj}
                p_upeCombinedUserObj={m_upeCombinedUserObj}
              />
            )}
          </div>
          <div className="flex00a displayFlexColumnHcVc" style={{flexBasis:"2em"}}>
            <CEGeneralReact.VerticalDotsMenu
              p_menuItemsArrayOfObjs={userPerEmailVerticalDotsMenuItemsArrayOfObjs}
            />
          </div>
        </div>
        {(s_editingUserPerEmailTF) &&
          <CEGeneralReact.FloatingBoxWithSaveCancel
            p_trblFlag="addEditDeleteTableEditItem"
            p_title={"Editing User " + p_userPerEmailObj.upeFirstNameLastName}
            f_onClickSave={this.onclick_close_upe_name_email_edit}>
            <div className="flex11a yScroll medFullPad">
              <CEGeneralReact.CaptureExecFieldEditSaveCancel
                p_ceEditItemString={"adminUserPerEmailEdit_uID" + p_userPerEmailObj.user_id + "first_name"}
                p_fieldDisplayName="User First Name"
                p_fieldTypeObj={this.props.DatabaseMobx.c_genericTextFieldTypeObj}
                p_valueRaw={p_userPerEmailObj.first_name}
                p_valueIsEditableTFU={true}
                p_containerClass="tbMargin"
                p_fieldClass="fontBlue"
                p_fieldWidth={editingUserPerEmailFieldWidthEm + "em"}
                f_onSaveChanged={this.onsave_upe_first_name}
              />
              <CEGeneralReact.CaptureExecFieldEditSaveCancel
                p_ceEditItemString={"adminUserPerEmailEdit_uID" + p_userPerEmailObj.user_id + "last_name"}
                p_fieldDisplayName="User Last Name"
                p_fieldTypeObj={this.props.DatabaseMobx.c_genericTextFieldTypeObj}
                p_valueRaw={p_userPerEmailObj.last_name}
                p_valueIsEditableTFU={true}
                p_containerClass="tbMargin"
                p_fieldClass="fontBlue"
                p_fieldWidth={editingUserPerEmailFieldWidthEm + "em"}
                f_onSaveChanged={this.onsave_upe_last_name}
              />
              <CEGeneralReact.CaptureExecFieldEditSaveCancel
                p_ceEditItemString={"adminUserPerEmailEdit_uID" + p_userPerEmailObj.user_id + "email"}
                p_fieldDisplayName="Email"
                p_fieldTypeObj={this.props.DatabaseMobx.c_genericTextFieldTypeObj}
                p_valueRaw={p_userPerEmailObj.email}
                p_valueIsEditableTFU={true}
                p_containerClass="tbMargin"
                p_fieldClass="fontBlue"
                p_fieldWidth={editingUserPerEmailFieldWidthEm + "em"}
                f_onSaveChanged={this.onsave_upe_email}
              />
              <CEGeneralReact.CaptureExecFieldEditSaveCancel
                p_ceEditItemString={"adminUserPerEmailEdit_uID" + p_userPerEmailObj.user_id + "titlerole"}
                p_fieldDisplayName="Title/Role (optional)"
                p_fieldTypeObj={this.props.DatabaseMobx.c_genericTextFieldTypeObj}
                p_valueRaw={p_userPerEmailObj.title_role}
                p_valueIsEditableTFU={true}
                p_containerClass="tbMargin"
                p_fieldClass="fontBlue"
                p_fieldWidth={editingUserPerEmailFieldWidthEm + "em"}
                f_onSaveChanged={this.onsave_upe_title_role}
              />
              <CEGeneralReact.CaptureExecFieldEditSaveCancel
                p_ceEditItemString={"adminUserPerEmailEdit_uID" + p_userPerEmailObj.user_id + "outside_company_name"}
                p_fieldDisplayName="Outside Company Name (optional)"
                p_fieldTypeObj={this.props.DatabaseMobx.c_genericTextFieldTypeObj}
                p_valueRaw={p_userPerEmailObj.outside_company_name}
                p_valueIsEditableTFU={true}
                p_containerClass="tbMargin"
                p_fieldClass="fontBlue"
                p_fieldWidth={editingUserPerEmailFieldWidthEm + "em"}
                f_onSaveChanged={this.onsave_upe_outside_company_name}
              />
            </div>
          </CEGeneralReact.FloatingBoxWithSaveCancel>
        }
        {(s_creatingNewUserPowerTF) &&
          <UsersCreateNewUserPower
            p_includeUpeTF={false}
            p_userPerEmailObj={p_userPerEmailObj}
            f_onClose={this.onclick_close_new_user_power}
          />
        }
        {(s_reassignUserCustomCreationsFloatingBoxIsOpenTF) &&
          <UsersReassignUserCustomCreationsFloatingBox
            p_userPerEmailObj={p_userPerEmailObj}
            f_onClose={this.onclick_close_reassign_user_custom_creations_floating_box}
          />
        }
      </>
    );
  }
}));


function UserPerEmailRowSwitchWithLabel(props) { //props: p_isOnTF, p_onColor, p_switchToOnMessage, p_switchToOnButtonName, p_label, p_title, f_onClick
  const p_isOnTF = props.p_isOnTF;
  const p_onColor = props.p_onColor;
  const p_switchToOnMessage = props.p_switchToOnMessage;
  const p_switchToOnButtonName = props.p_switchToOnButtonName;
  const p_label = props.p_label;
  const p_title = props.p_title;
  const f_onClick = props.f_onClick;

  const switchSizeEm = 2.8;
  const switchOffColor = "bbb";

  return(
    <div
      className="flex00a displayFlexColumnHcVc"
      style={{flexBasis:"5.5em"}}
      title={p_title}>
      <div className="flex00a displayFlexRowVc nowrap">
        <font className="font09 fontItalic fontTextLighter">
          {p_label}
        </font>
      </div>
      {((p_switchToOnMessage !== undefined) && (p_switchToOnButtonName !== undefined)) ? (
        <CEGeneralReact.SwitchWithTextAndConfirmBox
          p_isOnTF={p_isOnTF}
          p_sizeEm={switchSizeEm}
          p_onColor={p_onColor}
          p_offColor={switchOffColor}
          p_switchToOnMessage={p_switchToOnMessage}
          p_switchToOnButtonName={p_switchToOnButtonName}
          f_onSwitch={f_onClick}
        />
      ) : (
        <LibraryReact.Switch
          p_isOnTF={p_isOnTF}
          p_sizeEm={switchSizeEm}
          p_onColor={p_onColor}
          p_offColor={switchOffColor}
          f_onClick={f_onClick}
        />
      )}
    </div>
  );
}


const UsersCreateNewUserPower = inject("CaptureExecMobx", "AdminMobx", "DatabaseMobx")(observer(
class UsersCreateNewUserPower extends Component { //props: p_includeUpeTF, p_userPerEmailObj, f_onClose
  constructor(props) {
    super(props);

    const c_productStylingObj = this.props.CaptureExecMobx.c_productStylingObj;
    const c_topDivision00ID = this.props.DatabaseMobx.c_topDivision00ID;

    //initialize user's selected divisionID
    var initialDivisionID = -1; //can make more than 1 division, initialize with no division selected for the new user
    if(!c_productStylingObj.setupCompanyCanCreateDivisionsTF) { //company forced to have exactly 1 division in admin, initialize to that divisionID (usually ID:1)
      initialDivisionID = c_topDivision00ID;
    }

    this.state = {
      s_firstName: "",
      s_lastName: "",
      s_email: "",
      s_titleRole: "",
      s_outsideCompanyName: "",
      s_powerName: "",
      s_divisionID: initialDivisionID,
      s_createNewCaptureDefaultDivisionIDOrM1: -1,
      s_altName: "",
      s_showErrorsTF: false,
      s_isWorkingTF: false
    };
  }

  onchange_first_name = (i_newValue) => { this.setState({s_firstName:i_newValue}); }
  onchange_last_name = (i_newValue) => { this.setState({s_lastName:i_newValue}); }
  onchange_email = (i_newValue) => { this.setState({s_email:i_newValue}); }
  onchange_title_role = (i_newValue) => { this.setState({s_titleRole:i_newValue}); }
  onchange_outside_company_name = (i_newValue) => { this.setState({s_outsideCompanyName:i_newValue}); }
  onchange_power_name = (i_newValue) => { this.setState({s_powerName:i_newValue}); }
  onchange_division_id = (i_newValue) => { this.setState({s_divisionID:i_newValue}); }
  onchange_create_new_capture_default_division_id = (i_newValue) => { this.setState({s_createNewCaptureDefaultDivisionIDOrM1:i_newValue}); }
  onchange_alt_name = (i_newValue) => { this.setState({s_altName:i_newValue}); }

  onclick_create_new_user = () => {
    const s_firstName = this.state.s_firstName;
    const s_lastName = this.state.s_lastName;
    const s_email = this.state.s_email;
    const s_titleRole = this.state.s_titleRole;
    const s_outsideCompanyName = this.state.s_outsideCompanyName;

    const p_includeUpeTF = this.props.p_includeUpeTF;
    const p_userPerEmailObj = this.props.p_userPerEmailObj;

    if(p_includeUpeTF) {
      if(this.first_name_error_tf() || this.last_name_error_tf() || this.email_unique_error_tf() || this.email_error_tf() || this.power_error_tf() || this.division_error_tf()) {
        this.setState({s_showErrorsTF:true});
      }
      else {
        this.setState({s_isWorkingTF:true});

        const c_companyNewUserDefaultPassword = this.props.DatabaseMobx.c_companyNewUserDefaultPassword;

        const todayDateYmd = JSFUNC.now_dateYmd();
        const todayMinus2YearsDateYmd = JSFUNC.date_add_months(todayDateYmd, -24);
        const todayPlus3YearsDateYmd = JSFUNC.date_add_months(todayDateYmd, 36);

        const jsDescription = JSFUNC.js_description_from_action("AdminReact - UsersCreateNewUserPower", "onclick_create_new_user", [], []);
        const C_CallPhpTblUID = new JSPHP.ClassCallPhpTblUID(jsDescription);

        var fieldNamesArray = [];
        var valuesArray = [];
        var idsbArray = [];
        fieldNamesArray.push("email");                                                valuesArray.push(s_email);                        idsbArray.push("s");
        fieldNamesArray.push("first_name");                                           valuesArray.push(s_firstName);                    idsbArray.push("s");
        fieldNamesArray.push("last_name");                                            valuesArray.push(s_lastName);                     idsbArray.push("s");
        fieldNamesArray.push("disabled");                                             valuesArray.push(0);                              idsbArray.push("i");
        fieldNamesArray.push("lockedout");                                            valuesArray.push(0);                              idsbArray.push("i");
        fieldNamesArray.push("no_bit_mass_emails_01");                                valuesArray.push(0);                              idsbArray.push("i");
        fieldNamesArray.push("title_role");                                           valuesArray.push(s_titleRole);                    idsbArray.push("s");
        fieldNamesArray.push("outside_company_name");                                 valuesArray.push(s_outsideCompanyName);           idsbArray.push("s");
        fieldNamesArray.push("can_create_public_01");                                 valuesArray.push(1);                              idsbArray.push("i");
        fieldNamesArray.push("code_update_01");                                       valuesArray.push(0);                              idsbArray.push("i");
        fieldNamesArray.push("font_size_px");                                         valuesArray.push(12);                             idsbArray.push("i");
        fieldNamesArray.push("left_nav_0collapsed_1expanded");                        valuesArray.push(1);                              idsbArray.push("i");
        fieldNamesArray.push("right_panel_width_em");                                 valuesArray.push(28);                             idsbArray.push("i");
        fieldNamesArray.push("notification_email_01");                                valuesArray.push(1);                              idsbArray.push("i");
        fieldNamesArray.push("archived_captures_preference");                         valuesArray.push("noLoadArchivedWithPrompt");     idsbArray.push("s");
        fieldNamesArray.push("capture_card_min_height_em");                           valuesArray.push(20);                             idsbArray.push("i");
        fieldNamesArray.push("capture_card_max_height_em");                           valuesArray.push(35);                             idsbArray.push("i");
        fieldNamesArray.push("dates_card_three_cols_0_single_col_1");                 valuesArray.push(0);                              idsbArray.push("i");
        fieldNamesArray.push("propmgmt_card_calendar_start_date");                    valuesArray.push(JSFUNC.blank_date());            idsbArray.push("s");
        fieldNamesArray.push("propmgmt_card_calendar_end_date");                      valuesArray.push(JSFUNC.blank_date());            idsbArray.push("s");
        fieldNamesArray.push("propmgmt_card_calendar_week_height_em");                valuesArray.push(12);                             idsbArray.push("i");
        fieldNamesArray.push("propmgmt_card_calendar_week_start_day_0to6");           valuesArray.push(0);                              idsbArray.push("i");
        fieldNamesArray.push("recently_visited_capture_ids_comma");                   valuesArray.push("");                             idsbArray.push("s");
        fieldNamesArray.push("favorited_capture_ids_comma");                          valuesArray.push("");                             idsbArray.push("s");
        fieldNamesArray.push("cst_row_height_em");                                    valuesArray.push(5);                              idsbArray.push("d");
        fieldNamesArray.push("cst_edit_cells_mode_01");                               valuesArray.push(0);                              idsbArray.push("i");
        fieldNamesArray.push("stage_view_box_size");                                  valuesArray.push(2);                              idsbArray.push("i");
        fieldNamesArray.push("stage_view_selected_capture_type_ids_comma");           valuesArray.push("");                             idsbArray.push("s");
        fieldNamesArray.push("stage_view_minimized_stage_ids_comma");                 valuesArray.push("");                             idsbArray.push("s");
        fieldNamesArray.push("priority_view_minimized_priority_ids_comma");           valuesArray.push("");                             idsbArray.push("s");
        fieldNamesArray.push("capture_chart_start_date");                             valuesArray.push(todayMinus2YearsDateYmd);        idsbArray.push("s");
        fieldNamesArray.push("capture_chart_end_date");                               valuesArray.push(todayPlus3YearsDateYmd);         idsbArray.push("s");
        fieldNamesArray.push("capture_chart_progress_size");                          valuesArray.push(10);                             idsbArray.push("i");
        fieldNamesArray.push("capture_chart_gantt_size");                             valuesArray.push(2);                              idsbArray.push("i");
        fieldNamesArray.push("notepad_selected_tab_db_name");                         valuesArray.push("");                             idsbArray.push("s");
        fieldNamesArray.push("notepad_note_stamps_view_flag");                        valuesArray.push("");                             idsbArray.push("s");
        fieldNamesArray.push("gcss_search_results_compact0_large1");                  valuesArray.push(0);                              idsbArray.push("i");
        fieldNamesArray.push("gcss_search_results_sort_gcss_field_db_name");          valuesArray.push("");                             idsbArray.push("s");
        fieldNamesArray.push("gcss_search_results_sort_desc0_asc1");                  valuesArray.push(1);                              idsbArray.push("i");
        fieldNamesArray.push("gcss_ids_marked_for_import_comma");                     valuesArray.push("");                             idsbArray.push("s");
        fieldNamesArray.push("gcss_govwin_ids_marked_for_import_comma");              valuesArray.push("");                             idsbArray.push("s");
        fieldNamesArray.push("gcss_fedcomp_ids_marked_for_import_comma");             valuesArray.push("");                             idsbArray.push("s");
        fieldNamesArray.push("gcss_sam0_govwin1");                                    valuesArray.push(0);                              idsbArray.push("i");
        fieldNamesArray.push("gcss_cexai_filters_and0_or1");                          valuesArray.push(0);                              idsbArray.push("i");
        fieldNamesArray.push("gcss_cexai_selected_filters_auto_search_ids_comma");    valuesArray.push("");                             idsbArray.push("s");
        fieldNamesArray.push("gcss_cexai_positive_gcss_ids_comma");                   valuesArray.push("");                             idsbArray.push("s");
        fieldNamesArray.push("gcss_cexai_negative_gcss_ids_comma");                   valuesArray.push("");                             idsbArray.push("s");
        fieldNamesArray.push("gcss_import_capture_manager_ids_colon_percents_comma"); valuesArray.push("");                             idsbArray.push("s");
        fieldNamesArray.push("gcss_import_division_owner_ids_colon_percents_comma");  valuesArray.push("");                             idsbArray.push("s");
        fieldNamesArray.push("gcss_import_capture_type_id");                          valuesArray.push(0);                              idsbArray.push("i");
        fieldNamesArray.push("gcss_import_stage_id");                                 valuesArray.push(0);                              idsbArray.push("i");
        fieldNamesArray.push("sync_user_ce_actions_in_integration_system_01");        valuesArray.push(1);                              idsbArray.push("i");
        fieldNamesArray.push("password");                                             valuesArray.push(c_companyNewUserDefaultPassword);idsbArray.push("s");
        fieldNamesArray.push("password_last_changed_date");                           valuesArray.push(JSFUNC.now_dateYmd());           idsbArray.push("s");
        fieldNamesArray.push("welcome_email_sent_01");                                valuesArray.push(0);                              idsbArray.push("i");
        fieldNamesArray.push("last_refresh_datetime_utc");                            valuesArray.push(JSFUNC.blank_datetime());        idsbArray.push("s");
        fieldNamesArray.push("refresh_data_comma");                                   valuesArray.push("");                             idsbArray.push("s");
        fieldNamesArray.push("currently_open_capture_id");                            valuesArray.push(-1);                             idsbArray.push("i");

        C_CallPhpTblUID.add_insert("tbl_a_users_per_email", fieldNamesArray, valuesArray, idsbArray);

        const functionOnSuccess = (i_parseResponse) => {
          const newlyCreatedUserPerEmailID = i_parseResponse.outputObj.i0;
          const newlyCreatedUserFirstNameLastName = JSFUNC.full_name_from_first_name_last_name(s_firstName, s_lastName);
          this.insert_user_power_record(newlyCreatedUserPerEmailID, newlyCreatedUserFirstNameLastName);
        }
        C_CallPhpTblUID.add_function("onSuccess", functionOnSuccess);

        C_CallPhpTblUID.execute();
      }
    }
    else {
      if(this.power_error_tf() || this.division_error_tf()) {
        this.setState({s_showErrorsTF:true});
      }
      else {
        this.setState({s_isWorkingTF:true});
        this.insert_user_power_record(p_userPerEmailObj.id, p_userPerEmailObj.upeFirstNameLastName);
      }
    }
  }

  insert_user_power_record = (i_userPerEmailID, i_userFirstNameLastName) => {
    const s_powerName = this.state.s_powerName;
    const s_divisionID = this.state.s_divisionID;
    const s_createNewCaptureDefaultDivisionIDOrM1 = this.state.s_createNewCaptureDefaultDivisionIDOrM1;
    const s_altName = this.state.s_altName;

    const c_allDivisionIDsComma = this.props.DatabaseMobx.c_allDivisionIDsComma;
    const c_closedWonStageIDsArray = this.props.DatabaseMobx.c_closedWonStageIDsArray;

    const initialDivexecMoneyFieldID = this.props.DatabaseMobx.c_fieldMapOfContractRevenueValue.get("id");

    const closedWonStageIDsComma = JSFUNC.convert_array_to_comma_list(c_closedWonStageIDsArray);

    const jsDescription = JSFUNC.js_description_from_action("AdminReact - UsersCreateNewUserPower", "insert_user_power_record", ["i_userPerEmailID", "i_userFirstNameLastName"], [i_userPerEmailID, i_userFirstNameLastName]);
    const C_CallPhpTblUID = new JSPHP.ClassCallPhpTblUID(jsDescription);

    var fieldNamesArray = [];
    var valuesArray = [];
    var idsbArray = [];
    fieldNamesArray.push("user_per_email_id");                                                valuesArray.push(i_userPerEmailID);           idsbArray.push("i");
    fieldNamesArray.push("division_id");                                                      valuesArray.push(s_divisionID);               idsbArray.push("i");
    fieldNamesArray.push("create_new_capture_default_division_id_or_m1");                     valuesArray.push(s_createNewCaptureDefaultDivisionIDOrM1); idsbArray.push("i");
    fieldNamesArray.push("power_name");                                                       valuesArray.push(s_powerName);                idsbArray.push("s");
    fieldNamesArray.push("bit_non_billable_user_01");                                         valuesArray.push(0);                          idsbArray.push("i");
    fieldNamesArray.push("alt_full_name");                                                    valuesArray.push(s_altName);                  idsbArray.push("s");
    fieldNamesArray.push("num_logins");                                                       valuesArray.push(0);                          idsbArray.push("i");
    fieldNamesArray.push("last_login_datetime_utc");                                          valuesArray.push(JSFUNC.blank_datetime());    idsbArray.push("s");
    fieldNamesArray.push("last_login_timezone_string");                                       valuesArray.push("");                         idsbArray.push("s");
    fieldNamesArray.push("last_login_browser_type");                                          valuesArray.push("");                         idsbArray.push("s");
    fieldNamesArray.push("last_login_mediaqueryflag");                                        valuesArray.push(-1);                         idsbArray.push("i");
    fieldNamesArray.push("start_tab_name");                                                   valuesArray.push("");                         idsbArray.push("s");
    fieldNamesArray.push("quick_access_master_preset_ids_comma");                             valuesArray.push("-101,-102,-103");           idsbArray.push("s");
    fieldNamesArray.push("quick_access_master_preset_id_selected");                           valuesArray.push(-101);                       idsbArray.push("i");
    fieldNamesArray.push("gantt_date_preset_id_selected");                                    valuesArray.push(-1);                         idsbArray.push("i");
    fieldNamesArray.push("divexec_filter_division_ids_comma");                                valuesArray.push(c_allDivisionIDsComma);      idsbArray.push("s");
    fieldNamesArray.push("divexec_goals_latest_year");                                        valuesArray.push(0);                          idsbArray.push("i");
    fieldNamesArray.push("divexec_goals_num_years");                                          valuesArray.push(10);                         idsbArray.push("i");
    fieldNamesArray.push("divexec_graphs_start_date");                                        valuesArray.push("8004-01-04");               idsbArray.push("s");
    fieldNamesArray.push("divexec_graphs_end_date");                                          valuesArray.push("9001-01-04");               idsbArray.push("s");
    fieldNamesArray.push("divexec_graphs_selected_stage_ids_comma_or_all");                   valuesArray.push("all");                      idsbArray.push("s");
    fieldNamesArray.push("divexec_performance_tree_selected_tab_du0_cp1");                    valuesArray.push(0);                          idsbArray.push("i");
    fieldNamesArray.push("divexec_performance_custom_performance_selected_capture_field_id"); valuesArray.push(-1);                         idsbArray.push("i");
    fieldNamesArray.push("divexec_performance_cp_scf_selected_option_ids_comma_or_all");      valuesArray.push("all");                      idsbArray.push("s");
    fieldNamesArray.push("divexec_performance_money_field_id");                               valuesArray.push(initialDivexecMoneyFieldID); idsbArray.push("i");
    fieldNamesArray.push("divexec_performance_view_y0q1m2");                                  valuesArray.push(0);                          idsbArray.push("i");
    fieldNamesArray.push("divexec_performance_view_dec0inc1");                                valuesArray.push(0);                          idsbArray.push("i");
    fieldNamesArray.push("divexec_finproj_custom0_manual1");                                  valuesArray.push(1);                          idsbArray.push("i");
    fieldNamesArray.push("divexec_finproj_filter_preset_id");                                 valuesArray.push(-1);                         idsbArray.push("i");
    fieldNamesArray.push("divexec_finproj_division_ids_comma");                               valuesArray.push(c_allDivisionIDsComma);      idsbArray.push("s");
    fieldNamesArray.push("divexec_finproj_stage_ids_comma");                                  valuesArray.push(closedWonStageIDsComma);     idsbArray.push("s");
    fieldNamesArray.push("divexec_finproj_money_field_id");                                   valuesArray.push(initialDivexecMoneyFieldID); idsbArray.push("i");
    fieldNamesArray.push("divexec_finproj_goals_division_id");                                valuesArray.push(s_divisionID);               idsbArray.push("i");
    fieldNamesArray.push("divexec_finproj_view_start_date");                                  valuesArray.push(JSFUNC.blank_date());        idsbArray.push("s");
    fieldNamesArray.push("divexec_finproj_view_end_date");                                    valuesArray.push(JSFUNC.blank_date());        idsbArray.push("s");
    fieldNamesArray.push("divexec_finproj_view_y0q1m2");                                      valuesArray.push(0);                          idsbArray.push("i");
    fieldNamesArray.push("divexec_finproj_view_logy_01");                                     valuesArray.push(0);                          idsbArray.push("i");
    fieldNamesArray.push("divexec_finproj_view_stackedarea0_vbars1");                         valuesArray.push(0);                          idsbArray.push("i");
    fieldNamesArray.push("divexec_finproj_stacked_area_active_stage_ids_comma");              valuesArray.push("");                         idsbArray.push("i");
    fieldNamesArray.push("divexec_finproj_captures_list_selected_cst_column_preset_id");      valuesArray.push(-1);                         idsbArray.push("i");
    fieldNamesArray.push("divexec_hotbits_fixed0_calendar1");                                 valuesArray.push(0);                          idsbArray.push("i");
    fieldNamesArray.push("divexec_critthresh_money_field_id");                                valuesArray.push(initialDivexecMoneyFieldID); idsbArray.push("i");

    C_CallPhpTblUID.add_insert("tbl_a_users", fieldNamesArray, valuesArray, idsbArray);

    const functionOnSuccess = (i_parseResponse) => {
      const newlyCreatedUserID = i_parseResponse.outputObj.i0;
      
      //insert an admin changelog entry
      const C_CallPhpTblUIDAfterCreateNewUserPower = new JSPHP.ClassCallPhpTblUID(jsDescription);
      const newlyCreatedUserPowerDataObj = DatabaseMobx.power_data_obj_from_power_name(s_powerName);
      const adminChangelogValue = i_userFirstNameLastName + " (" + newlyCreatedUserPowerDataObj.displayName + ")";
      C_CallPhpTblUIDAfterCreateNewUserPower.add_changelog_admin(CEC.adminLogObj.actionCodesObj.CREATE_NEW_USER, "", adminChangelogValue);
      C_CallPhpTblUIDAfterCreateNewUserPower.execute();
    }
    C_CallPhpTblUID.add_function("onSuccess", functionOnSuccess);

    const functionOnFinish = () => {
      this.setState({s_isWorkingTF:false});
      this.onclick_close_create_new_user();
    }
    C_CallPhpTblUID.add_function("onFinish", functionOnFinish);

    C_CallPhpTblUID.execute();
  }

  onclick_close_create_new_user = () => {
    if(JSFUNC.is_function(this.props.f_onClose)) {
      this.props.f_onClose();
    }
  }

  first_name_error_tf = () => { return(this.state.s_firstName === ""); }
  last_name_error_tf = () => { return(this.state.s_lastName === ""); }
  email_unique_error_tf = () => { return(JSFUNC.in_array(this.state.s_email, this.props.AdminMobx.c_usersAllUserEmailsArray)); }
  email_error_tf = () => { return(JSFUNC.valid_email_address_undefined_or_invalid_email_error_message_string(this.state.s_email) !== undefined); }
  power_error_tf = () => { return(!JSFUNC.in_array(this.state.s_powerName, this.props.DatabaseMobx.c_allUserPowersDbNamesArray)); }
  division_error_tf = () => { return(this.state.s_divisionID <= 0); }

  render() {
    const s_firstName = this.state.s_firstName;
    const s_lastName = this.state.s_lastName;
    const s_email = this.state.s_email;
    const s_titleRole = this.state.s_titleRole;
    const s_outsideCompanyName = this.state.s_outsideCompanyName;
    const s_powerName = this.state.s_powerName;
    const s_divisionID = this.state.s_divisionID;
    const s_createNewCaptureDefaultDivisionIDOrM1 = this.state.s_createNewCaptureDefaultDivisionIDOrM1;
    const s_altName = this.state.s_altName;
    const s_showErrorsTF = this.state.s_showErrorsTF;
    const s_isWorkingTF = this.state.s_isWorkingTF;

    const p_includeUpeTF = this.props.p_includeUpeTF;
    const p_userPerEmailObj = this.props.p_userPerEmailObj;
    const f_onClick = this.props.f_onClick;

    const c_productStylingObj = this.props.CaptureExecMobx.c_productStylingObj;
    const c_usersMaxNumSuperAdminsAddedTF = this.props.AdminMobx.c_usersMaxNumSuperAdminsAddedTF;
    const c_usersNumLicensesRemaining = this.props.AdminMobx.c_usersNumLicensesRemaining;
    const c_usersAddNewUserPerEmailPowerDbNamesToNotIncludeArray = this.props.AdminMobx.c_usersAddNewUserPerEmailPowerDbNamesToNotIncludeArray;

    const userOrUserPowerString = ((p_includeUpeTF) ? ("User") : ("User Power"));

    var firstNameError = undefined;
    var lastNameError = undefined;
    var emailError = undefined;
    var powerError = undefined;
    var divisionError = undefined;
    if(s_showErrorsTF) { //pushed the create button for the first time
      if(this.first_name_error_tf()) { firstNameError = "First Name cannot be blank"; }
      if(this.last_name_error_tf()) { lastNameError = "Last Name cannot be blank"; }
      if(this.email_unique_error_tf()) { emailError = "Email '" + s_email + "' has already been added as a user. If you would like to add another power multi-login for this user, close this form and click the gray 'Add User Power' button within that user's row"; }
      if(this.email_error_tf()) { emailError = "Email must be a valid email address (" + JSFUNC.valid_email_address_undefined_or_invalid_email_error_message_string(s_email) + ")"; }
      if(this.power_error_tf()) { powerError = "Must select a Power for this User"; }
      if(this.division_error_tf()) { divisionError = "Must select a valid division (if none exist, a division must be created on the 'Company/Divisions' Admin subtab)"; }
    }

    var createNewUserSelectPowersToNotIncludeArray = undefined;
    var selectDivisionIDsAlreadyAddedArray = undefined;
    if(p_includeUpeTF) {
      createNewUserSelectPowersToNotIncludeArray = c_usersAddNewUserPerEmailPowerDbNamesToNotIncludeArray;
    }
    else { //adding a new user power to an existing UPE (precalculated which powers to not include in the select options)
      createNewUserSelectPowersToNotIncludeArray = p_userPerEmailObj.createNewUserSelectPowersToNotIncludeArray;
      selectDivisionIDsAlreadyAddedArray = p_userPerEmailObj.upeAllUserDivisionIDsPerPowerNameObj[s_powerName];
    }

    const altNameHoverHelpIconTextArray = [
      "This field will rarely be filled out when creating new Users.",
      "User names are automatically displayed in " + c_productStylingObj.productName + " as 'Firstname Lastname'. This Alternate Name field is used instead of Firstname Lastname if filled out.",
      "Some examples of when to use this field:",
      "1) If a single User has multiple power logins, the name is expanded automatically to distinguish them (like 'Firstname Lastname (Divexec: Sample Division)'), this Alternate Name gives you the option to make a different or much shorter name for this particular User's single power level.",
      "2) When using consultants, you could enter their first and last name, followed by their company so that all users can see where they are from"
    ];
    const createNewCaptureDefaultDivisionHoverHelpIconTextArray = [
      "When this User creates a new Capture, the selected Division will be initialized as the Division Owner with 100% ownership.",
      "If the selected Capture Type has its own default configured for Division Owners, the Capture Type default is used instead.",
      "If this field is left blank, the User's Division will be initialized as the Division Owner."
    ];

    return(
      <CEGeneralReact.FloatingBoxWithSaveCancel
        p_trblFlag="addEditDeleteTableEditItem"
        p_title={"Creating a New " + userOrUserPowerString}
        f_onClickCancel={this.onclick_close_create_new_user}>
        <div className="flex11a yScroll medFullPad">
          {(p_includeUpeTF) &&
            <>
              <CreateNewUserEditFieldShell p_fieldDisplayName="First Name">
                <LibraryReact.Text
                  p_value={s_firstName}
                  p_styleObj={{width:"100%"}}
                  p_tabIndex={1}
                  p_errorTF={(firstNameError !== undefined)}
                  f_onChange={this.onchange_first_name}
                />
                {(firstNameError !== undefined) &&
                  <CEGeneralReact.ErrorText p_class="microTopMargin" p_text={firstNameError} />
                }
              </CreateNewUserEditFieldShell>
              <CreateNewUserEditFieldShell p_fieldDisplayName="Last Name">
                <LibraryReact.Text
                  p_value={s_lastName}
                  p_styleObj={{width:"100%"}}
                  p_tabIndex={2}
                  p_errorTF={(lastNameError !== undefined)}
                  f_onChange={this.onchange_last_name}
                />
                {(lastNameError !== undefined) &&
                  <CEGeneralReact.ErrorText p_class="microTopMargin" p_text={lastNameError} />
                }
              </CreateNewUserEditFieldShell>
              <CreateNewUserEditFieldShell p_fieldDisplayName="Email (used to log in)">
                <LibraryReact.Text
                  p_value={s_email}
                  p_styleObj={{width:"100%"}}
                  p_tabIndex={3}
                  p_errorTF={(emailError !== undefined)}
                  f_onChange={this.onchange_email}
                />
                {(emailError !== undefined) &&
                  <CEGeneralReact.ErrorText p_class="microTopMargin" p_text={emailError} />
                }
              </CreateNewUserEditFieldShell>
              <CreateNewUserEditFieldShell p_fieldDisplayName="Title/Role (optional)">
                <LibraryReact.Text
                  p_value={s_titleRole}
                  p_styleObj={{width:"100%"}}
                  p_tabIndex={4}
                  f_onChange={this.onchange_title_role}
                />
              </CreateNewUserEditFieldShell>
              <CreateNewUserEditFieldShell p_fieldDisplayName="Outside Company Name (optional)">
                <LibraryReact.Text
                  p_value={s_outsideCompanyName}
                  p_styleObj={{width:"100%"}}
                  p_tabIndex={5}
                  f_onChange={this.onchange_outside_company_name}
                />
              </CreateNewUserEditFieldShell>
            </>
          }
          <CreateNewUserEditFieldShell p_fieldDisplayName="User Power">
            <CEGeneralReact.GenericInputOrSelectFromInputType
              p_fieldTypeObj={this.props.DatabaseMobx.c_selectUserPowerWithSuperAdminLicenseCostFieldTypeObj}
              p_valueRaw={s_powerName}
              p_valuesToNotIncludeArray={createNewUserSelectPowersToNotIncludeArray}
              p_tabIndex={6}
              p_errorTF={(powerError !== undefined)}
              f_onChangeOrOnSelect={this.onchange_power_name}
            />
            {(powerError !== undefined) &&
              <CEGeneralReact.ErrorText p_class="microTopMargin" p_text={powerError} />
            }
            {(c_usersNumLicensesRemaining === 0) &&
              <LibraryReact.DivFont p_class="microTopMargin" p_fontClass="fontItalic fontDarkBlue">
                {"With 0 licenses remaining, User Power options that cost additional licenses have been removed. Contact support@bitsolutionsllc.com for pricing on additional licenses."}
              </LibraryReact.DivFont>
            }
            {(c_usersMaxNumSuperAdminsAddedTF) &&
              <LibraryReact.DivFont p_class="microTopMargin" p_fontClass="fontItalic fontDarkBlue">
                {"'Super Admin' has been removed as a User Power option as the maximum number have already been added."}
              </LibraryReact.DivFont>
            }
          </CreateNewUserEditFieldShell>
          {(c_productStylingObj.setupCompanyCanCreateDivisionsTF) &&
            <CreateNewUserEditFieldShell p_fieldDisplayName="User's Division">
              {(this.power_error_tf()) ? (
                <font className="fontItalic fontTextLighter">
                  {"--Select a User Power first--"}
                </font>
              ) : (
                <CEGeneralReact.GenericInputOrSelectFromInputType
                  p_fieldTypeObj={this.props.DatabaseMobx.c_selectDivisionFieldTypeObj}
                  p_valueRaw={s_divisionID}
                  p_valuesToNotIncludeArray={selectDivisionIDsAlreadyAddedArray}
                  p_tabIndex={7}
                  p_errorTF={(divisionError !== undefined)}
                  f_onChangeOrOnSelect={this.onchange_division_id}
                />
              )}
              {(divisionError !== undefined) &&
                <CEGeneralReact.ErrorText p_class="microTopMargin" p_text={divisionError} />
              }
            </CreateNewUserEditFieldShell>
          }
          <CreateNewUserEditFieldShell
            p_fieldDisplayName="Create New Capture Default Division (optional)"
            p_hoverHelpIconTextArray={createNewCaptureDefaultDivisionHoverHelpIconTextArray}>
            <CEGeneralReact.GenericInputOrSelectFromInputType
              p_fieldTypeObj={this.props.DatabaseMobx.c_selectDivisionFieldTypeObj}
              p_valueRaw={s_createNewCaptureDefaultDivisionIDOrM1}
              p_tabIndex={8}
              f_onChangeOrOnSelect={this.onchange_create_new_capture_default_division_id}
            />
          </CreateNewUserEditFieldShell>
          {(c_productStylingObj.setupUsersCreateUserAltNameTF) &&
            <CreateNewUserEditFieldShell p_fieldDisplayName="Alternative Name to Display (optional)" p_hoverHelpIconTextArray={altNameHoverHelpIconTextArray}>
              <LibraryReact.Text
                p_value={s_altName}
                p_styleObj={{width:"100%"}}
                p_tabIndex={9}
                p_errorTF={false}
                f_onChange={this.onchange_alt_name}
              />
            </CreateNewUserEditFieldShell>
          }
          <div className="borderT1bbb" style={{margin:"2em 0"}} />
          <CreateOrEditUserUserPowerDescriptions />
        </div>
        <div className="flex00a displayFlexColumnHcVc tbMedPad borderT1ddd">
          {(s_isWorkingTF) ? (
            <CEGeneralReact.PhpWorkingMessage p_text={"Creating " + userOrUserPowerString + "..."} />
          ) : (
            <CEGeneralReact.CEButton
              p_type="blue"
              p_text="Create New User"
              p_tabIndex={10}
              f_onClick={this.onclick_create_new_user}
            />
          )}
        </div>
      </CEGeneralReact.FloatingBoxWithSaveCancel>
    );
  }
}));


function CreateNewUserEditFieldShell(props) { //props: p_fieldDisplayName, p_hoverHelpIconTextArray, children
  const p_fieldDisplayName = props.p_fieldDisplayName;
  const p_hoverHelpIconTextArray = props.p_hoverHelpIconTextArray;
  const children = props.children;

  var fieldDisplayNameComponent = null;
  if(!JSFUNC.is_array(p_hoverHelpIconTextArray)) {
    fieldDisplayNameComponent = (
      <font className="fontBlue">
        {p_fieldDisplayName}
      </font>
    );
  }
  else {
    fieldDisplayNameComponent = (
      <>
        <div className="flex11a">
          <font className="fontBlue">
            {p_fieldDisplayName}
          </font>
        </div>
        <div className="flex00a lrPad">
          <CEGeneralReact.HelpHoverIconWithFloatingBox>
            {p_hoverHelpIconTextArray}
          </CEGeneralReact.HelpHoverIconWithFloatingBox>
        </div>
      </>
    );
  }

  return(
    <div className="displayFlexRowVc tbMargin">
      <div className="flex11a displayFlexRowVc" style={{flexBasis:"100em"}}>
        {fieldDisplayNameComponent}
      </div>
      <div className="flex11a" style={{flexBasis:"200em"}}>
        {children}
      </div>
    </div>
  );
}


const CreateOrEditUserUserPowerDescriptions = inject("DatabaseMobx")(observer(
class CreateOrEditUserUserPowerDescriptions extends Component { //props: none
  render() {
    const c_allUserPowersDataArrayOfObjs = this.props.DatabaseMobx.c_allUserPowersDataArrayOfObjs;

    return(
      <div className="medFullMargin border1bbb borderRadius10 bgLightestGray medFullPad">
        <LibraryReact.DivFont p_class="medBottomMargin textCenter" p_fontClass="font11 fontBold fontTextLight">
          {"Descriptions of each User Power option"}
        </LibraryReact.DivFont>
        <LibraryReact.DivFont p_class="medBottomMargin lrHugeMargin border bevelBorderColors borderRadius10 bgGray tbPad lrMedPad textCenter" p_fontClass="fontWhite">
          {"All User Powers can do full Capture Management as part of the process"}
        </LibraryReact.DivFont>
        {c_allUserPowersDataArrayOfObjs.map((m_userPowerDataObj) =>
          <div
            key={m_userPowerDataObj.id}
            className="displayFlexRow borderT1eee borderB1ddd tbPad hoverLightestBlueGradient"
            style={{minHeight:"4.4em"}}>
            <div className="flex00a lrMargin border bevelBorderColors" style={{flexBasis:"1.5em", background:m_userPowerDataObj.hashColor}} />
            <div className="flex00a displayFlexRowVc lrPad" style={{flexBasis:"11em"}}>
              <font className="fontItalic fontBold fontTextLight">
                {m_userPowerDataObj.displayName}
              </font>
            </div>
            <div className="flex11a displayFlexRowVc lrPad">
              <font className="fontItalic fontTextLight">
                {m_userPowerDataObj.description}
              </font>
            </div>
          </div>
        )}
      </div>
    );
  }
}));


const UserPowerRow = inject("CaptureExecMobx", "AdminMobx", "DatabaseMobx", "UserMobx")(observer(
class UserPowerRow extends Component { //props: p_userPerEmailObj, p_upeCombinedUserObj
  constructor(props) {
    super(props);
    this.state = {
      s_editingUserPowerTF: false
    };
  }

  onclick_edit_user_power_row = () => {
    this.setState({s_editingUserPowerTF:true});
  }

  onclick_close_edit_user_power = () => {
    this.setState({s_editingUserPowerTF:false});
  }

  ondelete_user_power = () => {
    const p_upeCombinedUserObj = this.props.p_upeCombinedUserObj;

    const jsDescription = JSFUNC.js_description_from_action("AdminReact - UserPowerRow", "ondelete_user_power", [], []);
    const C_CallPhpTblUID = new JSPHP.ClassCallPhpTblUID(jsDescription);
    C_CallPhpTblUID.add_delete("tbl_a_users", p_upeCombinedUserObj.user_id); //users are sorted by power sort and division_tree id, no resort needed when deleting
    C_CallPhpTblUID.execute();
  }

  onsave_user_power_power = (i_powerName) => {
    this.update_user_power_field("power_name", i_powerName, "s");
  }

  onsave_user_power_division = (i_divisionID) => {
    this.update_user_power_field("division_id", i_divisionID, "i");
  }

  onsave_user_power_create_new_capture_default_division = (i_divisionID) => {
    this.update_user_power_field("create_new_capture_default_division_id_or_m1", i_divisionID, "i");
  }

  onsave_user_power_alt_full_name = (i_altName) => {
    this.update_user_power_field("alt_full_name", i_altName, "s");
  }

  update_user_power_field = (i_fieldName, i_value, i_idsb) => {
    const p_upeCombinedUserObj = this.props.p_upeCombinedUserObj;

    const jsDescription = JSFUNC.js_description_from_action("AdminReact - UserPowerRow", "update_user_power_field", ["i_fieldName", "i_value", "i_idsb"], [i_fieldName, i_value, i_idsb]);
    const C_CallPhpTblUID = new JSPHP.ClassCallPhpTblUID(jsDescription);
    C_CallPhpTblUID.add_update("tbl_a_users", p_upeCombinedUserObj.user_id, i_fieldName, i_value, i_idsb);
    C_CallPhpTblUID.execute();
  }

  render() {
    const s_editingUserPowerTF = this.state.s_editingUserPowerTF;

    const p_userPerEmailObj = this.props.p_userPerEmailObj;
    const p_upeCombinedUserObj = this.props.p_upeCombinedUserObj;

    const c_productStylingObj = this.props.CaptureExecMobx.c_productStylingObj;
    const o_userID = this.props.UserMobx.o_userID;
    const createNewCaptureDefaultDivisionIDOrM1 = p_upeCombinedUserObj.create_new_capture_default_division_id_or_m1;
    const defaultCaptureDivisionDisplayName = ((JSFUNC.is_number_not_nan_gt_0(createNewCaptureDefaultDivisionIDOrM1)) ? (this.props.DatabaseMobx.value_mask_plaintext_from_value_raw_and_field_type_obj(createNewCaptureDefaultDivisionIDOrM1, this.props.DatabaseMobx.c_selectDivisionFieldTypeObj)) : (""));

    const userNumPowers = p_userPerEmailObj.upeMultiLoginCombinedUsersArrayOfObjs.length;
    const canDeleteUserPowerTF = ((userNumPowers > 1) && (p_upeCombinedUserObj.user_id !== o_userID)); //can't delete the last power of a userPerEmail, also can't delete yourself

    //modified power name shows up only in this Admin User table when a user has tbl_a_users bit_non_billable_user_01 marked as 1
    var modifiedUserPowerRowPowerDisplayName = p_upeCombinedUserObj.powerDisplayName;
    var modifiedUserPowerRowPowerDisplayNamePlainText = p_upeCombinedUserObj.powerDisplayName;
    if(p_upeCombinedUserObj.bitNonBillableUserTF) {
      modifiedUserPowerRowPowerDisplayName = (
        <font>{p_upeCombinedUserObj.powerDisplayName}<font className="fontItalic">{" [BIT Non-Billable User]"}</font></font>
      );
      modifiedUserPowerRowPowerDisplayNamePlainText += " [BIT Non-Billable User]";
    }

    var userPowerRowTitle = p_userPerEmailObj.upeFirstNameLastName + " (" + p_userPerEmailObj.email + ")";
    userPowerRowTitle += "\nUser Power: " + modifiedUserPowerRowPowerDisplayNamePlainText;
    userPowerRowTitle += "\nDivision: " + p_upeCombinedUserObj.divisionName;
    if(JSFUNC.string_is_filled_out_tf(defaultCaptureDivisionDisplayName)) {
      userPowerRowTitle += "\nCreate New Capture Default Division (optional): " + defaultCaptureDivisionDisplayName;
    }
    if(JSFUNC.string_is_filled_out_tf(p_upeCombinedUserObj.alt_full_name)) {
      userPowerRowTitle += "\nAlternative Name: " + p_upeCombinedUserObj.alt_full_name;
    }
    userPowerRowTitle += "\n[Click to edit this User's Power, Division, or Create New Capture Default Division (optional)";
    if(c_productStylingObj.setupUsersCreateUserAltNameTF) {
      userPowerRowTitle += ", or Alternative Name to Display"
    }
    userPowerRowTitle += "]";

    const editUserPowerFieldWidth = "30%";

    return (
      <div
        className="flex00a displayFlexRow lrMedMargin microTopMargin microBottomMargin lrPad hoverLighterBlueGradient cursorPointer"
        style={{height:"2.2em", backgroundColor:((p_userPerEmailObj.upeDeactivatedTF) ? ("#ddd") : ("#cdf")), border:"solid 1px #cba", borderRadius:"0.5em"}}
        title={userPowerRowTitle}
        onClick={this.onclick_edit_user_power_row}>
        <div className="flex00a smallFullMargin" style={{flexBasis:"0.9em", background:p_upeCombinedUserObj.powerHashColor}} />
        <div className="flex11a displayFlexRowVc lrPad" style={{flexBasis:"300em", maxWidth:"20em"}}>
          <LibraryReact.NowrapEllipsis p_fontClass="">
            {modifiedUserPowerRowPowerDisplayName}
          </LibraryReact.NowrapEllipsis>
        </div>
        <div className="flex11a displayFlexRowVc lrPad" style={{flexBasis:"150em"}}>
          <LibraryReact.NowrapEllipsis p_fontClass="fontItalic">
            {p_upeCombinedUserObj.divisionName}
          </LibraryReact.NowrapEllipsis>
        </div>
        <div className="flex11a displayFlexRowVc lrPad" style={{flexBasis:"100em"}}>
          <LibraryReact.NowrapEllipsis p_fontClass="fontItalic">
            {defaultCaptureDivisionDisplayName}
          </LibraryReact.NowrapEllipsis>
        </div>
        <div className="flex11a displayFlexRowVc lrPad" style={{flexBasis:"100em"}}>
          <LibraryReact.NowrapEllipsis p_fontClass="fontItalic">
            {p_upeCombinedUserObj.alt_full_name}
          </LibraryReact.NowrapEllipsis>
        </div>
        <div className="flex00a displayFlexRowVc" style={{flexBasis:"6em"}}>
          <font className="fontItalic fontTextLighter">
            {"# Captures"}
          </font>
        </div>
        <div className="flex00a displayFlexRowVc">
          <CapturesReact.NumberOfAssignedCapturesCountButton
            p_partialNumMatchingCaptures={p_upeCombinedUserObj.numCapturesOwnedByUserPower}
            p_matchingCaptureIDsArray={p_upeCombinedUserObj.capturesOwnedByUserPowerCaptureIDsArray}
            p_floatingBoxTitle={"Captures Owned by User '" + p_userPerEmailObj.upeFirstNameLastName + " (" + p_upeCombinedUserObj.powerDisplayName + " - " + p_upeCombinedUserObj.divisionName + ")'"}
          />
        </div>
        <div className="flex00a displayFlexColumnHcVc" style={{flexBasis:"2em"}}>
          {(canDeleteUserPowerTF) &&
            <CEGeneralReact.DeleteMenu
              p_menuItemText="Delete"
              p_message={"Are you sure you want to remove the following User from " + c_productStylingObj.productName + "?\n\nUser: " + p_userPerEmailObj.upeFirstNameLastName + "\nUser Power/Division: " + p_upeCombinedUserObj.powerDisplayName + " (" + p_upeCombinedUserObj.divisionName + ")"}
              f_onDelete={this.ondelete_user_power}
            />
          }
        </div>
        {(s_editingUserPowerTF) &&
          <CEGeneralReact.FloatingBoxWithSaveCancel
            p_trblFlag="addEditDeleteTableEditItem"
            p_title={"Editing " + p_upeCombinedUserObj.powerDisplayName + " (" + p_upeCombinedUserObj.divisionName + ") User Power for " + p_userPerEmailObj.upeFirstNameLastName}
            f_onClickSave={this.onclick_close_edit_user_power}>
            <div className="flex11a yScroll medFullPad">
              {(p_upeCombinedUserObj.bitNonBillableUserTF) &&
                <div
                  className="displayFlexColumnHcVc medBottomMargin"
                  title="This is a BIT Solutions created User that you are not being billed for and you are not able to create yourself. If you have any questions, please contact support@bitsolutionsllc.com">
                  <div className="displayFlexColumnHcVc border1 bevelBorderColorBlue borderRadius05 bgLightBlue tbMicroPad lrMedPad textCenter" style={{minWidth:"10em", width:"50%"}}>
                    <font className="font11 fontItalic fontWhite">
                      {"BIT Non-Billable User"}
                    </font>
                  </div>
                </div>
              }
              <CEGeneralReact.CaptureExecFieldEditSaveCancel
                p_ceEditItemString={"adminUserEdit_uID" + p_upeCombinedUserObj.user_id + "power"}
                p_fieldDisplayName="User Power"
                p_fieldTypeObj={this.props.DatabaseMobx.c_selectUserPowerWithSuperAdminLicenseCostFieldTypeObj}
                p_valueRaw={p_upeCombinedUserObj.power_name}
                p_valueIsEditableTFU={true}
                p_valuesToNotIncludeArray={p_upeCombinedUserObj.editUserSelectPowersToNotIncludeArray}
                p_containerClass="tbMargin"
                p_fieldClass="fontBlue"
                p_fieldWidth={editUserPowerFieldWidth}
                f_onSaveChanged={this.onsave_user_power_power}
              />
              <CEGeneralReact.CaptureExecFieldEditSaveCancel
                p_ceEditItemString={"adminUserEdit_uID" + p_upeCombinedUserObj.user_id + "division_id"}
                p_fieldDisplayName="User's Division"
                p_fieldTypeObj={this.props.DatabaseMobx.c_selectDivisionFieldTypeObj}
                p_valueRaw={p_upeCombinedUserObj.division_id}
                p_valueIsEditableTFU={true}
                p_containerClass="tbMargin"
                p_fieldClass="fontBlue"
                p_fieldWidth={editUserPowerFieldWidth}
                f_onSaveChanged={this.onsave_user_power_division}
              />
              <CEGeneralReact.CaptureExecFieldEditSaveCancel
                p_ceEditItemString={"adminUserEdit_uID" + p_upeCombinedUserObj.user_id + "create_new_capture_default_division_id_or_m1"}
                p_fieldDisplayName="Create New Capture Default Division (optional)"
                p_fieldTypeObj={this.props.DatabaseMobx.c_selectDivisionFieldTypeObj}
                p_valueRaw={p_upeCombinedUserObj.create_new_capture_default_division_id_or_m1}
                p_valueIsEditableTFU={true}
                p_containerClass="tbMargin"
                p_fieldClass="fontBlue"
                p_fieldWidth={editUserPowerFieldWidth}
                f_onSaveChanged={this.onsave_user_power_create_new_capture_default_division}
              />
              {(c_productStylingObj.setupUsersCreateUserAltNameTF) &&
                <CEGeneralReact.CaptureExecFieldEditSaveCancel
                  p_ceEditItemString={"adminUserEdit_uID" + p_upeCombinedUserObj.user_id + "alt_full_name"}
                  p_fieldDisplayName="Alternative Name to Display (optional)"
                  p_fieldTypeObj={this.props.DatabaseMobx.c_genericTextFieldTypeObj}
                  p_valueRaw={p_upeCombinedUserObj.alt_full_name}
                  p_valueIsEditableTFU={true}
                  p_containerClass="tbMargin"
                  p_fieldClass="fontBlue"
                  p_fieldWidth={editUserPowerFieldWidth}
                  f_onSaveChanged={this.onsave_user_power_alt_full_name}
                />
              }
              <div style={{marginTop:"3em"}} />
              <CreateOrEditUserUserPowerDescriptions />
            </div>
          </CEGeneralReact.FloatingBoxWithSaveCancel>
        }
      </div>
    );
  }
}));





const UsersReassignUserCustomCreationsFloatingBox = inject("AdminMobx", "DatabaseMobx", "UserMobx")(observer(
class UsersReassignUserCustomCreationsFloatingBox extends Component { //props: p_userPerEmailObj, f_onClose
  //user_id: trend/daily graphs/pages, master presets, column presets, filter presets, sort presets, gantt date presets
  //user_per_email_id: GCSS Auto Searches
  constructor(props) {
    super(props);
    this.state = {
      s_reassignToUserID: -1,
      s_triedFirstSaveTF: false
    };
  }

  onselect_to_user = (i_selectedToUserID) => {
    this.setState({s_reassignToUserID:i_selectedToUserID});
  }

  onclick_reassign_custom_creations = () => {
    const s_reassignToUserID = this.state.s_reassignToUserID;

    this.setState({s_triedFirstSaveTF:true});

    if(JSFUNC.select_int_is_filled_out_tf(s_reassignToUserID)) {
      const customCreationTblInfoArrayOfObjs = this.get_custom_creations_tbl_info_arrayOfObjs();

      const jsDescription = JSFUNC.js_description_from_action("AdminReact - UsersReassignUserCustomCreationsFloatingBox", "onclick_reassign_custom_creations", [], []);
      const C_CallPhpTblUID = new JSPHP.ClassCallPhpTblUID(jsDescription);

      for(let customCreationTblInfo of customCreationTblInfoArrayOfObjs) {
        var tblDataMapOfMaps = this.props.DatabaseMobx["o_" + customCreationTblInfo.tblMapOfMapsName];
        for(let dataMap of tblDataMapOfMaps.values()) {
          if(JSFUNC.in_array(dataMap.get(customCreationTblInfo.filterFieldDbName), customCreationTblInfo.filterValuesArray)) {
            var rowID = dataMap.get("id");
            if(customCreationTblInfo.newValueInt > 0) {
              C_CallPhpTblUID.add_update(customCreationTblInfo.tblMapOfMapsName, rowID, customCreationTblInfo.filterFieldDbName, customCreationTblInfo.newValueInt, "i");
            }
          }
        }
      }

      C_CallPhpTblUID.execute();
    }
  }

  get_custom_creations_tbl_info_arrayOfObjs = () => {
    const s_reassignToUserID = this.state.s_reassignToUserID;

    const p_userPerEmailObj = this.props.p_userPerEmailObj;

    const fromUserIDsArray = this.props.DatabaseMobx.get_all_user_ids_from_user_per_email_id(p_userPerEmailObj.id);

    var reassignToUserPerEmailID = -1; //in case it can't match the user to a userPerEmail
    for(let combinedUserMap of this.props.DatabaseMobx.c_tbl_a_users.values()) {
      if(combinedUserMap.get("user_id") === s_reassignToUserID) {
        reassignToUserPerEmailID = combinedUserMap.get("user_per_email_id");
        break;
      }
    }

    return([
      {tblDisplayName:"Master Presets",                 tblMapOfMapsName:"tbl_f_capture_table_presets", filterFieldDbName:"user_id", filterValuesArray:fromUserIDsArray, p_displayFieldDbName:"name", newValueInt:s_reassignToUserID},
      {tblDisplayName:"Column Presets",                 tblMapOfMapsName:"tbl_f_cst_column_presets",    filterFieldDbName:"user_id", filterValuesArray:fromUserIDsArray, p_displayFieldDbName:"name", newValueInt:s_reassignToUserID},
      {tblDisplayName:"Filter Presets",                 tblMapOfMapsName:"tbl_f_filter_presets",        filterFieldDbName:"user_id", filterValuesArray:fromUserIDsArray, p_displayFieldDbName:"name", newValueInt:s_reassignToUserID},
      {tblDisplayName:"Sort Presets",                   tblMapOfMapsName:"tbl_f_sort_presets",          filterFieldDbName:"user_id", filterValuesArray:fromUserIDsArray, p_displayFieldDbName:"name", newValueInt:s_reassignToUserID},
      {tblDisplayName:"Gantt Date Presets",             tblMapOfMapsName:"tbl_f_gantt_date_presets",    filterFieldDbName:"user_id", filterValuesArray:fromUserIDsArray, p_displayFieldDbName:"name", newValueInt:s_reassignToUserID},
      {tblDisplayName:"Daily Snapshot Pages of Graphs", tblMapOfMapsName:"tbl_d_daily_snapshot_pages",  filterFieldDbName:"user_id", filterValuesArray:fromUserIDsArray, p_displayFieldDbName:"name", newValueInt:s_reassignToUserID},
      {tblDisplayName:"Trend Analyzer Pages of Graphs", tblMapOfMapsName:"tbl_d_trend_analyzer_pages",  filterFieldDbName:"user_id", filterValuesArray:fromUserIDsArray, p_displayFieldDbName:"name", newValueInt:s_reassignToUserID},
      {tblDisplayName:"GCSS Auto Searches",             tblMapOfMapsName:"tbl_u_gcss_auto_searches",    filterFieldDbName:"user_per_email_id", filterValuesArray:[p_userPerEmailObj.id], p_displayFieldDbName:"name", newValueInt:reassignToUserPerEmailID}
    ]);
  }

  render() {
    const s_reassignToUserID = this.state.s_reassignToUserID;
    const s_triedFirstSaveTF = this.state.s_triedFirstSaveTF;

    const p_userPerEmailObj = this.props.p_userPerEmailObj;
    const f_onClose = this.props.f_onClose;

    const selectedToUserErrorTF = (s_triedFirstSaveTF && !JSFUNC.select_int_is_filled_out_tf(s_reassignToUserID));

    const customCreationTblInfoArrayOfObjs = this.get_custom_creations_tbl_info_arrayOfObjs();

    return(
      <CEGeneralReact.FloatingBoxWithSaveCancel
        p_trblFlag="medium"
        p_title={"Reassign User Custom Creations from User '" + p_userPerEmailObj.upeFirstNameLastName + "'"}
        f_onClickCancel={f_onClose}>
        <div className="flex11a yScroll medFullPad">
          <LibraryReact.DivFont p_class="smallBottomMargin" p_fontClass="font11 fontBold fontTextLight">
            {"Select User to reassign all the custom creations to:"}
          </LibraryReact.DivFont>
          <div className="" style={{maxWidth:"25em"}}>
            <CEGeneralReact.GenericInputOrSelectFromInputType
              p_fieldTypeObj={this.props.DatabaseMobx.c_selectUserDeactivatedHiddenUnlessCheckedFieldTypeObj}
              p_valueRaw={s_reassignToUserID}
              p_errorTF={selectedToUserErrorTF}
              f_onChangeOrOnSelect={this.onselect_to_user}
            />
            {(selectedToUserErrorTF) &&
              <CEGeneralReact.ErrorText p_text="Select a User to reassign the custom creations to" />
            }
          </div>
          <div className="bigTopMargin lrMedMargin border1bbb borderRadius05 bgLightestGray medFullPad">
            {(customCreationTblInfoArrayOfObjs.map((m_customCreationTblInfoObj) =>
              <UserCustomCreationsList
                p_text={m_customCreationTblInfoObj.tblDisplayName}
                p_dataMapOfMaps={this.props.DatabaseMobx["o_" + m_customCreationTblInfoObj.tblMapOfMapsName]}
                p_filterFieldDbName={m_customCreationTblInfoObj.filterFieldDbName}
                p_filterValuesArray={m_customCreationTblInfoObj.filterValuesArray}
                p_displayFieldDbName={m_customCreationTblInfoObj.p_displayFieldDbName}
              />
            ))}
          </div>
        </div>
        <div className="displayFlexRowHcVc borderT1bbb tbMedPad">
          <div className="flex00a lrMedPad">
            <CEGeneralReact.CEButton
              p_text="Reassign Custom Creations"
              p_type="blue"
              f_onClick={this.onclick_reassign_custom_creations}
            />
          </div>
          <div className="flex00a lrMedPad">
            <CEGeneralReact.CEButton
              p_text="Cancel"
              p_type="gray"
              f_onClick={f_onClose}
            />
          </div>
        </div>
      </CEGeneralReact.FloatingBoxWithSaveCancel>
    );
  }
}));

function UserCustomCreationsList(props) { //props: p_text, p_dataMapOfMaps, p_filterFieldDbName, p_filterValuesArray, p_displayFieldDbName
  const p_text = props.p_text;
  const p_dataMapOfMaps = props.p_dataMapOfMaps;
  const p_filterFieldDbName = props.p_filterFieldDbName;
  const p_filterValuesArray = props.p_filterValuesArray;
  const p_displayFieldDbName = props.p_displayFieldDbName;

  var dataValuesArray = [];
  for(let dataMap of p_dataMapOfMaps.values()) {
    if(JSFUNC.in_array(dataMap.get(p_filterFieldDbName), p_filterValuesArray)) {
      dataValuesArray.push(dataMap.get(p_displayFieldDbName));
    }
  }

  return(
    <>
      <LibraryReact.DivFont p_class="smallBottomMargin" p_fontClass="font11 fontBold fontBlue">
        {p_text + " (" + dataValuesArray.length + ")"}
      </LibraryReact.DivFont>
      {dataValuesArray.map((m_dataValue) =>
        <LibraryReact.DivFont p_class="" p_fontClass="fontDarkBlue">
          {" - " + m_dataValue}
        </LibraryReact.DivFont>
      )}
      <div className="bigBottomMargin" />
    </>
  );
}






//=================================================================================================================================================================
//=================================================================================================================================================================



export const AdminSubtabCaptureTypes = inject("AdminMobx", "DatabaseMobx")(observer(
class AdminSubtabCaptureTypes extends Component { //props: none
  constructor(props) {
    super(props);
    this.state = {
      s_selectedCaptureTypeIDToCopy: -1
    };
  }

  onselect_admin_create_new_capture_default_capture_type = (i_selectedCreateNewCaptureDefaultCaptureTypeID) => {
    this.props.AdminMobx.a_update_tbl_a_company_fields("create_new_capture_default_capture_type_id", i_selectedCreateNewCaptureDefaultCaptureTypeID, "i");
  }

  onselect_capture_type_id_to_copy = (i_newValue) => {
    this.setState({s_selectedCaptureTypeIDToCopy:i_newValue});
  }

  onclick_create_new_capture_type_from_copy = () => {
    this.props.AdminMobx.a_capture_type_create_new_from_copy(this.state.s_selectedCaptureTypeIDToCopy);
    this.setState({s_selectedCaptureTypeIDToCopy:-1}); //reset the selected capture type to copy to nothing selected
  }

  render() {
    const s_selectedCaptureTypeIDToCopy = this.state.s_selectedCaptureTypeIDToCopy;

    const c_adminCaptureTypesWithMatchingCapturesArrayOfObjs = this.props.AdminMobx.c_adminCaptureTypesWithMatchingCapturesArrayOfObjs;
    const c_captureTypesUnassignedMatchingCapturesObj = this.props.AdminMobx.c_captureTypesUnassignedMatchingCapturesObj;
    const o_tbl_a_capture_types_details_fields = this.props.DatabaseMobx.o_tbl_a_capture_types_details_fields;
    const o_tbl_a_capture_types_shaping_questions = this.props.DatabaseMobx.o_tbl_a_capture_types_shaping_questions;
    const o_tbl_a_capture_types_stages = this.props.DatabaseMobx.o_tbl_a_capture_types_stages;
    const o_tbl_a_capture_types_debrief_questions = this.props.DatabaseMobx.o_tbl_a_capture_types_debrief_questions;
    const c_companyCreateNewCaptureDefaultCaptureTypeID = this.props.DatabaseMobx.c_companyCreateNewCaptureDefaultCaptureTypeID;
    const c_cardNameDates = this.props.DatabaseMobx.c_cardNameDates;
    const c_cardNameDetails = this.props.DatabaseMobx.c_cardNameDetails;
    const c_cardNameDealShaping = this.props.DatabaseMobx.c_cardNameDealShaping;
    const c_captureTypesArrayOfObjs = this.props.DatabaseMobx.c_captureTypesArrayOfObjs;
    const c_captureTypeNamesArray = this.props.DatabaseMobx.c_captureTypeNamesArray;

    const functionDeleteCaptureTypeCleanup = (i_C_CallPhpTblUID, i_captureTypeRowObj) => {
      const captureTypeID = i_captureTypeRowObj.id;

      //remove all stage timeline rows for this capture type
      const captureTypeStageIDsToDeleteArray = JSFUNC.get_column_vector_from_mapOfMaps_matching_field_value(o_tbl_a_capture_types_stages, "capture_type_id", captureTypeID, "id");
      i_C_CallPhpTblUID.add_delete("tbl_a_capture_types_stages", captureTypeStageIDsToDeleteArray);

      //remove all details (and dates) card assignments of fields for this capture type (no need for resorting as entire capture type is removed)
      const captureTypeDetailsFieldsIDsToDeleteArray = JSFUNC.get_column_vector_from_mapOfMaps_matching_field_value(o_tbl_a_capture_types_details_fields, "capture_type_id", captureTypeID, "id");
      i_C_CallPhpTblUID.add_delete("tbl_a_capture_types_details_fields", captureTypeDetailsFieldsIDsToDeleteArray); //deletes every details field in the capture type (all groups) no need to resort

      //remove all deal shaping question assignments for this capture type
      const captureTypeShapingQuestionsIDsToDeleteArray = JSFUNC.get_column_vector_from_mapOfMaps_matching_field_value(o_tbl_a_capture_types_shaping_questions, "capture_type_id", captureTypeID, "id");
      i_C_CallPhpTblUID.add_delete("tbl_a_capture_types_shaping_questions", captureTypeShapingQuestionsIDsToDeleteArray); //deletes every active shaping question in the capture type (all stages) no need to resort

      //remove all deal shaping debrief question assignments for this capture type
      const captureTypeDebriefQuestionsIDsToDeleteArray = JSFUNC.get_column_vector_from_mapOfMaps_matching_field_value(o_tbl_a_capture_types_debrief_questions, "capture_type_id", captureTypeID, "id");
      i_C_CallPhpTblUID.add_delete("tbl_a_capture_types_debrief_questions", captureTypeDebriefQuestionsIDsToDeleteArray); //deletes every debrief closed shaping question in the capture type (all stages) no need to resort
    };

    const aedTableObj = {
      tblName: "tbl_a_capture_types",
      dragToResortFieldDbName: "sort",
      initialSortedFieldDbName: "sort",
      tableWidth: "60em",
      itemName: "Capture Type",
      deleteItemNameFieldDbName: "name",
      itemDeleteFunctionsArray: [functionDeleteCaptureTypeCleanup],
      newItemConstantFieldNamesArray: ["card_ids_comma"],
      newItemConstantValuesArray: ["1,2,3,4,5,6,7,8,9,10,11,12,13,14,15"],
      newItemConstantIdsbArray: ["s"],
      unassignedMatchingCapturesObj: c_captureTypesUnassignedMatchingCapturesObj,
      fieldsArrayOfObjs: [
        {width:"300em", dbName:"name", displayName:"Capture Type Name", fieldTypeObj:this.props.DatabaseMobx.c_genericTextFieldTypeObj, initialValue:"", cellHoverTF:true, requiredNotEmptyTF:true},
        {width:"100em", dbName:"prime1_sub2", displayName:"Prime/Sub", fieldTypeObj:this.props.DatabaseMobx.c_selectPrimeSubFieldTypeObj, initialValue:1, requiredNotEmptyTF:true},
        {width:"100em", displayName:"# Assigned Captures", matchingCapturesObjTF:true},
        {width:"3em", dbName:"sort", displayName:"Sort", fieldTypeObj:this.props.DatabaseMobx.c_genericIntPositiveFieldTypeObj, initialValue:1}
      ]
    };

    var valueArray = [-1, 0];
    var displayArray = ["|No Capture Type Initially Selected|", "|Use First Capture Type in Admin Pool|" + ((c_captureTypeNamesArray.length > 0) ? (" (" + c_captureTypeNamesArray[0] + ")") : (""))];
    for(let captureTypeObj of c_captureTypesArrayOfObjs) {
      valueArray.push(captureTypeObj.id);
      displayArray.push(captureTypeObj.name);
    }
    const swsOptionsObj = undefined;
    const selectWithSearchDataObj = this.props.DatabaseMobx.create_sws_data_obj_from_value_array_and_display_array("Default Capture Type", valueArray, false, displayArray, swsOptionsObj);
    const selectAdminCreateNewCaptureDefaultCaptureTypeFieldTypeObj = this.props.DatabaseMobx.create_field_type_obj("select", selectWithSearchDataObj);

    return (
      <>
        <AdminCaptureTypeSelectionBoxes />
        <div className="flex11a yScroll yScrollBottomPad">
          <div className="displayFlexRow flexWrap">
            <div className="flex00a medFullMargin">
              <CEComplexReact.AddEditDeleteTable
                p_dataArrayOfObjs={c_adminCaptureTypesWithMatchingCapturesArrayOfObjs}
                p_aedTableObj={aedTableObj}
              />
            </div>
            <div className="flex00a medFullMargin" style={{flexBasis:"35em"}}>
              <div className="border1bbb borderRadius10 bgLightestGray medFullPad">
                <div className="displayFlexColumnHcVc microBottomMargin textCenter">
                  <font className="font11 fontBold fontTextLight">
                    {"Create New Capture: pre-selected default Capture Type"}
                  </font>
                </div>
                <div className="smallBottomMargin">
                  <font className="fontItalic fontTextLight">
                    {"When in the 'Create New Capture' process on the 'Captures' tab, this selection below determines which Capture Type (if any) is pre-selected for the User as a convenience"}
                  </font>
                </div>
                <CEGeneralReact.GenericInputOrSelectFromInputType
                  p_fieldTypeObj={selectAdminCreateNewCaptureDefaultCaptureTypeFieldTypeObj}
                  p_valueRaw={c_companyCreateNewCaptureDefaultCaptureTypeID}
                  f_onChangeOrOnSelect={this.onselect_admin_create_new_capture_default_capture_type}
                />
              </div>
            </div>
          </div>
          <div className="lrMedMargin hugeTopMargin borderT1bbb" />
          <div className="lrMedMargin hugeTopMargin borderRadius10 bgLightesterGray medFullPad" style={{border:"solid 1px #66a", width:"38em"}}>
            <div className="smallBottomMargin textCenter">
              <font className="font12 fontBold fontBlue">
                {"Create Full Copy of Existing Capture Type"}
              </font>
            </div>
            <div className="microBottomMargin">
              <font className="fontItalic fontTextLight">
                {"Creates a new entry in the Capture Type pool above with name 'Copy of __'"}
              </font>
            </div>
            <div className="smallBottomMargin">
              <font className="fontItalic fontTextLight">
                {"Copies all settings from these Admin 'System Setup' menus:\n - Capture Cards\n - Stages\n - " + c_cardNameDetails + " Card Groups\n - " + c_cardNameDetails + "/" + c_cardNameDates + " Fields\n - " + c_cardNameDealShaping + " Questions\n - Budgets"}
              </font>
            </div>
            <div className="medBottomMargin">
              <CEGeneralReact.GenericInputOrSelectFromInputType
                p_fieldTypeObj={this.props.DatabaseMobx.c_selectCaptureTypeFieldTypeObj}
                p_valueRaw={s_selectedCaptureTypeIDToCopy}
                f_onChangeOrOnSelect={this.onselect_capture_type_id_to_copy}
              />
            </div>
            {(JSFUNC.select_int_is_filled_out_tf(s_selectedCaptureTypeIDToCopy)) &&
              <div className="displayFlexColumnHcVc">
                <CEGeneralReact.CEButton
                  p_type="add"
                  p_text="Copy Selected Capture Type"
                  f_onClick={this.onclick_create_new_capture_type_from_copy}
                />
              </div>
            }
          </div>
        </div>
      </>
    );
  }
}));





//=================================================================================================================================================================
//=================================================================================================================================================================




export const AdminSubtabCaptureCards = inject("CaptureExecMobx", "AdminMobx", "OpenCaptureMobx", "DatabaseMobx")(observer(
class AdminSubtabCaptureCards extends Component { //props: none
  render() {
    const c_computedUrlAndProductObj = this.props.CaptureExecMobx.c_computedUrlAndProductObj;
    const c_selectedCaptureTypeObj = this.props.AdminMobx.c_selectedCaptureTypeObj;
    const c_selectedCaptureTypeExistsTF = this.props.AdminMobx.c_selectedCaptureTypeExistsTF;
    const c_selectedCaptureTypeCaptureCardsArrayOfObjs = this.props.AdminMobx.c_selectedCaptureTypeCaptureCardsArrayOfObjs;
    const c_notSelectedCaptureTypeDetailsCardsArrayOfObjs = this.props.AdminMobx.c_notSelectedCaptureTypeDetailsCardsArrayOfObjs;
    const c_fieldMapOfCaptureType = this.props.DatabaseMobx.c_fieldMapOfCaptureType;

    const numCardsAdded = c_selectedCaptureTypeCaptureCardsArrayOfObjs.length;
    const numCardsNotAdded = c_notSelectedCaptureTypeDetailsCardsArrayOfObjs.length;

    return (
      <div className="flex11a displayFlexColumn">
        <AdminCaptureTypeSelectionBoxes />
        <div className="flex11a displayFlexRow">
          <div className="flex00a yScroll yScrollBottomPad" style={{flexBasis:"32em", borderRight:"solid 1px #ccc"}}>
            <div className="smallFullMargin medFullPad bgAdminCaptureTypeTableReceiving" style={{border:"solid 1px #ddd", borderRadius:"1em"}}>
              {(c_selectedCaptureTypeExistsTF) ? (
                <>
                  <div className="smallBottomMargin">
                    <font className="font12 fontItalic">
                      {"Cards available inside captures with " + c_fieldMapOfCaptureType.get("display_name") + " '" + c_selectedCaptureTypeObj.name + "'"}
                    </font>
                  </div>
                  {(numCardsAdded === 0) ? (
                    <div className="smallFullMargin textCenter">
                      <font className="fontItalic fontTextLight">
                        {"No capture cards have been added yet for " + c_fieldMapOfCaptureType.get("display_name") + " '" + c_selectedCaptureTypeObj.name + "'"}
                      </font>
                    </div>
                  ) : (
                    c_selectedCaptureTypeCaptureCardsArrayOfObjs.map((m_captureCardObj, m_index) =>
                      <SelectedCaptureCardItem
                        key={c_selectedCaptureTypeObj.id + "-" + m_captureCardObj.cardID}
                        p_captureCardIndex={m_index}
                        p_captureCardObj={m_captureCardObj}
                        p_isOnlyItemTF={(numCardsAdded === 1)}
                        p_isLastItemTF={(m_index === (numCardsAdded - 1))}
                      />
                    )
                  )}
                  <div className="bigTopMargin smallBottomMargin">
                    <font className="font12 fontItalic">
                      {"Cards removed from this " + c_fieldMapOfCaptureType.get("display_name")}
                    </font>
                  </div>
                  {(numCardsNotAdded === 0) ? (
                    <div className="smallFullMargin textCenter">
                      <font className="fontItalic fontTextLight">
                        {"All capture cards have been added"}
                      </font>
                    </div>
                  ) : (
                    c_notSelectedCaptureTypeDetailsCardsArrayOfObjs.map((m_captureCardObj) =>
                      <NotSelectedCaptureCardItem
                        key={m_captureCardObj.cardID}
                        p_captureCardObj={m_captureCardObj}
                      />
                    )
                  )}
                </>
              ) : (
                <div className="smallBottomMargin">
                  <font className="font12 fontItalic fontTextLight">
                    {"--Capture Cards cannot be added until at least one Capture Type is created and selected using the 'Capture Type' subtab--"}
                  </font>
                </div>
              )}
            </div>
          </div>
          <div className="flex11a displayFlexColumn">
            <div className="flex00a microTopMargin smallBottomMargin lrPad textCenter">
              <font className="font13 fontItalic">
                {"Example Selected Capture Snapshot Layout "}
              </font>
              <font className="fontItalic fontTextLighter">
                {"(users will see different numbers of cards per row based on their screen width)"}
              </font>
            </div>
            <div className="flex11a yScroll yScrollBottomPad lrMedPad">
              {(c_selectedCaptureTypeExistsTF) &&
                <div className="displayFlexRow flexWrap">
                  {c_selectedCaptureTypeCaptureCardsArrayOfObjs.map((m_captureCardObj) =>
                    <div className="positionRelative" style={{height:"243px", width:"363px"}}>
                      <LibraryReact.Image
                        p_src={c_computedUrlAndProductObj.productGraphicsSubfolderAddress + "/cardsnapshot_" + m_captureCardObj.adminPictureFileName + ".png"}
                        p_alt={"Capture Card - " + m_captureCardObj.cardName}
                        p_styleObj={{opacity:"0.66"}}
                      />
                      {(m_captureCardObj.cardNameIsCustomTF) &&
                        <div className="positionAbsolute bgWhite" style={{top:"10px", left:"10px", width:"215px", height:"20px"}}>
                          <LibraryReact.NowrapEllipsis p_fontStyleObj={{fontSize:"16px", color:"#9f9f9f"}}>
                            {m_captureCardObj.cardName}
                          </LibraryReact.NowrapEllipsis>
                        </div>
                      }
                    </div>
                  )}
                </div>
              }
            </div>
          </div>
        </div>
      </div>
    );
  }
}));


const SelectedCaptureCardItem = inject("AdminMobx", "DatabaseMobx")(observer(
class SelectedCaptureCardItem extends Component { //props: p_captureCardIndex, p_captureCardObj, p_isOnlyItemTF, p_isLastItemTF
  onclick_remove_capture_card = () => {
    const p_captureCardObj = this.props.p_captureCardObj;

    const c_selectedCaptureTypeObj = this.props.AdminMobx.c_selectedCaptureTypeObj;
    const c_selectedCaptureTypeCardIDsArray = this.props.AdminMobx.c_selectedCaptureTypeCardIDsArray;

    const newSelectedCaptureTypeCardIDsArray = JSFUNC.remove_all_values_from_array(p_captureCardObj.cardID, c_selectedCaptureTypeCardIDsArray);
    const newSelectedCaptureTypeCardIDsComma = JSFUNC.convert_array_to_comma_list(newSelectedCaptureTypeCardIDsArray);

    const jsDescription = JSFUNC.js_description_from_action("AdminReact - SelectedCaptureCardItem", "onclick_remove_capture_card", [], []);
    const C_CallPhpTblUID = new JSPHP.ClassCallPhpTblUID(jsDescription);
    C_CallPhpTblUID.add_update("tbl_a_capture_types", c_selectedCaptureTypeObj.id, "card_ids_comma", newSelectedCaptureTypeCardIDsComma, "s");
    C_CallPhpTblUID.execute();
  }

  render() {
    const p_captureCardIndex = this.props.p_captureCardIndex;
    const p_captureCardObj = this.props.p_captureCardObj;
    const p_isOnlyItemTF = this.props.p_isOnlyItemTF;
    const p_isLastItemTF = this.props.p_isLastItemTF;

    const k_blueItemCollectionShellItemStylingObj = this.props.AdminMobx.k_blueItemCollectionShellItemStylingObj;
    const c_selectedCaptureTypeObj = this.props.AdminMobx.c_selectedCaptureTypeObj;
    const c_fieldMapOfCaptureType = this.props.DatabaseMobx.c_fieldMapOfCaptureType;

    return (
      <CEGeneralReact.CEDragToResortItemWithinCommaListWithinDbTbl
        p_canResortTF={true}
        p_uniqueString="adminCaptureCards"
        p_itemIndex={p_captureCardIndex}
        p_itemID={p_captureCardObj.cardID}
        p_itemSortColumnWidth={undefined}
        p_itemSortNumberFontClass={undefined}
        p_isOnlyItemTF={p_isOnlyItemTF}
        p_isLastItemTF={p_isLastItemTF}
        p_outerPadClass={k_blueItemCollectionShellItemStylingObj.outerPadClass}
        p_itemClass="displayFlexRow border bevelBorderColors borderRadius05 bgAlmostWhite"
        p_itemStyleObj={{height:k_blueItemCollectionShellItemStylingObj.rowHeightEm + "em"}}
        p_lastItemExtraDropZoneHeight={k_blueItemCollectionShellItemStylingObj.lastItemExtraDropZoneHeightEm + "em"}
        p_dragEntireItemTrueOnlySortNumberFalse={true}
        p_tblName="tbl_a_capture_types"
        p_tblRowID={c_selectedCaptureTypeObj.id}
        p_tblCommaListColumnName="card_ids_comma"
        p_commaList={c_selectedCaptureTypeObj.card_ids_comma}>
        <div className="flex11a displayFlexColumnVc lrPad">
          {p_captureCardObj.cardName}
        </div>
        <CaptureCardItemRenameVerticalDots p_captureCardObj={p_captureCardObj} />
        <div className="flex00a displayFlexColumnHcVc borderL1ddd" style={{flexBasis:"2em"}}>
          <CEGeneralReact.RemoveItemXWithRedHover
            p_title={"Remove Capture Card '" + p_captureCardObj.cardName + "' for " + c_fieldMapOfCaptureType.get("display_name") + " '" + c_selectedCaptureTypeObj.name + "'"}
            f_onClick={this.onclick_remove_capture_card}
          />
        </div>
      </CEGeneralReact.CEDragToResortItemWithinCommaListWithinDbTbl>
    );
  }
}));


const NotSelectedCaptureCardItem = inject("AdminMobx", "DatabaseMobx")(observer(
class NotSelectedCaptureCardItem extends Component { //props: p_captureCardObj
  onadd_capture_card = () => {
    const p_captureCardObj = this.props.p_captureCardObj;

    const c_selectedCaptureTypeObj = this.props.AdminMobx.c_selectedCaptureTypeObj;
    const c_selectedCaptureTypeCardIDsArray = this.props.AdminMobx.c_selectedCaptureTypeCardIDsArray;

    var newSelectedCaptureTypeCardIDsArray = JSFUNC.copy_array(c_selectedCaptureTypeCardIDsArray);
    newSelectedCaptureTypeCardIDsArray.push(p_captureCardObj.cardID);
    const newSelectedCaptureTypeCardIDsComma = JSFUNC.convert_array_to_comma_list(newSelectedCaptureTypeCardIDsArray);

    const jsDescription = JSFUNC.js_description_from_action("AdminReact - AdminSubtabCaptureCards", "onadd_capture_card", [], []);
    const C_CallPhpTblUID = new JSPHP.ClassCallPhpTblUID(jsDescription);
    C_CallPhpTblUID.add_update("tbl_a_capture_types", c_selectedCaptureTypeObj.id, "card_ids_comma", newSelectedCaptureTypeCardIDsComma, "s");
    C_CallPhpTblUID.execute();
  }

  render() {
    const p_captureCardObj = this.props.p_captureCardObj;

    const c_selectedCaptureTypeObj = this.props.AdminMobx.c_selectedCaptureTypeObj;
    const c_fieldMapOfCaptureType = this.props.DatabaseMobx.c_fieldMapOfCaptureType;

    return (
      <div class="displayFlexRow microFullMargin microTopPad microBottomPad border bevelBorderColors borderRadius05 bgLighterGray" style={{height:"2.4em"}}>
        <div className="flex11a displayFlexRowVc lrPad">
          {p_captureCardObj.cardName}
        </div>
        <CaptureCardItemRenameVerticalDots p_captureCardObj={p_captureCardObj} />
        <div className="flex00a displayFlexColumnHcVc lrPad">
          <CEGeneralReact.CEButton
            p_type="add"
            p_text="Add Card"
            p_title={"Take card '" + p_captureCardObj.cardName + "' off of the capture screen for " + c_fieldMapOfCaptureType.get("display_name") + " '" + c_selectedCaptureTypeObj.name + "'"}
            f_onClick={this.onadd_capture_card}
          />
        </div>
      </div>
    );
  }
}));


const CaptureCardItemRenameVerticalDots = inject("CaptureExecMobx")(observer(
class CaptureCardItemRenameVerticalDots extends Component { //props: p_captureCardObj
  onsave_changed_custom_capture_card_name = (i_newCaptureCardNameString) => {
    const p_captureCardObj = this.props.p_captureCardObj;

    const jsDescription = JSFUNC.js_description_from_action("AdminReact - CaptureCardItemRenameVerticalDots", "onsave_changed_custom_capture_card_name", ["i_newCaptureCardNameString"], [i_newCaptureCardNameString]);
    const C_CallPhpTblUID = new JSPHP.ClassCallPhpTblUID(jsDescription);

    const tblName = "tbl_a_capture_cards_custom_names";
    if(i_newCaptureCardNameString === p_captureCardObj.ceCardName) { //if the exact CE version of the card name was entered, delete the custom record to use the natural default CE card name
      C_CallPhpTblUID.add_delete(tblName, p_captureCardObj.cardID);
    }
    else { //insert/update custom name record
      const whereFieldNameOrNamesArray = ["id"];
      const whereValueOrValuesArray = [p_captureCardObj.cardID];
      const whereValueIdsbOrIdsbArray = ["i"];
      const fieldNameOrFieldNamesArray = ["name"];
      const valueOrValuesArray = [i_newCaptureCardNameString];
      const valueIdsbOrIdsbArray = ["s"];
      const oldValueOrValuesArray = undefined;
      const performUpdateIfExistsTF = true;
      C_CallPhpTblUID.add_update_existing_otherwise_insert(tblName, whereFieldNameOrNamesArray, whereValueOrValuesArray, whereValueIdsbOrIdsbArray, fieldNameOrFieldNamesArray, valueOrValuesArray, valueIdsbOrIdsbArray, oldValueOrValuesArray, performUpdateIfExistsTF);
    }

    C_CallPhpTblUID.execute();
  }

  render() {
    const p_captureCardObj = this.props.p_captureCardObj;

    const c_productStylingObj = this.props.CaptureExecMobx.c_productStylingObj;

    const captureCardRenameMenuItemsArrayOfObjs = [
      {
        displayName: "Rename Capture Card",
        confirmType: "inputText",
        confirmTitle: "Rename Capture Card",
        confirmTextInitialValue: p_captureCardObj.cardName,
        confirmButton1Name: "Rename",
        confirmMessage: "You can change the name of this " + c_productStylingObj.productName + " '" + p_captureCardObj.ceCardName + "' Capture Card to a custom name throughout the system",
        functionOnClickConfirmButton: this.onsave_changed_custom_capture_card_name
      }
    ];

    return (
      <div className="flex00a displayFlexColumnHcVc" style={{flexBasis:"2.2em"}}>
        <CEGeneralReact.VerticalDotsMenu
          p_menuItemsArrayOfObjs={captureCardRenameMenuItemsArrayOfObjs}
        />
      </div>
    );
  }
}));



//=================================================================================================================================================================
//=================================================================================================================================================================


export const AdminSubtabStages = inject("AdminMobx", "DatabaseMobx")(observer(
class AdminSubtabStages extends Component { //props: none
  ondrop_stage_pool_into_capture_type = (i_draggedStageID) => {
    const c_selectedCaptureTypeObj = this.props.AdminMobx.c_selectedCaptureTypeObj;
    const c_selectedCaptureTypeStageIDsArray = this.props.AdminMobx.c_selectedCaptureTypeStageIDsArray;

    if(!JSFUNC.in_array(i_draggedStageID, c_selectedCaptureTypeStageIDsArray)) { //must be adding a unique stageID to this capture type that is not already added
      const jsDescription = JSFUNC.js_description_from_action("AdminReact - AdminSubtabStages", "ondrop_stage_pool_into_capture_type", [], []);
      const C_CallPhpTblUID = new JSPHP.ClassCallPhpTblUID(jsDescription);
      const fieldNamesArray = ["capture_type_id", "stage_id", "sort", "max_num_days_in_stage_send_email_0_off", "gate_review_to_enter_stage_name", "gate_review_to_enter_stage_approval_divexec_user_ids_comma"];
      const valuesArray = [c_selectedCaptureTypeObj.id, i_draggedStageID, (c_selectedCaptureTypeStageIDsArray.length + 1), 0, "", ""];
      const idsbArray = ["i", "i", "i", "i", "s", "s"];
      C_CallPhpTblUID.add_insert("tbl_a_capture_types_stages", fieldNamesArray, valuesArray, idsbArray, "sort", ["capture_type_id"], [c_selectedCaptureTypeObj.id]);
      C_CallPhpTblUID.execute();
    }
  }

  onremove_all_stages_from_capture_type = () => {
    const c_selectedCaptureTypeExpandedCaptureTypeStagesArrayOfObjs = this.props.AdminMobx.c_selectedCaptureTypeExpandedCaptureTypeStagesArrayOfObjs;
    
    if(c_selectedCaptureTypeExpandedCaptureTypeStagesArrayOfObjs.length > 0) { //if there are any stages to remove
      const captureTypeStageRowIDsToDeleteArray = JSFUNC.get_column_vector_from_arrayOfObjs(c_selectedCaptureTypeExpandedCaptureTypeStagesArrayOfObjs, "id");

      const jsDescription = JSFUNC.js_description_from_action("AdminReact - AdminSubtabStages", "onremove_all_stages_from_capture_type", [], []);
      const C_CallPhpTblUID = new JSPHP.ClassCallPhpTblUID(jsDescription);
      C_CallPhpTblUID.add_delete("tbl_a_capture_types_stages", captureTypeStageRowIDsToDeleteArray);
      C_CallPhpTblUID.execute();
    }
  }

  onswitch_restrict_advance_capture_stage = (i_newValue01) => {
    this.props.AdminMobx.a_update_tbl_a_company_fields("restrict_advance_capture_stage_01", i_newValue01, "i");
  }

  onchange_restrict_advance_capture_stage_users = (i_selectedUserPerEmailIDsComma) => {
    this.props.AdminMobx.a_update_tbl_a_company_fields("restrict_advance_capture_stage_user_per_email_ids_comma", i_selectedUserPerEmailIDsComma, "s");
  }

  render() {
    const c_selectedCaptureTypeObj = this.props.AdminMobx.c_selectedCaptureTypeObj;
    const c_selectedCaptureTypeExistsTF = this.props.AdminMobx.c_selectedCaptureTypeExistsTF;
    const c_selectedCaptureTypeStageIDsArray = this.props.AdminMobx.c_selectedCaptureTypeStageIDsArray;
    const c_selectedCaptureTypeExpandedCaptureTypeStagesArrayOfObjs = this.props.AdminMobx.c_selectedCaptureTypeExpandedCaptureTypeStagesArrayOfObjs;
    const o_tbl_a_capture_types_stages = this.props.DatabaseMobx.o_tbl_a_capture_types_stages;
    const c_adminSortedExpandedStagesArrayOfObjs = this.props.DatabaseMobx.c_adminSortedExpandedStagesArrayOfObjs;
    const c_fieldMapOfStage = this.props.DatabaseMobx.c_fieldMapOfStage;
    const c_fieldMapOfCaptureType = this.props.DatabaseMobx.c_fieldMapOfCaptureType;
    const c_companyRestrictAdvanceCaptureStage01 = this.props.DatabaseMobx.c_companyRestrictAdvanceCaptureStage01;
    const c_companyRestrictAdvanceCaptureStageTF = this.props.DatabaseMobx.c_companyRestrictAdvanceCaptureStageTF;
    const c_companyRestrictAdvanceCaptureStageUserPerEmailIDsComma = this.props.DatabaseMobx.c_companyRestrictAdvanceCaptureStageUserPerEmailIDsComma;
    const c_selectStageType1234567FieldTypeObj = this.props.DatabaseMobx.c_selectStageType1234567FieldTypeObj;

    const stageFieldDisplayName = c_fieldMapOfStage.get("display_name");
    const captureTypeFieldDisplayName = c_fieldMapOfCaptureType.get("display_name");

    const numStagesAdded = c_selectedCaptureTypeStageIDsArray.length;

    const functionDeleteStageFromPoolCleanup = (i_C_CallPhpTblUID, i_stageRowObj) => {
      const stageID = i_stageRowObj.id; //deleted stageID from tbl_a_stages_pool

      //find all assignments of this stageID in tbl_a_capture_types_stages and remove each row with per-capture_type resorting
      for(let [captureTypeStageRecordID, captureTypeStageMap] of o_tbl_a_capture_types_stages) {
        if(captureTypeStageMap.get("stage_id") === stageID) {
          const captureTypeID = captureTypeStageMap.get("capture_type_id");
          i_C_CallPhpTblUID.add_delete("tbl_a_capture_types_stages", captureTypeStageRecordID, "sort", ["capture_type_id"], [captureTypeID]);
        }
      }
    }

    const aedTableObj = {
      tblName: "tbl_a_stages_pool",
      dragToResortFieldDbName: "admin_sort",
      canAlwaysDragResortTF: true,
      initialSortedFieldDbName: "admin_sort",
      tableWidth: "100%",
      itemName: stageFieldDisplayName,
      deleteItemNameFieldDbName: "name",
      canAddItemsFromAddColumnTF: c_selectedCaptureTypeExistsTF,
      idsAlreadyAddedArray: c_selectedCaptureTypeStageIDsArray,
      itemDeleteFunctionsArray: [functionDeleteStageFromPoolCleanup],
      fieldsArrayOfObjs: [
        {width:"300em", dbName:"name", displayName:stageFieldDisplayName + " Name", fieldTypeObj:this.props.DatabaseMobx.c_genericTextFieldTypeObj, initialValue:"", cellHoverTF:true, requiredNotEmptyTF:true},
        {width:"300em", dbName:"pa1_a2_as3_csw4_csl5_cnsnb6_cnsgc7", displayName:stageFieldDisplayName + " Type", fieldTypeObj:c_selectStageType1234567FieldTypeObj, initialValue:1, cellHoverTF:true, requiredNotEmptyTF:true},
        {width:"100em", dbName:"color", displayName:"Divexec Color", fieldTypeObj:this.props.DatabaseMobx.c_genericColorFieldTypeObj, initialValue:"999999", cellHoverTF:true},
        {width:"100em", dbName:"hover_text", displayName:"Hover Text", fieldTypeObj:this.props.DatabaseMobx.c_genericTextareaFieldTypeObj, initialValue:"", cellHoverTF:true},
        {width:"3em", dbName:"admin_sort", displayName:"Admin Sort", fieldTypeObj:this.props.DatabaseMobx.c_genericIntPositiveFieldTypeObj, initialValue:1}
      ]
    };

    return(
      <div className="flex11a displayFlexColumn">
        <AdminCaptureTypeSelectionBoxes />
        {(stageFieldDisplayName !== "Stage") &&
          <>
            <LibraryReact.DivFont p_class="smallTopMargin textCenter" p_fontClass="font12 fontBold fontBlue">
              {"Stage is referred to as '" + stageFieldDisplayName + "' in this system"}
            </LibraryReact.DivFont>
            <LibraryReact.DivFont p_class="textCenter" p_fontClass="font09 fontTextLightester">
              {"This can be edited on the System Setup 'Details/Dates Fields' subtab"}
            </LibraryReact.DivFont>
          </>
        }
        <div className="flex11a displayFlexRow">
          <div className="flex11a yScroll medFullPad" style={{flexBasis:"130em"}}>
            <LibraryReact.DivFont p_class="smallBottomMargin" p_fontClass="font14 fontItalic">
              {stageFieldDisplayName + " Pool: Every unique " + stageFieldDisplayName + " used in every " + captureTypeFieldDisplayName}
            </LibraryReact.DivFont>
            <CEComplexReact.AddEditDeleteTable
              p_dataArrayOfObjs={c_adminSortedExpandedStagesArrayOfObjs}
              p_aedTableObj={aedTableObj}
              f_onClickAddItem={this.ondrop_stage_pool_into_capture_type}
            />
            <div className="tbHugeMargin borderT1bbb" />
            <div className="lrMedMargin border1bbb bgLightestGray bigFullPad" style={{maxWidth:"50em"}}>
              <LibraryReact.DivFont p_class="smallBottomMargin textCenter" p_fontClass="font11 fontBold fontTextLight">
                {"Use this switch to restrict the ability to advance the Stage of a Capture to select Users"}
              </LibraryReact.DivFont>
              <div className="lrMedMargin">
                <CEGeneralReact.GenericInputOrSelectFromInputType
                  p_fieldTypeObj={this.props.DatabaseMobx.create_verticalswitch_field_type_obj_from_value_array_and_display_array("NAICS Inclusion Option", [0, 1], false, ["[default] Anyone that can access a particular Capture can advance its Stage", "Only selected Users below can advance Capture Stages"], 2)}
                  p_valueRaw={c_companyRestrictAdvanceCaptureStage01}
                  f_onChangeOrOnSelect={this.onswitch_restrict_advance_capture_stage}
                />
              </div>
              {(c_companyRestrictAdvanceCaptureStageTF) &&
                <div className="bigTopMargin border1bbb borderRadius05 bgLightesterGray medFullPad">
                  <CEGeneralReact.CaptureExecFieldEditSaveCancel
                    p_ceEditItemString="adminStagesRestrictUsers"
                    p_fieldDisplayName={"Only Users who can advance " + stageFieldDisplayName}
                    p_fieldTypeObj={this.props.DatabaseMobx.c_selectMultiUsersPerEmailNotDeactivatedFieldTypeObj}
                    p_valueRaw={c_companyRestrictAdvanceCaptureStageUserPerEmailIDsComma}
                    p_valueIsEditableTFU={true}
                    p_containerClass="tbPad"
                    p_fieldClass="fontBlue"
                    p_fieldWidth="40%"
                    f_onSaveChanged={this.onchange_restrict_advance_capture_stage_users}
                  />
                </div>
              }
            </div>
            <div className="tbHugeMargin" />
          </div>
          <div className="flex11a xyScroll medFullPad" style={{flexBasis:"100em"}}>
            <div className="flex00a displayFlexRow">
              <div className="flex11a" style={{flexBasis:"100em"}} />
              <div className="flex11a displayFlexColumn" style={{flexBasis:"500em"}}>
                <div className="flex00a displayFlexRow">
                  <div className="flex00a displayFlexColumn" style={{flexBasis:"2em"}}>
                    <LibraryReact.DivFont p_fontClass="fontBold fontBlue">
                      {"LE: "}
                    </LibraryReact.DivFont>
                  </div>
                  <div className="flex11a displayFlexColumn">
                    <LibraryReact.DivFont p_fontClass="fontItalic fontTextLighter">
                      {"('Languish Email', active if set with # days, 0=off) - sends an email to the Capture Managers if a Capture has been in the same " + stageFieldDisplayName + " for the specified number of days."}
                    </LibraryReact.DivFont>
                  </div>
                </div>
                <div className="flex00a displayFlexRow">
                  <div className="flex00a displayFlexColumn" style={{flexBasis:"2em"}}>
                    <LibraryReact.DivFont p_fontClass="fontBold fontBlue">
                      {"GR: "}
                    </LibraryReact.DivFont>
                  </div>
                  <div className="flex11a displayFlexColumn">
                    <LibraryReact.DivFont p_fontClass="fontItalic fontTextLighter">
                      {"('Gate Review') - if Divexec User(s) are selected for a Gate Review, one of them must make an approval decision before the Capture can advance into that " + stageFieldDisplayName + ". Can only be applied to an Active " + stageFieldDisplayName + "."}
                    </LibraryReact.DivFont>
                  </div>
                </div>
              </div>
            </div>
            <BlueItemCollectionShell
              p_isReceivingTF={true}
              p_title={stageFieldDisplayName + " Timeline for captures with " + captureTypeFieldDisplayName + " '" + c_selectedCaptureTypeObj.name + "'"}
              p_dropUniqueString="AddEditDeleteTableRow_tbl_a_stages_pool"
              p_dropNotAllowedDraggerIDsArray={c_selectedCaptureTypeStageIDsArray}
              p_dropMessage="[Drag/drop stages from the pool]"
              p_dropAllowDropMessage="[Drop stage to add to Stage Timeline]"
              p_dropNotAllowDropMessage="[Cannot have duplicate stages in a Stage Timeline]"
              f_onClickSetAsReceiving={undefined}
              f_onDrop={this.ondrop_stage_pool_into_capture_type}
              f_onRemoveAllItems={this.onremove_all_stages_from_capture_type}>
              {c_selectedCaptureTypeExpandedCaptureTypeStagesArrayOfObjs.map((m_expandedCaptureTypeStageObj, m_index) =>
                <AddedStageItem
                  key={c_selectedCaptureTypeObj.id + "_" + m_expandedCaptureTypeStageObj.id}
                  p_selectedCaptureTypeObj={c_selectedCaptureTypeObj}
                  p_expandedCaptureTypeStageObj={m_expandedCaptureTypeStageObj}
                  p_isOnlyItemTF={(numStagesAdded === 1)}
                  p_isLastItemTF={(m_index === (numStagesAdded - 1))}
                />
              )}
            </BlueItemCollectionShell>
          </div>
        </div>
      </div>
    );
  }
}));


export const AddedStageItem = inject("AdminMobx", "DatabaseMobx")(observer(
class AddedStageItem extends Component { //props: p_selectedCaptureTypeObj, p_expandedCaptureTypeStageObj, p_isOnlyItemTF, p_isLastItemTF
  constructor(props) {
    super(props);
    this.state = {
      s_editingAddedStageRecordTF: false
    };
  }

  onclick_stage_item_to_edit = () => {
    this.setState({s_editingAddedStageRecordTF:true});
  }

  onclick_close_stage_item_to_edit = () => {
    this.setState({s_editingAddedStageRecordTF:false});
  }

  onclick_remove_stage_from_capture_type = () => {
    const p_expandedCaptureTypeStageObj = this.props.p_expandedCaptureTypeStageObj;
    const p_selectedCaptureTypeObj = this.props.p_selectedCaptureTypeObj;

    const jsDescription = JSFUNC.js_description_from_action("AdminReact - AddedStageItem", "onclick_remove_stage_from_capture_type", [], []);
    const C_CallPhpTblUID = new JSPHP.ClassCallPhpTblUID(jsDescription);
    C_CallPhpTblUID.add_delete("tbl_a_capture_types_stages", p_expandedCaptureTypeStageObj.id, "sort", ["capture_type_id"], [p_selectedCaptureTypeObj.id]);
    C_CallPhpTblUID.execute();
  }

  render() {
    const s_editingAddedStageRecordTF = this.state.s_editingAddedStageRecordTF;

    const p_selectedCaptureTypeObj = this.props.p_selectedCaptureTypeObj;
    const p_expandedCaptureTypeStageObj = this.props.p_expandedCaptureTypeStageObj;
    const p_isOnlyItemTF = this.props.p_isOnlyItemTF;
    const p_isLastItemTF = this.props.p_isLastItemTF;

    const k_blueItemCollectionShellItemStylingObj = this.props.AdminMobx.k_blueItemCollectionShellItemStylingObj;
    const c_fieldMapOfCaptureManagers = this.props.DatabaseMobx.c_fieldMapOfCaptureManagers;
    const c_fieldMapOfCaptureType = this.props.DatabaseMobx.c_fieldMapOfCaptureType;
    const c_fieldMapOfStage = this.props.DatabaseMobx.c_fieldMapOfStage;

    const captureManagerFieldDisplayName = c_fieldMapOfCaptureManagers.get("display_name");
    const captureTypeFieldDisplayName = c_fieldMapOfCaptureType.get("display_name");
    const stageFieldDisplayName = c_fieldMapOfStage.get("display_name");

    const languishEmailNumDaysText = p_expandedCaptureTypeStageObj.max_num_days_in_stage_send_email_0_off + " " + JSFUNC.plural(p_expandedCaptureTypeStageObj.max_num_days_in_stage_send_email_0_off, "day", "days");
    const gateReviewerNamesSlashesText = p_expandedCaptureTypeStageObj.gateReviewToEnterStageApprovalDivexecUserNamesArray.join("/");

    //hover text for entire Stage Item row
    var stageItemTitle = stageFieldDisplayName + " Name: '" + p_expandedCaptureTypeStageObj.name + "'";
    stageItemTitle += "\n" + stageFieldDisplayName + " Type: '" + p_expandedCaptureTypeStageObj.stageTypeName + "'";
    stageItemTitle += "\n" + "Divexec Color: #" + p_expandedCaptureTypeStageObj.color;
    stageItemTitle += "\n" + "Hover Text: '" + p_expandedCaptureTypeStageObj.hover_text + "'";

    stageItemTitle += "\n" + "Languish Email: "
    if(p_expandedCaptureTypeStageObj.maxNumDaysInStageSendEmailIsSetTF) {
      stageItemTitle += "Email/notification sent to " + captureManagerFieldDisplayName + " after Capture has been in '" + p_expandedCaptureTypeStageObj.name + "' for " + languishEmailNumDaysText;
    }
    else {
      stageItemTitle += "--none--";
    }

    stageItemTitle += "\n" + "Gate Review: ";
    if(p_expandedCaptureTypeStageObj.gateReviewToEnterStageIsSetTF) {
      stageItemTitle += "'" + p_expandedCaptureTypeStageObj.gate_review_to_enter_stage_name + "' Capture must be approved by '" + gateReviewerNamesSlashesText + "' to advance into " + stageFieldDisplayName + " '" + p_expandedCaptureTypeStageObj.name + "'";
    }
    else {
      stageItemTitle += "--not required--";
    }

    stageItemTitle += "\n\n[Click to edit " + stageFieldDisplayName + " settings]";

    //display for languish email setting
    var languishEmailTextComponent = null;
    if(p_expandedCaptureTypeStageObj.maxNumDaysInStageSendEmailIsSetTF) {
      languishEmailTextComponent = (<><span className="fontBold fontBlue">{"LE: "}</span><span className="">{languishEmailNumDaysText}</span></>);
    }
    else {
      languishEmailTextComponent = (<span className="fontItalic fontTextLightest">{"LE: -"}</span>);
    }

    //display for gate review setting
    var gateReviewTextComponent = null;
    if(p_expandedCaptureTypeStageObj.gateReviewToEnterStageIsSetTF) {
      gateReviewTextComponent = (<><span className="fontBold fontBlue">{"GR: "}</span><span className="">{p_expandedCaptureTypeStageObj.gate_review_to_enter_stage_name + " [" + gateReviewerNamesSlashesText + "]"}</span></>);
    }
    else {
      gateReviewTextComponent = (<span className="fontItalic fontTextLightest">{"GR: -"}</span>);
    }

    return(
      <CEGeneralReact.CEDragToResortItemWithinDbTbl
        p_canResortTF={true}
        p_uniqueString="adminCaptureTypeStage"
        p_itemID={p_expandedCaptureTypeStageObj.id}
        p_itemSort={p_expandedCaptureTypeStageObj.sort}
        p_itemSortColumnWidth="2em"
        p_itemSortNumberFontClass={undefined}
        p_isOnlyItemTF={p_isOnlyItemTF}
        p_isLastItemTF={p_isLastItemTF}
        p_outerPadClass={k_blueItemCollectionShellItemStylingObj.outerPadClass}
        p_itemClass="displayFlexRow border bevelBorderColors borderRadius05 bgAlmostWhite hoverLighterBlueGradient"
        p_itemStyleObj={{height:k_blueItemCollectionShellItemStylingObj.rowHeightEm + "em"}}
        p_lastItemExtraDropZoneHeight={k_blueItemCollectionShellItemStylingObj.lastItemExtraDropZoneHeightEm + "em"}
        p_dragEntireItemTrueOnlySortNumberFalse={true}
        p_tblName="tbl_a_capture_types_stages"
        p_tblSortFieldDbName="sort"
        p_filterFieldNamesArray={["capture_type_id"]}
        p_filterValuesArray={[p_selectedCaptureTypeObj.id]}>
        <div
          className="flex11a displayFlexRow cursorPointer"
          title={stageItemTitle}
          onClick={this.onclick_stage_item_to_edit}>
          <div className="flex00a displayFlexColumnHcVc smallLeftMargin">
            <div className="border bevelBorderColors" style={{width:"0.5em", height:"1em", background:"#" + p_expandedCaptureTypeStageObj.color}} />
          </div>
          <div className="flex11a displayFlexRowVc lrPad" style={{flexBasis:"175em"}}>
            <LibraryReact.NowrapEllipsis p_fontClass="">
              {p_expandedCaptureTypeStageObj.name}
            </LibraryReact.NowrapEllipsis>
          </div>
          <div className="flex11a displayFlexRowVc lrPad" style={{flexBasis:"100em"}}>
            <LibraryReact.NowrapEllipsis p_fontClass="fontItalic fontTextLighter">
              {p_expandedCaptureTypeStageObj.stageTypeName}
            </LibraryReact.NowrapEllipsis>
          </div>
          <div className="flex00a displayFlexRowVc lrPad" style={{flexBasis:"7em"}}>
            <LibraryReact.NowrapEllipsis>
              {languishEmailTextComponent}
            </LibraryReact.NowrapEllipsis>
          </div>
          <div className="flex11a displayFlexRowVc lrPad" style={{flexBasis:"150em"}}>
            <LibraryReact.NowrapEllipsis>
              {gateReviewTextComponent}
            </LibraryReact.NowrapEllipsis>
          </div>
        </div>
        <div className="flex00a displayFlexColumnHcVc borderL1ddd" style={{flexBasis:"2em"}}>
          <CEGeneralReact.RemoveItemXWithRedHover
            p_title={"Remove " + stageFieldDisplayName + " '" + p_expandedCaptureTypeStageObj.name + "' from " + stageFieldDisplayName + " timeline for " + captureTypeFieldDisplayName + " '" + p_selectedCaptureTypeObj.name + "'"}
            f_onClick={this.onclick_remove_stage_from_capture_type}
          />
        </div>
        {(s_editingAddedStageRecordTF) &&
          <AddedStageItemEditFloatingBox
            p_selectedCaptureTypeObj={p_selectedCaptureTypeObj}
            p_expandedCaptureTypeStageObj={p_expandedCaptureTypeStageObj}
            f_onClickClose={this.onclick_close_stage_item_to_edit}
          />
        }
      </CEGeneralReact.CEDragToResortItemWithinDbTbl>
    );
  }
}));



const AddedStageItemEditFloatingBox = inject("DatabaseMobx")(observer(
class AddedStageItemEditFloatingBox extends Component { //props: p_selectedCaptureTypeObj, p_expandedCaptureTypeStageObj, f_onClickClose
  onsave_max_num_days_in_stage_send_email_0_off = (i_newValue) => {
    this.update_capture_type_stage_record_field_value("max_num_days_in_stage_send_email_0_off", i_newValue, "i");
  }

  onsave_gate_review_to_enter_stage_name = (i_newValue) => {
    this.update_capture_type_stage_record_field_value("gate_review_to_enter_stage_name", i_newValue, "s");
  }

  onsave_gate_review_to_enter_stage_approval_divexec_user_ids_comma = (i_newValue) => {
    this.update_capture_type_stage_record_field_value("gate_review_to_enter_stage_approval_divexec_user_ids_comma", i_newValue, "s");
  }

  update_capture_type_stage_record_field_value = (i_fieldName, i_value, i_idsb) => {
    const p_expandedCaptureTypeStageObj = this.props.p_expandedCaptureTypeStageObj;

    const jsDescription = JSFUNC.js_description_from_action("AdminReact - AddedStageItemEditFloatingBox", "update_capture_type_stage_record_field_value", ["i_fieldName", "i_value", "i_idsb"], [i_fieldName, i_value, i_idsb]);
    const C_CallPhpTblUID = new JSPHP.ClassCallPhpTblUID(jsDescription);
    C_CallPhpTblUID.add_update("tbl_a_capture_types_stages", p_expandedCaptureTypeStageObj.id, i_fieldName, i_value, i_idsb);
    C_CallPhpTblUID.execute();
  }

  render() {
    const p_selectedCaptureTypeObj = this.props.p_selectedCaptureTypeObj;
    const p_expandedCaptureTypeStageObj = this.props.p_expandedCaptureTypeStageObj;
    const f_onClickClose = this.props.f_onClickClose;

    const c_fieldMapOfCaptureManagers = this.props.DatabaseMobx.c_fieldMapOfCaptureManagers;
    const c_fieldMapOfCaptureType = this.props.DatabaseMobx.c_fieldMapOfCaptureType;
    const c_fieldMapOfStage = this.props.DatabaseMobx.c_fieldMapOfStage;
    const c_genericTextFieldTypeObj = this.props.DatabaseMobx.c_genericTextFieldTypeObj;
    const c_genericIntPositiveFieldTypeObj = this.props.DatabaseMobx.c_genericIntPositiveFieldTypeObj;
    const c_selectMultiUsersWithDivexecPowerFieldTypeObj = this.props.DatabaseMobx.c_selectMultiUsersWithDivexecPowerFieldTypeObj;

    const captureManagersFieldDisplayName = c_fieldMapOfCaptureManagers.get("display_name");
    const captureTypeFieldDisplayName = c_fieldMapOfCaptureType.get("display_name");
    const stageFieldDisplayName = c_fieldMapOfStage.get("display_name");

    const stageItemFieldContainerClass = undefined;
    const stageItemFieldClass = "fontBlue";
    const stageItemFieldWidth = "15em";

    return(
      <CEGeneralReact.FloatingBoxWithSaveCancel
        p_trblFlag="addEditDeleteTableEditItem"
        p_title="Editing Stage Settings"
        f_onClickSave={f_onClickClose}>
        <div className="flex11a yScroll medFullPad">
          <div className="displayFlexColumnHcVc border1ddd bgLighterGray smallFullPad textCenter">
            <LibraryReact.DivFont p_fontClass="font11 fontTextLight">
              {stageFieldDisplayName + ": " + p_expandedCaptureTypeStageObj.name}
            </LibraryReact.DivFont>
            <LibraryReact.DivFont p_class="microTopMargin" p_fontClass="fontBold fontDarkOrange">
              {captureTypeFieldDisplayName + ": " + p_selectedCaptureTypeObj.name}
            </LibraryReact.DivFont>
          </div>
          <LibraryReact.DivFont p_class="medTopMargin smallBottomMargin" p_fontClass="fontItalic fontTextLighter">
            {"Use this 'Languish Email' field to set up an email reminder to the " + captureManagersFieldDisplayName + " when a capture has been in this " + stageFieldDisplayName + " for a certain number of days. Set to 0 to turn off the email reminder."}
          </LibraryReact.DivFont>
          <CEGeneralReact.CaptureExecFieldEditSaveCancel
            p_ceEditItemString={"adminStage_stageID" + p_expandedCaptureTypeStageObj.id + "max_num_days_in_stage_send_email_0_off"}
            p_fieldDisplayName={"Languish Email max # Days in " + stageFieldDisplayName + " before Email Reminder (0 = off)"}
            p_fieldTypeObj={c_genericIntPositiveFieldTypeObj}
            p_valueRaw={p_expandedCaptureTypeStageObj.max_num_days_in_stage_send_email_0_off}
            p_valueIsEditableTFU={true}
            p_containerClass={stageItemFieldContainerClass}
            p_fieldClass={stageItemFieldClass}
            p_fieldWidth={stageItemFieldWidth}
            f_onSaveChanged={this.onsave_max_num_days_in_stage_send_email_0_off}
          />
          <LibraryReact.DivFont p_class="hugeTopMargin smallBottomMargin" p_fontClass="fontItalic fontTextLighter">
            {"Use this 'Gate Review' field to require the Divexec User(s) selected below to approve a Capture before it can advance into this " + stageFieldDisplayName + "."}
          </LibraryReact.DivFont>
          <CEGeneralReact.CaptureExecFieldEditSaveCancel
            p_ceEditItemString={"adminStage_stageID" + p_expandedCaptureTypeStageObj.id + "gate_review_to_enter_stage_name"}
            p_fieldDisplayName={"Gate Review Name"}
            p_fieldTypeObj={c_genericTextFieldTypeObj}
            p_valueRaw={p_expandedCaptureTypeStageObj.gate_review_to_enter_stage_name}
            p_valueIsEditableTFU={true}
            p_containerClass={stageItemFieldContainerClass}
            p_fieldClass={stageItemFieldClass}
            p_fieldWidth={stageItemFieldWidth}
            f_onSaveChanged={this.onsave_gate_review_to_enter_stage_name}
          />
          <CEGeneralReact.CaptureExecFieldEditSaveCancel
            p_ceEditItemString={"adminStage_stageID" + p_expandedCaptureTypeStageObj.id + "gate_review_to_enter_stage_approval_divexec_user_ids_comma"}
            p_fieldDisplayName={"Gate Review approver(s)"}
            p_fieldTypeObj={c_selectMultiUsersWithDivexecPowerFieldTypeObj}
            p_valueRaw={p_expandedCaptureTypeStageObj.gate_review_to_enter_stage_approval_divexec_user_ids_comma}
            p_valueIsEditableTFU={true}
            p_containerClass={stageItemFieldContainerClass}
            p_fieldClass={stageItemFieldClass}
            p_fieldWidth={stageItemFieldWidth}
            f_onSaveChanged={this.onsave_gate_review_to_enter_stage_approval_divexec_user_ids_comma}
          />
        </div>
      </CEGeneralReact.FloatingBoxWithSaveCancel>
    );
  }
}));






//=================================================================================================================================================================
//=================================================================================================================================================================





export const AdminSubtabDetailsCardGroups = inject("CaptureExecMobx", "AdminMobx", "DatabaseMobx")(observer(
class AdminSubtabDetailsCardGroups extends Component { //props: none
  ondrop_details_card_group_into_capture_type = (i_draggedDetailsCardGroupID) => {
    const o_selectedCaptureTypeID = this.props.AdminMobx.o_selectedCaptureTypeID;
    const c_selectedCaptureTypeDetailsCardGroupIDsArray = this.props.AdminMobx.c_selectedCaptureTypeDetailsCardGroupIDsArray;

    if(!JSFUNC.in_array(i_draggedDetailsCardGroupID, c_selectedCaptureTypeDetailsCardGroupIDsArray)) { //must be adding a unique details card group to this capture type that is not already added
      var newSelectedCaptureTypeDetailsCardGroupIDsArray = JSFUNC.copy_array(c_selectedCaptureTypeDetailsCardGroupIDsArray);
      newSelectedCaptureTypeDetailsCardGroupIDsArray.push(i_draggedDetailsCardGroupID);
      const newSelectedCaptureTypeDetailsCardGroupIDsComma = JSFUNC.convert_array_to_comma_list(newSelectedCaptureTypeDetailsCardGroupIDsArray);

      const jsDescription = JSFUNC.js_description_from_action("AdminReact - AdminSubtabDetailsCardGroups", "ondrop_details_card_group_into_capture_type", ["i_draggedDetailsCardGroupID"], [i_draggedDetailsCardGroupID]);
      const C_CallPhpTblUID = new JSPHP.ClassCallPhpTblUID(jsDescription);
      C_CallPhpTblUID.add_update("tbl_a_capture_types", o_selectedCaptureTypeID, "details_group_ids_comma", newSelectedCaptureTypeDetailsCardGroupIDsComma, "s");
      C_CallPhpTblUID.execute();
    }
  }

  onremove_all_details_card_groups_from_capture_type = () => {
    const o_selectedCaptureTypeID = this.props.AdminMobx.o_selectedCaptureTypeID;
    const c_selectedCaptureTypeDetailsCardGroupIDsArray = this.props.AdminMobx.c_selectedCaptureTypeDetailsCardGroupIDsArray;
    if(c_selectedCaptureTypeDetailsCardGroupIDsArray.length > 0) {
      const jsDescription = JSFUNC.js_description_from_action("AdminReact - AdminSubtabDetailsCardGroups", "onremove_all_details_card_groups_from_capture_type", [], []);
      const C_CallPhpTblUID = new JSPHP.ClassCallPhpTblUID(jsDescription);
      C_CallPhpTblUID.add_update("tbl_a_capture_types", o_selectedCaptureTypeID, "details_group_ids_comma", "", "s");
      C_CallPhpTblUID.execute();
    }
  }

  render() {
    const o_mediaQueryFlag = this.props.CaptureExecMobx.o_mediaQueryFlag;
    const c_selectedCaptureTypeObj = this.props.AdminMobx.c_selectedCaptureTypeObj;
    const c_selectedCaptureTypeExistsTF = this.props.AdminMobx.c_selectedCaptureTypeExistsTF;
    const c_selectedCaptureTypeDetailsCardGroupIDsArray = this.props.AdminMobx.c_selectedCaptureTypeDetailsCardGroupIDsArray;
    const c_selectedCaptureTypeDetailsCardGroupsArrayOfObjs = this.props.AdminMobx.c_selectedCaptureTypeDetailsCardGroupsArrayOfObjs;
    const o_tbl_a_capture_types = this.props.DatabaseMobx.o_tbl_a_capture_types;
    const o_tbl_a_capture_types_details_fields = this.props.DatabaseMobx.o_tbl_a_capture_types_details_fields;
    const c_cardNameDetails = this.props.DatabaseMobx.c_cardNameDetails;
    const c_fieldMapOfCaptureType = this.props.DatabaseMobx.c_fieldMapOfCaptureType;

    const numDetailsCardGroupsAdded = c_selectedCaptureTypeDetailsCardGroupIDsArray.length;

    const functionDeleteDetailsGroupFromPoolCleanup = (i_C_CallPhpTblUID, i_detailsGroupRowObj) => {
      const groupID = i_detailsGroupRowObj.id; //deleted groupID

      //remove all details fields assigned to this group in any capture type
      const captureTypeDetailsFieldsIDsToDeleteArray = JSFUNC.get_column_vector_from_mapOfMaps_matching_field_value(o_tbl_a_capture_types_details_fields, "group_id", groupID, "id");
      i_C_CallPhpTblUID.add_delete("tbl_a_capture_types_details_fields", captureTypeDetailsFieldsIDsToDeleteArray); //no resorting needed since all fields from the entire group will be removed

      //find any assignments of this groupID on the details card (tbl_a_capture_types details_group_ids_comma column) for any capture type and remove them
      for(let [captureTypeID, captureTypeMap] of o_tbl_a_capture_types) {
        var oldDetailsGroupIDsComma = captureTypeMap.get("details_group_ids_comma");
        var newDetailsGroupIDsComma = JSFUNC.remove_all_int_values_from_int_comma_list(groupID, oldDetailsGroupIDsComma);
        if(newDetailsGroupIDsComma !== oldDetailsGroupIDsComma) { //if the groupID was removed, update the field with the changed comma list of remaining fieldIDs
          i_C_CallPhpTblUID.add_update("tbl_a_capture_types", captureTypeID, "details_group_ids_comma", newDetailsGroupIDsComma, "s");
        }
      }
    }

    const aedTableObj = {
      tblName: "tbl_a_details_groups_pool",
      dragToResortFieldDbName: "admin_sort",
      canAlwaysDragResortTF: true,
      initialSortedFieldDbName: "admin_sort",
      tableWidth: "100%",
      itemName: c_cardNameDetails + " Card Group",
      deleteItemNameFieldDbName: "name",
      canAddItemsFromAddColumnTF: c_selectedCaptureTypeExistsTF,
      idsAlreadyAddedArray: c_selectedCaptureTypeDetailsCardGroupIDsArray,
      itemDeleteFunctionsArray: [functionDeleteDetailsGroupFromPoolCleanup],
      fieldsArrayOfObjs: [
        {width:"100em", dbName:"name", displayName:"Group Name", fieldTypeObj:this.props.DatabaseMobx.c_genericTextFieldTypeObj, initialValue:"", cellHoverTF:true, requiredNotEmptyTF:true},
        {width:"5em", fixedWidthTF:true, dbName:"group_name_styling_string_comma", displayName:"Style", fieldTypeObj:this.props.DatabaseMobx.c_genericStylingStringAdminFontDarkGrayBoldFieldTypeObj, initialValue:"", cellCenterTF:true, cellHoverTF:true, cellDisplayBlankIfNotFilledOutTF:true},
        {width:"3em", dbName:"admin_sort", displayName:"Admin Sort", fieldTypeObj:this.props.DatabaseMobx.c_genericIntPositiveFieldTypeObj, initialValue:1}
      ]
    };

    const includeExampleDetailsCardLayoutTF = (o_mediaQueryFlag >= 4);
    const detailsNumGroupsPerRow = ((o_mediaQueryFlag >= 5) ? (3) : (2));
    const groupIDsRCMatrix = JSFUNC.get_rc_matrix_from_num_items_and_columns(numDetailsCardGroupsAdded, detailsNumGroupsPerRow);

    return(
      <div className="flex11a displayFlexColumn">
        <AdminCaptureTypeSelectionBoxes />
        <div className="flex11a displayFlexRow">
          <div className="flex11a yScroll medFullPad" style={{flexBasis:"100em"}}>
            <LibraryReact.DivFont p_class="smallBottomMargin" p_fontClass="font14 fontItalic">
              {"All unique " + c_cardNameDetails + " Card Groups used in every " + c_fieldMapOfCaptureType.get("display_name")}
            </LibraryReact.DivFont>
            <CEComplexReact.AddEditDeleteTable
              p_dataArrayOfObjs={this.props.AdminMobx.c_detailsCardGroupsPoolArrayOfObjs}
              p_aedTableObj={aedTableObj}
              f_onClickAddItem={this.ondrop_details_card_group_into_capture_type}
            />
          </div>
          <div className="flex11a displayFlexRow" style={{flexBasis:((includeExampleDetailsCardLayoutTF) ? ("200em") : ("100em"))}}>
            <div className="flex11a yScroll yScrollBottomPad lrPad" style={{flexBasis:"100em"}}>
              <BlueItemCollectionShell
                p_isReceivingTF={true}
                p_title={c_cardNameDetails + " Card Groups for captures with " + c_fieldMapOfCaptureType.get("display_name") + " '" + c_selectedCaptureTypeObj.name + "'"}
                p_dropUniqueString="AddEditDeleteTableRow_tbl_a_details_groups_pool"
                p_dropNotAllowedDraggerIDsArray={c_selectedCaptureTypeDetailsCardGroupIDsArray}
                p_dropMessage="[Drag/drop groups from the pool]"
                p_dropAllowDropMessage={"[Drop group to add to " + c_cardNameDetails + " Card]"}
                p_dropNotAllowDropMessage={"[Cannot have duplicate groups on the " + c_cardNameDetails + " Card]"}
                f_onClickSetAsReceiving={undefined}
                f_onDrop={this.ondrop_details_card_group_into_capture_type}
                f_onRemoveAllItems={this.onremove_all_details_card_groups_from_capture_type}>
                {c_selectedCaptureTypeDetailsCardGroupsArrayOfObjs.map((m_detailsCardGroupObj, m_index) =>
                  <AddedDetailsCardGroupItem
                    key={c_selectedCaptureTypeObj.id + "-" + m_detailsCardGroupObj.id}
                    p_detailsCardGroupObj={m_detailsCardGroupObj}
                    p_detailsCardGroupIndex={m_index}
                    p_isOnlyItemTF={(numDetailsCardGroupsAdded === 1)}
                    p_isLastItemTF={(m_index === (numDetailsCardGroupsAdded - 1))}
                  />
                )}
              </BlueItemCollectionShell>
            </div>
            {(includeExampleDetailsCardLayoutTF) &&
              <div className="flex11a displayFlexColumn yScroll" style={{flexBasis:"150em", borderLeft:"solid 1px #ccc"}}>
                <div className="flex00a smallFullMargin">
                  <div>
                    <font className="font14 fontItalic fontTextLighter">
                      {"Example " + c_cardNameDetails + " Card Layout"}
                    </font>
                  </div>
                  <div>
                    <font className="fontItalic fontTextLighter">
                      {"Note that users will see a different number of " + c_cardNameDetails + " Groups per row inside the details card based on their screen width"}
                    </font>
                  </div>
                </div>
                <div className="flex11a" style={{marginBottom:"5em"}}>
                  <OpenCaptureReact.CardShell
                    p_label={c_cardNameDetails}
                    p_drawLeftRightButtonsTF={true}>
                    {(c_selectedCaptureTypeExistsTF) &&
                      <div className="flex11a displayFlexColumn bgLightesterGray">
                        {groupIDsRCMatrix.map((m_groupIDsRowArray, m_rowIndex) =>
                          <div key={JSFUNC.rc_unique_row_key(detailsNumGroupsPerRow, m_rowIndex)} className="flex00a displayFlexRow">
                            {m_groupIDsRowArray.map((m_groupID) =>
                              <OpenCaptureReact.DetailsGroupShell
                                key={m_groupID}
                                p_groupName={((m_groupID >= 0) ? (c_selectedCaptureTypeDetailsCardGroupsArrayOfObjs[m_groupID].name) : (undefined))}
                                p_groupNameStylingStringComma={((m_groupID >= 0) ? (c_selectedCaptureTypeDetailsCardGroupsArrayOfObjs[m_groupID].group_name_styling_string_comma) : (undefined))}>
                                <ExampleFieldValue />
                                <ExampleFieldValue />
                                <ExampleFieldValue />
                              </OpenCaptureReact.DetailsGroupShell>
                            )}
                          </div>
                        )}
                      </div>
                    }
                  </OpenCaptureReact.CardShell>
                </div>
              </div>
            }
          </div>
        </div>
      </div>
    );
  }
}));

function ExampleFieldValue(props) { //props: none
  return(
    <div className="displayFlexRow">
      <div className="flex11a" style={{flexBasis:"100em"}}>
        <font className="fontBlueLighter">
          {"Example Field"}
        </font>
      </div>
      <div className="flex11a" style={{flexBasis:"100em"}}>
        <font className="fontTextLightester">
          {"Example Value"}
        </font>
      </div>
    </div>
  );
}


export const AddedDetailsCardGroupItem = inject("AdminMobx", "DatabaseMobx")(observer(
class AddedDetailsCardGroupItem extends Component { //props: p_detailsCardGroupObj, p_detailsCardGroupIndex, p_isOnlyItemTF, p_isLastItemTF
  onclick_remove_details_card_group_from_capture_type = () => {
    const removedDetailsCardGroupID = this.props.p_detailsCardGroupObj.id;

    const c_selectedCaptureTypeObj = this.props.AdminMobx.c_selectedCaptureTypeObj;
    const selectedCaptureTypeDetailsCardGroupIDsArray = this.props.AdminMobx.c_selectedCaptureTypeDetailsCardGroupIDsArray;

    const newSelectedCaptureTypeDetailsCardGroupIDsArray = JSFUNC.remove_all_values_from_array(removedDetailsCardGroupID, selectedCaptureTypeDetailsCardGroupIDsArray);
    const newSelectedCaptureTypeDetailsCardGroupIDsComma = JSFUNC.convert_array_to_comma_list(newSelectedCaptureTypeDetailsCardGroupIDsArray);

    const jsDescription = JSFUNC.js_description_from_action("AdminReact - AddedDetailsCardGroupItem", "onclick_remove_details_card_group_from_capture_type", [], []);
    const C_CallPhpTblUID = new JSPHP.ClassCallPhpTblUID(jsDescription);
    C_CallPhpTblUID.add_update("tbl_a_capture_types", c_selectedCaptureTypeObj.id, "details_group_ids_comma", newSelectedCaptureTypeDetailsCardGroupIDsComma, "s");
    C_CallPhpTblUID.execute();
  }

  render() {
    const p_detailsCardGroupObj = this.props.p_detailsCardGroupObj;
    const p_detailsCardGroupIndex = this.props.p_detailsCardGroupIndex;
    const p_isOnlyItemTF = this.props.p_isOnlyItemTF;
    const p_isLastItemTF = this.props.p_isLastItemTF;

    const k_blueItemCollectionShellItemStylingObj = this.props.AdminMobx.k_blueItemCollectionShellItemStylingObj;
    const c_fieldsAddedToDetailsCardGroupsObj = this.props.AdminMobx.c_fieldsAddedToDetailsCardGroupsObj;
    const c_selectedCaptureTypeObj = this.props.AdminMobx.c_selectedCaptureTypeObj;
    const c_cardNameDetails = this.props.DatabaseMobx.c_cardNameDetails;
    const c_fieldMapOfCaptureType = this.props.DatabaseMobx.c_fieldMapOfCaptureType;

    var captureTypeDetailsFieldsDisplayNamesListString = "";
    for(let fieldsPerGroupObj of c_fieldsAddedToDetailsCardGroupsObj.fieldsPerGroupArrayOfObjs) {
      if(fieldsPerGroupObj.detailsCardGroupObj.id === p_detailsCardGroupObj.id) {
        for(let expandedCaptureTypeDetailsFieldObj of fieldsPerGroupObj.expandedCaptureTypeDetailsFieldsArrayOfObjs) {
          captureTypeDetailsFieldsDisplayNamesListString += "\n - " + expandedCaptureTypeDetailsFieldObj.fieldDisplayName;
        }
      }
    }

    if(captureTypeDetailsFieldsDisplayNamesListString === "") {
      captureTypeDetailsFieldsDisplayNamesListString = "\n--0 Fields are added to this Group--";
    }
    else {
      captureTypeDetailsFieldsDisplayNamesListString = "\nFields added to this Group:" + captureTypeDetailsFieldsDisplayNamesListString;
    }

    return(
      <CEGeneralReact.CEDragToResortItemWithinCommaListWithinDbTbl
        p_canResortTF={true}
        p_uniqueString="captureTypeDetailsCardGroup"
        p_itemIndex={p_detailsCardGroupIndex}
        p_itemID={p_detailsCardGroupObj.id}
        p_itemSortColumnWidth="2em"
        p_itemSortNumberFontClass={undefined}
        p_isOnlyItemTF={p_isOnlyItemTF}
        p_isLastItemTF={p_isLastItemTF}
        p_outerPadClass={k_blueItemCollectionShellItemStylingObj.outerPadClass}
        p_itemClass="displayFlexRow border bevelBorderColors borderRadius05 bgAlmostWhite"
        p_itemStyleObj={{height:k_blueItemCollectionShellItemStylingObj.rowHeightEm + "em"}}
        p_lastItemExtraDropZoneHeight={k_blueItemCollectionShellItemStylingObj.lastItemExtraDropZoneHeightEm + "em"}
        p_dragEntireItemTrueOnlySortNumberFalse={true}
        p_tblName="tbl_a_capture_types"
        p_tblRowID={c_selectedCaptureTypeObj.id}
        p_tblCommaListColumnName="details_group_ids_comma"
        p_commaList={c_selectedCaptureTypeObj.details_group_ids_comma}>
        <div className="flex11a displayFlexRowVc lrPad">
          {p_detailsCardGroupObj.name}
        </div>
        <div className="flex00a displayFlexColumnHcVc borderL1ddd" style={{flexBasis:"2em"}}>
          <CEGeneralReact.DeleteMenu
            p_message={"Are you sure you want to remove group '" + p_detailsCardGroupObj.name + "' from " + c_cardNameDetails + " Card for " + c_fieldMapOfCaptureType.get("display_name") + " '" + c_selectedCaptureTypeObj.name + "'?\n" + captureTypeDetailsFieldsDisplayNamesListString}
            p_menuItemText="Remove Group"
            f_onDelete={this.onclick_remove_details_card_group_from_capture_type}
          />
        </div>
      </CEGeneralReact.CEDragToResortItemWithinCommaListWithinDbTbl>
    );
  }
}));





//=================================================================================================================================================================
//=================================================================================================================================================================



export const AdminSubtabDetailsDatesFields = inject("CaptureExecMobx", "AdminMobx", "DatabaseMobx")(observer(
class AdminSubtabDetailsDatesFields extends Component { //props: none
  componentDidMount() {
    this.props.AdminMobx.a_fields_initialize_selected_receiving_details_card_group();
  }

  onclick_view_field_in_receiving_table = (i_fieldID) => {
    const o_fieldsHighlightedFieldID = this.props.AdminMobx.o_fieldsHighlightedFieldID;
    if(o_fieldsHighlightedFieldID === i_fieldID) {
      this.props.AdminMobx.a_fields_set_highlighted_field_id(undefined);
      return;
    }

    this.props.AdminMobx.a_fields_set_search_filter_text("");
    this.props.AdminMobx.a_fields_set_highlighted_field_id(i_fieldID);
    window.requestAnimationFrame(() => {
      const receivingFieldRow = document.getElementById("adminDetailsAddedFieldRow_" + i_fieldID);
      if(receivingFieldRow) {
        receivingFieldRow.scrollIntoView({block:"nearest", inline:"nearest"});
      }
    });
  }

  onclick_view_field_in_pool = (i_fieldID) => {
    if(i_fieldID === undefined) {
      this.props.AdminMobx.a_fields_set_highlighted_field_id(undefined);
      return;
    }

    const o_fieldsHighlightedFieldID = this.props.AdminMobx.o_fieldsHighlightedFieldID;
    if(o_fieldsHighlightedFieldID === i_fieldID) {
      this.props.AdminMobx.a_fields_set_highlighted_field_id(undefined);
      return;
    }

    this.props.AdminMobx.a_fields_set_search_filter_text("");
    this.props.AdminMobx.a_fields_set_highlighted_field_id(i_fieldID);
    window.requestAnimationFrame(() => {
      const poolFieldRow = document.getElementById("adminDetailsFieldPoolRow_" + i_fieldID);
      if(poolFieldRow) {
        poolFieldRow.scrollIntoView({block:"nearest", inline:"nearest"});
      }
    });
  }

  onclick_details_snapshot_details_groups_dates_card_tab = (i_snapshotGroupsDatesTab) => {
    this.props.AdminMobx.a_fields_set_search_filter_text("");
    this.props.AdminMobx.a_fields_set_selected_tab_snapshot_groups_dates(i_snapshotGroupsDatesTab);
    this.props.AdminMobx.a_fields_set_highlighted_field_id(undefined);
  }

  onchange_fields_search_filter_text = (i_newValue) => {
    this.props.AdminMobx.a_fields_set_search_filter_text(i_newValue);
  }

  onclick_add_capture_field_to_receiving_details_group = (i_fieldID) => { //click the add button in the fields pool, add this field to the receiving details card group or dates card
    const o_fieldsSelectedTabSnapshotGroupsDates = this.props.AdminMobx.o_fieldsSelectedTabSnapshotGroupsDates;
    const fieldsSelectedReceivingDetailsCardGroupID = this.props.AdminMobx.o_fieldsSelectedReceivingDetailsCardGroupID;
    if(o_fieldsSelectedTabSnapshotGroupsDates === "detailsCardSnapshot") {
      this.props.AdminMobx.a_fields_add_field_to_receiving_details_snapshot(i_fieldID);
    }
    else if(o_fieldsSelectedTabSnapshotGroupsDates === "detailsCardGroups") {
      this.props.AdminMobx.a_fields_add_field_to_receiving_details_card_group(fieldsSelectedReceivingDetailsCardGroupID, i_fieldID);
    }
    else if(o_fieldsSelectedTabSnapshotGroupsDates === "datesCard") {
      this.props.AdminMobx.a_fields_add_field_to_receiving_details_card_group(0, i_fieldID);
    }
    else if(o_fieldsSelectedTabSnapshotGroupsDates === "revenueCard") {
      this.props.AdminMobx.a_fields_add_field_to_receiving_details_card_group(-1, i_fieldID);
    }

    if(i_fieldID > 0) {
      this.props.AdminMobx.a_fields_set_highlighted_field_id(i_fieldID);
    }
  }

  onclick_add_blank_space_to_receiving_details_group = () => {
    this.onclick_add_capture_field_to_receiving_details_group(-10);
  }

  onclick_add_line_break_to_receiving_details_group = () => {
    this.onclick_add_capture_field_to_receiving_details_group(-11);
  }

  render() {
    const o_mediaQueryFlag = this.props.CaptureExecMobx.o_mediaQueryFlag;
    const o_fieldsSelectedTabSnapshotGroupsDates = this.props.AdminMobx.o_fieldsSelectedTabSnapshotGroupsDates;
    const o_fieldsHighlightedFieldID = this.props.AdminMobx.o_fieldsHighlightedFieldID;
    const c_selectedCaptureTypeExistsTF = this.props.AdminMobx.c_selectedCaptureTypeExistsTF;
    const c_filteredFieldsOnDetailsCardCustomArrayOfObjs = this.props.AdminMobx.c_filteredFieldsOnDetailsCardCustomArrayOfObjs;
    const c_filteredFieldsOnDetailsCardMandatoryArrayOfObjs = this.props.AdminMobx.c_filteredFieldsOnDetailsCardMandatoryArrayOfObjs;
    const c_filteredFieldsOnDetailsCardGcssArrayOfObjs = this.props.AdminMobx.c_filteredFieldsOnDetailsCardGcssArrayOfObjs;
    const c_filteredFieldsOnNotepadCardArrayOfObjs = this.props.AdminMobx.c_filteredFieldsOnNotepadCardArrayOfObjs;
    const c_filteredFieldsOnAdvanceStageCardArrayOfObjs = this.props.AdminMobx.c_filteredFieldsOnAdvanceStageCardArrayOfObjs;
    const c_filteredFieldsOnDealShapingCardArrayOfObjs = this.props.AdminMobx.c_filteredFieldsOnDealShapingCardArrayOfObjs;
    const c_filteredFieldsOnTeammatesCardArrayOfObjs = this.props.AdminMobx.c_filteredFieldsOnTeammatesCardArrayOfObjs;
    const c_filteredFieldsOnCompetitorsCardArrayOfObjs = this.props.AdminMobx.c_filteredFieldsOnCompetitorsCardArrayOfObjs;
    const c_fieldsAddedToDetailsSnapshotObj = this.props.AdminMobx.c_fieldsAddedToDetailsSnapshotObj;
    const c_fieldsAddedToDetailsCardGroupsObj = this.props.AdminMobx.c_fieldsAddedToDetailsCardGroupsObj;
    const c_fieldsAddedToDatesCardObj = this.props.AdminMobx.c_fieldsAddedToDatesCardObj;
    const c_fieldsAddedToRevenueCardObj = this.props.AdminMobx.c_fieldsAddedToRevenueCardObj;
    const o_tbl_a_capture_types_details_fields = this.props.DatabaseMobx.o_tbl_a_capture_types_details_fields;
    const c_cardNameAdvanceStage = this.props.DatabaseMobx.c_cardNameAdvanceStage;
    const c_cardNameDates = this.props.DatabaseMobx.c_cardNameDates;
    const c_cardNameDetails = this.props.DatabaseMobx.c_cardNameDetails;
    const c_cardNameDealShaping = this.props.DatabaseMobx.c_cardNameDealShaping;
    const c_cardNameRevenue = this.props.DatabaseMobx.c_cardNameRevenue;

    var fieldsSelectedTabIsDetailsCardGroupsTF = false;
    var fieldsSelectedTabIsDetailsCardSnapshotTF = false;
    var fieldsSelectedTabIsDatesCardTF = false;
    var fieldsSelectedTabIsRevenueCardTF = false;
    if(o_fieldsSelectedTabSnapshotGroupsDates === "detailsCardGroups") { fieldsSelectedTabIsDetailsCardGroupsTF = true; }
    else if(o_fieldsSelectedTabSnapshotGroupsDates === "detailsCardSnapshot") { fieldsSelectedTabIsDetailsCardSnapshotTF = true; }
    else if(o_fieldsSelectedTabSnapshotGroupsDates === "datesCard") { fieldsSelectedTabIsDatesCardTF = true; }
    else if(o_fieldsSelectedTabSnapshotGroupsDates === "revenueCard") { fieldsSelectedTabIsRevenueCardTF = true; }

    var receivingTitle = undefined;
    var fieldIDsAlreadyAddedArray = undefined;
    var receivingGroupsComponent = null;
    var exampleSnapshotCardComponent = null;
    if(fieldsSelectedTabIsDetailsCardGroupsTF) {
      receivingTitle = "Capture Fields in Groups on " + c_cardNameDetails + " Card";
      fieldIDsAlreadyAddedArray = c_fieldsAddedToDetailsCardGroupsObj.fieldIDsAlreadyAddedArray;
      receivingGroupsComponent = (
        c_fieldsAddedToDetailsCardGroupsObj.fieldsPerGroupArrayOfObjs.map((m_fieldsPerGroupObj) =>
          <DetailsCardGroupOfAddedCaptureFields
            key={m_fieldsPerGroupObj.detailsCardGroupObj.id}
            p_fieldsPerGroupObj={m_fieldsPerGroupObj}
            p_fieldIDsAlreadyAddedArray={fieldIDsAlreadyAddedArray}
            p_fieldsSelectedReceivingDetailsCardGroupID={this.props.AdminMobx.o_fieldsSelectedReceivingDetailsCardGroupID}
            p_canResortTF={true}
            p_highlightedFieldID={o_fieldsHighlightedFieldID}
            f_onClickHighlightField={this.onclick_view_field_in_pool}
          />
        )
      );
    }
    else if(fieldsSelectedTabIsDetailsCardSnapshotTF) {
      receivingTitle = "Capture Fields in " + c_cardNameDetails + " Card Snapshot on Capture Summary";
      fieldIDsAlreadyAddedArray = c_fieldsAddedToDetailsSnapshotObj.fieldIDsAlreadyAddedArray;
      receivingGroupsComponent = (
        <DetailsSnapshotOfAddedCaptureFields
          p_highlightedFieldID={o_fieldsHighlightedFieldID}
          f_onClickHighlightField={this.onclick_view_field_in_pool}
        />
      );
      exampleSnapshotCardComponent = (
        <>
          <LibraryReact.DivFont p_class="medTopMargin" p_fontClass="font13 fontItalic fontTextLighter">
            {"Example " + c_cardNameDetails + " Card Snapshot"}
          </LibraryReact.DivFont>
          <div className="displayFlexColumnHcVc">
            <div className="flex00a displayFlexColumn" style={{flexBasis:"22em", width:"30em"}}>
              <OpenCaptureReact.CardShell p_label={c_cardNameDetails}>
                <div className="flex11a overflowHidden smallFullMargin">
                  {c_fieldsAddedToDetailsSnapshotObj.snapshotExampleCaptureFieldValuesArrayOfObjs.map((m_snapshotExampleCaptureFieldValueObj) =>
                    <OpenCaptureReact.DetailsItem
                      p_captureID={-1}
                      p_cardID={this.props.DatabaseMobx.k_cardIDDetails}
                      p_captureFieldValueObj={m_snapshotExampleCaptureFieldValueObj}
                      p_isSnapshotTF={true}
                      p_fieldWidth="11em"
                    />
                  )}
                </div>
              </OpenCaptureReact.CardShell>
            </div>
          </div>
        </>
      );
    }
    else if(fieldsSelectedTabIsDatesCardTF) {
      receivingTitle = "Date Fields on " + c_cardNameDates + " Card";
      fieldIDsAlreadyAddedArray = c_fieldsAddedToDatesCardObj.fieldIDsAlreadyAddedArray;
      receivingGroupsComponent = (
        <DetailsCardGroupOfAddedCaptureFields
          p_fieldsPerGroupObj={c_fieldsAddedToDatesCardObj}
          p_fieldIDsAlreadyAddedArray={fieldIDsAlreadyAddedArray}
          p_fieldsSelectedReceivingDetailsCardGroupID={0}
          p_canResortTF={true}
          p_highlightedFieldID={o_fieldsHighlightedFieldID}
          f_onClickHighlightField={this.onclick_view_field_in_pool}
        />
      );
    }
    else if(fieldsSelectedTabIsRevenueCardTF) {
      receivingTitle = "Money Fields as Costs on " + c_cardNameRevenue + " Card";
      fieldIDsAlreadyAddedArray = c_fieldsAddedToRevenueCardObj.fieldIDsAlreadyAddedArray;
      receivingGroupsComponent = (
        <DetailsCardGroupOfAddedCaptureFields
          p_fieldsPerGroupObj={c_fieldsAddedToRevenueCardObj}
          p_fieldIDsAlreadyAddedArray={fieldIDsAlreadyAddedArray}
          p_fieldsSelectedReceivingDetailsCardGroupID={-1}
          p_canResortTF={true}
          p_highlightedFieldID={o_fieldsHighlightedFieldID}
          f_onClickHighlightField={this.onclick_view_field_in_pool}
        />
      );
    }

    const fieldsDataArrayOfArrayOfObjs = [
      c_filteredFieldsOnDetailsCardCustomArrayOfObjs,
      c_filteredFieldsOnDetailsCardMandatoryArrayOfObjs,
      c_filteredFieldsOnDetailsCardGcssArrayOfObjs,
      c_filteredFieldsOnNotepadCardArrayOfObjs,
      c_filteredFieldsOnAdvanceStageCardArrayOfObjs,
      c_filteredFieldsOnDealShapingCardArrayOfObjs,
      c_filteredFieldsOnTeammatesCardArrayOfObjs,
      c_filteredFieldsOnCompetitorsCardArrayOfObjs
    ];

    const canAddNewItemsTFArray = [true, false, false, false, false, false, false, false];
    const canHighlightAlreadyAddedItemsTFArray = [true, true, true, true, true, true, true, true];
    const canDeleteItemsTFArray = [true, false, false, false, false, false, false, false];
    const dragToResortFieldDbNameArray = ["admin_sort", "admin_sort", "admin_sort", undefined, undefined, undefined, undefined, undefined];
    const maskResortFieldDbNameArray = ["fakeSort", "fakeSort", "fakeSort", undefined, undefined, undefined, undefined, undefined];
    const initialSortedFieldDbNameArray = ["admin_sort", "admin_sort", "admin_sort", "display_name", "display_name", "display_name", "display_name", "display_name"];
    const idsAlreadyAddedArrayOrUndefinedArray = [fieldIDsAlreadyAddedArray, fieldIDsAlreadyAddedArray, fieldIDsAlreadyAddedArray, fieldIDsAlreadyAddedArray, fieldIDsAlreadyAddedArray, fieldIDsAlreadyAddedArray, fieldIDsAlreadyAddedArray, fieldIDsAlreadyAddedArray]; //undefined is a flag that prevents the 'Add ->' button for every tbl item

    const functionDeleteTblCapturesColumnAndTblCapTable = (i_C_CallPhpTblUID, i_captureFieldRowObj) => {
      //remove the data column from tbl_captures for this deleted field
      i_C_CallPhpTblUID.add_alter_db_tbl_delete_column("tbl_captures", i_captureFieldRowObj.db_name);

      //check if this field has a tbl_cap_ select table associated with it, if so, check all the fields to see if any other fields use that table, if this field is the only user, delete the tbl_cap table completely
      if(JSFUNC.text_or_number_is_filled_out_tf(i_captureFieldRowObj.select_tbl_name)) {
        if(this.props.DatabaseMobx.tbl_name_is_tbl_cap(i_captureFieldRowObj.select_tbl_name)) { //ensure the tblName being deleted is a tbl_cap tbl, not an admin tbl
          var deleteTblCapTableTF = true;
          for(let fieldMap of this.props.DatabaseMobx.o_tbl_captures_fields.values()) {
            if(fieldMap.get("id") !== i_captureFieldRowObj.id) { //check all other fields other than this one
              if(fieldMap.get("select_tbl_name") === i_captureFieldRowObj.select_tbl_name) { //if any other field is using this tbl_cap table data, do not delete it
                deleteTblCapTableTF = false;
              }
            }
          }

          if(deleteTblCapTableTF) {
            i_C_CallPhpTblUID.add_db_delete_tbl_cap_table(i_captureFieldRowObj.select_tbl_name);
          }
        }
      }

      //find any assignments of this fieldID on details groups or dates card (tbl_a_capture_types_details_fields) for any capture type and remove them
      for(let [captureTypeDetailsFieldRecordID, captureTypeDetailsFieldRecordMap] of o_tbl_a_capture_types_details_fields) { //must have individual deletes within a loop so that post delete resorting among the different capture_type_id/group_id combinations can properly happen
        if(captureTypeDetailsFieldRecordMap.get("field_id") === i_captureFieldRowObj.id) { //delete this record if the field_id matches the fieldID of the details field that was just deleted (this table covers all capture types and both the details card and dates card (group 0))
          var resortSortColumnName = "sort";
          var resortFilterFieldNameOrFieldNamesArray = ["capture_type_id", "group_id"];
          var resortFilterValueOrValuesArray = [captureTypeDetailsFieldRecordMap.get("capture_type_id"), captureTypeDetailsFieldRecordMap.get("group_id")];
          i_C_CallPhpTblUID.add_delete("tbl_a_capture_types_details_fields", captureTypeDetailsFieldRecordID, resortSortColumnName, resortFilterFieldNameOrFieldNamesArray, resortFilterValueOrValuesArray);
        }
      }

      //find any assignments of this fieldID on the details snapshot card (tbl_a_capture_types details_snapshot_field_ids_comma column) for any capture type and remove them
      for(let [captureTypeID, captureTypeMap] of this.props.DatabaseMobx.o_tbl_a_capture_types) {
        var oldDetailsSnapshotFieldIDsComma = captureTypeMap.get("details_snapshot_field_ids_comma");
        var newDetailsSnapshotFieldIDsComma = JSFUNC.remove_all_int_values_from_int_comma_list(i_captureFieldRowObj.id, oldDetailsSnapshotFieldIDsComma);
        if(newDetailsSnapshotFieldIDsComma !== oldDetailsSnapshotFieldIDsComma) { //if the fieldID was removed, update the field with the changed comma list of remaining fieldIDs
          i_C_CallPhpTblUID.add_update("tbl_a_capture_types", captureTypeID, "details_snapshot_field_ids_comma", newDetailsSnapshotFieldIDsComma, "s");
        }
      }
    };
    const itemDeleteFunctionsArrayArray = [[functionDeleteTblCapturesColumnAndTblCapTable], undefined, undefined, undefined, undefined, undefined, undefined, undefined];

    const keysArray = ["dc", "dm", "dg", "np", "as", "ds", "tm", "cp"];

    const tableTitlesArray = [
      "User Capture Fields",
      "System Capture Fields",
      "GovCon Smart Search Import Fields",
      "'Notepad' Card",
      "'" + c_cardNameAdvanceStage + "' Card",
      "'" + c_cardNameDealShaping + "' Card",
      "'Teammates' Card",
      "'Competitors' Card"
    ];

    var numOptionsColumnWidth = "7em";
    var hoverTextColumnWidth = "10em";
    var styleColumnWidth = "5em";
    if(o_mediaQueryFlag <= 2) {
      numOptionsColumnWidth = "3em";
      hoverTextColumnWidth = "3em";
      styleColumnWidth = "3em";
    }
    else if(o_mediaQueryFlag <= 3) {
      numOptionsColumnWidth = "4em";
      hoverTextColumnWidth = "4em";
      styleColumnWidth = "4em";
    }
    else if(o_mediaQueryFlag <= 4) {
      numOptionsColumnWidth = "5em";
      hoverTextColumnWidth = "6em";
      styleColumnWidth = "5em";
    }

    var aedTableObjsArray = [];
    for(let f = 0; f < fieldsDataArrayOfArrayOfObjs.length; f++) {
      var aedTableObj = {
        tblName: "tbl_captures_fields",
        canAddNewItemsTF: canAddNewItemsTFArray[f],
        canHighlightAlreadyAddedItemsTF: canHighlightAlreadyAddedItemsTFArray[f],
        functionOnClickViewItemToHighlight: this.onclick_view_field_in_receiving_table,
        canDeleteItemsTF: canDeleteItemsTFArray[f],
        dragToResortFieldDbName: dragToResortFieldDbNameArray[f],
        maskResortFieldDbName: maskResortFieldDbNameArray[f],
        canAlwaysDragResortTF: true,
        initialSortedFieldDbName: initialSortedFieldDbNameArray[f],
        tableWidth: "100%",
        itemName: "Capture Field",
        deleteItemNameFieldDbName: "display_name",
        searchFieldDbName: undefined,
        canAddItemsFromAddColumnTF: c_selectedCaptureTypeExistsTF,
        idsAlreadyAddedArray: idsAlreadyAddedArrayOrUndefinedArray[f],
        highlightedItemID: o_fieldsHighlightedFieldID,
        itemDeleteFunctionsArray: itemDeleteFunctionsArrayArray[f],
        fieldsArrayOfObjs: [
          {width:"400em", dbName:"display_name", displayName:"Display Name", fieldTypeObj:this.props.DatabaseMobx.c_genericTextFieldTypeObj, initialValue:"", cellHoverTF:true, requiredNotEmptyTF:true},
          {width:"300em", dbName:"fieldTypeMask", displayName:"Input Type", fieldTypeObj:this.props.DatabaseMobx.c_genericTextFieldTypeObj, initialValue:"", cellHoverTF:true, rawValueDisplayedFieldIsReadOnlyOnFormTF:true}, //text input so that the raw value (actually precalculated masked value) is simply displayed with no masking
          {width:numOptionsColumnWidth, fixedWidthTF:true, dbName:"numOptions", displayName:"# Options", fieldTypeObj:undefined, initialValue:undefined, cellCenterTF:true, rawValueDisplayedFieldNotOnFormTF:true},
          {width:undefined, dbName:"optionsArrayOfObjs", displayName:"Options for 'Select' field types", fieldTypeObj:{editOptionsForSelectFieldTF:true}, initialValue:undefined},
          {width:undefined, dbName:"textarea_details_max_lines", displayName:"Textarea Max # Lines Shown on " + c_cardNameDetails + " Card ('0' for all lines)", fieldTypeObj:this.props.DatabaseMobx.c_genericIntPositiveFieldTypeObj, initialValue:-1, rawValueFalseDisplaysNAAndNoEditTF:true},
          {width:undefined, dbName:"num_decimals", displayName:"# Decimals Shown (max 9)", fieldTypeObj:this.props.DatabaseMobx.c_genericInt0to9FieldTypeObj, initialValue:-1, rawValueFalseDisplaysNAAndNoEditTF:true},
          {width:hoverTextColumnWidth, fixedWidthTF:true, dbName:"hover_text", displayName:"Hover Help Text", fieldTypeObj:this.props.DatabaseMobx.c_genericTextareaFieldTypeObj, initialValue:"", cellHoverTF:true, cellDisplayBlankIfNotFilledOutTF:true},
          {width:styleColumnWidth, fixedWidthTF:true, dbName:"display_name_styling_string_comma", displayName:"Style", fieldTypeObj:this.props.DatabaseMobx.c_genericStylingStringAdminFontBlueFieldTypeObj, initialValue:"", cellCenterTF:true, cellHoverTF:true, cellDisplayBlankIfNotFilledOutTF:true},
          {width:"6em", fixedWidthTF:true, dbName:"codeword_names_comma", displayName:"Template/Report Extra [[codewords]]", fieldTypeObj:this.props.DatabaseMobx.c_genericTextFieldTypeObj, initialValue:"", cellHoverTF:true, cellDisplayBlankIfNotFilledOutTF:true}
        ]
      };

      aedTableObjsArray.push(aedTableObj);
    }

    return (
      <div className="flex11a displayFlexColumn">
        <AdminCaptureTypeSelectionBoxes />
        <div className="flex11a displayFlexRow">
          <div className="flex11a displayFlexColumn smallRightMargin" style={{flexBasis:"140em", borderRight:"solid 1px #ba9"}}>
            <div className="flex00a displayFlexRow" style={{flexBasis:"3em", background:"#ddccbb", borderBottom:"solid 1px #ba9"}}>
              <div className="flex00a displayFlexColumnVc lrMedPad" style={{flexBasis:"25em"}}>
                <CEGeneralReact.SearchInputTextWithClearX
                  p_inputText={this.props.AdminMobx.o_fieldsSearchFilterText}
                  p_placeholderText="Filter All Capture Fields..."
                  p_includeSearchIconTF={false}
                  p_heightEm={2.2}
                  p_tabIndex={1}
                  f_onChange={this.onchange_fields_search_filter_text}
                />
              </div>
              <div className="flex11a" />
            </div>
            <div className="flex11a yScroll smallTopPad lrPad hugeBottomPad">
              {fieldsDataArrayOfArrayOfObjs.map((m_fieldsDataArrayOfObjs, m_index) =>
                <div key={keysArray[m_index]} className={((m_index > 0) ? ("hugeTopMargin") : ("")) + " smallBottomMargin"}>
                  <LibraryReact.DivFont p_class="microBottomMargin" p_fontClass="font14 fontItalic">
                    {tableTitlesArray[m_index]}
                  </LibraryReact.DivFont>
                  <CEComplexReact.AddEditDeleteTable
                    p_dataArrayOfObjs={m_fieldsDataArrayOfObjs}
                    p_aedTableObj={aedTableObjsArray[m_index]}
                    f_onClickAddItem={this.onclick_add_capture_field_to_receiving_details_group}
                  />
                </div>
              )}
              <div className="hugeTopMargin smallBottomMargin">
                <LibraryReact.DivFont p_class="microBottomMargin" p_fontClass="font14 fontItalic">
                  {"Add Blank Spaces or Line Breaks Between Fields"}
                </LibraryReact.DivFont>
                <div className="displayFlexRowHcVc bgLightGray medFullPad border bevelBorderColors borderRadius10">
                  <div className="flex00a lrMedPad">
                    <CEGeneralReact.CEButton
                      p_type="add"
                      p_text="Add Blank Space ->"
                      f_onClick={this.onclick_add_blank_space_to_receiving_details_group}
                    />
                  </div>
                  <div className="flex00a lrMedPad">
                    <CEGeneralReact.CEButton
                      p_type="add"
                      p_text="Add Line Break ->"
                      f_onClick={this.onclick_add_line_break_to_receiving_details_group}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="flex11a displayFlexColumn" style={{flexBasis:"100em"}}>
            <div className="flex00a displayFlexRow medFullPad" style={{background:"#ddccbb"}}>
              <DetailsGroupOrDatesCardTab
                p_label={c_cardNameDetails + " Card (Groups)"}
                p_selectedTF={fieldsSelectedTabIsDetailsCardGroupsTF}
                f_onClick={() => this.onclick_details_snapshot_details_groups_dates_card_tab("detailsCardGroups")}
              />
              <DetailsGroupOrDatesCardTab
                p_label={c_cardNameDetails + " Card (Snapshot)"}
                p_selectedTF={fieldsSelectedTabIsDetailsCardSnapshotTF}
                f_onClick={() => this.onclick_details_snapshot_details_groups_dates_card_tab("detailsCardSnapshot")}
              />
              <DetailsGroupOrDatesCardTab
                p_label={c_cardNameDates + " Card"}
                p_selectedTF={fieldsSelectedTabIsDatesCardTF}
                f_onClick={() => this.onclick_details_snapshot_details_groups_dates_card_tab("datesCard")}
              />
              <DetailsGroupOrDatesCardTab
                p_label={c_cardNameRevenue + " Card"}
                p_selectedTF={fieldsSelectedTabIsRevenueCardTF}
                f_onClick={() => this.onclick_details_snapshot_details_groups_dates_card_tab("revenueCard")}
              />
            </div>
            <div className="flex11a yScroll">
              <div className="smallTopMargin smallFullPad" style={{border:"solid 1px #bbb"}}>
                <LibraryReact.DivFont p_class="" p_fontClass="font13 fontBold fontItalic fontTextLight">
                  {receivingTitle}
                </LibraryReact.DivFont>
                {receivingGroupsComponent}
                {exampleSnapshotCardComponent}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}));

function DetailsGroupOrDatesCardTab(props) { //props: p_label, p_selectedTF, f_onClick
  const p_label = props.p_label;
  const p_selectedTF = props.p_selectedTF;
  const f_onClick = props.f_onClick;

  return(
    <div
      className={"flex11a displayFlexRowVc lrMargin lrMedPad border bevelBorderDarkColors textCenter " + ((p_selectedTF) ? ("bgGreenGradient") : ("bgDarkGrayGradient hoverLightGreenGradient cursorPointer"))}
      style={{flexBasis:"100em", height:"3.3em", borderRadius:"2em"}}
      onClick={((p_selectedTF) ? (undefined) : (f_onClick))}>
      <LibraryReact.MaxHeightWrap p_maxHeight="2.9em" p_fontClass="font12 fontItalic fontWhite">
        {p_label}
      </LibraryReact.MaxHeightWrap>
    </div>
  );
}



export const DetailsSnapshotOfAddedCaptureFields = inject("AdminMobx")(observer(
class DetailsSnapshotOfAddedCaptureFields extends Component { //props: p_highlightedFieldID, f_onClickHighlightField
  ondrop_field_from_pool_into_group_drop_zone = (i_draggedFieldID) => {
    const c_fieldsAddedToDetailsSnapshotObj = this.props.AdminMobx.c_fieldsAddedToDetailsSnapshotObj;
    if(!JSFUNC.in_array(i_draggedFieldID, c_fieldsAddedToDetailsSnapshotObj.fieldIDsAlreadyAddedArray)) {
      this.props.AdminMobx.a_fields_add_field_to_receiving_details_snapshot(i_draggedFieldID);
    }
  }

  onremove_all_details_snapshot_fields_from_capture_type = () => {
    const o_selectedCaptureTypeID = this.props.AdminMobx.o_selectedCaptureTypeID;
    const c_selectedCaptureTypeDetailsSnapshotFieldIDsArray = this.props.AdminMobx.c_selectedCaptureTypeDetailsSnapshotFieldIDsArray;
    if(c_selectedCaptureTypeDetailsSnapshotFieldIDsArray.length > 0) {
      const jsDescription = JSFUNC.js_description_from_action("AdminReact - DetailsSnapshotOfAddedCaptureFields", "onremove_all_details_snapshot_fields_from_capture_type", [], []);
      const C_CallPhpTblUID = new JSPHP.ClassCallPhpTblUID(jsDescription);
      C_CallPhpTblUID.add_update("tbl_a_capture_types", o_selectedCaptureTypeID, "details_snapshot_field_ids_comma", "", "s");
      C_CallPhpTblUID.execute();
    }
  }

  render() {
    const p_highlightedFieldID = this.props.p_highlightedFieldID;
    const f_onClickHighlightField = this.props.f_onClickHighlightField;

    const c_selectedCaptureTypeObj = this.props.AdminMobx.c_selectedCaptureTypeObj;
    const c_fieldsAddedToDetailsSnapshotObj = this.props.AdminMobx.c_fieldsAddedToDetailsSnapshotObj;

    const snapshotFieldsArrayOfObjs = c_fieldsAddedToDetailsSnapshotObj.snapshotFieldsArrayOfObjs;
    const fieldIDsAlreadyAddedArray = c_fieldsAddedToDetailsSnapshotObj.fieldIDsAlreadyAddedArray;
    const numFields = snapshotFieldsArrayOfObjs.length;

    return (
      <BlueItemCollectionShell
        p_isReceivingTF={true}
        p_dropUniqueString="AddEditDeleteTableRow_tbl_captures_fields"
        p_dropNotAllowedDraggerIDsArray={fieldIDsAlreadyAddedArray}
        p_dropMessage="[Drag/drop capture fields from the pool]"
        p_dropAllowDropMessage={"[Drop field to add to Details Snapshot]"}
        p_dropNotAllowDropMessage="[Cannot add a field already added to one of the groups]"
        f_onDrop={this.ondrop_field_from_pool_into_group_drop_zone}
        f_onRemoveAllItems={this.onremove_all_details_snapshot_fields_from_capture_type}>
        {snapshotFieldsArrayOfObjs.map((m_snapshotFieldObj, m_index) =>
          <DetailsSnapshotAddedCaptureFieldItem
            key={c_selectedCaptureTypeObj.id + "-" + m_snapshotFieldObj.fieldID + "-" + (m_index + 1)}
            p_snapshotFieldObj={m_snapshotFieldObj}
            p_snapshotFieldIndex={m_index}
            p_isOnlyItemTF={(numFields === 1)}
            p_isLastItemTF={(m_index === (numFields - 1))}
            p_highlightedFieldID={p_highlightedFieldID}
            f_onClickHighlightField={f_onClickHighlightField}
          />
        )}
      </BlueItemCollectionShell>
    );
  }
}));


export const DetailsSnapshotAddedCaptureFieldItem = inject("AdminMobx", "DatabaseMobx")(observer(
class DetailsSnapshotAddedCaptureFieldItem extends Component { //props: p_snapshotFieldObj, p_snapshotFieldIndex, p_isOnlyItemTF, p_isLastItemTF, p_highlightedFieldID, f_onClickHighlightField
  onclick_remove_field_from_capture_type_details_snapshot_card = () => {
    const p_snapshotFieldObj = this.props.p_snapshotFieldObj;
    const f_onClickHighlightField = this.props.f_onClickHighlightField;

    this.props.AdminMobx.a_fields_remove_field_from_details_snapshot(p_snapshotFieldObj.fieldID);

    if(JSFUNC.is_function(f_onClickHighlightField)) {
      f_onClickHighlightField(undefined);
    }
  }

  render() {
    const p_snapshotFieldObj = this.props.p_snapshotFieldObj;
    const p_snapshotFieldIndex = this.props.p_snapshotFieldIndex;
    const p_isOnlyItemTF = this.props.p_isOnlyItemTF;
    const p_isLastItemTF = this.props.p_isLastItemTF;
    const p_highlightedFieldID = this.props.p_highlightedFieldID;
    const f_onClickHighlightField = this.props.f_onClickHighlightField;

    const c_selectedCaptureTypeObj = this.props.AdminMobx.c_selectedCaptureTypeObj;
    const c_fieldMapOfCaptureType = this.props.DatabaseMobx.c_fieldMapOfCaptureType;

    var addedCaptureFieldItemContentComponent = null;
    if(p_snapshotFieldObj.fieldID === -10) {
      addedCaptureFieldItemContentComponent = (
        <div className="flex11a displayFlexColumnHcVc">
          {"[Blank Space]"}
        </div>
      );
    }
    else if(p_snapshotFieldObj.fieldID === -11) {
      addedCaptureFieldItemContentComponent = (
        <div className="flex11a displayFlexColumnVc">
          <div className="borderT1Blue" style={{margin:"0 1.5em"}} />
        </div>
      );
    }
    else {
      addedCaptureFieldItemContentComponent = (
        <>
          {(p_snapshotFieldObj.fieldID > 0) &&
            <HighlightFieldInPoolButton
              p_fieldID={p_snapshotFieldObj.fieldID}
              f_onClickHighlightField={f_onClickHighlightField}
            />
          }
          <div className="flex11a displayFlexRowVc lrPad" title={p_snapshotFieldObj.fieldDisplayName}>
            <LibraryReact.NowrapEllipsis>
              {p_snapshotFieldObj.fieldDisplayName}
            </LibraryReact.NowrapEllipsis>
          </div>
        </>
      );
    }

    return(
      <div id={"adminDetailsAddedFieldRow_" + p_snapshotFieldObj.fieldID}>
      <CEGeneralReact.CEDragToResortItemWithinCommaListWithinDbTbl
        p_canResortTF={true}
        p_uniqueString="captureTypeDetailsSnapshotField"
        p_itemIndex={p_snapshotFieldIndex}
        p_itemID={p_snapshotFieldObj.fieldID}
        p_itemSortColumnWidth="3em"
        p_itemSortNumberFontClass={undefined}
        p_isOnlyItemTF={p_isOnlyItemTF}
        p_isLastItemTF={p_isLastItemTF}
        p_outerPadClass="microFullPad"
        p_itemClass="displayFlexRow border bevelBorderColors borderRadius05 bgAlmostWhite"
        p_itemStyleObj={{height:"2em", backgroundColor:((p_highlightedFieldID === p_snapshotFieldObj.fieldID) ? ("#fff4c2") : (undefined))}}
        p_lastItemExtraDropZoneHeight="1.8em"
        p_dragEntireItemTrueOnlySortNumberFalse={true}
        p_tblName="tbl_a_capture_types"
        p_tblRowID={c_selectedCaptureTypeObj.id}
        p_tblCommaListColumnName="details_snapshot_field_ids_comma"
        p_commaList={c_selectedCaptureTypeObj.details_snapshot_field_ids_comma}>
        {addedCaptureFieldItemContentComponent}
        <div className="flex00a displayFlexColumnHcVc borderL1ddd" style={{flexBasis:"2.5em"}}>
          <CEGeneralReact.RemoveItemXWithRedHover
            p_title={"Remove Capture Field '" + p_snapshotFieldObj.fieldDisplayName + "' from Details Snapshot Card for " + c_fieldMapOfCaptureType.get("display_name") + " '" + c_selectedCaptureTypeObj.name + "'"}
            f_onClick={this.onclick_remove_field_from_capture_type_details_snapshot_card}
          />
        </div>
      </CEGeneralReact.CEDragToResortItemWithinCommaListWithinDbTbl>
      </div>
    );
  }
}));



function HighlightFieldInPoolButton(props) { //props: p_fieldID, f_onClickHighlightField
  const p_fieldID = props.p_fieldID;
  const f_onClickHighlightField = props.f_onClickHighlightField;

  return(
    <div className="flex00a displayFlexColumnHcVc borderR1ddd" style={{flexBasis:"1.8em"}}>
      <button
        type="button"
        title="Highlight this field in the pool"
        aria-label="Highlight this field in the pool"
        className="flex00a displayFlexColumnHcVc cursorPointer"
        style={{width:"1.5em", height:"1.8em", border:"0", background:"transparent", padding:0}}
        onClick={(i_event) => {
          i_event.stopPropagation();
          if(JSFUNC.is_function(f_onClickHighlightField)) {
            f_onClickHighlightField(p_fieldID);
          }
        }}>
        <CEIconsReact.SvgEyeIcon p_sizeEm={0.9} p_color="999999" />
      </button>
    </div>
  );
}



export const DetailsCardGroupOfAddedCaptureFields = inject("AdminMobx")(observer(
class DetailsCardGroupOfAddedCaptureFields extends Component { //props: p_fieldsPerGroupObj, p_fieldIDsAlreadyAddedArray, p_fieldsSelectedReceivingDetailsCardGroupID, p_canResortTF, p_highlightedFieldID, f_onClickHighlightField
  onclick_set_receiving_details_card_group_id = () => {
    const p_fieldsPerGroupObj = this.props.p_fieldsPerGroupObj;
    this.props.AdminMobx.a_fields_set_receiving_details_card_group_id(p_fieldsPerGroupObj.detailsCardGroupObj.id);
  }

  ondrop_field_from_pool_into_group_drop_zone = (i_draggedFieldID) => {
    const p_fieldsPerGroupObj = this.props.p_fieldsPerGroupObj;
    const p_fieldIDsAlreadyAddedArray = this.props.p_fieldIDsAlreadyAddedArray;
    if(!JSFUNC.in_array(i_draggedFieldID, p_fieldIDsAlreadyAddedArray)) {
      this.props.AdminMobx.a_fields_add_field_to_receiving_details_card_group(p_fieldsPerGroupObj.detailsCardGroupObj.id, i_draggedFieldID);
    }
  }

  onremove_all_details_fields_in_group_from_capture_type = () => {
    const p_fieldsPerGroupObj = this.props.p_fieldsPerGroupObj;
    
    const jsDescription = JSFUNC.js_description_from_action("AdminMobx - DetailsCardGroupOfAddedCaptureFields", "onremove_all_details_fields_in_group_from_capture_type", [], []);
    const C_CallPhpTblUID = new JSPHP.ClassCallPhpTblUID(jsDescription);

    const allCaptureTypeDetailsFieldRowIDsInGroupArray = JSFUNC.get_column_vector_from_arrayOfObjs(p_fieldsPerGroupObj.expandedCaptureTypeDetailsFieldsArrayOfObjs, "id");
    C_CallPhpTblUID.add_delete("tbl_a_capture_types_details_fields", allCaptureTypeDetailsFieldRowIDsInGroupArray);

    C_CallPhpTblUID.execute();
  }

  render() {
    const p_fieldsPerGroupObj = this.props.p_fieldsPerGroupObj;
    const p_fieldIDsAlreadyAddedArray = this.props.p_fieldIDsAlreadyAddedArray;
    const p_fieldsSelectedReceivingDetailsCardGroupID = this.props.p_fieldsSelectedReceivingDetailsCardGroupID;
    const p_canResortTF = this.props.p_canResortTF;
    const p_highlightedFieldID = this.props.p_highlightedFieldID;
    const f_onClickHighlightField = this.props.f_onClickHighlightField;

    const detailsCardGroupObj = p_fieldsPerGroupObj.detailsCardGroupObj;
    const expandedCaptureTypeDetailsFieldsArrayOfObjs = p_fieldsPerGroupObj.expandedCaptureTypeDetailsFieldsArrayOfObjs;
    const numFields = expandedCaptureTypeDetailsFieldsArrayOfObjs.length;

    return (
      <BlueItemCollectionShell
        p_isReceivingTF={(detailsCardGroupObj.id === p_fieldsSelectedReceivingDetailsCardGroupID)}
        p_title={((detailsCardGroupObj.id > 0) ? ("Group Name: '" + detailsCardGroupObj.name + "'") : (undefined))}
        p_dropUniqueString="AddEditDeleteTableRow_tbl_captures_fields"
        p_dropNotAllowedDraggerIDsArray={p_fieldIDsAlreadyAddedArray}
        p_dropMessage="[Drag/drop capture fields from the pool]"
        p_dropAllowDropMessage={"[Drop field to add to group '" + detailsCardGroupObj.name + "']"}
        p_dropNotAllowDropMessage="[Cannot add a field already added to one of the groups]"
        f_onClickSetAsReceiving={this.onclick_set_receiving_details_card_group_id}
        f_onDrop={this.ondrop_field_from_pool_into_group_drop_zone}
        f_onRemoveAllItems={this.onremove_all_details_fields_in_group_from_capture_type}>
        {expandedCaptureTypeDetailsFieldsArrayOfObjs.map((m_expandedCaptureTypeDetailsFieldObj, m_index) =>
          <DetailsCardGroupAddedCaptureFieldItem
            key={m_expandedCaptureTypeDetailsFieldObj.id}
            p_detailsCardGroupObj={detailsCardGroupObj}
            p_expandedCaptureTypeDetailsFieldObj={m_expandedCaptureTypeDetailsFieldObj}
            p_canResortTF={p_canResortTF}
            p_sortNumber={(m_index + 1)}
            p_isOnlyItemTF={(numFields === 1)}
            p_isLastItemTF={(m_index === (numFields - 1))}
            p_highlightedFieldID={p_highlightedFieldID}
            f_onClickHighlightField={f_onClickHighlightField}
          />
        )}
      </BlueItemCollectionShell>
    );
  }
}));


export const DetailsCardGroupAddedCaptureFieldItem = inject("CaptureExecMobx", "AdminMobx", "DatabaseMobx")(observer(
class DetailsCardGroupAddedCaptureFieldItem extends Component { //props: p_detailsCardGroupObj, p_expandedCaptureTypeDetailsFieldObj, p_canResortTF, p_sortNumber, p_isOnlyItemTF, p_isLastItemTF, p_highlightedFieldID, f_onClickHighlightField
  constructor(props) {
    super(props);
    this.state = {
      s_editingAddedCaptureTypeFieldRecordTF: false
    };
  }

  onclick_capture_type_details_card_group_field_item_to_edit = () => {
    this.setState({s_editingAddedCaptureTypeFieldRecordTF:true});
  }

  onclick_close_capture_type_details_card_group_field_item_to_edit = () => {
    this.setState({s_editingAddedCaptureTypeFieldRecordTF:false});
  }

  onclick_remove_field_from_capture_type_details_card_group = () => {
    const p_expandedCaptureTypeDetailsFieldObj = this.props.p_expandedCaptureTypeDetailsFieldObj;
    const f_onClickHighlightField = this.props.f_onClickHighlightField;

    this.props.AdminMobx.a_fields_remove_field_from_details_card_group(p_expandedCaptureTypeDetailsFieldObj.id, p_expandedCaptureTypeDetailsFieldObj.capture_type_id, p_expandedCaptureTypeDetailsFieldObj.group_id);

    if(JSFUNC.is_function(f_onClickHighlightField)) {
      f_onClickHighlightField(undefined);
    }
  }

  render() {
    const p_detailsCardGroupObj = this.props.p_detailsCardGroupObj;
    const p_expandedCaptureTypeDetailsFieldObj = this.props.p_expandedCaptureTypeDetailsFieldObj;
    const p_canResortTF = this.props.p_canResortTF;
    const p_sortNumber = this.props.p_sortNumber;
    const p_isOnlyItemTF = this.props.p_isOnlyItemTF;
    const p_isLastItemTF = this.props.p_isLastItemTF;
    const p_highlightedFieldID = this.props.p_highlightedFieldID;
    const f_onClickHighlightField = this.props.f_onClickHighlightField;

    const k_blueItemCollectionShellItemStylingObj = this.props.AdminMobx.k_blueItemCollectionShellItemStylingObj;
    const c_selectedCaptureTypeObj = this.props.AdminMobx.c_selectedCaptureTypeObj;
    const c_fieldMapOfStage = this.props.DatabaseMobx.c_fieldMapOfStage;

    const s_editingAddedCaptureTypeFieldRecordTF = this.state.s_editingAddedCaptureTypeFieldRecordTF;

    //hover title
    var captureFieldNameTitle = "[Click to edit '" + p_expandedCaptureTypeDetailsFieldObj.fieldDisplayName + "' field options]\n";

    if(p_expandedCaptureTypeDetailsFieldObj.errorIfNotFilledOutTF) {
      captureFieldNameTitle += "\n[B] Field cannot be left blank when creating a new Capture"
    }

    captureFieldNameTitle += "\n[D] Default Value: " + ((p_expandedCaptureTypeDetailsFieldObj.useDefaultTF) ? (p_expandedCaptureTypeDetailsFieldObj.defaultValueMaskSortIfoObjOrUndefined.valueMaskPlainText) : ("--none--"));
    
    if(p_expandedCaptureTypeDetailsFieldObj.private1CaptureManagersOnlyTF || p_expandedCaptureTypeDetailsFieldObj.private2AdminsOnlyTF) {
      captureFieldNameTitle += "\n[pC/pA] Privacy: ";
      if(p_expandedCaptureTypeDetailsFieldObj.private0EveryoneTF) { captureFieldNameTitle += "--none--"; }
      else if(p_expandedCaptureTypeDetailsFieldObj.private1CaptureManagersOnlyTF) { captureFieldNameTitle += "Capture Managers only"; }
      else if(p_expandedCaptureTypeDetailsFieldObj.private2AdminsOnlyTF) { captureFieldNameTitle += "Admins only"; }
    }

    if(p_expandedCaptureTypeDetailsFieldObj.errorIfMultipleSelectedTF) {
      captureFieldNameTitle += "\n[M] Multiple options cannot be selected"
    }

    if(p_expandedCaptureTypeDetailsFieldObj.errorIfSelectedNotAllowedIDsIsFilledOutTF) {
      captureFieldNameTitle += "\n[O] Option(s) cannot be selected: " + p_expandedCaptureTypeDetailsFieldObj.errorIfSelectedNotAllowedOptionDisplayNamesComma;
    }

    captureFieldNameTitle += "\n[Req] Required in " + c_fieldMapOfStage.get("display_name") + ": " + ((p_expandedCaptureTypeDetailsFieldObj.requiredToAdvanceStageTF) ? (p_expandedCaptureTypeDetailsFieldObj.requiredInStageNameMaskSortIfoObj.valueMaskPlainText) : ("--none--"));
    
    //display within drag to resort item shell
    var addedCaptureFieldItemContentComponent = null;
    if(p_expandedCaptureTypeDetailsFieldObj.isBlankSpaceTF) {
      addedCaptureFieldItemContentComponent = (
        <div className="flex11a displayFlexColumnHcVc">
          {"[Blank Space]"}
        </div>
      );
    }
    else if(p_expandedCaptureTypeDetailsFieldObj.isLineBreakTF) {
      addedCaptureFieldItemContentComponent = (
        <div className="flex11a displayFlexColumnVc">
          <div className="borderT1Blue" style={{margin:"0 1.5em"}} />
        </div>
      );
    }
    else {
      addedCaptureFieldItemContentComponent = (
        <>
          {(p_expandedCaptureTypeDetailsFieldObj.field_id > 0) &&
            <HighlightFieldInPoolButton
              p_fieldID={p_expandedCaptureTypeDetailsFieldObj.field_id}
              f_onClickHighlightField={f_onClickHighlightField}
            />
          }
          <div
            className="flex11a displayFlexRow cursorPointer"
            title={captureFieldNameTitle}
            onClick={this.onclick_capture_type_details_card_group_field_item_to_edit}>
            <div className="flex11a displayFlexRowVc lrPad">
              <LibraryReact.NowrapEllipsis>
                {p_expandedCaptureTypeDetailsFieldObj.fieldDisplayName}
              </LibraryReact.NowrapEllipsis>
            </div>
            <AddedFieldOptionIndicator p_letter="B" p_onTF={p_expandedCaptureTypeDetailsFieldObj.errorIfNotFilledOutTF} />
            <AddedFieldOptionIndicator p_letter="D" p_onTF={p_expandedCaptureTypeDetailsFieldObj.useDefaultTF} />
            <AddedFieldOptionIndicator p_letter={((p_expandedCaptureTypeDetailsFieldObj.private2AdminsOnlyTF) ? ("pA") : ("pC"))} p_onTF={p_expandedCaptureTypeDetailsFieldObj.private1CaptureManagersOnlyTF || p_expandedCaptureTypeDetailsFieldObj.private2AdminsOnlyTF} />
            <AddedFieldOptionIndicator p_letter="M" p_onTF={p_expandedCaptureTypeDetailsFieldObj.errorIfMultipleSelectedTF} />
            <AddedFieldOptionIndicator p_letter="O" p_onTF={p_expandedCaptureTypeDetailsFieldObj.errorIfSelectedNotAllowedIDsIsFilledOutTF} />
            <div className="flex00a displayFlexRowVc" style={{flexBasis:"10em", marginLeft:"0.4em"}}>
              <div className="flex00a" style={{flexBasis:"2em", marginRight:"0.2em"}}>
                <font className={((p_expandedCaptureTypeDetailsFieldObj.requiredToAdvanceStageTF) ? ("font09 fontBold fontItalic fontBlue") : ("font09 fontItalic fontTextLightest"))}>{"Req:"}</font>
              </div>
              <div className="flex11a">
                <LibraryReact.NowrapEllipsis>
                  {((p_expandedCaptureTypeDetailsFieldObj.requiredToAdvanceStageTF) ? (p_expandedCaptureTypeDetailsFieldObj.requiredInStageNameMaskSortIfoObj.valueMask) : ("-"))}
                </LibraryReact.NowrapEllipsis>
              </div>
            </div>
          </div>
        </>
      );
    }

    return(
      <div
        id={"adminDetailsAddedFieldRow_" + p_expandedCaptureTypeDetailsFieldObj.field_id}>
      <CEGeneralReact.CEDragToResortItemWithinDbTbl
        p_canResortTF={p_canResortTF}
        p_uniqueString="captureTypeDetailsField"
        p_itemID={p_expandedCaptureTypeDetailsFieldObj.id}
        p_itemSort={((p_canResortTF) ? (p_sortNumber) : (undefined))}
        p_itemSortColumnWidth="3em"
        p_itemSortNumberFontClass={undefined}
        p_isOnlyItemTF={p_isOnlyItemTF}
        p_isLastItemTF={p_isLastItemTF}
        p_outerPadClass={k_blueItemCollectionShellItemStylingObj.outerPadClass}
        p_itemClass="displayFlexRow border bevelBorderColors borderRadius05 bgAlmostWhite hoverLighterBlueGradient"
        p_itemStyleObj={{height:k_blueItemCollectionShellItemStylingObj.rowHeightEm + "em", backgroundColor:((p_highlightedFieldID === p_expandedCaptureTypeDetailsFieldObj.field_id) ? ("#fff4c2") : (undefined))}}
        p_lastItemExtraDropZoneHeight={k_blueItemCollectionShellItemStylingObj.lastItemExtraDropZoneHeightEm + "em"}
        p_dragEntireItemTrueOnlySortNumberFalse={true}
        p_tblName="tbl_a_capture_types_details_fields"
        p_tblSortFieldDbName="sort"
        p_filterFieldNamesArray={["capture_type_id", "group_id"]}
        p_filterValuesArray={[p_expandedCaptureTypeDetailsFieldObj.capture_type_id, p_expandedCaptureTypeDetailsFieldObj.group_id]}>
        {addedCaptureFieldItemContentComponent}
        <div className="flex00a displayFlexColumnHcVc borderL1ddd" style={{flexBasis:"2.5em"}}>
          <CEGeneralReact.RemoveItemXWithRedHover
            p_title={"Remove Capture Field '" + p_expandedCaptureTypeDetailsFieldObj.fieldDisplayName + "' from '" + p_detailsCardGroupObj.name + "' for Capture Type '" + c_selectedCaptureTypeObj.name + "'"}
            f_onClick={this.onclick_remove_field_from_capture_type_details_card_group}
          />
        </div>
        {(s_editingAddedCaptureTypeFieldRecordTF) &&
          <AddedDetailsCardCaptureFieldEditFloatingBox
            p_expandedCaptureTypeDetailsFieldObj={p_expandedCaptureTypeDetailsFieldObj}
            f_onClickClose={this.onclick_close_capture_type_details_card_group_field_item_to_edit}
          />
        }
      </CEGeneralReact.CEDragToResortItemWithinDbTbl>
      </div>
    );
  }
}));

function AddedFieldOptionIndicator(props) { //props: p_letter, p_onTF
  const p_letter = props.p_letter;
  const p_onTF = props.p_onTF;

  return(
    <div className="flex00a displayFlexColumnHcVc" style={{flexBasis:"1.2em"}}>
      {(p_onTF) && 
        <div className="flex00a displayFlexColumnHcVc bgLightGray textCenter" style={{width:"1.1em", height:"1.2em"}}>
          <font className="font09 fontBold fontItalic fontBlue">
            {p_letter}
          </font>
        </div>
      }
    </div>
  )
}


const AddedDetailsCardCaptureFieldEditFloatingBox = inject("CaptureExecMobx", "AdminMobx", "DatabaseMobx")(observer(
class AddedDetailsCardCaptureFieldEditFloatingBox extends Component { //props: p_expandedCaptureTypeDetailsFieldObj, f_onClickClose
  onselect_error_if_not_filled_out = (i_newValue01) => {
    this.update_capture_type_field_record_field_value("error_if_not_filled_out_01", i_newValue01, "i");
  }

  onselect_error_if_multiple_selected = (i_newValue01) => {
    this.update_capture_type_field_record_field_value("error_if_multiple_selected_01", i_newValue01, "i");
  }

  onselect_not_allowed_select_options = (i_selectedNotAllowedOptionIDsComma) => {
    this.update_capture_type_field_record_field_value("error_if_selected_not_allowed_ids_comma", i_selectedNotAllowedOptionIDsComma, "s");
  }

  onswitch_use_default = () => {
    const p_expandedCaptureTypeDetailsFieldObj = this.props.p_expandedCaptureTypeDetailsFieldObj;
    const newUseDefault01 = ((p_expandedCaptureTypeDetailsFieldObj.useDefaultTF) ? (0) : (1));
    this.update_capture_type_field_record_field_value("use_default_01", newUseDefault01, "i");
  }

  onsave_default_value = (i_newValue) => {
    const newDefaultValueString = JSFUNC.num2str(i_newValue);
    this.update_capture_type_field_record_field_value("default_value", newDefaultValueString, "s");
  }

  onswitch_required = () => {
    const p_expandedCaptureTypeDetailsFieldObj = this.props.p_expandedCaptureTypeDetailsFieldObj;
    
    const c_selectedCaptureTypeStageIDsArray = this.props.AdminMobx.c_selectedCaptureTypeStageIDsArray;

    //if switching to on, set the stage to the first stage in this capture type's timeline, otherwise if turning off, set the stage to -1
    var newRec1Req3 = 1;
    var newStageIDRelevant = -1;
    if(p_expandedCaptureTypeDetailsFieldObj.recommended1TF) { //switch recommended to required
      newRec1Req3 = 3;
      if(c_selectedCaptureTypeStageIDsArray.length > 0) {
        newStageIDRelevant = c_selectedCaptureTypeStageIDsArray[0]; //default to first stage when turning on the required flag
      }
    }
    else { //switch required to recommended
      newRec1Req3 = 1;
      newStageIDRelevant = -1;
    }

    this.update_capture_type_field_record_field_value(["rec1_reqsig2_req3", "stage_id_relevant"], [newRec1Req3, newStageIDRelevant], ["i", "i"]);
  }

  onsave_stage_id_relevant = (i_newValue) => {
    this.update_capture_type_field_record_field_value("stage_id_relevant", i_newValue, "i");
  }

  onselect_only_capture_managers_can_view_field = (i_newValue012) => {
    this.update_capture_type_field_record_field_value("only_capture_managers_can_view_field_01", i_newValue012, "i");
  }

  update_capture_type_field_record_field_value = (i_fieldName, i_value, i_idsb) => {
    const p_expandedCaptureTypeDetailsFieldObj = this.props.p_expandedCaptureTypeDetailsFieldObj;
    const allFieldsAddedToDetailsDatesRevenueCardsForSelectedCaptureTypeArrayOfObjs = this.props.AdminMobx.c_allFieldsAddedToDetailsDatesRevenueCardsForSelectedCaptureTypeArrayOfObjs;

    //get all captureTypesDetailsFields rowIDs that match this fieldID for this capture type (keeps requirements/defaults/privacy synchronized across same field added to details/dates/revenue cards)
    var captureTypesDetailsFieldsRowIDsToUpdateArray = [p_expandedCaptureTypeDetailsFieldObj.id]; //start with the id of the row being edited
    for(let allFieldsCaptureTypeDetailsFieldObj of allFieldsAddedToDetailsDatesRevenueCardsForSelectedCaptureTypeArrayOfObjs) {
      if((allFieldsCaptureTypeDetailsFieldObj.id !== p_expandedCaptureTypeDetailsFieldObj.id) && (allFieldsCaptureTypeDetailsFieldObj.field_id === p_expandedCaptureTypeDetailsFieldObj.field_id)) { //if the fieldIDs match, but its not the same entry as the one we're currently editing
        captureTypesDetailsFieldsRowIDsToUpdateArray.push(allFieldsCaptureTypeDetailsFieldObj.id);
      }
    }

    const jsDescription = JSFUNC.js_description_from_action("AdminReact - AddedDetailsCardCaptureFieldEditFloatingBox", "update_capture_type_field_record_field_value", ["i_fieldName", "i_value", "i_idsb"], [i_fieldName, i_value, i_idsb]);
    const C_CallPhpTblUID = new JSPHP.ClassCallPhpTblUID(jsDescription);
    C_CallPhpTblUID.add_update("tbl_a_capture_types_details_fields", captureTypesDetailsFieldsRowIDsToUpdateArray, i_fieldName, i_value, i_idsb);
    C_CallPhpTblUID.execute();
  }

  render() {
    const p_expandedCaptureTypeDetailsFieldObj = this.props.p_expandedCaptureTypeDetailsFieldObj;
    const f_onClickClose = this.props.f_onClickClose;

    const c_productStylingObj = this.props.CaptureExecMobx.c_productStylingObj;
    const c_selectedCaptureTypeObj = this.props.AdminMobx.c_selectedCaptureTypeObj;
    const c_selectStageWithinSelectedCaptureTypeFieldTypeObj = this.props.AdminMobx.c_selectStageWithinSelectedCaptureTypeFieldTypeObj;
    const c_cardNameDetails = this.props.DatabaseMobx.c_cardNameDetails;
    const c_fieldMapOfStage = this.props.DatabaseMobx.c_fieldMapOfStage;

    const stageFieldDisplayName = c_fieldMapOfStage.get("display_name");
    const editItemString = "adminDDF_fID" + p_expandedCaptureTypeDetailsFieldObj.id;

    var fieldIsSelectTF = false;
    var fieldIsMultiSelectTF = false;
    var fieldIsSharedPercentTF = false;
    if(p_expandedCaptureTypeDetailsFieldObj.fieldTypeObj !== undefined) {
      fieldIsSelectTF = p_expandedCaptureTypeDetailsFieldObj.fieldTypeObj.selectTF;
      if(fieldIsSelectTF) {
        if(p_expandedCaptureTypeDetailsFieldObj.fieldTypeObj.selectWithSearchDataObj !== undefined) {
          fieldIsMultiSelectTF = p_expandedCaptureTypeDetailsFieldObj.fieldTypeObj.selectWithSearchDataObj.isMultiSelectTF;
        }
      }
      fieldIsSharedPercentTF = p_expandedCaptureTypeDetailsFieldObj.fieldTypeObj.sharedPercentTF;
    }

    const errorIfNotFilledOutValueArray = [0, 1];
    const errorIfNotFilledOutDisplayArray = ["[default] Field may be saved as empty/unassigned", "New Capture (and edit) will not allow this field to be empty/unassigned"];
    const errorIfNotFilledOutSelectFieldTypeObj = this.props.DatabaseMobx.create_verticalswitch_field_type_obj_from_value_array_and_display_array("Details Field Not Filled Out Option", errorIfNotFilledOutValueArray, false, errorIfNotFilledOutDisplayArray, 1.7);

    const detailsFieldPrivateValueArray = [0, 1, 2];
    const detailsFieldPrivateDisplayArray = ["[default] Field can be viewed by anyone who can access the Capture", "Only assigned Capture Managers of a Capture can view this field and its data", "Only " + c_productStylingObj.productName + " Admins can view this field and its data"];
    const detailsFieldPrivateSelectFieldTypeObj = this.props.DatabaseMobx.create_verticalswitch_field_type_obj_from_value_array_and_display_array("Details Field Privacy Option", detailsFieldPrivateValueArray, false, detailsFieldPrivateDisplayArray, 1.7);
    
    var selectFieldTypesOptionsSectionComponent = null;
    if(fieldIsSelectTF || fieldIsSharedPercentTF) {
      const errorIfMultipleSelectedValueArray = [0, 1];
      const errorIfMultipleSelectedDisplayArray = ["[default] Can select multiple options from multi-select", "Can only select 1 option at most"];
      const errorIfMultipleSelectedSelectFieldTypeObj = this.props.DatabaseMobx.create_verticalswitch_field_type_obj_from_value_array_and_display_array("Details Field Not Filled Out Option", errorIfMultipleSelectedValueArray, false, errorIfMultipleSelectedDisplayArray, 1.7);
  
      const forcedSelectMultiOptionsSwsOptionsObj = {isMultiSelectTF:true, hasSearchTF:true, hasClearSelectionTF:true};
      const forcedSelectMultiOptionsFieldTypeObj = this.props.DatabaseMobx.create_new_copy_field_type_obj_from_old_field_type_obj_and_field_input_type_and_sws_options_obj(p_expandedCaptureTypeDetailsFieldObj.fieldTypeObj, "select", forcedSelectMultiOptionsSwsOptionsObj);
  
      selectFieldTypesOptionsSectionComponent = (
        <>
          <AddedDetailsCardCaptureFieldSectionTitle>
            {"Field Options for Select Field Types"}
          </AddedDetailsCardCaptureFieldSectionTitle>
          {(fieldIsMultiSelectTF || fieldIsSharedPercentTF) &&
            <AddedDetailsCardCaptureFieldOptionContainer p_optionName="[M] Multi-Select" p_optionDescription="Field can select multiple options (Multi-Select or Shared Percent field types only)">
              <CEGeneralReact.GenericInputOrSelectFromInputType
                p_fieldTypeObj={errorIfMultipleSelectedSelectFieldTypeObj}
                p_valueRaw={p_expandedCaptureTypeDetailsFieldObj.error_if_multiple_selected_01}
                f_onChangeOrOnSelect={this.onselect_error_if_multiple_selected}
              />
            </AddedDetailsCardCaptureFieldOptionContainer>
          }
          <AddedDetailsCardCaptureFieldOptionContainer p_optionName="[O] Not Allowed Options" p_optionDescription="Specify select options that are not allowed">
            <div className="bgLightestestGray smallFullPad">
              <CEGeneralReact.CaptureExecFieldEditSaveCancel
                p_ceEditItemString={editItemString + "not"}
                p_fieldDisplayName={undefined}
                p_fieldTypeObj={forcedSelectMultiOptionsFieldTypeObj}
                p_valueRaw={p_expandedCaptureTypeDetailsFieldObj.error_if_selected_not_allowed_ids_comma}
                p_valueMask={((JSFUNC.selectmulti_is_filled_out_tf(p_expandedCaptureTypeDetailsFieldObj.error_if_selected_not_allowed_ids_comma)) ? (undefined) : ("--[default] All Options Allowed--"))}
                p_valueIsEditableTFU={true}
                p_containerClass=""
                p_fieldClass="fontBlue"
                p_fieldWidth="10em"
                f_onSaveChanged={this.onselect_not_allowed_select_options}
              />
            </div>
          </AddedDetailsCardCaptureFieldOptionContainer>
        </>
      );
    }

    return(
      <CEGeneralReact.FloatingBoxWithSaveCancel
        p_trblFlag="addEditDeleteTableEditItem"
        p_title={"Field Options for '" + p_expandedCaptureTypeDetailsFieldObj.fieldDisplayName + "'"}
        f_onClickSave={f_onClickClose}>
        <div className="flex11a yScroll medFullPad">
          <div className="smallBottomMargin border1bbb bgLighterGray smallFullPad">
            <LibraryReact.DivFont p_class="textCenter" p_fontClass="font14 fontBold fontDarkBlue">
              {"Capture Field: '" + p_expandedCaptureTypeDetailsFieldObj.fieldDisplayName + "'"}
            </LibraryReact.DivFont>
            <LibraryReact.DivFont p_class="textCenter" p_fontClass="fontItalic fontTextLight">
              {"Added to " + c_cardNameDetails + " Card for Capture Type"}
            </LibraryReact.DivFont>
            <LibraryReact.DivFont p_class="textCenter" p_fontClass="fontBold fontDarkOrange">
              {c_selectedCaptureTypeObj.name}
            </LibraryReact.DivFont>
          </div>
          <AddedDetailsCardCaptureFieldSectionTitle p_topSpaceTF={false}>
            {"Field Options"}
          </AddedDetailsCardCaptureFieldSectionTitle>
          <AddedDetailsCardCaptureFieldOptionContainer p_optionName="[B] Field not allowed to be blank" p_optionDescription={undefined}>
            <CEGeneralReact.GenericInputOrSelectFromInputType
              p_fieldTypeObj={errorIfNotFilledOutSelectFieldTypeObj}
              p_valueRaw={p_expandedCaptureTypeDetailsFieldObj.error_if_not_filled_out_01}
              f_onChangeOrOnSelect={this.onselect_error_if_not_filled_out}
            />
          </AddedDetailsCardCaptureFieldOptionContainer>
          <AddedDetailsCardCaptureFieldOptionContainer p_optionName="[D] Default Value" p_optionDescription="If this switch is turned on, when a new Capture is created (or imported), this field will have its value automatically filled in with the default value specified here. Otherwise the field will be initialized with a standard empty value.">
            <div className="bgLightestestGray smallFullPad">
              <CEGeneralReact.SwitchWithTextAndConfirmBox
                p_isOnTF={p_expandedCaptureTypeDetailsFieldObj.useDefaultTF}
                p_sizeEm={3}
                p_onText="New Capture initializes Field with Default Value"
                p_offText="[default] Field is Empty in a New Capture"
                f_onSwitch={this.onswitch_use_default}
              />
              {(p_expandedCaptureTypeDetailsFieldObj.useDefaultTF) &&
                <CEGeneralReact.CaptureExecFieldEditSaveCancel
                  p_ceEditItemString={editItemString + "default_value"}
                  p_fieldDisplayName="Default Value"
                  p_fieldTypeObj={p_expandedCaptureTypeDetailsFieldObj.fieldTypeObj}
                  p_valueRaw={this.props.DatabaseMobx.int_decimal_or_string_value_raw_from_string_value_raw_and_field_type_obj(p_expandedCaptureTypeDetailsFieldObj.default_value, p_expandedCaptureTypeDetailsFieldObj.fieldTypeObj)}
                  p_valueIsEditableTFU={true}
                  p_containerClass="medTopMargin"
                  p_fieldClass="fontBlue"
                  p_fieldWidth="7em"
                  f_onSaveChanged={this.onsave_default_value}
                />
              }
            </div>
          </AddedDetailsCardCaptureFieldOptionContainer>
          <AddedDetailsCardCaptureFieldOptionContainer p_optionName="[pC/pA] Privacy" p_optionDescription="Option to hide this field for certain Users">
            <CEGeneralReact.GenericInputOrSelectFromInputType
              p_fieldTypeObj={detailsFieldPrivateSelectFieldTypeObj}
              p_valueRaw={p_expandedCaptureTypeDetailsFieldObj.only_capture_managers_can_view_field_01}
              f_onChangeOrOnSelect={this.onselect_only_capture_managers_can_view_field}
            />
          </AddedDetailsCardCaptureFieldOptionContainer>
          {selectFieldTypesOptionsSectionComponent}
          <AddedDetailsCardCaptureFieldSectionTitle>
            {"Required to Advance " + stageFieldDisplayName}
          </AddedDetailsCardCaptureFieldSectionTitle>
          <AddedDetailsCardCaptureFieldOptionContainer p_optionName={"[Req] Required to be filled out to advance " + stageFieldDisplayName} p_optionDescription={"Marking a field as 'required' in a specified " + stageFieldDisplayName + " means that if a Capture is in that " + stageFieldDisplayName + " and this field is not filled out, the system prevents advancing to any further " + stageFieldDisplayName + " until this field is filled out."}>
            <div className="bgLightestestGray smallFullPad">
              <CEGeneralReact.SwitchWithTextAndConfirmBox
                p_isOnTF={p_expandedCaptureTypeDetailsFieldObj.required3TF}
                p_onText={"Field is required to be filled out to advance past selected " + stageFieldDisplayName}
                p_offText={"[default] Field is not required to advance " + stageFieldDisplayName}
                f_onSwitch={this.onswitch_required}
              />
              {(p_expandedCaptureTypeDetailsFieldObj.required3TF) &&
                <CEGeneralReact.CaptureExecFieldEditSaveCancel
                  p_ceEditItemString={editItemString + "stage_id_relevant"}
                  p_fieldDisplayName={stageFieldDisplayName}
                  p_fieldTypeObj={c_selectStageWithinSelectedCaptureTypeFieldTypeObj}
                  p_valueRaw={p_expandedCaptureTypeDetailsFieldObj.stage_id_relevant}
                  p_valueIsEditableTFU={true}
                  p_containerClass="medTopMargin"
                  p_fieldClass="fontBlue"
                  p_fieldWidth="7em"
                  f_onSaveChanged={this.onsave_stage_id_relevant}
                />
              }
            </div>
          </AddedDetailsCardCaptureFieldOptionContainer>
        </div>
      </CEGeneralReact.FloatingBoxWithSaveCancel>
    );
  }
}));

function AddedDetailsCardCaptureFieldSectionTitle(props) { //props: p_topSpaceTF, children
  const p_topSpaceTF = JSFUNC.prop_value(props.p_topSpaceTF, false);
  const children = props.children;

  return(
    <div className={((p_topSpaceTF) ? ("massiveTopMargin") : ("")) + " microBottomMargin borderT1bbb borderB1bbb bgDarkBlue smallFullPad"}>
      <font className="font12 fontWhite">
        {children}
      </font>
    </div>
  );
}

function AddedDetailsCardCaptureFieldOptionContainer(props) { //props: p_optionName, p_optionDescription, children
  const p_optionName = props.p_optionName;
  const p_optionDescription = props.p_optionDescription;
  const children = props.children;

  return(
    <div className="smallTopMargin bigBottomMargin border1bbb borderRadius05 bgLightGray medFullPad" style={{marginLeft:"0.6em"}}>
      {JSFUNC.string_is_filled_out_tf(p_optionName) &&
        <LibraryReact.DivFont p_class="microBottomMargin" p_fontClass="fontBold">
          {p_optionName}
        </LibraryReact.DivFont>
      }
      {JSFUNC.string_is_filled_out_tf(p_optionDescription) &&
        <LibraryReact.DivFont p_class="smallBottomMargin" p_fontClass="fontItalic">
          {p_optionDescription}
        </LibraryReact.DivFont>
      }
      {children}
    </div>
  );
}












//=================================================================================================================================================================
//=================================================================================================================================================================



export const AdminSubtabDetailsFieldsOptions = inject("CaptureExecMobx", "AdminMobx", "DatabaseMobx")(observer(
class AdminSubtabDetailsFieldsOptions extends Component { //props: none
  constructor(props) {
    super(props);
    this.state = {
      s_exampleIDIQVehicleCaptureID: -1,
      s_exampleCapturePriorityLevelID: 1,
      s_exampleCaptureFavoriteTF: true
    }
  }

  onclick_admin_contact_tab = (i_newValue) => {
    this.props.AdminMobx.a_set_details_fields_options_selected_subtab(i_newValue);
  }

  onswitch_bit_master_set_asides_only_short_names = (i_newValue01) => {
    this.props.AdminMobx.a_update_tbl_a_company_fields("bit_master_set_asides_only_short_names_01", i_newValue01, "i");
  }

  onswitch_bit_master_naics_codes_only6digits = (i_newValue01) => {
    this.props.AdminMobx.a_update_tbl_a_company_fields("bit_master_naics_codes_all0_only6digit1", i_newValue01, "i");
  }

  onsave_bit_master_naics_codes_ranges_comma = (i_newValue) => {
    this.props.AdminMobx.a_update_tbl_a_company_fields("bit_master_naics_codes_ranges_comma", i_newValue, "s");
  }

  onselect_company_idiq_vehicle_wins_filter = (i_selectedIDIQFilteringOption012) => {
    this.props.AdminMobx.a_update_tbl_a_company_fields("idiq_vehicle_wins0_winsandactive1", i_selectedIDIQFilteringOption012, "i");
  }

  onchange_example_idiq_capture_id = (i_newValueInt) => {
    this.setState({s_exampleIDIQVehicleCaptureID:i_newValueInt});
  }

  onselect_example_capture_priority_level = (i_newValueInt) => {
    this.setState({s_exampleCapturePriorityLevelID:i_newValueInt});
  }

  onsave_capture_favorites_color = (i_selectedColorString) => {
    this.props.AdminMobx.a_update_tbl_a_company_fields("capture_favorites_color", i_selectedColorString, "s");
  }

  onclick_example_capture_favorite = (i_newValueTF) => {
    this.setState({s_exampleCaptureFavoriteTF:i_newValueTF});
  }

  render() {
    const s_exampleIDIQVehicleCaptureID = this.state.s_exampleIDIQVehicleCaptureID;

    const c_productStylingObj = this.props.CaptureExecMobx.c_productStylingObj;
    const o_detailsFieldsOptionsSelectedSubtab = this.props.AdminMobx.o_detailsFieldsOptionsSelectedSubtab;
    const c_fieldMapOfIdiqCaptureIDTOLink = this.props.DatabaseMobx.c_fieldMapOfIdiqCaptureIDTOLink;

    const idiqCaptureIDTOLinkFieldDisplayName = c_fieldMapOfIdiqCaptureIDTOLink.get("display_name");

    var tabTitle = undefined;
    var tabHelpLinesArray = [];
    var adminDetailsFieldsOptionsPageComponent = null;
    if(o_detailsFieldsOptionsSelectedSubtab === "competitionTypeSBCertsMasterTbl") {
      const c_bitMasterSetAsidesSamAlphabeticTopCustomSortedBottomDuplicatesRemovedArrayOfObjs = this.props.AdminMobx.c_bitMasterSetAsidesSamAlphabeticTopCustomSortedBottomDuplicatesRemovedArrayOfObjs;
      const c_companyBitMasterSetAsidesOnlyShortNames01 = this.props.DatabaseMobx.c_companyBitMasterSetAsidesOnlyShortNames01;
      const c_companyBitMasterSetAsidesOnlyShortNamesTF = this.props.DatabaseMobx.c_companyBitMasterSetAsidesOnlyShortNamesTF;

      tabTitle = "BIT Master Competition Type Set-Asides Table";
      tabHelpLinesArray = [
        "This table of Set-Asides (used to specify both Competition Type for opportunities and Small Business Certifications for Contact Companies) is kept at an uneditable Master level in " + c_productStylingObj.productName + ".",
        "You can use the checkboxes below to reduce the list of options presented to users when filling out the field."
      ];

      const setAsidesFullNamesOption0 = "[default] Display full Set-Aside names when appropriate in " + c_productStylingObj.productName + " (uses short name/abbreviation in small spaces)";
      const setAsidesAbbrNamesOption1 = "Always use short names/abbreviations when displaying or selecting Set-Aside values in " + c_productStylingObj.productName;

      adminDetailsFieldsOptionsPageComponent = (
        <>
          <div className="flex00a borderT1ddd borderB1ddd tbPad" style={{width:"70em"}}>
            <div className="microBottomMargin">
              <font className="fontItalic fontTextLighter">
                {"Use this switch below to control whether selected Set-Asides display their full name when possible, or if they always use their abbreviated name."}
              </font>
            </div>
            <div className="" style={{maxWidth:"61em"}}>
              <CEGeneralReact.GenericInputOrSelectFromInputType
                p_fieldTypeObj={this.props.DatabaseMobx.create_verticalswitch_field_type_obj_from_value_array_and_display_array("Set-Asides Display Option", [0, 1], false, [setAsidesFullNamesOption0, setAsidesAbbrNamesOption1], 1.9)}
                p_valueRaw={c_companyBitMasterSetAsidesOnlyShortNames01}
                f_onChangeOrOnSelect={this.onswitch_bit_master_set_asides_only_short_names}
              />
            </div>
          </div>
          <AdminBitMasterTblCheckboxes
            p_tblACompanyIDsToNotIncludeCommaFieldName="bit_master_set_aside_ids_to_not_include_comma"
            p_hiddenUnlessCheckedTFFieldName="setAsideHiddenUnlessCheckedTF"
            p_tblDataArrayOfObjs={c_bitMasterSetAsidesSamAlphabeticTopCustomSortedBottomDuplicatesRemovedArrayOfObjs}
            p_tblDataNameFieldName={((c_companyBitMasterSetAsidesOnlyShortNamesTF) ? ("computedShortName") : ("bracketsShortNameName"))}
            p_tblRowIDsToNotIncludeArray={this.props.DatabaseMobx.c_companyBitMasterSetAsideIDsToNotIncludeArray}
          />
        </>
      );
    }
    else if(o_detailsFieldsOptionsSelectedSubtab === "naicsCodes") {
      const numNaicsCodesNotHidden = this.props.AdminMobx.c_bitMasterNaicsCombinedNamesNotHiddenArray.length;

      tabTitle = "BIT Master NAICS Codes Table";
      tabHelpLinesArray = [
        "This table of NAICS Codes used in " + c_productStylingObj.productName + " is kept at an uneditable Master level.",
        "Using this tool below, you can filter and minimize the list of NAICS Code choices to pick from throughout the system by specifying which ranges of codes you would like."
      ];

      adminDetailsFieldsOptionsPageComponent = (
        <>
          <div className="flex00a displayFlexRow borderT1ddd borderB1ddd tbPad">
            <div className="flex11a lrMedPad borderR1bbb" style={{flexBasis:"100em"}}>
              <LibraryReact.DivFont p_class="smallBottomMargin" p_fontClass="fontItalic fontTextLighter">
                {"Choose whether to include all NAICS Codes, or to filter the list to only include the 6-digit codes"}
              </LibraryReact.DivFont>
              <CEGeneralReact.GenericInputOrSelectFromInputType
                p_fieldTypeObj={this.props.DatabaseMobx.create_verticalswitch_field_type_obj_from_value_array_and_display_array("NAICS Inclusion Option", [0, 1], false, ["[default] Include all NAICS Codes (2, 3, 4, 5, and 6 digit codes)", "Only include 6-digit NAICS Codes"], 1.9)}
                p_valueRaw={this.props.DatabaseMobx.c_companyBitMasterNaicsCodesAll0Only6Digit1}
                f_onChangeOrOnSelect={this.onswitch_bit_master_naics_codes_only6digits}
              />
            </div>
            <div className="flex11a lrMedPad" style={{flexBasis:"150em"}}>
              <LibraryReact.DivFont p_class="smallBottomMargin" p_fontClass="fontItalic fontTextLight">
                {"Use all 6 digit codes when specifying ranges. Blank input means every NAICS code is included. [Example: 541000-699999,800000-899999]"}
              </LibraryReact.DivFont>
              <CEGeneralReact.CaptureExecFieldEditSaveCancel
                p_ceEditItemString="adminBudgetsApprovalNumDays"
                p_fieldDisplayName="Master NAICS Codes Table Minimization Code Ranges"
                p_fieldTypeObj={this.props.DatabaseMobx.c_genericTextFieldTypeObj}
                p_valueRaw={this.props.DatabaseMobx.c_companyBitMasterNaicsCodesRangesComma}
                p_valueIsEditableTFU={true}
                p_fieldClass="fontBlue"
                p_fieldWidth="14em"
                f_onSaveChanged={this.onsave_bit_master_naics_codes_ranges_comma}
              />
            </div>
          </div>
          <div className="flex00a microBottomMargin textRight">
            <font className="font12 fontBold fontTextLighter">
              {numNaicsCodesNotHidden + " NAICS " + JSFUNC.plural(numNaicsCodesNotHidden, "Code", "Codes")}
            </font>
          </div>
          <div className="flex11a yScroll medBottomMargin border1bbb bgLightestGray medFullPad">
            {this.props.AdminMobx.c_bitMasterNaicsCombinedNamesNotHiddenArray.map((m_naicsCombinedName) =>
              <LibraryReact.DivFont p_fontClass="">
                {m_naicsCombinedName}
              </LibraryReact.DivFont>
            )}
          </div>
        </>
      );
    }
    else if(o_detailsFieldsOptionsSelectedSubtab === "productServiceCodesMasterTbl") {
      tabTitle = "BIT Master Product Service Codes (PSC)";
      tabHelpLinesArray = [
        "This table of Product Service Codes used in " + c_productStylingObj.productName + " is kept at an uneditable Master level.",
        "You can use the checkboxes below to reduce the list of options presented to users when filling out the field."
      ];

      adminDetailsFieldsOptionsPageComponent = (
        <AdminBitMasterTblCheckboxes
          p_tblACompanyIDsToNotIncludeCommaFieldName="bit_master_product_service_code_ids_to_not_include_comma"
          p_hiddenUnlessCheckedTFFieldName="productServiceCodeHiddenUnlessCheckedTF"
          p_tblDataArrayOfObjs={this.props.AdminMobx.c_bitMasterProductServiceCodesArrayOfObjs}
          p_tblDataNameFieldName="code"
          p_tblRowIDsToNotIncludeArray={this.props.DatabaseMobx.c_companyBitMasterProductServiceCodeIDsToNotIncludeArray}
        />
      );
    }
    else if(o_detailsFieldsOptionsSelectedSubtab === "departmentsAgenciesMasterTbl") {
      tabTitle = "BIT Master Departments/Agencies Table";
      tabHelpLinesArray = [
        "This table of Departments/Agencies used in " + c_productStylingObj.productName + " is kept at an uneditable Master level.",
        "You can use the checkboxes below to reduce the list of options presented to users when filling out the field."
      ];

      adminDetailsFieldsOptionsPageComponent = (
        <AdminBitMasterTblCheckboxes
          p_tblACompanyIDsToNotIncludeCommaFieldName="bit_master_depts_ags_ids_to_not_include_comma"
          p_hiddenUnlessCheckedTFFieldName="departmentAgencyHiddenUnlessCheckedTF"
          p_tblDataArrayOfObjs={this.props.AdminMobx.c_bitMasterDepartmentsAgenciesArrayOfObjs}
          p_tblDataNameFieldName="name"
          p_tblRowIDsToNotIncludeArray={this.props.DatabaseMobx.c_companyBitMasterDepartmentsAgenciesIDsToNotIncludeArray}
        />
      );
    }
    else if(o_detailsFieldsOptionsSelectedSubtab === "subTiersMasterTbl") {
      tabTitle = "BIT Master Sub-Tiers Table";
      tabHelpLinesArray = [
        "This table of Sub-Tiers used in " + c_productStylingObj.productName + " is kept at an uneditable Master level.",
        "You can use the checkboxes below to reduce the list of options presented to users when filling out the field."
      ];

      adminDetailsFieldsOptionsPageComponent = (
        <AdminBitMasterTblCheckboxes
          p_tblACompanyIDsToNotIncludeCommaFieldName="bit_master_subtiers_ids_to_not_include_comma"
          p_hiddenUnlessCheckedTFFieldName="subTierHiddenUnlessCheckedTF"
          p_tblDataArrayOfObjs={this.props.AdminMobx.c_bitMasterSubTiersArrayOfObjs}
          p_tblDataNameFieldName="displayName"
          p_tblRowIDsToNotIncludeArray={this.props.DatabaseMobx.c_companyBitMasterSubTiersIDsToNotIncludeArray}
        />
      );
    }
    else if(o_detailsFieldsOptionsSelectedSubtab === "idiqVehicleFieldOptions") {
      const c_companyIDIQVehicleWins0WinsAndActive1 = this.props.DatabaseMobx.c_companyIDIQVehicleWins0WinsAndActive1;
      const idiqCategoryDetailsArrayOfObjs = this.props.DatabaseMobx.c_idiqCategoryDetailsArrayOfObjs;

      tabTitle = "'" + idiqCaptureIDTOLinkFieldDisplayName + "' as a Details Field";
      tabHelpLinesArray = [
        "The " + c_productStylingObj.productName + " System field '" + idiqCaptureIDTOLinkFieldDisplayName + "' is used in Task Order type Captures to link them to an existing IDIQ type Capture as its vehicle",
        "You can use the switch below to specify when choosing from the list of IDIQ Captures if all Active and Won IDIQs are included, or only Won IDIQs [the default setting]."
      ];

      const idiqListOptions012Array = [0, 1, 2];
      const idiqListOptionsDisplayArray = ["Won IDIQs Only", "Won and Active IDIQs Shown", "All IDIQs Shown"];
      adminDetailsFieldsOptionsPageComponent = (
        <>
          <div className="flex00a borderT1ddd borderB1ddd tbMedPad" style={{width:"40em"}}>
            <LibraryReact.DivFont p_class="smallBottomMargin" p_fontClass="fontBold fontTextLighter">
              {"Specify how IDIQs are filtered when selecting the IDIQ Vehicle for a Task Order type Capture"}
            </LibraryReact.DivFont>
            <div style={{maxWidth:"20em"}}>
              <CEGeneralReact.GenericInputOrSelectFromInputType
                p_fieldTypeObj={this.props.DatabaseMobx.create_verticalswitch_field_type_obj_from_value_array_and_display_array("IDIQ List Option", idiqListOptions012Array, false, idiqListOptionsDisplayArray, 1.9)}
                p_valueRaw={c_companyIDIQVehicleWins0WinsAndActive1}
                f_onChangeOrOnSelect={this.onselect_company_idiq_vehicle_wins_filter}
              />
            </div>
          </div>
          <div className="flex00a displayFlexRow hugeTopMargin">
            <div className="flex00a" style={{flexBasis:"40em"}}>
              <div className="border1bbb borderRadius05 bgLighterGray bigFullPad">
                <LibraryReact.DivFont p_class="smallBottomMargin" p_fontClass="fontItalic fontTextLight">
                  {"Example " + idiqCaptureIDTOLinkFieldDisplayName + " field options filtered using the selected setting above:"}
                </LibraryReact.DivFont>
                <CEGeneralReact.GenericInputOrSelectFromInputType
                  p_fieldTypeObj={c_fieldMapOfIdiqCaptureIDTOLink.get("fieldTypeObj")}
                  p_valueRaw={s_exampleIDIQVehicleCaptureID}
                  f_onChangeOrOnSelect={this.onchange_example_idiq_capture_id}
                />
              </div>
            </div>
            <div className="flex00a" style={{flexBasis:"5em"}} />
            <div className="flex00a" style={{flexBasis:"30em"}}>
              <LibraryReact.DivFont p_class="smallBottomMargin textCenter" p_fontClass="fontBold">
                {idiqCaptureIDTOLinkFieldDisplayName + " Selection Color Legend"}
              </LibraryReact.DivFont>
              {idiqCategoryDetailsArrayOfObjs.map((idiqCategoryDetailsObj) =>
                <div key={idiqCategoryDetailsObj.idiqCategoryNumber} className="displayFlexColumnHcVc border1bbb tbMicroPad lrMedPad textCenter" style={{height:"2.8em", backgroundColor:"#" + idiqCategoryDetailsObj.bgColor}}>
                  <font>
                    {idiqCategoryDetailsObj.description}
                  </font>
                </div>
              )}
            </div>
          </div>
        </>
      );
    }
    else if(o_detailsFieldsOptionsSelectedSubtab === "priorityFavorites") {
      const c_companyCaptureFavoritesColor = this.props.DatabaseMobx.c_companyCaptureFavoritesColor;
      const c_fieldMapOfCaptureFavorites = this.props.DatabaseMobx.c_fieldMapOfCaptureFavorites;
      const c_fieldMapOfCapturePriorityLevel = this.props.DatabaseMobx.c_fieldMapOfCapturePriorityLevel;

      const captureFavoritesFieldDisplayName = c_fieldMapOfCaptureFavorites.get("display_name");
      const capturePriorityLevelFieldDisplayName = c_fieldMapOfCapturePriorityLevel.get("display_name");

      const capturePriorityLevelsAedTableObj = {
        tblName: "tbl_a_capture_priority_levels",
        dragToResortFieldDbName: "sort",
        initialSortedFieldDbName: "sort",
        tableWidth: "100%",
        itemName: "Priority Level",
        deleteItemNameFieldDbName: "name",
        fieldsArrayOfObjs: [
          {width:"250em", dbName:"name", displayName:"Name", fieldTypeObj:this.props.DatabaseMobx.c_genericTextFieldTypeObj, requiredNotEmptyTF:true},
          {width:"100em", dbName:"color", displayName:"Color", fieldTypeObj:this.props.DatabaseMobx.c_genericColorFieldTypeObj, initialValue:"cccccc", requiredNotEmptyTF:true}
        ]
      };

      adminDetailsFieldsOptionsPageComponent = (
        <div className="displayFlexRow flexWrap">
          <div className="flex00a tbMedMargin borderR1bbb lrHugePad" style={{flexBasis:"53em"}}>
            <LibraryReact.DivFont p_class="smallBottomMargin textCenter" p_fontClass="font14">
              {"Capture field: '" + capturePriorityLevelFieldDisplayName + "'"}
            </LibraryReact.DivFont>
            <LibraryReact.DivFont p_class="medBottomMargin" p_fontClass="font12 fontBold fontTextLight">
              {"Specify the number, colors, and order of priority levels that can be set for a Capture"}
            </LibraryReact.DivFont>
            <div className="displayFlexRow">
              <div className="flex11a">
                <CEComplexReact.AddEditDeleteTable
                  p_dataArrayOfObjs={this.props.DatabaseMobx.c_capturePriorityLevelsArrayOfObjs}
                  p_aedTableObj={capturePriorityLevelsAedTableObj}
                />
              </div>
              <div className="flex00a lrBigMargin" style={{flexBasis:"9em"}}>
                <LibraryReact.DivFont p_class="smallBottomMargin textCenter" p_fontClass="fontItalic fontTextLight">
                  {"Interactive example of this field"}
                </LibraryReact.DivFont>
                <div className="displayFlexColumnHcVc">
                  <CEGeneralReact.GenericInputOrSelectFromInputType
                    p_valueRaw={this.state.s_exampleCapturePriorityLevelID}
                    p_fieldTypeObj={c_fieldMapOfCapturePriorityLevel.get("fieldTypeObj")}
                    f_onChangeOrOnSelect={this.onselect_example_capture_priority_level}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="flex00a tbMedMargin lrHugePad" style={{flexBasis:"53em"}}>
            <LibraryReact.DivFont p_class="smallBottomMargin textCenter" p_fontClass="font14">
              {"Capture field: '" + captureFavoritesFieldDisplayName + "'"}
            </LibraryReact.DivFont>
            <LibraryReact.DivFont p_class="medBottomMargin" p_fontClass="font12 fontBold fontTextLight">
              {"Specify the icon color when a User favorites a Capture for themselves"}
            </LibraryReact.DivFont>
            <div className="displayFlexRow">
              <div className="flex11a">
                <div className="border1bbb borderRadius05 medFullPad">
                  <CEGeneralReact.CaptureExecFieldEditSaveCancel
                    p_ceEditItemString="adminCaptureFavoritesColor"
                    p_fieldDisplayName="Capture Favorites Color"
                    p_fieldTypeObj={this.props.DatabaseMobx.c_genericColorFieldTypeObj}
                    p_valueRaw={c_companyCaptureFavoritesColor}
                    p_valueIsEditableTFU={true}
                    p_fieldClass="fontBlue"
                    p_fieldWidth="12em"
                    f_onSaveChanged={this.onsave_capture_favorites_color}
                  />
                </div>
              </div>
              <div className="flex00a lrBigMargin" style={{flexBasis:"9em"}}>
                <LibraryReact.DivFont p_class="smallBottomMargin textCenter" p_fontClass="fontItalic fontTextLight">
                  {"Interactive example of this field"}
                </LibraryReact.DivFont>
                <div className="displayFlexColumnHcVc">
                  <CEGeneralReact.GenericInputOrSelectFromInputType
                    p_valueRaw={this.state.s_exampleCaptureFavoriteTF}
                    p_fieldTypeObj={c_fieldMapOfCaptureFavorites.get("fieldTypeObj")}
                    f_onChangeOrOnSelect={this.onclick_example_capture_favorite}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    }


    return(
      <>
        <div className="flex00a smallFullPad">
          <CEGeneralReact.TabsList
            p_tabDbNamesArray={["competitionTypeSBCertsMasterTbl", "naicsCodes", "productServiceCodesMasterTbl", "departmentsAgenciesMasterTbl", "subTiersMasterTbl", "idiqVehicleFieldOptions", "priorityFavorites"]}
            p_tabDisplayNamesArray={["Competition Type Set-Asides", "NAICS Codes", "Product Service Codes", "Departments/Agencies", "Sub-Tiers", idiqCaptureIDTOLinkFieldDisplayName, "Capture Priority / Favorites"]}
            p_selectedTabDbName={o_detailsFieldsOptionsSelectedSubtab}
            p_tabHeight="2.4em"
            p_textMaxHeight="2.2em"
            p_tabWidth="17em"
            p_unselectedFontClass="font11 fontBold fontTextLight"
            p_unselectedBgClass="bgLighterGrayGradient hoverLighterBlueGradient fontTextLight"
            p_selectedBgClass="bgGoldGradient"
            f_onSelect={this.onclick_admin_contact_tab}
          />
        </div>
        {(tabTitle !== undefined) &&
          <div className="flex00a tbMargin lrMedPad">
            <LibraryReact.DivFont p_class="microBottomMargin" p_fontClass="font11 fontBold">
              {tabTitle}
            </LibraryReact.DivFont>
            <LibraryReact.DivFont p_fontClass="fontTextLight">
              {tabHelpLinesArray.map((m_tabHelpLine) =>
                <div>{m_tabHelpLine}</div>
              )}
            </LibraryReact.DivFont>
          </div>
        }
        <div className="flex11a displayFlexColumn medFullPad">
          {adminDetailsFieldsOptionsPageComponent}
        </div>
      </>
    );
  }
}));


class AdminBitMasterTblCheckboxes extends Component { //props: p_tblACompanyIDsToNotIncludeCommaFieldName, p_hiddenUnlessCheckedTFFieldName, p_tblDataArrayOfObjs, p_tblDataNameFieldName, p_tblRowIDsToNotIncludeArray
  constructor(props) {
    super(props);
    this.state = {
      s_searchFilterText: "",
      s_onlyShowCheckedTF: false
    }
  }

  onclick_only_show_checked = () => {
    const s_onlyShowCheckedTF = this.state.s_onlyShowCheckedTF;
    this.setState({s_onlyShowCheckedTF:!s_onlyShowCheckedTF});
  }

  onchange_search_filter_text = (i_newValueString) => {
    this.setState({s_searchFilterText:i_newValueString});
  }

  onclick_check_all = () => {
    const p_tblACompanyIDsToNotIncludeCommaFieldName = this.props.p_tblACompanyIDsToNotIncludeCommaFieldName;

    const jsDescription = JSFUNC.js_description_from_action("AdminReact - AdminBitMasterTblCheckboxes", "onclick_check_all", [], []);
    const C_CallPhpTblUID = new JSPHP.ClassCallPhpTblUID(jsDescription);
    C_CallPhpTblUID.add_update("tbl_a_company", 1, p_tblACompanyIDsToNotIncludeCommaFieldName, "", "s");
    C_CallPhpTblUID.execute();
  }

  onclick_uncheck_all = () => {
    const p_tblACompanyIDsToNotIncludeCommaFieldName = this.props.p_tblACompanyIDsToNotIncludeCommaFieldName;
    const p_tblDataArrayOfObjs = this.props.p_tblDataArrayOfObjs;

    const allRowIDsArray = JSFUNC.get_column_vector_from_arrayOfObjs(p_tblDataArrayOfObjs, "id");
    const allRowIDsComma = JSFUNC.convert_array_to_comma_list(allRowIDsArray);

    const jsDescription = JSFUNC.js_description_from_action("AdminReact - AdminBitMasterTblCheckboxes", "onclick_uncheck_all", [], []);
    const C_CallPhpTblUID = new JSPHP.ClassCallPhpTblUID(jsDescription);
    C_CallPhpTblUID.add_update("tbl_a_company", 1, p_tblACompanyIDsToNotIncludeCommaFieldName, allRowIDsComma, "s");
    C_CallPhpTblUID.execute();
  }

  render() {
    const s_onlyShowCheckedTF = this.state.s_onlyShowCheckedTF;
    const s_searchFilterText = this.state.s_searchFilterText;

    const p_tblACompanyIDsToNotIncludeCommaFieldName = this.props.p_tblACompanyIDsToNotIncludeCommaFieldName;
    const p_hiddenUnlessCheckedTFFieldName = this.props.p_hiddenUnlessCheckedTFFieldName;
    const p_tblDataArrayOfObjs = this.props.p_tblDataArrayOfObjs;
    const p_tblDataNameFieldName = this.props.p_tblDataNameFieldName;
    const p_tblRowIDsToNotIncludeArray = this.props.p_tblRowIDsToNotIncludeArray;

    const searchFilterFilledOutTF = JSFUNC.string_is_filled_out_tf(s_searchFilterText);
    var p_searchFilterTextLowercase = "";
    if(searchFilterFilledOutTF) {
      p_searchFilterTextLowercase = s_searchFilterText.toLowerCase();
    }

    return(
      <div className="flex11a medFullMargin border1bbb bgLighterGray smallFullPad yScroll">
        <div className="flex00a displayFlexRowVc smallBottomMargin">
          <div className="flex00a" style={{flexBasis:"20em"}}>
            <CEGeneralReact.SearchInputTextWithClearX
              p_inputText={s_searchFilterText}
              p_placeholderText="Search BIT Master Table Items"
              p_includeSearchIconTF={true}
              p_heightEm={undefined}
              p_bgHashColor="#fbfbfb"
              p_tabIndex={undefined}
              f_onChange={this.onchange_search_filter_text}
            />
          </div>
          <div className="flex11a" />
          <div className="flex00a displayFlexRowVc lrMedPad cursorPointer" onClick={this.onclick_only_show_checked}>
            <div className="flex00a smallRightMargin">
              <font className="">
                {"Only Show Checked?"}
              </font>
            </div>
            <div className="flex00a">
              <LibraryReact.CheckBox
                p_u0_s1_p2_du3_ds4={((s_onlyShowCheckedTF) ? (1) : (0))}
                p_sizeEm={1.2}
              />
            </div>
          </div>
          <div className="flex00a lrMedPad">
            <CEGeneralReact.ButtonWithConfirmBox
              p_buttonType="add"
              p_buttonText="Check All"
              p_confirmType="confirm"
              p_confirmMessage="Are you sure you want to check all options?"
              f_onClickConfirm={this.onclick_check_all}
            />
          </div>
          <div className="flex00a lrMedPad">
            <CEGeneralReact.ButtonWithConfirmBox
              p_buttonType="add"
              p_buttonText="Uncheck All"
              p_confirmType="confirm"
              p_confirmMessage="Are you sure you want to uncheck all options?"
              f_onClickConfirm={this.onclick_uncheck_all}
            />
          </div>
        </div>
        {p_tblDataArrayOfObjs.map((m_tblDataObj) =>
          ((!searchFilterFilledOutTF || (JSFUNC.input_string_converted_to_lowercase_contains_lowercase_search_term_string_tf(m_tblDataObj[p_tblDataNameFieldName], p_searchFilterTextLowercase))) && (!s_onlyShowCheckedTF || (!m_tblDataObj[p_hiddenUnlessCheckedTFFieldName]))) &&
          <AdminBitMasterTblCheckboxesSingleRow
            p_tblACompanyIDsToNotIncludeCommaFieldName={p_tblACompanyIDsToNotIncludeCommaFieldName}
            p_hiddenUnlessCheckedTFFieldName={p_hiddenUnlessCheckedTFFieldName}
            p_tblDataObj={m_tblDataObj}
            p_tblDataNameFieldName={p_tblDataNameFieldName}
            p_tblRowIDsToNotIncludeArray={p_tblRowIDsToNotIncludeArray}
          />
        )}
      </div>
    );
  }
}


const AdminBitMasterTblCheckboxesSingleRow = inject("AdminMobx")(observer(
class AdminBitMasterTblCheckboxesSingleRow extends Component { //props: p_tblACompanyIDsToNotIncludeCommaFieldName, p_hiddenUnlessCheckedTFFieldName, p_tblDataObj, p_tblDataNameFieldName, p_tblRowIDsToNotIncludeArray
  onclick_bit_master_tbl_item_checkbox = () => {
    const p_tblACompanyIDsToNotIncludeCommaFieldName = this.props.p_tblACompanyIDsToNotIncludeCommaFieldName;
    const p_hiddenUnlessCheckedTFFieldName = this.props.p_hiddenUnlessCheckedTFFieldName;
    const p_tblDataObj = this.props.p_tblDataObj;
    const p_tblRowIDsToNotIncludeArray = this.props.p_tblRowIDsToNotIncludeArray;

    const addIDTrueRemoveIDFalse = (!(p_tblDataObj[p_hiddenUnlessCheckedTFFieldName]));
    var updatedIDsToNotIncludeArray = [];
    if(addIDTrueRemoveIDFalse) { //mark this row as hidden (unchecked)
      updatedIDsToNotIncludeArray = JSFUNC.concat_arrays_or_values_into_new_array(p_tblRowIDsToNotIncludeArray, p_tblDataObj.id);
    }
    else { //mark this row as visible (checked)
      updatedIDsToNotIncludeArray = JSFUNC.remove_all_values_from_array(p_tblDataObj.id, p_tblRowIDsToNotIncludeArray);
    }

    const updatedIDsToNotIncludeComma = JSFUNC.convert_array_to_comma_list(updatedIDsToNotIncludeArray);

    const jsDescription = JSFUNC.js_description_from_action("AdminReact - AdminBitMasterTblCheckboxesSingleRow", "onclick_bit_master_tbl_item_checkbox", [], []);
    const C_CallPhpTblUID = new JSPHP.ClassCallPhpTblUID(jsDescription);
    C_CallPhpTblUID.add_update("tbl_a_company", 1, p_tblACompanyIDsToNotIncludeCommaFieldName, updatedIDsToNotIncludeComma, "s");
    C_CallPhpTblUID.execute();
  }

  render() {
    const p_tblACompanyIDsToNotIncludeCommaFieldName = this.props.p_tblACompanyIDsToNotIncludeCommaFieldName;
    const p_hiddenUnlessCheckedTFFieldName = this.props.p_hiddenUnlessCheckedTFFieldName;
    const p_tblDataObj = this.props.p_tblDataObj;
    const p_tblDataNameFieldName = this.props.p_tblDataNameFieldName;
    const p_tblRowIDsToNotIncludeArray = this.props.p_tblRowIDsToNotIncludeArray;

    const checkedTF = (!(p_tblDataObj[p_hiddenUnlessCheckedTFFieldName]));

    return(
      <div
        className="displayFlexRow borderB1ddd bgLightesterGray hoverLighterBlueGradient tbMicroPad cursorPointer"
        onClick={this.onclick_bit_master_tbl_item_checkbox}>
        <div className="flex00a displayFlexColumnHcVc lrPad">
          <LibraryReact.CheckBox
            p_u0_s1_p2_du3_ds4={((checkedTF) ? (1) : (0))}
            p_sizeEm={1.4}
          />
        </div>
        <div className="flex11a displayFlexRowVc lrPad">
          <font className="">
            {p_tblDataObj[p_tblDataNameFieldName]}
          </font>
        </div>
      </div>
    );
  }
}));





//=================================================================================================================================================================
//=================================================================================================================================================================






export const AdminSubtabDealShapingQuestions = inject("CaptureExecMobx", "AdminMobx", "DatabaseMobx")(observer(
class AdminSubtabDealShapingQuestions extends Component { //props: none
  constructor(props) {
    super(props);
    this.state = {
      s_importNewQuestionsFromCsvFloatingBoxIsOpenTF: false,
      s_importNewQuestionsFromCsvCurrentImportNumber: undefined,
      s_importNewQuestionsFromCsvCurrentQuestionText: undefined,
      s_importNewQuestionsFromCsvNumQuestionsToImport: undefined
    };
  }

  componentDidMount() {
    this.props.AdminMobx.a_initialize_questions_pool_selected_receiving_stage();
  }

  onclick_view_question_in_receiving_table = (i_questionID) => {
    const AdminMobx = this.props.AdminMobx;
    const o_questionsHighlightedQuestionID = AdminMobx.o_questionsHighlightedQuestionID;
    if(o_questionsHighlightedQuestionID === i_questionID) {
      AdminMobx.a_questions_set_highlighted_question_id(undefined);
      return;
    }

    const c_selectedCaptureTypeQuestionsPerStageObj = AdminMobx.c_selectedCaptureTypeQuestionsPerStageObj;
    const o_questionsSelectedReceivingStageID = AdminMobx.o_questionsSelectedReceivingStageID;
    var matchingStageIDsArray = [];
    for(let activeStageObj of c_selectedCaptureTypeQuestionsPerStageObj.activeStagesArrayOfObjs) {
      if(activeStageObj.questionsArrayOfObjs.some((m_questionObj) => (m_questionObj.question_id === i_questionID))) {
        matchingStageIDsArray.push(activeStageObj.expandedCaptureTypeStageObj.stage_id);
      }
    }
    for(let closedStageTypeObj of c_selectedCaptureTypeQuestionsPerStageObj.closedStageTypesArrayOfObjs) {
      for(let closedStageObj of closedStageTypeObj.closedStagesArrayOfObjs) {
        if(closedStageObj.questionsArrayOfObjs.some((m_questionObj) => (m_questionObj.question_id === i_questionID))) {
          matchingStageIDsArray.push(closedStageObj.expandedCaptureTypeStageObj.stage_id);
        }
      }
    }

    const receivingStageID = ((JSFUNC.in_array(o_questionsSelectedReceivingStageID, matchingStageIDsArray)) ? (o_questionsSelectedReceivingStageID) : (matchingStageIDsArray[0]));
    if(receivingStageID !== undefined) {
      AdminMobx.a_set_receiving_item_collection_id(receivingStageID);
    }
    AdminMobx.a_questions_set_search_filter_text("");
    AdminMobx.a_questions_set_highlighted_question_id(i_questionID);
    window.requestAnimationFrame(() => {
      const receivingQuestionRow = document.getElementById("adminDealShapingAddedQuestionRow_" + receivingStageID + "_" + i_questionID);
      if(receivingQuestionRow) {
        receivingQuestionRow.scrollIntoView({block:"nearest", inline:"nearest"});
      }
    });
  }

  onclick_view_question_in_pool = (i_questionID) => {
    if(i_questionID === undefined) {
      this.props.AdminMobx.a_questions_set_highlighted_question_id(undefined);
      return;
    }

    const o_questionsHighlightedQuestionID = this.props.AdminMobx.o_questionsHighlightedQuestionID;
    if(o_questionsHighlightedQuestionID === i_questionID) {
      this.props.AdminMobx.a_questions_set_highlighted_question_id(undefined);
      return;
    }

    this.props.AdminMobx.a_questions_set_search_filter_text("");
    this.props.AdminMobx.a_questions_set_highlighted_question_id(i_questionID);
    window.requestAnimationFrame(() => {
      const poolQuestionRow = document.getElementById("adminDetailsFieldPoolRow_" + i_questionID);
      if(poolQuestionRow) {
        poolQuestionRow.scrollIntoView({block:"nearest", inline:"nearest"});
      }
    });
  }

  onchange_questions_search_filter_text = (i_newValue) => {
    this.props.AdminMobx.a_questions_set_search_filter_text(i_newValue);
  }

  onclick_add_pool_question_to_receiving_stage = (i_questionID) => { //click the add button in the questions pool, add this question to the receiving stage
    this.props.AdminMobx.a_add_pool_question_to_receiving_stage(i_questionID, this.props.AdminMobx.o_questionsSelectedReceivingStageID);
    this.props.AdminMobx.a_questions_set_highlighted_question_id(i_questionID);
  }

  onclick_import_new_questions_from_csv = () => {
    this.setState({s_importNewQuestionsFromCsvFloatingBoxIsOpenTF:true});
  }

  onclick_close_import_new_questions_From_csv_floating_box = () => {
    this.setState({s_importNewQuestionsFromCsvFloatingBoxIsOpenTF:false});
  }

  onclick_import_csv_into_new_questions = (i_csvDataArrayOrArrayOfArrays, i_runThisFunctionUponSuccess, i_runThisFunctionUponError) => {
    const c_questionsPoolArrayOfObjs = this.props.AdminMobx.c_questionsPoolArrayOfObjs;

    if(JSFUNC.is_array(i_csvDataArrayOrArrayOfArrays) && (i_csvDataArrayOrArrayOfArrays.length > 0)) { //if there is at least 1 question to import
      const numPoolQuestions = c_questionsPoolArrayOfObjs.length;

      const initialCurrent = 0;
      const initialMax = i_csvDataArrayOrArrayOfArrays.length;
      var initialLastPoolAdminSort = 0;
      if(numPoolQuestions > 0) {
        initialLastPoolAdminSort = c_questionsPoolArrayOfObjs[(numPoolQuestions - 1)].admin_sort;
      }

      this.setState({s_importNewQuestionsFromCsvNumQuestionsToImport:initialMax});

      this.recursive_import_csv_single_question_and_answers_into_questions_pool(i_csvDataArrayOrArrayOfArrays, initialCurrent, initialMax, initialLastPoolAdminSort, i_runThisFunctionUponSuccess);
    }
    else {
      i_runThisFunctionUponSuccess();
    }
  }

  recursive_import_csv_single_question_and_answers_into_questions_pool = (i_csvDataArrayOrArrayOfArrays, i_prevCurrent, i_max, i_previousPoolAdminSort, i_runThisFunctionUponSuccess) => {
    const jsDescription = JSFUNC.js_description_from_action("AdminReact - AdminSubtabDealShapingQuestions", "recursive_import_csv_single_question_and_answers_into_questions_pool", ["i_csvDataArrayOrArrayOfArrays", "i_prevCurrent", "i_max", "i_previousPoolAdminSort"], [i_csvDataArrayOrArrayOfArrays, i_prevCurrent, i_max, i_previousPoolAdminSort]);

    const current = (i_prevCurrent + 1);
    const currentIndex = (current - 1);
    const currentDataRowArray = i_csvDataArrayOrArrayOfArrays[currentIndex];
    const currentDataRowIsArrayTF = JSFUNC.is_array(currentDataRowArray);
    const currentDataRowNumColumns = ((currentDataRowIsArrayTF) ? (currentDataRowArray.length) : (0));
    const currentNewQuestionAdminSort = (i_previousPoolAdminSort + 1);

    if((current > i_max) || (currentDataRowNumColumns < 4)) { //end recursion if the last item was handled on the previous loop, or if this data row is not an array with at least 4 columns (all rows should be arrays for this 2D csv shaping questions import)
      i_runThisFunctionUponSuccess();

      this.setState({
        s_importNewQuestionsFromCsvCurrentImportNumber: undefined,
        s_importNewQuestionsFromCsvNumQuestionsToImport: undefined
      });
    }
    else {
      const questionText = currentDataRowArray[0];
      const questionTypeSelectTextTextareaString = JSFUNC.str2lower(JSFUNC.remove_whitespace_from_string(currentDataRowArray[1]));
      var questionType123 = 3; //textarea by default
      var questionTypeIsSelectTF = false;
      if(questionTypeSelectTextTextareaString === "select") { questionType123 = 1; questionTypeIsSelectTF = true; }
      else if(questionTypeSelectTextTextareaString === "text") { questionType123 = 2; }
      else if(questionTypeSelectTextTextareaString === "textarea") { questionType123 = 3; }
      const questionTagIDsComma = JSFUNC.convert_unformatted_comma_list_to_int_only_comma_list(currentDataRowArray[2]);
      const questionHoverText = ((JSFUNC.string_is_filled_out_tf(currentDataRowArray[3])) ? (currentDataRowArray[3]) : (""));
      var selectAnswersArrayOfObjs = [];
      if(questionTypeIsSelectTF) {
        var colIndex = 4;
        var checkNextAnswerPairTF = true;
        while(checkNextAnswerPairTF && (colIndex < currentDataRowNumColumns)) {
          var answerText = currentDataRowArray[colIndex];
          var answerPercent0to100Int = JSFUNC.str2int(currentDataRowArray[(colIndex + 1)]);
          if(JSFUNC.string_is_filled_out_tf(answerText) && JSFUNC.is_number(answerPercent0to100Int)) {
            selectAnswersArrayOfObjs.push({
              answerText: answerText,
              answerPercent0to100: answerPercent0to100Int
            });
            colIndex += 2;
          }
          else {
            checkNextAnswerPairTF = false;
          }
        }
      }

      this.setState({
        s_importNewQuestionsFromCsvCurrentImportNumber: current,
        s_importNewQuestionsFromCsvCurrentQuestionText: "[" + questionTypeSelectTextTextareaString + "] " + questionText
      });

      //------insert question-----------------------
      const C_CallPhpTblUIDInsertQuestion = new JSPHP.ClassCallPhpTblUID(jsDescription);

      const questionFieldNamesArray = ["name", "answer_select1_text2_textarea3", "tag_ids_comma", "admin_sort", "hover_text", "question_name_styling_string_comma"];
      const questionValuesArrayOfArrays = [questionText, questionType123, questionTagIDsComma, currentNewQuestionAdminSort, questionHoverText, ""]; //styling string not an option for .csv import, always "" default
      const questionIdsbArray = ["s", "i", "s", "i", "s", "s"];
      C_CallPhpTblUIDInsertQuestion.add_insert("tbl_a_shaping_questions_pool", questionFieldNamesArray, questionValuesArrayOfArrays, questionIdsbArray);

      const functionOnSuccessInsertQuestion = (i_parseResponse) => {
        const newlyInsertedQuestionID = i_parseResponse.outputObj.i0;
        if(questionTypeIsSelectTF) { //select question, need to insert answers which contain newly inserted questionID
          //&&&&&&inset answers&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&
          const C_CallPhpTblUIDInsertAnswers = new JSPHP.ClassCallPhpTblUID(jsDescription);
          
          const answersFieldNamesArray = ["question_id", "name", "score0to100"];
          const answersIdsbArray = ["i", "s", "i"];
          for(let selectAnswerObj of selectAnswersArrayOfObjs) {
            var answersValuesArrayOfArrays = [newlyInsertedQuestionID, selectAnswerObj.answerText, selectAnswerObj.answerPercent0to100];
            C_CallPhpTblUIDInsertAnswers.add_insert("tbl_a_shaping_select_answers", answersFieldNamesArray, answersValuesArrayOfArrays, answersIdsbArray);
          }

          const functionOnFinishInsertAnswers = () => { //success or failure of inserting select question answers, move to the next question
            this.recursive_import_csv_single_question_and_answers_into_questions_pool(i_csvDataArrayOrArrayOfArrays, current, i_max, currentNewQuestionAdminSort, i_runThisFunctionUponSuccess);
          }
          C_CallPhpTblUIDInsertAnswers.add_function("onFinish", functionOnFinishInsertAnswers);

          C_CallPhpTblUIDInsertAnswers.execute();
          //&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&
        }
        else { //text/textarea question, finished inserting can move to next question
          this.recursive_import_csv_single_question_and_answers_into_questions_pool(i_csvDataArrayOrArrayOfArrays, current, i_max, currentNewQuestionAdminSort, i_runThisFunctionUponSuccess);
        }
      }
      C_CallPhpTblUIDInsertQuestion.add_function("onSuccess", functionOnSuccessInsertQuestion);

      const functionOnErrorInsertQuestion = () => { //if there is an error inserting this question, skip it and move to the next with no error handling or reporting
        this.recursive_import_csv_single_question_and_answers_into_questions_pool(i_csvDataArrayOrArrayOfArrays, current, i_max, currentNewQuestionAdminSort, i_runThisFunctionUponSuccess);
      }
      C_CallPhpTblUIDInsertQuestion.add_function("onError", functionOnErrorInsertQuestion);

      C_CallPhpTblUIDInsertQuestion.execute();
      //--------------------------------------------
    }
  }

  onclick_cancel_import_new_questions_to_pool_from_csv = () => {
    this.setState({
      s_importNewQuestionsFromCsvFloatingBoxIsOpenTF: false,
      s_importNewQuestionsFromCsvCurrentImportNumber: undefined,
      s_importNewQuestionsFromCsvCurrentQuestionText: undefined,
      s_importNewQuestionsFromCsvNumQuestionsToImport: undefined
    });
  }

  onclick_pool_view_print_questions = () => {
    this.onclick_view_print_questions(true);
  }

  onclick_capture_type_view_print_questions = () => {
    this.onclick_view_print_questions(false);
  }

  onclick_view_print_questions = (i_poolTrueCaptureTypeFalse) => {
    this.props.AdminMobx.a_questions_view_print_questions(i_poolTrueCaptureTypeFalse);
  }
  render() {
    const s_importNewQuestionsFromCsvFloatingBoxIsOpenTF = this.state.s_importNewQuestionsFromCsvFloatingBoxIsOpenTF;
    const s_importNewQuestionsFromCsvCurrentImportNumber = this.state.s_importNewQuestionsFromCsvCurrentImportNumber;
    const s_importNewQuestionsFromCsvCurrentQuestionText = this.state.s_importNewQuestionsFromCsvCurrentQuestionText;
    const s_importNewQuestionsFromCsvNumQuestionsToImport = this.state.s_importNewQuestionsFromCsvNumQuestionsToImport;

    const c_customDealShapingQuestionsStringFromCardName = this.props.DatabaseMobx.c_customDealShapingQuestionsStringFromCardName;
    const c_fieldMapOfCaptureType = this.props.DatabaseMobx.c_fieldMapOfCaptureType;
    const c_valueDisplayArraysObjCaptureShapingQuestionTags = this.props.DatabaseMobx.c_valueDisplayArraysObjCaptureShapingQuestionTags;

    const drawRecursiveImportNewQuestionsProgressFloatingBoxTF = (JSFUNC.is_number_not_nan_gt_0(s_importNewQuestionsFromCsvCurrentImportNumber) && JSFUNC.is_number_not_nan_gt_0(s_importNewQuestionsFromCsvNumQuestionsToImport));

    //upper right vertical dots menu for printing pool or capture type questions/answers
    const adminDealShapingPoolVerticalDotsMenuItemsArrayOfObjs = [
      {
        displayName: "Import New Questions from .csv",
        functionOnClickMenuItem: this.onclick_import_new_questions_from_csv
      },
      {
        displayName: "[Entire Pool] View/Print Questions and All Answers",
        functionOnClickMenuItem: this.onclick_pool_view_print_questions
      }
    ];

    const adminDealShapingCaptureTypeVerticalDotsMenuItemsArrayOfObjs = [
      {
        displayName: "[Selcted " + c_fieldMapOfCaptureType.get("display_name") + "] View/Print Questions and All Answers",
        functionOnClickMenuItem: this.onclick_capture_type_view_print_questions
      }
    ];

    var importShapingQuestionsFromCsvInstructionsHtml = null;
    if(s_importNewQuestionsFromCsvFloatingBoxIsOpenTF) {
      const csvInstructionsColumnsTextArray = [
        "Column A: Question Text",
        "Column B: Question Type (enter 'select', 'text', or 'textarea' without the quotes)",
        "Column C: Tag ID number(s) separated by commas",
        "Column D: Hover Help Text",
        "Column E: ('select' type only) Select Answer #1 Text",
        "Column F: ('select' type only) Select Answer #1 Score [0-100]",
        "Column G: ('select' type only) Select Answer #2 Text",
        "Column H: ('select' type only) Select Answer #2 Score [0-100]",
        "Columns I-?: ('select' type only) Answers #3-? as needed"
      ];
      importShapingQuestionsFromCsvInstructionsHtml = (
        <>
          <div className="microBottomMargin"><font className="">{"Newly imported Questions will be added to the bottom of the existing pool of Questions"}</font></div>
          <div className=""><font className="">{"Only columns 'A' through 'I' will be displayed on the next page - all columns will be imported"}</font></div>
          <div className="hugeTopMargin" />
          <div className="microBottomMargin"><font className="">{"Example .csv file columns for new Questions import (no header row, first row is first Question to import)"}</font></div>
          {csvInstructionsColumnsTextArray.map((m_csvInstructionsColumnText) =>
            <div style={{marginLeft:"0.5em"}}><font className="fontTextLight">{m_csvInstructionsColumnText}</font></div>
          )}
          <div className="hugeTopMargin" />
          <div className="microBottomMargin"><font className="">{"Tags with [ID numbers] to use in Tags column C"}</font></div>
          {c_valueDisplayArraysObjCaptureShapingQuestionTags.valueArray.map((m_value, m_index) =>
            <div style={{marginLeft:"0.5em"}}><font className="fontTextLight">{"[" + m_value + "] " + c_valueDisplayArraysObjCaptureShapingQuestionTags.displayArray[m_index]}</font></div>
          )}
        </>
      );
    }

    var recursiveProgressTextHtml = null;
    if(drawRecursiveImportNewQuestionsProgressFloatingBoxTF) {
      recursiveProgressTextHtml = (
        <>
          <LibraryReact.DivFont p_class="smallBottomMargin" p_fontClass="">
            {"Importing Question " + s_importNewQuestionsFromCsvCurrentImportNumber + " of " + s_importNewQuestionsFromCsvNumQuestionsToImport}
          </LibraryReact.DivFont>
          <LibraryReact.DivFont p_class="" p_fontClass="fontItalic">
            {"'" + s_importNewQuestionsFromCsvCurrentQuestionText + "'"}
          </LibraryReact.DivFont>
        </>
      );
    }

    return (
      <div className="flex11a displayFlexColumn">
        <AdminCaptureTypeSelectionBoxes />
        <div className="flex11a displayFlexRow">
          <DealShapingQuestionsPoolPanel
            p_menuItemsArrayOfObjs={adminDealShapingPoolVerticalDotsMenuItemsArrayOfObjs}
            f_onClickViewQuestionInReceivingTable={this.onclick_view_question_in_receiving_table}
            f_onChangeSearchText={this.onchange_questions_search_filter_text}
            f_onClickAddPoolQuestion={this.onclick_add_pool_question_to_receiving_stage}
          />
          <div className="flex00a" style={{flexBasis:"0.5em"}} />
          <DealShapingQuestionsAssignedPanel
            p_menuItemsArrayOfObjs={adminDealShapingCaptureTypeVerticalDotsMenuItemsArrayOfObjs}
            f_onClickHighlightQuestion={this.onclick_view_question_in_pool}
          />
        </div>
        {(s_importNewQuestionsFromCsvFloatingBoxIsOpenTF) &&
          <CEComplexReact.ImportDataFromCsvFileFloatingBox
            p_trblFlag="medium"
            p_importTitle={"Import New " + c_customDealShapingQuestionsStringFromCardName + " into Questions Pool"}
            p_instructionsHtmlOrUndefined={importShapingQuestionsFromCsvInstructionsHtml}
            p_existingValuesArray={undefined}
            p_maxNumColumnsInCsvOrUndefined={undefined}
            p_maxNumColumnsToShow={10}
            p_combineAll2DDataInto1DTF={false}
            p_markAndPreventDuplicateEntriesTF={false}
            p_includeBlankColumn1EntriesTF={false}
            f_onClickImportCsvData={this.onclick_import_csv_into_new_questions}
            f_onClickClose={this.onclick_close_import_new_questions_From_csv_floating_box}
          />
        }
        {(drawRecursiveImportNewQuestionsProgressFloatingBoxTF) &&
          <CEGeneralReact.RecursiveProgressBarFloatingBox
            p_floatingBoxTitle={"Importing New " + c_customDealShapingQuestionsStringFromCardName + " into Questions Pool"}
            p_progressTextHtmlOrUndefined={recursiveProgressTextHtml}
            p_currentItemNumber={s_importNewQuestionsFromCsvCurrentImportNumber}
            p_totalNumItems={s_importNewQuestionsFromCsvNumQuestionsToImport}
            p_progressColor="fb7"
            f_onClickCancel={this.onclick_cancel_import_new_questions_to_pool_from_csv}
          />
        }
      </div>
    );
  }
}));


function HighlightQuestionInPoolButton(props) { //props: p_questionID, f_onClickHighlightQuestion
  const p_questionID = props.p_questionID;
  const f_onClickHighlightQuestion = props.f_onClickHighlightQuestion;

  return(
    <div className="flex00a displayFlexColumnHcVc borderR1ddd" style={{flexBasis:"1.8em"}}>
      <LibraryReact.ButtonFixedHeightWidthCenteredContent
        p_widthEm={1.5}
        p_heightEm={1.8}
        p_class="flex00a cursorPointer"
        p_styleObj={{border:"0", background:"transparent", padding:0}}
        p_hoverText="Highlight this question in the pool"
        f_onClick={() => {
          if(JSFUNC.is_function(f_onClickHighlightQuestion)) {
            f_onClickHighlightQuestion(p_questionID);
          }
        }}>
        <CEIconsReact.SvgEyeIcon p_sizeEm={0.9} p_color="999999" />
      </LibraryReact.ButtonFixedHeightWidthCenteredContent>
    </div>
  );
}


const DealShapingQuestionsPoolPanel = inject("CaptureExecMobx", "AdminMobx", "DatabaseMobx")(observer(
class DealShapingQuestionsPoolPanel extends Component { //props: p_menuItemsArrayOfObjs, f_onClickViewQuestionInReceivingTable, f_onChangeSearchText, f_onClickAddPoolQuestion
  render() {
    const p_menuItemsArrayOfObjs = this.props.p_menuItemsArrayOfObjs;
    const f_onClickViewQuestionInReceivingTable = this.props.f_onClickViewQuestionInReceivingTable;
    const f_onChangeSearchText = this.props.f_onChangeSearchText;
    const f_onClickAddPoolQuestion = this.props.f_onClickAddPoolQuestion;

    const o_mediaQueryFlag = this.props.CaptureExecMobx.o_mediaQueryFlag;

    const o_questionsSearchFilterText = this.props.AdminMobx.o_questionsSearchFilterText;
    const o_questionsHighlightedQuestionID = this.props.AdminMobx.o_questionsHighlightedQuestionID;
    const c_selectedCaptureTypeExistsTF = this.props.AdminMobx.c_selectedCaptureTypeExistsTF;
    const c_questionsPoolArrayOfObjs = this.props.AdminMobx.c_questionsPoolArrayOfObjs;
    const c_selectedCaptureTypeQuestionsPerStageObj = this.props.AdminMobx.c_selectedCaptureTypeQuestionsPerStageObj;

    const o_tbl_a_capture_types_debrief_questions = this.props.DatabaseMobx.o_tbl_a_capture_types_debrief_questions;
    const o_tbl_a_capture_types_shaping_questions = this.props.DatabaseMobx.o_tbl_a_capture_types_shaping_questions;
    const o_tbl_a_shaping_select_answers = this.props.DatabaseMobx.o_tbl_a_shaping_select_answers;
    const c_customDealShapingQuestionsStringFromCardName = this.props.DatabaseMobx.c_customDealShapingQuestionsStringFromCardName;
    const c_fieldMapOfCaptureType = this.props.DatabaseMobx.c_fieldMapOfCaptureType;
    const c_genericTextareaFieldTypeObj = this.props.DatabaseMobx.c_genericTextareaFieldTypeObj;
    const c_genericIntPositiveFieldTypeObj = this.props.DatabaseMobx.c_genericIntPositiveFieldTypeObj;
    const c_genericStylingStringAdminFontBlueFieldTypeObj = this.props.DatabaseMobx.c_genericStylingStringAdminFontBlueFieldTypeObj;
    const c_selectMultiAddDealShapingQuestionTagsFieldTypeObj = this.props.DatabaseMobx.c_selectMultiAddDealShapingQuestionTagsFieldTypeObj;

    const functionDeleteDealShapingQuestionCleanup = (i_C_CallPhpTblUID, i_questionRowObj) => {
      const questionID = i_questionRowObj.id;
      const selectAnswerIDsToDeleteArray = JSFUNC.get_column_vector_from_mapOfMaps_matching_field_value(o_tbl_a_shaping_select_answers, "question_id", questionID, "id");
      i_C_CallPhpTblUID.add_delete("tbl_a_shaping_select_answers", selectAnswerIDsToDeleteArray);

      for(let [captureTypeShapingQuestionRecordID, captureTypeShapingQuestionRecordMap] of o_tbl_a_capture_types_shaping_questions) {
        if(captureTypeShapingQuestionRecordMap.get("question_id") === questionID) {
          i_C_CallPhpTblUID.add_delete(
            "tbl_a_capture_types_shaping_questions",
            captureTypeShapingQuestionRecordID,
            "sort",
            ["capture_type_id", "stage_id_relevant"],
            [captureTypeShapingQuestionRecordMap.get("capture_type_id"), captureTypeShapingQuestionRecordMap.get("stage_id_relevant")]
          );
        }
      }

      for(let [captureTypeDebriefQuestionRecordID, captureTypeDebriefQuestionRecordMap] of o_tbl_a_capture_types_debrief_questions) {
        if(captureTypeDebriefQuestionRecordMap.get("question_id") === questionID) {
          i_C_CallPhpTblUID.add_delete(
            "tbl_a_capture_types_debrief_questions",
            captureTypeDebriefQuestionRecordID,
            "sort",
            ["capture_type_id", "closed_stage_id"],
            [captureTypeDebriefQuestionRecordMap.get("capture_type_id"), captureTypeDebriefQuestionRecordMap.get("closed_stage_id")]
          );
        }
      }
    };

    const answerTypeFieldTypeObj = this.props.DatabaseMobx.create_verticalswitch_field_type_obj_from_value_array_and_display_array("Answer Type", [1, 3], false, ["Scored Select", "Scored Textarea"], undefined);
    var answerTypeColumnWidthEm = 6.5;
    var numAnswersColumnWidthEm = 7;
    var hoverHelpTextColumnWidthEm = 7;
    var styleColumnWidthEm = 5;
    if(o_mediaQueryFlag <= 2) {
      answerTypeColumnWidthEm = 4;
      numAnswersColumnWidthEm = 4;
      hoverHelpTextColumnWidthEm = 4;
      styleColumnWidthEm = 3;
    }

    const aedTableObj = {
      tblName: "tbl_a_shaping_questions_pool",
      dragToResortFieldDbName: "admin_sort",
      canAlwaysDragResortTF: true,
      initialSortedFieldDbName: "admin_sort",
      tableWidth: "100%",
      itemName: "Question",
      deleteItemNameFieldDbName: "name",
      searchFieldDbName: "name",
      canAddItemsFromAddColumnTF: c_selectedCaptureTypeExistsTF,
      idsAlreadyAddedArray: c_selectedCaptureTypeQuestionsPerStageObj.selectedReceivingStageQuestionIDsAlreadyAddedArray,
      canHighlightAlreadyAddedItemsTF: true,
      highlightedItemID: o_questionsHighlightedQuestionID,
      functionOnClickViewItemToHighlight: f_onClickViewQuestionInReceivingTable,
      itemDeleteFunctionsArray: [functionDeleteDealShapingQuestionCleanup],
      fieldsArrayOfObjs: [
        {width:"500em", dbName:"name", displayName:"Question", fieldTypeObj:c_genericTextareaFieldTypeObj, initialValue:"", cellHoverTF:true},
        {width:answerTypeColumnWidthEm + "em", fixedWidthTF:true, dbName:"answerTypeShort", displayName:"Answer Type", fieldTypeObj:undefined, initialValue:undefined, cellCenterTF:true, rawValueDisplayedFieldNotOnFormTF:true},
        {width:undefined, dbName:"answer_select1_text2_textarea3", displayName:"Answer Type", fieldTypeObj:answerTypeFieldTypeObj, initialValue:1},
        {width:numAnswersColumnWidthEm + "em", fixedWidthTF:true, dbName:"numAnswers", displayName:"# Answers", fieldTypeObj:undefined, initialValue:undefined, cellCenterTF:true, rawValueDisplayedFieldNotOnFormTF:true},
        {width:undefined, dbName:"answersArrayOfObjs", displayName:"Answers (for Question Type 'Select')", fieldTypeObj:{editAnswersForSelectQuestionTF:true}, initialValue:undefined},
        {width:"100em", dbName:"tag_ids_comma", displayName:"Tags", fieldTypeObj:c_selectMultiAddDealShapingQuestionTagsFieldTypeObj, initialValue:"", cellHoverTF:true},
        {width:hoverHelpTextColumnWidthEm + "em", fixedWidthTF:true, dbName:"hover_text", displayName:"Hover Help Text", fieldTypeObj:c_genericTextareaFieldTypeObj, initialValue:"", cellHoverTF:true},
        {width:styleColumnWidthEm + "em", fixedWidthTF:true, dbName:"question_name_styling_string_comma", displayName:"Style", fieldTypeObj:c_genericStylingStringAdminFontBlueFieldTypeObj, initialValue:"", cellCenterTF:true, cellHoverTF:true, cellDisplayBlankIfNotFilledOutTF:true},
        {width:"3em", dbName:"admin_sort", displayName:"Question Pool Sort", fieldTypeObj:c_genericIntPositiveFieldTypeObj, initialValue:1}
      ]
    };

    return(
      <div className="flex11a displayFlexColumn yScroll lrPad" style={{flexBasis:"150em"}}>
        <div className="flex00a displayFlexRow" style={{minHeight:"3em"}}>
          <div className="flex11a displayFlexRowVc smallFullPad">
            <LibraryReact.DivFont p_class="" p_fontClass="font13 fontBold fontUnderline fontItalic">
              {"Questions Pool:"}
            </LibraryReact.DivFont>
            <LibraryReact.DivFont p_class="" p_fontClass="font13 fontItalic">
              {" All unique " + c_customDealShapingQuestionsStringFromCardName + " used for every " + c_fieldMapOfCaptureType.get("display_name")}
            </LibraryReact.DivFont>
          </div>
          <div className="flex00a displayFlexColumnHcVc" style={{flexBasis:"2.5em"}}>
            <CEGeneralReact.VerticalDotsMenu p_menuItemsArrayOfObjs={p_menuItemsArrayOfObjs} />
          </div>
        </div>
        <CEComplexReact.AddEditDeleteTable
          p_dataArrayOfObjs={c_questionsPoolArrayOfObjs}
          p_aedTableObj={aedTableObj}
          p_searchText={o_questionsSearchFilterText}
          f_onChangeSearchText={f_onChangeSearchText}
          f_onClickAddItem={f_onClickAddPoolQuestion}
        />
      </div>
    );
  }
}));

export const AdminSubtabDealShapingOptions = inject("DatabaseMobx")(observer(
class AdminSubtabDealShapingOptions extends Component { //props: none
  constructor(props) {
    super(props);
    this.state = {
      s_selectedTabDbName: "answerValueStyling",
      s_recalculateShapingPwinPercentsMessage: "none",
      s_recalculateAllCapturesTF: false
    };
  }

  onselect_tab = (i_selectedTabDbName) => {
    this.setState({s_selectedTabDbName:i_selectedTabDbName});
  }

  onswitch_recalculate_all_captures = () => {
    this.setState((i_prevState) => ({s_recalculateAllCapturesTF: !i_prevState.s_recalculateAllCapturesTF}));
  }

  onclick_recalculate_shaping_progress_pwin_percents_on_all_captures = () => {
    this.setState({s_recalculateShapingPwinPercentsMessage:"working"});

    const jsDescription = JSFUNC.js_description_from_action("AdminReact - AdminSubtabDealShapingOptions", "onclick_recalculate_shaping_progress_pwin_percents_on_all_captures", [], []);
    const C_CallPhpScript = new JSPHP.ClassCallPhpScript("recalculateShapingPwinPercentsOnAllCaptures", jsDescription);

    C_CallPhpScript.add_post_var("i_recalculateAllCaptures01", ((this.state.s_recalculateAllCapturesTF) ? ("1") : ("0")));
    C_CallPhpScript.add_return_vars("recalculationSuccessMessage");

    const functionOnSuccess = (i_parseResponse) => {
      this.setState({s_recalculateShapingPwinPercentsMessage:i_parseResponse.recalculationSuccessMessage});
    }
    C_CallPhpScript.add_function("onSuccess", functionOnSuccess);

    const functionOnError = () => {
      this.setState({s_recalculateShapingPwinPercentsMessage:"Server recalculation was not successful"});
    }
    C_CallPhpScript.add_function("onError", functionOnError);

    C_CallPhpScript.execute();
  }

  onclick_close_recalculation_message_box = () => {
    this.setState({s_recalculateShapingPwinPercentsMessage:"none"});
  }

  render() {
    const s_selectedTabDbName = this.state.s_selectedTabDbName;
    const s_recalculateShapingPwinPercentsMessage = this.state.s_recalculateShapingPwinPercentsMessage;
    const s_recalculateAllCapturesTF = this.state.s_recalculateAllCapturesTF;

    const c_cardNameDealShaping = this.props.DatabaseMobx.c_cardNameDealShaping;
    const c_shapingCardAnswerValueStylingsArrayOfObjs = this.props.DatabaseMobx.c_shapingCardAnswerValueStylingsArrayOfObjs;
    const c_genericTextFieldTypeObj = this.props.DatabaseMobx.c_genericTextFieldTypeObj;
    const c_genericPercentIntm1000to100FieldTypeObj = this.props.DatabaseMobx.c_genericPercentIntm1000to100FieldTypeObj;
    const c_genericStylingStringAdminFontBlueFieldTypeObj = this.props.DatabaseMobx.c_genericStylingStringAdminFontBlueFieldTypeObj;
    const c_fieldMapOfPwin = this.props.DatabaseMobx.c_fieldMapOfPwin;
    const c_fieldMapOfShapingTotalProgress = this.props.DatabaseMobx.c_fieldMapOfShapingTotalProgress;
    const c_fieldMapOfShapingStageProgress = this.props.DatabaseMobx.c_fieldMapOfShapingStageProgress;

    const aedTableObj = {
      tblName: "tbl_a_shaping_card_answer_value_stylings",
      initialSortedFieldDbName: "percent_start_0to100",
      initialSortedFieldIsAscTF: true,
      tableWidth: "100%",
      itemName: "Answer Value Styling",
      deleteItemNameFieldDbName: "percent_start_0to100",
      fieldsArrayOfObjs: [
        {width:"8em", fixedWidthTF:true, dbName:"percent_start_0to100", displayName:"Start Percent", fieldTypeObj:c_genericPercentIntm1000to100FieldTypeObj, initialValue:0, cellCenterTF:true, requiredNotEmptyTF:true},
        {width:"20em", dbName:"shaping_card_answer_styling_string_comma", displayName:"Answer Style", fieldTypeObj:c_genericStylingStringAdminFontBlueFieldTypeObj, initialValue:"", cellCenterTF:true, cellHoverTF:true, cellDisplayBlankIfNotFilledOutTF:true}
      ]
    };
    
    const previewPercentsArray = JSFUNC.concat_arrays_or_values_into_new_array(-100, JSFUNC.array_fill_incrementing_x_to_y(-10, 100, 10));
    const notFilledOutStylingObj = this.props.DatabaseMobx.get_shaping_card_answer_value_styling_obj_for_not_filled_out();
    const exampleNotAnswered = "Example --Not Yet Answered-- (enter -999 to set)";
    const exampleNotAnsweredDisplay = ((notFilledOutStylingObj === undefined)
      ? (exampleNotAnswered)
      : (
        <CEGeneralReact.StyledTextDiv p_stylingObj={notFilledOutStylingObj}>
          {exampleNotAnswered}
        </CEGeneralReact.StyledTextDiv>
      ));
    const recalcCaptureScopeString = ((s_recalculateAllCapturesTF) ? ("all Captures") : ("active Captures"));
    var recalcProgressPwinConfirmMessage = "With this tool, you can perform a recalculation on all Shaping (" + c_fieldMapOfShapingTotalProgress.get("display_name") + ", " + c_fieldMapOfShapingStageProgress.get("display_name") + ") and " + c_fieldMapOfPwin.get("display_name") + " percentages for " + recalcCaptureScopeString + " in the system.";
    recalcProgressPwinConfirmMessage += " " + "This is necessary if you make changes to the weightings of Deal Shaping Questions, or add/remove questions from the different Capture Types or from the Questions Pool.";
    recalcProgressPwinConfirmMessage += " " + "Normally, when a single Capture is opened, the action of editing any Answer will trigger a recalculation for that one Capture.";
    recalcProgressPwinConfirmMessage += "\n\n" + "This recalculation is intensive and can take a while, which is the reason it's not triggered every time a Deal Shaping weighting is changed in this Admin system.";

    return(
      <>
        <div className="flex00a smallFullPad">
          <CEGeneralReact.TabsList
            p_tabDbNamesArray={["answerValueStyling", "recalculateProgressPwin"]}
            p_tabDisplayNamesArray={["Answer Value Styling", "Recalculate Progress/PWin"]}
            p_selectedTabDbName={s_selectedTabDbName}
            p_tabHeight="2.4em"
            p_textMaxHeight="2.2em"
            p_tabWidth="17em"
            p_unselectedFontClass="font11 fontBold fontTextLight"
            p_unselectedBgClass="bgLighterGrayGradient hoverLighterBlueGradient fontTextLight"
            p_selectedBgClass="bgGoldGradient"
            f_onSelect={this.onselect_tab}
          />
        </div>
        {(s_selectedTabDbName === "answerValueStyling") &&
          <div className="flex11a displayFlexColumn medFullPad" style={{maxWidth:"75em"}}>
            <div className="smallFullPad">
              <LibraryReact.DivFont p_class="" p_fontClass="font13 fontBold fontUnderline fontItalic">
                {"Deal Shaping Answer Value Styling"}
              </LibraryReact.DivFont>
              <LibraryReact.DivFont p_class="smallTopMargin" p_fontClass="fontItalic fontTextLight">
                {"Regular Start Percent rows change how answered questions look on the " + c_cardNameDealShaping + " Card based on the selected or self-scored answer, making it easier to identify questions that need work. To style an answer that is not filled out, add a separate row with Start Percent exactly -999; this special row applies to unanswered Select and Textarea questions and is excluded from percent-based styling. Without a regular Start Percent row, filled answers use the standard display; without a -999 row, unanswered answers use the standard display."}
              </LibraryReact.DivFont>
            </div>
            <div className="displayFlexRow flexWrap" style={{gap:"0.75em", alignItems:"flex-start"}}>
              <div className="flex11a" style={{flexBasis:"30em"}}>
                <CEComplexReact.AddEditDeleteTable
                  p_dataArrayOfObjs={c_shapingCardAnswerValueStylingsArrayOfObjs}
                  p_aedTableObj={aedTableObj}
                />
              </div>
              <div className="flex11a smallFullPad border1bbb borderRadius10 bgWhite" style={{flexBasis:"25em"}}>
                <LibraryReact.DivFont p_class="smallBottomMargin" p_fontClass="font12 fontBold fontItalic">
                  {"Preview"}
                </LibraryReact.DivFont>
                <CEGeneralReact.CaptureExecFieldEditSaveCancel
                  p_ceEditItemString="shapingAnswerStylingPreview_notFilledOut"
                  p_fieldDisplayName="Example Question"
                  p_fieldTypeObj={c_genericTextFieldTypeObj}
                  p_valueRaw={exampleNotAnswered}
                  p_valueMask={exampleNotAnsweredDisplay}
                  p_valueIsEditableTFU={undefined}
                  p_containerClass="smallBottomMargin"
                  p_fieldClass="fontBlue"
                  p_fieldWidth="10em"
                  p_fieldValueVerticallyAlignedTF={true}
                />
                {previewPercentsArray.map((m_percent) => {
                  const stylingObj = this.props.DatabaseMobx.get_shaping_card_answer_value_styling_obj_from_percent(m_percent);
                  const exampleAnswer = "Example " + m_percent + "% Answer";
                  const exampleAnswerDisplay = ((stylingObj === undefined)
                    ? (exampleAnswer)
                    : (
                      <CEGeneralReact.StyledTextDiv p_stylingObj={stylingObj}>
                        {exampleAnswer}
                      </CEGeneralReact.StyledTextDiv>
                    ));
                  return(
                    <CEGeneralReact.CaptureExecFieldEditSaveCancel
                      key={m_percent}
                      p_ceEditItemString={"shapingAnswerStylingPreview_" + m_percent}
                      p_fieldDisplayName="Example Question"
                      p_fieldTypeObj={c_genericTextFieldTypeObj}
                      p_valueRaw={exampleAnswer}
                      p_valueMask={exampleAnswerDisplay}
                      p_valueIsEditableTFU={undefined}
                      p_containerClass="smallBottomMargin"
                      p_fieldClass="fontBlue"
                      p_fieldWidth="10em"
                      p_fieldValueVerticallyAlignedTF={true}
                    />
                  );
                })}
              </div>
            </div>
          </div>
        }
        {(s_selectedTabDbName === "recalculateProgressPwin") &&
          <div className="flex11a displayFlexColumn medFullPad" style={{maxWidth:"75em"}}>
            <div className="smallFullPad">
              <LibraryReact.DivFont p_class="" p_fontClass="font13 fontBold fontUnderline fontItalic">
                {"Recalculate Shaping Progress/PWin %"}
              </LibraryReact.DivFont>
              <LibraryReact.DivFont p_class="smallTopMargin" p_fontClass="fontItalic fontTextLight">
                {recalcProgressPwinConfirmMessage}
              </LibraryReact.DivFont>
            </div>
            <div className="smallFullPad">
              <CEGeneralReact.SwitchWithTextAndConfirmBox
                p_isOnTF={s_recalculateAllCapturesTF}
                p_sizeEm={2.2}
                p_onColor="005da3"
                p_offColor="666666"
                p_onText="Recalculate All Captures"
                p_offText="[default] Only Recalculate Active Captures"
                f_onSwitch={this.onswitch_recalculate_all_captures}
              />
            </div>
            <div className="smallFullPad">
              <CEGeneralReact.ButtonWithConfirmBox
                p_buttonType="add"
                p_buttonText={"Recalculate Shaping Progress/PWin % on " + recalcCaptureScopeString}
                p_confirmType="confirm"
                p_confirmTitle={"Recalculate Shaping Progress/PWin % on " + recalcCaptureScopeString}
                p_button1Name={((s_recalculateAllCapturesTF) ? ("Recalculate All Captures") : ("Recalculate Active Captures"))}
                p_confirmMessage={recalcProgressPwinConfirmMessage}
                f_onClickConfirm={this.onclick_recalculate_shaping_progress_pwin_percents_on_all_captures}
              />
            </div>
            {(s_recalculateShapingPwinPercentsMessage !== "none") &&
              <div className={"flex00a displayFlexColumn tbBigMargin lrHugeMargin border1bbb " + ((s_recalculateShapingPwinPercentsMessage === "working") ? ("bgLightOrange") : ("bgLightGreen"))}>
                <div className="flex00a displayFlexRow" style={{flexBasis:"2em"}}>
                  <div className="flex11a" />
                  <div className="flex00a displayFlexColumnHcVc hoverLighterBlueGradient textCenter cursorPointer" style={{flexBasis:"2em"}} onClick={this.onclick_close_recalculation_message_box}>
                    <font>{"X"}</font>
                  </div>
                </div>
                <div className="flex00a displayFlexColumnHcVc microTopPad lrMedPad medBottomPad textCenter">
                  <font>
                    {((s_recalculateShapingPwinPercentsMessage === "working") ? ("Working on Shaping/PWin Recalculation") : (s_recalculateShapingPwinPercentsMessage))}
                  </font>
                  {(s_recalculateShapingPwinPercentsMessage === "working") && <CEGeneralReact.LoadingAnimation />}
                </div>
              </div>
            }
          </div>
        }
      </>
    );
  }
}));

const DealShapingQuestionsAssignedPanel = inject("AdminMobx", "DatabaseMobx")(observer(
class DealShapingQuestionsAssignedPanel extends Component { //props: p_menuItemsArrayOfObjs, f_onClickHighlightQuestion
  render() {
    const p_menuItemsArrayOfObjs = this.props.p_menuItemsArrayOfObjs;
    const f_onClickHighlightQuestion = this.props.f_onClickHighlightQuestion;

    const o_questionsHighlightedQuestionID = this.props.AdminMobx.o_questionsHighlightedQuestionID;
    const c_selectedCaptureTypeObj = this.props.AdminMobx.c_selectedCaptureTypeObj;
    const c_selectedCaptureTypeQuestionsPerStageObj = this.props.AdminMobx.c_selectedCaptureTypeQuestionsPerStageObj;

    const c_fieldMapOfCaptureType = this.props.DatabaseMobx.c_fieldMapOfCaptureType;

    return(
      <div className="flex11a yScroll" style={{flexBasis:"100em"}}>
        <div className="displayFlexRow" style={{minHeight:"3em"}}>
          <div className="flex11a displayFlexRowVc smallFullPad">
            <LibraryReact.DivFont p_class="" p_fontClass="font13 fontBold fontUnderline fontItalic">
              {"Assigned Questions per Stage:"}
            </LibraryReact.DivFont>
            <LibraryReact.DivFont p_class="" p_fontClass="font13 fontItalic">
              {" for " + c_fieldMapOfCaptureType.get("display_name") + " '" + c_selectedCaptureTypeObj.name + "'"}
            </LibraryReact.DivFont>
          </div>
          <div className="flex00a displayFlexColumnHcVc" style={{flexBasis:"2.5em"}}>
            <CEGeneralReact.VerticalDotsMenu p_menuItemsArrayOfObjs={p_menuItemsArrayOfObjs} />
          </div>
        </div>
        <div className="smallTopPad lrPad border1bbb">
          <LibraryReact.DivFont p_class="" p_fontClass="font13 fontBold fontItalic">
            {"Questions for Active Stages"}
          </LibraryReact.DivFont>
          {c_selectedCaptureTypeQuestionsPerStageObj.activeStagesArrayOfObjs.map((m_activeStageObj) =>
            <ActiveStageOfAddedQuestions
              key={m_activeStageObj.expandedCaptureTypeStageObj.stage_id}
              p_activeStageObj={m_activeStageObj}
              p_activeQuestionIDsAlreadyAddedArray={c_selectedCaptureTypeQuestionsPerStageObj.activeQuestionIDsAlreadyAddedArray}
              p_highlightedQuestionID={o_questionsHighlightedQuestionID}
              f_onClickHighlightQuestion={f_onClickHighlightQuestion}
            />
          )}
        </div>
        <div className="hugeTopMargin smallFullPad border1bbb">
          <LibraryReact.DivFont p_class="" p_fontClass="font13 fontBold fontItalic">
            {"Debrief Questions for Closed Stages"}
          </LibraryReact.DivFont>
          {c_selectedCaptureTypeQuestionsPerStageObj.closedStageTypesArrayOfObjs.map((m_closedStageTypeObj, m_index) =>
            <div
              key={m_index}
              className="medTopMargin hugeBottomMargin"
              style={{borderTop:((m_index > 0) ? ("solid 1px #ccc") : (undefined))}}>
              <LibraryReact.DivFont p_class="tbMargin" p_fontClass="font12 fontItalic">
                {m_closedStageTypeObj.stageTypeName}
              </LibraryReact.DivFont>
              {m_closedStageTypeObj.closedStagesArrayOfObjs.map((m_closedStageObj) =>
                <ClosedStageOfAddedQuestions
                  key={m_closedStageObj.expandedCaptureTypeStageObj.stage_id}
                  p_closedStageObj={m_closedStageObj}
                  p_closedQuestionIDsAlreadyAddedArray={m_closedStageObj.closedStageQuestionIDsAlreadyAddedArray}
                  p_highlightedQuestionID={o_questionsHighlightedQuestionID}
                  f_onClickHighlightQuestion={f_onClickHighlightQuestion}
                />
              )}
            </div>
          )}
        </div>
      </div>
    );
  }
}));

export const ActiveStageOfAddedQuestions = inject("AdminMobx")(observer(
class ActiveStageOfAddedQuestions extends Component { //props: p_activeStageObj, p_activeQuestionIDsAlreadyAddedArray
  onclick_set_stage_as_receiving_questions = () => {
    this.props.AdminMobx.a_set_receiving_item_collection_id(this.props.p_activeStageObj.expandedCaptureTypeStageObj.stage_id);
    this.props.AdminMobx.a_questions_set_search_filter_text("");
    this.props.AdminMobx.a_questions_set_highlighted_question_id(undefined);
  }

  ondrop_question_from_pool_into_active_stage_drop_zone = (i_draggedQuestionID) => {
    if(!JSFUNC.in_array(i_draggedQuestionID, this.props.p_activeQuestionIDsAlreadyAddedArray)) {
      this.props.AdminMobx.a_add_pool_question_to_receiving_stage(i_draggedQuestionID, this.props.p_activeStageObj.expandedCaptureTypeStageObj.stage_id);
    }
  }

  onremove_all_shaping_questions_in_active_stage_from_capture_type = () => {
    const p_activeStageObj = this.props.p_activeStageObj;
    const allCaptureTypeShapingQuestionsRowIDsInActiveStageArray = JSFUNC.get_column_vector_from_arrayOfObjs(p_activeStageObj.questionsArrayOfObjs, "id");
    this.props.AdminMobx.a_questions_set_highlighted_question_id(undefined);
    const jsDescription = JSFUNC.js_description_from_action("AdminMobx - ActiveStageOfAddedQuestions", "onremove_all_shaping_questions_in_active_stage_from_capture_type", [], []);
    const C_CallPhpTblUID = new JSPHP.ClassCallPhpTblUID(jsDescription);
    C_CallPhpTblUID.add_delete("tbl_a_capture_types_shaping_questions", allCaptureTypeShapingQuestionsRowIDsInActiveStageArray);
    C_CallPhpTblUID.execute();
  }

  render() {
    const p_activeStageObj = this.props.p_activeStageObj;
    const p_activeQuestionIDsAlreadyAddedArray = this.props.p_activeQuestionIDsAlreadyAddedArray;
    const p_highlightedQuestionID = this.props.p_highlightedQuestionID;
    const f_onClickHighlightQuestion = this.props.f_onClickHighlightQuestion;

    const questionsSelectedReceivingStageID = this.props.AdminMobx.o_questionsSelectedReceivingStageID;

    const expandedCaptureTypeStageObj = p_activeStageObj.expandedCaptureTypeStageObj;
    const questionsArrayOfObjs = p_activeStageObj.questionsArrayOfObjs;
    const numQuestions = questionsArrayOfObjs.length;

    return (
      <BlueItemCollectionShell
        p_isReceivingTF={(expandedCaptureTypeStageObj.stage_id === questionsSelectedReceivingStageID)}
        p_title={"Stage: '" + expandedCaptureTypeStageObj.name + "'"}
        p_dropUniqueString="AddEditDeleteTableRow_tbl_a_shaping_questions_pool"
        p_dropNotAllowedDraggerIDsArray={p_activeQuestionIDsAlreadyAddedArray}
        p_dropMessage="[Drag/drop questions from the pool]"
        p_dropAllowDropMessage={"[Drop question to add to stage '" + expandedCaptureTypeStageObj.name + "']"}
        p_dropNotAllowDropMessage="[Cannot add a question already added to one of the active stages]"
        f_onClickSetAsReceiving={this.onclick_set_stage_as_receiving_questions}
        f_onDrop={this.ondrop_question_from_pool_into_active_stage_drop_zone}
        f_onRemoveAllItems={this.onremove_all_shaping_questions_in_active_stage_from_capture_type}>
        {questionsArrayOfObjs.map((m_questionObj, m_index) =>
          <ActiveStageAddedDealShapingQuestionItem
            key={m_questionObj.id}
            p_expandedCaptureTypeStageObj={expandedCaptureTypeStageObj}
            p_questionObj={m_questionObj}
            p_sortNumber={(m_index + 1)}
            p_isOnlyItemTF={(numQuestions === 1)}
            p_isLastItemTF={(m_index === (numQuestions - 1))}
            p_highlightedQuestionID={p_highlightedQuestionID}
            f_onClickHighlightQuestion={f_onClickHighlightQuestion}
          />
        )}
      </BlueItemCollectionShell>
    );
  }
}));


export const ActiveStageAddedDealShapingQuestionItem = inject("AdminMobx", "DatabaseMobx")(observer(
class ActiveStageAddedDealShapingQuestionItem extends Component { //props: p_expandedCaptureTypeStageObj, p_questionObj, p_sortNumber, p_isOnlyItemTF, p_isLastItemTF, p_highlightedQuestionID, f_onClickHighlightQuestion
  constructor(props) {
    super(props);
    this.state = {
      s_editingAddedCaptureTypeQuestionRecordTF: false
    };
  }

  onclick_capture_type_stage_question_item_to_edit = () => {
    this.setState({s_editingAddedCaptureTypeQuestionRecordTF:true});
  }

  onclick_close_capture_type_stage_question_item_to_edit = () => {
    this.setState({s_editingAddedCaptureTypeQuestionRecordTF:false});
  }

  onclick_remove_question_from_capture_type_stage = () => {
    const p_questionObj = this.props.p_questionObj;
    this.props.AdminMobx.a_questions_set_highlighted_question_id(undefined);
    this.props.AdminMobx.a_remove_question_from_capture_type_stage(true, p_questionObj.id, p_questionObj.capture_type_id, p_questionObj.stage_id_relevant);
  }

  render() {
    const s_editingAddedCaptureTypeQuestionRecordTF = this.state.s_editingAddedCaptureTypeQuestionRecordTF;

    const p_expandedCaptureTypeStageObj = this.props.p_expandedCaptureTypeStageObj;
    const p_questionObj = this.props.p_questionObj;
    const p_sortNumber = this.props.p_sortNumber;
    const p_isOnlyItemTF = this.props.p_isOnlyItemTF;
    const p_isLastItemTF = this.props.p_isLastItemTF;
    const p_highlightedQuestionID = this.props.p_highlightedQuestionID;
    const f_onClickHighlightQuestion = this.props.f_onClickHighlightQuestion;

    const k_blueItemCollectionShellItemStylingObj = this.props.AdminMobx.k_blueItemCollectionShellItemStylingObj;
    const c_selectedCaptureTypeObj = this.props.AdminMobx.c_selectedCaptureTypeObj;
    const c_fieldMapOfCaptureType = this.props.DatabaseMobx.c_fieldMapOfCaptureType;

    const questionItemTitle = p_questionObj.name + "\n[Click to edit Progress/PWin weighting and requirements for this Question]";

    return(
      <div id={"adminDealShapingAddedQuestionRow_" + p_expandedCaptureTypeStageObj.stage_id + "_" + p_questionObj.question_id}>
      <CEGeneralReact.CEDragToResortItemWithinDbTbl
        p_canResortTF={true}
        p_uniqueString="captureTypeShapingQuestion"
        p_itemID={p_questionObj.id}
        p_itemSort={p_sortNumber}
        p_itemSortColumnWidth="2em"
        p_itemSortNumberFontClass={undefined}
        p_isOnlyItemTF={p_isOnlyItemTF}
        p_isLastItemTF={p_isLastItemTF}
        p_outerPadClass={k_blueItemCollectionShellItemStylingObj.outerPadClass}
        p_itemClass="displayFlexRow border bevelBorderColors borderRadius05 bgAlmostWhite hoverLighterBlueGradient"
        p_itemStyleObj={{height:k_blueItemCollectionShellItemStylingObj.rowHeightEm + "em", backgroundColor:((p_highlightedQuestionID === p_questionObj.question_id) ? ("#fff4c2") : (undefined))}}
        p_lastItemExtraDropZoneHeight={k_blueItemCollectionShellItemStylingObj.lastItemExtraDropZoneHeightEm + "em"}
        p_dragEntireItemTrueOnlySortNumberFalse={true}
        p_tblName="tbl_a_capture_types_shaping_questions"
        p_tblSortFieldDbName="sort"
        p_filterFieldNamesArray={["capture_type_id", "stage_id_relevant"]}
        p_filterValuesArray={[p_questionObj.capture_type_id, p_questionObj.stage_id_relevant]}>
        <div
          className="flex11a displayFlexRow cursorPointer"
          title={questionItemTitle}
          onClick={this.onclick_capture_type_stage_question_item_to_edit}>
          <HighlightQuestionInPoolButton
            p_questionID={p_questionObj.question_id}
            f_onClickHighlightQuestion={f_onClickHighlightQuestion}
          />
          <div className="flex11a displayFlexRowVc lrPad">
            <LibraryReact.NowrapEllipsis>
              {p_questionObj.name}
            </LibraryReact.NowrapEllipsis>
          </div>
          <div className="flex00a displayFlexRowVc lrPad" style={{flexBasis:"7em"}}>
            <font className="fontItalic fontTextLighter">{"Progress: "}</font>{p_questionObj.progress_weight}
          </div>
          <div className="flex00a displayFlexRowVc lrPad" style={{flexBasis:"5em"}}>
            <font className="fontItalic fontTextLighter">{"PWin: "}</font>{p_questionObj.pwin_weight}
          </div>
          <div className="flex00a displayFlexRowVc lrPad" style={{flexBasis:"7em"}}>
            <font className="fontItalic fontTextLighter">{"Required?: "}</font>{((p_questionObj.requiredTF) ? ("Y") : ("-"))}
          </div>
        </div>
        <div className="flex00a displayFlexColumnHcVc borderL1ddd" style={{flexBasis:"2em"}}>
          <CEGeneralReact.RemoveItemXWithRedHover
            p_title={"Remove Question '" + p_questionObj.name + "' from stage '" + p_expandedCaptureTypeStageObj.name + "' for " + c_fieldMapOfCaptureType.get("display_name") + " '" + c_selectedCaptureTypeObj.name + "'"}
            f_onClick={this.onclick_remove_question_from_capture_type_stage}
          />
        </div>
        {(s_editingAddedCaptureTypeQuestionRecordTF) &&
          <AddedCaptureTypeQuestionEditFloatingBox
            p_selectedCaptureTypeObj={c_selectedCaptureTypeObj}
            p_expandedCaptureTypeStageObj={p_expandedCaptureTypeStageObj}
            p_questionObj={p_questionObj}
            f_onClickClose={this.onclick_close_capture_type_stage_question_item_to_edit}
          />
        }
      </CEGeneralReact.CEDragToResortItemWithinDbTbl>
      </div>
    );
  }
}));


const AddedCaptureTypeQuestionEditFloatingBox = inject("DatabaseMobx")(observer(
class AddedCaptureTypeQuestionEditFloatingBox extends Component { //props: p_selectedCaptureTypeObj, p_expandedCaptureTypeStageObj, p_questionObj, f_onClickClose
  onsave_progress_weight = (i_newValue) => {
    this.update_capture_type_question_record_field_value("progress_weight", i_newValue, "i");
  }

  onsave_pwin_weight = (i_newValue) => {
    this.update_capture_type_question_record_field_value("pwin_weight", i_newValue, "i");
  }

  onswitch_required = () => {
    const p_questionObj = this.props.p_questionObj;
    const newRec1Req3 = ((p_questionObj.rec1_reqsig2_req3 === 3) ? (1) : (3));
    this.update_capture_type_question_record_field_value("rec1_reqsig2_req3", newRec1Req3, "i");
  }

  update_capture_type_question_record_field_value = (i_fieldName, i_value, i_idsb) => {
    const p_questionObj = this.props.p_questionObj;

    const jsDescription = JSFUNC.js_description_from_action("AdminReact - AddedCaptureTypeQuestionEditFloatingBox", "update_capture_type_question_record_field_value", ["i_fieldName", "i_value", "i_idsb"], [i_fieldName, i_value, i_idsb]);
    const C_CallPhpTblUID = new JSPHP.ClassCallPhpTblUID(jsDescription);
    C_CallPhpTblUID.add_update("tbl_a_capture_types_shaping_questions", p_questionObj.id, i_fieldName, i_value, i_idsb);
    C_CallPhpTblUID.execute();
  }

  render() {
    const p_selectedCaptureTypeObj = this.props.p_selectedCaptureTypeObj;
    const p_expandedCaptureTypeStageObj = this.props.p_expandedCaptureTypeStageObj;
    const p_questionObj = this.props.p_questionObj;
    const f_onClickClose = this.props.f_onClickClose;

    return(
      <CEGeneralReact.FloatingBoxWithSaveCancel
        p_trblFlag="addEditDeleteTableEditItem"
        p_title="Editing Added Question Weights and Requirements"
        f_onClickSave={f_onClickClose}>
        <div className="flex11a yScroll medFullPad">
          <div className="">
            <font className="fontItalic fontTextLighter">{"Capture Type: "}</font>
            <font className="fontTextLight">{p_selectedCaptureTypeObj.name}</font>
          </div>
          <div className="smallTopMargin">
            <font className="fontItalic fontTextLighter">{"Stage where this question appears: "}</font>
            <font className="fontTextLight">{p_expandedCaptureTypeStageObj.name}</font>
          </div>
          <div className="lrMedMargin smallTopMargin medBottomMargin smallFullPad" style={{border:"solid 1px #ccc"}}>
            <LibraryReact.DivFont p_class="" p_fontClass="font11 fontItalic fontTextLighter">
              {"Question:"}
            </LibraryReact.DivFont>
            <LibraryReact.DivFont p_class="smallTopMargin" p_fontClass="fontTextLight">
              {p_questionObj.name}
            </LibraryReact.DivFont>
          </div>
          <LibraryReact.DivFont p_class="hugeTopMargin" p_fontClass="fontItalic fontTextLighter">
            {"Question Weighting: A number from 0-9. 1 (least important) to 9 (most important) weights the questions among each other in how much their answers affect the Progress/PWin. 0 means the question will not affect the Progress/PWin."}
          </LibraryReact.DivFont>
          <CEGeneralReact.CaptureExecFieldEditSaveCancel
            p_ceEditItemString={"adminDSQ_qID" + p_questionObj.id + "progress_weight"}
            p_fieldDisplayName="Question Weighting towards Total Progress (0-9)"
            p_fieldTypeObj={this.props.DatabaseMobx.c_genericInt0to9FieldTypeObj}
            p_valueRaw={p_questionObj.progress_weight}
            p_valueIsEditableTFU={true}
            p_containerClass="smallTopMargin"
            p_fieldClass="fontBlue"
            p_fieldWidth="50%"
            f_onSaveChanged={this.onsave_progress_weight}
          />
          <CEGeneralReact.CaptureExecFieldEditSaveCancel
            p_ceEditItemString={"adminDSQ_qID" + p_questionObj.id + "pwin_weight"}
            p_fieldDisplayName="Question Weighting towards Calculated PWin (0-9)"
            p_fieldTypeObj={this.props.DatabaseMobx.c_genericInt0to9FieldTypeObj}
            p_valueRaw={p_questionObj.pwin_weight}
            p_valueIsEditableTFU={true}
            p_containerClass="smallTopMargin"
            p_fieldClass="fontBlue"
            p_fieldWidth="50%"
            f_onSaveChanged={this.onsave_pwin_weight}
          />
          <div className="displayFlexRowVc hugeTopMargin">
            <div className="flex11a" style={{flexBasis:"100em"}}>
              <font className="fontBlue">
                {"Question is Required?"}
              </font>
            </div>
            <div className="flex11a" style={{flexBasis:"100em"}}>
              <LibraryReact.Switch
                p_isOnTF={(p_questionObj.rec1_reqsig2_req3 === 3)}
                f_onClick={this.onswitch_required}
              />
            </div>
          </div>
          <LibraryReact.DivFont p_class="" p_fontClass="font09 fontItalic fontTextLighter">
            {"(Required means the question must be answered before the stage can advance)"}
          </LibraryReact.DivFont>
        </div>
      </CEGeneralReact.FloatingBoxWithSaveCancel>
    );
  }
}));


export const ClosedStageOfAddedQuestions = inject("AdminMobx")(observer(
class ClosedStageOfAddedQuestions extends Component { //props: p_closedStageObj, p_closedQuestionIDsAlreadyAddedArray
  onclick_set_stage_as_receiving_questions = () => {
    const p_closedStageObj = this.props.p_closedStageObj;
    this.props.AdminMobx.a_set_receiving_item_collection_id(p_closedStageObj.expandedCaptureTypeStageObj.stage_id);
    this.props.AdminMobx.a_questions_set_search_filter_text("");
    this.props.AdminMobx.a_questions_set_highlighted_question_id(undefined);
  }

  ondrop_question_from_pool_into_closed_stage_drop_zone = (i_draggedQuestionID) => {
    const p_closedStageObj = this.props.p_closedStageObj;
    const p_closedQuestionIDsAlreadyAddedArray = this.props.p_closedQuestionIDsAlreadyAddedArray;
    if(!JSFUNC.in_array(i_draggedQuestionID, p_closedQuestionIDsAlreadyAddedArray)) {
      this.props.AdminMobx.a_add_pool_question_to_receiving_stage(i_draggedQuestionID, p_closedStageObj.expandedCaptureTypeStageObj.stage_id);
    }
  }

  onremove_all_shaping_questions_in_closed_stage_from_capture_type = () => {
    const p_closedStageObj = this.props.p_closedStageObj;

    const allCaptureTypeShapingQuestionsRowIDsInClosedStageArray = JSFUNC.get_column_vector_from_arrayOfObjs(p_closedStageObj.questionsArrayOfObjs, "id");
    this.props.AdminMobx.a_questions_set_highlighted_question_id(undefined);
    const jsDescription = JSFUNC.js_description_from_action("AdminMobx - ClosedStageOfAddedQuestions", "onremove_all_shaping_questions_in_closed_stage_from_capture_type", [], []);
    const C_CallPhpTblUID = new JSPHP.ClassCallPhpTblUID(jsDescription);
    C_CallPhpTblUID.add_delete("tbl_a_capture_types_debrief_questions", allCaptureTypeShapingQuestionsRowIDsInClosedStageArray);
    C_CallPhpTblUID.execute();
  }

  render() {
    const p_closedStageObj = this.props.p_closedStageObj;
    const p_closedQuestionIDsAlreadyAddedArray = this.props.p_closedQuestionIDsAlreadyAddedArray;
    const p_highlightedQuestionID = this.props.p_highlightedQuestionID;
    const f_onClickHighlightQuestion = this.props.f_onClickHighlightQuestion;

    const o_questionsSelectedReceivingStageID = this.props.AdminMobx.o_questionsSelectedReceivingStageID;

    const expandedCaptureTypeStageObj = p_closedStageObj.expandedCaptureTypeStageObj;
    const questionsArrayOfObjs = p_closedStageObj.questionsArrayOfObjs;
    const numQuestions = questionsArrayOfObjs.length;

    return (
      <BlueItemCollectionShell
        p_isReceivingTF={(expandedCaptureTypeStageObj.stage_id === o_questionsSelectedReceivingStageID)}
        p_title={"Stage: '" + expandedCaptureTypeStageObj.name + "'"}
        p_dropUniqueString="AddEditDeleteTableRow_tbl_a_shaping_questions_pool"
        p_dropNotAllowedDraggerIDsArray={p_closedQuestionIDsAlreadyAddedArray}
        p_dropMessage="[Drag/drop questions from the pool]"
        p_dropAllowDropMessage={"[Drop question to add to stage '" + expandedCaptureTypeStageObj.name + "']"}
        p_dropNotAllowDropMessage="[Cannot add a question already added to one of the active stages]"
        f_onClickSetAsReceiving={this.onclick_set_stage_as_receiving_questions}
        f_onDrop={this.ondrop_question_from_pool_into_closed_stage_drop_zone}
        f_onRemoveAllItems={this.onremove_all_shaping_questions_in_closed_stage_from_capture_type}>
        {questionsArrayOfObjs.map((m_questionObj, m_index) =>
          <ClosedStageAddedDealShapingQuestionItem
            key={m_questionObj.id}
            p_expandedCaptureTypeStageObj={expandedCaptureTypeStageObj}
            p_questionObj={m_questionObj}
            p_sortNumber={(m_index + 1)}
            p_isOnlyItemTF={(numQuestions === 1)}
            p_isLastItemTF={(m_index === (numQuestions - 1))}
            p_highlightedQuestionID={p_highlightedQuestionID}
            f_onClickHighlightQuestion={f_onClickHighlightQuestion}
          />
        )}
      </BlueItemCollectionShell>
    );
  }
}));


export const ClosedStageAddedDealShapingQuestionItem = inject("AdminMobx", "DatabaseMobx")(observer(
class ClosedStageAddedDealShapingQuestionItem extends Component { //props: p_expandedCaptureTypeStageObj, p_questionObj, p_sortNumber, p_isOnlyItemTF, p_isLastItemTF, p_highlightedQuestionID, f_onClickHighlightQuestion
  onclick_remove_question_from_capture_type_stage = () => {
    const p_questionObj = this.props.p_questionObj;
    this.props.AdminMobx.a_questions_set_highlighted_question_id(undefined);
    this.props.AdminMobx.a_remove_question_from_capture_type_stage(false, p_questionObj.id, p_questionObj.capture_type_id, p_questionObj.closed_stage_id);
  }

  render() {
    const p_expandedCaptureTypeStageObj = this.props.p_expandedCaptureTypeStageObj;
    const p_questionObj = this.props.p_questionObj;
    const p_sortNumber = this.props.p_sortNumber;
    const p_isOnlyItemTF = this.props.p_isOnlyItemTF;
    const p_isLastItemTF = this.props.p_isLastItemTF;
    const p_highlightedQuestionID = this.props.p_highlightedQuestionID;
    const f_onClickHighlightQuestion = this.props.f_onClickHighlightQuestion;

    const k_blueItemCollectionShellItemStylingObj = this.props.AdminMobx.k_blueItemCollectionShellItemStylingObj;
    const c_selectedCaptureTypeObj = this.props.AdminMobx.c_selectedCaptureTypeObj;
    const c_fieldMapOfCaptureType = this.props.DatabaseMobx.c_fieldMapOfCaptureType;

    const questionItemTitle = p_questionObj.name + "\n[Closed Stage Questions do not have any additional parameters to edit]";

    return(
      <div id={"adminDealShapingAddedQuestionRow_" + p_expandedCaptureTypeStageObj.stage_id + "_" + p_questionObj.question_id}>
      <CEGeneralReact.CEDragToResortItemWithinDbTbl
        p_canResortTF={true}
        p_uniqueString="captureTypeDebriefQuestion"
        p_itemID={p_questionObj.id}
        p_itemSort={p_sortNumber}
        p_itemSortColumnWidth="2em"
        p_itemSortNumberFontClass={undefined}
        p_isOnlyItemTF={p_isOnlyItemTF}
        p_isLastItemTF={p_isLastItemTF}
        p_outerPadClass={k_blueItemCollectionShellItemStylingObj.outerPadClass}
        p_itemClass="displayFlexRow border bevelBorderColors borderRadius05 bgAlmostWhite hoverLighterBlueGradient"
        p_itemStyleObj={{height:k_blueItemCollectionShellItemStylingObj.rowHeightEm + "em", backgroundColor:((p_highlightedQuestionID === p_questionObj.question_id) ? ("#fff4c2") : (undefined))}}
        p_lastItemExtraDropZoneHeight={k_blueItemCollectionShellItemStylingObj.lastItemExtraDropZoneHeightEm + "em"}
        p_dragEntireItemTrueOnlySortNumberFalse={true}
        p_tblName="tbl_a_capture_types_debrief_questions"
        p_tblSortFieldDbName="sort"
        p_filterFieldNamesArray={["capture_type_id", "closed_stage_id"]}
        p_filterValuesArray={[p_questionObj.capture_type_id, p_questionObj.closed_stage_id]}>
        <div
          className="flex11a displayFlexRowVc lrPad"
          title={questionItemTitle}>
          <HighlightQuestionInPoolButton
            p_questionID={p_questionObj.question_id}
            f_onClickHighlightQuestion={f_onClickHighlightQuestion}
          />
          <LibraryReact.NowrapEllipsis>
            {p_questionObj.name}
          </LibraryReact.NowrapEllipsis>
        </div>
        <div className="flex00a displayFlexColumnHcVc borderL1ddd" style={{flexBasis:"2em"}}>
          <CEGeneralReact.RemoveItemXWithRedHover
            p_title={"Remove Question '" + p_questionObj.name + "' from stage '" + p_expandedCaptureTypeStageObj.name + "' for " + c_fieldMapOfCaptureType.get("display_name") + " '" + c_selectedCaptureTypeObj.name + "'"}
            f_onClick={this.onclick_remove_question_from_capture_type_stage}
          />
        </div>
      </CEGeneralReact.CEDragToResortItemWithinDbTbl>
      </div>
    );
  }
}));





//=================================================================================================================================================================
//=================================================================================================================================================================



export const AdminSubtabTeammates = inject("AdminMobx", "DatabaseMobx")(observer(
class AdminSubtabTeammates extends Component { //props: none
  render() {
    const c_teammatesWorkshareTypesArrayOfObjs = this.props.AdminMobx.c_teammatesWorkshareTypesArrayOfObjs;
    const c_teammatesWorkshareTypeFieldDisplayName = this.props.DatabaseMobx.c_teammatesWorkshareTypeFieldDisplayName;
    const c_genericTextFieldTypeObj = this.props.DatabaseMobx.c_genericTextFieldTypeObj;
    const c_genericIntPositiveFieldTypeObj = this.props.DatabaseMobx.c_genericIntPositiveFieldTypeObj;

    const workshareTypesAedTableObj = {
      tblName: "tbl_a_teammates_workshare_types",
      dragToResortFieldDbName: "sort",
      initialSortedFieldDbName: "sort",
      tableWidth: "40em",
      itemName: "Teammate " + c_teammatesWorkshareTypeFieldDisplayName,
      deleteItemNameFieldDbName: "name",
      fieldsArrayOfObjs: [
        {width:"100em", dbName:"name", displayName:c_teammatesWorkshareTypeFieldDisplayName, fieldTypeObj:c_genericTextFieldTypeObj, initialValue:"", cellHoverTF:true, requiredNotEmptyTF:true},
        {width:"3em", dbName:"sort", displayName:"Sort", fieldTypeObj:c_genericIntPositiveFieldTypeObj, initialValue:1}
      ]
    };

    return (
      <div className="flex11a yScroll">
        <TeamCompContactExtraFieldColumnManipulationTable p_tblName="tbl_a_teammates_extra_fields" />
        <div className="lrMedMargin hugeTopMargin hugeBottomMargin borderB1bbb" />
        <div className="medFullPad">
          <CEComplexReact.AddEditDeleteTable
            p_dataArrayOfObjs={c_teammatesWorkshareTypesArrayOfObjs}
            p_aedTableObj={workshareTypesAedTableObj}
          />
        </div>
      </div>
    );
  }
}));




//=================================================================================================================================================================
//=================================================================================================================================================================



export const AdminSubtabTeammateContracts = inject("AdminMobx")(observer(
class AdminSubtabTeammateContracts extends Component { //props: none
  constructor(props) {
    super(props);
    this.state = {
      s_selectedTab: "typesAndTemplates"
    }
  }

  onclick_admin_teammate_contract_tab = (i_newValue) => {
    this.setState({s_selectedTab:i_newValue});
  }

  render() {
    const s_selectedTab = this.state.s_selectedTab;

    var teammateContractsPageComponent = null;
    if(s_selectedTab === "typesAndTemplates") {
      teammateContractsPageComponent = (<TeammateContractTypesAndTemplates />);
    }
    else if(s_selectedTab === "processStatuses") {
      teammateContractsPageComponent = (<TeammateContractProcessStatuses />);
    }
    else if(s_selectedTab === "agreementTypes") {
      teammateContractsPageComponent = (<TeammateContractAgreementTypes />);
    }

    return (
      <>
        <div className="flex00a borderB1bbb smallFullPad">
          <CEGeneralReact.TabsList
            p_tabDbNamesArray={["typesAndTemplates", "processStatuses", "agreementTypes"]}
            p_tabDisplayNamesArray={["Contract Types (NDA/TA/SubK) and Templates", "Contract Process Statuses", "Edit Agreement Types"]}
            p_selectedTabDbName={s_selectedTab}
            p_tabHeight="3.2em"
            p_textMaxHeight="3em"
            p_tabWidth="18em"
            p_unselectedFontClass="font11 fontBold fontTextLight"
            p_unselectedBgClass="bgLighterGrayGradient hoverLighterBlueGradient fontTextLight"
            p_selectedBgClass="bgLightRedGradient"
            f_onSelect={this.onclick_admin_teammate_contract_tab}
          />
        </div>
        <div className="flex11a displayFlexColumn yScroll">
          {teammateContractsPageComponent}
        </div>
      </>
    );
  }
}));


const TeammateContractTypesAndTemplates = inject("CaptureExecMobx", "AdminMobx", "DatabaseMobx", "ContactsMobx")(observer(
class TeammateContractTypesAndTemplates extends Component { //props: none
  constructor(props) {
    super(props);

    var initialSelectedFileFolderSystemContactTypeID = -1;
    if(this.props.DatabaseMobx.c_teammatesContractTypesArrayOfObjs.length > 0) {
      initialSelectedFileFolderSystemContactTypeID = this.props.DatabaseMobx.c_teammatesContractTypesArrayOfObjs[0].id;
    }

    this.state = {
      s_selectedFileFolderSystemContractTypeID: initialSelectedFileFolderSystemContactTypeID,
      s_loadingAllContractsState: "notLoaded", //"notLoaded", "loading", "loaded"
      s_selectedCaptureID: -1,
      s_selectedContractRecordID: -1,
      s_selectedTemplateID: -1,
      s_showErrorsTF: false
    }
  }

  onswitch_contracts_on_other_teammates_when_sub = (i_newValue01) => {
    this.props.AdminMobx.a_update_tbl_a_company_fields("teammate_contracts_on_other_teammates_when_sub_01", i_newValue01, "i");
  }

  onclick_select_teammate_contract_type = (i_selectedTeammateContractTypeID) => {
    this.setState({s_selectedFileFolderSystemContractTypeID:i_selectedTeammateContractTypeID});
  }

  onclick_load_all_contracts_from_database = () => {
    this.setState({s_loadingAllContractsState:"loading"});

    const functionOnSuccess = () => {
      this.setState({s_loadingAllContractsState:"loaded"});
    }

    const functionOnError = () => {
      this.setState({s_loadingAllContractsState:"notLoaded"});
    }

    this.props.AdminMobx.a_teammate_contracts_load_all_contracts_from_database(functionOnSuccess, functionOnError);
  }

  onselect_capture_teammate_combination = (i_captureIDCommaContractRecordID) => {
    const explodeArray = JSFUNC.convert_comma_list_to_int_array(i_captureIDCommaContractRecordID);
    if(JSFUNC.is_array(explodeArray) && (explodeArray.length === 2)) {
      this.setState({
        s_selectedCaptureID: explodeArray[0],
        s_selectedContractRecordID: explodeArray[1]
      });
    }
  }

  onselect_template = (i_templateID) => {
    this.setState({s_selectedTemplateID:i_templateID});
  }

  onclick_generate_button_set_show_errors = () => {
    this.setState({s_showErrorsTF:true});
  }

  render() {
    const s_selectedFileFolderSystemContractTypeID = this.state.s_selectedFileFolderSystemContractTypeID;
    const s_loadingAllContractsState = this.state.s_loadingAllContractsState;
    const s_selectedCaptureID = this.state.s_selectedCaptureID;
    const s_selectedContractRecordID = this.state.s_selectedContractRecordID;
    const s_selectedTemplateID = this.state.s_selectedTemplateID;
    const s_showErrorsTF = this.state.s_showErrorsTF;

    const o_mediaQueryFlag = this.props.CaptureExecMobx.o_mediaQueryFlag;
    const c_companyTeammateContractsOnOtherTeammatesWhenSub01 = this.props.DatabaseMobx.c_companyTeammateContractsOnOtherTeammatesWhenSub01;
    const teammatesContractTypesArrayOfObjs = this.props.DatabaseMobx.c_teammatesContractTypesArrayOfObjs;

    const captureValidTF = JSFUNC.select_int_is_filled_out_tf(s_selectedCaptureID);
    const contractRecordValidTF = JSFUNC.select_int_is_filled_out_tf(s_selectedContractRecordID);
    const templateValidTF = JSFUNC.select_int_is_filled_out_tf(s_selectedTemplateID);

    const teammateContractTypesAedTableObj = {
      tblName: "tbl_a_teammates_contract_types",
      dragToResortFieldDbName: "admin_sort",
      initialSortedFieldDbName: "admin_sort",
      tableWidth: "100%",
      itemName: "Teammate Contract",
      deleteItemNameFieldDbName: "name",
      fieldsArrayOfObjs: [
        {width:"300em", dbName:"name", displayName:"Teammate Contract Name", fieldTypeObj:this.props.DatabaseMobx.c_genericTextFieldTypeObj, initialValue:"", cellHoverTF:true, requiredNotEmptyTF:true},
        {width:"100em", dbName:"short_name", displayName:"Short Name / Acronym", fieldTypeObj:this.props.DatabaseMobx.c_genericTextFieldTypeObj, initialValue:"", requiredNotEmptyTF:true},
        {width:"3em", dbName:"admin_sort", displayName:"Sort", fieldTypeObj:this.props.DatabaseMobx.c_genericIntPositiveFieldTypeObj, initialValue:1}
      ]
    };

    //if the contract type selected for the FFS was just deleted, change the selected contract type to the first one remaining in the array of contract types
    var selectedFileFolderSystemContractTypeID = s_selectedFileFolderSystemContractTypeID;
    if((teammatesContractTypesArrayOfObjs.length > 0) && !JSFUNC.in_array(s_selectedFileFolderSystemContractTypeID, JSFUNC.get_column_vector_from_arrayOfObjs(teammatesContractTypesArrayOfObjs, "id"))) {
      selectedFileFolderSystemContractTypeID = teammatesContractTypesArrayOfObjs[0].id;
    }

    //get the name of the red Contract Type currently selected at the top
    const selectedContractTypeMap = this.props.DatabaseMobx.tbl_row_map_from_id("tbl_a_teammates_contract_types", selectedFileFolderSystemContractTypeID);

    //build the state logic for loading all capture teammate contracts into memory from the database, selecting one, and running it as a test
    var selectContractTestsComponent = null;
    if(s_loadingAllContractsState === "notLoaded") {
      selectContractTestsComponent = (
        <div className="displayFlexColumnHcVc tbPad">
          <CEGeneralReact.CEButton
            p_type="gray"
            p_text="Click to Load Template Testing Choices"
            f_onClick={this.onclick_load_all_contracts_from_database}
          />
        </div>
      );
    }
    else if(s_loadingAllContractsState === "loading") {
      selectContractTestsComponent = (
        <div className="displayFlexColumnHcVc tbMedPad">
          <CEGeneralReact.LoadingAnimation />
        </div>
      );
    }
    else if(s_loadingAllContractsState === "loaded") {
      const selectedContractTypeTemplatesArrayOfObjs = JSFUNC.filtered_sorted_arrayOfObjs_from_mapOfMaps_matching_field_value(this.props.DatabaseMobx.o_tbl_a_teammates_contract_templates_filefoldersystem, "contract_type_id", selectedFileFolderSystemContractTypeID, "display_name", true, true);
      const teamplateSwsOptionsObj = {hasSearchTF:true, unselectedDisplay:"--Select a Teammate Contract Template--"};
      const templateSwsDataObj = this.props.DatabaseMobx.create_sws_data_obj_from_arrayOfObjs_and_vd_column_names("Teammate Contract Template", selectedContractTypeTemplatesArrayOfObjs, "id", false, "display_name", teamplateSwsOptionsObj);
      const selectTemplatesFieldTypeObj = this.props.DatabaseMobx.create_field_type_obj("select", templateSwsDataObj);

      var contractRecordsArrayOfObjs = [];
      for(let contractRecordObj of this.props.AdminMobx.o_allTeammateContractsArrayOfObjs) {
        if(contractRecordObj.teammate_contract_type_id === selectedFileFolderSystemContractTypeID) {
          var captureName = this.props.DatabaseMobx.capture_name_plaintext_from_capture_id(contractRecordObj.capture_id);
          var captureNameShort = JSFUNC.trim_string_max_chars_add_ellipsis(captureName, 100);

          var contactCompanyName = this.props.ContactsMobx.contact_name_from_id(false, contractRecordObj.contactCompanyID);

          var captureIDCommaContactRecordIDString = contractRecordObj.capture_id + "," + contractRecordObj.id;

          contractRecordsArrayOfObjs.push({
            captureIDCommaContactRecordIDString: captureIDCommaContactRecordIDString,
            captureNameSlashTeammateName: (captureName + " / " + contactCompanyName)
          });
        }
      }
      JSFUNC.sort_arrayOfObjs(contractRecordsArrayOfObjs, "captureNameSlashTeammateName", true);

      const captureTeammateSwsOptionsObj = {hasSearchTF:true, unselectedDisplay:"--Select a Teammate/Contract--"};
      const captureTeammateSwsDataObj = this.props.DatabaseMobx.create_sws_data_obj_from_arrayOfObjs_and_vd_column_names("Teammate/Contract", contractRecordsArrayOfObjs, "captureIDCommaContactRecordIDString", true, "captureNameSlashTeammateName", captureTeammateSwsOptionsObj);
      const selectCaptureTeammateFieldTypeObj = this.props.DatabaseMobx.create_field_type_obj("select", captureTeammateSwsDataObj);

      const selectedCaptureIDCommaContractRecordIDString = s_selectedCaptureID + "," + s_selectedContractRecordID;

      selectContractTestsComponent = (
        <>
          <div className="lrMedMargin">
            <div className="smallTopMargin microBottomMargin">
              <font className="fontItalic fontTextLight">
                {"Select a Capture/Teammate combination to test"}
              </font>
            </div>
            <CEGeneralReact.GenericInputOrSelectFromInputType
              p_fieldTypeObj={selectCaptureTeammateFieldTypeObj}
              p_valueRaw={selectedCaptureIDCommaContractRecordIDString}
              p_errorTF={(s_showErrorsTF && (!JSFUNC.select_int_is_filled_out_tf(s_selectedCaptureID) || !JSFUNC.select_int_is_filled_out_tf(s_selectedContractRecordID)))}
              f_onChangeOrOnSelect={this.onselect_capture_teammate_combination}
            />
          </div>
          <div className="displayFlexRowVc smallTopMargin">
            <div className="flex11a tbMargin lrMedMargin">
              <div className="smallTopMargin">
                <font className="fontItalic fontTextLight">
                  {"Select a Contract Template to test"}
                </font>
              </div>
              <div className="microTopMargin">
                <CEGeneralReact.GenericInputOrSelectFromInputType
                  p_fieldTypeObj={selectTemplatesFieldTypeObj}
                  p_valueRaw={s_selectedTemplateID}
                  p_errorTF={(s_showErrorsTF && !templateValidTF)}
                  f_onChangeOrOnSelect={this.onselect_template}
                />
              </div>
            </div>
            <div className="flex00a lrMedMargin">
              <CEComplexReact.GenerateAndUploadTeammateContractTemplateButtonProcess
                p_captureID={s_selectedCaptureID}
                p_teammateContractID={s_selectedContractRecordID}
                p_teammateContractTemplateID={s_selectedTemplateID}
                p_buttonText="Generate/Download Test Contract Template"
                p_canClickButtonTF={(captureValidTF && contractRecordValidTF && templateValidTF)}
                p_adminDownloadNoUploadTF={true}
                f_onClick={this.onclick_generate_button_set_show_errors}
              />
            </div>
          </div>
        </>
      );
    }

    const processContractsOnlyToPrimeOption0 = "[default] Can only process contracts between You (as a Sub) and the Prime";
    const processContractsToPrimeAndSubsOption1 = "Can process contracts between You (as a Sub) and other added Sub Teammates";
    const processContractsAsSubVerticalSwitchOptionsHeightEm = ((o_mediaQueryFlag >= 4) ? (1.9) : (2.8));

    return(
      <div className="flex11a displayFlexRow">
        <div className="flex11a yScroll" style={{flexBasis:"100em", borderRight:"solid 2px #bbb"}}>
          <div className="medFullPad">
            <div className="smallBottomMargin">
              <font className="font11 fontItalic fontTextLight">
                {"Option for processing Teammate Contracts when You are a Sub"}
              </font>
            </div>
            <div style={{maxWidth:"44em"}}>
              <CEGeneralReact.GenericInputOrSelectFromInputType
                p_fieldTypeObj={this.props.DatabaseMobx.create_verticalswitch_field_type_obj_from_value_array_and_display_array("Process Contracts as Sub Option", [0, 1], false, [processContractsOnlyToPrimeOption0, processContractsToPrimeAndSubsOption1], processContractsAsSubVerticalSwitchOptionsHeightEm)}
                p_valueRaw={c_companyTeammateContractsOnOtherTeammatesWhenSub01}
                f_onChangeOrOnSelect={this.onswitch_contracts_on_other_teammates_when_sub}
              />
            </div>
          </div>
          <div className="medFullPad borderT1bbb">
            <CEComplexReact.AddEditDeleteTable
              p_dataArrayOfObjs={teammatesContractTypesArrayOfObjs}
              p_aedTableObj={teammateContractTypesAedTableObj}
            />
          </div>
        </div>
        <div className="flex11a displayFlexColumn" style={{flexBasis:"100em"}}>
          <div className="flex00a medFullPad borderB1bbb">
            <div className="smallBottomMargin">
              <font className="font13 fontBold fontItalic fontTextLight">
                {"Select a Teammate Contract Type to upload Templates of that type below:"}
              </font>
            </div>
            <div className="displayFlexRow xyScroll">
              {teammatesContractTypesArrayOfObjs.map((m_teammateContractTypeObj) =>
                <TeammateContractTypeSelectionBox
                  key={m_teammateContractTypeObj.id}
                  p_contractTypeObj={m_teammateContractTypeObj}
                  p_selectedContractTypeID={selectedFileFolderSystemContractTypeID}
                  f_onClick={this.onclick_select_teammate_contract_type}
                />
              )}
            </div>
          </div>
          {(teammatesContractTypesArrayOfObjs.length > 0) ? (
            <CEComplexReact.FileFolderSystem
              p_tblName="tbl_a_teammates_contract_templates_filefoldersystem"
              p_tblMapOfMaps={this.props.DatabaseMobx.o_tbl_a_teammates_contract_templates_filefoldersystem}
              p_tblFilterValuesObj={{contract_type_id:selectedFileFolderSystemContractTypeID}}
              p_title={undefined}
              p_defaultXmlType={undefined}
              p_allowedExtsArray={["xml"]}
              p_disableUploadFilesTF={false}
              p_disableCreateOnlineLinkDocsTF={true}
              p_disableCreateFoldersTF={false}
              p_viewWideTrueNarrowFalse={(this.props.CaptureExecMobx.o_mediaQueryFlag >= 6)}
              p_navigateToFolderID={undefined}
              f_onPerformFFSAction={undefined}
              f_onNavigateToFolder={undefined}
            />
          ) : (
            <CEGeneralReact.EmptyScreenGray>
              {"There are 0 Teammate Contract Types, no Teammate Contract Templates can be uploaded until at least 1 is created"}
            </CEGeneralReact.EmptyScreenGray>
          )}
          <div className="flex00a bgAddEditDeleteTable" style={{borderTop:"solid 2px #985"}}>
            {selectContractTestsComponent}
            <div className="displayFlexColumnHcVc tbPad" style={{borderTop:"solid 1px #985"}}>
              <ViewAllTemplateCodewordsButtonWithFloatingBox />
            </div>
          </div>
        </div>
      </div>
    );
  }
}));


const TeammateContractTypeSelectionBox = inject("AdminMobx")(observer(
class TeammateContractTypeSelectionBox extends Component { //props: p_contractTypeObj, p_selectedContractTypeID, f_onClick
  onclick_teammate_contract_type_box = () => {
    const p_contractTypeObj = this.props.p_contractTypeObj;
    const f_onClick = this.props.f_onClick;
    if(JSFUNC.is_function(f_onClick)) {
      f_onClick(p_contractTypeObj.id);
    }
  }

  render() {
    const p_contractTypeObj = this.props.p_contractTypeObj;
    const p_selectedContractTypeID = this.props.p_selectedContractTypeID;
    const f_onClick = this.props.f_onClick;

    const isSelectedTF = (p_contractTypeObj.id === p_selectedContractTypeID);

    return(
      <div
        className={"flex00a displayFlexRowVc lrMargin lrPad border bevelBorderColors textCenter " + ((isSelectedTF) ? ("bgRed fontWhite") : ("bgLighterGray hoverLighterBlueGradient cursorPointer"))}
        style={{height:"4em", width:"11em", borderRadius:"0.9em"}}
        onClick={((isSelectedTF) ? (undefined) : (this.onclick_teammate_contract_type_box))}>
        <LibraryReact.MaxHeightWrap p_maxHeight="3.5em">
          {p_contractTypeObj.name}
        </LibraryReact.MaxHeightWrap>
      </div>
    );
  }
}));


const TeammateContractProcessStatuses = inject("AdminMobx", "DatabaseMobx")(observer(
class TeammateContractProcessStatuses extends Component { //props: none
  render() {
    const c_teammatesContractOtherStatusesArrayOfObjs = this.props.AdminMobx.c_teammatesContractOtherStatusesArrayOfObjs;
    const c_teammatesContractThemStatusesArrayOfObjs = this.props.AdminMobx.c_teammatesContractThemStatusesArrayOfObjs;
    const c_teammatesContractWeStatusesArrayOfObjs = this.props.AdminMobx.c_teammatesContractWeStatusesArrayOfObjs;

    const teammateContractOtherStatusesAedTableObj = {
      tblName: "tbl_a_teammates_contract_statuses",
      initialSortedFieldDbName: "sort",
      tableWidth: "37em",
      canAddNewItemsTF: false,
      canDeleteItemsTF: false,
      itemName: "Teammate Contracts Process Other Statuses",
      fieldsArrayOfObjs: [
        {width:"200em", dbName:"name", displayName:"Teammate Contract Agreement Type", fieldTypeObj:this.props.DatabaseMobx.c_genericTextFieldTypeObj, initialValue:"", cellHoverTF:true, requiredNotEmptyTF:true},
        {width:"100em", dbName:"color", displayName:"Color", fieldTypeObj:this.props.DatabaseMobx.c_genericColorFieldTypeObj, initialValue:"1155cc"}
      ]
    };

    const teammateContractThemStatusesAedTableObj = {
      tblName: "tbl_a_teammates_contract_statuses",
      dragToResortFieldDbName: "sort",
      initialSortedFieldDbName: "sort",
      tableWidth: "47em",
      itemName: "Teammate Contracts Process 'Them' Status",
      deleteItemNameFieldDbName: "name",
      newItemConstantFieldNamesArray: ["hc0_they1_we2"],
      newItemConstantValuesArray: [1],
      newItemConstantIdsbArray: ["i"],
      fieldsArrayOfObjs: [
        {width:"200em", dbName:"name", displayName:"Teammate Contract Agreement Type", fieldTypeObj:this.props.DatabaseMobx.c_genericTextFieldTypeObj, initialValue:"", cellHoverTF:true, requiredNotEmptyTF:true},
        {width:"100em", dbName:"color", displayName:"Color", fieldTypeObj:this.props.DatabaseMobx.c_genericColorFieldTypeObj, initialValue:"c09000"},
        {width:"3em", dbName:"sort", displayName:"Sort", fieldTypeObj:this.props.DatabaseMobx.c_genericIntPositiveFieldTypeObj, initialValue:1}
      ]
    };

    const teammateContractWeStatusesAedTableObj = {
      tblName: "tbl_a_teammates_contract_statuses",
      dragToResortFieldDbName: "sort",
      initialSortedFieldDbName: "sort",
      tableWidth: "47em",
      itemName: "Teammate Contracts Process 'We' Status",
      deleteItemNameFieldDbName: "name",
      newItemConstantFieldNamesArray: ["hc0_they1_we2"],
      newItemConstantValuesArray: [2],
      newItemConstantIdsbArray: ["i"],
      fieldsArrayOfObjs: [
        {width:"200em", dbName:"name", displayName:"Teammate Contract Agreement Type", fieldTypeObj:this.props.DatabaseMobx.c_genericTextFieldTypeObj, initialValue:"", cellHoverTF:true, requiredNotEmptyTF:true},
        {width:"100em", dbName:"color", displayName:"Color", fieldTypeObj:this.props.DatabaseMobx.c_genericColorFieldTypeObj, initialValue:"1155cc"},
        {width:"3em", dbName:"sort", displayName:"Sort", fieldTypeObj:this.props.DatabaseMobx.c_genericIntPositiveFieldTypeObj, initialValue:1}
      ]
    };

    return(
      <>
        <div className="smallFullMargin hugeTopPad hugeBottomPad lrMedPad border1bbb bgLightestGray" style={{maxWidth:"100em"}}>
          <div className="smallBottomMargin">
            <font className="font15 fontTextLight">
              {"Full Teammate Contract Process"}
            </font>
          </div>
          <TeammateContractsReact.StatusTimeline />
        </div>
        <div className="displayFlexRow flexWrap">
          <div className="flex00a hugeTopPad hugeBottomPad lrMedPad borderR1bbb">
            <CEComplexReact.AddEditDeleteTable
              p_dataArrayOfObjs={c_teammatesContractOtherStatusesArrayOfObjs}
              p_aedTableObj={teammateContractOtherStatusesAedTableObj}
            />
          </div>
          <div className="flex00a hugeTopPad hugeBottomPad lrMedPad borderR1bbb">
            <CEComplexReact.AddEditDeleteTable
              p_dataArrayOfObjs={c_teammatesContractThemStatusesArrayOfObjs}
              p_aedTableObj={teammateContractThemStatusesAedTableObj}
            />
          </div>
          <div className="flex00a hugeTopPad hugeBottomPad lrMedPad">
            <CEComplexReact.AddEditDeleteTable
              p_dataArrayOfObjs={c_teammatesContractWeStatusesArrayOfObjs}
              p_aedTableObj={teammateContractWeStatusesAedTableObj}
            />
          </div>
        </div>
      </>
    );
  }
}));


const TeammateContractAgreementTypes = inject("AdminMobx", "DatabaseMobx")(observer(
class TeammateContractAgreementTypes extends Component { //props: none
  render() {
    const c_teammatesContractAgreementTypesArrayOfObjs = this.props.AdminMobx.c_teammatesContractAgreementTypesArrayOfObjs;

    const teammateContractAgreementTypesAedTableObj = {
      tblName: "tbl_a_teammates_contract_agreement_types",
      dragToResortFieldDbName: "sort",
      initialSortedFieldDbName: "sort",
      tableWidth: "35em",
      itemName: "Teammate Contract Agreement Type",
      deleteItemNameFieldDbName: "name",
      fieldsArrayOfObjs: [
        {width:"100em", dbName:"name", displayName:"Teammate Contract Agreement Type", fieldTypeObj:this.props.DatabaseMobx.c_genericTextFieldTypeObj, initialValue:"", cellHoverTF:true, requiredNotEmptyTF:true},
        {width:"3em", dbName:"sort", displayName:"Sort", fieldTypeObj:this.props.DatabaseMobx.c_genericIntPositiveFieldTypeObj, initialValue:1}
      ]
    };

    return(
      <div className="medFullMargin">
        <CEComplexReact.AddEditDeleteTable
          p_dataArrayOfObjs={c_teammatesContractAgreementTypesArrayOfObjs}
          p_aedTableObj={teammateContractAgreementTypesAedTableObj}
        />
      </div>
    );
  }
}));





//=================================================================================================================================================================
//=================================================================================================================================================================



export const AdminSubtabTeammateRatings = inject("AdminMobx", "DatabaseMobx")(observer(
class AdminSubtabTeammateRatings extends Component { //props: none
  constructor(props) {
    super(props);
    this.state = {
      s_recomputingContactCompanyTeammateRatingsState: "initial" //"initial", "working", "success", "error"
    }
  }

  onclick_recompute_all_contact_company_teammate_ratings = () => {
    this.setState({s_recomputingContactCompanyTeammateRatingsState:"working"});

    const functionOnSuccess = () => {
      this.setState({s_recomputingContactCompanyTeammateRatingsState:"success"});
    }
    const functionOnError = () => {
      this.setState({s_recomputingContactCompanyTeammateRatingsState:"error"});
    }
    this.props.AdminMobx.a_teammates_ratings_recompute_all_contact_teammate_ratings(functionOnSuccess, functionOnError);
  }


  render() {
    const s_recomputingContactCompanyTeammateRatingsState = this.state.s_recomputingContactCompanyTeammateRatingsState;

    const c_teammatesRatingsQuestionsArrayOfObjs = this.props.DatabaseMobx.c_teammatesRatingsQuestionsArrayOfObjs;

    const functionOnInsertTeammateRatingQuestion = (i_parseResponse) => {
      const newlyInsertedTeammateRatingQuestionID = i_parseResponse.outputObj.i0;

      const jsDescription = JSFUNC.js_description_from_action("AdminReact - AdminSubtabTeammateRatings", "functionOnInsertTeammateRatingQuestion", ["newlyInsertedTeammateRatingQuestionID"], [newlyInsertedTeammateRatingQuestionID]);
      const C_CallPhpTblUID = new JSPHP.ClassCallPhpTblUID(jsDescription);

      const contactCompaniesRatingColumnDbName = "tr_q" + newlyInsertedTeammateRatingQuestionID;
      const decimalFieldTypeObj = this.props.DatabaseMobx.c_genericDecimalFieldTypeObj;
      const initialValueForAllExistingRows = -1; //set every rating value to -1 initially for "N/A"
      C_CallPhpTblUID.add_alter_db_tbl_insert_column("tbl_g_contacts_companies", contactCompaniesRatingColumnDbName, decimalFieldTypeObj.mysqlColumnDataType, decimalFieldTypeObj.blankValue, initialValueForAllExistingRows);

      const questionnaireSubmissionAnswerColumnDbName = "q" + newlyInsertedTeammateRatingQuestionID + "a";
      const int0to9FieldTypeObj = this.props.DatabaseMobx.c_genericInt0to9FieldTypeObj;
      C_CallPhpTblUID.add_alter_db_tbl_insert_column("tbl_c_teammates_ratings_questionnaire_submissions", questionnaireSubmissionAnswerColumnDbName, int0to9FieldTypeObj.mysqlColumnDataType, int0to9FieldTypeObj.blankValue, initialValueForAllExistingRows);

      const questionnaireSubmissionCommentColumnDbName = "q" + newlyInsertedTeammateRatingQuestionID + "c";
      const textFieldTypeObj = this.props.DatabaseMobx.c_genericTextFieldTypeObj;
      C_CallPhpTblUID.add_alter_db_tbl_insert_column("tbl_c_teammates_ratings_questionnaire_submissions", questionnaireSubmissionCommentColumnDbName, textFieldTypeObj.mysqlColumnDataType, textFieldTypeObj.blankValue);

      C_CallPhpTblUID.execute();
    }

    const functionOnDeleteTeammateRatingQuestion = (i_C_CallPhpTblUID, i_dataRowObj) => {
      const contactCompaniesRatingColumnDbName = "tr_q" + i_dataRowObj.id;
      i_C_CallPhpTblUID.add_alter_db_tbl_delete_column("tbl_g_contacts_companies", contactCompaniesRatingColumnDbName);

      const questionnaireSubmissionAnswerColumnDbName = "q" + i_dataRowObj.id + "a";
      i_C_CallPhpTblUID.add_alter_db_tbl_delete_column("tbl_c_teammates_ratings_questionnaire_submissions", questionnaireSubmissionAnswerColumnDbName);

      const questionnaireSubmissionCommentColumnDbName = "q" + i_dataRowObj.id + "c";
      i_C_CallPhpTblUID.add_alter_db_tbl_delete_column("tbl_c_teammates_ratings_questionnaire_submissions", questionnaireSubmissionCommentColumnDbName);
    }

    const teammatesRatingsQuestionsAedTableObj = {
      tblName: "tbl_a_teammates_ratings_questions",
      dragToResortFieldDbName: "sort",
      initialSortedFieldDbName: "sort",
      tableWidth: "70em",
      itemName: "Teammate Rating Question",
      deleteItemNameFieldDbName: "name",
      itemInsertFunctionOnSuccess: functionOnInsertTeammateRatingQuestion,
      itemDeleteFunctionsArray: [functionOnDeleteTeammateRatingQuestion],
      fieldsArrayOfObjs: [
        {width:"500em", dbName:"name", displayName:"Question", fieldTypeObj:this.props.DatabaseMobx.c_genericTextFieldTypeObj, initialValue:"", cellHoverTF:true, requiredNotEmptyTF:true},
        {width:"100em", dbName:"weight", displayName:"Weight (0-9)", fieldTypeObj:this.props.DatabaseMobx.c_genericInt0to9FieldTypeObj, initialValue:5, cellCenterTF:true, requiredNotEmptyTF:true},
        {width:"3em", dbName:"sort", displayName:"Sort", fieldTypeObj:this.props.DatabaseMobx.c_genericIntPositiveFieldTypeObj, initialValue:1}
      ]
    };

    return(
      <div className="flex11a yScroll medFullPad">
        <div className="displayFlexRow flexWrap">
          <div className="flex00a">
            <CEComplexReact.AddEditDeleteTable
              p_dataArrayOfObjs={c_teammatesRatingsQuestionsArrayOfObjs}
              p_aedTableObj={teammatesRatingsQuestionsAedTableObj}
            />
          </div>
          <div className="flex00a" style={{flexBasis: "6em"}} />
          <div className="flex00a" style={{flexBasis:"41em"}}>
            <div className="border1bbb medFullPad">
              <div className="smallBottomMargin">
                <font className="fontItalic fontTextLighter">
                  {"Use this button to manually recompute the Teammate Rating for all Contact Companies when the Questions or Weights are changed/added/deleted in this table"}
                </font>
              </div>
              {(s_recomputingContactCompanyTeammateRatingsState === "working") ? (
                <div className="displayFlexColumnHcVc tbPad lrMedPad bgLightestGray border1ddd borderRadius05 textCenter">
                  <div className="">
                    <font className="fontItalic">
                      {"Recomputing..."}
                    </font>
                  </div>
                  <div>
                    <CEGeneralReact.LoadingAnimation />
                  </div>
                </div>
              ) : (
                <CEGeneralReact.ButtonWithConfirmBox
                  p_buttonType="add"
                  p_buttonText="Recompute All Contact Company Teammate Ratings"
                  p_confirmType="confirm"
                  p_confirmMessage="Are you sure you want to recompute the Teammate Rating for all Contact Companies?"
                  f_onClickConfirm={this.onclick_recompute_all_contact_company_teammate_ratings}
                />
              )}
              {(s_recomputingContactCompanyTeammateRatingsState === "success") &&
                <div className="displayFlexColumnHcVc smallTopMargin tbPad lrMedPad bgLighterGreen border1LightGreen borderRadius05 textCenter">
                  <font className="fontItalic fontDarkGreen">
                    {"Recomputation completed successfully"}
                  </font>
                </div>
              }
              {(s_recomputingContactCompanyTeammateRatingsState === "error") &&
                <div className="displayFlexColumnHcVc smallTopMargin tbPad lrMedPad bgLightRed border1LightRed borderRadius05 textCenter">
                  <font className="fontBold fontRed">
                    {"Recomputation unsuccessful, please try again"}
                  </font>
                </div>
              }
            </div>
          </div>
        </div>
      </div>
    );
  }
}));





//=================================================================================================================================================================
//=================================================================================================================================================================



export const AdminSubtabTeammateSurveys = inject("CaptureExecMobx", "AdminMobx", "DatabaseMobx")(observer(
class AdminSubtabTeammateSurveys extends Component { //props: none
  onswitch_company_teammate_surveys_notifications_to_all_capture_managers = (i_newValue01) => {
    this.props.AdminMobx.a_update_tbl_a_company_fields("teammate_surveys_notifications_to_all_capture_managers_01", i_newValue01, "i");
  }

  render() {
    const c_productStylingObj = this.props.CaptureExecMobx.c_productStylingObj;
    const c_companyTeammateSurveysNotificationsToAllCaptureManagers01 = this.props.DatabaseMobx.c_companyTeammateSurveysNotificationsToAllCaptureManagers01;

    return(
      <div className="flex11a yScroll medFullPad">
        <div className="bgLightestestGray border1bbb borderRadius05 medFullPad" style={{width:"30em"}}>
          <div className="medBottomMargin">
            <font className="fontItalic fontTextLight">
              {"Here you can custom define the 6 colors representing 0 to 5 (out of 5) on 'Scale 0-5' type questions in the " + c_productStylingObj.productName + " Teammates Survey Matrix of response results"}
            </font>
          </div>
          {[0,1,2,3,4,5].map((m_scale0to5Int) =>
            <AdminTeammateSurveysEditColor p_scale0to5Int={m_scale0to5Int} />
          )}
        </div>
        <div className="hugeTopMargin border1bbb medFullPad" style={{maxWidth:"44em"}}>
          <div className="medBottomMargin">
            <font className="fontItalic fontTextLight">
              {"Use this switch to choose whether notifications/emails regarding Teammate Survey completion from Teammates are sent to only the original sender of the survey, or also to all Capture Managers on the Capture"}
            </font>
          </div>
          <CEGeneralReact.GenericInputOrSelectFromInputType
            p_fieldTypeObj={this.props.DatabaseMobx.create_verticalswitch_field_type_obj_from_value_array_and_display_array("Survey Notifications Option", [0, 1], false, ["[default] Notifications/Emails are only sent to the survey sender", "Notifications/Emails are sent to the survey sender and all Capture Managers"], 1.9)}
            p_valueRaw={c_companyTeammateSurveysNotificationsToAllCaptureManagers01}
            f_onChangeOrOnSelect={this.onswitch_company_teammate_surveys_notifications_to_all_capture_managers}
          />
        </div>
      </div>
    );
  }
}));

const AdminTeammateSurveysEditColor = inject("DatabaseMobx")(observer(
class AdminTeammateSurveysEditColor extends Component { //props: p_scale0to5Int
  onsave_teammates_surveys_scale05_color = (i_newValue) => {
    const scale0to5Int = this.props.p_scale0to5Int;

    const colorFieldDbName = "color" + scale0to5Int;

    const jsDescription = JSFUNC.js_description_from_action("AdminReact - AdminTeammateSurveysEditColor", "onsave_teammates_surveys_scale05_color", ["i_newValue"], [i_newValue]);
    const C_CallPhpTblUID = new JSPHP.ClassCallPhpTblUID(jsDescription);
    C_CallPhpTblUID.add_update("tbl_a_teammates_surveys_scale05_colors", 1, [colorFieldDbName], [i_newValue], ["s"]);
    C_CallPhpTblUID.execute();
  }

  render() {
    const p_scale0to5Int = this.props.p_scale0to5Int;
    
    const o_tbl_a_teammates_surveys_scale05_colors = this.props.DatabaseMobx.o_tbl_a_teammates_surveys_scale05_colors;

    const colorFieldDbName = "color" + p_scale0to5Int;

    var currentColor = "ffffff";
    const teammatesSurveysScale05ColorsMap = o_tbl_a_teammates_surveys_scale05_colors.get(1);
    if(teammatesSurveysScale05ColorsMap !== undefined) {
      currentColor = teammatesSurveysScale05ColorsMap.get(colorFieldDbName);
    }

    return(
      <CEGeneralReact.CaptureExecFieldEditSaveCancel
        p_ceEditItemString={"AdminTeammatesSurveysEdit_" + colorFieldDbName}
        p_fieldDisplayName={"Color for Scale Response " + p_scale0to5Int}
        p_fieldTypeObj={this.props.DatabaseMobx.c_genericColorFieldTypeObj}
        p_valueRaw={currentColor}
        p_valueIsEditableTFU={true}
        p_containerClass=""
        p_fieldClass="fontBlue"
        p_fieldWidth="14em"
        f_onSaveChanged={this.onsave_teammates_surveys_scale05_color}
      />
    );
  }
}));





//=================================================================================================================================================================
//=================================================================================================================================================================



export const AdminSubtabCompetitors = inject("AdminMobx")(observer(
class AdminSubtabCompetitors extends Component { //props: none
  render() {
    return (
      <div className="flex11a yScroll yScrollBottomPad">
        <TeamCompContactExtraFieldColumnManipulationTable p_tblName="tbl_a_competitors_extra_fields" />
      </div>
    );
  }
}));





//=================================================================================================================================================================
//=================================================================================================================================================================


//Admin for Proposal Managements Options is in ProposalManagementReact


//=================================================================================================================================================================
//=================================================================================================================================================================



export const AdminSubtabRiskAssessment = inject("AdminMobx", "DatabaseMobx")(observer(
class AdminSubtabRiskAssessment extends Component { //props: none
  render() {
    const c_riskCategoriesArrayOfObjs = this.props.AdminMobx.c_riskCategoriesArrayOfObjs;
    const c_risksProbabilityRiskLevelsArrayOfObjs = this.props.AdminMobx.c_risksProbabilityRiskLevelsArrayOfObjs;
    const c_risksImpactRiskLevelsArrayOfObjs = this.props.AdminMobx.c_risksImpactRiskLevelsArrayOfObjs;
    const c_genericTextFieldTypeObj = this.props.DatabaseMobx.c_genericTextFieldTypeObj;
    const c_genericTextareaFieldTypeObj = this.props.DatabaseMobx.c_genericTextareaFieldTypeObj;
    const c_genericPercentInt0to100FieldTypeObj = this.props.DatabaseMobx.c_genericPercentInt0to100FieldTypeObj;
    const c_genericColorFieldTypeObj = this.props.DatabaseMobx.c_genericColorFieldTypeObj;

    const riskCategoriesAedTableObj = {
      tblName: "tbl_a_risks_categories",
      dragToResortFieldDbName: undefined,
      initialSortedFieldDbName: "name",
      tableWidth: "35em",
      itemName: "Risk Category",
      deleteItemNameFieldDbName: "name",
      fieldsArrayOfObjs: [
        {width:"100em", dbName:"name", displayName:"Risk Category", fieldTypeObj:c_genericTextareaFieldTypeObj, initialValue:"", cellHoverTF:true, requiredNotEmptyTF:true}
      ]
    };

    const probabilityAedTableObj = {
      tblName: "tbl_a_risks_probability_levels",
      dragToResortFieldDbName: undefined,
      initialSortedFieldDbName: "percent_0to100",
      tableWidth: "45em",
      itemName: "Probability Risk Level",
      deleteItemNameFieldDbName: "name",
      fieldsArrayOfObjs: [
        {width:"200em", dbName:"name", displayName:"Probability Risk Level Name", fieldTypeObj:c_genericTextFieldTypeObj, initialValue:"", cellHoverTF:true, requiredNotEmptyTF:true},
        {width:"100em", dbName:"percent_0to100", displayName:"Percent (0-100%)", fieldTypeObj:c_genericPercentInt0to100FieldTypeObj, initialValue:50, cellCenterTF:true, requiredNotEmptyTF:true},
        {width:"100em", dbName:"color", displayName:"Font Color", fieldTypeObj:c_genericColorFieldTypeObj, initialValue:"666666", cellCenterTF:true, requiredNotEmptyTF:true}
      ]
    };

    const impactAedTableObj = {
      tblName: "tbl_a_risks_impact_levels",
      dragToResortFieldDbName: undefined,
      initialSortedFieldDbName: "percent_0to100",
      tableWidth: "45em",
      itemName: "Impact Risk Level",
      deleteItemNameFieldDbName: "name",
      fieldsArrayOfObjs: [
        {width:"200em", dbName:"name", displayName:"Impact Risk Level Name", fieldTypeObj:c_genericTextFieldTypeObj, initialValue:"", cellHoverTF:true, requiredNotEmptyTF:true},
        {width:"100em", dbName:"percent_0to100", displayName:"Percent (0-100%)", fieldTypeObj:c_genericPercentInt0to100FieldTypeObj, initialValue:50, cellCenterTF:true, requiredNotEmptyTF:true},
        {width:"100em", dbName:"color", displayName:"Font Color", fieldTypeObj:c_genericColorFieldTypeObj, initialValue:"666666", cellCenterTF:true, requiredNotEmptyTF:true}
      ]
    };

    return (
      <div className="flex11a xyScroll yScrollBottomPad">
        <div className="displayFlexRow flexWrap" style={{borderBottom:"solid 1px #bbb"}}>
          <div className="flex00a medFullMargin">
            <CEComplexReact.AddEditDeleteTable
              p_dataArrayOfObjs={c_riskCategoriesArrayOfObjs}
              p_aedTableObj={riskCategoriesAedTableObj}
            />
          </div>
          <div className="flex00a medFullMargin">
            <CEComplexReact.AddEditDeleteTable
              p_dataArrayOfObjs={c_risksProbabilityRiskLevelsArrayOfObjs}
              p_aedTableObj={probabilityAedTableObj}
            />
          </div>
          <div className="flex00a medFullMargin">
            <CEComplexReact.AddEditDeleteTable
              p_dataArrayOfObjs={c_risksImpactRiskLevelsArrayOfObjs}
              p_aedTableObj={impactAedTableObj}
            />
          </div>
        </div>
        <div className="medFullMargin" style={{width:"70em"}}>
          <OpenCaptureReact.RiskAssessmentProbabilityImpactMatrix p_risksArrayOfObjs={[]} />
        </div>
      </div>
    );
  }
}));





//=================================================================================================================================================================
//=================================================================================================================================================================



export const AdminSubtabBudgets = inject("AdminMobx", "DatabaseMobx")(observer(
class AdminSubtabBudgets extends Component { //props: none
  onsave_budget_manager_approval_num_days = (i_newValue) => {
    this.props.AdminMobx.a_update_tbl_a_company_fields("budget_manager_approval_num_days", i_newValue, "i");
  }

  ondrop_budget_category_into_capture_type = (i_draggedBudgetCategoryID) => {
    const o_selectedCaptureTypeID = this.props.AdminMobx.o_selectedCaptureTypeID;
    const c_selectedCaptureTypeBudgetCategoryIDsArray = this.props.AdminMobx.c_selectedCaptureTypeBudgetCategoryIDsArray;

    if(!JSFUNC.in_array(i_draggedBudgetCategoryID, c_selectedCaptureTypeBudgetCategoryIDsArray)) { //must be adding a unique budget category to this capture type that is not already added
      var newSelectedCaptureTypeDetailsCardGroupIDsArray = JSFUNC.copy_array(c_selectedCaptureTypeBudgetCategoryIDsArray);
      newSelectedCaptureTypeDetailsCardGroupIDsArray.push(i_draggedBudgetCategoryID);
      const newSelectedCaptureTypeDetailsCardGroupIDsComma = JSFUNC.convert_array_to_comma_list(newSelectedCaptureTypeDetailsCardGroupIDsArray);

      const jsDescription = JSFUNC.js_description_from_action("AdminReact - AdminSubtabBudgets", "ondrop_budget_category_into_capture_type", ["i_draggedBudgetCategoryID"], [i_draggedBudgetCategoryID]);
      const C_CallPhpTblUID = new JSPHP.ClassCallPhpTblUID(jsDescription);
      C_CallPhpTblUID.add_update("tbl_a_capture_types", o_selectedCaptureTypeID, "budget_category_ids_comma", newSelectedCaptureTypeDetailsCardGroupIDsComma, "s");
      C_CallPhpTblUID.execute();
    }
  }

  onremove_all_budget_categories_from_capture_type = () => {
    const o_selectedCaptureTypeID = this.props.AdminMobx.o_selectedCaptureTypeID;
    const c_selectedCaptureTypeBudgetCategoryIDsArray = this.props.AdminMobx.c_selectedCaptureTypeBudgetCategoryIDsArray;
    if(c_selectedCaptureTypeBudgetCategoryIDsArray.length > 0) {
      const jsDescription = JSFUNC.js_description_from_action("AdminMobx - AdminSubtabBudgets", "onremove_all_budget_categories_from_capture_type", [], []);
      const C_CallPhpTblUID = new JSPHP.ClassCallPhpTblUID(jsDescription);
      C_CallPhpTblUID.add_update("tbl_a_capture_types", o_selectedCaptureTypeID, "budget_category_ids_comma", "", "s");
      C_CallPhpTblUID.execute();
    }
  }

  render() {
    const c_selectedCaptureTypeExistsTF = this.props.AdminMobx.c_selectedCaptureTypeExistsTF;
    const c_selectedCaptureTypeObj = this.props.AdminMobx.c_selectedCaptureTypeObj;
    const c_selectedCaptureTypeBudgetCategoryIDsArray = this.props.AdminMobx.c_selectedCaptureTypeBudgetCategoryIDsArray;
    const c_selectedCaptureTypeBudgetCategoriesArrayOfObjs = this.props.AdminMobx.c_selectedCaptureTypeBudgetCategoriesArrayOfObjs;
    const c_cardNameBudget = this.props.DatabaseMobx.c_cardNameBudget;
    const c_fieldMapOfCaptureType = this.props.DatabaseMobx.c_fieldMapOfCaptureType;

    const numBudgetCategoriesAdded = c_selectedCaptureTypeBudgetCategoryIDsArray.length;

    const budgetCategoriesAedTableObj = {
      tblName: "tbl_a_budget_categories_pool",
      dragToResortFieldDbName: "sort",
      canAlwaysDragResortTF: true,
      initialSortedFieldDbName: "sort",
      tableWidth: "100%",
      itemName: "Budget Category",
      deleteItemNameFieldDbName: "name",
      canAddItemsFromAddColumnTF: c_selectedCaptureTypeExistsTF,
      idsAlreadyAddedArray: c_selectedCaptureTypeBudgetCategoryIDsArray,
      fieldsArrayOfObjs: [
        {width:"100em", dbName:"name", displayName:"Budget Category", fieldTypeObj:this.props.DatabaseMobx.c_genericTextFieldTypeObj, initialValue:"", cellHoverTF:true, requiredNotEmptyTF:true},
        {width:"3em", dbName:"sort", displayName:"Sort", fieldTypeObj:this.props.DatabaseMobx.c_genericIntPositiveFieldTypeObj, initialValue:1}
      ]
    };

    return (
      <>
        <AdminCaptureTypeSelectionBoxes />
        <div className="flex11a displayFlexRow">
          <div className="flex11a yScroll medFullPad" style={{flexBasis:"100em"}}>
            <div className="smallBottomMargin">
              <font className="font14 fontItalic">
                {"All unique Budget Categories used in every " + c_fieldMapOfCaptureType.get("display_name")}
              </font>
            </div>
            <CEComplexReact.AddEditDeleteTable
              p_dataArrayOfObjs={this.props.AdminMobx.c_budgetCategoriesPoolArrayOfObjs}
              p_aedTableObj={budgetCategoriesAedTableObj}
              f_onClickAddItem={this.ondrop_budget_category_into_capture_type}
            />
            <div className="flex00a hugeTopMargin medFullPad borderT1ddd borderB1ddd" style={{width:"40em"}}>
              <CEGeneralReact.CaptureExecFieldEditSaveCancel
                p_ceEditItemString="adminBudgetsApprovalNumDays"
                p_fieldDisplayName="Budget Manager Target # Days to Approve Funding Requests"
                p_fieldTypeObj={this.props.DatabaseMobx.c_genericIntPositiveFieldTypeObj}
                p_valueRaw={this.props.DatabaseMobx.c_companyBudgetManagerApprovalNumDays}
                p_valueIsEditableTFU={true}
                p_fieldClass="fontBlue"
                p_fieldWidth="14em"
                f_onSaveChanged={this.onsave_budget_manager_approval_num_days}
              />
            </div>
          </div>
          <div className="flex11a displayFlexColumn medFullPad" style={{flexBasis:"100em"}}>
            <div className="flex11a xyScroll">
              <BlueItemCollectionShell
                p_isReceivingTF={true}
                p_title={"Budget Categories for captures with " + c_fieldMapOfCaptureType.get("display_name") + " '" + c_selectedCaptureTypeObj.name + "'"}
                p_dropUniqueString="AddEditDeleteTableRow_tbl_a_budget_categories_pool"
                p_dropNotAllowedDraggerIDsArray={c_selectedCaptureTypeBudgetCategoryIDsArray}
                p_dropMessage="[Drag/drop Budget Categories from the pool]"
                p_dropAllowDropMessage={"[Drop Category to add to " + c_cardNameBudget + " Card]"}
                p_dropNotAllowDropMessage={"[Cannot have duplicate Budget Categories on the " + c_cardNameBudget + " Card]"}
                f_onClickSetAsReceiving={undefined}
                f_onDrop={this.ondrop_budget_category_into_capture_type}
                f_onRemoveAllItems={this.onremove_all_budget_categories_from_capture_type}>
                {c_selectedCaptureTypeBudgetCategoriesArrayOfObjs.map((m_budgetCategoryObj, m_index) =>
                  <AddedBudgetCategoryItem
                    key={c_selectedCaptureTypeObj.id + "-" + m_budgetCategoryObj.id}
                    p_budgetCategoryObj={m_budgetCategoryObj}
                    p_budgetCategoryIndex={m_index}
                    p_isOnlyItemTF={(numBudgetCategoriesAdded === 1)}
                    p_isLastItemTF={(m_index === (numBudgetCategoriesAdded - 1))}
                  />
                )}
              </BlueItemCollectionShell>
            </div>
          </div>
        </div>
      </>
    );
  }
}));


export const AddedBudgetCategoryItem = inject("AdminMobx", "DatabaseMobx")(observer(
class AddedBudgetCategoryItem extends Component { //props: p_budgetCategoryObj, p_budgetCategoryIndex, p_isOnlyItemTF, p_isLastItemTF
  onclick_remove_details_card_group_from_capture_type = () => {
    const p_budgetCategoryObj = this.props.p_budgetCategoryObj;

    const c_selectedCaptureTypeObj = this.props.AdminMobx.c_selectedCaptureTypeObj;
    const c_selectedCaptureTypeBudgetCategoryIDsArray = this.props.AdminMobx.c_selectedCaptureTypeBudgetCategoryIDsArray;

    const newSelectedCaptureTypeDetailsCardGroupIDsArray = JSFUNC.remove_all_values_from_array(p_budgetCategoryObj.id, c_selectedCaptureTypeBudgetCategoryIDsArray);
    const newSelectedCaptureTypeDetailsCardGroupIDsComma = JSFUNC.convert_array_to_comma_list(newSelectedCaptureTypeDetailsCardGroupIDsArray);

    const jsDescription = JSFUNC.js_description_from_action("AdminReact - AddedBudgetCategoryItem", "onclick_remove_details_card_group_from_capture_type", [], []);
    const C_CallPhpTblUID = new JSPHP.ClassCallPhpTblUID(jsDescription);
    C_CallPhpTblUID.add_update("tbl_a_capture_types", c_selectedCaptureTypeObj.id, "budget_category_ids_comma", newSelectedCaptureTypeDetailsCardGroupIDsComma, "s");
    C_CallPhpTblUID.execute();
  }

  render() {
    const p_budgetCategoryObj = this.props.p_budgetCategoryObj;
    const p_budgetCategoryIndex = this.props.p_budgetCategoryIndex;
    const p_isOnlyItemTF = this.props.p_isOnlyItemTF;
    const p_isLastItemTF = this.props.p_isLastItemTF;

    const c_selectedCaptureTypeObj = this.props.AdminMobx.c_selectedCaptureTypeObj;
    const c_cardNameBudget = this.props.DatabaseMobx.c_cardNameBudget;
    const c_fieldMapOfCaptureType = this.props.DatabaseMobx.c_fieldMapOfCaptureType;

    return(
      <CEGeneralReact.CEDragToResortItemWithinCommaListWithinDbTbl
        p_canResortTF={true}
        p_uniqueString="captureTypeDetailsCardGroup"
        p_itemIndex={p_budgetCategoryIndex}
        p_itemID={p_budgetCategoryObj.id}
        p_itemSortColumnWidth="2em"
        p_itemSortNumberFontClass={undefined}
        p_isOnlyItemTF={p_isOnlyItemTF}
        p_isLastItemTF={p_isLastItemTF}
        p_outerPadClass="microFullPad"
        p_itemClass="displayFlexRow border bevelBorderColors borderRadius05 bgAlmostWhite"
        p_itemStyleObj={{height:"2.4em"}}
        p_lastItemExtraDropZoneHeight="1.8em"
        p_dragEntireItemTrueOnlySortNumberFalse={true}
        p_tblName="tbl_a_capture_types"
        p_tblRowID={c_selectedCaptureTypeObj.id}
        p_tblCommaListColumnName="budget_category_ids_comma"
        p_commaList={c_selectedCaptureTypeObj.budget_category_ids_comma}>
        <div className="flex11a displayFlexRowVc lrPad">
          {p_budgetCategoryObj.name}
        </div>
        <div className="flex00a displayFlexColumnHcVc borderL1ddd" style={{flexBasis:"2em"}}>
          <CEGeneralReact.RemoveItemXWithRedHover
            p_title={"Remove Budget Category '" + p_budgetCategoryObj.name + "' from " + c_cardNameBudget + " Card for " + c_fieldMapOfCaptureType.get("display_name") + " '" + c_selectedCaptureTypeObj.name + "'"}
            f_onClick={this.onclick_remove_details_card_group_from_capture_type}
          />
        </div>
      </CEGeneralReact.CEDragToResortItemWithinCommaListWithinDbTbl>
    );
  }
}));





//=================================================================================================================================================================
//=================================================================================================================================================================






export const AdminSubtabSingleCaptureTemplates = inject("CaptureExecMobx", "AdminMobx", "DatabaseMobx")(observer(
class AdminSubtabSingleCaptureTemplates extends Component { //props: none
  constructor(props) {
    super(props);
    this.state = {
      s_selectedCaptureID: -1,
      s_selectedTemplateID: -1,
      s_showErrorsTF: false
    }
  }

  onselect_capture = (i_captureID) => {
    this.setState({s_selectedCaptureID:i_captureID});
  }

  onselect_template = (i_templateID) => {
    this.setState({s_selectedTemplateID:i_templateID});
  }

  onclick_generate_button_set_show_errors = () => {
    this.setState({s_showErrorsTF:true});
  }

  render() {
    const s_selectedCaptureID = this.state.s_selectedCaptureID;
    const s_selectedTemplateID = this.state.s_selectedTemplateID;
    const s_showErrorsTF = this.state.s_showErrorsTF;

    const o_mediaQueryFlag = this.props.CaptureExecMobx.o_mediaQueryFlag;
    const c_adminSelectSingleCaptureTemplateFFSFieldTypeObj = this.props.AdminMobx.c_adminSelectSingleCaptureTemplateFFSFieldTypeObj;
    const o_tbl_a_single_capture_templates_filefoldersystem = this.props.DatabaseMobx.o_tbl_a_single_capture_templates_filefoldersystem;
    const c_selectAllCapturesNoClearFieldTypeObj = this.props.DatabaseMobx.c_selectAllCapturesNoClearFieldTypeObj;

    const captureValidTF = JSFUNC.select_int_is_filled_out_tf(s_selectedCaptureID);
    const templateValidTF = JSFUNC.select_int_is_filled_out_tf(s_selectedTemplateID);

    return (
      <>
        <CEComplexReact.FileFolderSystem
          p_tblName="tbl_a_single_capture_templates_filefoldersystem"
          p_tblMapOfMaps={o_tbl_a_single_capture_templates_filefoldersystem}
          p_tblFilterValuesObj={undefined}
          p_title={undefined}
          p_defaultXmlType={undefined}
          p_allowedExtsArray={["xml"]}
          p_disableUploadFilesTF={false}
          p_disableCreateOnlineLinkDocsTF={true}
          p_disableCreateFoldersTF={false}
          p_viewWideTrueNarrowFalse={(o_mediaQueryFlag >= 4)}
          p_navigateToFolderID={undefined}
          f_onPerformFFSAction={undefined}
          f_onNavigateToFolder={undefined}
        />
        <div className="flex00a displayFlexRow bgAddEditDeleteTable" style={{padding:"1em 0", borderTop:"solid 2px #985"}}>
          <div className="flex00a displayFlexColumnHcVc lrMedPad" style={{borderRight:"solid 1px #985"}}>
            <ViewAllTemplateCodewordsButtonWithFloatingBox />
          </div>
          <div className="flex11a displayFlexRowVc flexWrap">
            <div className="flex00a tbMicroPad lrMedPad" style={{flexBasis:"19em"}}>
              <font className="font12 fontBold fontItalic fontTextLight">
                {"Select a Capture to test out generating a sample template"}
              </font>
            </div>
            <div className="flex00a tbMicroPad lrMedPad" style={{flexBasis:"25em"}}>
              <div className="microBottomMargin textCenter">
                <font className="fontItalic fontTextLight">
                  {"Select a sample Capture"}
                </font>
              </div>
              <CEGeneralReact.GenericInputOrSelectFromInputType
                p_fieldTypeObj={c_selectAllCapturesNoClearFieldTypeObj}
                p_valueRaw={s_selectedCaptureID}
                p_errorTF={(s_showErrorsTF && !captureValidTF)}
                f_onChangeOrOnSelect={this.onselect_capture}
              />
            </div>
            <div className="flex00a tbMicroPad lrMedPad" style={{flexBasis:"25em"}}>
              <div className="microBottomMargin textCenter">
                <font className="fontItalic fontTextLight">
                  {"Select a Template to test"}
                </font>
              </div>
              <CEGeneralReact.GenericInputOrSelectFromInputType
                p_fieldTypeObj={c_adminSelectSingleCaptureTemplateFFSFieldTypeObj}
                p_valueRaw={s_selectedTemplateID}
                p_errorTF={(s_showErrorsTF && !templateValidTF)}
                f_onChangeOrOnSelect={this.onselect_template}
              />
            </div>
            <div className="flex00a tbMicroPad lrMedPad" style={{flexBasis:"20em"}}>
              <CEComplexReact.GenerateAndDownloadSingleCaptureTemplateButtonProcess
                p_fromOpenCaptureTrueAdminFalse={false}
                p_captureID={s_selectedCaptureID}
                p_singleCaptureTemplateID={s_selectedTemplateID}
                p_buttonText="Generate/Download Test Template"
                p_buttonTitle={undefined}
                p_canClickButtonTF={(captureValidTF && templateValidTF)}
                f_onClick={this.onclick_generate_button_set_show_errors}
              />
            </div>
          </div>
        </div>
      </>
    );
  }
}));



export function ViewAllTemplateCodewordsButtonWithFloatingBox(props) { //props: p_excelReportsTF
  const p_excelReportsTF = props.p_excelReportsTF;
  const [hookCodewordsFloatingBoxIsOpenTF, f_hookSetCodewordFloatingBoxIsOpenTF] = useState(false);

  const p_excelReportsTFDefault = JSFUNC.prop_value(p_excelReportsTF, false);
  const buttonText = ((p_excelReportsTFDefault) ? ("View All Excel Report Codewords") : ("View All Template Codewords"));
  return(
    <>
      <CEGeneralReact.CEButton
        p_type="add"
        p_text={buttonText}
        f_onClick={() => f_hookSetCodewordFloatingBoxIsOpenTF(true)}
      />
      {(hookCodewordsFloatingBoxIsOpenTF) &&
        <ViewAllTemplateCodewordsFloatingBox
          p_excelReportsTF={p_excelReportsTFDefault}
          f_onClose={() => f_hookSetCodewordFloatingBoxIsOpenTF(false)}
        />
      }
    </>
  );
}


const ViewAllTemplateCodewordsFloatingBox = inject("CaptureExecMobx", "AdminMobx")(observer(
class ViewAllTemplateCodewordsFloatingBox extends Component { //props: p_excelReportsTF, f_onClose
  constructor(props) {
    super(props);
    this.state = {
      s_searchFilterText: ""
    }
  }

  onchange_search_filter_text = (i_newValueString) => {
    this.setState({s_searchFilterText:i_newValueString});
  }

  onclick_view_codewords_list_in_new_tab_for_printing = () => {
    const p_excelReportsTF = this.props.p_excelReportsTF;

    const c_productStylingObj = this.props.CaptureExecMobx.c_productStylingObj;

    const newWindow = window.open();

    newWindow.document.title = c_productStylingObj.productName + " Template Codewords List"

    const templateCodewordsExamplesArrayOfObjs = this.props.AdminMobx.create_template_codewords_examples_arrayOfObjs(p_excelReportsTF);

    var codewordsHtmlString = '<font style="font-family:sans-serif;">';
    for(let templateCodewordExampleObj of templateCodewordsExamplesArrayOfObjs) {
      if(templateCodewordExampleObj.sectionTitle !== undefined) {
        codewordsHtmlString += '<div style="border-top:solid 1px #000; padding:0.3em 0; margin-top:0.3em"><font style="font-size:22px; font-weight:bold;">' + templateCodewordExampleObj.sectionTitle + '</font></div>';
      }

      if(JSFUNC.is_array(templateCodewordExampleObj.exampleRowsArrayOfObjs)) {
        codewordsHtmlString += '<div style="border:dashed 1px #aaa; padding:0.2em">';
        for(let exampleRowObj of templateCodewordExampleObj.exampleRowsArrayOfObjs) {
          codewordsHtmlString += this.codeword_row_html_from_row_obj(exampleRowObj);
        }
        codewordsHtmlString += '</div>';
      }

      if(JSFUNC.is_array(templateCodewordExampleObj.rowsArrayOfObjs)) {
        for(let rowObj of templateCodewordExampleObj.rowsArrayOfObjs) {
          codewordsHtmlString += this.codeword_row_html_from_row_obj(rowObj);
        }
      }
    }
    codewordsHtmlString += "</font>";

    newWindow.document.body.innerHTML = codewordsHtmlString;
  }

  codeword_row_html_from_row_obj = (i_rowObj) => {
    if(i_rowObj.subtitle !== undefined) {
      return('<div style="padding-bottom:0.2em"><font style="font-size:16px; font-weight:bold; color:#333">' + i_rowObj.subtitle + '</font></div>');
    }

    const codewordsArray = JSFUNC.convert_single_or_array_to_array(i_rowObj.codewordOrCodewordsArray);
    var codewordRowHtml = '<div><font style="font-size:13px; font-style:italic;">' + i_rowObj.description + '</font></div>';
    codewordRowHtml += '<div style="margin-left:2em; margin-bottom:0.2em"><font style="font-size:13px;">';
    for(let c = 0; c < codewordsArray.length; c++) {
      if(c > 0) {
        codewordRowHtml += " or ";
      }
      codewordRowHtml += "[[" + codewordsArray[c] + "]]";
    }
    codewordRowHtml += '</font></div>';
    return(codewordRowHtml);
  }

  render() {
    const s_searchFilterText = this.state.s_searchFilterText;

    const p_excelReportsTF = this.props.p_excelReportsTF;
    const f_onClose = this.props.f_onClose;

    const templateCodewordsExamplesArrayOfObjs = this.props.AdminMobx.c_templateCodewordsExamplesArrayOfObjs;

    const searchFilterFilledOutTF = (s_searchFilterText !== "");

    return (
      <CEGeneralReact.FloatingBoxWithSaveCancel
        p_trblFlag="addEditDeleteTableEditQuestion"
        p_title="All Template Codewords"
        f_onClickCancel={f_onClose}>
        <div className="flex00a displayFlexRowVc flexWrap bgLightGray borderT1bbb borderB1bbb">
          <div className="flex00a tbMargin lrMedMargin" style={{flexBasis:"25em"}}>
            <CEGeneralReact.SearchInputTextWithClearX
              p_inputText={s_searchFilterText}
              p_placeholderText="Search Codeword List..."
              p_includeSearchIconTF={false}
              p_tabIndex={1}
              f_onChange={this.onchange_search_filter_text}
            />
          </div>
          <div className="flex11a" />
          <div className="flex00a tbPad lrMedPad">
            <CEGeneralReact.CEButton
              p_type="add"
              p_text="View Codewords List in New Tab for Printing"
              f_onClick={this.onclick_view_codewords_list_in_new_tab_for_printing}
            />
          </div>
        </div>
        <div className="flex11a yScroll yScrollBottomPad">
          {templateCodewordsExamplesArrayOfObjs.map((m_templateCodewordExampleObj, m_index) =>
            (!p_excelReportsTF || (m_templateCodewordExampleObj.inExcelReportsTF !== false)) &&
            <>
              {(m_templateCodewordExampleObj.sectionTitle !== undefined) &&
                <ViewCodewordTitle
                  p_text={m_templateCodewordExampleObj.sectionTitle}
                  p_topMarginTF={(m_index > 0)}
                />
              }
              {(JSFUNC.is_array(m_templateCodewordExampleObj.exampleRowsArrayOfObjs)) &&
                <ViewCodewordExamplesBg p_color={m_templateCodewordExampleObj.exampleBgColor}>
                  {m_templateCodewordExampleObj.exampleRowsArrayOfObjs.map((m_exampleRowObj) =>
                    <ViewCodewordSubTitleOrCodewordRow
                      p_rowObj={m_exampleRowObj}
                      p_excelReportsTF={p_excelReportsTF}
                      p_searchFilterTextLowercase={s_searchFilterText}
                      p_searchFilterFilledOutTF={searchFilterFilledOutTF}
                    />
                  )}
                </ViewCodewordExamplesBg>
              }
              {(JSFUNC.is_array(m_templateCodewordExampleObj.rowsArrayOfObjs)) &&
                m_templateCodewordExampleObj.rowsArrayOfObjs.map((m_rowObj) =>
                  <ViewCodewordSubTitleOrCodewordRow
                    p_rowObj={m_rowObj}
                    p_excelReportsTF={p_excelReportsTF}
                    p_searchFilterTextLowercase={s_searchFilterText}
                    p_searchFilterFilledOutTF={searchFilterFilledOutTF}
                  />
                )
              }
            </>
          )}
        </div>
      </CEGeneralReact.FloatingBoxWithSaveCancel>
    );
  }
}));

function ViewCodewordTitle(props) { //props: p_text, p_color, p_topMarginTF
  const p_topMarginTF = JSFUNC.prop_value(props.p_topMarginTF, false);
  const p_color = props.p_color;
  const p_text = props.p_text;

  var bgColor = "c7c1bb";
  if(p_color === "green") {
    bgColor = "bbc7bb";
  }

  return(
    <div
      className={"medFullPad " + ((p_topMarginTF) ? ("hugeTopMargin") : (""))}
      style={{background:"#" + bgColor, borderBottom:"solid 1px #eee"}}>
      <font className="font16 fontBold fontItalic">
        {p_text}
      </font>
    </div>
  );
}

function ViewCodewordExamplesBg(props) { //props: p_color, children
  const p_color = props.p_color;
  const children = props.children;

  var bgColor = "eee8dd";
  if(p_color === "green") {
    bgColor = "dde8dd";
  }

  return(
    <div style={{background:"#" + bgColor}}>
      {children}
    </div>
  );
}

function ViewCodewordSubTitleOrCodewordRow(props) { //props: p_rowObj, p_excelReportsTF, p_searchFilterTextLowercase, p_searchFilterFilledOutTF
  const p_rowObj = props.p_rowObj;
  const p_excelReportsTF = props.p_excelReportsTF;
  const p_searchFilterTextLowercase = props.p_searchFilterTextLowercase;
  const p_searchFilterFilledOutTF = props.p_searchFilterFilledOutTF;

  if(p_excelReportsTF && (p_rowObj.inExcelReportsTF === false)) {
    return(null);
  }

  if(p_searchFilterFilledOutTF) {
    const searchFilterMatchesTF = JSFUNC.input_lowercase_string_contains_lowercase_search_term_string_tf(p_rowObj.codewordsAndDescriptionLowercase, p_searchFilterTextLowercase);
    if(!searchFilterMatchesTF) {
      return(null);
    }
  }

  if(p_rowObj.subtitle !== undefined) {
    return(
      <LibraryReact.DivFont p_class="borderB1eee tbPad lrPad" p_fontClass="font12 fontBold fontTextLighter">
        {p_rowObj.subtitle}
      </LibraryReact.DivFont>
    );
  }

  return(
    <ViewCodewordRow
      p_codeword={p_rowObj.codewordOrCodewordsArray}
      p_description={p_rowObj.description}
      p_codewordsHorizontalTF={p_rowObj.codewordsHorizontalTF}
    />
  );
}

function ViewCodewordRow(props) { //props: p_codeword, p_description, p_codewordsHorizontalTF
  const p_codeword = props.p_codeword;
  const p_description = props.p_description;
  const p_codewordsHorizontalTF = props.p_codewordsHorizontalTF;

  const lowercaseCodewordsArray = JSFUNC.convert_single_or_array_to_array(p_codeword);
  const numCodewords = lowercaseCodewordsArray.length;

  var codewordsDisplayFlexString = "displayFlexRow";
  var codewordsComponent = null;
  if(numCodewords === 1) {
    codewordsComponent = (
      <ViewCodewordSingleCodeword p_codeword={lowercaseCodewordsArray[0]} />
    );
  }
  else if(numCodewords > 1) {
    if(p_codewordsHorizontalTF) {
      codewordsDisplayFlexString = "displayFlexRow";
      codewordsComponent = (
        lowercaseCodewordsArray.map((m_codeword, m_index) =>
          <div className="flex00a displayFlexRowVc">
            <ViewCodewordSingleCodeword p_codeword={m_codeword} />
            {(m_index < (numCodewords - 1)) &&
              <div className="flex00a lrPad" />
            }
            <div className="flex11a" />
          </div>
        )
      );
    }
    else {
      codewordsDisplayFlexString = "displayFlexColumn";
      codewordsComponent = (
        lowercaseCodewordsArray.map((m_codeword, m_index) =>
          <div className="flex00a displayFlexRowVc">
            <ViewCodewordSingleCodeword p_codeword={m_codeword} />
            {(m_index < (numCodewords - 1)) &&
              <LibraryReact.DivFont p_class="flex00a lrPad" p_fontClass="font09 fontItalic fontTextLighter">
                {"or"}
              </LibraryReact.DivFont>
            }
            <div className="flex11a" />
          </div>
        )
      );
    }
  }

  return(
    <div className="flex00a displayFlexRow borderB1eee tbPad hoverLighterBlueGradient">
      <div className="flex11a displayFlexColumnVc lrPad" style={{flexBasis:"100em"}}>
        <font className="fontItalic fontTextLight">
          {p_description}
        </font>
      </div>
      <div className={"flex11a " + codewordsDisplayFlexString} style={{flexBasis:"100em"}}>
        {codewordsComponent}
      </div>
    </div>
  );
}

function ViewCodewordSingleCodeword(props) { //props: p_codeword
  const p_codeword = props.p_codeword;
  const codewordWithBrackets = "[[" + p_codeword + "]]";

  return(
    <CEGeneralReact.ButtonCopyToClipboard
      p_clipboardText={codewordWithBrackets}
      p_preCopyText={codewordWithBrackets}
      p_postCopyText={"Copied " + codewordWithBrackets + " to clipboard"}
      p_preCopyClass="flex00a displayFlexColumnVc lrPad tbMicroPad hoverFontUnderline breakWord"
      p_postCopyClass="flex00a displayFlexColumnVc lrMedPad tbMicroPad bgDarkGrayGradient border bevelBorderDarkColors borderRadius05"
      p_styleObj={{height:"1.4em"}}
      p_preCopyFontClass="font12 fontTextLight"
      p_postCopyFontClass="font12 fontWhite"
      p_tabIndex={-1}
      p_title={"Click to copy '" + codewordWithBrackets + "' to clipboard for pasting into Templates"}
    />
  );
}





//=================================================================================================================================================================
//=================================================================================================================================================================



export const AdminSubtabGCSSOptions = inject("CaptureExecMobx", "AdminMobx", "DatabaseMobx")(observer(
class AdminSubtabGCSSOptions extends Component { //props: none
  onselect_gcss_options_tab = (i_selectedSubtabDbName) => {
    this.props.AdminMobx.a_set_gcss_options_selected_subtab_db_name(i_selectedSubtabDbName);
  }

  render() {
    const c_productStylingObj = this.props.CaptureExecMobx.c_productStylingObj;
    const o_gcssOptionsSelectedSubtabDbName = this.props.AdminMobx.o_gcssOptionsSelectedSubtabDbName;
    const c_bitGovConSmartSearchTF = this.props.DatabaseMobx.c_bitGovConSmartSearchTF;

    if(!c_bitGovConSmartSearchTF) {
      return(
        <LibraryReact.DivFont p_class="medFullPad" p_fontClass="font12 fontItalic fontTextLight">
          {"Your company has not purchased the GovCon Smart Search (GCSS) Module. Please contact BIT Solutions if you are interested adding this module to your " + c_productStylingObj.productName + " suite of government tools."}
        </LibraryReact.DivFont>
      );
    }

    var gcssOptionsContentComponent = null;
    if(o_gcssOptionsSelectedSubtabDbName === "dataSources") { gcssOptionsContentComponent = (<GCSSOptionsDataSources />); }
    else if(o_gcssOptionsSelectedSubtabDbName === "customReasonsNotInterested") { gcssOptionsContentComponent = (<GCSSOptionsCustomReasonsNotInterested />); }
    else if(o_gcssOptionsSelectedSubtabDbName === "autoUpdateOptions") { gcssOptionsContentComponent = (<GCSSOptionsAutoUpdateOptions />); }
  
    return(
      <>
        <div className="flex00a bgLightestGray smallFullPad borderB1bbb">
          <CEGeneralReact.TabsList
            p_tabDbNamesArray={["dataSources", "customReasonsNotInterested", "autoUpdateOptions"]}
            p_tabDisplayNamesArray={["GCSS Data Sources", "GCSS Reasons Not Interested", "GCSS Automatic Update Options"]}
            p_selectedTabDbName={o_gcssOptionsSelectedSubtabDbName}
            p_tabHeight="2.4em"
            p_textMaxHeight="2em"
            p_tabWidth="18em"
            p_selectedBgClass="bgGreenGradient"
            p_selectedFontClass="fontBold fontAlmostWhite"
            p_unselectedBgClass="bgLightGrayGradient"
            p_unselectedFontClass="fontTextLight"
            p_canEditTF={true}
            p_rowFlexWrapTF={true}
            p_borderRadiusClass="borderRadius05"
            f_onSelect={this.onselect_gcss_options_tab}
          />
        </div>
        {gcssOptionsContentComponent}
      </>
    );
  }
}));

const GCSSOptionsDataSources = inject("CaptureExecMobx", "AdminMobx", "DatabaseMobx")(observer(
class GCSSOptionsDataSources extends Component { //props: none
  constructor(props) {
    super(props);
    this.state = {
      s_selectedDataSourceLearnMoreTabDbName: ""
    };
  }

  onselect_gcss_learn_more = (i_selectedTabDbName) => {
    const s_selectedDataSourceLearnMoreTabDbName = this.state.s_selectedDataSourceLearnMoreTabDbName;
    const updatedSelectedLearnMoreTabDbName = ((i_selectedTabDbName === s_selectedDataSourceLearnMoreTabDbName) ? ("") : (i_selectedTabDbName));
    this.setState({s_selectedDataSourceLearnMoreTabDbName:updatedSelectedLearnMoreTabDbName});
  }

  render() {
    const s_selectedDataSourceLearnMoreTabDbName = this.state.s_selectedDataSourceLearnMoreTabDbName;

    const c_computedUrlAndProductObj = this.props.CaptureExecMobx.c_computedUrlAndProductObj;
    const c_productStylingObj = this.props.CaptureExecMobx.c_productStylingObj;
    const c_gcssGovWinCredentialsArrayOfObjs = this.props.AdminMobx.c_gcssGovWinCredentialsArrayOfObjs;
    const c_gcssFedCompCredentialsArrayOfObjs = this.props.AdminMobx.c_gcssFedCompCredentialsArrayOfObjs;
    const c_companyGcssGovInfoRssShownTF = this.props.DatabaseMobx.c_companyGcssGovInfoRssShownTF;
    const c_companyGcssDataSourceSamShownTF = this.props.DatabaseMobx.c_companyGcssDataSourceSamShownTF;
    const c_companyGcssDataSourceGovWinShownTF = this.props.DatabaseMobx.c_companyGcssDataSourceGovWinShownTF;
    const c_companyGcssDataSourceFedCompShownTF = this.props.DatabaseMobx.c_companyGcssDataSourceFedCompShownTF;

    var dataSourceAdContentsComponent = null;
    if(s_selectedDataSourceLearnMoreTabDbName === "govinfo") {
      dataSourceAdContentsComponent = (
        <GCSSAdContainer
          key="govinfo"
          p_logoFileLoc={c_computedUrlAndProductObj.productGraphicsSubfolderAddress + "/gcss_ds_govinforss_70px280px.png"}
          p_logoWidthPx={280}
          p_logoHeightPx={70}
          p_productName="GovInfo"
          p_webAddress="https://www.govinfo.gov/">
          <div className="tbPad lrMedPad" style={{maxWidth:"80em"}}>
            <GovInfoAdSectionHeader>{"About GovInfo"}</GovInfoAdSectionHeader>
            <GovInfoAdSubHeader>{"GovInfo is free U.S. Government information for all."}</GovInfoAdSubHeader>
            <GovInfoAdText>{"GovInfo is a service of the United States Government Publishing Office (GPO), which is a Federal agency in the legislative branch."}</GovInfoAdText>
            <GovInfoAdText>{"GovInfo provides free public access to official publications from all three branches of the Federal Government."}</GovInfoAdText>
            
            <GovInfoAdSubHeader>{"GovInfo replaced the FDsys website in December 2018."}</GovInfoAdSubHeader>
            <GovInfoAdText>{"GPO launched GovInfo in February 2016 as a beta website to replace its predecessor, GPO’s Federal Digital System (FDsys). Learn about the transition."}</GovInfoAdText>
            <GovInfoAdSubHeader>{"GovInfo is more than a website."}</GovInfoAdSubHeader>
            <GovInfoAdText>{"In addition to providing an advanced, metadata-powered search experience, GovInfo also includes a content management system and a standards-compliant preservation repository."}</GovInfoAdText>
            <GovInfoAdText>{"These three components comprise GPO’s world-class system for the comprehensive management of electronic information:"}</GovInfoAdText>
            <GovInfoAdText>
              <div>{"1. Public access - GPO combines modern search technology with extensive metadata creation to ensure the highest quality search experience. Users can easily access documents for free by searching or browsing the mobile-friendly website."}</div>
              <div>{"2. Content management – GPO securely controls digital content throughout its lifecycle to ensure content integrity and authenticity. This includes the application of digital signatures to PDF files so users can verify documents have not been altered and are the official versions."}</div>
              <div>{"3. Digital preservation – GPO’s ISO 16363  certified Trustworthy Digital Repository ensures content is preserved for future generations despite technical failure, aging of hardware, or technological change."}</div>
            </GovInfoAdText>
            <GovInfoAdSubHeader>{"What can I find on GovInfo?"}</GovInfoAdSubHeader>
            <GovInfoAdText>{"See what's available, including information on individual publications or collections of content, or view an alphabetical list of collections, publications, other resources, and external partner sites."}</GovInfoAdText>
            <GovInfoAdSubHeader>{"What's the difference between GovInfo, GPO.gov, FDLP.gov, and the CGP?"}</GovInfoAdSubHeader>
            <GovInfoAdText>{"The Government Publishing Office (GPO) is a Federal legislative branch agency established in 1861. GPO’s mission is rooted in legislation codified in Title 44 U.S.C. and is the Federal Government’s resource for publishing trusted information for the Federal Government to the American people. The GPO is responsible for the production and distribution of information products and services for all three branches of the Federal Government, including U.S. passports for the Department of State as well as the official publications of Congress, the White House, and other Federal agencies in digital and print formats. GPO’s website is available at www.gpo.gov  and is helpful for current Federal agency customers, vendors looking for contract opportunities, prospective Federal agency customers, and anyone who wants to learn about GPO and available resources. Learn more about GPO. "}</GovInfoAdText>
            <GovInfoAdText>{"The Federal Depository Library Program (FDLP) was established by Congress to ensure that the American public has access to its Government’s information. GPO administers the FDLP on behalf of the participating libraries and the public. Information products from the Federal Government are disseminated to these nationwide libraries that, in turn, ensure the American public has free access to the materials, both in print and online. The website for the FDLP is available at www.fdlp.gov  and is helpful for librarians at FDLP libraries or prospective FDLP member libraries. Learn more about the FDLP. "}</GovInfoAdText>
            <GovInfoAdText>{"By law (U.S.C. Title 44, Sections 1710 and 1711) GPO aims to provide a comprehensive index of every document issued or published by a department, bureau, or office not confidential in character. GPO administers this program and provides public access to this index through the online bibliographic records contained in the Catalog of U.S. Government Publications (CGP). The CGP is available at https://catalog.gpo.gov  as a finding tool for Government publications, containing records with information about publications in many different file formats. When you search the CGP for a publication, you will find a record that tells you where you can find the publication, whether at a physical library or through a link to the full-text electronic version when available. The CGP includes records for content available on GovInfo and links to GovInfo for access to these publications. The CGP is helpful for anyone who wants to locate a Federal Government publication whether online or in print at a Federal Depository Library. Learn more about the CGP. "}</GovInfoAdText>
            <GovInfoAdText>{"Available at www.govinfo.gov, GovInfo is a service of GPO to provide free public access to the full text of official publications from all three branches of the Federal Government. When you search the content available on GovInfo, you will be able to download the full text of publications but you won’t see records for documents that are not stored on GovInfo. GovInfo is also a standards-compliant preservation repository, advanced search engine, and content management system that securely controls digital content throughout its lifecycle to ensure content integrity and authenticity. Learn more about GovInfo."}</GovInfoAdText>
            <GovInfoAdSubHeader>{"How can I learn more or get help using GovInfo? Are training and educational materials or webinars available?"}</GovInfoAdSubHeader>
            <GovInfoAdText>{"Several tutorials and handouts are available and we will periodically add additional resources. Recorded webinars are available through the FDLP Academy.  To learn more about using GovInfo, visit our Help pages."}</GovInfoAdText>
            <GovInfoAdSubHeader>{"Is GovInfo 508 compliant?"}</GovInfoAdSubHeader>
            <GovInfoAdText>{"GPO accepts official content from Federal committees, offices, or agencies in the form of final published documents that are then submitted into GovInfo and made available to public users. We generally do not make alterations to the files we receive (one exception is to add a visible Seal of Authenticity to PDF files). This includes alterations to files to apply accessibility standards."}</GovInfoAdText>
            <GovInfoAdText>{"GPO does make an effort to follow best practices for making GovInfo webpages accessible to assistive technology, such as screen readers, whenever feasible. For example, providing alternative text for images, structuring content with headings to facilitate keyboard navigation, and using labels to provide enhanced semantics and accessibility for web content."}</GovInfoAdText>
            <GovInfoAdText>{"Read GPO’s Section 508/Accessibility Policy and feel free to contact us if you encounter barriers to accessibility on any of our webpages. With your help, we can work together to ensure that GPO websites remain as accessible as possible."}</GovInfoAdText>
            <GovInfoAdText>{"More information about Section 508 can be found on Section508.gov. "}</GovInfoAdText>
          </div>
        </GCSSAdContainer>
      );
    }
    if(s_selectedDataSourceLearnMoreTabDbName === "sam") {
      const samUseSiteToBulletLinesArray = [
        "Register to do business with the U.S. Government",
        "Update, renew, or check the status of your entity registration",
        "Search for entity registration and exclusion records",
        "Search for assistance listings (formerly CFDA.gov), wage determinations (formerly WDOL.gov), contract opportunities (formerly FBO.gov), and contract data reports (formerly part of FPDS.gov).",
        "View and submit BioPreferred and Service Contract Reports",
        "Access publicly available award data via data extracts and system accounts"
      ];

      const samFPDSBulletLinesArray = [
        "Standard Reports contain information about contract activity and are formatted to meet the needs of both government and public users. Data in Standard Reports can be filtered and sorted to locate information of interest.",
        "Static Reports are prepared on a fiscal year basis for the public and are available as prepared for download. There are currently four Static Reports for Contract Data represented in the Data Bank section.",
        "Administrative Reports are configurable and available to Federal users assigned the appropriate roles.",
        "Ad Hoc Reports offer the ability to select data fields from the database to run a query. Ad hoc reports are an advanced feature recommended for users who are familiar with the data parameters and knowledge of the sophisticated reporting tool."
      ];

      dataSourceAdContentsComponent = (
        <GCSSAdContainer
          key="sam"
          p_logoFileLoc={c_computedUrlAndProductObj.productGraphicsSubfolderAddress + "/gcss_sam_whitebg.png"}
          p_logoWidthPx={210}
          p_logoHeightPx={57}
          p_productName="SAM.gov"
          p_webAddress="https://sam.gov/content/home">
          <div style={{height:"1em", background:"linear-gradient(#ccc,#fff)"}} />
          <div className="tbPad lrMedPad" style={{maxWidth:"80em"}}>
            <SAMAdTitle>{"About This Site"}</SAMAdTitle>
            <SAMAdHeader>{"What is SAM.gov?"}</SAMAdHeader>
            <SAMAdText>{"The System for Award Management (SAM.gov) is an official website of the U.S. Government. There is no cost to use SAM.gov. You can use this site to:"}</SAMAdText>
            <CEGeneralReact.BulletList p_linesArray={samUseSiteToBulletLinesArray} p_fontClass="fontTextLight" p_dashFontClass="fontTextLight" />
            <SAMAdHeader>{"What is the IAE?"}</SAMAdHeader>
            <SAMAdText>{"The Integrated Award Environment (IAE) is a government-wide initiative administered by GSA’s Federal Acquisition Service (FAS). We manage the suite of systems, including SAM.gov, that are an essential part of the federal awards lifecycle. The goal of the IAE is to continue to evolve and integrate the existing shared portfolio of multiple online systems used for awarding and administering federal financial assistance (i.e., grants, loans) and contracts."}</SAMAdText>
            <SAMAdHeader>{"What is an entity?"}</SAMAdHeader>
            <SAMAdText>{"At SAM.gov, we use the term “entity” to refer to prime contractors, organizations or individuals applying for assistance awards, those receiving loans, sole proprietors, corporations, partnerships, and any U.S. federal government agencies desiring to do business with the government. Entity can also refer to a party that has been suspended or debarred, is covered by a prohibition or restriction, or is otherwise excluded from doing business with the government."}</SAMAdText>
            <SAMAdHeader>{"What are entity registrations?"}</SAMAdHeader>
            <SAMAdText>{"You register your entity to do business with the U.S. federal government by completing the entity registration process at SAM.gov. Active registration in SAM.gov provides your entity the ability to apply for federal grants or loans or bid on government contracts."}</SAMAdText>
            <SAMAdHeader>{"What are exclusions?"}</SAMAdHeader>
            <SAMAdText>{"An exclusion identifies a party excluded from receiving federal contracts, certain subcontracts, and certain types of federal financial and non-financial assistance and benefits. If your entity or any of its principals are subject to an active exclusion, it means your entity is currently debarred, suspended, proposed for debarment, or declared ineligible for the award of contracts by any federal agency. Awarding officials check SAM.gov to see if an exclusion exists for your entity. Always contact the issuing agency if you have questions about an exclusion record."}</SAMAdText>
            <SAMAdHeader>{"What is entity reporting?"}</SAMAdHeader>
            <SAMAdText>{"Contractors may be required to submit periodic reports on contracts that meet certain criteria. Two examples are Service Contract Reporting (SCR) and BioPreferred Reporting. Under SCR, contractors awarded cost-reimbursement, time-and-materials, and labor hour service contracts and orders at or above the simplified acquisition threshold must report information about the amount invoiced, labor hours expended, and subcontractor labor hours to help build a governmentwide service contract inventory. Under the BioPreferred program, contractors awarded service or construction contracts must report purchases of biobased products in the execution of those contracts."}</SAMAdText>
            <SAMAdHeader>{"What are assistance listings?"}</SAMAdHeader>
            <SAMAdText>{"The federal government provides assistance to the American public in the form of projects, services, and activities. It supports a broad range of assistance listings—such as education, health care, research, infrastructure, economic development, and other assistance listings—through grants, loans, scholarships, insurance, and other types of financial assistance."}</SAMAdText>
            <SAMAdText>{"SAM.gov provides detailed, public descriptions of federal assistance listings available to state and local governments (including the District of Columbia); federally recognized Indian tribal governments, territories (and possessions) of the United States; domestic public, quasi-public, and private profit and nonprofit organizations and institutions; specialized groups, and individuals."}</SAMAdText>
            <SAMAdText>{"As an entity looking for federal assistance, you can conduct your preliminary planning using SAM.gov. Browse assistance listings across all government agencies to form a “big picture” of your options."}</SAMAdText>
            <SAMAdText>{"Each assistance listing is associated with a unique five-digit AL (Assistance Listing) number. Once you identify a federal assistance listing that you’re interested in, you can link directly to grant opportunities on Grants.gov or follow up with that specific agency using the contact information provided."}</SAMAdText>
            <SAMAdHeader>{"What are wage determinations?"}</SAMAdHeader>
            <SAMAdText>{"Wage determinations are legally mandated wage rates and fringe benefits that must be paid by federal contractors to their employees based on the county where the work is performed. The U.S. Department of Labor determines wage rates and fringe benefits in a given area and shall be the minimum paid by contractors and subcontractors to laborers and mechanics on federal contracts."}</SAMAdText>
            <SAMAdHeader>{"What are contract opportunities?"}</SAMAdHeader>
            <SAMAdText>{"Contract opportunities are listings of federal business opportunities greater than $25,000, including synopses of proposed contract actions, solicitations, and associated information that can be accessed electronically by the public. Organizations registered inSAM.gov may compete to be awarded federal contracts."}</SAMAdText>
            <SAMAdHeader>{"What contract data reports are available?"}</SAMAdHeader>
            <SAMAdText>{"Contract data reports provide detailed information on awarded contracts using data directly from the Federal Data Procurement System (FPDS). The report data can be aggregated by various attributes and can be downloaded for detailed analysis. There are four categories of contract data reports available:"}</SAMAdText>
            <CEGeneralReact.BulletList p_linesArray={samFPDSBulletLinesArray} p_fontClass="fontTextLight" p_dashFontClass="fontTextLight" />
            <SAMAdHeader>{"What is the federal hierarchy?"}</SAMAdHeader>
            <SAMAdText>{"The federal hierarchy is the authoritative source for managing and referencing federal funding and awarding organizations. It is a directory that organizes federal government users and establishes relationships between each department or independent agency’s sub-tiers and its offices."}</SAMAdText>
            <SAMAdHeader>{"What design standards have been used to create the user interface at SAM.gov?"}</SAMAdHeader>
            <SAMAdText>{"The design of this site implements the most current U.S. Web Design System (USWDS) standards and best practices mandated by the 21st Century Integrated Digital Experience Act (IDEA). This site is continually updated and improved based on user feedback and federal requirements."}</SAMAdText>
          </div>
        </GCSSAdContainer>
      );
    }
    else if(s_selectedDataSourceLearnMoreTabDbName === "govwin") {
      dataSourceAdContentsComponent = (
        <GCSSAdContainer
          key="govwin"
          p_logoFileLoc={c_computedUrlAndProductObj.productGraphicsSubfolderAddress + "/gcss_deltek_whitebg.png"}
          p_logoWidthPx={193}
          p_logoHeightPx={57}
          p_productName="GovWin"
          p_webAddress="https://www.deltek.com/en/government-contracting/govwin/federal">
          <div className="displayFlexRow">
            <div className="flex11a" style={{maxWidth:"80em"}}>
              <div className="hugeFullPad">
                <GovWinAdTitleAndLine>{"FEDERAL MARKET"}</GovWinAdTitleAndLine>
                <GovWinAdHeader>{"GOVWIN IQ FOR FEDERAL CONTRACTORS"}</GovWinAdHeader>
                <GovWinAdText>{"The federal government contracting market is vibrant and healthy with the top opportunities for FY 2023 alone valued at more than $750B. Within this favorable & lucrative environment, contractors can win more business by using GovWin IQ. GovWin IQ serves contractors that are selling to the federal government by providing the earliest awareness of new opportunities, deep planning intelligence, potential teaming partnerships, and the strategic insight that businesses need to get ahead of the competition and win more federal government contracts."}</GovWinAdText>
              </div>
              <div className="hugeFullPad bgLighterGray">
                <div className="textCenter">
                  <font className="font16 fontDarkBlue">
                    {"“Since becoming a GovWin IQ member, we realized very quickly why [GovWin’s] product and supporting services are known as the ‘gold standard’ for research and tracking of the government market.”"}
                  </font>
                </div>
                <div className="bigTopMargin textCenter">
                  <font className="font12 fontDarkBlue">
                    {" - Development Director, IMT, LLC, A Mission Essential Company"}
                  </font>
                </div>
              </div>
              <div className="hugeFullPad">
                <GovWinAdTitleAndLine>{"HOW TO COMPETE"}</GovWinAdTitleAndLine>
                <GovWinAdText>{"Understanding the federal market is key to being successful at federal government contracting, whether you are an experienced vendor or a new entrant. GovWin IQ provides key insights and opportunities to help you navigate this complex, cumbersome world."}</GovWinAdText>
              </div>
              <div className="hugeFullPad bgLighterGray">
                <GovWinAdTitleAndLine>{"BENEFITS"}</GovWinAdTitleAndLine>
                <div className="displayFlexRow textCenter">
                  <div className="flex11a lrMedMargin">
                    <GovWinAdHeader>{"PLAN BEYOND THE PROPOSAL"}</GovWinAdHeader>
                    <GovWinAdText>{"Discover opportunities months, or even years, before they go to bid in the form of forecast pre-RFP intelligence."}</GovWinAdText>
                  </div>
                  <div className="flex11a lrMedMargin">
                    <GovWinAdHeader>{"FIND A QUALITY PARTNER"}</GovWinAdHeader>
                    <GovWinAdText>{"Identify quality teaming partners in a specific location, level of experience, or set-aside category in our exclusive GovWin Network™ of contacts."}</GovWinAdText>
                  </div>
                  <div className="flex11a lrMedMargin">
                    <GovWinAdHeader>{"CAPTURE MARKET INSIGHTS"}</GovWinAdHeader>
                    <GovWinAdText>{"Detect market potential based on data analysis conducted by our research support team along with easy-to-use data breakdown tools within GovWin IQ."}</GovWinAdText>
                  </div>
                </div>
              </div>
              <div className="hugeFullPad">
                <GovWinAdTitleAndLine>{"CANADIAN MARKET"}</GovWinAdTitleAndLine>
                <GovWinAdText>{"New! We have expanded our coverage into the Canadian government contracting markets. Grow your footprint beyond the U.S. into the Canadian provincial, MASH (municipal, academic institutes, schools, health & social) and federal government markets with the same level of centralized coverage and early visibility you expect from GovWin."}</GovWinAdText>
              </div>
            </div>
            <GCSSOptionsIntegrationEmailForm p_dataSourceTabDbName={s_selectedDataSourceLearnMoreTabDbName} />
          </div>
        </GCSSAdContainer>
      );
    }
    else if(s_selectedDataSourceLearnMoreTabDbName === "fedcomp") {
      dataSourceAdContentsComponent = (
        <GCSSAdContainer
          key="fedcomp"
          p_logoFileLoc={c_computedUrlAndProductObj.productGraphicsSubfolderAddress + "/gcss_ds_fedcomp_70px280px.png"}
          p_logoWidthPx={280}
          p_logoHeightPx={70}
          p_productName="Federal Compass"
          p_webAddress="https://federalcompass.com/">
          <div className="displayFlexRow">
            <div className="flex11a" style={{maxWidth:"80em"}}>
              <div className="hugeFullPad" style={{maxWidth:"80em", background:"#172432"}}>
                <FedCompAdTitleWhite>{"Plan. Execute. Capture."}</FedCompAdTitleWhite>
                <FedCompAdTextWhite>{"Federal Compass is a SaaS solution that enables strategy, growth, and process for federal contractors and the federal market."}</FedCompAdTextWhite>
              </div>
              <div className="hugeFullPad" style={{maxWidth:"80em", background:"#ecf1f4"}}>
                <FedCompAdTitleBlue>{"Federal Opportunities & Pipeline Tools"}</FedCompAdTitleBlue>
                <FedCompAdTextBlue>{"With the largest database of federal pre-RFP and recompete opportunities, we have you covered. Combine that with rich pipeline tracking, collaboration and management tools built exclusively for Federal contractors."}</FedCompAdTextBlue>
              </div>
              <div className="hugeFullPad">
                <FedCompAdTitleBlue>{"Personalized Markets"}</FedCompAdTitleBlue>
                <FedCompAdTextBlue>{"Our market-centric platform adds context to every pursuit. Every opportunity, every report, tailored specifically to you."}</FedCompAdTextBlue>
              </div>
              <div className="hugeFullPad" style={{maxWidth:"80em", background:"#ecf1f4"}}>
                <FedCompAdTitleBlue>{"Award Research & Market Intelligence"}</FedCompAdTitleBlue>
                <FedCompAdTextBlue>{"Find gaps in the market, identify key competitors and teaming partners, evaluate performance, and analyze pathways to new business. *including prime and subcontract awards"}</FedCompAdTextBlue>
              </div>
              <div className="hugeFullPad" style={{maxWidth:"80em", background:"#172432"}}>
                <FedCompAdTitleWhite>{"Let's get started today"}</FedCompAdTitleWhite>
                <FedCompAdTextWhite>{"If you do business with the Federal Government, you need Federal Compass."}</FedCompAdTextWhite>
              </div>
            </div>
            <GCSSOptionsIntegrationEmailForm p_dataSourceTabDbName={s_selectedDataSourceLearnMoreTabDbName} />
          </div>
        </GCSSAdContainer>
      );
    }

    return(
      <div className="flex11a yScroll bgLightGray">
        <div className="displayFlexRow flexWrap bgDarkGray">
          <GCSSSingleDataSourceInfoBox
            p_dataSourceDisplayName="GovInfo"
            p_logoFileNameAndExt="gcss_ds_govinforss_70px280px.png"
            p_dataSourceShownTF={c_companyGcssGovInfoRssShownTF}
            p_dataSourceShownCompanyColumnDbName="gcss_data_source_news_govinfo_shown_01"
            p_switchOnBgColor="444488"
            p_learnMoreTabDbName="govinfo"
            p_selectedLearnMoreTabDbName={s_selectedDataSourceLearnMoreTabDbName}
            p_learnMoreSelectedBgClass="bgDarkGrayGradient"
            f_onClickLearnMore={this.onselect_gcss_learn_more}>
            <GCSSSingleDataSourceInfoName p_name="GovInfo Live News Feed" />
            <div className="displayFlexColumnHcVc smallBottomMargin">
              <div className="flex00a smallBottomMargin lrMedMargin border1ddd borderRadius10 tbPad lrMedPad textCenter" style={{width:"25em"}}>
                <font className="font13 fontTextLighter">
                  {"Included free with " + c_productStylingObj.productName + " GovCon Smart Search (GCSS) module"}
                </font>
              </div>
            </div>
          </GCSSSingleDataSourceInfoBox>
          <GCSSSingleDataSourceInfoBox
            p_dataSourceDisplayName="SAM.gov"
            p_logoFileNameAndExt="gcss_ds_sam_70px280px.png"
            p_dataSourceShownTF={c_companyGcssDataSourceSamShownTF}
            p_dataSourceShownCompanyColumnDbName="gcss_data_source_sam_shown_01"
            p_switchOnBgColor="cc202a"
            p_learnMoreTabDbName="sam"
            p_selectedLearnMoreTabDbName={s_selectedDataSourceLearnMoreTabDbName}
            p_learnMoreSelectedBgClass="bgDarkGrayGradient"
            f_onClickLearnMore={this.onselect_gcss_learn_more}>
            <GCSSSingleDataSourceInfoName p_name="SAM.gov Integration" />
            <div className="displayFlexColumnHcVc smallBottomMargin">
              <div className="flex00a smallBottomMargin lrMedMargin border1ddd borderRadius10 tbPad lrMedPad textCenter" style={{width:"25em"}}>
                <font className="font13 fontTextLighter">
                  {"Included free with " + c_productStylingObj.productName + " GovCon Smart Search (GCSS) module"}
                </font>
              </div>
            </div>
          </GCSSSingleDataSourceInfoBox>
          <GCSSSingleDataSourceInfoBox
            p_dataSourceDisplayName="GovWin"
            p_logoFileNameAndExt="gcss_ds_govwin_70px280px.png"
            p_dataSourceShownTF={c_companyGcssDataSourceGovWinShownTF}
            p_dataSourceShownCompanyColumnDbName="gcss_data_source_govwin_shown_01"
            p_switchOnBgColor="0069aa"
            p_learnMoreTabDbName="govwin"
            p_selectedLearnMoreTabDbName={s_selectedDataSourceLearnMoreTabDbName}
            p_learnMoreSelectedBgClass="bgDarkGrayGradient"
            f_onClickLearnMore={this.onselect_gcss_learn_more}>
            <GCSSSingleDataSourceInfoName p_name="Deltek GovWin IQ Integration" />
            <div className="flex00a smallBottomMargin lrMedMargin">
              <font className="fontItalic">
                {"After purchasing a GovWin IQ license through Deltek, fill in the 4 fields below to active integration through the " + c_productStylingObj.productName + " GCSS system. Make sure to come back and update these if they are changed."}
              </font>
            </div>
            <GCSSGovWinMultipleCredentialsEditor
              p_dataSourceSam0GovWin1={1}
              p_gcssCredentialsArrayOfObjs={c_gcssGovWinCredentialsArrayOfObjs}
            />
          </GCSSSingleDataSourceInfoBox>
          <GCSSSingleDataSourceInfoBox
            p_dataSourceDisplayName="Federal Compass"
            p_logoFileNameAndExt="gcss_ds_fedcomp_70px280px.png"
            p_dataSourceShownTF={c_companyGcssDataSourceFedCompShownTF}
            p_dataSourceShownCompanyColumnDbName="gcss_data_source_fedcomp_shown_01"
            p_switchOnBgColor="ffbd29"
            p_learnMoreTabDbName="fedcomp"
            p_selectedLearnMoreTabDbName={s_selectedDataSourceLearnMoreTabDbName}
            p_learnMoreSelectedBgClass="bgDarkGrayGradient"
            f_onClickLearnMore={this.onselect_gcss_learn_more}>
            <GCSSSingleDataSourceInfoName p_name="Federal Compass Integration" />
            <div className="smallBottomMargin lrMedMargin">
              <font className="fontItalic">
                {"After purchasing a license through Federal Compass (contact form to fill out in the 'Learn More'), fill in the API key below to active integration through the " + c_productStylingObj.productName + " GCSS system."}
              </font>
            </div>
            <GCSSGovWinMultipleCredentialsEditor
              p_dataSourceSam0GovWin1={2}
              p_gcssCredentialsArrayOfObjs={c_gcssFedCompCredentialsArrayOfObjs}
            />
          </GCSSSingleDataSourceInfoBox>
        </div>
        {dataSourceAdContentsComponent}
      </div>
    );
  }
}));

const GCSSOptionsIntegrationEmailForm = inject("CaptureExecMobx", "UserMobx")(observer(
class GCSSOptionsIntegrationEmailForm extends Component { //props: p_dataSourceTabDbName
  constructor(props) {
    super(props);

    const o_userCompanyCode = this.props.UserMobx.o_userCompanyCode;
    const c_userName = this.props.UserMobx.c_userName;
    const c_userEmail = this.props.UserMobx.c_userEmail;

    this.state = {
      s_fedCompFormCompany: o_userCompanyCode,
      s_fedCompFormName: c_userName,
      s_fedCompFormWorkEmail: c_userEmail,
      s_fedCompFormWorkPhone: "",
      s_fedCompFormEmailSentTF: false
    };
  }

  onclick_fedcomp_send_form_by_email = () => {
    const s_fedCompFormCompany = this.state.s_fedCompFormCompany;
    const s_fedCompFormName = this.state.s_fedCompFormName;
    const s_fedCompFormWorkEmail = this.state.s_fedCompFormWorkEmail;
    const s_fedCompFormWorkPhone = this.state.s_fedCompFormWorkPhone;
    
    const p_dataSourceTabDbName = this.props.p_dataSourceTabDbName;

    const c_productStylingObj = this.props.CaptureExecMobx.c_productStylingObj;

    var formCompanyName = "Deltek";
    var toEmailsComma = "skip@bitsolutionsllc.com";
    var ccEmailsComma = "";
    if(p_dataSourceTabDbName === "fedcomp") {
      formCompanyName = "Federal Compass";
      toEmailsComma = "skip@bitsolutionsllc.com";
      ccEmailsComma = "";
    }

    const subject = "New interest in " + formCompanyName + " & " + c_productStylingObj.productName + " integration!";
    
    var bodyHtml = "This " + c_productStylingObj.productName + " User below is interested in your service.<br /><br />";
    bodyHtml += "New interest in " + formCompanyName + " & " + c_productStylingObj.productName + " integration<br /><br />";
    bodyHtml += "Company: " + s_fedCompFormCompany + "<br/>";
    bodyHtml += "Name: " + s_fedCompFormName + "<br/>";
    bodyHtml += "Work Email: " + s_fedCompFormWorkEmail + "<br/>";
    bodyHtml += "Work Phone: " + s_fedCompFormWorkPhone;

    const fromEmail = "";
    const fromFullName = "";
    const notificationClickActionString = "";

    const jsDescription = JSFUNC.js_description_from_action("AdminReact - GCSSOptionsIntegrationEmailForm", "onclick_fedcomp_send_form_by_email", [], []);
    const C_CallPhpTblUID = new JSPHP.ClassCallPhpTblUID(jsDescription);
    C_CallPhpTblUID.add_email(toEmailsComma, ccEmailsComma, subject, bodyHtml, fromEmail, fromFullName, notificationClickActionString);
    C_CallPhpTblUID.execute();

    this.setState({s_fedCompFormEmailSentTF:true});
  }

  onchange_fedcomp_form_company = (i_newValueString) => { this.setState({s_fedCompFormCompany:i_newValueString}); }
  onchange_fedcomp_form_name = (i_newValueString) => { this.setState({s_fedCompFormName:i_newValueString}); }
  onchange_fedcomp_form_work_email = (i_newValueString) => { this.setState({s_fedCompFormWorkEmail:i_newValueString}); }
  onchange_fedcomp_form_work_phone = (i_newValueString) => { this.setState({s_fedCompFormWorkPhone:i_newValueString}); }

  render() {
    const s_fedCompFormCompany = this.state.s_fedCompFormCompany;
    const s_fedCompFormName = this.state.s_fedCompFormName;
    const s_fedCompFormWorkEmail = this.state.s_fedCompFormWorkEmail;
    const s_fedCompFormWorkPhone = this.state.s_fedCompFormWorkPhone;
    const s_fedCompFormEmailSentTF = this.state.s_fedCompFormEmailSentTF;

    const p_dataSourceTabDbName = this.props.p_dataSourceTabDbName;

    const c_productStylingObj = this.props.CaptureExecMobx.c_productStylingObj;


    var formCompanyName = "Deltek";
    var formFontColor = "19d";
    var formSendButtonBgColor = "29bdff";
    if(p_dataSourceTabDbName === "fedcomp") {
      formCompanyName = "Federal Compass";
      formFontColor = "d91";
      formSendButtonBgColor = "ffbd29";
    }

    const fedCompFormInputTextStyleObj = {width:"100%", border:"solid 1px #bdd", borderRadius:"0.2em", background:"#ecf1f4", padding:"0.7em"};

    return(
      <div className="flex00a" style={{width:"30em", marginLeft:"1em"}}>
        <div className="border1bbb borderRadius05 bigFullPad">
          <div className="textCenter">
            <font className="font14 fontBold" style={{color:"#" + formFontColor}}>
              {"Tell " + formCompanyName + " you're interested in integration with " + c_productStylingObj.productName + "!"}
            </font>
          </div>
          <FedCompAdFormLabel>{"Company"}</FedCompAdFormLabel>
          <LibraryReact.Text
            p_value={s_fedCompFormCompany}
            p_styleObj={fedCompFormInputTextStyleObj}
            p_tabIndex={1}
            f_onChange={this.onchange_fedcomp_form_company}
          />
          <FedCompAdFormLabel>{"Name"}</FedCompAdFormLabel>
          <LibraryReact.Text
            p_value={s_fedCompFormName}
            p_styleObj={fedCompFormInputTextStyleObj}
            p_tabIndex={2}
            f_onChange={this.onchange_fedcomp_form_name}
          />
          <FedCompAdFormLabel>{"Work Email"}</FedCompAdFormLabel>
          <LibraryReact.Text
            p_value={s_fedCompFormWorkEmail}
            p_styleObj={fedCompFormInputTextStyleObj}
            p_tabIndex={3}
            f_onChange={this.onchange_fedcomp_form_work_email}
          />
          <FedCompAdFormLabel>{"Work Phone (optional)"}</FedCompAdFormLabel>
          <LibraryReact.Text
            p_value={s_fedCompFormWorkPhone}
            p_styleObj={fedCompFormInputTextStyleObj}
            p_tabIndex={4}
            f_onChange={this.onchange_fedcomp_form_work_phone}
          />
          <div className="displayFlexColumnHcVc hugeTopMargin">
            {(s_fedCompFormEmailSentTF) ? (
              <font className="fontBold" style={{color:"#" + formFontColor}}>
                {"Email sent! Thank you for your interest."}
              </font>
            ) : (
              <div
                className="flex00a displayFlexColumnHcVc border bevelBorderColors borderRadius05 hoverLighterBlueGradient textCenter cursorPointer"
                style={{width:"15em", height:"4em", backgroundColor:"#" + formSendButtonBgColor}}
                onClick={this.onclick_fedcomp_send_form_by_email}>
                <font className="font14 fontBold fontWhite">
                  {"Email Us!"}
                </font>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}));

function GCSSAdContainer(props) { //props: p_logoFileLoc, p_logoWidthPx, p_logoHeightPx, p_productName, p_webAddress, children
  const p_logoFileLoc = props.p_logoFileLoc;
  const p_logoWidthPx = props.p_logoWidthPx;
  const p_logoHeightPx = props.p_logoHeightPx;
  const p_productName = props.p_productName;
  const p_webAddress = props.p_webAddress;
  const children = props.children;

  return(
    <div className="medFullMargin boxShadowDarkGray bgWhite" style={{border:"solid 2px #889"}}>
      <div className="displayFlexRow tbPad lrMedPad">
        <div className="flex00a">
          <div className="border bevelBorderColors">
            <div className="displayFlexColumn" style={{width:p_logoWidthPx, height:p_logoHeightPx}}>
              <LibraryReact.Image p_src={p_logoFileLoc} p_alt={p_productName} />
            </div>
          </div>
        </div>
        <div className="flex11a lrMedMargin">
          <font className="fontItalic fontTextLight">
            {"From the official " + p_productName + " website " + p_webAddress}
          </font>
        </div>
      </div>
      {children}
    </div>
  );
}

function GovInfoAdSectionHeader(props) { return(<div className="smallBottomMargin smallBottomPad" style={{borderBottom:"solid 1px #01203B"}}><span className="font20 fontBold" style={{fontFamily:"sans-serif", color:"#01203B"}}>{props.children}</span></div>); }
function GovInfoAdSubHeader(props) { return(<div className="bigTopMargin smallBottomMargin"><span className="font11 fontBold" style={{fontFamily:"sans-serif", color:"#01203B"}}>{props.children}</span></div>); }
function GovInfoAdText(props) { return(<div className="smallBottomMargin"><span style={{fontFamily:"sans-serif", color:"#01203B"}}>{props.children}</span></div>); }

function SAMAdTitle(props) { return(<div className="medBottomMargin"><span className="font20 fontBold fontTextLighter">{props.children}</span></div>); }
function SAMAdHeader(props) { return(<div className="bigTopMargin smallBottomMargin"><span className="font11 fontBold fontTextLight">{props.children}</span></div>); }
function SAMAdText(props) { return(<div className="smallBottomMargin"><span className="fontTextLight">{props.children}</span></div>); }

function GovWinAdTitleAndLine(props) { return(<><div className="medBottomMargin"><span className="font14 fontDarkBlue">{props.children}</span></div><div className="bigBottomMargin borderT1bbb" /></>); }
function GovWinAdHeader(props) { return(<div className="smallBottomMargin"><span className="font12 fontDarkBlue">{props.children}</span></div>); }
function GovWinAdText(props) { return(<div className="smallBottomMargin"><span className="fontTextLight">{props.children}</span></div>); }

function FedCompAdTitleWhite(props) { return(<div className="bigBottomMargin"><span className="font25 fontBold fontWhite">{props.children}</span></div>); }
function FedCompAdTextWhite(props) { return(<div className=""><span className="font13 fontWhite">{props.children}</span></div>); }
function FedCompAdTitleBlue(props) { return(<div className="bigBottomMargin"><span className="font20 fontBold fontDarkBlue">{props.children}</span></div>); }
function FedCompAdTextBlue(props) { return(<div className=""><span className="font13 fontDarkBlue">{props.children}</span></div>); }
function FedCompAdFormLabel(props) { return(<div className="bigTopMargin smallBottomMargin"><span className="font12 fontDarkBlue">{props.children}</span></div>); }


const GCSSSingleDataSourceInfoBox = inject("CaptureExecMobx", "AdminMobx", "DatabaseMobx")(observer(
class GCSSSingleDataSourceInfoBox extends Component { //props: p_dataSourceDisplayName, p_logoFileNameAndExt, p_dataSourceShownTF, p_dataSourceShownCompanyColumnDbName, p_switchOnBgColor, p_learnMoreTabDbName, p_selectedLearnMoreTabDbName, p_learnMoreSelectedBgClass, f_onClickLearnMore, children
  onswitch_data_source_shown = () => {
    const p_dataSourceShownTF = this.props.p_dataSourceShownTF;
    const p_dataSourceShownCompanyColumnDbName = this.props.p_dataSourceShownCompanyColumnDbName;
    const updatedDataSourceShown01 = ((p_dataSourceShownTF) ? (0) : (1));
    this.props.AdminMobx.a_update_tbl_a_company_fields(p_dataSourceShownCompanyColumnDbName, updatedDataSourceShown01, "i");
  }

  onclick_learn_more_button = () => {
    const p_learnMoreTabDbName = this.props.p_learnMoreTabDbName;

    if(JSFUNC.is_function(this.props.f_onClickLearnMore)) {
      this.props.f_onClickLearnMore(p_learnMoreTabDbName);
    }
  }

  render() {
    const p_dataSourceDisplayName = this.props.p_dataSourceDisplayName;
    const p_logoFileNameAndExt = this.props.p_logoFileNameAndExt;
    const p_dataSourceShownTF = this.props.p_dataSourceShownTF;
    const p_dataSourceShownCompanyColumnDbName = this.props.p_dataSourceShownCompanyColumnDbName;
    const p_switchOnBgColor = this.props.p_switchOnBgColor;
    const p_learnMoreTabDbName = this.props.p_learnMoreTabDbName;
    const p_selectedLearnMoreTabDbName = this.props.p_selectedLearnMoreTabDbName;
    const p_learnMoreSelectedBgClass = this.props.p_learnMoreSelectedBgClass;
    const children = this.props.children;

    const c_computedUrlAndProductObj = this.props.CaptureExecMobx.c_computedUrlAndProductObj;
    const c_productStylingObj = this.props.CaptureExecMobx.c_productStylingObj;

    const isSelectedTF = (p_learnMoreTabDbName === p_selectedLearnMoreTabDbName);

    return(
      <div className="flex00a displayFlexColumn smallFullMargin border1bbb bgLightesterGray" style={{flexBasis:"50em", height:"35em"}}>
        <div className="flex00a displayFlexRow">
          <div className="flex00a">
            <div className="border bevelBorderColors">
              <div className="displayFlexColumn" style={{width:"280px", height:"70px"}}>
                <LibraryReact.Image p_src={c_computedUrlAndProductObj.productGraphicsSubfolderAddress + "/" + p_logoFileNameAndExt} p_alt={p_dataSourceDisplayName} />
              </div>
            </div>
          </div>
          <div className="flex11a" />
          <div className="flex00a displayFlexColumnHcVc" style={{marginRight:"1em"}}>
            <div className="flex00a displayFlexColumnHcVc border1ddd borderRadius05 bgLighterGray tbPad" style={{width:"15em"}}>
              <div className="textCenter" style={{width:"14em"}}>
                <font className="">
                  {"Show " + p_dataSourceDisplayName + " as GCSS data source option"}
                </font>
              </div>
              <div className="microTopMargin">
                <LibraryReact.Switch
                  p_isOnTF={p_dataSourceShownTF}
                  p_sizeEm={4}
                  p_onColor={p_switchOnBgColor}
                  p_title={"Turn this switch off to hide " + p_dataSourceDisplayName + " as a data source option to select within the GovCon Smart Search tab for " + c_productStylingObj.productName + " Users"}
                  f_onClick={this.onswitch_data_source_shown}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="flex11a displayFlexColumn">
          {children}
        </div>
        <div className="flex00a displayFlexColumnHcVc tbPad">
          <div
            className={"flex00a displayFlexColumnHcVc border bevelBorderColors borderRadius05 " + ((isSelectedTF) ? (p_learnMoreSelectedBgClass) : ("bgLightGrayGradient")) + " hoverLighterBlueGradient cursorPointer textCenter"}
            style={{width:"20em", height:"2.5em"}}
            onClick={this.onclick_learn_more_button}>
            <font className={"font11 " + ((isSelectedTF) ? ("fontWhite") : ("fontTextLight"))}>
              {"Learn More About " + p_dataSourceDisplayName}
            </font>
          </div>
        </div>
      </div>
    );
  }
}));

function GCSSSingleDataSourceInfoName(props) { //props: p_name
  const p_name = props.p_name;

  return(
    <LibraryReact.DivFont p_class="smallFullMargin textCenter" p_fontClass="font13 fontBold fontBlue">
      {p_name}
    </LibraryReact.DivFont>
  )
}



class GCSSGovWinMultipleCredentialsEditor extends Component { //props: p_dataSourceSam0GovWin1, p_gcssCredentialsArrayOfObjs
  onclick_add_additional_govwin_credentials = () => {
    const p_dataSourceSam0GovWin1 = this.props.p_dataSourceSam0GovWin1;

    const jsDescription = JSFUNC.js_description_from_action("AdminMobx - GCSSGovWinMultipleCredentialsEditor", "onclick_add_additional_govwin_credentials", [], []);
    const C_CallPhpTblUID = new JSPHP.ClassCallPhpTblUID(jsDescription);

    const fieldNamesArray = ["data_source_sam0_govwin1", "division_ids_comma", "username", "password_scramble", "client_id_scramble", "client_secret_scramble", "oauth_access_json", "access_token_expiration_datetime_utc", "previous_access_successful_01"];
    const valuesArray = [p_dataSourceSam0GovWin1, "", "", "", "", "", "", JSFUNC.blank_datetime(), 1];
    const idsbArray = ["i", "s", "s", "s", "s", "s", "s", "s", "i"];
    C_CallPhpTblUID.add_insert("tbl_a_gcss_data_source_credentials", fieldNamesArray, valuesArray, idsbArray); //no resorting with no sort column, ordered by id ASC and can't be changed by user

    C_CallPhpTblUID.execute();
  }

  render() {
    const p_dataSourceSam0GovWin1 = this.props.p_dataSourceSam0GovWin1;
    const p_gcssCredentialsArrayOfObjs = this.props.p_gcssCredentialsArrayOfObjs;

    const dataSourceIsFederalCompassTF = (p_dataSourceSam0GovWin1 === 2);
    const multipleGovWinCredentialsTF = (p_gcssCredentialsArrayOfObjs.length > 1);

    return(
      <>
        <div className="flex00a displayFlexColumnHcVc smallBottomMargin">
          <CEGeneralReact.CEButton
            p_type="add"
            p_text={"Add Additional " + ((dataSourceIsFederalCompassTF) ? ("Federal Compass") : ("GovWin")) + " Credentials"}
            p_title="Use this to create multiple instances of valid GovWin login credentials. You can assign these logins to different divisions within your company to address any needs related to licensing and contracts. Having a single instance will apply automatically to all users."
            f_onClick={this.onclick_add_additional_govwin_credentials}
          />
        </div>
        <div className="flex11a yScroll smallBottomMargin">
          {p_gcssCredentialsArrayOfObjs.map((m_gcssCredentialsObj, m_index) =>
            <GCSSGovWinSingleCredentials
              p_dataSourceSam0GovWin1={p_dataSourceSam0GovWin1}
              p_gcssCredentialsObj={m_gcssCredentialsObj}
              p_sortNumber={(m_index + 1)}
              p_multipleGovWinCredentialsTF={multipleGovWinCredentialsTF}
            />
          )}
        </div>
      </>
    );
  }
}


const GCSSGovWinSingleCredentials = inject("AdminMobx", "DatabaseMobx")(observer(
class GCSSGovWinSingleCredentials extends Component { //props: p_dataSourceSam0GovWin1, p_gcssCredentialsObj, p_sortNumber, p_multipleGovWinCredentialsTF
  onsave_govwin_division_ids = (i_newValueString) => {
    this.update_data_source_credentials_field("division_ids_comma", i_newValueString, "s");
  }

  onsave_govwin_username = (i_newValueString) => {
    this.update_data_source_credentials_field("username", i_newValueString, "s");
  }

  onsave_govwin_password = (i_newValueStringUnscrambled) => {
    const newValueStringScrambled = JSFUNC.rfr_scramble_or_unscramble_password(i_newValueStringUnscrambled);
    this.update_data_source_credentials_field("password_scramble", newValueStringScrambled, "s");
  }

  onsave_govwin_client_id = (i_newValueStringUnscrambled) => {
    const newValueStringScrambled = JSFUNC.rfr_scramble_or_unscramble_password(i_newValueStringUnscrambled);
    this.update_data_source_credentials_field("client_id_scramble", newValueStringScrambled, "s");
  }

  onsave_govwin_client_secret = (i_newValueStringUnscrambled) => {
    const newValueStringScrambled = JSFUNC.rfr_scramble_or_unscramble_password(i_newValueStringUnscrambled);
    this.update_data_source_credentials_field("client_secret_scramble", newValueStringScrambled, "s");
  }

  update_data_source_credentials_field = (i_fieldDbName, i_newValue, i_idsb) => {
    const p_gcssCredentialsObj = this.props.p_gcssCredentialsObj;

    const jsDescription = JSFUNC.js_description_from_action("AdminMobx - GCSSGovWinSingleCredentials", "update_data_source_credentials_field", ["i_fieldDbName", "i_newValue", "i_idsb"], [i_fieldDbName, i_newValue, i_idsb]);
    const C_CallPhpTblUID = new JSPHP.ClassCallPhpTblUID(jsDescription);
    C_CallPhpTblUID.add_update("tbl_a_gcss_data_source_credentials", p_gcssCredentialsObj.id, i_fieldDbName, i_newValue, i_idsb);
    C_CallPhpTblUID.execute();
  }

  ondelete_govwin_credential = () => {
    const p_gcssCredentialsObj = this.props.p_gcssCredentialsObj;

    const jsDescription = JSFUNC.js_description_from_action("AdminMobx - GCSSGovWinSingleCredentials", "ondelete_govwin_credential", [], []);
    const C_CallPhpTblUID = new JSPHP.ClassCallPhpTblUID(jsDescription);
    C_CallPhpTblUID.add_delete("tbl_a_gcss_data_source_credentials", p_gcssCredentialsObj.id);
    C_CallPhpTblUID.execute();
  }

  render() {
    const p_dataSourceSam0GovWin1 = this.props.p_dataSourceSam0GovWin1;
    const p_gcssCredentialsObj = this.props.p_gcssCredentialsObj;
    const p_sortNumber = this.props.p_sortNumber;
    const p_multipleGovWinCredentialsTF = this.props.p_multipleGovWinCredentialsTF;

    const dataSourceIsGovWinTF = (p_dataSourceSam0GovWin1 === 1);
    const dataSourceIsFederalCompassTF = (p_dataSourceSam0GovWin1 === 2);

    const govWinFieldClass = "fontBlue";
    const govWinFieldWidth = "13em";

    return(
      <div className="flex00a displayFlexRow smallFullMargin border1bbb">
        <div className="flex00a displayFlexColumnHcVc textCenter" style={{flexBasis:"2em"}}>
          <font className="font11 fontTextLighter">
            {p_sortNumber}
          </font>
        </div>
        <div className="flex11a smallFullPad">
          {(p_multipleGovWinCredentialsTF) &&
            <CEGeneralReact.CaptureExecFieldEditSaveCancel
              p_ceEditItemString={"adminGcssGovWinDivisions" + p_gcssCredentialsObj.id}
              p_fieldDisplayName="Valid for CE Divisions"
              p_fieldTypeObj={this.props.DatabaseMobx.c_selectMultiDivisionsFieldTypeObj}
              p_valueRaw={p_gcssCredentialsObj.division_ids_comma}
              p_valueIsEditableTFU={true}
              p_fieldClass={govWinFieldClass}
              p_fieldWidth={govWinFieldWidth}
              f_onSaveChanged={this.onsave_govwin_division_ids}
            />
          }
          {(dataSourceIsGovWinTF) &&
            <CEGeneralReact.CaptureExecFieldEditSaveCancel
              p_ceEditItemString={"adminGcssGovWinUsername" + p_gcssCredentialsObj.id}
              p_fieldDisplayName="GovWin Username"
              p_fieldTypeObj={this.props.DatabaseMobx.c_genericTextFieldTypeObj}
              p_valueRaw={p_gcssCredentialsObj.username}
              p_valueIsEditableTFU={true}
              p_fieldClass={govWinFieldClass}
              p_fieldWidth={govWinFieldWidth}
              f_onSaveChanged={this.onsave_govwin_username}
            />
          }
          {(dataSourceIsGovWinTF || dataSourceIsFederalCompassTF) &&
            <CEGeneralReact.CaptureExecFieldEditSaveCancel
              p_ceEditItemString={"adminGcssGovWinPassword" + p_gcssCredentialsObj.id}
              p_fieldDisplayName={((dataSourceIsFederalCompassTF) ? ("Federal Compass API Key") : ("GovWin Password"))}
              p_fieldTypeObj={this.props.DatabaseMobx.c_genericTextFieldTypeObj}
              p_valueRaw={JSFUNC.rfr_scramble_or_unscramble_password(p_gcssCredentialsObj.password_scramble)}
              p_valueIsEditableTFU={true}
              p_fieldClass={govWinFieldClass}
              p_fieldWidth={govWinFieldWidth}
              f_onSaveChanged={this.onsave_govwin_password}
            />
          }
          {(dataSourceIsGovWinTF) &&
            <CEGeneralReact.CaptureExecFieldEditSaveCancel
              p_ceEditItemString={"adminGcssGovWinClientID" + p_gcssCredentialsObj.id}
              p_fieldDisplayName="GovWin Client ID Code"
              p_fieldTypeObj={this.props.DatabaseMobx.c_genericTextFieldTypeObj}
              p_valueRaw={JSFUNC.rfr_scramble_or_unscramble_password(p_gcssCredentialsObj.client_id_scramble)}
              p_valueIsEditableTFU={true}
              p_fieldClass={govWinFieldClass}
              p_fieldWidth={govWinFieldWidth}
              f_onSaveChanged={this.onsave_govwin_client_id}
            />
          }
          {(dataSourceIsGovWinTF) &&
            <CEGeneralReact.CaptureExecFieldEditSaveCancel
              p_ceEditItemString={"adminGcssGovWinClientSecret" + p_gcssCredentialsObj.id}
              p_fieldDisplayName="GovWin Client Secret Code"
              p_fieldTypeObj={this.props.DatabaseMobx.c_genericTextFieldTypeObj}
              p_valueRaw={JSFUNC.rfr_scramble_or_unscramble_password(p_gcssCredentialsObj.client_secret_scramble)}
              p_valueIsEditableTFU={true}
              p_fieldClass={govWinFieldClass}
              p_fieldWidth={govWinFieldWidth}
              f_onSaveChanged={this.onsave_govwin_client_secret}
            />
          }
        </div>
        <div className="flex00a displayFlexColumnHcVc" style={{flexBasis:"2em"}}>
          <CEGeneralReact.DeleteMenu
            p_message={"Are you sure you want to delete the GovWin credentials for Username '" + p_gcssCredentialsObj.username + "'?"}
            f_onDelete={this.ondelete_govwin_credential}
          />
        </div>
      </div>
    );
  }
}));



const GCSSOptionsCustomReasonsNotInterested = inject("CaptureExecMobx", "AdminMobx", "DatabaseMobx")(observer(
class GCSSOptionsCustomReasonsNotInterested extends Component { //props: none
  render() {
    const c_productStylingObj = this.props.CaptureExecMobx.c_productStylingObj;
    const c_gcssNotInterestedReasonsArrayOfObjs = this.props.AdminMobx.c_gcssNotInterestedReasonsArrayOfObjs;
    const c_genericTextFieldTypeObj = this.props.DatabaseMobx.c_genericTextFieldTypeObj;
    const c_genericIntPositiveFieldTypeObj = this.props.DatabaseMobx.c_genericIntPositiveFieldTypeObj;
    
    const gcssNotInterestedReasonsAedTableObj = {
      tblName: "tbl_a_gcss_not_interested_reasons",
      dragToResortFieldDbName: "sort",
      initialSortedFieldDbName: "sort",
      tableWidth: "50em",
      itemName: "GCSS Not Interested Reason",
      deleteItemNameFieldDbName: "name",
      fieldsArrayOfObjs: [
        {width:"100em", dbName:"name", displayName:"Reason", fieldTypeObj:c_genericTextFieldTypeObj, initialValue:"", cellHoverTF:true, requiredNotEmptyTF:true},
        {width:"3em", dbName:"sort", displayName:"Sort", fieldTypeObj:c_genericIntPositiveFieldTypeObj, initialValue:1}
      ]
    };

    return(
      <div className="flex11a medFullPad yScroll">
        <LibraryReact.DivFont p_class="smallBottomMargin" p_fontClass="font13 fontBold fontBlue">
          {"Create Custom 'Reasons Not Interested' for GCSS"}
        </LibraryReact.DivFont>
        <LibraryReact.DivFont p_class="smallBottomMargin" p_fontClass="fontItalic">
          {"When an opportunity from GCSS is marked as 'Not Interested', you can select one of these created Reasons below to show other " + c_productStylingObj.productName + " Users why you believe this deal is not relevant to pursue"}
        </LibraryReact.DivFont>
        <CEComplexReact.AddEditDeleteTable
          p_dataArrayOfObjs={c_gcssNotInterestedReasonsArrayOfObjs}
          p_aedTableObj={gcssNotInterestedReasonsAedTableObj}
        />
      </div>
    );
  }
}));

const GCSSOptionsAutoUpdateOptions = inject("CaptureExecMobx", "AdminMobx", "GCSSMobx")(observer(
class GCSSOptionsAutoUpdateOptions extends Component { //props: none
  onclick_add_new_overwrite_fields_card = () => {
    this.props.AdminMobx.a_gcss_options_overwrite_fields_insert_new_card();
  }

  render() {
    const c_productStylingObj = this.props.CaptureExecMobx.c_productStylingObj;
    const k_gcssAutomaticUpdateOptionsColorsObj = this.props.AdminMobx.k_gcssAutomaticUpdateOptionsColorsObj;
    const c_allAdminExpandedGcssOverwriteFieldsCardsArrayOfObjs = this.props.GCSSMobx.c_allAdminExpandedGcssOverwriteFieldsCardsArrayOfObjs;

    return(
      <div className="flex11a displayFlexColumn bgLighterGray yScroll">
        <div className="flex00a borderB1bbb bgWhite medFullPad">
          <LibraryReact.DivFont p_class="" p_fontClass="font13 fontBold fontBlue">
            {"Automatic Government Data Source Updates - Overwrite Controls"}
          </LibraryReact.DivFont>
          <LibraryReact.DivFont p_class="smallTopMargin" p_fontClass="fontItalic">
            {"In the " + c_productStylingObj.productName + " GovCon Smart Search (GCSS) tab, opportunities can be searched and imported from various data sources (SAM.gov, GovWin, etc). When imported they become 'linked', and every night all linked opportunities are checked for updates in those data sources from the government."}
          </LibraryReact.DivFont>
          <LibraryReact.DivFont p_class="smallTopMargin" p_fontClass="fontItalic">
            {"For each GCSS specific field, these switches control whether government updates are applied to your local " + c_productStylingObj.productName + " opportunity, which would overwrite the old value."}
          </LibraryReact.DivFont>
          <div className="microTopMargin" style={{marginLeft:"0.5em"}}>
            <font className="fontItalic">
              <div>
                {"- "}<font className="fontBold" style={{color:"#" + k_gcssAutomaticUpdateOptionsColorsObj.overwriteOnColor}}>{"Overwrite/Not Overwrite"}</font>
                {": [Off default] an update from the governemnt overwrites the field value in " + c_productStylingObj.productName + ", [On] will not take any updates for that field"}
              </div>
              <div>
                {"- "}<font className="fontBold" style={{color:"#" + k_gcssAutomaticUpdateOptionsColorsObj.overwriteBlankOnColor}}>{"Not Blank Values/Overwrite Blank"}</font>
                {": [Off default] do not overwrite (even if 'Overwrite' is turned on) if the new government value is blank (sometimes when Captures expire, the last government update is full of blank dates and values), [On] overwrite even if the value from the government is blank"}
              </div>
              <div>
                {"- "}<font className="fontBold" style={{color:"#" + k_gcssAutomaticUpdateOptionsColorsObj.notifyOnColor}}>{"Notify/Not Notify"}</font>
                {": [Off default] when this field is updated send Capture Owners a notification, [On] this field does not appear on the notification/email of nightly government updates"}
              </div>
            </font>
          </div>
          <LibraryReact.DivFont p_class="smallTopMargin" p_fontClass="fontItalic">
            {"The 'Division(s)' selector can be used to have different switch settings for different Divisions of your company. Multiple cards with different Divisions can be added using the 'Add' button below."}
          </LibraryReact.DivFont>
          <LibraryReact.DivFont p_class="smallTopMargin" p_fontClass="fontItalic">
            {"The 3 lights on the left side of each GCSS field represent in which data source(s) each field is utilized."}
          </LibraryReact.DivFont>
          <div className="flex00a displayFlexRow smallTopMargin lrMedPad">
            <GCSSDataSourceLightBox p_dataSourceSam0GovWin1={0} p_onTF={true} p_labelTF={true} />
            <div className="flex00a" style={{flexBasis:"0.4em"}} />
            <GCSSDataSourceLightBox p_dataSourceSam0GovWin1={1} p_onTF={true} p_labelTF={true} />
            <div className="flex00a" style={{flexBasis:"0.4em"}} />
            <GCSSDataSourceLightBox p_dataSourceSam0GovWin1={2} p_onTF={true} p_labelTF={true} />
          </div>
        </div>
        <div className="bgGray">
          <div className="displayFlexColumnHcVc tbMedPad">
            <CEGeneralReact.CEButton
              p_type="add"
              p_text="Add New GCSS Overwrite Options Card"
              p_title="Clicking this will create another card of switch controls for each GCSS field, which can be used with a different subset of Divisions to allow different automatic overwrite behavior based on a Capture's assigned Division"
              f_onClick={this.onclick_add_new_overwrite_fields_card}
            />
          </div>
          <div className="displayFlexRow flexWrap">
            {c_allAdminExpandedGcssOverwriteFieldsCardsArrayOfObjs.map((m_gcssExpandedGcssOverwriteFieldsObj, m_index) =>
              <GCSSAutoUpdateSingleGcssOverwriteFieldsCard
                p_gcssExpandedGcssOverwriteFieldsObj={m_gcssExpandedGcssOverwriteFieldsObj}
                p_countNumber={(m_index + 1)}
              />
            )}
          </div>
        </div>
      </div>
    );
  }
}));

const GCSSAutoUpdateSingleGcssOverwriteFieldsCard = inject("AdminMobx", "DatabaseMobx")(observer(
class GCSSAutoUpdateSingleGcssOverwriteFieldsCard extends Component { //props: p_gcssExpandedGcssOverwriteFieldsObj, p_countNumber
  onsave_overwrite_fields_division_ids_comma_or_all = (i_newValueDivisionIDsCommaOrAll) => {
    const p_gcssExpandedGcssOverwriteFieldsObj = this.props.p_gcssExpandedGcssOverwriteFieldsObj;
    this.props.AdminMobx.a_gcss_options_overwrite_fields_card_update_divisions(p_gcssExpandedGcssOverwriteFieldsObj.id, i_newValueDivisionIDsCommaOrAll);
  }

  ondelete_overwrite_fields_card = () => {
    const p_gcssExpandedGcssOverwriteFieldsObj = this.props.p_gcssExpandedGcssOverwriteFieldsObj;
    this.props.AdminMobx.a_gcss_options_overwrite_fields_delete_card(p_gcssExpandedGcssOverwriteFieldsObj.id);
  }

  render() {
    const p_gcssExpandedGcssOverwriteFieldsObj = this.props.p_gcssExpandedGcssOverwriteFieldsObj;
    const p_countNumber = this.props.p_countNumber;
    
    const c_selectMultiDivisionsOrAllFieldTypeObj = this.props.DatabaseMobx.c_selectMultiDivisionsOrAllFieldTypeObj;

    return(
      <div className="flex00a displayFlexColumn medFullMargin border1bbb bgWhite medFullPad boxShadowDarkGray" style={{flexBasis:"60em"}}>
        <div className="flex00a displayFlexRow medBottomMargin" style={{height:"2em"}}>
          <div className="flex11a displayFlexColumnHcVc textCenter">
            <font className="font12 fontBold fontDarkBlue">
              {"GCSS Fields Overwrite Settings " + p_countNumber}
            </font>
          </div>
          <div className="flex00a displayFlexColumnHcVc" style={{flexBasis:"2em"}}>
            <CEGeneralReact.DeleteMenu
              p_message={"Are you sure you want to delete GCSS Fields Overwrite Settings " + p_countNumber}
              f_onDelete={this.ondelete_overwrite_fields_card}
            />
          </div>
        </div>
        <div className="flex00a bigBottomMargin">
          <CEGeneralReact.CaptureExecFieldEditSaveCancel
            p_ceEditItemString={"adminGcssAutoUpdateOverwriteFieldsDivisions" + p_gcssExpandedGcssOverwriteFieldsObj.id}
            p_fieldDisplayName="Division(s) Applied To (or 'All')"
            p_fieldTypeObj={c_selectMultiDivisionsOrAllFieldTypeObj}
            p_valueRaw={p_gcssExpandedGcssOverwriteFieldsObj.division_ids_comma_or_all}
            p_valueIsEditableTFU={true}
            p_fieldClass="fontBlue"
            p_fieldWidth="14em"
            f_onSaveChanged={this.onsave_overwrite_fields_division_ids_comma_or_all}
          />
        </div>
        {p_gcssExpandedGcssOverwriteFieldsObj.overwriteGcssFieldsPerDetailsSectionArrayOfObjs.map((m_gcssDetailSectionObj, m_index) =>
          <>
            <div className={"flex00a " + ((m_index > 0) ? ("bigTopMargin") : (""))}>
              <font className="fontBold fontBlue">
                {m_gcssDetailSectionObj.sectionHeader}
              </font>
            </div>
            {m_gcssDetailSectionObj.gcssFieldsArrayOfObjs.map((m_gcssFieldObj) =>
              <AdminGCSSAutoUpdateSingleFieldSwitchControlsRow
                p_gcssExpandedGcssOverwriteFieldsObj={p_gcssExpandedGcssOverwriteFieldsObj}
                p_gcssFieldObj={m_gcssFieldObj}
              />
            )}
          </>
        )}
      </div>
    );
  }
}));

const AdminGCSSAutoUpdateSingleFieldSwitchControlsRow = inject("AdminMobx")(observer(
class AdminGCSSAutoUpdateSingleFieldSwitchControlsRow extends Component { //props: p_gcssExpandedGcssOverwriteFieldsObj, p_gcssFieldObj
  onswitch_field_not_overwrite_update = () => {
    const p_gcssExpandedGcssOverwriteFieldsObj = this.props.p_gcssExpandedGcssOverwriteFieldsObj;
    const p_gcssFieldObj = this.props.p_gcssFieldObj;
    const addFieldIDTrueRemoveFalse = (!p_gcssFieldObj.fieldIDToNotOverwriteUpdateTF);
    this.props.AdminMobx.a_gcss_options_overwrite_fields_card_update_single_field_switch(p_gcssExpandedGcssOverwriteFieldsObj.id, "capture_field_ids_to_not_overwrite_updates_comma", p_gcssExpandedGcssOverwriteFieldsObj.capture_field_ids_to_not_overwrite_updates_comma, addFieldIDTrueRemoveFalse, p_gcssFieldObj.fieldID);
  }

  onswitch_field_overwrite_blank_value = () => {
    const p_gcssExpandedGcssOverwriteFieldsObj = this.props.p_gcssExpandedGcssOverwriteFieldsObj;
    const p_gcssFieldObj = this.props.p_gcssFieldObj;
    const addFieldIDTrueRemoveFalse = (!p_gcssFieldObj.fieldIDToOverwriteBlankValuesTF);
    this.props.AdminMobx.a_gcss_options_overwrite_fields_card_update_single_field_switch(p_gcssExpandedGcssOverwriteFieldsObj.id, "capture_field_ids_to_overwrite_blank_values_comma", p_gcssExpandedGcssOverwriteFieldsObj.capture_field_ids_to_overwrite_blank_values_comma, addFieldIDTrueRemoveFalse, p_gcssFieldObj.fieldID);
  }

  onswitch_field_not_notify_update = () => {
    const p_gcssExpandedGcssOverwriteFieldsObj = this.props.p_gcssExpandedGcssOverwriteFieldsObj;
    const p_gcssFieldObj = this.props.p_gcssFieldObj;
    const addFieldIDTrueRemoveFalse = (!p_gcssFieldObj.fieldIDToNotNotifyUpdateTF);
    this.props.AdminMobx.a_gcss_options_overwrite_fields_card_update_single_field_switch(p_gcssExpandedGcssOverwriteFieldsObj.id, "capture_field_ids_to_not_notify_updates_comma", p_gcssExpandedGcssOverwriteFieldsObj.capture_field_ids_to_not_notify_updates_comma, addFieldIDTrueRemoveFalse, p_gcssFieldObj.fieldID);
  }

  render() {
    const p_gcssFieldObj = this.props.p_gcssFieldObj;

    const k_gcssAutomaticUpdateOptionsColorsObj = this.props.AdminMobx.k_gcssAutomaticUpdateOptionsColorsObj;

    const switchSizeEm = 2.8;

    return(
      <div className="flex00a displayFlexRow hoverLighterBlueGradient" style={{height:"2em"}}>
        <GCSSDataSourceLightBox p_dataSourceSam0GovWin1={0} p_onTF={p_gcssFieldObj.samTF} p_labelTF={false} />
        <GCSSDataSourceLightBox p_dataSourceSam0GovWin1={1} p_onTF={p_gcssFieldObj.govWinTF} p_labelTF={false} />
        <GCSSDataSourceLightBox p_dataSourceSam0GovWin1={2} p_onTF={p_gcssFieldObj.fedCompTF} p_labelTF={false} />
        <div className="flex11a displayFlexRowVc lrPad" title={p_gcssFieldObj.fieldDisplayName}>
          <LibraryReact.NowrapEllipsis p_fontClass="">
            {p_gcssFieldObj.fieldDisplayName}
          </LibraryReact.NowrapEllipsis>
        </div>
        <div className="flex00a displayFlexRowVc lrPad" style={{flexBasis:"12em"}}>
          <CEGeneralReact.SwitchWithTextAndConfirmBox
            p_isOnTF={p_gcssFieldObj.fieldIDToNotOverwriteUpdateTF}
            p_sizeEm={switchSizeEm}
            p_onColor={k_gcssAutomaticUpdateOptionsColorsObj.overwriteOnColor}
            p_offColor={k_gcssAutomaticUpdateOptionsColorsObj.overwriteOffColor}
            p_onText="Not Overwrite"
            p_offText="Overwrite"
            p_onTextFontClass="fontBold"
            p_offTextFontClass=""
            p_labelWidthEm={6}
            p_title={undefined}
            f_onSwitch={this.onswitch_field_not_overwrite_update}
          />
        </div>
        <div className="flex00a displayFlexRowVc lrPad" style={{flexBasis:"14em"}}>
          {(!p_gcssFieldObj.fieldIDToNotOverwriteUpdateTF) ? (
            <CEGeneralReact.SwitchWithTextAndConfirmBox
              p_isOnTF={p_gcssFieldObj.fieldIDToOverwriteBlankValuesTF}
              p_sizeEm={switchSizeEm}
              p_onColor={k_gcssAutomaticUpdateOptionsColorsObj.overwriteBlankOnColor}
              p_offColor={k_gcssAutomaticUpdateOptionsColorsObj.overwriteBlankOffColor}
              p_onText="Overwrite Blank"
              p_offText="Not Blank Values"
              p_onTextFontClass="fontBold"
              p_offTextFontClass=""
              p_labelWidthEm={9}
              p_title={undefined}
              f_onSwitch={this.onswitch_field_overwrite_blank_value}
            />
          ) : (
            <div className="flex11a lrMedPad">
              <font className="fontItalic" style={{color:"#" + k_gcssAutomaticUpdateOptionsColorsObj.overwriteBlankOffColor}}>
                {"--N/A--"}
              </font>
            </div>
          )}
        </div>
        <div className="flex00a displayFlexRowVc lrPad" style={{flexBasis:"10em"}}>
          <CEGeneralReact.SwitchWithTextAndConfirmBox
            p_isOnTF={p_gcssFieldObj.fieldIDToNotNotifyUpdateTF}
            p_sizeEm={switchSizeEm}
            p_onColor={k_gcssAutomaticUpdateOptionsColorsObj.notifyOnColor}
            p_offColor={k_gcssAutomaticUpdateOptionsColorsObj.notifyOffColor}
            p_onText="Not Notify"
            p_offText="Notify"
            p_onTextFontClass="fontBold"
            p_offTextFontClass=""
            p_labelWidthEm={4}
            p_title={undefined}
            f_onSwitch={this.onswitch_field_not_notify_update}
          />
        </div>
      </div>
    );
  }
}));

const GCSSDataSourceLightBox = inject("GCSSMobx")(observer(
class GCSSDataSourceLightBox extends Component { //props: p_dataSourceSam0GovWin1, p_onTF, p_labelTF
  render() {
    const p_dataSourceSam0GovWin1 = this.props.p_dataSourceSam0GovWin1;
    const p_onTF = this.props.p_onTF;
    const p_labelTF = this.props.p_labelTF;
    
    const gcssDataSourceInfoObj = this.props.GCSSMobx.get_gcss_data_source_info_obj_from_gcss_sam0_govwin1(p_dataSourceSam0GovWin1);

    const lightComponent = (
      <div className="flex00a displayFlexColumnHcVc" style={{flexBasis:"1.1em"}}>
        <div
          className={"flex00a lrMargin border bevelBorderColors borderRadius05 " + ((p_onTF) ? (gcssDataSourceInfoObj.gcssBgLightGradientClass) : ("bgLightestGray")) + " textCenter"}
          style={{width:"1em", height:"1.3em"}}
          title={gcssDataSourceInfoObj.dataSourceName}
        />
      </div>
    );

    if(p_labelTF) {
      return(
        <div className="flex00a displayFlexRowVc">
          {lightComponent}
          <div className="flex00a" style={{marginLeft:"0.4em"}}>
            <font className="">
              {gcssDataSourceInfoObj.dataSourceName}
            </font>
          </div>
        </div>
      );
    }

    return(lightComponent);
  }
}));






//=================================================================================================================================================================
//=================================================================================================================================================================



export const AdminSubtabContactsFields = inject("AdminMobx", "DatabaseMobx")(observer(
class AdminSubtabContactsFields extends Component { //props: none
  constructor(props) {
    super(props);
    this.state = {
      s_selectedTab: "personCompanyExtraFields"
    }
  }

  onclick_admin_contact_tab = (i_newValue) => {
    this.setState({s_selectedTab:i_newValue});
  }

  render() {
    const s_selectedTab = this.state.s_selectedTab;

    const businessTypesArrayOfObjs = this.props.AdminMobx.c_businessTypesArrayOfObjs;
    const capabilitiesArrayOfObjs = this.props.AdminMobx.c_capabilitiesArrayOfObjs;

    var adminContactsPageComponent = null;
    if(s_selectedTab === "personCompanyExtraFields") {
      adminContactsPageComponent = (
        <div className="flex11a yScroll medFullPad">
          <AdminContactsDividerAndTitle p_title="Contact Person Fields" p_noTopLineTF={true} />
          <TeamCompContactExtraFieldColumnManipulationTable p_tblName="tbl_a_contacts_persons_extra_fields" />
          <AdminContactsDividerAndTitle p_title="Contact Company Fields" />
          <TeamCompContactExtraFieldColumnManipulationTable p_tblName="tbl_a_contacts_companies_extra_fields" />
        </div>
      );
    }
    else if(s_selectedTab === "businessTypes") {
      const isSmallBusinessValueArray = [0, 1];
      const isSmallBusinessDisplayArray = ["No (this is a Large Business type, Gov Organization, etc)", "Yes (this is a Small Business type)"];
      const selectIsSmallBusinessFieldTypeObj = this.props.DatabaseMobx.create_verticalswitch_field_type_obj_from_value_array_and_display_array("Is Small Business?", isSmallBusinessValueArray, false, isSmallBusinessDisplayArray, 3);

      const businessTypesAedTableObj = {
        tblName: "tbl_a_business_types",
        dragToResortFieldDbName: "sort",
        initialSortedFieldDbName: "sort",
        tableWidth: "70em",
        itemName: "Company Business Type",
        deleteItemNameFieldDbName: "name",
        fieldsArrayOfObjs: [
          {width:"100em", dbName:"name", displayName:"Business Type Name", fieldTypeObj:this.props.DatabaseMobx.c_genericTextFieldTypeObj, initialValue:"", cellHoverTF:true, requiredNotEmptyTF:true},
          {width:"100em", dbName:"is_sb_type_01", displayName:"Is 'Small Business' Type? (Uses SB Certifications)", fieldTypeObj:selectIsSmallBusinessFieldTypeObj, initialValue:0, cellHoverTF:true, requiredNotEmptyTF:true},
          {width:"3em", dbName:"sort", displayName:"Sort", fieldTypeObj:this.props.DatabaseMobx.c_genericIntPositiveFieldTypeObj, initialValue:1}
        ]
      };

      adminContactsPageComponent = (
        <div className="flex11a yScroll medFullPad">
          <CEComplexReact.AddEditDeleteTable
            p_dataArrayOfObjs={businessTypesArrayOfObjs}
            p_aedTableObj={businessTypesAedTableObj}
          />
        </div>
      );
    }
    else if(s_selectedTab === "capabilities") {
      const capabilitiesAedTableObj = {
        tblName: "tbl_a_capabilities",
        dragToResortFieldDbName: undefined,
        initialSortedFieldDbName: "name",
        tableWidth: "60em",
        itemName: "Company Capability",
        deleteItemNameFieldDbName: "name",
        fieldsArrayOfObjs: [
          {width:"100em", dbName:"name", displayName:"Capability", fieldTypeObj:this.props.DatabaseMobx.c_genericTextareaFieldTypeObj, initialValue:"", cellHoverTF:true, requiredNotEmptyTF:true}
        ]
      };

      adminContactsPageComponent = (
        <div className="flex11a yScroll medFullPad">
          <CEComplexReact.AddEditDeleteTable
            p_dataArrayOfObjs={capabilitiesArrayOfObjs}
            p_aedTableObj={capabilitiesAedTableObj}
          />
        </div>
      );
    }
    else if(s_selectedTab === "reassignContacts") {
      adminContactsPageComponent = (
        <div className="flex11a yScroll medFullPad">
          <AdminContactsReassignDuplicated />
        </div>
      );
    }


    return (
      <>
        <div className="smallFullPad">
          <CEGeneralReact.TabsList
            p_tabDbNamesArray={["personCompanyExtraFields", "businessTypes", "capabilities", "reassignContacts"]}
            p_tabDisplayNamesArray={["Edit Contact Data Fields", "Edit Business Types", "Edit Capabilities", "Untangle Duplicate Contact Entries"]}
            p_selectedTabDbName={s_selectedTab}
            p_tabHeight="3.2em"
            p_textMaxHeight="3em"
            p_tabWidth="13em"
            p_unselectedFontClass="font11 fontBold fontTextLight"
            p_unselectedBgClass="bgLighterGrayGradient hoverLighterBlueGradient fontTextLight"
            p_selectedBgClass="bgGoldGradient"
            f_onSelect={this.onclick_admin_contact_tab}
          />
        </div>
        {adminContactsPageComponent}
      </>
    );
  }
}));


const AdminContactsReassignDuplicated = inject("AdminMobx", "DatabaseMobx", "ContactsMobx")(observer(
class AdminContactsReassignDuplicated extends Component { //props: none
  constructor(props) {
    super(props);
    this.state = {
      s_reassignState: "setup", //"setup", "running", "done"
      s_contactsArePersons12: -1, //-1 - none selected yet, 1 - persons, 2 - companies
      s_contact1ID: -1,
      s_contact2ID: -1,
      s_contactIsDeletedTF: false
    }
  }

  onselect_are_persons_or_companies = (i_newValue) => {
    this.setState({
      s_contactsArePersons12: i_newValue,
      s_contact1ID: -1, //reset the selected contacts when changing their type
      s_contact2ID: -1,
      s_contactIsDeletedTF: false
    });
  }

  onselect_contact1 = (i_newValue) => {
    this.setState({s_contact1ID:i_newValue});
  }

  onselect_contact2 = (i_newValue) => {
    this.setState({s_contact2ID:i_newValue});
  }

  onclick_reassign_contact_assignments = () => {
    this.setState({s_reassignState:"running"});

    const isPersonTF = (this.state.s_contactsArePersons12 === 1);
    const functionOnSuccess = () => {
      this.setState({s_reassignState:"done"});
    }
    const functionOnError = () => {
      this.setState({s_reassignState:"setup"});
      alert("Contacts reassign failed");
    }
    this.props.AdminMobx.a_admin_contacts_reassign(isPersonTF, this.state.s_contact1ID, this.state.s_contact2ID, functionOnSuccess, functionOnError);
  }

  onclick_delete_duplicate_contact = () => {
    const isPersonTF = (this.state.s_contactsArePersons12 === 1);
    this.props.ContactsMobx.a_delete_contact(isPersonTF, this.state.s_contact1ID);
    this.setState({s_contactIsDeletedTF:true});
  }

  onclick_return_to_create_another_reassignment = () => {
    this.setState({
      s_reassignState: "setup",
      s_contactsArePersons12: -1,
      s_contact1ID: -1,
      s_contact2ID: -1,
      s_contactIsDeletedTF: false
    });
  }

  render() {
    const s_reassignState = this.state.s_reassignState;
    const s_contactsArePersons12 = this.state.s_contactsArePersons12;
    const s_contact1ID = this.state.s_contact1ID;
    const s_contact2ID = this.state.s_contact2ID;
    const s_contactIsDeletedTF = this.state.s_contactIsDeletedTF;

    const selectedPersonsTF = (s_contactsArePersons12 === 1);
    const selectedCompaniesTF = (s_contactsArePersons12 === 2);
    const selectedPersonsOrCompanies = (selectedPersonsTF || selectedCompaniesTF);

    var selectContactFieldTypeObj = undefined;
    if(selectedPersonsTF) {
      selectContactFieldTypeObj = this.props.DatabaseMobx.c_selectContactPersonFieldTypeObj;
    }
    else if(selectedCompaniesTF) {
      selectContactFieldTypeObj = this.props.DatabaseMobx.c_selectContactCompanyFieldTypeObj;
    }

    const personsCompaniesSwsOptionsObj = {hasClearSelectionTF:true, unselectedDisplay:"--Select a Contact Type--"};
    const personsCompaniesSwsDataObj = this.props.DatabaseMobx.create_sws_data_obj_from_value_array_and_display_array("Contact Type", [1, 2], false, ["Reassigning Contact Persons", "Reassigning Contact Companies"], personsCompaniesSwsOptionsObj);
    const selectPersonsCompaniesFieldTypeObj = this.props.DatabaseMobx.create_field_type_obj("select", personsCompaniesSwsDataObj);

    const contact1And2AreSetTF = (JSFUNC.select_int_is_filled_out_tf(s_contact1ID) && JSFUNC.select_int_is_filled_out_tf(s_contact2ID));

    if(s_reassignState === "setup") {
      return(
        <>
          <div className="microBottomMargin">
            <font className="fontBold fontTextLighter">
              {"Reassign Duplicate Contact Persons or Companies?"}
            </font>
          </div>
          <div style={{width:"20em"}}>
            <CEGeneralReact.GenericInputOrSelectFromInputType
              p_fieldTypeObj={selectPersonsCompaniesFieldTypeObj}
              p_valueRaw={s_contactsArePersons12}
              f_onChangeOrOnSelect={this.onselect_are_persons_or_companies}
            />
          </div>
          {(selectedPersonsOrCompanies) &&
            <>
              <div className="smallTopMargin">
                <font className="fontItalic fontTextLighter">
                  {((selectedPersonsTF) ? (
                    "This Contact Person reassignment affects 1) Specific Contact Person Capture Details Fields, 2) Contact Persons added within each Teammate (including specified Contracts Manager), and 3) Conversation Contact Persons"
                  ) : (
                    "This Contact Company reassignment affects 1) Specific Contact Company Capture Details Fields, 2) Teammates, 3) Competitors, and 4) Competitor's Teammates"
                  ))}
                </font>
              </div>
              <div className="medTopMargin microBottomMargin">
                <font className="fontItalic fontTextLighter">
                  {"Remove Assignments from:"}
                </font>
              </div>
              <CEGeneralReact.CaptureExecFieldEditSaveCancel
                p_ceEditItemString="adminContactsReassignContact1"
                p_fieldDisplayName="Remove all assignments in system from this contact:"
                p_fieldTypeObj={selectContactFieldTypeObj}
                p_valueRaw={s_contact1ID}
                p_valuesToNotIncludeArray={[s_contact2ID]}
                p_valueIsEditableTFU={true}
                p_fieldClass="fontBlue"
                p_fieldWidth="14em"
                p_floatingBoxTitle="Remove all assignments in system from this selected contact"
                f_onSaveChanged={this.onselect_contact1}
              />
              <div className="medTopMargin microBottomMargin">
                <font className="fontItalic fontTextLighter">
                  {"Give assignments to:"}
                </font>
              </div>
              <CEGeneralReact.CaptureExecFieldEditSaveCancel
                p_ceEditItemString="adminContactsReassignContact2"
                p_fieldDisplayName="Reassign all from above contact to this contact:"
                p_fieldTypeObj={selectContactFieldTypeObj}
                p_valueRaw={s_contact2ID}
                p_valuesToNotIncludeArray={[s_contact1ID]}
                p_valueIsEditableTFU={true}
                p_fieldClass="fontBlue"
                p_fieldWidth="14em"
                p_floatingBoxTitle="Reassign all from above contact to this selected contact"
                f_onSaveChanged={this.onselect_contact2}
              />
              <div className="medTopMargin">
                {(contact1And2AreSetTF) &&
                  <CEGeneralReact.CEButton
                    p_type="blue"
                    p_text="Reassign All Contact Assignments"
                    f_onClick={this.onclick_reassign_contact_assignments}
                  />
                }
              </div>
            </>
          }
        </>
      );
    }

    const contact1NamePlainText = this.props.ContactsMobx.contact_name_from_id(selectedPersonsTF, s_contact1ID);
    const contact2NamePlainText = this.props.ContactsMobx.contact_name_from_id(selectedPersonsTF, s_contact2ID);

    if(s_reassignState === "running") {
      return(
        <div className="medFullPad hugeBottomMargin">
          <LibraryReact.DivFont p_class="" p_fontClass="font12 fontBold fontItalic fontTextLighter">
            {"Running Contact Reassign..."}
          </LibraryReact.DivFont>
          <LibraryReact.DivFont p_class="microTopMargin" p_fontClass="fontItalic fontTextLighter">
            {"Reassigning '" + contact1NamePlainText + "' to '" + contact2NamePlainText + "'..."}
          </LibraryReact.DivFont>
          <div className="smallTopMargin">
            <CEGeneralReact.LoadingAnimation />
          </div>
        </div>
      );
    }

    //done
    return(
      <div className="displayFlexRowVc flexWrap medFullPad hugeBottomMargin">
        {(!s_contactIsDeletedTF) &&
          <div className="flex00a lrMedMargin tbMargin">
            <CEGeneralReact.ButtonWithConfirmBox
              p_buttonType="red"
              p_buttonText={"Delete Duplicate Contact '" + contact1NamePlainText + "'"}
              p_confirmType="confirmDelete"
              p_confirmMessage={"Delete Duplicate Contact '" + contact1NamePlainText + "'?"}
              f_onClickConfirm={this.onclick_delete_duplicate_contact}
            />
          </div>
        }
        <div className="flex00a lrMedMargin tbMargin">
          <CEGeneralReact.CEButton
            p_type="gray"
            p_text="Return to Create Another Reassignment"
            f_onClick={this.onclick_return_to_create_another_reassignment}
          />
        </div>
      </div>
    )
  }
}));

function AdminContactsDividerAndTitle(props) { //props: p_title, p_noTopLineTF
  const p_noTopLineTF = JSFUNC.prop_value(props.p_noTopLineTF, false);
  const p_title = props.p_title;

  return(
    <div
      className={((p_noTopLineTF) ? (undefined) : ("medTopPad bigTopMargin"))}
      style={{borderTop:((p_noTopLineTF) ? (undefined) : ("solid 1px #ccc"))}}>
      <font className="font14 fontBold fontTextLighter">
        {p_title}
      </font>
    </div>
  );
}





//=================================================================================================================================================================
//=================================================================================================================================================================

export const AdminSubtabTasksOptions = inject("AdminMobx")(observer(
class AdminSubtabTasksOptions extends Component { //props: none
  onclick_company_communications_tab = (i_selectedTabDbName) => {
    this.props.AdminMobx.a_set_tasks_options_selected_subtab_db_name(i_selectedTabDbName);
  }

  render() {
    const o_tasksOptionsSelectedSubtabDbName = this.props.AdminMobx.o_tasksOptionsSelectedSubtabDbName;

    return(
        <>
          <div className="flex00a displayFlexColumnVc borderB1bbb lrMedPad xScroll" style={{flexBasis:"3em"}}>
            <CEGeneralReact.TabsList
              p_tabDbNamesArray={["taskCreateEditPrivileges", "tasksPanelExtraCaptureFields", "viewAllTasksInSystem"]}
              p_tabDisplayNamesArray={["Task Create/Edit Privileges", "Tasks Panel Extra Capture Fields", "View All Tasks in System"]}
              p_selectedTabDbName={o_tasksOptionsSelectedSubtabDbName}
              p_tabHeight="1.8em"
              p_textMaxHeight="1.8em"
              p_tabWidth="18em"
              p_unselectedBgClass="bgLighterGrayGradient hoverLighterBlueGradient fontTextLight"
              p_unselectedFontClass="fontBold fontTextLight"
              p_selectedBgClass="bgDarkGreenGradient"
              p_selectedFontClass="fontBold fontWhite"
              f_onSelect={this.onclick_company_communications_tab}
            />
          </div>
          <div className="flex11a xyScroll medFullPad">
            {(o_tasksOptionsSelectedSubtabDbName === "taskCreateEditPrivileges") &&
              <AdminTaskCreateEditPrivileges />
            }
            {(o_tasksOptionsSelectedSubtabDbName === "tasksPanelExtraCaptureFields") &&
              <AdminTasksPanelExtraTaskCaptureFields />
            }
            {(o_tasksOptionsSelectedSubtabDbName === "viewAllTasksInSystem") &&
              <AdminTasksViewAllTasksInSystem />
            }
          </div>
        </>
    );
  }
}));


const AdminTaskCreateEditPrivileges = inject("AdminMobx", "DatabaseMobx")(observer(
class AdminTaskCreateEditPrivileges extends Component { //props: none
  onsave_tasks_assignee_can_edit_due_date = (i_newValueInt01) => {
    this.props.AdminMobx.a_update_tbl_a_company_fields("tasks_assignee_can_edit_due_date_01", i_newValueInt01, "i");
  }

  onsave_tasks_can_edit_assigned_admins_all = (i_newValueInt012) => {
    this.props.AdminMobx.a_update_tbl_a_company_fields("tasks_can_edit_assigned0_admins1_all2", i_newValueInt012, "i");
  }

  onsave_tasks_user_ids_cant_assign_tasks_to_others = (i_newValueCommaListString) => {
    this.props.AdminMobx.a_update_tbl_a_company_fields("tasks_user_ids_cant_assign_tasks_to_others_comma", i_newValueCommaListString, "s");
  }

  render() {
    const c_companyTasksAssigneeCanEditDueDate01 = this.props.DatabaseMobx.c_companyTasksAssigneeCanEditDueDate01;
    const c_companyTasksCanEditAssigned0Admins1All2 = this.props.DatabaseMobx.c_companyTasksCanEditAssigned0Admins1All2;
    const c_companyTasksUserIDsCantAssignTasksToOthersComma = this.props.DatabaseMobx.c_companyTasksUserIDsCantAssignTasksToOthersComma;
    const c_selectMultiUsersDeactivatedHiddenUnlessCheckedFieldTypeObj = this.props.DatabaseMobx.c_selectMultiUsersDeactivatedHiddenUnlessCheckedFieldTypeObj;

    const editingDueDatesDbArray = [0, 1];
    const editingDueDatesDisplayArray = ["[default] 'Assigned To' person(s) cannot change the Due Date of a Task that someone else has assigned to them", "'Assigned To' person(s) can edit their own Due Dates"];
    const taskAssigneesEditingTaskDueDatesFieldTypeObj = this.props.DatabaseMobx.create_verticalswitch_field_type_obj_from_value_array_and_display_array("Task Edit Due Date Option", editingDueDatesDbArray, false, editingDueDatesDisplayArray, 2.8);
    
    const otherUsersEditTasksDbArray = [0, 1, 2];
    const otherUsersEditTasksDisplayArray = ["[default] 'Assigned To' person(s) can edit the Task Description ('Assigned By' person can edit all fields of their Task)", "Admins can edit anybody's Task (all fields) in the System", "All Users can edit anybody's Task (all fields) in the System"];
    const tasksOtherUsersEditTasksFieldTypeObj = this.props.DatabaseMobx.create_verticalswitch_field_type_obj_from_value_array_and_display_array("Other Users Edit Task Option", otherUsersEditTasksDbArray, false, otherUsersEditTasksDisplayArray, 2.8);

    const containerClass = "medBottomMargin";
    const fieldWidth = "20em";

    return (
      <div className="" style={{maxWidth:"60em"}}>
        <div className="medBottomMargin">
          <font className="fontItalic">
            <div>{"Task Creator/Owner = "}<font className="fontBold">{"'Assigned By'"}</font>{" (the person who created the Task)"}</div>
            <div>{"Task Receiver = "}<font className="fontBold">{"'Assigned To'"}</font>{" (the person(s) the Task is delegated to)"}</div>
          </font>
        </div>
        <CEGeneralReact.CaptureExecFieldEditSaveCancel
          p_ceEditItemString="adminSystemTasksAssigneeCanEditDueDate"
          p_fieldDisplayName="'Assigned To' People Can Edit Task Due Date"
          p_fieldTypeObj={taskAssigneesEditingTaskDueDatesFieldTypeObj}
          p_valueRaw={c_companyTasksAssigneeCanEditDueDate01}
          p_valueIsEditableTFU={true}
          p_containerClass={containerClass}
          p_fieldClass="fontBlue"
          p_fieldWidth={fieldWidth}
          p_valueClass={undefined}
          f_onSaveChanged={this.onsave_tasks_assignee_can_edit_due_date}
        />
        <CEGeneralReact.CaptureExecFieldEditSaveCancel
          p_ceEditItemString="adminSystemTasksOtherUsersEditTasks"
          p_fieldDisplayName="Option For Other Users To Edit Tasks"
          p_fieldTypeObj={tasksOtherUsersEditTasksFieldTypeObj}
          p_valueRaw={c_companyTasksCanEditAssigned0Admins1All2}
          p_valueIsEditableTFU={true}
          p_containerClass={containerClass}
          p_fieldClass="fontBlue"
          p_fieldWidth={fieldWidth}
          p_valueClass={undefined}
          f_onSaveChanged={this.onsave_tasks_can_edit_assigned_admins_all}
        />
        <CEGeneralReact.CaptureExecFieldEditSaveCancel
          p_ceEditItemString="adminSystemTasksRestrictedUsersList"
          p_fieldDisplayName="Restricted Users List (these Users can only create/assign a Task to themselves)"
          p_fieldTypeObj={c_selectMultiUsersDeactivatedHiddenUnlessCheckedFieldTypeObj}
          p_valueRaw={c_companyTasksUserIDsCantAssignTasksToOthersComma}
          p_valueIsEditableTFU={true}
          p_containerClass={containerClass}
          p_fieldClass="fontBlue"
          p_fieldWidth={fieldWidth}
          p_valueClass={undefined}
          f_onSaveChanged={this.onsave_tasks_user_ids_cant_assign_tasks_to_others}
        />
      </div>
    );
  }
}));


const AdminTasksPanelExtraTaskCaptureFields = inject("AdminMobx", "RightPanelMobx", "DatabaseMobx")(observer(
class AdminTasksPanelExtraTaskCaptureFields extends Component { //props: none
  render() {
    const c_tasksExtraCaptureFieldsArrayOfObjs = this.props.RightPanelMobx.c_tasksExtraCaptureFieldsArrayOfObjs;
    const c_fieldMapOfOpportunityName = this.props.DatabaseMobx.c_fieldMapOfOpportunityName;
    const c_genericTextFieldTypeObj = this.props.DatabaseMobx.c_genericTextFieldTypeObj;
    const c_genericIntPositiveFieldTypeObj = this.props.DatabaseMobx.c_genericIntPositiveFieldTypeObj;
    const c_genericDateDayMdyDaysUntil1OverdueFieldTypeObj = this.props.DatabaseMobx.c_genericDateDayMdyDaysUntil1OverdueFieldTypeObj;
    const c_selectCaptureFieldFieldTypeObj = this.props.DatabaseMobx.c_selectCaptureFieldFieldTypeObj;
   
    const tasksExtraCaptureFieldsAedTableObj = {
      tblName: "tbl_a_tasks_extra_capture_fields",
      dragToResortFieldDbName: "sort",
      initialSortedFieldDbName: "sort",
      tableWidth: "40em",
      itemName: "Tasks Extra Capture Field",
      deleteItemNameFieldDbName: "name",
      fieldsArrayOfObjs: [
        {width:"100em", dbName:"capture_field_id", displayName:"Capture Field", fieldTypeObj:c_selectCaptureFieldFieldTypeObj, initialValue:-1, cellHoverTF:true, requiredNotEmptyTF:true},
        {width:"3em", dbName:"sort", displayName:"Sort", fieldTypeObj:c_genericIntPositiveFieldTypeObj}
      ]
    };

    const nowDateValueMaskSortIfoObj = this.props.DatabaseMobx.value_mask_sort_ifo_obj_from_value_raw_and_field_type_obj(JSFUNC.now_dateYmd(), c_genericDateDayMdyDaysUntil1OverdueFieldTypeObj);

    var exampleExtraCaptureFieldValuesArrayOfObjs = [];
    for(let tasksExtraCaptureFieldsObj of c_tasksExtraCaptureFieldsArrayOfObjs) {
      var exampleExtraCaptureFieldValueObj = this.props.DatabaseMobx.value_mask_sort_ifo_obj_from_value_raw_and_field_type_obj("Example Capture Value", c_genericTextFieldTypeObj);
      exampleExtraCaptureFieldValueObj.captureFieldDisplayName = tasksExtraCaptureFieldsObj.captureFieldDisplayName;
      exampleExtraCaptureFieldValuesArrayOfObjs.push(exampleExtraCaptureFieldValueObj);
    }

    const exmapleExpandedTaskObj = {
      id: -1,
      capture_id: -1,
      assigner_user_id: -1,
      assigned_to_user_ids_comma: "",
      date_created: "0000-00-00",
      date_due: "0000-00-00",
      date_completed: "0000-00-00",
      important_01: 0,
      viewed_0123: 0,
      description: "",
      pre_reminder_days: -1,
      pre_reminder_sent_01: 0,
      post_reminder_days: -1,
      post_reminder_sent_date: "0000-00-00",
      dueDateIsSetTF: false,
      isCompletedTF: false,
      isImportantTF: false,
      isGeneralTaskTF: false,
      assignedToMeTF: false,
      assignerIsMeTF: false,
      preReminderIsOnTF: false,
      postReminderIsOnTF: false,
      maskAssignedToName: "Example User",
      maskAssignedToNamePlainText: "Example User",
      maskAssignerName: "Example User",
      maskAssignerNamePlainText: "Example User",
      maskRelevancePlainText: "Capture " + c_fieldMapOfOpportunityName.get("display_name"),
      maskActiveTaskMdyDueDate: nowDateValueMaskSortIfoObj.valueMask,
      maskActiveTaskMdyDueDatePlainText: nowDateValueMaskSortIfoObj.valueMaskPlainText,
      maskCompletedTaskItemDueDate: "",
      maskCompletedTaskItemCompletedDate: "",
      maskDescription: "Example description",
      maskDescriptionPlainText: "Example description",
      extraCaptureFieldValuesArrayOfObjs: exampleExtraCaptureFieldValuesArrayOfObjs
    };

    return (
      <div style={{width:"72em"}}>
        <LibraryReact.DivFont p_class="medBottomMargin" p_fontClass="font11 fontItalic">
          {"Using this table, you can add extra Capture Fields below 'Relevance' when displayed in a Task in the Tasks Panel. 'Relevance' displays the name of the Capture, and these extra fields can help to more easily identify which Capture this is."}
        </LibraryReact.DivFont>
        <div className="displayFlexRow">
          <div className="flex00a">
            <CEComplexReact.AddEditDeleteTable
              p_dataArrayOfObjs={c_tasksExtraCaptureFieldsArrayOfObjs}
              p_aedTableObj={tasksExtraCaptureFieldsAedTableObj}
            />
          </div>
          <div className="flex00a" style={{flexBasis:"2em"}} />
          <div className="flex11a">
            <div className="border1bbb bgLighterGray smallFullPad">
              <LibraryReact.DivFont p_class="smallBottomMargin" p_fontClass="fontItalic fontTextLight">
                {"Example Task as it will appear in Tasks Panel"}
              </LibraryReact.DivFont>
              <RightPanelReact.TaskItem
                p_container="rightPanel"
                p_taskObj={exmapleExpandedTaskObj}
                f_onClick={undefined}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}));


const AdminTasksViewAllTasksInSystem = inject("AdminMobx", "RightPanelMobx", "DatabaseMobx", "UserMobx")(observer(
class AdminTasksViewAllTasksInSystem extends Component { //props: none
  componentDidMount() {
    this.props.AdminMobx.a_tasks_options_load_all_tasks_data();
  }

  onclick_admin_task_data_row = (i_dataRowTaskID) => {
    this.props.RightPanelMobx.a_tasks_open_task_from_task_id(i_dataRowTaskID);
  }

  render() {
    const o_tasksOptionsAllTasksLoadingDataOrErrorUndefinedTFU = this.props.AdminMobx.o_tasksOptionsAllTasksLoadingDataOrErrorUndefinedTFU;
    const c_adminTasksOptionsAllExpandedTasksArrayOfOptions = this.props.AdminMobx.c_adminTasksOptionsAllExpandedTasksArrayOfOptions;
    const c_adminTasksOptionsSelectImportantFieldTypeObj = this.props.AdminMobx.c_adminTasksOptionsSelectImportantFieldTypeObj;
    const c_genericTextFieldTypeObj = this.props.DatabaseMobx.c_genericTextFieldTypeObj;
    const c_genericDateFieldTypeObj = this.props.DatabaseMobx.c_genericDateFieldTypeObj;
    const c_selectUserDeactivatedHiddenUnlessCheckedFieldTypeObj = this.props.DatabaseMobx.c_selectUserDeactivatedHiddenUnlessCheckedFieldTypeObj;
    const c_selectMultiUsersDeactivatedHiddenUnlessCheckedFieldTypeObj = this.props.DatabaseMobx.c_selectMultiUsersDeactivatedHiddenUnlessCheckedFieldTypeObj;
    const c_selectAllCapturesFieldTypeObj = this.props.DatabaseMobx.c_selectAllCapturesFieldTypeObj;
    const o_userID = this.props.UserMobx.o_userID;

    const integrationChangelogColumnsArrayOfObjs = [
      {valueRawDbName:"date_due",         fieldTypeObjOrUndefined:c_genericDateFieldTypeObj,                      altMaskDbNameOrUndefined:undefined, columnDisplayName:"Due",         flex01:0, flexBasisEm:8,   alignClassName:"textCenter", filterTypeOrUndefined:"minMaxDate", filterMultiSelectMustIncludeValueOrFalseOrUndefined:undefined, sortInitialIsAscTFOrUndefined:false},
      {valueRawDbName:"important_01",     fieldTypeObjOrUndefined:c_adminTasksOptionsSelectImportantFieldTypeObj, altMaskDbNameOrUndefined:undefined, columnDisplayName:"Important",   flex01:0, flexBasisEm:4,   alignClassName:"textCenter", filterTypeOrUndefined:"multiSelect", filterMultiSelectMustIncludeValueOrFalseOrUndefined:undefined, sortInitialIsAscTFOrUndefined:undefined},
      {valueRawDbName:"date_completed",   fieldTypeObjOrUndefined:c_genericDateFieldTypeObj,                      altMaskDbNameOrUndefined:undefined, columnDisplayName:"Completed",   flex01:0, flexBasisEm:8,   alignClassName:"textCenter", filterTypeOrUndefined:undefined, filterMultiSelectMustIncludeValueOrFalseOrUndefined:undefined, sortInitialIsAscTFOrUndefined:undefined},
      {valueRawDbName:"capture_id",       fieldTypeObjOrUndefined:c_selectAllCapturesFieldTypeObj,                altMaskDbNameOrUndefined:undefined, columnDisplayName:"Relevance",   flex01:1, flexBasisEm:100, alignClassName:"",           filterTypeOrUndefined:"multiSelect", filterMultiSelectMustIncludeValueOrFalseOrUndefined:undefined, sortInitialIsAscTFOrUndefined:undefined},
      {valueRawDbName:"date_created",     fieldTypeObjOrUndefined:c_genericDateFieldTypeObj,                      altMaskDbNameOrUndefined:undefined, columnDisplayName:"Created",     flex01:0, flexBasisEm:8,   alignClassName:"textCenter", filterTypeOrUndefined:undefined, filterMultiSelectMustIncludeValueOrFalseOrUndefined:undefined, sortInitialIsAscTFOrUndefined:undefined},
      {valueRawDbName:"assigned_to_user_ids_comma", fieldTypeObjOrUndefined:c_selectMultiUsersDeactivatedHiddenUnlessCheckedFieldTypeObj,       altMaskDbNameOrUndefined:undefined, columnDisplayName:"Assigned To", flex01:1, flexBasisEm:100, alignClassName:"",           filterTypeOrUndefined:"multiSelect", filterMultiSelectMustIncludeValueOrFalseOrUndefined:o_userID, sortInitialIsAscTFOrUndefined:undefined},
      {valueRawDbName:"assigner_user_id", fieldTypeObjOrUndefined:c_selectUserDeactivatedHiddenUnlessCheckedFieldTypeObj,                       altMaskDbNameOrUndefined:undefined, columnDisplayName:"Assigned By", flex01:1, flexBasisEm:100, alignClassName:"",           filterTypeOrUndefined:"multiSelect", filterMultiSelectMustIncludeValueOrFalseOrUndefined:o_userID, sortInitialIsAscTFOrUndefined:undefined},
      {valueRawDbName:"description",      fieldTypeObjOrUndefined:c_genericTextFieldTypeObj,                      altMaskDbNameOrUndefined:undefined, columnDisplayName:"Description", flex01:1, flexBasisEm:500, alignClassName:"",           filterTypeOrUndefined:"searchText", filterMultiSelectMustIncludeValueOrFalseOrUndefined:undefined, sortInitialIsAscTFOrUndefined:undefined},
    ];
      
    return(
      <div className="flex11a displayFlexColumn">
        <CEGeneralReact.DataTableWithFiltersColSortPages
          p_dataTableDisplayName="All System Tasks"
          p_dataTableDisplayShortName="Tasks"
          p_dataIsLoadingTF={(o_tasksOptionsAllTasksLoadingDataOrErrorUndefinedTFU === true)}
          p_dataLoadingErrorTF={(o_tasksOptionsAllTasksLoadingDataOrErrorUndefinedTFU === undefined)}
          p_dataArrayOfObjs={c_adminTasksOptionsAllExpandedTasksArrayOfOptions}
          p_uniqueIDColumnValueRawDbName="id"
          p_displayColumnsArrayOfObjs={integrationChangelogColumnsArrayOfObjs}
          p_verticalDotsMenuItemsArrayOfObjsOrUndefined={undefined}
          p_numRowsPerPage={25}
          p_filterContainerWithEm={18}
          p_selectedBgColorClass="bgDarkOrangeGradient"
          p_selectedFontClass="fontWhite"
          p_canClickHoverColorClass="hoverLightOrangeGradient"
          f_onClickDataRow={this.onclick_admin_task_data_row}
        />
      </div>
    );
  }
}));



//=================================================================================================================================================================
//=================================================================================================================================================================



export const AdminSubtabCompanyCommunications = inject("AdminMobx")(observer(
class AdminSubtabCompanyCommunications extends Component { //props: none
  onclick_company_communications_tab = (i_selectedTabDbName) => {
    this.props.AdminMobx.a_set_company_communications_selected_subtab_db_name(i_selectedTabDbName);
  }

  render() {
    const o_companyCommunicationsSelectedSubtabDbName = this.props.AdminMobx.o_companyCommunicationsSelectedSubtabDbName;

    return(
        <>
          <div className="flex00a displayFlexColumnVc borderB1bbb lrMedPad xScroll" style={{flexBasis:"3em"}}>
            <CEGeneralReact.TabsList
              p_tabDbNamesArray={["banners", "broadcast"]}
              p_tabDisplayNamesArray={["Publish System Banners", "Send Broadcast Notifications"]}
              p_selectedTabDbName={o_companyCommunicationsSelectedSubtabDbName}
              p_tabHeight="1.8em"
              p_textMaxHeight="1.8em"
              p_tabWidth="18em"
              p_unselectedBgClass="bgLighterGrayGradient hoverLighterBlueGradient fontTextLight"
              p_unselectedFontClass="fontBold fontTextLight"
              p_selectedBgClass="bgTealGradient"
              p_selectedFontClass="fontBold fontWhite"
              f_onSelect={this.onclick_company_communications_tab}
            />
          </div>
          <div className="flex11a xyScroll medFullPad">
            {(o_companyCommunicationsSelectedSubtabDbName === "banners") &&
              <AdminCommunicationsBanners />
            }
            {(o_companyCommunicationsSelectedSubtabDbName === "broadcast") &&
              <div className="" style={{width:"95%", maxWidth:"30em"}}>
                <RightPanelReact.NotificationsBroadcastCreateAndSend />
              </div>
            }
          </div>
        </>
    );
  }
}));


const AdminCommunicationsBanners = inject("CaptureExecMobx", "AdminMobx", "DatabaseMobx", "UserMobx")(observer(
class AdminCommunicationsBanners extends Component { //props: none
  render() {
    const o_mediaQueryFlag = this.props.CaptureExecMobx.o_mediaQueryFlag;
    const c_adminCompanyCommunicationsArrayOfObjs = this.props.AdminMobx.c_adminCompanyCommunicationsArrayOfObjs;
    const c_adminCompanyCommunicationsSelectBannerOff0OnlyMe1On2FieldTypeObj = this.props.AdminMobx.c_adminCompanyCommunicationsSelectBannerOff0OnlyMe1On2FieldTypeObj;
    const c_adminCompanyCommunicationsSelectFontSizeMultiplier10xFieldTypeObj = this.props.AdminMobx.c_adminCompanyCommunicationsSelectFontSizeMultiplier10xFieldTypeObj;
    const c_genericTextareaFieldTypeObj = this.props.DatabaseMobx.c_genericTextareaFieldTypeObj;
    const c_genericDecimalPositiveFieldTypeObj = this.props.DatabaseMobx.c_genericDecimalPositiveFieldTypeObj;
    const c_genericDateFieldTypeObj = this.props.DatabaseMobx.c_genericDateFieldTypeObj;
    const c_genericStylingStringAdminFieldTypeObj = this.props.DatabaseMobx.c_genericStylingStringAdminFieldTypeObj;
    const c_selectMultiUsersPerEmailNotDeactivatedOrAllFieldTypeObj = this.props.DatabaseMobx.c_selectMultiUsersPerEmailNotDeactivatedOrAllFieldTypeObj;
    const c_selectMultiDivisionsOrAllFieldTypeObj = this.props.DatabaseMobx.c_selectMultiDivisionsOrAllFieldTypeObj;
    const o_userID = this.props.UserMobx.o_userID;

    const nowDateTimeUtc = JSFUNC.now_naturalDateTimeUtcYmdHis();

    const companyCommunicationsAedTableObj = {
      tblName: "tbl_a_communications_banners",
      dragToResortFieldDbName: "sort",
      initialSortedFieldDbName: "sort",
      tableWidth: ((o_mediaQueryFlag >= 5) ? ("95%") : ("100em")),
      itemName: "Communications Banner",
      deleteItemNameFieldDbName: "banner_display_text",
      newItemConstantFieldNamesArray: ["created_datetime_utc", "created_by_user_id"],
      newItemConstantValuesArray: [nowDateTimeUtc, o_userID],
      newItemConstantIdsbArray: ["s", "i"],
      fieldsArrayOfObjs: [
        {width:"8em", fixedWidthTF:true, dbName:"off0_onlyme1_on2", displayName:"On/Off", fieldTypeObj:c_adminCompanyCommunicationsSelectBannerOff0OnlyMe1On2FieldTypeObj, initialValue:1, cellCenterTF:true},
        {width:"8em", fixedWidthTF:true, dbName:"start_date", displayName:"Start Date (optional)", fieldTypeObj:c_genericDateFieldTypeObj, initialValue:"0000-00-00", cellCenterTF:true},
        {width:"8em", fixedWidthTF:true, dbName:"end_date", displayName:"End Date (optional)", fieldTypeObj:c_genericDateFieldTypeObj, initialValue:"0000-00-00", cellCenterTF:true},
        {width:"200em", dbName:"banner_display_text", displayName:"Banner Display Text", fieldTypeObj:c_genericTextareaFieldTypeObj, initialValue:"", cellHoverTF:true},
        {width:"150em", dbName:"banner_full_description", displayName:"Full Description (optional)", fieldTypeObj:c_genericTextareaFieldTypeObj, initialValue:"", cellHoverTF:true},
        {width:"8em", fixedWidthTF:true, dbName:"banner_height_em_decimal", displayName:"Height (# Lines)", fieldTypeObj:c_genericDecimalPositiveFieldTypeObj, initialValue:1.9, cellCenterTF:true},
        {width:"8em", fixedWidthTF:true, dbName:"banner_styling_string_comma", displayName:"Style", fieldTypeObj:c_genericStylingStringAdminFieldTypeObj, initialValue:"color#777777,highlight#fbf9e9", cellCenterTF:true, cellDisplayBlankIfNotFilledOutTF:true},
        {width:"8em", fixedWidthTF:true, dbName:"banner_font_size_multiplier_10x", displayName:"Font Size", fieldTypeObj:c_adminCompanyCommunicationsSelectFontSizeMultiplier10xFieldTypeObj, initialValue:10, cellCenterTF:true},
        {width:"100em", dbName:"seen_by_user_per_email_ids_comma_or_all", displayName:"Seen by Users (optional)", fieldTypeObj:c_selectMultiUsersPerEmailNotDeactivatedOrAllFieldTypeObj, initialValue:"all"},
        {width:"100em", dbName:"seen_by_division_ids_comma_or_all", displayName:"Seen by Divisions (optional)", fieldTypeObj:c_selectMultiDivisionsOrAllFieldTypeObj, initialValue:"all"},
        {width:"3em", dbName:"sort", displayName:"Sort", fieldTypeObj:this.props.DatabaseMobx.c_genericIntPositiveFieldTypeObj, initialValue:1}
      ]
    };

    return(
      <>
        <LibraryReact.DivFont p_class="smallBottomMargin" p_fontClass="font12 fontBold fontTextLighter">
          {"System Banners"}
        </LibraryReact.DivFont>
        <div className="smallBottomMargin" style={{width:"100em"}}>
          <LibraryReact.DivFont p_class="microBottomMargin" p_fontClass="fontItalic fontTextLight">
            {"To create a new Banner that displays above the CE system, click the “Add New Communications Banner” button."}
          </LibraryReact.DivFont>
          <LibraryReact.DivFont p_class="microBottomMargin" p_fontClass="fontItalic fontTextLight">
            {"Start and end dates may be left blank and the banner will always be displayed. If dates are put in, the system will display and remove the banner based on the dates."}
          </LibraryReact.DivFont>
          <LibraryReact.DivFont p_class="" p_fontClass="fontItalic fontTextLight">
            {"You can also restrict who can see the banners based on the “Seen by Users” and “Seen by Divisions” options."}
          </LibraryReact.DivFont>
        </div>
        <CEComplexReact.AddEditDeleteTable
          p_dataArrayOfObjs={c_adminCompanyCommunicationsArrayOfObjs}
          p_aedTableObj={companyCommunicationsAedTableObj}
        />
      </>
    );
  }
}));



//=================================================================================================================================================================
//=================================================================================================================================================================



export const AdminSubtabAutomatedReminders = inject("AdminMobx", "DatabaseMobx")(observer(
class AdminSubtabAutomatedReminders extends Component { //props: none
  render() {
    const c_automatedRemindersArrayOfObjs = this.props.AdminMobx.c_automatedRemindersArrayOfObjs;
    const c_fieldMapOfCaptureManagers = this.props.DatabaseMobx.c_fieldMapOfCaptureManagers;
    const c_selectMultiDivisionsOrAllFieldTypeObj = this.props.DatabaseMobx.c_selectMultiDivisionsOrAllFieldTypeObj;

    const selectActiveAllFieldTypeObj = this.props.DatabaseMobx.create_verticalswitch_field_type_obj_from_value_array_and_display_array("Active/All", [0, 1], false, ["Only Send for Active Captures (Not Won/Lost/Cancelled)", "Send for All Captures"], 3);
    const usersListedText = "User(s) listed on Capture '" + c_fieldMapOfCaptureManagers.get("display_name") + "' field";
    const selectNotifyAllCaptureManagersFieldTypeObj = this.props.DatabaseMobx.create_verticalswitch_field_type_obj_from_value_array_and_display_array("Notify All Capture Managers", [1, 0], false, ["[default] Notify all " + usersListedText, "Do not include " + usersListedText], 3);
    const selectPrePostFieldTypeObj = this.props.DatabaseMobx.create_verticalswitch_field_type_obj_from_value_array_and_display_array("Pre/Post", [0, 1], false, ["Send # Days Prior to Date", "Send # Days After Date"], 3);

    const automatedRemindersAedTableObj = {
      tblName: "tbl_a_automated_reminders",
      tableWidth: "100%",
      itemName: "Automated Reminder",
      customFieldWidth: "40%",
      fieldsArrayOfObjs: [
        {width:"100em", dbName:"date_field_id", displayName:"Capture Date Field", fieldTypeObj:this.props.DatabaseMobx.c_selectCaptureDateFieldFieldTypeObj, initialValue:-1, cellHoverTF:true, requiredNotEmptyTF:true},
        {width:"6em", fixedWidthTF:true, dbName:"num_days_prior", displayName:"# Days", fieldTypeObj:this.props.DatabaseMobx.c_genericIntPositiveFieldTypeObj, initialValue:30, cellCenterTF:true, requiredNotEmptyTF:true},
        {width:"13em", fixedWidthTF:true, dbName:"pre0_post1", displayName:"Pre/Post Reminder", fieldTypeObj:selectPrePostFieldTypeObj, initialValue:0, cellCenterTF:true, cellHoverTF:true, requiredNotEmptyTF:true},
        {width:"100em", dbName:"active0_all1", displayName:"Active/Closed Capture Send Restriction", fieldTypeObj:selectActiveAllFieldTypeObj, initialValue:0, cellCenterTF:true, cellHoverTF:true, requiredNotEmptyTF:true},
        {width:"100em", dbName:"notify_all_capture_managers_01", displayName:"Notify All Capture Managers Yes/No", fieldTypeObj:selectNotifyAllCaptureManagersFieldTypeObj, initialValue:1, cellHoverTF:true},
        {width:"100em", dbName:"extra_user_per_email_ids_to_notify_comma", displayName:"Users in Addition to Capture Managers to Notify (optional)", fieldTypeObj:this.props.DatabaseMobx.c_selectMultiUsersPerEmailNotDeactivatedFieldTypeObj, initialValue:"", cellHoverTF:true},
        {width:"100em", dbName:"extra_message", displayName:"Extra Message Included in Notification (optional)", fieldTypeObj:this.props.DatabaseMobx.c_genericTextareaFieldTypeObj, initialValue:"", cellHoverTF:true},
        {width:"100em", dbName:"division_ids_comma_or_all", displayName:"Division(s) Applied To (optional)", fieldTypeObj:c_selectMultiDivisionsOrAllFieldTypeObj, initialValue:"all", cellHoverTF:true}
      ]
    };

    return (
      <div className="flex11a xyScroll medFullPad">
        <LibraryReact.DivFont p_class="smallBottomMargin" p_fontClass="font14 fontBold fontTextLight">
          {"Admin Automated Reminder System"}
        </LibraryReact.DivFont>
        <LibraryReact.DivFont p_styleObj={{maxWidth:"90em"}} p_fontClass="fontItalic fontTextLight">
          <div>{"The Admin Automated Reminder system allows you to configure reminders for Capture dates. You can specify the number of days prior to the Capture date for the reminder, whether it is a pre or post reminder, and the active/closed Capture send restriction."}</div>
          <div className="smallTopMargin">{"You can choose to notify all Capture Managers or select additional users to notify. You can also include an extra message in the notification and apply the reminder to specific divisions."}</div>
          <div className="smallTopMargin">{"Reminder emails are sent daily at 0900 UTC (5am EST) for all Captures where the specified date matches the number of days prior to today's date, or the number of days post today's date."}</div>
        </LibraryReact.DivFont>
        <div className="medTopMargin" />
        <CEComplexReact.AddEditDeleteTable
          p_dataArrayOfObjs={c_automatedRemindersArrayOfObjs}
          p_aedTableObj={automatedRemindersAedTableObj}
        />
      </div>
    );
  }
}));



//=================================================================================================================================================================
//=================================================================================================================================================================


/*
export const AdminSubtabAutomatedExports = inject("AdminMobx", "DatabaseMobx")(observer(
class AdminSubtabAutomatedExports extends Component {
  constructor(props) {
    super(props);
    this.state = {
      s_createNewAutomatedExportJobFloatingBoxIsOpenTF: false,
      s_editingAutomatedExportIDOrUndefined: undefined
    };
  }

  onclick_open_create_new_automated_export_job_floating_box = () => {
    this.setState({s_createNewAutomatedExportJobFloatingBoxIsOpenTF:true});
  }

  onclick_close_create_new_automated_export_job_floating_box = () => {
    this.setState({s_createNewAutomatedExportJobFloatingBoxIsOpenTF:false});
  }

  onclick_open_edit_automated_export_job_floating_box = (i_automatedExportID) => {
    this.setState({s_editingAutomatedExportIDOrUndefined:i_automatedExportID});
  }

  onclick_close_edit_automated_export_job_floating_box = () => {
    this.setState({s_editingAutomatedExportIDOrUndefined:undefined});
  }

  render() {
    const s_createNewAutomatedExportJobFloatingBoxIsOpenTF = this.state.s_createNewAutomatedExportJobFloatingBoxIsOpenTF;
    const s_editingAutomatedExportIDOrUndefined = this.state.s_editingAutomatedExportIDOrUndefined;

    const c_automatedExportsArrayOfObjs = this.props.AdminMobx.c_automatedExportsArrayOfObjs;

    const colWidthsEmArray = [6, 9, 7, 25, 8, 10, 7, 25, 15, 15, 10, 6, 3];

    return (
      <>
        <div className="flex11a xyScroll medFullPad">
          <div className="">
            <font className="">
              {"Automated Exports - Use this tool to create regularly scheduled exports of Captures in .csv format. These files can be used by tools such as PowerBI."}
            </font>
          </div>
          <div className="">
            <CEGeneralReact.CEButton
              p_type="add"
              p_text="Create New Automated Export Job"
              f_onClick={this.onclick_open_create_new_automated_export_job_floating_box}
            />
          </div>
          <div className="">
            <div className="displayFlexRow" style={{minHeight:"3em"}}>
              <AutomatedExportsTblHeaderCell p_widthEm={colWidthsEmArray[0]} p_label="On/Off" p_title="'On' will run the job indefinitely creating .csv files of Captures according to the selected schedule. 'Off' will stop the scheduled runs." />
              <AutomatedExportsTblHeaderCell p_widthEm={colWidthsEmArray[1]} p_label="Latest File URL" p_title="Icon to copy the URL of latest .csv file generated by this job, hosted on the CaptureExec server. If the job has not yet run for the first time '-' will be shown." />
              <AutomatedExportsTblHeaderCell p_widthEm={colWidthsEmArray[2]} p_label="Download Latest File" p_title="Icon to manually download the latest .csv file generated by this job." />
              <AutomatedExportsTblHeaderCell p_widthEm={colWidthsEmArray[3]} p_label="Job Name" />
              <AutomatedExportsTblHeaderCell p_widthEm={colWidthsEmArray[4]} p_label="Recurrence" />
              <AutomatedExportsTblHeaderCell p_widthEm={colWidthsEmArray[5]} p_label="Recurrence Count" />
              <AutomatedExportsTblHeaderCell p_widthEm={colWidthsEmArray[6]} p_label="Run Time" />
              <AutomatedExportsTblHeaderCell p_widthEm={colWidthsEmArray[7]} p_label="Capture Table View Button" />
              <AutomatedExportsTblHeaderCell p_widthEm={colWidthsEmArray[8]} p_label="Last Run" />
              <AutomatedExportsTblHeaderCell p_widthEm={colWidthsEmArray[9]} p_label="Created By" />
              <AutomatedExportsTblHeaderCell p_widthEm={colWidthsEmArray[10]} p_label="Date Created" />
              <AutomatedExportsTblHeaderCell p_widthEm={colWidthsEmArray[11]} p_label="History" />
              <AutomatedExportsTblHeaderCell p_widthEm={colWidthsEmArray[12]} p_label="" />
            </div>
            {c_automatedExportsArrayOfObjs.map((m_automatedExportObj) =>
              <AutomatedExportsTblRow
                key={m_automatedExportObj.id}
                p_automatedExportObj={m_automatedExportObj}
                p_colWidthsEmArray={colWidthsEmArray}
                f_onClickEdit={this.onclick_open_edit_automated_export_job_floating_box}
              />
            )}
          </div>
        </div>
        {(s_createNewAutomatedExportJobFloatingBoxIsOpenTF) &&
          <AutomatedExportsCreateNewJobFloatingBox
            f_onClickClose={this.onclick_close_create_new_automated_export_job_floating_box}
          />
        }
        {(JSFUNC.is_number_not_nan_gt_0(s_editingAutomatedExportIDOrUndefined)) &&
          <AutomatedExportsEditJobFloatingBox
            p_editingAutomatedExportID={s_editingAutomatedExportIDOrUndefined}
            f_onClickSave={this.onclick_close_edit_automated_export_job_floating_box}
          />
        }
      </>
    );
  }
}));


function AutomatedExportsTblHeaderCell(props) { //props: p_widthEm, p_label, p_title
  const p_widthEm = props.p_widthEm;
  const p_label = props.p_label;
  const p_title = props.p_title;

  return(
    <div className="flex00a displayFlexColumn bgDarkOrangeGradient" style={{flexBasis:p_widthEm + "em"}} title={p_title}>
      <div className="flex11a displayFlexColumnHcVc borderR1bbb lrPad textCenter">
        <font className="fontBold fontWhite">
          {p_label}
        </font>
      </div>
    </div>
  );
}


const AutomatedExportsTblRow = inject("AdminMobx", "CapturesMobx", "DatabaseMobx")(observer(
class AutomatedExportsTblRow extends Component { //props: p_automatedExportObj, p_colWidthsEmArray, f_onClickEdit
  onswitch_job_on_off = () => {
    const p_automatedExportObj = this.props.p_automatedExportObj;
    const newValue01 = ((p_automatedExportObj.isOnTF) ? (0) : (1));
    this.props.AdminMobx.a_automated_exports_update_single_field(p_automatedExportObj.id, "off0_on1", newValue01);
  }


  onclick_edit_job = () => {
    const p_automatedExportObj = this.props.p_automatedExportObj;
    if(JSFUNC.is_function(this.props.f_onClickEdit)) {
      this.props.f_onClickEdit(p_automatedExportObj.id);
    }
  }

  ondelete_job = () => {
    const p_automatedExportObj = this.props.p_automatedExportObj;
    this.props.AdminMobx.a_automated_exports_delete_job_and_server_files(p_automatedExportObj);
  }

  render() {
    const p_automatedExportObj = this.props.p_automatedExportObj;
    const p_colWidthsEmArray = this.props.p_colWidthsEmArray;

    const automatedExportsRowMenuItemsArrayOfObjs = [
      {
        displayName: "Edit Job",
        functionOnClickMenuItem: this.onclick_edit_job
      },
      {
        displayName: "Delete Job",
        confirmType: "confirmDelete",
        confirmTitle: "Delete Automated Export Job",
        confirmMessage: "Delete Automated Export Job '" + p_automatedExportObj.jobNameValueMaskSortIfoObj.valueMaskPlainText + "'?",
        functionOnClickConfirmButton: this.ondelete_job
      }
    ];

    return(
      <div className="displayFlexRow" style={{height:"3em"}}>
        <div className="flex00a displayFlexColumnHcVc borderL1bbb borderB1bbb" style={{flexBasis:p_colWidthsEmArray[0] + "em"}}>
          <CEGeneralReact.SwitchWithTextAndConfirmBox
            p_isOnTF={p_automatedExportObj.isOnTF}
            p_sizeEm={4}
            p_onColor="22aa22"
            p_offColor="994444"
            f_onSwitch={this.onswitch_job_on_off}
          />
        </div>
        <div className="flex00a displayFlexColumnHcVc borderB1bbb" style={{flexBasis:p_colWidthsEmArray[1] + "em"}}>
          {(p_automatedExportObj.hasRunOnceTF) ? (
            <CEGeneralReact.ButtonCopyToClipboard
              p_clipboardText={p_automatedExportObj.latestFileUrl}
              p_preCopyText="Copy URL"
              p_postCopyText="Copied!"
              p_preCopyClass="bgLightGrayGradient border bevelBorderColors borderRadius10 tbMicroPad lrMedPad"
              p_postCopyClass="bgDarkGrayGradient border bevelBorderDarkColors borderRadius10 tbMicroPad lrMedPad"
              p_styleObj={{width:"6em", height:"1.7em"}}
              p_preCopyFontClass=""
              p_postCopyFontClass="fontBold fontWhite"
              p_title={"Click to copy latest file URL '" + p_automatedExportObj.latestFileUrl + "' to clipboard"}
            />
          ) : (
            this.props.DatabaseMobx.not_filled_out_font_html("--Not Yet Run--")
          )}
        </div>
        <div className="flex00a displayFlexColumnHcVc borderB1bbb" style={{flexBasis:p_colWidthsEmArray[2] + "em"}}>
          <CEComplexReact.SmallDownloadFileButtonForServerFile
            p_fileLocRootUploadsOrWeb="web"
            p_fileLocRelativeFromRoot={p_automatedExportObj.latestFileUrl}
            p_downloadSaveAsFileName={p_automatedExportObj.latestFileNameAndExt}
            p_title={"Click to download '" + p_automatedExportObj.latestFileNameAndExt + "'"}
          />
        </div>
        <AutomatedExportTblRowDataCellNowrap p_dataValueMaskSortIfoObj={p_automatedExportObj.jobNameValueMaskSortIfoObj} p_colWidthEm={p_colWidthsEmArray[3]} />
        <AutomatedExportTblRowDataCellNowrap p_dataValueMaskSortIfoObj={p_automatedExportObj.recurrenceValueMaskSortIfoObj} p_colWidthEm={p_colWidthsEmArray[4]} />
        <AutomatedExportTblRowDataCellNowrap p_dataValueMaskSortIfoObj={p_automatedExportObj.recurrenceCountValueMaskSortIfoObj} p_colWidthEm={p_colWidthsEmArray[5]} />
        <AutomatedExportTblRowDataCellNowrap p_dataValueMaskSortIfoObj={p_automatedExportObj.rumTimeHourValueMaskSortIfoObj} p_colWidthEm={p_colWidthsEmArray[6]} />
        <AutomatedExportTblRowDataCellNowrap p_dataValueMaskSortIfoObj={p_automatedExportObj.captureTableViewButtonPresetValueMaskSortIfoObj} p_colWidthEm={p_colWidthsEmArray[7]} />
        <AutomatedExportTblRowDataCellNowrap p_dataValueMaskSortIfoObj={p_automatedExportObj.lastRunDateTimeEstValueMaskSortIfoObj} p_colWidthEm={p_colWidthsEmArray[8]} />
        <AutomatedExportTblRowDataCellNowrap p_dataValueMaskSortIfoObj={p_automatedExportObj.createdByUserValueMaskSortIfoObj} p_colWidthEm={p_colWidthsEmArray[9]} />
        <AutomatedExportTblRowDataCellNowrap p_dataValueMaskSortIfoObj={p_automatedExportObj.dateCreatedValueMaskSortIfoObj} p_colWidthEm={p_colWidthsEmArray[10]} />
        <div className="flex00a displayFlexColumnHcVc borderB1bbb" style={{flexBasis:p_colWidthsEmArray[11] + "em"}}>

        </div>
        <div className="flex00a displayFlexColumnHcVc borderB1bbb borderR1bbb" style={{flexBasis:p_colWidthsEmArray[12] + "em"}}>
          <CEGeneralReact.VerticalDotsMenu
            p_menuItemsArrayOfObjs={automatedExportsRowMenuItemsArrayOfObjs}
          />
        </div>
      </div>
    );
  }
}));


function AutomatedExportTblRowDataCellNowrap(props) { //props: p_dataValueMaskSortIfoObj, p_colWidthEm
  const p_dataValueMaskSortIfoObj = props.p_dataValueMaskSortIfoObj;
  const p_colWidthEm = props.p_colWidthEm;
  return(
    <div className="flex00a displayFlexRowVc borderB1bbb lrPad" style={{flexBasis:p_colWidthEm + "em"}} title={p_dataValueMaskSortIfoObj.valueMaskPlainText}>
      <LibraryReact.NowrapEllipsis p_fontClass={undefined}>
        {p_dataValueMaskSortIfoObj.valueMask}
      </LibraryReact.NowrapEllipsis>
    </div>
  );
}


const AutomatedExportsCreateNewJobFloatingBox = inject("AdminMobx", "CapturesMobx", "DatabaseMobx")(observer(
class AutomatedExportsCreateNewJobFloatingBox extends Component { //props: f_onClickClose
  constructor(props) {
    super(props);
    this.state = {
      s_jobName: "",
      s_recurrence: 1,
      s_recurrenceCount: 1,
      s_runTimeHourInt: 1,
      s_ceViewButtonID: -1,
      s_createButtonPushedAtLeastOnceTF: false,
      s_creatingNewJobTF: false
    };
  }

  onchange_job_name = (i_newValue) => { this.setState({s_jobName:i_newValue}); }
  onchange_recurrence = (i_newValue) => { this.setState({s_recurrence:i_newValue}); }
  onchange_recurrence_count = (i_newValue) => { this.setState({s_recurrenceCount:i_newValue}); }
  onchange_run_time_hour_int = (i_newValue) => { this.setState({s_runTimeHourInt:i_newValue}); }
  onselect_ce_view_button = (i_selectedViewButtonID) => { this.setState({s_ceViewButtonID:i_selectedViewButtonID}); }
  
  onclick_create_new_automated_export_job = () => {
    const s_jobName = this.state.s_jobName;
    const s_recurrence = this.state.s_recurrence;
    const s_recurrenceCount = this.state.s_recurrenceCount;
    const s_runTimeHourInt = this.state.s_runTimeHourInt;
    const s_ceViewButtonID = this.state.s_ceViewButtonID;

    this.setState({s_createButtonPushedAtLeastOnceTF:true});

    const inputErrorsObj = this.input_errors_obj();
    if(!inputErrorsObj.anyErrorsTF) {
      this.setState({s_creatingNewJobTF:true});

      const functionOnFinish = () => {
        this.setState({s_creatingNewJobTF:false});
        if(JSFUNC.is_function(this.props.f_onClickClose)) {
          this.props.f_onClickClose();
        }
      }
      this.props.AdminMobx.a_automated_exports_insert_new_job(s_jobName, s_recurrence, s_recurrenceCount, s_runTimeHourInt, s_ceViewButtonID, functionOnFinish);
    }
  }

  input_errors_obj = () => {
    const s_jobName = this.state.s_jobName;
    const s_recurrence = this.state.s_recurrence;
    const s_recurrenceCount = this.state.s_recurrenceCount;
    const s_runTimeHourInt = this.state.s_runTimeHourInt;
    const s_ceViewButtonID = this.state.s_ceViewButtonID;
    const s_createButtonPushedAtLeastOnceTF = this.state.s_createButtonPushedAtLeastOnceTF;

    const jobNameErrorTF = (!JSFUNC.string_is_filled_out_tf(s_jobName));
    const recurrenceErrorTF = (!JSFUNC.in_array(s_recurrence, [1, 2, 3]));
    const recurrenceCountErrorTF = (!JSFUNC.is_number_not_nan_gte_0(s_recurrenceCount));
    const runTimeHourErrorTF = (!JSFUNC.is_number_not_nan_gte_0(s_runTimeHourInt));
    const viewButtonErrorTF = (!JSFUNC.select_int_is_filled_out_tf(s_ceViewButtonID));

    const anyErrorsTF = (jobNameErrorTF || recurrenceErrorTF || recurrenceCountErrorTF || runTimeHourErrorTF || viewButtonErrorTF);

    const showJobNameErrorTF = (s_createButtonPushedAtLeastOnceTF && jobNameErrorTF);
    const showRecurrenceErrorTF = (s_createButtonPushedAtLeastOnceTF && recurrenceErrorTF);
    const showRecurrenceCountErrorTF = (s_createButtonPushedAtLeastOnceTF && recurrenceCountErrorTF);
    const showRunTimeHourErrorTF = (s_createButtonPushedAtLeastOnceTF && runTimeHourErrorTF);
    const showViewButtonErrorTF = (s_createButtonPushedAtLeastOnceTF && viewButtonErrorTF);

    return({
      anyErrorsTF: anyErrorsTF,
      jobNameErrorTF: jobNameErrorTF,
      recurrenceErrorTF: recurrenceErrorTF,
      recurrenceCountErrorTF: recurrenceCountErrorTF,
      runTimeHourErrorTF: runTimeHourErrorTF,
      viewButtonErrorTF: viewButtonErrorTF,
      showJobNameErrorTF: showJobNameErrorTF,
      showRecurrenceErrorTF: showRecurrenceErrorTF,
      showRecurrenceCountErrorTF: showRecurrenceCountErrorTF,
      showRunTimeHourErrorTF: showRunTimeHourErrorTF,
      showViewButtonErrorTF: showViewButtonErrorTF,
      jobNameErrorMessageOrUndefined: ((showJobNameErrorTF) ? ("Job Name must be filled out") : (undefined)),
      recurrenceErrorMessageOrUndefined: ((showRecurrenceErrorTF) ? ("Recurrence must be selected") : (undefined)),
      recurrenceCountErrorMessageOrUndefined: ((showRecurrenceCountErrorTF) ? ("Must be filled out") : (undefined)),
      runTimeHourErrorMessageOrUndefined: ((showRunTimeHourErrorTF) ? ("Run Time must be filled out") : (undefined)),
      viewButtonErrorMessageOrUndefined: ((showViewButtonErrorTF) ? ("A Capture Table View Button must be selected") : (undefined))
    });
  }

  render() {
    const s_jobName = this.state.s_jobName;
    const s_recurrence = this.state.s_recurrence;
    const s_recurrenceCount = this.state.s_recurrenceCount;
    const s_runTimeHourInt = this.state.s_runTimeHourInt;
    const s_ceViewButtonID = this.state.s_ceViewButtonID;
    const s_createButtonPushedAtLeastOnceTF = this.state.s_createButtonPushedAtLeastOnceTF;
    const s_creatingNewJobTF = this.state.s_creatingNewJobTF;

    const c_automatedExportsSelectRecurrenceFieldTypeObj = this.props.AdminMobx.c_automatedExportsSelectRecurrenceFieldTypeObj;
    const c_selectMyAndPublicCaptureTableViewButtonPresetsFieldTypeObj = this.props.CapturesMobx.c_selectMyAndPublicCaptureTableViewButtonPresetsFieldTypeObj;
    const c_selectDayOfTheWeekFieldTypeObj = this.props.DatabaseMobx.c_selectDayOfTheWeekFieldTypeObj;
    const c_selectDateOfTheMonth1stTo31stFieldTypeObj = this.props.DatabaseMobx.c_selectDateOfTheMonth1stTo31stFieldTypeObj;
    const c_selectTimeHour1to12AmPmFieldTypeObj = this.props.DatabaseMobx.c_selectTimeHour1to12AmPmFieldTypeObj;

    const inputErrorsObj = this.input_errors_obj();

    var recurrenceCountLabel = "";
    var recurrenceCountContainerMaxWidthEm = 10;
    var recurrenceCountInputComponent = null;
    if(s_recurrence === 1) { //daily
      recurrenceCountLabel = "(Daily) Run Every 'X' Days";
      recurrenceCountContainerMaxWidthEm = 6;
      recurrenceCountInputComponent = (
        <LibraryReact.Text
          p_value={s_recurrenceCount}
          p_styleObj={{width:"6em"}}
          p_errorTF={inputErrorsObj.showRecurrenceCountErrorTF}
          p_tabIndex={3}
          p_title={undefined}
          f_onChange={this.onchange_recurrence_count}
        />
      );
    }
    else if(s_recurrence === 2) { //weekly
      recurrenceCountLabel = "(Weekly) Run on Selected Day";
      recurrenceCountContainerMaxWidthEm = 9;
      recurrenceCountInputComponent = (
        <CEGeneralReact.GenericInputOrSelectFromInputType
          p_fieldTypeObj={c_selectDayOfTheWeekFieldTypeObj}
          p_valueRaw={s_recurrenceCount}
          p_tabIndex={3}
          p_title={undefined}
          p_errorTF={inputErrorsObj.showRecurrenceCountErrorTF}
          f_onChangeOrOnSelect={this.onchange_recurrence_count}
        />
      );
    }
    else if(s_recurrence === 3) { //monthly
      recurrenceCountLabel = "(Monthly) Run on Selected Date";
      recurrenceCountContainerMaxWidthEm = 6;
      recurrenceCountInputComponent = (
        <CEGeneralReact.GenericInputOrSelectFromInputType
          p_fieldTypeObj={c_selectDateOfTheMonth1stTo31stFieldTypeObj}
          p_valueRaw={s_recurrenceCount}
          p_tabIndex={3}
          p_title={undefined}
          p_errorTF={inputErrorsObj.showRecurrenceCountErrorTF}
          f_onChangeOrOnSelect={this.onchange_recurrence_count}
        />
      );
    }

    return(
      <CEGeneralReact.FloatingBoxWithSaveCancel
        p_trblFlag="smallVertical"
        p_title="Creating New Automated Export Job"
        f_onClickCancel={this.props.f_onClickClose}>
        <div className="flex11a displayFlexColumn medFullPad yScroll">
          <NewJobFieldShell p_label="Job Name" p_errorMessage={inputErrorsObj.jobNameErrorMessageOrUndefined}>
            <LibraryReact.Text
              p_value={s_jobName}
              p_tabIndex={1}
              p_title={undefined}
              p_errorTF={inputErrorsObj.showJobNameErrorTF}
              f_onChange={this.onchange_job_name}
            />
          </NewJobFieldShell>
          <NewJobFieldShell p_label="Recurrence" p_errorMessage={inputErrorsObj.recurrenceErrorMessageOrUndefined}>
            <div style={{maxWidth:"7em"}}>
              <CEGeneralReact.GenericInputOrSelectFromInputType
                p_fieldTypeObj={c_automatedExportsSelectRecurrenceFieldTypeObj}
                p_valueRaw={s_recurrence}
                p_tabIndex={2}
                p_title={undefined}
                p_errorTF={inputErrorsObj.showRecurrenceErrorTF}
                f_onChangeOrOnSelect={this.onchange_recurrence}
              />
            </div>
          </NewJobFieldShell>
          <NewJobFieldShell p_label={recurrenceCountLabel} p_errorMessage={inputErrorsObj.recurrenceCountErrorMessageOrUndefined}>
            <div style={{maxWidth:recurrenceCountContainerMaxWidthEm + "em"}}>
              {recurrenceCountInputComponent}
            </div>
          </NewJobFieldShell>
          <NewJobFieldShell p_label="Run at Selected Time (EST)" p_errorMessage={inputErrorsObj.runTimeHourErrorMessageOrUndefined}>
            <div style={{maxWidth:"6em"}}>
              <CEGeneralReact.GenericInputOrSelectFromInputType
                p_fieldTypeObj={c_selectTimeHour1to12AmPmFieldTypeObj}
                p_valueRaw={s_runTimeHourInt}
                p_tabIndex={4}
                p_title={undefined}
                p_errorTF={inputErrorsObj.showRunTimeHourErrorTF}
                f_onChangeOrOnSelect={this.onchange_run_time_hour_int}
              />
            </div>
          </NewJobFieldShell>
          <NewJobFieldShell p_label="Capture Table Columns/Filter/Sort 'View Button'" p_errorMessage={inputErrorsObj.viewButtonErrorMessageOrUndefined}>
            <CEGeneralReact.GenericInputOrSelectFromInputType
              p_fieldTypeObj={c_selectMyAndPublicCaptureTableViewButtonPresetsFieldTypeObj}
              p_valueRaw={s_ceViewButtonID}
              p_tabIndex={5}
              p_title={undefined}
              p_errorTF={inputErrorsObj.showViewButtonErrorTF}
              f_onChangeOrOnSelect={this.onselect_ce_view_button}
            />
          </NewJobFieldShell>
        </div>
        <div className="flex00a displayFlexColumnHcVc flexWrap borderT1bbb tbMedPad">
          {(s_creatingNewJobTF) ? (
            <>
              <CEGeneralReact.LoadingAnimation />
              <div className="microTopMargin">
                <font className="fontItalic fontTextLight">
                  {"Creating new Automated Export job..."}
                </font>
              </div>
            </>
          ) : (
            <div className="flex00a displayFlexRowHcVc">
              <div className="flex00a lrMedMargin">
                <CEGeneralReact.CEButton
                  p_type={((s_createButtonPushedAtLeastOnceTF && inputErrorsObj.anyErrorsTF) ? ("blueDisabled") : ("blue"))}
                  p_text="Create New Job"
                  f_onClick={this.onclick_create_new_automated_export_job}
                />
              </div>
              <div className="flex00a lrMedMargin">
                <CEGeneralReact.CEButton
                  p_type="gray"
                  p_text="Cancel"
                  f_onClick={this.props.f_onClickClose}
                />
              </div>
            </div>
          )}
        </div>
      </CEGeneralReact.FloatingBoxWithSaveCancel>
    );
  }
}));

function NewJobFieldShell(props) { //props: p_label, p_errorMessage, children
  const p_label = props.p_label;
  const p_errorMessage = props.p_errorMessage;

  const errorTF = JSFUNC.string_is_filled_out_tf(p_errorMessage);

  return(
    <div className="displayFlexRow medBottomMargin">
      <div className="flex00a displayFlexRowVc" style={{flexBasis:"15em", marginRight:"0.4em"}}>
        <font className="fontBlue">
          {p_label}
        </font>
      </div>
      <div className="flex11a displayFlexColumnVc">
        {props.children}
        {(errorTF) &&
          <CEGeneralReact.ErrorText
            p_class="microTopMargin"
            p_text={p_errorMessage}
          />
        }
      </div>
    </div>
  );
}


const AutomatedExportsEditJobFloatingBox = inject("AdminMobx", "CapturesMobx", "DatabaseMobx")(observer(
class AutomatedExportsEditJobFloatingBox extends Component { //props: p_editingAutomatedExportID, f_onClickSave
  onsave_job_name = (i_newValue) => { this.props.AdminMobx.a_automated_exports_update_single_field(this.props.p_editingAutomatedExportID, "job_name", i_newValue, "s"); }
  onsave_recurrence = (i_newValue) => { this.props.AdminMobx.a_automated_exports_update_single_field(this.props.p_editingAutomatedExportID, "recurrence_type_123", i_newValue, "i"); }
  onsave_recurrence_count = (i_newValue) => { this.props.AdminMobx.a_automated_exports_update_single_field(this.props.p_editingAutomatedExportID, "recurrence_count", i_newValue, "i"); }
  onsave_run_time_hour = (i_newValue) => { this.props.AdminMobx.a_automated_exports_update_single_field(this.props.p_editingAutomatedExportID, "run_time_hour_0to23", i_newValue, "i"); }
  onsave_capture_table_view_button = (i_newValue) => { this.props.AdminMobx.a_automated_exports_update_single_field(this.props.p_editingAutomatedExportID, "capture_table_view_button_preset_id", i_newValue, "i"); }

  render() {
    const p_editingAutomatedExportID = this.props.p_editingAutomatedExportID;

    const c_automatedExportsArrayOfObjs = this.props.AdminMobx.c_automatedExportsArrayOfObjs;
    const c_automatedExportsSelectRecurrenceFieldTypeObj = this.props.AdminMobx.c_automatedExportsSelectRecurrenceFieldTypeObj;
    const c_selectMyAndPublicCaptureTableViewButtonPresetsFieldTypeObj = this.props.CapturesMobx.c_selectMyAndPublicCaptureTableViewButtonPresetsFieldTypeObj;
    const c_genericTextFieldTypeObj = this.props.DatabaseMobx.c_genericTextFieldTypeObj;
    const c_genericIntPositiveFieldTypeObj = this.props.DatabaseMobx.c_genericIntPositiveFieldTypeObj;
    const c_selectDayOfTheWeekFieldTypeObj = this.props.DatabaseMobx.c_selectDayOfTheWeekFieldTypeObj;
    const c_selectDateOfTheMonth1stTo31stFieldTypeObj = this.props.DatabaseMobx.c_selectDateOfTheMonth1stTo31stFieldTypeObj;
    const c_selectTimeHour1to12AmPmFieldTypeObj = this.props.DatabaseMobx.c_selectTimeHour1to12AmPmFieldTypeObj;

    const automatedExportObj = JSFUNC.get_first_obj_from_arrayOfObjs_matching_field_value(c_automatedExportsArrayOfObjs, "id", p_editingAutomatedExportID);

    if(automatedExportObj === undefined) {
      return(null);
    }

    const containerClass = "smallBottomMargin";
    const fieldClass = "fontBlue";
    const fieldWidth = "10em";

    var recurrenceCountLabel = "";
    var recurrenceCountFieldTypeObj = undefined;
    if(automatedExportObj.recurrence_type_123 === 1) { //daily
      recurrenceCountLabel = "(Daily) Run Every 'X' Days";
      recurrenceCountFieldTypeObj = c_genericIntPositiveFieldTypeObj;
    }
    else if(automatedExportObj.recurrence_type_123 === 2) { //weekly
      recurrenceCountLabel = "(Weekly) Run on Selected Day";
      recurrenceCountFieldTypeObj = c_selectDayOfTheWeekFieldTypeObj;
    }
    else if(automatedExportObj.recurrence_type_123 === 3) { //monthly
      recurrenceCountLabel = "(Monthly) Run on Selected Date";
      recurrenceCountFieldTypeObj = c_selectDateOfTheMonth1stTo31stFieldTypeObj;
    }

    return(
      <CEGeneralReact.FloatingBoxWithSaveCancel
        p_trblFlag="smallVertical"
        p_title="Editing Automated Export Job"
        f_onClickSave={this.props.f_onClickSave}>
        <div className="flex11a displayFlexColumn medFullPad yScroll">
          <div className="microBottomMargin textCenter">
            <font className="font11">
              {"Latest File URL"}
            </font>
          </div>
          <div className="bigBottomMargin textCenter">
            <font className="fontItalic">
              {automatedExportObj.latestFileUrl}
            </font>
          </div>
          <CEGeneralReact.CaptureExecFieldEditSaveCancel
            p_ceEditItemString="automatedExportsEditJobName"
            p_fieldDisplayName="Job Name"
            p_fieldTypeObj={c_genericTextFieldTypeObj}
            p_valueRaw={automatedExportObj.job_name}
            p_valueIsEditableTFU={true}
            p_containerClass={containerClass}
            p_fieldClass={fieldClass}
            p_fieldWidth={fieldWidth}
            f_onSaveChanged={this.onsave_job_name}
          />
          <CEGeneralReact.CaptureExecFieldEditSaveCancel
            p_ceEditItemString="automatedExportsEditRecurrence"
            p_fieldDisplayName="Recurrence"
            p_fieldTypeObj={c_automatedExportsSelectRecurrenceFieldTypeObj}
            p_valueRaw={automatedExportObj.recurrence_type_123}
            p_valueIsEditableTFU={true}
            p_containerClass={containerClass}
            p_fieldClass={fieldClass}
            p_fieldWidth={fieldWidth}
            f_onSaveChanged={this.onsave_recurrence}
          />
          <CEGeneralReact.CaptureExecFieldEditSaveCancel
            p_ceEditItemString="automatedExportsEditRecurrenceCount"
            p_fieldDisplayName={recurrenceCountLabel}
            p_fieldTypeObj={recurrenceCountFieldTypeObj}
            p_valueRaw={automatedExportObj.recurrence_count}
            p_valueIsEditableTFU={true}
            p_containerClass={containerClass}
            p_fieldClass={fieldClass}
            p_fieldWidth={fieldWidth}
            f_onSaveChanged={this.onsave_recurrence_count}
          />
          <CEGeneralReact.CaptureExecFieldEditSaveCancel
            p_ceEditItemString="automatedExportsEditRunTime"
            p_fieldDisplayName="Run Time"
            p_fieldTypeObj={c_selectTimeHour1to12AmPmFieldTypeObj}
            p_valueRaw={automatedExportObj.run_time_hour_0to23}
            p_valueIsEditableTFU={true}
            p_containerClass={containerClass}
            p_fieldClass={fieldClass}
            p_fieldWidth={fieldWidth}
            f_onSaveChanged={this.onsave_run_time_hour}
          />
          <CEGeneralReact.CaptureExecFieldEditSaveCancel
            p_ceEditItemString="automatedExportsEditViewButton"
            p_fieldDisplayName="Capture Table View Button"
            p_fieldTypeObj={c_selectMyAndPublicCaptureTableViewButtonPresetsFieldTypeObj}
            p_valueRaw={automatedExportObj.capture_table_view_button_preset_id}
            p_valueIsEditableTFU={true}
            p_containerClass={containerClass}
            p_fieldClass={fieldClass}
            p_fieldWidth={fieldWidth}
            f_onSaveChanged={this.onsave_capture_table_view_button}
          />
        </div>
      </CEGeneralReact.FloatingBoxWithSaveCancel>
    );
  }
}));
*/




//=================================================================================================================================================================
//=================================================================================================================================================================



export const AdminSubtabExcelReportTemplates = inject("CaptureExecMobx", "AdminMobx", "DatabaseMobx")(observer(
class AdminSubtabExcelReportTemplates extends Component { //props: none
  constructor(props) {
    super(props);
    this.state = {
      s_selectedExcelReportTemplateID: -1,
      s_showErrorsTF: false
    }
  }

  onselect_template = (i_templateID) => {
    this.setState({s_selectedExcelReportTemplateID:i_templateID});
  }

  onclick_generate_button_set_show_errors = () => {
    this.setState({s_showErrorsTF:true});
  }

  render() {
    const s_selectedExcelReportTemplateID = this.state.s_selectedExcelReportTemplateID;
    const s_showErrorsTF = this.state.s_showErrorsTF;

    const templateValidTF = JSFUNC.select_int_is_filled_out_tf(s_selectedExcelReportTemplateID);

    return (
      <div className="flex11a displayFlexColumn">
        <CEComplexReact.FileFolderSystem
          p_tblName="tbl_a_excel_report_templates_filefoldersystem"
          p_tblMapOfMaps={this.props.DatabaseMobx.o_tbl_a_excel_report_templates_filefoldersystem}
          p_tblFilterValuesObj={undefined}
          p_title={undefined}
          p_defaultXmlType="excel"
          p_allowedExtsArray={["xml"]}
          p_disableUploadFilesTF={false}
          p_disableCreateOnlineLinkDocsTF={true}
          p_disableCreateFoldersTF={false}
          p_viewWideTrueNarrowFalse={(this.props.CaptureExecMobx.o_mediaQueryFlag >= 4)}
          p_navigateToFolderID={undefined}
          f_onPerformFFSAction={undefined}
          f_onNavigateToFolder={undefined}
        />
        <div className="flex00a displayFlexRow" style={{padding:"1em 0", background:"#aca", borderTop:"solid 2px #585"}}>
          <div className="flex00a displayFlexColumnHcVc lrMedPad" style={{borderRight:"solid 1px #585"}}>
            <ViewAllTemplateCodewordsButtonWithFloatingBox p_excelReportsTF={true} />
          </div>
          <div className="flex11a displayFlexRowVc flexWrap">
            <div className="flex00a tbMicroPad lrMedPad" style={{flexBasis:"25em"}}>
              <div className="microBottomMargin textCenter">
                <font className="fontItalic fontTextLight">
                  {"Select an Excel Report Template to test"}
                </font>
              </div>
              <CEGeneralReact.GenericInputOrSelectFromInputType
                p_fieldTypeObj={this.props.AdminMobx.c_adminSelectExcelReportTemplateFFSFieldTypeObj}
                p_valueRaw={s_selectedExcelReportTemplateID}
                p_errorTF={(s_showErrorsTF && !templateValidTF)}
                f_onChangeOrOnSelect={this.onselect_template}
              />
            </div>
            <div className="flex00a tbMicroPad lrMedPad" style={{flexBasis:"20em"}}>
              <CEComplexReact.GenerateAndDownloadExcelReportButtonProcess
                p_excelReportTemplateID={s_selectedExcelReportTemplateID}
                p_buttonText="Generate/Download Test Excel Report"
                p_canClickButtonTF={templateValidTF}
                f_onClick={this.onclick_generate_button_set_show_errors}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}));





//=================================================================================================================================================================
//=================================================================================================================================================================



export const AdminSubtabSystem = inject("CaptureExecMobx", "AdminMobx", "DatabaseMobx")(observer(
class AdminSubtabSystem extends Component { //props: none
  onsave_fyr_start_month = (i_newValueInt) => {
    this.props.AdminMobx.a_update_tbl_a_company_fields("fyr_start_month", i_newValueInt, "i");
  }

  onsave_date_format = (i_newValue) => {
    this.props.AdminMobx.a_update_tbl_a_company_fields("date_format", i_newValue, "s");
  }

  onsave_capture_name_format = (i_newValue) => {
    this.props.AdminMobx.a_update_tbl_a_company_fields("capture_name_format", i_newValue, "s");
  }

  onsave_my_performance_all_users_ignore_shared_percent_calcs = (i_newValue) => {
    this.props.AdminMobx.a_update_tbl_a_company_fields("performance_graphs_all_users_ignore_shared_percent_calcs_01", i_newValue, "i");
  }

  render() {
    const c_productStylingObj = this.props.CaptureExecMobx.c_productStylingObj;
    const c_companyDateFormat = this.props.DatabaseMobx.c_companyDateFormat;
    const c_companyFyrMonthsAndQuartersInfoObj = this.props.DatabaseMobx.c_companyFyrMonthsAndQuartersInfoObj;
    const c_companyCaptureNameFormat = this.props.DatabaseMobx.c_companyCaptureNameFormat;
    const c_companyPerformanceGraphsAllUsersIgnoreSharedPercentCalcs01 = this.props.DatabaseMobx.c_companyPerformanceGraphsAllUsersIgnoreSharedPercentCalcs01;
    const c_fieldMapOfCaptureManagers = this.props.DatabaseMobx.c_fieldMapOfCaptureManagers;
    const c_fieldMapOfDivisionOwners = this.props.DatabaseMobx.c_fieldMapOfDivisionOwners;
    const c_selectMonth1to12FieldTypeObj = this.props.DatabaseMobx.c_selectMonth1to12FieldTypeObj;
    
    const dateFormatsArray = ["m/d/Y", "d/m/Y", "Y-m-d", "M j, Y"];
    const dateFormatsForSelectArray = ["m/d/Y", "d/m/Y", "Y-m-d", "M d, Y"];
    var dateSelectDisplaysArray = [];
    for(let d = 0; d < dateFormatsArray.length; d++) {
      var todayJsDateObj = new Date();
      var todayDateFormatted = JSFUNC.date_or_datetime_format_from_jsdateobj(todayJsDateObj, dateFormatsArray[d], "", false);
      dateSelectDisplaysArray.push(dateFormatsForSelectArray[d] + '  "' + todayDateFormatted + '"');
    }
    const dateFormatSwsOptionsObj = undefined;
    const dateFormatSwsDataObj = this.props.DatabaseMobx.create_sws_data_obj_from_value_array_and_display_array("Date Format", dateFormatsArray, true, dateSelectDisplaysArray, dateFormatSwsOptionsObj);
    const dateFormatFieldTypeObj = this.props.DatabaseMobx.create_field_type_obj("select", dateFormatSwsDataObj);

    const captureNameFormatsArray = [
      "cn(opp)|cn|opp|id", "opp(cn)|opp|cn|id", "cn|opp|id", "opp|cn|id", "cn|id", "opp|id", "id",
      "[id]cn(opp)|[id]cn|[id]opp|[id]", "[id]opp(cn)|[id]opp|[id]cn|[id]", "[id]cn|[id]opp|[id]", "[id]opp|[id]cn|[id]", "[id]cn|[id]", "[id]opp|[id]"
    ];
    const captureNameSelectDisplaysArray = [
      "Codename (Opportunity Name) | Codename | Opportunity Name | [ID]",
      "Opportunity Name (Codename) | Opportunity Name | Codename | [ID]",
      "Codename | Opportunity Name | [ID]",
      "Opportunity Name | Codename | [ID]",
      "Codename | [ID]",
      "Opportunity Name | [ID]",
      "[ID]",
      "[ID] Codename (Opportunity Name) | [ID] Codename | [ID] Opportunity Name",
      "[ID] Opportunity Name (Codename) | [ID] Opportunity Name | [ID] Codename",
      "[ID] Codename | [ID] Opportunity Name",
      "[ID] Opportunity Name | [ID] Codename",
      "[ID] Codename",
      "[ID] Opportunity Name"
    ];
    const captureNameFormatSwsOptionsObj = undefined;
    const captureNameFormatSwsDataObj = this.props.DatabaseMobx.create_sws_data_obj_from_value_array_and_display_array("Capture Name Format", captureNameFormatsArray, true, captureNameSelectDisplaysArray, captureNameFormatSwsOptionsObj);
    const captureNameFormatFieldTypeObj = this.props.DatabaseMobx.create_field_type_obj("select", captureNameFormatSwsDataObj);

    const mySummariesSharedOwnershipOptionsDisplayArray = ["[default] All 'Performance' calculations are proportional to percent ownership per Capture", "All 'Performance' calculations use whole Capture counts and dollars, regardless of percent ownership"];
    const myPerformanceAllUsersIgnoreSharedPercentCalcsFieldTypeObj = this.props.DatabaseMobx.create_verticalswitch_field_type_obj_from_value_array_and_display_array("Performance Shared Ownership Option", [0, 1], false, mySummariesSharedOwnershipOptionsDisplayArray, 3);

    const containerClass = "tbMargin";
    const fieldClass = "font11 fontBlue";
    const fieldWidth = "18em";
    const valueClass = "font11";

    return(
      <div className="flex11a xyScroll yScrollBottomPad medFullPad">
        <div className="medFullPad border1bbb" style={{width:"65em"}}>
          <div className="">
            <font className="font14 fontItalic fontTextLight">
              {c_productStylingObj.productName + " System Options"}
            </font>
          </div>
          <SystemSectionTitle p_text="Dates" />
          <div style={{width:"40em"}}>
            <CEGeneralReact.CaptureExecFieldEditSaveCancel
              p_ceEditItemString="adminSystemFYRStartMonth"
              p_fieldDisplayName="Fiscal Year (FYR) Start Month"
              p_fieldTypeObj={c_selectMonth1to12FieldTypeObj}
              p_valueRaw={c_companyFyrMonthsAndQuartersInfoObj.companyFyrStartMonth1to12}
              p_valueIsEditableTFU={true}
              p_containerClass={containerClass}
              p_fieldClass={fieldClass}
              p_fieldWidth={fieldWidth}
              p_valueClass={valueClass}
              f_onSaveChanged={this.onsave_fyr_start_month}
            />
          </div>
          <div style={{width:"40em"}}>
            <CEGeneralReact.CaptureExecFieldEditSaveCancel
              p_ceEditItemString="adminSystemDateFormat"
              p_fieldDisplayName="Date Format"
              p_fieldTypeObj={dateFormatFieldTypeObj}
              p_valueRaw={c_companyDateFormat}
              p_valueIsEditableTFU={true}
              p_containerClass={containerClass}
              p_fieldClass={fieldClass}
              p_fieldWidth={fieldWidth}
              p_valueClass={valueClass}
              f_onSaveChanged={this.onsave_date_format}
            />
          </div>
          <SystemSectionTitle p_text="Captures" />
          <CEGeneralReact.CaptureExecFieldEditSaveCancel
            p_ceEditItemString="adminSystemCaptureNameFormat"
            p_fieldDisplayName="Capture Name Format"
            p_fieldTypeObj={captureNameFormatFieldTypeObj}
            p_valueRaw={c_companyCaptureNameFormat}
            p_valueIsEditableTFU={true}
            p_containerClass={containerClass}
            p_fieldClass={fieldClass}
            p_fieldWidth={fieldWidth}
            p_valueClass={valueClass}
            f_onSaveChanged={this.onsave_capture_name_format}
          />
          <SystemSectionTitle p_text="Executive Management/My Summaries - 'Performance' Tab Calculations" />
          <CEGeneralReact.CaptureExecFieldEditSaveCancel
            p_ceEditItemString="adminSystemMyPerformanceAllUsrsIgnoreSharedPercentCalcs"
            p_fieldDisplayName={"Shared Ownership Calculations (" + c_fieldMapOfCaptureManagers.get("display_name") + ", " + c_fieldMapOfDivisionOwners.get("display_name") + ")"}
            p_fieldTypeObj={myPerformanceAllUsersIgnoreSharedPercentCalcsFieldTypeObj}
            p_valueRaw={c_companyPerformanceGraphsAllUsersIgnoreSharedPercentCalcs01}
            p_valueIsEditableTFU={true}
            p_containerClass={containerClass}
            p_fieldClass={fieldClass}
            p_fieldWidth={fieldWidth}
            p_valueClass={valueClass}
            f_onSaveChanged={this.onsave_my_performance_all_users_ignore_shared_percent_calcs}
          />
        </div>
        <div style={{marginTop:"4em"}} />
        <VerifyCompanyDomainForCEEmails />
      </div>
    );
  }
}));

function SystemSectionTitle(props) { //props: p_text
  const p_text = props.p_text;
  return(
    <div className="microBottomMargin borderB1ddd microBottomPad" style={{marginTop:"1.8em"}}>
      <font className="font12 fontBold fontTextLighter">
        {p_text}
      </font>
    </div>
  );
}

const VerifyCompanyDomainForCEEmails = inject("CaptureExecMobx", "DatabaseMobx")(observer(
class VerifyCompanyDomainForCEEmails extends Component { //props: none
  render() {
    const c_productStylingObj = this.props.CaptureExecMobx.c_productStylingObj;
    const c_bitCompanyDomainsDotExtsArray = this.props.DatabaseMobx.c_bitCompanyDomainsDotExtsArray;

    return(
      <div className="medFullPad border1bbb" style={{width:"65em"}}>
        <LibraryReact.DivFont p_class="smallBottomMargin" p_fontClass="font14 fontItalic fontTextLight">
          {"Verify Company Domain(s) for Automated Emails"}
        </LibraryReact.DivFont>
        <LibraryReact.DivFont p_class="smallBottomMargin" p_fontClass="fontItalic fontTextLighter">
          {c_productStylingObj.productName + " can send automated emails out to external recipients using the Teammate Survey system within each Capture. If a " + c_productStylingObj.productName + " User in the system has an email address that matches one of the domains listed below for your company, these emails will be sent from their email address, which the recipients can directly reply to."}
        </LibraryReact.DivFont>
        <div className="smallBottomMargin">
          <font className="fontItalic fontTextLighter">
            {"If you need to modify or add to this list for your company, please email "}
          </font>
          {this.props.DatabaseMobx.value_mask_from_value_raw_and_field_type_obj("support@bitsolutionsllc.com", this.props.DatabaseMobx.c_genericEmailFieldTypeObj)}
          <font className="fontItalic fontTextLighter">
            {". Please note that only company domains can be used, thus 'gmail.com' or 'yahoo.com' are not valid. If a " + c_productStylingObj.productName + " User has one of these invalid email addresses, their emails will be sent from the generic '" + c_productStylingObj.productAutomatedEmailFromEmailAddress + "'."}
          </font>
        </div>
        <div className="medBottomMargin" />
        {c_bitCompanyDomainsDotExtsArray.map((m_companyDomainDotExt, m_index) =>
          <div
            key={m_index}
            className="smallTopMargin border1ddd borderRadius05 bgLightestBlue tbPad lrMedPad"
            style={{width:"30em"}}>
            <font className="">
              {"@" + m_companyDomainDotExt}
            </font>
          </div>
        )}
      </div>
    );
  }
}));





//=================================================================================================================================================================
//=================================================================================================================================================================



export const AdminSubtabShortcutPresets = inject("AdminMobx", "DatabaseMobx")(observer(
class AdminSubtabShortcutPresets extends Component { //props: none
  onclick_shortcut_presets_tab = (i_selectedTabDbName) => {
    this.props.AdminMobx.a_shortcut_presets_set_selected_subtab_db_name(i_selectedTabDbName);
  }

  onsave_shortcut_presets_capture_managers_on_cnc = (i_newValueInt) => {
    this.props.AdminMobx.a_update_tbl_a_company_fields("shortcut_presets_capture_managers_on_cnc_01", i_newValueInt, "i");
  }

  onsave_shortcut_presets_documents_card_folders_on_cnc = (i_newValueInt) => {
    this.props.AdminMobx.a_update_tbl_a_company_fields("shortcut_presets_documents_card_folders_on_cnc_01", i_newValueInt, "i");
  }

  onconfirm_create_new_documents_card_folders_shortcut_preset = (i_newPresetName) => {
    this.props.AdminMobx.a_shortcut_presets_documents_create_new_preset(i_newPresetName);
  }

  onclick_close_editing_preset = () => {
    this.props.AdminMobx.a_shortcut_presets_set_documents_card_folders_editing_preset_id_or_undefined(undefined);
  }

  render() {
    const o_shortcutPresetsSelectedSubtabDbName = this.props.AdminMobx.o_shortcutPresetsSelectedSubtabDbName;
    const o_shortcutPresetsDocumentsCardFoldersEditingPresetIDOrUndefined = this.props.AdminMobx.o_shortcutPresetsDocumentsCardFoldersEditingPresetIDOrUndefined;
    const c_shortcutPresetsCaptureManagersArrayOfObjs = this.props.AdminMobx.c_shortcutPresetsCaptureManagersArrayOfObjs;
    const c_shortcutPresetsDocumentsCardFoldersPresetsArrayOfObjs = this.props.AdminMobx.c_shortcutPresetsDocumentsCardFoldersPresetsArrayOfObjs;
    const c_shortcutPresetsDocumentsCardFoldersEditingPresetObj = this.props.AdminMobx.c_shortcutPresetsDocumentsCardFoldersEditingPresetObj;
    const o_tbl_a_shortcut_presets_documents_card_folders_filefoldersystem = this.props.DatabaseMobx.o_tbl_a_shortcut_presets_documents_card_folders_filefoldersystem;
    const c_companyShortcutPresetsCaptureManagersOnCreateNewCapture01 = this.props.DatabaseMobx.c_companyShortcutPresetsCaptureManagersOnCreateNewCapture01;
    const c_companyShortcutPresetsCaptureManagersOnCreateNewCaptureTF = this.props.DatabaseMobx.c_companyShortcutPresetsCaptureManagersOnCreateNewCaptureTF;
    const c_companyShortcutPresetsDocumentsCardFoldersOnCreateNewCapture01 = this.props.DatabaseMobx.c_companyShortcutPresetsDocumentsCardFoldersOnCreateNewCapture01;
    const c_companyShortcutPresetsDocumentsCardFoldersOnCreateNewCaptureTF = this.props.DatabaseMobx.c_companyShortcutPresetsDocumentsCardFoldersOnCreateNewCaptureTF;
    const c_cardNameDocuments = this.props.DatabaseMobx.c_cardNameDocuments;
    const c_fieldMapOfCaptureManagers = this.props.DatabaseMobx.c_fieldMapOfCaptureManagers;

    const captureManagersFieldDisplayName = c_fieldMapOfCaptureManagers.get("display_name");
    const captureManagersFieldTypeObj = c_fieldMapOfCaptureManagers.get("fieldTypeObj");

    var shortcutPresetsContentComponent = null;
    if(o_shortcutPresetsSelectedSubtabDbName === "captureTeam") {
      const captureManagersOffMessage = "[default] Turned off, always manually choose Capture Manager(s) when creating a new Capture";
      const captureManagersOnMessage = "On, you can either select one of the presets in the table below, or manually fill out the " + captureManagersFieldDisplayName + " field";
      const shortCutPresetsCaptureManagersOnCreateNewCaptureFieldTypeObj = this.props.DatabaseMobx.create_verticalswitch_field_type_obj_from_value_array_and_display_array("Capture Manager Shortcut Preset Option", [0, 1], false, [captureManagersOffMessage, captureManagersOnMessage], 2);

      const shortcutPresetsCaptureManagersAedTableObj = {
        tblName: "tbl_a_shortcut_presets_capture_managers",
        dragToResortFieldDbName: "sort",
        initialSortedFieldDbName: "sort",
        tableWidth: "80em",
        itemName: captureManagersFieldDisplayName + " Shortcut Preset",
        deleteItemNameFieldDbName: "preset_name",
        fieldsArrayOfObjs: [
          {width:"100em", dbName:"preset_name", displayName:"Preset Name", fieldTypeObj:this.props.DatabaseMobx.c_genericTextFieldTypeObj, initialValue:"", cellHoverTF:true, requiredNotEmptyTF:true},
          {width:"250em", dbName:"user_ids_colon_percents_comma", displayName:"Preset " + captureManagersFieldDisplayName, fieldTypeObj:captureManagersFieldTypeObj, initialValue:"", cellHoverTF:true},
          {width:"3em", dbName:"sort", displayName:"Sort", fieldTypeObj:this.props.DatabaseMobx.c_genericIntPositiveFieldTypeObj, initialValue:1}
        ]
      };

      shortcutPresetsContentComponent = (
        <div className="flex11a xyScroll medFullPad">
          <div className="microBottomMargin">
            <font className="font11 fontItalic fontTextLight">
              {"Optional 'Shortcut Presets' for filling out " + captureManagersFieldDisplayName + " when creating a new Capture from the 'Captures' tab"}
            </font>
          </div>
          <div style={{width:"100%", maxWidth:"55em"}}>
            <CEGeneralReact.GenericInputOrSelectFromInputType
              p_fieldTypeObj={shortCutPresetsCaptureManagersOnCreateNewCaptureFieldTypeObj}
              p_valueRaw={c_companyShortcutPresetsCaptureManagersOnCreateNewCapture01}
              f_onChangeOrOnSelect={this.onsave_shortcut_presets_capture_managers_on_cnc}
            />
          </div>
          {(c_companyShortcutPresetsCaptureManagersOnCreateNewCaptureTF) &&
            <>
              <div className="hugeTopMargin" />
              <CEComplexReact.AddEditDeleteTable
                p_dataArrayOfObjs={c_shortcutPresetsCaptureManagersArrayOfObjs}
                p_aedTableObj={shortcutPresetsCaptureManagersAedTableObj}
              />
            </>
          }
        </div>
      );
    }
    else {
      const documentFoldersOffMessage = "[default] Always empty " + c_cardNameDocuments + " Card when creating a new Capture";
      const documentFoldersOnMessage = "Offer presets created below with a predefined folder structure";
      const shortCutPresetsDocumentsCardFoldersOnCreateNewCaptureFieldTypeObj = this.props.DatabaseMobx.create_verticalswitch_field_type_obj_from_value_array_and_display_array("Capture Manager Shortcut Preset Option", [0, 1], false, [documentFoldersOffMessage, documentFoldersOnMessage], 2);

      const numDocumentsCardFoldersPresets = c_shortcutPresetsDocumentsCardFoldersPresetsArrayOfObjs.length;

      const documentsShortcutPresetOnOffComponent = (
        <>
          <div className="microBottomMargin">
            <font className="font11 fontItalic fontTextLight">
              {"Optional 'Shortcut Presets' to create a predefined structure of empty folders in the " + c_cardNameDocuments + " Card when a new Capture is created"}
            </font>
          </div>
          <div style={{width:"100%", maxWidth:"40em"}}>
            <CEGeneralReact.GenericInputOrSelectFromInputType
              p_fieldTypeObj={shortCutPresetsDocumentsCardFoldersOnCreateNewCaptureFieldTypeObj}
              p_valueRaw={c_companyShortcutPresetsDocumentsCardFoldersOnCreateNewCapture01}
              f_onChangeOrOnSelect={this.onsave_shortcut_presets_documents_card_folders_on_cnc}
            />
          </div>
        </>
      );

      if(!c_companyShortcutPresetsDocumentsCardFoldersOnCreateNewCaptureTF) {
        shortcutPresetsContentComponent = (
          <div className="flex11a displayFlexColumn medFullPad yScroll">
            {documentsShortcutPresetOnOffComponent}
          </div>
        );
      }
      else {
        shortcutPresetsContentComponent = (
          <div className="flex11a displayFlexRow">
            <div className="flex11a displayFlexColumn borderR1bbb medFullPad yScroll" style={{flexBasis:"100em"}}>
              {documentsShortcutPresetOnOffComponent}
              <div className="medTopMargin border1bbb bigTopPad smallBottomPad lrPad" style={{background:"#dce"}}>
                <div className="displayFlexColumnHcVc medBottomMargin">
                  <CEGeneralReact.ButtonWithConfirmBox
                    p_buttonType="blue"
                    p_buttonText="Create a New Shortcut Preset of Folders"
                    p_buttonFontClass={undefined}
                    p_tabIndex={undefined}
                    p_title={"Add a new Shortcut Preset when creating a new Capture to fill the " + c_cardNameDocuments + " Card with a predefined structure of empty folders"}
                    p_confirmType="inputText"
                    p_confirmMessage={"Enter a name for a new " + c_cardNameDocuments + " Card folders Shortcut Preset"}
                    p_button1Name="Create New Preset"
                    p_textMustBeFilledOutTF={true}
                    f_onClickConfirm={this.onconfirm_create_new_documents_card_folders_shortcut_preset}
                  />
                </div>
                {(numDocumentsCardFoldersPresets === 0) ? (
                  <div className="smallTopPad bigBottomPad lrMedPad textCenter">
                    <font className="fontItalic fontTextLight">
                      {"--No " + c_cardNameDocuments + " Card folders presets have been created yet--"}
                    </font>
                  </div>
                ) : (
                  c_shortcutPresetsDocumentsCardFoldersPresetsArrayOfObjs.map((m_documentsCardFoldersPresetObj, m_index) =>
                    <ShortcutPresetsDocumentsCardFoldersPresetItem
                      key={m_documentsCardFoldersPresetObj.id}
                      p_documentsCardFoldersPresetObj={m_documentsCardFoldersPresetObj}
                      p_isOnlyItemTF={(numDocumentsCardFoldersPresets === 1)}
                      p_isLastItemTF={(m_index === (numDocumentsCardFoldersPresets - 1))}
                    />
                  )
                )}
              </div>
            </div>
            <div className="flex11a displayFlexColumn" style={{flexBasis:"100em"}}>
              {(JSFUNC.is_number_not_nan_gt_0(o_shortcutPresetsDocumentsCardFoldersEditingPresetIDOrUndefined)) ? (
                <>
                  <div className="flex00a displayFlexRowVc bgPurpleGradient tbPad">
                    <div className="flex11a lrMedPad">
                      <font className="font11 fontBold fontWhite">
                        {"Editing folder structure for Shortcut Preset '" + c_shortcutPresetsDocumentsCardFoldersEditingPresetObj.preset_name + "'"}
                      </font>
                    </div>
                    <div className="lrPad">
                      <CEGeneralReact.CEButton
                        p_type="gray"
                        p_text="Close"
                        f_onClick={this.onclick_close_editing_preset}
                      />
                    </div>
                  </div>
                  <CEComplexReact.FileFolderSystem
                    p_tblName="tbl_a_shortcut_presets_documents_card_folders_filefoldersystem"
                    p_tblMapOfMaps={o_tbl_a_shortcut_presets_documents_card_folders_filefoldersystem}
                    p_tblFilterValuesObj={{shortcut_preset_id:o_shortcutPresetsDocumentsCardFoldersEditingPresetIDOrUndefined}}
                    p_title={undefined}
                    p_defaultXmlType={undefined}
                    p_allowedExtsArray={undefined}
                    p_disableUploadFilesTF={true}
                    p_disableCreateOnlineLinkDocsTF={true}
                    p_disableCreateFoldersTF={false}
                    p_viewWideTrueNarrowFalse={false}
                    p_navigateToFolderID={undefined}
                    f_onPerformFFSAction={undefined}
                    f_onNavigateToFolder={undefined}
                  />
                </>
              ) : (
                <CEGeneralReact.EmptyScreenGray>
                  {"Select a Preset to create/edit its structure of folders"}
                </CEGeneralReact.EmptyScreenGray>
              )}
            </div>
          </div>
        );
      }
    }

    return(
      <>
        <div className="flex00a borderB1bbb tbPad lrMedPad xScroll">
          <CEGeneralReact.TabsList
            p_tabDbNamesArray={["captureTeam", "documentsCard"]}
            p_tabDisplayNamesArray={[captureManagersFieldDisplayName, c_cardNameDocuments + " Card"]}
            p_selectedTabDbName={o_shortcutPresetsSelectedSubtabDbName}
            p_tabHeight="1.8em"
            p_textMaxHeight="1.8em"
            p_tabWidth="18em"
            p_unselectedBgClass="bgLighterGrayGradient hoverLighterBlueGradient fontTextLight"
            p_unselectedFontClass="fontBold fontTextLight"
            p_selectedBgClass="bgDarkRedGradient"
            p_selectedFontClass="fontBold fontWhite"
            f_onSelect={this.onclick_shortcut_presets_tab}
          />
        </div>
        {shortcutPresetsContentComponent}
      </>
    );
  }
}));



const ShortcutPresetsDocumentsCardFoldersPresetItem = inject("AdminMobx", "DatabaseMobx")(observer(
class ShortcutPresetsDocumentsCardFoldersPresetItem extends Component { //props: p_documentsCardFoldersPresetObj, p_isOnlyItemTF, p_isLastItemTF
  onclick_preset_open_ffs_folders_editor = () => {
    const p_documentsCardFoldersPresetObj = this.props.p_documentsCardFoldersPresetObj;

    const o_shortcutPresetsDocumentsCardFoldersEditingPresetIDOrUndefined = this.props.AdminMobx.o_shortcutPresetsDocumentsCardFoldersEditingPresetIDOrUndefined;

    var selectedDocumentsCardFoldersPresetIDOrUndefined = p_documentsCardFoldersPresetObj.id;
    if(p_documentsCardFoldersPresetObj.id === o_shortcutPresetsDocumentsCardFoldersEditingPresetIDOrUndefined) {
      selectedDocumentsCardFoldersPresetIDOrUndefined = undefined;
    }
    this.props.AdminMobx.a_shortcut_presets_set_documents_card_folders_editing_preset_id_or_undefined(selectedDocumentsCardFoldersPresetIDOrUndefined);
  }

  onconfirm_rename_documents_card_folders_preset_item = (i_newPresetNameString) => {
    const p_documentsCardFoldersPresetObj = this.props.p_documentsCardFoldersPresetObj;
    this.props.AdminMobx.a_shortcut_presets_rename_documents_card_folders_preset(p_documentsCardFoldersPresetObj.id, i_newPresetNameString);
  }

  ondelete_documents_card_folders_preset_item = () => {
    const p_documentsCardFoldersPresetObj = this.props.p_documentsCardFoldersPresetObj;

    if(p_documentsCardFoldersPresetObj !== undefined) {
      //set that no preset is being edited anymore
      this.props.AdminMobx.a_shortcut_presets_set_documents_card_folders_editing_preset_id_or_undefined(undefined);

      //delete all folders under this preset, then the preset record itself
      this.props.AdminMobx.a_shortcut_presets_delete_documents_card_folders_preset(p_documentsCardFoldersPresetObj);
    }
  }

  render() {
    const p_documentsCardFoldersPresetObj = this.props.p_documentsCardFoldersPresetObj;
    const p_isOnlyItemTF = this.props.p_isOnlyItemTF;
    const p_isLastItemTF = this.props.p_isLastItemTF;
    
    const o_shortcutPresetsDocumentsCardFoldersEditingPresetIDOrUndefined = this.props.AdminMobx.o_shortcutPresetsDocumentsCardFoldersEditingPresetIDOrUndefined;
    const c_cardNameDocuments = this.props.DatabaseMobx.c_cardNameDocuments;

    const documentsCardFoldersPresetIsEditingTF = (p_documentsCardFoldersPresetObj.id === o_shortcutPresetsDocumentsCardFoldersEditingPresetIDOrUndefined);
    const hoverText = p_documentsCardFoldersPresetObj.preset_name + "\n[Click to add/edit the structure of folders for this preset]";

    const documentsCardFoldersPresetMenuItemsArrayOfObjs = [
      {
        displayName: "Rename Preset",
        confirmType: "inputText",
        confirmTitle: "Rename Preset",
        confirmMessage: "Enter a new name for this preset '" + p_documentsCardFoldersPresetObj.preset_name + "'",
        confirmTextInitialValue: p_documentsCardFoldersPresetObj.preset_name,
        confirmTextMustBeFilledOutTF: true,
        confirmButton1Name: "Rename",
        functionOnClickConfirmButton: this.onconfirm_rename_documents_card_folders_preset_item
      },
      {
        displayName: "Delete Preset",
        confirmType: "confirmDelete",
        confirmTitle: "Delete Preset",
        confirmMessage: "Delete " + c_cardNameDocuments + " Card Folders Shortcut Preset '" + p_documentsCardFoldersPresetObj.preset_name + "'?",
        functionOnClickConfirmButton: this.ondelete_documents_card_folders_preset_item
      }
    ];

    return(
      <CEGeneralReact.CEDragToResortItemWithinDbTbl
        p_canResortTF={true}
        p_uniqueString="documentsCardFoldersPresetItem"
        p_itemID={p_documentsCardFoldersPresetObj.id}
        p_itemSort={p_documentsCardFoldersPresetObj.sort}
        p_itemSortColumnWidth={undefined}
        p_itemSortNumberFontClass={undefined}
        p_isOnlyItemTF={p_isOnlyItemTF}
        p_isLastItemTF={p_isLastItemTF}
        p_outerPadClass="lrPad microTopPad"
        p_itemClass="border bevelBorderColors bgAlmostWhite hoverLighterBlueGradient"
        p_itemStyleObj={{height:"2.4em"}}
        p_lastItemExtraDropZoneHeight="1.8em"
        p_dragEntireItemTrueOnlySortNumberFalse={true}
        p_tblName="tbl_a_shortcut_presets_documents_card_folders"
        p_tblSortFieldDbName="sort"
        p_filterFieldNamesArray={undefined}
        p_filterValuesArray={undefined}>
        <div
          className={"flex11a displayFlexRow cursorPointer " + ((documentsCardFoldersPresetIsEditingTF) ? ("bgDarkPurpleGradient") : (""))}
          title={hoverText}
          onClick={this.onclick_preset_open_ffs_folders_editor}>
          <div className="flex11a displayFlexRowVc lrMedPad">
            <LibraryReact.NowrapEllipsis p_fontClass={((documentsCardFoldersPresetIsEditingTF) ? ("fontWhite") : (""))}>
              {(documentsCardFoldersPresetIsEditingTF) &&
                <font className="fontItalic">{"[editing] "}</font>
              }
              {p_documentsCardFoldersPresetObj.preset_name}
            </LibraryReact.NowrapEllipsis>
          </div>
          <div className="flex00a displayFlexColumnHcVc textCenter" style={{flexBasis:"7em"}}>
            <font className={"fontItalic " + ((documentsCardFoldersPresetIsEditingTF) ? ("fontAlmostWhite") : ("fontTextLight"))}>
              {p_documentsCardFoldersPresetObj.numFolders + " " + JSFUNC.plural(p_documentsCardFoldersPresetObj.numFolders, "Folder", "Folders")}
            </font>
          </div>
        </div>
        <div className="flex00a borderL1ddd displayFlexColumnHcVc" style={{flexBasis:"2.4em"}}>
          <CEGeneralReact.VerticalDotsMenu
            p_menuItemsArrayOfObjs={documentsCardFoldersPresetMenuItemsArrayOfObjs}
          />
        </div>
      </CEGeneralReact.CEDragToResortItemWithinDbTbl>
    );
  }
}));



//=================================================================================================================================================================
//=================================================================================================================================================================



export const AdminSubtabCaptureArchiving = inject("AdminMobx", "DatabaseMobx")(observer(
class AdminSubtabCaptureArchiving extends Component { //props: none
  onswitch_company_using_automated_capture_archiving = () => {
    const c_companyUsingAutomatedCaptureArchivingTF = this.props.DatabaseMobx.c_companyUsingAutomatedCaptureArchivingTF;
    const c_fieldMapOfAddedDate = this.props.DatabaseMobx.c_fieldMapOfAddedDate;
    const c_closedNoBidStageIDsArray = this.props.DatabaseMobx.c_closedNoBidStageIDsArray;
    const c_closedCancelledStageIDsArray = this.props.DatabaseMobx.c_closedCancelledStageIDsArray;

    const updatedValue01 = ((c_companyUsingAutomatedCaptureArchivingTF) ? (0) : (1));
    var companyFieldNamesArray = ["using_automated_capture_archiving_01"];
    var companyUpdatedValuesArray = [updatedValue01];
    var companyIdsbArray = ["i"];
    if(updatedValue01 === 1) { //if turning the switch on, set default values for the num days and set the selected date field to Added Date
      //get all stageIDs that are no bid and cancelled types
      const noBidAndCancelledStageIDsArray = JSFUNC.merge_unique(c_closedNoBidStageIDsArray, c_closedCancelledStageIDsArray);
      const noBidAndCancelledStageIDsComma = JSFUNC.convert_array_to_comma_list(noBidAndCancelledStageIDsArray);

      companyFieldNamesArray = ["using_automated_capture_archiving_01", "capture_archiving_closed_stage_ids_comma", "capture_archiving_num_days_after_date", "capture_archiving_date_field_id", "capture_archiving_num_days_no_activity"];
      companyUpdatedValuesArray = [updatedValue01, noBidAndCancelledStageIDsComma, 720, c_fieldMapOfAddedDate.get("id"), 90];
      companyIdsbArray = ["i", "s", "i", "i", "i"];
    }
    this.props.AdminMobx.a_update_tbl_a_company_fields(companyFieldNamesArray, companyUpdatedValuesArray, companyIdsbArray);
  }

  onsave_capture_archive_closed_stages = (i_newValueCommaListString) => {
    this.props.AdminMobx.a_update_tbl_a_company_fields("capture_archiving_closed_stage_ids_comma", i_newValueCommaListString, "s");
  }

  onsave_capture_archive_num_days_after_date = (i_newValueInt) => {
    this.props.AdminMobx.a_update_tbl_a_company_fields("capture_archiving_num_days_after_date", i_newValueInt, "i");
  }

  onsave_capture_archive_date_field = (i_newCaptureDateFieldID) => {
    this.props.AdminMobx.a_update_tbl_a_company_fields("capture_archiving_date_field_id", i_newCaptureDateFieldID, "i");
  }

  onsave_capture_archive_num_days_no_activity = (i_newValueInt) => {
    this.props.AdminMobx.a_update_tbl_a_company_fields("capture_archiving_num_days_no_activity", i_newValueInt, "i");
  }

  onswitch_capture_archive_send_gcss_update_reminders = () => {
    const c_companyCaptureArchivingSendGcssUpdateRemindersTF = this.props.DatabaseMobx.c_companyCaptureArchivingSendGcssUpdateRemindersTF;
    const newValue01 = ((c_companyCaptureArchivingSendGcssUpdateRemindersTF) ? (0) : (1));
    this.props.AdminMobx.a_update_tbl_a_company_fields("capture_archiving_send_gcss_update_reminders_01", newValue01, "i");
  }

  onswitch_capture_archive_send_task_reminders = () => {
    const c_companyCaptureArchivingSendTaskRemindersTF = this.props.DatabaseMobx.c_companyCaptureArchivingSendTaskRemindersTF;
    const newValue01 = ((c_companyCaptureArchivingSendTaskRemindersTF) ? (0) : (1));
    this.props.AdminMobx.a_update_tbl_a_company_fields("capture_archiving_send_task_reminders_01", newValue01, "i");
  }

  onswitch_capture_archive_send_automated_reminders = () => {
    const c_companyCaptureArchivingSendAutomatedRemindersTF = this.props.DatabaseMobx.c_companyCaptureArchivingSendAutomatedRemindersTF;
    const newValue01 = ((c_companyCaptureArchivingSendAutomatedRemindersTF) ? (0) : (1));
    this.props.AdminMobx.a_update_tbl_a_company_fields("capture_archiving_send_automated_reminders_01", newValue01, "i");
  }

  render() {
    const c_companyUsingAutomatedCaptureArchivingTF = this.props.DatabaseMobx.c_companyUsingAutomatedCaptureArchivingTF;
    const c_companyCaptureArchivingClosedStageIDsComma = this.props.DatabaseMobx.c_companyCaptureArchivingClosedStageIDsComma;
    const c_companyCaptureArchivingNumDaysAfterDate = this.props.DatabaseMobx.c_companyCaptureArchivingNumDaysAfterDate;
    const c_companyCaptureArchivingDateFieldID = this.props.DatabaseMobx.c_companyCaptureArchivingDateFieldID;
    const c_companyCaptureArchivingNumDaysNoActivity = this.props.DatabaseMobx.c_companyCaptureArchivingNumDaysNoActivity;
    const c_companyCaptureArchivingSendGcssUpdateRemindersTF = this.props.DatabaseMobx.c_companyCaptureArchivingSendGcssUpdateRemindersTF;
    const c_companyCaptureArchivingSendTaskRemindersTF = this.props.DatabaseMobx.c_companyCaptureArchivingSendTaskRemindersTF;
    const c_companyCaptureArchivingSendAutomatedRemindersTF = this.props.DatabaseMobx.c_companyCaptureArchivingSendAutomatedRemindersTF;

    const archivingInfoBulletListArray = [
      "Each User has the choice in their User Settings to always load archived Captures, be prompted with a choice every time, or to never load them",
      "Not loading archived Captures has the advantage of speeding up load time of your system, and reducing searches and data from Captures that are not relevant anymore",
      "Divexecs may wish to always load archived Captures to fill the historical data of their analysis charts"
    ];

    return (
      <div className="flex11a xyScroll medFullPad">
        <div className="displayFlexRowVc border1bbb medFullPad bgLightestGray" style={{width:"90em"}}>
          <div className="flex00" style={{flexBasis:"13em"}}>
            <font className="font14">
              <div>{"Using Automated"}</div>
              <div>{"Capture Archiving?"}</div>
            </font>
          </div>
          <div className="flex00">
            <CEGeneralReact.SwitchWithTextAndConfirmBox
              p_isOnTF={c_companyUsingAutomatedCaptureArchivingTF}
              p_sizeEm={5}
              f_onSwitch={this.onswitch_company_using_automated_capture_archiving}
            />
          </div>
          <div className="flex11a" style={{marginLeft:"5em"}}>
            <div className="smallBottomMargin">
              <font className="font12 fontItalic">
                {"Capture Archiving General Info:"}
              </font>
            </div>
            <CEGeneralReact.BulletList
              p_linesArray={archivingInfoBulletListArray}
              p_fontClass="fontItalic fontTextLight"
              p_dashFontClass="fontItalic fontTextLight"
            />
          </div>
        </div>
        {(c_companyUsingAutomatedCaptureArchivingTF) &&
          <div className="medTopMargin displayFlexRow" style={{width:"90em"}}>
            <div className="flex11a border1bbb medFullPad" style={{flexBasis:"175em"}}>
              <div className="">
                <font className="font12 fontBold fontTextLight">
                  {"Captures will be automatically marked for archiving following these rules at 5am ET every morning:"}
                </font>
              </div>
              <div className="medTopMargin lrMedPad">
                <div className="displayFlexRowVc">
                  <div className="flex00a" style={{flexBasis:"26em"}}>
                    <font className="">
                      {"1) Capture must be in one of the selected Closed Stages:"}
                    </font>
                  </div>
                  <div className="flex11a">
                    <CEGeneralReact.CaptureExecFieldEditSaveCancel
                      p_ceEditItemString="adminCaptureArchivingClosedStagesField"
                      p_fieldTypeObj={this.props.DatabaseMobx.c_selectMultiStagesFieldTypeObj}
                      p_valueRaw={c_companyCaptureArchivingClosedStageIDsComma}
                      p_valueIsEditableTFU={true}
                      p_valuesToNotIncludeArray={this.props.DatabaseMobx.c_activeStageIDsArray}
                      p_containerClass="border1ddd"
                      f_onSaveChanged={this.onsave_capture_archive_closed_stages}
                    />
                  </div>
                </div>
                <div className="tbMargin lrMedPad">
                  <font className="fontBold fontItalic fontDarkBlue">
                    {"AND"}
                  </font>
                </div>
                <div className="displayFlexRowVc">
                  <div className="flex00a" style={{flexBasis:"6em"}}>
                    <font className="">
                      {"2) Capture is "}
                    </font>
                  </div>
                  <div className="flex00a" style={{flexBasis:"11em"}}>
                    <CEGeneralReact.CaptureExecFieldEditSaveCancel
                      p_ceEditItemString="adminCaptureArchivingNumDaysAfterDate"
                      p_fieldTypeObj={this.props.DatabaseMobx.c_genericIntPositiveFieldTypeObj}
                      p_valueRaw={c_companyCaptureArchivingNumDaysAfterDate}
                      p_valueIsEditableTFU={true}
                      p_containerClass="border1ddd"
                      f_onSaveChanged={this.onsave_capture_archive_num_days_after_date}
                    />
                  </div>
                  <div className="flex00a lrPad" style={{flexBasis:"8em"}}>
                    <font className="">
                      {"days past date"}
                    </font>
                  </div>
                  <div className="flex11a">
                    <CEGeneralReact.CaptureExecFieldEditSaveCancel
                      p_ceEditItemString="adminCaptureArchivingDateField"
                      p_fieldTypeObj={this.props.DatabaseMobx.c_selectCaptureDateFieldFieldTypeObj}
                      p_valueRaw={c_companyCaptureArchivingDateFieldID}
                      p_valueIsEditableTFU={true}
                      p_containerClass="border1ddd"
                      f_onSaveChanged={this.onsave_capture_archive_date_field}
                    />
                  </div>
                </div>
                <div className="tbMargin lrMedPad">
                  <font className="fontBold fontItalic fontDarkBlue">
                    {"AND"}
                  </font>
                </div>
                <div className="displayFlexRowVc">
                  <div className="flex00a" style={{flexBasis:"6em"}}>
                    <font className="">
                      {"3) Capture is "}
                    </font>
                  </div>
                  <div className="flex00a" style={{flexBasis:"11em"}}>
                    <CEGeneralReact.CaptureExecFieldEditSaveCancel
                      p_ceEditItemString="adminCaptureArchivingNumDaysNoActivity"
                      p_fieldTypeObj={this.props.DatabaseMobx.c_genericIntPositiveFieldTypeObj}
                      p_valueRaw={c_companyCaptureArchivingNumDaysNoActivity}
                      p_valueIsEditableTFU={true}
                      p_containerClass="border1ddd"
                      f_onSaveChanged={this.onsave_capture_archive_num_days_no_activity}
                    />
                  </div>
                  <div className="flex11a lrPad">
                    <font className="">
                      {"days with no recent activity"}
                    </font>
                  </div>
                </div>
              </div>
            </div>
            <div className="flex00a" style={{flexBasis:"2em"}} />
            <div className="flex11a border1bbb medFullPad" style={{flexBasis:"100em"}}>
              <div className="medBottomMargin">
                <font className="font12 fontBold fontTextLight">
                  {"Reminders when Archived:"}
                </font>
              </div>
              <div className="medBottomMargin">
                <CEGeneralReact.SwitchWithTextAndConfirmBox
                  p_isOnTF={c_companyCaptureArchivingSendGcssUpdateRemindersTF}
                  p_sizeEm={3.3}
                  p_onText="Reminders will be sent"
                  p_offText="Reminders will not be sent"
                  p_labelText="GCSS Updates"
                  p_labelFontClass=""
                  p_labelWidthEm={11}
                  p_title="When this switch is on, Capture Team members will receive system notifications whenever SAM.gov or GovWin publish data updates, even though the Capture is currently archived. Turning this switch off disables these notifications for Captures that are archived."
                  f_onSwitch={this.onswitch_capture_archive_send_gcss_update_reminders}
                />
              </div>
              <div className="medBottomMargin">
                <CEGeneralReact.SwitchWithTextAndConfirmBox
                  p_isOnTF={c_companyCaptureArchivingSendTaskRemindersTF}
                  p_sizeEm={3.3}
                  p_onText="Reminders will be sent"
                  p_offText="Reminders will not be sent"
                  p_labelText="Task Reminders"
                  p_labelFontClass=""
                  p_labelWidthEm={11}
                  p_title="When this switch is on, Task participants will receive pre/post reminders, even for archived Captures. Turning this switch off disables these reminders for Captures that are archived."
                  f_onSwitch={this.onswitch_capture_archive_send_task_reminders}
                />
              </div>
              <div className="medBottomMargin">
                <CEGeneralReact.SwitchWithTextAndConfirmBox
                  p_isOnTF={c_companyCaptureArchivingSendAutomatedRemindersTF}
                  p_sizeEm={3.3}
                  p_onText="Reminders will be sent"
                  p_offText="Reminders will not be sent"
                  p_labelText="Automated Reminders"
                  p_labelFontClass=""
                  p_labelWidthEm={11}
                  p_title="When this switch is on, Capture Team members will receive Automated Reminders set up by the Admin whenever they are triggered by the system, even for archived Captures. Turning this switch off disables these reminders for Captures that are archived."
                  f_onSwitch={this.onswitch_capture_archive_send_automated_reminders}
                />
              </div>
            </div>
          </div>
        }
        <div style={{marginTop:"5em"}} />
        <CaptureArchivingArchivedCapturesSearchResultsTable />
      </div>
    );
  }
}));

const CaptureArchivingArchivedCapturesSearchResultsTable = inject("AdminMobx", "CapturesMobx", "DatabaseMobx", "UserMobx")(observer(
class CaptureArchivingArchivedCapturesSearchResultsTable extends Component { //props: none
  constructor(props) {
    super(props);
    this.state = {
      s_loadingAllArchivedCapturesInSeparateFetchTF: false,
      s_checkedCaptureIDsArray: [],
      s_unarchiveWorkingMessageOrUndefined: undefined
    };
  }

  onclick_admin_load_archived_captures_into_the_system = () => {
    const o_userID = this.props.UserMobx.o_userID;

    this.setState({s_loadingAllArchivedCapturesInSeparateFetchTF:true});

    const jsDescription = JSFUNC.js_description_from_action("AdminReact - CaptureArchivingArchivedCapturesSearchResultsTable", "onclick_admin_load_archived_captures_into_the_system", [], []);
    const C_CallPhpScript = new JSPHP.ClassCallPhpScript("loadAllArchivedCapturesSlim", jsDescription);
    C_CallPhpScript.add_post_var("i_userID", o_userID);
    C_CallPhpScript.add_return_vars("ceCompressedArchivedSlimCapturesMatrix");

    const functionOnSuccess = (i_parseResponse) => {
      //uncompress the CE compressed data matrix from php (raw rows from tbl_captures)
      const archivedSlimCapturesArrayOfObjs = this.props.DatabaseMobx.uncompress_ce_compressed_data_table_arrayOfObjs(i_parseResponse.ceCompressedArchivedSlimCapturesMatrix);
      this.props.AdminMobx.a_capture_archving_set_loaded_slim_captures_arrayOfObjs(archivedSlimCapturesArrayOfObjs);
    }
    C_CallPhpScript.add_function("onSuccess", functionOnSuccess);

    const functionOnFinish = () => {
      this.setState({s_loadingAllArchivedCapturesInSeparateFetchTF:false});
    }
    C_CallPhpScript.add_function("onFinish", functionOnFinish);

    C_CallPhpScript.execute();
  }

  onclick_select_all_captures_checkbox = () => {
    const s_checkedCaptureIDsArray = this.state.s_checkedCaptureIDsArray;

    const c_captureArchivingFilteredLoadedCstMaskedCaptureValuesArrayOfObjsOrUndefined = this.props.AdminMobx.c_captureArchivingFilteredLoadedCstMaskedCaptureValuesArrayOfObjsOrUndefined;

    if(JSFUNC.is_array(c_captureArchivingFilteredLoadedCstMaskedCaptureValuesArrayOfObjsOrUndefined)) {
      var updatedCheckedCaptureIDsArray = []; //if every checkbox was checked, uncheck them all
      if(s_checkedCaptureIDsArray.length < c_captureArchivingFilteredLoadedCstMaskedCaptureValuesArrayOfObjsOrUndefined.length) { //not every checkbox is checked yet, check them all
        updatedCheckedCaptureIDsArray = JSFUNC.get_column_vector_from_arrayOfObjs(c_captureArchivingFilteredLoadedCstMaskedCaptureValuesArrayOfObjsOrUndefined, "id");
      }
      this.setState({s_checkedCaptureIDsArray:updatedCheckedCaptureIDsArray});
    }
  }

  onclick_archived_capture_checkbox = (i_captureID) => {
    const s_checkedCaptureIDsArray = this.state.s_checkedCaptureIDsArray;
    const updatedCheckedCaptureIDsArray = JSFUNC.remove_value_from_array_if_exists_otherwise_append(i_captureID, s_checkedCaptureIDsArray);
    this.setState({s_checkedCaptureIDsArray:updatedCheckedCaptureIDsArray});
  }

  onclick_confirm_unarchive_selected_captures = () => {
    const s_checkedCaptureIDsArray = this.state.s_checkedCaptureIDsArray;

    const o_captureArchivingLoadedSlimCapturesArrayOfObjs = this.props.AdminMobx.o_captureArchivingLoadedSlimCapturesArrayOfObjs;
    const k_allCapturesNamesReferenceForCreateNewCaptureTblNamesArray = this.props.DatabaseMobx.k_allCapturesNamesReferenceForCreateNewCaptureTblNamesArray;
    const c_phase1TblNamesToLoadArray = this.props.DatabaseMobx.c_phase1TblNamesToLoadArray;
    const c_fieldMapOfArchiveDate = this.props.DatabaseMobx.c_fieldMapOfArchiveDate;

    //initialize the unarchiving processing message as working
    this.setState({s_unarchiveWorkingMessageOrUndefined:"Unarchiving Captures (loading set of Captures)..."});
    
    //1) load all archived captures (phase1 capture tbls)
    const phase1TblNamesComma = JSFUNC.convert_array_to_comma_list(c_phase1TblNamesToLoadArray);
    const loadAllArchivedCapturesForceLoadArchivedCapturesTF = true;
    const singleCaptureIDOrM1AllCaptures = -1;
    const functionOnFinishLoadEveryCapture = () => {
      //set the unarchiving processing message as working
      this.setState({s_unarchiveWorkingMessageOrUndefined:"Unarchiving Captures (resetting Archive Date values)..."});

      //2) mass edit to set all loaded archived captures to unarchived
      const selectedCapturesArrayOfObjs = JSFUNC.filtered_arrayOfObjs_from_arrayOfObjs_single_field_matching_arrayOfValues(o_captureArchivingLoadedSlimCapturesArrayOfObjs, "id", s_checkedCaptureIDsArray);
      const newArchiveDateValueRaw = JSFUNC.blank_date();
      const sendMassEditNotificationsTF = false;
      const floatingBoxTitle = "Unarchiving Captures";
      const functionOnFinishMassEditArchiveDate = () => {
        //set the unarchiving processing message as working
        this.setState({s_unarchiveWorkingMessageOrUndefined:"Unarchiving Captures (merging all Captures into current system session)..."});

        //clear selected captureIDs
        this.setState({s_checkedCaptureIDsArray:[]});

        //3) reload all captures normally loaded at login (phase1 capture tbls)
        var reloadAllNonArchivedCapturesForceLoadArchivedCapturesTF = false;
        const functionOnFinishSecondReload = () => {
          //4) reload the all captures names and archive dates from the database for create new capture to reflect the new archive status of captures
          JSPHP.php_db_api_load_multiple_full_database_tbls_from_tbl_names_array_and_uncompress_and_update_local_memory_maps(k_allCapturesNamesReferenceForCreateNewCaptureTblNamesArray, undefined);

          //mark the unarchive process as finished
          this.setState({s_unarchiveWorkingMessageOrUndefined:undefined});
        }
        JSPHP.php_db_api_load_firewalled_archived_filtered_tbl_captures_and_c_tbls_and_uncompress_and_update_local_memory_maps(phase1TblNamesComma, reloadAllNonArchivedCapturesForceLoadArchivedCapturesTF, singleCaptureIDOrM1AllCaptures, functionOnFinishSecondReload);

        //3a) force this subtab to recalculate the archived captures list
        this.onclick_admin_load_archived_captures_into_the_system();
      }
      this.props.CapturesMobx.a_mass_edit_field_for_all_captures_in_capture_table(selectedCapturesArrayOfObjs, c_fieldMapOfArchiveDate, newArchiveDateValueRaw, sendMassEditNotificationsTF, floatingBoxTitle, functionOnFinishMassEditArchiveDate);
    }
    JSPHP.php_db_api_load_firewalled_archived_filtered_tbl_captures_and_c_tbls_and_uncompress_and_update_local_memory_maps(phase1TblNamesComma, loadAllArchivedCapturesForceLoadArchivedCapturesTF, singleCaptureIDOrM1AllCaptures, functionOnFinishLoadEveryCapture);
  }

  onchange_archived_captures_search_text = (i_newValueString) => {
    this.props.AdminMobx.a_set_capture_archiving_search_text(i_newValueString);
  }

  render() {
    const s_loadingAllArchivedCapturesInSeparateFetchTF = this.state.s_loadingAllArchivedCapturesInSeparateFetchTF;
    const s_checkedCaptureIDsArray = this.state.s_checkedCaptureIDsArray;
    const s_unarchiveWorkingMessageOrUndefined = this.state.s_unarchiveWorkingMessageOrUndefined;

    const o_captureArchivingSearchText = this.props.AdminMobx.o_captureArchivingSearchText;
    const o_captureArchivingLoadedSlimCapturesArrayOfObjs = this.props.AdminMobx.o_captureArchivingLoadedSlimCapturesArrayOfObjs;
    const c_captureArchivingFilteredLoadedCstMaskedCaptureValuesArrayOfObjsOrUndefined = this.props.AdminMobx.c_captureArchivingFilteredLoadedCstMaskedCaptureValuesArrayOfObjsOrUndefined;
    const c_searchFieldsDivexecExpandedCstColumnsArrayOfObjs = this.props.CapturesMobx.c_searchFieldsDivexecExpandedCstColumnsArrayOfObjs;
    const c_searchFieldsDivexecInitialSortObj = this.props.CapturesMobx.c_searchFieldsDivexecInitialSortObj;

    const archivedCapturesLoadedTF = JSFUNC.is_array(c_captureArchivingFilteredLoadedCstMaskedCaptureValuesArrayOfObjsOrUndefined);

    var archivedCapturesTableComponent = null;
    if(JSFUNC.string_is_filled_out_tf(s_unarchiveWorkingMessageOrUndefined)) {
      archivedCapturesTableComponent = (
        <CEGeneralReact.EmptyScreenWhite>
          <div className="smallBottomMargin">
            {s_unarchiveWorkingMessageOrUndefined}
          </div>
          <CEGeneralReact.LoadingAnimation />
        </CEGeneralReact.EmptyScreenWhite>
      );
    }
    else if(archivedCapturesLoadedTF) {
      const numFilteredLoadedArchivedCaptures = c_captureArchivingFilteredLoadedCstMaskedCaptureValuesArrayOfObjsOrUndefined.length;
      const numCheckedCaptures = s_checkedCaptureIDsArray.length;
      const showUnarchiveButtonTF = (numCheckedCaptures > 0);

      var selectAllCapturesCheckboxStatus = 2; //partial selection
      if(numCheckedCaptures === numFilteredLoadedArchivedCaptures) {
        selectAllCapturesCheckboxStatus = 1; //all selected
      }
      else if(numCheckedCaptures === 0) {
        selectAllCapturesCheckboxStatus = 0; //none selected
      }

      var unarchiveConfirmMessage = "";
      if(showUnarchiveButtonTF) {
        unarchiveConfirmMessage = "Are you sure you want to unarchive the following Captures?\n";
        for(let slimCaptureObj of o_captureArchivingLoadedSlimCapturesArrayOfObjs) {
          if(JSFUNC.in_array(slimCaptureObj.id, s_checkedCaptureIDsArray)) {
            unarchiveConfirmMessage += "\n - " + this.props.DatabaseMobx.capture_name_plaintext_from_capture_id_codename_opportunity_name(slimCaptureObj.id, slimCaptureObj.codename, slimCaptureObj.opportunity_name);
          }
        }
      }

      archivedCapturesTableComponent = (
        <>
          <div className="hugeTopMargin">
            <font className="font12 fontItalic fontTextLighter">
              {"System Archived Captures (" + numFilteredLoadedArchivedCaptures + ")"}
            </font>
          </div>
          <div className="displayFlexRow flexWrap">
            <div className="flex00a displayFlexRow tbMargin border1bbb bgLighterGray lrMedPad" style={{flexBasis:"36em", height:"3em"}}>
              <div className="flex00a displayFlexColumnHcVc" style={{flexBasis:"2.5em"}}>
                <LibraryReact.CheckBox
                  p_u0_s1_p2_du3_ds4={selectAllCapturesCheckboxStatus}
                  p_sizeEm={1.4}
                  f_onClick={this.onclick_select_all_captures_checkbox}
                />
              </div>
              <div className="flex00a displayFlexRowVc" style={{flexBasis:"11em"}}>
                <font className="fontTextLight">
                  {"Select All Captures"}
                </font>
              </div>
              <div className="flex11a" />
              {(showUnarchiveButtonTF) &&
                <div className="flex00a displayFlexColumnHcVc">
                  <CEGeneralReact.ButtonWithConfirmBox
                    p_buttonType="blue"
                    p_buttonText={"Unarchive " + numCheckedCaptures + " selected " + JSFUNC.plural(numCheckedCaptures, "Capture", "Captures")}
                    p_confirmType="confirm"
                    p_confirmMessage={unarchiveConfirmMessage}
                    p_button1Name={"Unarchive " + numCheckedCaptures + " " + JSFUNC.plural(numCheckedCaptures, "Capture", "Captures")}
                    f_onClickConfirm={this.onclick_confirm_unarchive_selected_captures}
                  />
                </div>
              }
            </div>
            <div className="flex00a displayFlexRow tbMargin border1bbb bgLighterGray lrMedPad" style={{flexBasis:"36em", height:"3em", marginLeft:"2em"}}>
              <div className="flex00a displayFlexRowVc" style={{flexBasis:"8em"}}>
                <font className="fontTextLight">
                  {"Search Archived Captures"}
                </font>
              </div>
              <div className="flex11a displayFlexColumnVc">
                <CEGeneralReact.SearchInputTextWithClearX
                  p_inputText={o_captureArchivingSearchText}
                  p_placeholderText="Filter Archived Captures Table Below..."
                  p_includeSearchIconTF={true}
                  p_heightEm={2}
                  f_onChange={this.onchange_archived_captures_search_text}
                />
              </div>
            </div>
            <div className="flex11a" />
          </div>
          <CapturesReact.SearchFieldsCaptureSummaryTable
            p_filteredCstMaskedCaptureValuesArrayOfObjs={c_captureArchivingFilteredLoadedCstMaskedCaptureValuesArrayOfObjsOrUndefined}
            p_cstSumRowColumnsArrayOfObjsOrUndefined={undefined}
            p_expandedCstColumnsArrayOfObjs={c_searchFieldsDivexecExpandedCstColumnsArrayOfObjs}
            p_initialSortFieldID={c_searchFieldsDivexecInitialSortObj.sortFieldIDOrUndefined}
            p_initialSortIsAscTF={c_searchFieldsDivexecInitialSortObj.sortIsAscTFOrUndefined}
            p_checkedCaptureIDsArray={s_checkedCaptureIDsArray}
            p_maxNumCapturesShown={undefined}
            f_onClickCapture={undefined}
            f_onClickCheckBox={this.onclick_archived_capture_checkbox}
          />
        </>
      );
    }

    return(
      <>
        <div className="smallBottomMargin">
          <font className="fontItalic fontTextLighter">
            {"You can load and view all Archived Captures in a table below using this 'Load All Archived Captures' button"}
          </font>
        </div>
        {(s_loadingAllArchivedCapturesInSeparateFetchTF) ? (
          <div className="displayFlexRowVc">
            <div className="flex00a">
              <font className="fontBold fontItalic fontTextLighter">
                {"Loading Captures"}
              </font>
            </div>
            <div className="flex11a lrMedPad">
              <CEGeneralReact.LoadingAnimation />
            </div>
          </div>
        ) : (
          <CEGeneralReact.CEButton
            p_type="add"
            p_text={((archivedCapturesLoadedTF) ? ("Clear and Reload Archived Captures to Display Below") : ("Load All Archived Captures to Display Below"))}
            f_onClick={this.onclick_admin_load_archived_captures_into_the_system}
          />
        )}
        {archivedCapturesTableComponent}
      </>
    );
  }
}));




//=================================================================================================================================================================
//=================================================================================================================================================================



export const AdminSubtabNewCaptureAdditionalFields = inject("AdminMobx", "DatabaseMobx")(observer(
class AdminSubtabNewCaptureAdditionalFields extends Component { //props: none
  render() {
    const c_selectedCaptureTypeObj = this.props.AdminMobx.c_selectedCaptureTypeObj;
    const c_createNewCaptureStandardFieldsLayoutArrayOfArraysOfObjs = this.props.AdminMobx.c_createNewCaptureStandardFieldsLayoutArrayOfArraysOfObjs;
    const c_fieldMapOfCaptureType = this.props.DatabaseMobx.c_fieldMapOfCaptureType;

    return(
      <div className="flex11a displayFlexColumn">
        <AdminCaptureTypeSelectionBoxes />
        <div className="flex11a displayFlexRow">
          <div className="flex11a displayFlexColumn borderR1bbb" style={{flexBasis:"100em"}}>
            <div className="flex00a medFullPad">
              <LibraryReact.DivFont p_class="" p_fontClass="font12 fontBold fontTextLight">
                {"Fields shown when using Create New Capture on the 'Captures' tab (when " + c_fieldMapOfCaptureType.get("display_name") + " '" + c_selectedCaptureTypeObj.name + "' is selected)"}
              </LibraryReact.DivFont>
              <LibraryReact.DivFont p_class="microTopMargin" p_fontClass="fontItalic fontTextLight">
                {"Below you can add custom fields to a new area on the Create New Capture form in addition to the standard fields offered"}
              </LibraryReact.DivFont>
            </div>
            <CreateNewCaptureAddAdditionalFields />
            <NewCaptureAdditionalFieldsList />
          </div>
          <div className="flex11a displayFlexColumn" style={{flexBasis:"125em"}}>
            <div className="flex00a medFullPad">
              <LibraryReact.DivFont p_class="textCenter" p_fontClass="font12 fontBold fontItalic fontTextLight">
                {"Create New Capture Layout"}
              </LibraryReact.DivFont>
              <LibraryReact.DivFont p_class="microTopMargin textCenter" p_fontClass="fontItalic fontTextLight">
                {"when " + c_fieldMapOfCaptureType.get("display_name") + " '" + c_selectedCaptureTypeObj.name + "' is selected"}
              </LibraryReact.DivFont>
            </div>
            <div className="flex11a displayFlexColumn lrMedPad medBottomPad yScroll">
              <div className="border1bbb medFullPad">
                {c_createNewCaptureStandardFieldsLayoutArrayOfArraysOfObjs.map((m_rowArrayOfObjs) =>
                  <div className="displayFlexRow medBottomMargin">
                    {m_rowArrayOfObjs.map((m_sectionObj) =>
                      <div className="flex11a displayFlexRow lrMargin" style={{flexBasis:"100em"}}>
                        {(m_sectionObj !== undefined) &&
                          <CEGeneralReact.NewCaptureSectionContainer p_drawBorderTF={true}>
                            <CEGeneralReact.NewCaptureSectionLabel p_label={m_sectionObj.sectionLabel}>
                              {m_sectionObj.fieldMapsArray.map((m_fieldMap) =>
                                <div className="smallTopMargin">
                                  <CEGeneralReact.NewCaptureFieldLabel p_widthEm={11} p_label={m_fieldMap.get("display_name")} />
                                </div>
                              )}
                            </CEGeneralReact.NewCaptureSectionLabel>
                          </CEGeneralReact.NewCaptureSectionContainer>
                        }
                      </div>
                    )}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}));

const CreateNewCaptureAddAdditionalFields = inject("AdminMobx", "DatabaseMobx")(observer(
class CreateNewCaptureAddAdditionalFields extends Component { //props: none
  constructor(props) {
    super(props);
    this.state = {
      s_selectingAdditionalFieldsToAddTF: false,
      s_selectedCaptureFieldsToAddAsAdditionalFieldIDsComma: ""
    };
  }

  onclick_add_additional_create_new_capture_fields_button = () => {
    this.setState({
      s_selectingAdditionalFieldsToAddTF: true,
      s_selectedCaptureFieldsToAddAsAdditionalFieldIDsComma: ""
    });
  }

  onselect_capture_fields = (i_selectedFieldIDsComma) => {
    this.setState({s_selectedCaptureFieldsToAddAsAdditionalFieldIDsComma:i_selectedFieldIDsComma});
  }

  onclick_add_selected_fields_to_create_new_capture = () => {
    const s_selectedCaptureFieldsToAddAsAdditionalFieldIDsComma = this.state.s_selectedCaptureFieldsToAddAsAdditionalFieldIDsComma;

    const o_selectedCaptureTypeID = this.props.AdminMobx.o_selectedCaptureTypeID;
    const c_createNewCaptureAdditionalFieldsForSelectedCaptureTypeArrayOfObjs = this.props.AdminMobx.c_createNewCaptureAdditionalFieldsForSelectedCaptureTypeArrayOfObjs;

    const selectedCaptureFieldsToAddAsAdditionalFieldIDsArray = JSFUNC.convert_comma_list_to_int_array(s_selectedCaptureFieldsToAddAsAdditionalFieldIDsComma);
    const numSelectedCaptureFieldsToAddAsAdditionalFields = selectedCaptureFieldsToAddAsAdditionalFieldIDsArray.length;
    if(numSelectedCaptureFieldsToAddAsAdditionalFields > 0) { //if there is at least 1 new field to add, make the database insert
      const numCurrentAdditionalFields = c_createNewCaptureAdditionalFieldsForSelectedCaptureTypeArrayOfObjs.length;

      const jsDescription = JSFUNC.js_description_from_action("AdminMobx - NewCaptureSingleAdditionalFieldItem", "ondelete_additional_field_item", [], []);
      const C_CallPhpTblUID = new JSPHP.ClassCallPhpTblUID(jsDescription);

      var insertCaptureFieldIDsArray = [];
      var insertCaptureFieldSortsArray = [];
      for(let f = 0; f < numSelectedCaptureFieldsToAddAsAdditionalFields; f++) {
        insertCaptureFieldIDsArray.push(selectedCaptureFieldsToAddAsAdditionalFieldIDsArray[f]);
        insertCaptureFieldSortsArray.push(numCurrentAdditionalFields + f + 1);
      }
      const tblName = "tbl_a_create_new_capture_additional_fields";
      const fieldNamesArray = ["capture_type_id", "capture_field_id", "sort"];
      const valuesArrayOfArrays = [o_selectedCaptureTypeID, insertCaptureFieldIDsArray, insertCaptureFieldSortsArray];
      const valueIdsbArray = ["i", "i", "i"];
      C_CallPhpTblUID.add_multi_insert(tblName, fieldNamesArray, valuesArrayOfArrays, valueIdsbArray);
      C_CallPhpTblUID.execute();
    }

    this.onclick_cancel_add_additional_create_new_capture_fields();
  }

  onclick_cancel_add_additional_create_new_capture_fields = () => {
    this.setState({
      s_selectingAdditionalFieldsToAddTF: false,
      s_selectedCaptureFieldsToAddAsAdditionalFieldIDsComma: ""
    });
  }

  render() {
    const s_selectingAdditionalFieldsToAddTF = this.state.s_selectingAdditionalFieldsToAddTF;
    const s_selectedCaptureFieldsToAddAsAdditionalFieldIDsComma = this.state.s_selectedCaptureFieldsToAddAsAdditionalFieldIDsComma;

    const c_selectNewCaptureAdditionalFieldForCaptureTypeFieldTypeObj = this.props.AdminMobx.c_selectNewCaptureAdditionalFieldForCaptureTypeFieldTypeObj;

    var numNewAdditionalFieldsSelected = 0;
    if(s_selectingAdditionalFieldsToAddTF) {
      numNewAdditionalFieldsSelected = JSFUNC.count_comma_list_num_items(s_selectedCaptureFieldsToAddAsAdditionalFieldIDsComma);
    }

    return(
      <div className="tbPad flex00a displayFlexColumnHcVc">
        {(!s_selectingAdditionalFieldsToAddTF) ? (
          <CEGeneralReact.CEButton
            p_type="blue"
            p_text="Add Additional 'Create New Capture' Fields"
            f_onClick={this.onclick_add_additional_create_new_capture_fields_button}
          />
        ) : (
          <>
            <div className="flex00a" style={{width:"90%", maxWidth:"40em"}}>
              <CEGeneralReact.GenericInputOrSelectFromInputType
                p_fieldTypeObj={c_selectNewCaptureAdditionalFieldForCaptureTypeFieldTypeObj}
                p_valueRaw={s_selectedCaptureFieldsToAddAsAdditionalFieldIDsComma}
                p_selectInitOptionsBoxOpenTF={true}
                f_onChangeOrOnSelect={this.onselect_capture_fields}
              />
            </div>
            <div className="flex00a displayFlexRowVc medTopMargin">
              <CEGeneralReact.CEButton
                p_type={((numNewAdditionalFieldsSelected > 0) ? ("blue") : ("blueDisabled"))}
                p_text={((numNewAdditionalFieldsSelected > 0) ? ("Add " + numNewAdditionalFieldsSelected + " New " + JSFUNC.plural(numNewAdditionalFieldsSelected, "Field", "Fields")) : ("No Fields Selected"))}
                f_onClick={this.onclick_add_selected_fields_to_create_new_capture}
              />
              <div className="flex00a" style={{flexBasis:"1em"}} />
              <CEGeneralReact.CEButton
                p_type="gray"
                p_text="Cancel"
                f_onClick={this.onclick_cancel_add_additional_create_new_capture_fields}
              />
            </div>
          </>
        )}
      </div>
    );
  }
}));

const NewCaptureAdditionalFieldsList = inject("AdminMobx", "DatabaseMobx")(observer(
class NewCaptureAdditionalFieldsList extends Component { //props: none
  render() {
    const c_selectedCaptureTypeObj = this.props.AdminMobx.c_selectedCaptureTypeObj;
    const c_createNewCaptureAdditionalFieldsForSelectedCaptureTypeArrayOfObjs = this.props.AdminMobx.c_createNewCaptureAdditionalFieldsForSelectedCaptureTypeArrayOfObjs;
    const c_fieldMapOfCaptureType = this.props.DatabaseMobx.c_fieldMapOfCaptureType;

    const numAdditionalFields = c_createNewCaptureAdditionalFieldsForSelectedCaptureTypeArrayOfObjs.length;
    const isOnlyItemTF = (numAdditionalFields === 1);

    return(
      <div className="flex11a yScroll medFullPad">
        <div className="border1bbb borderRadius05 bgLightestGray medFullPad">
          {(numAdditionalFields === 0) ? (
            <div className="medFullPad textCenter">
              <font className="fontItalic fontTextLight">
                {"--No Additional Fields have been added yet to Create New Capture for " + c_fieldMapOfCaptureType.get("display_name") + " '" + c_selectedCaptureTypeObj.name + "'--"}
              </font>
            </div>
          ) : (
            c_createNewCaptureAdditionalFieldsForSelectedCaptureTypeArrayOfObjs.map((m_cncAdditionalFieldObj, m_index) =>
              <NewCaptureSingleAdditionalFieldItem
                p_cncAdditionalFieldObj={m_cncAdditionalFieldObj}
                p_isOnlyItemTF={isOnlyItemTF}
                p_isLastItemTF={(m_index === (numAdditionalFields - 1))}
              />
            )
          )}
        </div>
      </div>
    );
  }
}));

const NewCaptureSingleAdditionalFieldItem = inject("AdminMobx", "DatabaseMobx")(observer(
class NewCaptureSingleAdditionalFieldItem extends Component { //props: p_cncAdditionalFieldObj, p_isOnlyItemTF, p_isLastItemTF
  ondelete_additional_field_item = () => {
    const p_cncAdditionalFieldObj = this.props.p_cncAdditionalFieldObj;

    const o_selectedCaptureTypeID = this.props.AdminMobx.o_selectedCaptureTypeID;

    const jsDescription = JSFUNC.js_description_from_action("AdminMobx - NewCaptureSingleAdditionalFieldItem", "ondelete_additional_field_item", [], []);
    const C_CallPhpTblUID = new JSPHP.ClassCallPhpTblUID(jsDescription);
    C_CallPhpTblUID.add_delete("tbl_a_create_new_capture_additional_fields", p_cncAdditionalFieldObj.id, "sort", ["capture_type_id"], [o_selectedCaptureTypeID]);
    C_CallPhpTblUID.execute();
  }

  render() {
    const p_cncAdditionalFieldObj = this.props.p_cncAdditionalFieldObj;
    const p_isOnlyItemTF = this.props.p_isOnlyItemTF;
    const p_isLastItemTF = this.props.p_isLastItemTF;

    const o_selectedCaptureTypeID = this.props.AdminMobx.o_selectedCaptureTypeID;
    const c_selectedCaptureTypeObj = this.props.AdminMobx.c_selectedCaptureTypeObj;
    const c_fieldMapOfCaptureType = this.props.DatabaseMobx.c_fieldMapOfCaptureType;

    return(
      <CEGeneralReact.CEDragToResortItemWithinDbTbl
        p_canResortTF={true}
        p_uniqueString="cncAdditionalFieldItem"
        p_itemID={p_cncAdditionalFieldObj.id}
        p_itemSort={p_cncAdditionalFieldObj.sort}
        p_itemSortColumnWidth="3em"
        p_itemSortNumberContainerClass={undefined}
        p_itemSortNumberFontClass={undefined}
        p_isOnlyItemTF={p_isOnlyItemTF}
        p_isLastItemTF={p_isLastItemTF}
        p_outerPadClass="microBottomMargin"
        p_itemClass="border1bbb bgWhite"
        p_itemStyleObj={{height:"2.4em"}}
        p_lastItemExtraDropZoneHeight="1.6em"
        p_dragEntireItemTrueOnlySortNumberFalse={true}
        p_tblName="tbl_a_create_new_capture_additional_fields"
        p_tblSortFieldDbName="sort"
        p_filterFieldNamesArray={["capture_type_id"]}
        p_filterValuesArray={[o_selectedCaptureTypeID]}
        f_onDropForeignItem={undefined}>
        <div className="flex11a displayFlexRowVc lrPad" title={p_cncAdditionalFieldObj.fieldDisplayName}>
          <LibraryReact.NowrapEllipsis p_fontClass="font11 fontTextLight">
            {p_cncAdditionalFieldObj.fieldDisplayName}
          </LibraryReact.NowrapEllipsis>
        </div>
        <div className="flex00a displayFlexColumnHcVc" style={{flexBasis:"2em"}}>
          <CEGeneralReact.DeleteMenu
            p_message={"Are you sure you want to remove '" + p_cncAdditionalFieldObj.fieldDisplayName + "' as an additional Create New Capture field for " + c_fieldMapOfCaptureType.get("display_name") + " '" + c_selectedCaptureTypeObj.name + "'?"}
            f_onDelete={this.ondelete_additional_field_item}
          />
        </div>
      </CEGeneralReact.CEDragToResortItemWithinDbTbl>
    );
  }
}));


//=================================================================================================================================================================
//=================================================================================================================================================================



export const AdminSubtabSearchFields = inject("AdminMobx", "DatabaseMobx")(observer(
class AdminSubtabSearchFields extends Component { //props: none
  onswitch_search_fields_separate_divexec_fields = () => {
    const c_companySearchFieldsSeparateDivexecFieldsTF = this.props.DatabaseMobx.c_companySearchFieldsSeparateDivexecFieldsTF;
    const newValue01 = ((c_companySearchFieldsSeparateDivexecFieldsTF) ? (0) : (1));
    this.props.AdminMobx.a_update_tbl_a_company_fields("search_fields_separate_divexec_fields_01", newValue01, "i");
  }

  render() {
    const c_companySearchFieldsSeparateDivexecFieldsTF = this.props.DatabaseMobx.c_companySearchFieldsSeparateDivexecFieldsTF;  

    return (
      <div className="flex11a yScroll">
        <SearchFieldsExampleAndAedTable p_searchResults0Divexec1={0} />
        <div className="hugeTopMargin" style={{borderTop:"solid 2px #bbb"}} />
        <div className="tbHugePad lrPad">
          <div className="border1bbb bgLighterGray smallFullPad">
            <CEGeneralReact.SwitchWithTextAndConfirmBox
              p_isOnTF={c_companySearchFieldsSeparateDivexecFieldsTF}
              p_sizeEm={3}
              p_onText="Use separate Column Set for Divexec Graphs/Performance Capture Tables"
              p_offText="Use Search Results Column Set above for all mini Capture Tables"
              p_labelText="2nd Column Set"
              p_labelFontClass=""
              p_labelWidthEm={9}
              p_title="Use this switch to enable a 2nd customizable set of Search Fields columns that can be applied to all Divexec Graphs/Performance when clicking on graph segments to view Capture lists"
              f_onSwitch={this.onswitch_search_fields_separate_divexec_fields}
            />
          </div>
        </div>
        {(c_companySearchFieldsSeparateDivexecFieldsTF) &&
          <SearchFieldsExampleAndAedTable p_searchResults0Divexec1={1} />
        }
        <div style={{marginTop:"10em"}} />
      </div>
    );
  }
}));

const SearchFieldsExampleAndAedTable = inject("AdminMobx", "CapturesMobx", "DatabaseMobx")(observer(
class SearchFieldsExampleAndAedTable extends Component { //props: p_searchResults0Divexec1
  render() {
    const p_searchResults0Divexec1 = this.props.p_searchResults0Divexec1;

    const c_searchFieldsSelectUsedInSearchFieldTypeObj = this.props.AdminMobx.c_searchFieldsSelectUsedInSearchFieldTypeObj;
    const c_searchFieldsSelectSortColumnFieldTypeObj = this.props.AdminMobx.c_searchFieldsSelectSortColumnFieldTypeObj;
    const c_searchFieldsSelectShowSumFieldTypeObj = this.props.AdminMobx.c_searchFieldsSelectShowSumFieldTypeObj;
    const c_searchFieldsSearchResultsExpandedCstColumnsArrayOfObjs = this.props.CapturesMobx.c_searchFieldsSearchResultsExpandedCstColumnsArrayOfObjs;
    const c_searchFieldsDivexecExpandedCstColumnsArrayOfObjs = this.props.CapturesMobx.c_searchFieldsDivexecExpandedCstColumnsArrayOfObjs;
    const c_genericIntPositiveFieldTypeObj = this.props.DatabaseMobx.c_genericIntPositiveFieldTypeObj;
    const c_selectNoClearCaptureFieldFieldTypeObj = this.props.DatabaseMobx.c_selectNoClearCaptureFieldFieldTypeObj;

    var searchFieldsExpandedCstColumnsArrayOfObjs = [];
    var aedTblWidthEm = 70;
    var showUsedInSearchColumnTF = true;
    var exampleTitle = "";
    var itemName = "";
    var bgClass = "";
    if(p_searchResults0Divexec1 === 0) {
      searchFieldsExpandedCstColumnsArrayOfObjs = c_searchFieldsSearchResultsExpandedCstColumnsArrayOfObjs;
      aedTblWidthEm = 70;
      showUsedInSearchColumnTF = true;
      exampleTitle = "'Search Results' Search Fields - used in 'Search Captures...' box";
      itemName = "'Search Results' Search Field";
      bgClass = "bgLightOrange";
    }
    else if(p_searchResults0Divexec1 === 1) {
      searchFieldsExpandedCstColumnsArrayOfObjs = c_searchFieldsDivexecExpandedCstColumnsArrayOfObjs;
      aedTblWidthEm = 59;
      showUsedInSearchColumnTF = false;
      exampleTitle = "'Divexec' Search Fields - used in Divexec Graphs/Performance, Archived Captures list";
      itemName = "'Divexec' Search Field";
      bgClass = "bgLightBlue";
    }

    //example fake data rows
    const exampleCapturesMapOfMaps = JSFUNC.mapOfMaps_from_arrayOfObjs([{id:1},{id:2}]);
    var exampleFilteredCstMaskedCaptureValuesArrayOfObjs = this.props.CapturesMobx.create_filtered_cst_masked_capture_values_arrayOfObjs_from_filtered_captures_mapOfMaps_and_expanded_cst_columns_arrayOfObjs_and_sort_capture_field_ids_array(exampleCapturesMapOfMaps, searchFieldsExpandedCstColumnsArrayOfObjs, []);
    for(let exampleCstMaskedCatpureValuesObj of exampleFilteredCstMaskedCaptureValuesArrayOfObjs) {
      for(let searchFieldsExpandedCstColumnObj of searchFieldsExpandedCstColumnsArrayOfObjs) {
        exampleCstMaskedCatpureValuesObj[searchFieldsExpandedCstColumnObj.capture_field_id + "MASKNCL"] = "Example Value";
      }
    }

    //example sum row
    var exampleCstSumRowColumnsArrayOfObjsOrUndefined = this.props.CapturesMobx.create_cst_sum_row_columns_arrayOfObjs_or_undefined_from_filtered_cst_masked_capture_values_arrayOfObjs_and_expanded_cst_columns_arrayOfObjs(exampleFilteredCstMaskedCaptureValuesArrayOfObjs, searchFieldsExpandedCstColumnsArrayOfObjs);
    if(JSFUNC.is_array(exampleCstSumRowColumnsArrayOfObjsOrUndefined)) {
      for(let exampleCstSumRowColumnObj of exampleCstSumRowColumnsArrayOfObjsOrUndefined) {
        exampleCstSumRowColumnObj.sumValueMask = "Example Value";
      }
    }

    //example sort
    const exampleSearchFieldsInitialSortObj = this.props.CapturesMobx.create_search_fields_initial_sort_obj_from_search_fields_expanded_cst_columns_arrayOfObjs(searchFieldsExpandedCstColumnsArrayOfObjs);

    //modify the columns data, set sum_row_01 to false where it cannot be turned into a sumRow
    var modifiedSearchFieldsExpandedCstColumnsArrayOfObjs = [];
    for(let searchFieldsExpandedCstColumnObj of searchFieldsExpandedCstColumnsArrayOfObjs) {
      modifiedSearchFieldsExpandedCstColumnsArrayOfObjs.push({
        id: searchFieldsExpandedCstColumnObj.id,
        sr0_de1: searchFieldsExpandedCstColumnObj.sr0_de1,
        field_id: searchFieldsExpandedCstColumnObj.field_id,
        sort: searchFieldsExpandedCstColumnObj.sort,
        used_in_search_01: searchFieldsExpandedCstColumnObj.used_in_search_01,
        width_em: searchFieldsExpandedCstColumnObj.width_em,
        sortcol_1no_2asc_3desc: searchFieldsExpandedCstColumnObj.sortcol_1no_2asc_3desc,
        sum_row_01: ((searchFieldsExpandedCstColumnObj.canCalculateCstSumRowTF) ? (searchFieldsExpandedCstColumnObj.sum_row_01) : (false))
      });
    }

    const searchResultFieldIDsAlreadyAddedArray = JSFUNC.get_column_vector_from_arrayOfObjs(searchFieldsExpandedCstColumnsArrayOfObjs, "field_id");

    var fieldsArrayOfObjs = [];
    fieldsArrayOfObjs.push({width:"100em", dbName:"field_id", displayName:"Capture Field", fieldTypeObj:c_selectNoClearCaptureFieldFieldTypeObj, valuesToNotIncludeArray:searchResultFieldIDsAlreadyAddedArray, initialValue:"", cellHoverTF:true, requiredNotEmptyTF:true, onlyEditableDuringCreateUneditableOnEditTF:true});
    fieldsArrayOfObjs.push({width:"7em", fixedWidthTF:true, dbName:"width_em", displayName:"Column Width", fieldTypeObj:c_genericIntPositiveFieldTypeObj, initialValue:10, cellCenterTF:true, requiredNotEmptyTF:true});
    fieldsArrayOfObjs.push({width:"10em", fixedWidthTF:true, dbName:"sortcol_1no_2asc_3desc", displayName:"Results Sorted by this Column?", fieldTypeObj:c_searchFieldsSelectSortColumnFieldTypeObj, initialValue:1, cellCenterTF:true, requiredNotEmptyTF:true});
    fieldsArrayOfObjs.push({width:"8em", fixedWidthTF:true, dbName:"sum_row_01", displayName:"Show Sum At Top?", fieldTypeObj:c_searchFieldsSelectShowSumFieldTypeObj, initialValue:0, cellCenterTF:true, rawValueFalseDisplaysNAAndNoEditTF:true, onlyEditableInEditNotShownOnCreateNewTF:true});
    if(showUsedInSearchColumnTF) {
      fieldsArrayOfObjs.push({width:"11em", fixedWidthTF:true, dbName:"used_in_search_01", displayName:"Used to Compare with Search Term?", fieldTypeObj:c_searchFieldsSelectUsedInSearchFieldTypeObj, initialValue:1, cellCenterTF:true, requiredNotEmptyTF:true});
    }
    fieldsArrayOfObjs.push({width:"3em", dbName:"sort", displayName:"Sort", fieldTypeObj:c_genericIntPositiveFieldTypeObj, initialValue:1});
    
    const searchFieldsSearchResultsAedTableObj = {
      tblName: "tbl_a_search_fields",
      dragToResortFieldDbName: "sort",
      initialSortedFieldDbName: "sort",
      tableWidth: aedTblWidthEm + "em",
      itemName: itemName,
      deleteItemNameFieldDbName: "field_id",
      newItemConstantFieldNamesArray: ["sr0_de1"],
      newItemConstantValuesArray: [p_searchResults0Divexec1],
      newItemConstantIdsbArray: ["i"],
      insertDeleteResortFilterFieldNamesArray: ["sr0_de1"],
      insertDeleteResortFilterValuesArray: [p_searchResults0Divexec1],
      fieldsArrayOfObjs: fieldsArrayOfObjs
    };

    return(
      <div className={bgClass}>
        <div className="displayFlexRow bgLighterGray medFullPad" style={{borderBottom:"solid 1px #666"}}>
          <div className="flex11a displayFlexColumn border bevelBorderColors bgWhite" style={{flexBasis:"400em", height:"12em"}}>
            <div className="flex00a displayFlexRowVc bgLightGrayGradient borderB1bbb" style={{flexBasis:"2.3em"}}>
              <div className="flex11a lrPad">
                <LibraryReact.NowrapEllipsis p_fontClass="font11 fontBold">
                  {exampleTitle}
                </LibraryReact.NowrapEllipsis>
              </div>
              <div className="flex00a displayFlexColumnHcVc borderL1ddd" style={{flexBasis:"3em"}}>
                <CEGeneralReact.RemoveItemXWithRedHover p_fontClass="font13" />
              </div>
            </div>
            {(searchFieldsExpandedCstColumnsArrayOfObjs.length === 0) ? (
              <CEGeneralReact.EmptyScreenWhite p_fontClass="">
                {"--No columns added to this Search Fields table yet--"}
              </CEGeneralReact.EmptyScreenWhite>
            ) : (
              <div className="flex11a xyScroll">
                <CapturesReact.SearchFieldsCaptureSummaryTable
                  p_filteredCstMaskedCaptureValuesArrayOfObjs={exampleFilteredCstMaskedCaptureValuesArrayOfObjs}
                  p_cstSumRowColumnsArrayOfObjsOrUndefined={exampleCstSumRowColumnsArrayOfObjsOrUndefined}
                  p_expandedCstColumnsArrayOfObjs={searchFieldsExpandedCstColumnsArrayOfObjs}
                  p_initialSortFieldID={exampleSearchFieldsInitialSortObj.sortFieldIDOrUndefined}
                  p_initialSortIsAscTF={exampleSearchFieldsInitialSortObj.sortIsAscTFOrUndefined}
                  p_maxNumCapturesShown={undefined}
                  f_onClickCapture={undefined}
                />
              </div>
            )}
          </div>
          <div className="flex11a" style={{flexBasis:"100em"}} />
        </div>
        <div className="medFullPad">
          <CEComplexReact.AddEditDeleteTable
            p_dataArrayOfObjs={modifiedSearchFieldsExpandedCstColumnsArrayOfObjs}
            p_aedTableObj={searchFieldsSearchResultsAedTableObj}
          />
        </div>
      </div>
    );
  }
}));





//=================================================================================================================================================================
//=================================================================================================================================================================



export const AdminSubtabPwin = inject("CaptureExecMobx", "AdminMobx", "DatabaseMobx")(observer(
class AdminSubtabPwin extends Component { //props: none
  onswitch_turn_onoff_pwin = () => {
    const newCompanyPwinFlag = ((this.props.DatabaseMobx.c_companyUsingPwinTF) ? ("off") : ("manual"));
    this.props.AdminMobx.a_update_tbl_a_company_fields("pwin_flag", newCompanyPwinFlag, "s");
  }

  onswitch_set_pwin_manual_calculated = () => {
    const newCompanyPwinFlag = ((this.props.DatabaseMobx.c_companyPwinIsCalculatedTF) ? ("manual") : ("calculated"));
    this.props.AdminMobx.a_update_tbl_a_company_fields("pwin_flag", newCompanyPwinFlag, "s");
  }

  onswitch_turn_onoff_calc_pwin_min_threshold = () => {
    const c_companyUsingCalculatedPwinMinimumThresholdSwitchIsOnTF = this.props.DatabaseMobx.c_companyUsingCalculatedPwinMinimumThresholdSwitchIsOnTF;
    const fieldDbNamesArray = ["pwin_calc_min_thresh_score", "pwin_calc_min_thresh_pwin"];
    var newValuesArray = [10, 10];
    if(c_companyUsingCalculatedPwinMinimumThresholdSwitchIsOnTF) {
      newValuesArray = [-1, -1];
    }
    const newIdsbArray = ["i", "i"];
    this.props.AdminMobx.a_update_tbl_a_company_fields(fieldDbNamesArray, newValuesArray, newIdsbArray);
  }

  onsave_calc_min_thresh_score = (i_newValue) => {
    this.props.AdminMobx.a_update_tbl_a_company_fields("pwin_calc_min_thresh_score", i_newValue, "i");
  }

  onsave_calc_min_thresh_pwin = (i_newValue) => {
    this.props.AdminMobx.a_update_tbl_a_company_fields("pwin_calc_min_thresh_pwin", i_newValue, "i");
  }

  render() {
    const c_productStylingObj = this.props.CaptureExecMobx.c_productStylingObj;
    const c_companyUsingPwinTF = this.props.DatabaseMobx.c_companyUsingPwinTF;
    const c_companyPwinIsCalculatedTF = this.props.DatabaseMobx.c_companyPwinIsCalculatedTF;
    const c_companyPwinCalcMinThreshScore = this.props.DatabaseMobx.c_companyPwinCalcMinThreshScore;
    const c_companyPwinCalcMinThreshPwin = this.props.DatabaseMobx.c_companyPwinCalcMinThreshPwin;
    const c_companyUsingCalculatedPwinMinimumThresholdSwitchIsOnTF = this.props.DatabaseMobx.c_companyUsingCalculatedPwinMinimumThresholdSwitchIsOnTF;
    const c_pwinCalcLinesSortedArrayOfObjs = this.props.DatabaseMobx.c_pwinCalcLinesSortedArrayOfObjs;
    const c_pwinColorsArrayOfObjs = this.props.DatabaseMobx.c_pwinColorsArrayOfObjs;

    const pwinCalcLinesAedTableObj = {
      tblName: "tbl_a_pwin_calc_lines",
      initialSortedFieldDbName: "progress_x1",
      tableWidth: "45em",
      itemName: "Calculated PWin Line",
      deleteItemNameFieldDbName: "progress_x1",
      fieldsArrayOfObjs: [
        {width:"100em", dbName:"progress_x1", displayName:"PWin Answers x1", fieldTypeObj:this.props.DatabaseMobx.c_genericPercentInt0to100FieldTypeObj, initialValue:50, cellCenterTF:true, requiredNotEmptyTF:true},
        {width:"100em", dbName:"progress_x2", displayName:"PWin Answers x2", fieldTypeObj:this.props.DatabaseMobx.c_genericPercentInt0to100FieldTypeObj, initialValue:50, cellCenterTF:true, requiredNotEmptyTF:true},
        {width:"100em", dbName:"pwin_y1", displayName:"Calc PWin y1", fieldTypeObj:this.props.DatabaseMobx.c_genericPercentInt0to100FieldTypeObj, initialValue:50, cellCenterTF:true, requiredNotEmptyTF:true},
        {width:"100em", dbName:"pwin_y2", displayName:"Calc PWin y2", fieldTypeObj:this.props.DatabaseMobx.c_genericPercentInt0to100FieldTypeObj, initialValue:50, cellCenterTF:true, requiredNotEmptyTF:true}
      ]
    };

    const pwinColorsAedTableObj = {
      tblName: "tbl_a_pwin_colors",
      initialSortedFieldDbName: "percent_start",
      tableWidth: "35em",
      itemName: "PWin Color",
      deleteItemNameFieldDbName: "percent_start",
      fieldsArrayOfObjs: [
        {width:"200em", dbName:"color", displayName:"Color", fieldTypeObj:this.props.DatabaseMobx.c_genericColorFieldTypeObj, initialValue:"cccccc", requiredNotEmptyTF:true},
        {width:"100em", dbName:"percent_start", displayName:"Percent Start", fieldTypeObj:this.props.DatabaseMobx.c_genericPercentInt0to100FieldTypeObj, initialValue:0, cellCenterTF:true, requiredNotEmptyTF:true},
        {width:"100em", dbName:"font_color", displayName:"Font Color", fieldTypeObj:this.props.DatabaseMobx.c_selectAdminFontColorFieldTypeObj, initialValue:"2a2a2a", cellCenterTF:true, requiredNotEmptyTF:true}
      ]
    };

    var examplePercentsArray = [0];
    for(let colorObj of c_pwinColorsArrayOfObjs) {
      var colorStart = colorObj.percent_start;
      var colorStartM1 = (colorStart - 1);
      if(colorStartM1 > 0 && !JSFUNC.in_array(colorStartM1, examplePercentsArray)) {
        examplePercentsArray.push(colorStartM1);
      }

      if(!JSFUNC.in_array(colorStart, examplePercentsArray)) {
        examplePercentsArray.push(colorStart);
      }
    }

    if(!JSFUNC.in_array(100, examplePercentsArray)) {
      examplePercentsArray.push(100);
    }

    const pwinFieldTypeObj = this.props.DatabaseMobx.c_fieldMapOfPwin.get("fieldTypeObj");

    return (
      <div className="flex11a displayFlexRow">
        <div className="flex11a yScroll yScrollBottomPad">
          <div className="medFullPad displayFlexRowVc" style={{borderBottom:"solid 1px #aaa"}}>
            <div className="flex00a" style={{flexBasis:"11em"}}>
              <font className="font14 fontBlue">
                {"Use PWin in " + c_productStylingObj.productName + "?"}
              </font>
            </div>
            <div className="flex00a">
              <LibraryReact.Switch
                p_isOnTF={c_companyUsingPwinTF}
                p_sizeEm={4.5}
                p_title={"Turn " + ((c_companyUsingPwinTF) ? ("off") : ("on")) + " PWin in the " + c_productStylingObj.productName + " system"}
                f_onClick={this.onswitch_turn_onoff_pwin}
              />
            </div>
            <div className="flex11a lrMedMargin">
              <font className="font12 fontItalic fontTextLighter">
                {'If turned on, PWin will be displayed at the top-center of the Deal Shaping capture card. For each capture, the PWin value can be entered manually ("Manual"), or automatically calculated ("Calculated") using the switch below.'}
              </font>
            </div>
          </div>
          <div className="medFullPad displayFlexRowVc" style={{borderBottom:"solid 1px #aaa"}}>
            <div className="flex00a" style={{flexBasis:"11em"}}>
              <CEGeneralReact.GenericInputOrSelectFromInputType
                p_fieldTypeObj={this.props.DatabaseMobx.create_verticalswitch_field_type_obj_from_value_array_and_display_array("PWin Calculation Option", [0, 1], false, ["Manual PWin", "Calculated PWin"], 1.9)}
                p_valueRaw={((c_companyUsingPwinTF) ? ((c_companyPwinIsCalculatedTF) ? (1) : (0)) : (-1))}
                f_onChangeOrOnSelect={((c_companyUsingPwinTF) ? (this.onswitch_set_pwin_manual_calculated) : (undefined))}
              />
            </div>
            <div className="flex11a lrMedMargin">
              <font className="fontItalic fontTextLighter">
                {((c_companyUsingPwinTF) ? (
                  (c_companyPwinIsCalculatedTF) ? (
                    '"Calculated" - PWin cannot be edited, and is an automatically calculated value based on the answers given to PWin specific Deal Shaping questions. The weighted average of those answers are correlated against the calculation tables below to determine the PWin value'
                  ) : (
                    '"Manual" - PWin can be edited manually for each capture with a value from 0 to 100%'
                  )
                ) : (
                  'PWin is currently turned off and must be turned on before chosing Manual/Calculated'
                ))}
              </font>
            </div>
          </div>
          {(c_companyUsingPwinTF && c_companyPwinIsCalculatedTF) &&
            <>
              <div className="medFullPad displayFlexRow flexWrap" style={{borderBottom:"solid 1px #aaa"}}>
                <div className="flex00a" style={{flexBasis:"30em"}}>
                  <div className="displayFlexRowVc">
                    <div className="flex00a" style={{flexBasis:"15em"}}>
                      <font className="font11 fontBlue">
                        {"Using Calculated PWin Minimum Threshold"}
                      </font>
                    </div>
                    <div className="flex00a">
                      <LibraryReact.Switch
                        p_isOnTF={c_companyUsingCalculatedPwinMinimumThresholdSwitchIsOnTF}
                        p_onColor="992222"
                        p_title={"Turn " + ((c_companyUsingCalculatedPwinMinimumThresholdSwitchIsOnTF) ? ("off") : ("on")) + " Calculated PWin Minimum Threshold"}
                        f_onClick={((c_companyUsingPwinTF) ? (this.onswitch_turn_onoff_calc_pwin_min_threshold) : (undefined))}
                      />
                    </div>
                  </div>
                  {(c_companyUsingCalculatedPwinMinimumThresholdSwitchIsOnTF) &&
                    <>
                    <CEGeneralReact.CaptureExecFieldEditSaveCancel
                      p_ceEditItemString="adminPwinMinThreshScore"
                      p_fieldDisplayName="Calculated PWin Minimum Progress Threshold"
                      p_fieldTypeObj={this.props.DatabaseMobx.c_genericPercentInt0to100FieldTypeObj}
                      p_valueRaw={c_companyPwinCalcMinThreshScore}
                      p_valueIsEditableTFU={true}
                      p_containerClass="tbMedMargin"
                      p_fieldClass="font11 fontBlue"
                      p_fieldWidth="15em"
                      p_valueClass="font11"
                      f_onSaveChanged={this.onsave_calc_min_thresh_score}
                    />
                    <CEGeneralReact.CaptureExecFieldEditSaveCancel
                      p_ceEditItemString="adminPwinMinThreshPwin"
                      p_fieldDisplayName="Calculated PWin Minimum PWin Threshold"
                      p_fieldTypeObj={this.props.DatabaseMobx.c_genericPercentInt0to100FieldTypeObj}
                      p_valueRaw={c_companyPwinCalcMinThreshPwin}
                      p_valueIsEditableTFU={true}
                      p_containerClass="tbMedMargin"
                      p_fieldClass="font11 fontBlue"
                      p_fieldWidth="15em"
                      p_valueClass="font11"
                      f_onSaveChanged={this.onsave_calc_min_thresh_pwin}
                    />
                    </>
                  }
                </div>
                <div className="flex00a" style={{flexBasis:"45em"}}>
                  <CEComplexReact.AddEditDeleteTable
                    p_dataArrayOfObjs={c_pwinCalcLinesSortedArrayOfObjs}
                    p_aedTableObj={pwinCalcLinesAedTableObj}
                  />
                </div>
              </div>
              <div className="medFullPad">
                <div className="displayFlexColumn">
                  <div className="flex11a displayFlexRow">
                    <div className="flex00a displayFlexColumnHcVc" style={{flexBasis:"3em", transform:"rotate(270deg)"}}>
                      <font className="font15 fontBold fontTextLighter">
                        {"Calculated PWin"}
                      </font>
                    </div>
                    <div className="flex11a">
                      <PwinCalculatedGraph />
                    </div>
                  </div>
                  <div className="flex00a displayFlexRow">
                    <div className="flex00a" style={{flexBasis:"3em"}} />
                    <div className="flex11a textCenter">
                      <font className="font15 fontBold fontTextLighter">
                        {"PWin Deal Shaping Answer Progress"}
                      </font>
                    </div>
                  </div>
                </div>
              </div>
            </>
          }
        </div>
        <div className="flex00a yScroll yScrollBottomPad medFullPad" style={{flexBasis:"52em", borderLeft:"solid 1px #aaa"}}>
          <div className="flex00a displayFlexRow">
            <div className="flex00a">
              <CEComplexReact.AddEditDeleteTable
                p_dataArrayOfObjs={c_pwinColorsArrayOfObjs}
                p_aedTableObj={pwinColorsAedTableObj}
              />
            </div>
            <div className="flex11a medFullPad" style={{margin:"0 1em", border:"solid 1px #ddd"}}>
              <div className="textCenter smallBottomMargin">
                <font className="font12 fontItalic">
                  {"Examples to show PWin color ranges:"}
                </font>
              </div>
              {examplePercentsArray.map((m_percent) =>
                <div key={m_percent} className="displayFlexColumnHcVc microTopMargin microBottomMargin">
                  {this.props.DatabaseMobx.value_mask_from_value_raw_and_field_type_obj(m_percent, pwinFieldTypeObj)}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}));


export const PwinCalculatedGraph = inject("AdminMobx", "DatabaseMobx")(observer(
class PwinCalculatedGraph extends Component { //props: none
  compute_calc_line_obj(i_x1_0to100, i_x2_0to100, i_y1_0to100, i_y2_0to100, i_lineColor, i_gridXStartP, i_gridXEndP, i_gridYStartP, i_gridYEndP) {
    return({
      x1p: JSFUNC.two_point_interpolation(0, 100, i_gridXStartP, i_gridXEndP, i_x1_0to100),
      x2p: JSFUNC.two_point_interpolation(0, 100, i_gridXStartP, i_gridXEndP, i_x2_0to100),
      y1p: JSFUNC.two_point_interpolation(0, 100, i_gridYStartP, i_gridYEndP, i_y1_0to100),
      y2p: JSFUNC.two_point_interpolation(0, 100, i_gridYStartP, i_gridYEndP, i_y2_0to100),
      color: i_lineColor
    });
  }

  render() {
    const c_companyPwinCalcMinThreshScore = this.props.DatabaseMobx.c_companyPwinCalcMinThreshScore;
    const c_companyPwinCalcMinThreshPwin = this.props.DatabaseMobx.c_companyPwinCalcMinThreshPwin;
    const c_companyUsingCalculatedPwinMinimumThresholdSwitchIsOnTF = this.props.DatabaseMobx.c_companyUsingCalculatedPwinMinimumThresholdSwitchIsOnTF;
    const c_pwinCalcLinesSortedArrayOfObjs = this.props.DatabaseMobx.c_pwinCalcLinesSortedArrayOfObjs;

    const numCalcLines = c_pwinCalcLinesSortedArrayOfObjs.length;

    const gridColor = "#999";
    const gridWidthEm = 0.2;
    const gridLabelFontSize = "1.5em";
    const minThreshLineColor = "#922";
    const minThreshLineWidthP = 1;
    const calcLineColor = "#292";
    const calcHConnectorLineColor = "#595";
    const calcUnusedLineColor = "#cdc";
    const calcLineWidthP = 1;

    //grid
    const gridXStartP = 6;
    const gridXEndP = 95;
    const gridYStartP = 95;
    const gridYEndP = 5;

    const xGridPercentsArray = [0, 20, 40, 60, 80, 100];
    const yGridPercentsArray = [0, 20, 40, 60, 80, 100];

    var xGridPArray = [];
    for(let xGridPercent of xGridPercentsArray) {
      xGridPArray.push(JSFUNC.two_point_interpolation(0, 100, gridXStartP, gridXEndP, xGridPercent));
    }

    var yGridPArray = [];
    for(let yGridPercent of yGridPercentsArray) {
      yGridPArray.push(JSFUNC.two_point_interpolation(0, 100, gridYStartP, gridYEndP, yGridPercent));
    }

    //calc lines
    var calcLinePArrayOfObjs = [];
    for(let c = 0; c < numCalcLines; c++) {
      var currentCalcLineObj = c_pwinCalcLinesSortedArrayOfObjs[c];
      var cx1 = currentCalcLineObj.progress_x1;
      var cx2 = currentCalcLineObj.progress_x2;
      var cy1 = currentCalcLineObj.pwin_y1;
      var cy2 = currentCalcLineObj.pwin_y2;

      var lineX1 = undefined;
      var lineX2 = undefined;
      var lineY1 = undefined;
      var lineY2 = undefined;

      if((c === 0) && (cx1 > 0) && (cx1 > c_companyPwinCalcMinThreshScore)) {
        var horiz0X1 = Math.max(0, c_companyPwinCalcMinThreshScore);
        var horiz0X2 = cx1;
        var horiz0Y1 = cy1;
        var horiz0Y2 = cy1;
        calcLinePArrayOfObjs.push(this.compute_calc_line_obj(horiz0X1, horiz0X2, horiz0Y1, horiz0Y2, calcHConnectorLineColor, gridXStartP, gridXEndP, gridYStartP, gridYEndP));
      }

      if(c > 0) {
        var prevCalcLineObj = c_pwinCalcLinesSortedArrayOfObjs[c - 1];
        var px1 = prevCalcLineObj.progress_x1;
        var px2 = prevCalcLineObj.progress_x2;
        var py1 = prevCalcLineObj.pwin_y1;
        var py2 = prevCalcLineObj.pwin_y2;

        if((cx1 > 0) && (cx1 > c_companyPwinCalcMinThreshScore) && (cx1 > px2)) {
          var horizX1 = Math.max(0, c_companyPwinCalcMinThreshScore, px2);
          var horizX2 = cx1;
          var horizY1 = cy1;
          var horizY2 = cy1;
          calcLinePArrayOfObjs.push(this.compute_calc_line_obj(horizX1, horizX2, horizY1, horizY2, calcHConnectorLineColor, gridXStartP, gridXEndP, gridYStartP, gridYEndP));
        }

        if((c === (numCalcLines - 1)) && (cx2 < 100)) { //last defined calc line
          calcLinePArrayOfObjs.push(this.compute_calc_line_obj(cx2, 100, cy2, cy2, calcHConnectorLineColor, gridXStartP, gridXEndP, gridYStartP, gridYEndP));
        }
      }

      if((cx1 < c_companyPwinCalcMinThreshScore) && c_companyUsingCalculatedPwinMinimumThresholdSwitchIsOnTF) { //any of this line is in the red, draw that part of the line unused
        var redX1 = cx1;
        var redX2 = undefined;
        var redY1 = cy1;
        var redY2 = undefined;
        if(cx2 < c_companyPwinCalcMinThreshScore) { //line starts and ends in red
          redX2 = cx2;
          redY2 = cy2;
        }
        else { //line starts in red and ends outside
          redX2 = c_companyPwinCalcMinThreshScore;
          redY2 = JSFUNC.two_point_interpolation(cx1, cx2, cy1, cy2, c_companyPwinCalcMinThreshScore);
          calcLinePArrayOfObjs.push(this.compute_calc_line_obj(redX2, cx2, redY2, cy2, calcLineColor, gridXStartP, gridXEndP, gridYStartP, gridYEndP));
        }
        calcLinePArrayOfObjs.push(this.compute_calc_line_obj(redX1, redX2, redY1, redY2, calcUnusedLineColor, gridXStartP, gridXEndP, gridYStartP, gridYEndP));
      }
      else {
        calcLinePArrayOfObjs.push(this.compute_calc_line_obj(cx1, cx2, cy1, cy2, calcLineColor, gridXStartP, gridXEndP, gridYStartP, gridYEndP));
      }

    }

    //min threshold line
    const minThreshXStartP = gridXStartP;
    const minThreshXEndP = JSFUNC.two_point_interpolation(0, 100, gridXStartP, gridXEndP, c_companyPwinCalcMinThreshScore);
    const minThreshYStartP = JSFUNC.two_point_interpolation(0, 100, gridYStartP, gridYEndP, c_companyPwinCalcMinThreshPwin);
    const minThreshYEndP = minThreshYStartP;

    return(
      <svg width="100%" height="40em">
        {xGridPArray.map((m_xGridP, m_index) =>
          <>
            <LibraryReact.SvgVLine p_y1p={gridYStartP} p_y2p={gridYEndP} p_xcp={m_xGridP} p_widthEm={gridWidthEm} p_color={gridColor} />
            <text x={(m_xGridP - 1) + "%"} y={(gridYStartP + 4) + "%"} fill={gridColor} style={{fontSize:gridLabelFontSize}}>{xGridPercentsArray[m_index] + "%"}</text>
          </>
        )}
        {yGridPArray.map((m_yGridP, m_index) =>
          <>
            <LibraryReact.SvgHLine p_x1p={gridXStartP} p_x2p={gridXEndP} p_ycp={m_yGridP} p_widthEm={gridWidthEm} p_color={gridColor} />
            <text x={(gridXStartP - 5) + "%"} y={(m_yGridP + 2) + "%"} fill={gridColor} style={{fontSize:gridLabelFontSize}}>{yGridPercentsArray[m_index] + "%"}</text>
          </>
        )}
        {calcLinePArrayOfObjs.map((m_calcLinePObj) =>
          <line x1={m_calcLinePObj.x1p + "%"} x2={m_calcLinePObj.x2p + "%"} y1={m_calcLinePObj.y1p + "%"} y2={m_calcLinePObj.y2p + "%"} style={{stroke:m_calcLinePObj.color, strokeWidth:calcLineWidthP + "%"}} />
        )}
        <line x1={minThreshXStartP + "%"} x2={minThreshXEndP + "%"} y1={minThreshYStartP + "%"} y2={minThreshYEndP + "%"} style={{stroke:minThreshLineColor, strokeWidth:minThreshLineWidthP + "%"}} />
      </svg>
    );
  }
}));





//=================================================================================================================================================================
//=================================================================================================================================================================



export const AdminSubtabProgressColors = inject("AdminMobx", "DatabaseMobx")(observer(
class AdminSubtabProgressColors extends Component { //props: none
  render() {
    const aedTableObj = {
      tblName: "tbl_a_shaping_progress_colors",
      initialSortedFieldDbName: "percent_start",
      tableWidth: "35em",
      itemName: "Progress Color",
      deleteItemNameFieldDbName: "percent_start",
      fieldsArrayOfObjs: [
        {width:"200em", dbName:"color", displayName:"Color", fieldTypeObj:this.props.DatabaseMobx.c_genericColorFieldTypeObj, initialValue:"DD2222", requiredNotEmptyTF:true},
        {width:"100em", dbName:"percent_start", displayName:"Percent Start", fieldTypeObj:this.props.DatabaseMobx.c_genericPercentInt0to100FieldTypeObj, initialValue:0, cellCenterTF:true, requiredNotEmptyTF:true},
        {width:"100em", dbName:"font_color", displayName:"Font Color", fieldTypeObj:this.props.DatabaseMobx.c_selectAdminFontColorFieldTypeObj, initialValue:"2a2a2a", cellCenterTF:true, requiredNotEmptyTF:true}
      ]
    };

    var examplePercentsArray = [0];
    for(let colorObj of this.props.DatabaseMobx.c_shapingProgressColorsArrayOfObjs) {
      var colorStart = colorObj.percent_start;
      var colorStartM1 = (colorStart - 1);
      if(colorStartM1 > 0 && !JSFUNC.in_array(colorStartM1, examplePercentsArray)) {
        examplePercentsArray.push(colorStartM1);
      }

      if(!JSFUNC.in_array(colorStart, examplePercentsArray)) {
        examplePercentsArray.push(colorStart);
      }
    }

    if(!JSFUNC.in_array(100, examplePercentsArray)) {
      examplePercentsArray.push(100);
    }

    return (
      <div className="flex11a xyScroll yScrollBottomPad">
        <div className="displayFlexRow medFullMargin">
          <div className="flex00a">
            <CEComplexReact.AddEditDeleteTable
              p_dataArrayOfObjs={this.props.DatabaseMobx.c_shapingProgressColorsArrayOfObjs}
              p_aedTableObj={aedTableObj}
            />
          </div>
          <div className="flex00a medFullPad" style={{flexBasis:"16em", marginLeft:"2em", border:"solid 1px #ddd"}}>
            <LibraryReact.DivFont p_class="smallBottomMargin textCenter" p_fontClass="font12 fontItalic">
              {"Examples to show progress bar color ranges:"}
            </LibraryReact.DivFont>
            {examplePercentsArray.map((m_percent) =>
              <div key={m_percent} className="microTopMargin microBottomMargin">
                {this.props.DatabaseMobx.value_mask_from_value_raw_and_field_type_obj(m_percent, this.props.DatabaseMobx.c_genericProgressBarShapingFieldTypeObj)}
              </div>
            )}
            <LibraryReact.DivFont p_class="hugeTopMargin microBottomMargin textCenter" p_fontClass="fontItalic fontTextLighter">
              {"Example negative percentage"}
            </LibraryReact.DivFont>
            <LibraryReact.DivFont p_class="microTopMargin microBottomMargin" p_fontClass="">
              {this.props.DatabaseMobx.value_mask_from_value_raw_and_field_type_obj(-40, this.props.DatabaseMobx.c_genericProgressBarShapingFieldTypeObj)}
            </LibraryReact.DivFont>
          </div>
        </div>
      </div>
    );
  }
}));




//=================================================================================================================================================================
//=================================================================================================================================================================



export const AdminSubtabUpcomingDateColors = inject("CaptureExecMobx", "AdminMobx", "DatabaseMobx")(observer(
class AdminSubtabUpcomingDateColors extends Component { //props: none
  render() {
    const c_productStylingObj = this.props.CaptureExecMobx.c_productStylingObj;

    return (
      <div className="flex11a displayFlexRow xyScroll">
        <div className="flex00a borderR1bbb lrMedPad" style={{flexBasis:"60em"}}>
          <LibraryReact.DivFont p_class="smallTopMargin microBottomMargin lrMedPad textCenter" p_fontClass="font13">
            {"Upcoming Date Color Set #1"}
          </LibraryReact.DivFont>
          <div className="microBottomMargin lrMedPad textCenter">
            <font className="fontItalic fontTextLight">
              {c_productStylingObj.productName + " uses this color set for "}
              <font className="fontUnderline">{"Task due dates"}</font>{", "}
              <font className="fontUnderline">{"Conversation dates"}</font>{", and "}
              <font className="fontUnderline">{"Contract/Budget need by dates"}</font>
            </font>
          </div>
          <LibraryReact.DivFont p_class="smallBottomMargin lrMedPad textCenter" p_fontClass="fontItalic fontTextLight">
            {"You can also create custom Date or Date/Time fields with this color set"}
          </LibraryReact.DivFont>
          <DateDayMdyDaysUntilOverdueAEDTableWithExamples
            p_tblDataArrayOfObjs={this.props.DatabaseMobx.c_dateUpcomingColors1ArrayOfObjs}
            p_dateDayMdyDaysUntilOverdueFieldTypeObj={this.props.DatabaseMobx.c_genericDateDayMdyDaysUntil1OverdueFieldTypeObj}
            p_tblName="tbl_a_date_upcoming_colors1"
            p_itemName="Upcoming Date Color #1"
          />
        </div>
        <div className="flex00a borderR1bbb lrMedPad" style={{flexBasis:"60em"}}>
          <LibraryReact.DivFont p_class="smallTopMargin microBottomMargin lrMedPad textCenter" p_fontClass="font13">
            {"Upcoming Date Color Set #2"}
          </LibraryReact.DivFont>
          <LibraryReact.DivFont p_class="microBottomMargin lrMedPad textCenter" p_fontClass="fontItalic fontTextLight">
            {c_productStylingObj.productName + " uses this color set for the "}
            <span className="fontUnderline">{"Proposal Due Date/Time"}</span>{" Capture Field"}
          </LibraryReact.DivFont>
          <LibraryReact.DivFont p_class="smallBottomMargin lrMedPad textCenter" p_fontClass="fontItalic fontTextLight">
            {"You can also create custom Date or Date/Time fields with this color set"}
          </LibraryReact.DivFont>
          <DateDayMdyDaysUntilOverdueAEDTableWithExamples
            p_tblDataArrayOfObjs={this.props.DatabaseMobx.c_dateUpcomingColors2ArrayOfObjs}
            p_dateDayMdyDaysUntilOverdueFieldTypeObj={this.props.DatabaseMobx.c_genericDateDayMdyDaysUntil2OverdueFieldTypeObj}
            p_tblName="tbl_a_date_upcoming_colors2"
            p_itemName="Upcoming Date Color #2"
          />
        </div>
      </div>
    );
  }
}));


const DateDayMdyDaysUntilOverdueAEDTableWithExamples = inject("AdminMobx", "DatabaseMobx")(observer(
class DateDayMdyDaysUntilOverdueAEDTableWithExamples extends Component { //props: p_tblDataArrayOfObjs, p_dateDayMdyDaysUntilOverdueFieldTypeObj, p_tblName, p_itemName
  render() {
    const p_tblDataArrayOfObjs = this.props.p_tblDataArrayOfObjs;
    const p_dateDayMdyDaysUntilOverdueFieldTypeObj = this.props.p_dateDayMdyDaysUntilOverdueFieldTypeObj
    const p_tblName = this.props.p_tblName;
    const p_itemName = this.props.p_itemName;

    const aedTableObj = {
      tblName: p_tblName,
      dragToResortFieldDbName: undefined,
      initialSortedFieldDbName: "days_before_due",
      tableWidth: "40em",
      itemName: p_itemName,
      deleteItemNameFieldDbName: "name",
      fieldsArrayOfObjs: [
        {width:"100em", dbName:"days_before_due", displayName:"# Days Before Due", fieldTypeObj:this.props.DatabaseMobx.c_genericIntFieldTypeObj, initialValue:0, cellCenterTF:true, requiredNotEmptyTF:true},
        {width:"100em", dbName:"color", displayName:"Color", fieldTypeObj:this.props.DatabaseMobx.c_genericColorFieldTypeObj, initialValue:"bbbbbb", requiredNotEmptyTF:true},
        {width:"100em", dbName:"font_color", displayName:"Font Color", fieldTypeObj:this.props.DatabaseMobx.c_selectAdminFontColorFieldTypeObj, initialValue:"2a2a2a", cellCenterTF:true, requiredNotEmptyTF:true}
      ]
    };

    var daysUntilDueArray = [];
    for(let d = -7; d < 60; d++) {
      daysUntilDueArray.push(d);
    }
    for(let d = 60; d < 1500; d+=28) {
      daysUntilDueArray.push(d);
    }

    var ymdDatesArray = [];
    for(let d of daysUntilDueArray) {
      var shiftedDateObj = new Date();
      shiftedDateObj.setDate(shiftedDateObj.getDate() + d);
      var shiftedYear = shiftedDateObj.getFullYear();
      var shiftedMonth = JSFUNC.zero_pad_integer_from_left((shiftedDateObj.getMonth() + 1), 2);
      var shiftedDate = JSFUNC.zero_pad_integer_from_left(shiftedDateObj.getDate(), 2);
      ymdDatesArray.push(shiftedYear + "-" + shiftedMonth + "-" + shiftedDate);
    }

    return (
      <div className="displayFlexRow">
        <div className="flex00a">
          <CEComplexReact.AddEditDeleteTable
            p_dataArrayOfObjs={p_tblDataArrayOfObjs}
            p_aedTableObj={aedTableObj}
          />
        </div>
        <div className="flex00a lrMargin" />
        <div className="flex00a border1ddd medFullPad" style={{flexBasis:"17em"}}>
          {ymdDatesArray.map((m_ymdDate) =>
            <div>
              {this.props.DatabaseMobx.value_mask_from_value_raw_and_field_type_obj(m_ymdDate, p_dateDayMdyDaysUntilOverdueFieldTypeObj)}
            </div>
          )}
        </div>
      </div>
    );
  }
}));





//=================================================================================================================================================================
//=================================================================================================================================================================



export const AdminSubtabDeleteCaptureReasons = inject("AdminMobx", "DatabaseMobx")(observer(
class AdminSubtabDeleteCaptureReasons extends Component { //props: none
  render() {
    const deleteCaptureReasonsArrayOfObjs = this.props.AdminMobx.c_deleteCaptureReasonsArrayOfObjs;

    const aedTableObj = {
      tblName: "tbl_a_delete_capture_reasons",
      dragToResortFieldDbName: "admin_sort",
      initialSortedFieldDbName: "admin_sort",
      tableWidth: "60em",
      itemName: "Delete Capture Reason",
      deleteItemNameFieldDbName: "name",
      fieldsArrayOfObjs: [
        {width:"100em", dbName:"name", displayName:"Reason", fieldTypeObj:this.props.DatabaseMobx.c_genericTextFieldTypeObj, initialValue:"", cellHoverTF:true, requiredNotEmptyTF:true},
        {width:"3em", dbName:"admin_sort", displayName:"Admin Sort", fieldTypeObj:this.props.DatabaseMobx.c_genericIntPositiveFieldTypeObj, initialValue:1}
      ]
    };

    return (
      <div className="flex11a xyScroll yScrollBottomPad">
        <div className="medFullMargin">
          <CEComplexReact.AddEditDeleteTable
            p_dataArrayOfObjs={deleteCaptureReasonsArrayOfObjs}
            p_aedTableObj={aedTableObj}
          />
        </div>
      </div>
    );
  }
}));





//=================================================================================================================================================================
//=================================================================================================================================================================



export const AdminSubtabQuestionTags = inject("AdminMobx", "DatabaseMobx")(observer(
class AdminSubtabQuestionTags extends Component { //props: none
  render() {
    const aedTableObj = {
      tblName: "tbl_a_shaping_questions_tags",
      dragToResortFieldDbName: undefined,
      initialSortedFieldDbName: "name",
      tableWidth: "60em",
      itemName: "Question Tag",
      deleteItemNameFieldDbName: "name",
      fieldsArrayOfObjs: [
        {width:"150em", dbName:"name", displayName:"Tag", fieldTypeObj:this.props.DatabaseMobx.c_genericTextFieldTypeObj, initialValue:"", cellHoverTF:true, requiredNotEmptyTF:true},
        {width:"100em", dbName:"hover_text", displayName:"Hover Help Text", fieldTypeObj:this.props.DatabaseMobx.c_genericTextFieldTypeObj, initialValue:"", cellHoverTF:true}
      ]
    };

    return (
      <div className="flex11a xyScroll yScrollBottomPad">
        <div className="medFullMargin">
          <CEComplexReact.AddEditDeleteTable
            p_dataArrayOfObjs={this.props.AdminMobx.c_shapingQuestionTagsArrayOfObjs}
            p_aedTableObj={aedTableObj}
          />
        </div>
      </div>
    );
  }
}));




//=================================================================================================================================================================
//=================================================================================================================================================================



export const AdminSubtabAdminChangelog = inject("AdminMobx", "DatabaseMobx", "UserMobx")(observer(
class AdminSubtabAdminChangelog extends Component { //props: none
  componentDidMount() {
    this.props.AdminMobx.a_load_admin_changelog_data();
  }

  render() {
    const o_adminChangelogLoadingDataOrErrorUndefinedTFU = this.props.AdminMobx.o_adminChangelogLoadingDataOrErrorUndefinedTFU;
    const c_expandedAdminChangelogArrayOfObjs = this.props.AdminMobx.c_expandedAdminChangelogArrayOfObjs;
    const c_selectAdminLogActionCodeFieldTypeObj = this.props.AdminMobx.c_selectAdminLogActionCodeFieldTypeObj;
    const c_genericTextFieldTypeObj = this.props.DatabaseMobx.c_genericTextFieldTypeObj;
    const c_genericDateTimeNaturalFieldTypeObj = this.props.DatabaseMobx.c_genericDateTimeNaturalFieldTypeObj;
    const c_selectUserDeactivatedHiddenUnlessCheckedFieldTypeObj = this.props.DatabaseMobx.c_selectUserDeactivatedHiddenUnlessCheckedFieldTypeObj;
    const o_userID = this.props.UserMobx.o_userID;

    const adminChangelogColumnsArrayOfObjs = [
      {valueRawDbName:"datetime_utc",       fieldTypeObjOrUndefined:c_genericDateTimeNaturalFieldTypeObj,   altMaskDbNameOrUndefined:undefined, columnDisplayName:"Date",             flex01:0, flexBasisEm:11.5, alignClassName:"", filterTypeOrUndefined:"minMaxDate",  filterMultiSelectMustIncludeValueOrFalseOrUndefined:undefined,  sortInitialIsAscTFOrUndefined:false},
      {valueRawDbName:"admin_action_code",  fieldTypeObjOrUndefined:c_selectAdminLogActionCodeFieldTypeObj, altMaskDbNameOrUndefined:undefined, columnDisplayName:"Action Category",  flex01:1, flexBasisEm:100,  alignClassName:"", filterTypeOrUndefined:"multiSelect", filterMultiSelectMustIncludeValueOrFalseOrUndefined:false,      sortInitialIsAscTFOrUndefined:undefined},
      {valueRawDbName:"field",              fieldTypeObjOrUndefined:c_genericTextFieldTypeObj,              altMaskDbNameOrUndefined:undefined, columnDisplayName:"Field",            flex01:1, flexBasisEm:200,  alignClassName:"", filterTypeOrUndefined:"searchText",  filterMultiSelectMustIncludeValueOrFalseOrUndefined:undefined,  sortInitialIsAscTFOrUndefined:undefined},
      {valueRawDbName:"value",              fieldTypeObjOrUndefined:c_genericTextFieldTypeObj,              altMaskDbNameOrUndefined:undefined, columnDisplayName:"New Value",        flex01:1, flexBasisEm:300,  alignClassName:"", filterTypeOrUndefined:"searchText",  filterMultiSelectMustIncludeValueOrFalseOrUndefined:undefined,  sortInitialIsAscTFOrUndefined:undefined},
      {valueRawDbName:"user_id",            fieldTypeObjOrUndefined:c_selectUserDeactivatedHiddenUnlessCheckedFieldTypeObj,               altMaskDbNameOrUndefined:undefined, columnDisplayName:"Changed By",       flex01:1, flexBasisEm:100,  alignClassName:"", filterTypeOrUndefined:"multiSelect", filterMultiSelectMustIncludeValueOrFalseOrUndefined:o_userID,   sortInitialIsAscTFOrUndefined:undefined}
    ];

    return (
      <CEGeneralReact.DataTableWithFiltersColSortPages
        p_dataTableDisplayName="Admin Changelog"
        p_dataTableDisplayShortName="Changelog"
        p_dataIsLoadingTF={(o_adminChangelogLoadingDataOrErrorUndefinedTFU === true)}
        p_dataLoadingErrorTF={(o_adminChangelogLoadingDataOrErrorUndefinedTFU === undefined)}
        p_dataArrayOfObjs={c_expandedAdminChangelogArrayOfObjs}
        p_uniqueIDColumnValueRawDbName="id"
        p_displayColumnsArrayOfObjs={adminChangelogColumnsArrayOfObjs}
        p_verticalDotsMenuItemsArrayOfObjsOrUndefined={undefined}
        p_numRowsPerPage={25}
        p_filterContainerWithEm={22}
        p_selectedBgColorClass="bgDarkOrangeGradient"
        p_selectedFontClass="fontWhite"
        p_canClickHoverColorClass="hoverLightOrangeGradient"
        f_onClickDataRow={undefined}
      />
    );
  }
}));






//=================================================================================================================================================================
//=================================================================================================================================================================



export const AdminSubtabOnPremise = inject("CaptureExecMobx")(observer(
class AdminSubtabOnPremise extends Component { //props: none
  constructor(props) {
    super(props);
    this.state = {
      s_authenticatedDate: "loading" //"loading", "2022-01-15", undefined
    };
  }

  componentDidMount() {
    this.verify_on_premise_customer_authentication_quarterly_passcode_file();
  }

  set_authenticated_date = (i_loadingDateOrUndefined) => {
    this.setState({s_authenticatedDate:i_loadingDateOrUndefined});
  }

  verify_on_premise_customer_authentication_quarterly_passcode_file = () => {
    this.set_authenticated_date("loading");

    const jsDescription = JSFUNC.js_description_from_action("AdminReact - AdminSubtabOnPremise", "verify_on_premise_customer_authentication_quarterly_passcode_file", [], []);
    const C_CallPhpScript = new JSPHP.ClassCallPhpScript("verifyOnPremiseCustomerAuthenticationQuarterlyPasscodeFile", jsDescription);
    C_CallPhpScript.add_return_vars("passcode");

    const functionOnSuccess = (i_parseResponse) => {
      var onPremiseAuthenticationExpirationDate = this.props.CaptureExecMobx.opa(i_parseResponse.passcode);
      this.set_authenticated_date(onPremiseAuthenticationExpirationDate);
    }
    C_CallPhpScript.add_function("onSuccess", functionOnSuccess);

    C_CallPhpScript.execute();
  }

  render() {
    const s_authenticatedDate = this.state.s_authenticatedDate;

    const c_productStylingObj = this.props.CaptureExecMobx.c_productStylingObj;

    var authenticationString = null;
    var bgColor = "999";
    var fontClass = "font12";
    if(JSFUNC.date_is_filled_out_tf(s_authenticatedDate)) {
      if(s_authenticatedDate >= JSFUNC.now_dateYmd()) {
        authenticationString = c_productStylingObj.productName + " On-Premise is authenticated through " + s_authenticatedDate;
        bgColor = "cfc";
      }
      else {
        authenticationString = c_productStylingObj.productName + " On-Premise has expired (" + s_authenticatedDate + ") and requires an Authentication Passcode file to continue use";
        bgColor = "fcc";
        fontClass += " fontDarkRed";
      }
    }
    else if(s_authenticatedDate === "loading") {
      authenticationString = "Verifying " + c_productStylingObj.productName + " On-Premise authentication";
      bgColor = "ddd";
      fontClass += " fontItalic";
    }
    else {
      authenticationString = c_productStylingObj.productName + " On-Premise requires an Authentication Passcode file to continue use";
      bgColor = "fcc";
      fontClass += " fontDarkRed";
    }

    return (
      <div className="flex11a xyScroll medFullPad">
        <div className="displayFlexColumnHcVc medFullMargin border1bbb bgLightestGray hugeTopPad hugeBottomPad lrHugePad" style={{width:"40em"}}>
          <div className="hugeBottomMargin textCenter">
            <font className="font14 fontBold fontTextLighter">
              {"On-Premise Authentication Passcode File"}
            </font>
          </div>
          <div className="displayFlexColumnHcVc width100 hugeBottomMargin border1444 medFullPad textCenter" style={{background:"#" + bgColor}}>
            {authenticationString}
            {(s_authenticatedDate === "loading") &&
              <div className="microTopMargin">
                <CEGeneralReact.LoadingAnimation />
              </div>
            }
          </div>
          <div className="smallBottomMargin textCenter">
            <font className="fontTextLight">
              {"Upload a newer Authentication File here"}
            </font>
          </div>
          <CEGeneralReact.OnPremiseUploadNewAuthenticationFile
            f_onUploadFile={this.verify_on_premise_customer_authentication_quarterly_passcode_file}
          />
        </div>
      </div>
    );
  }
}));





//=================================================================================================================================================================
//=================================================================================================================================================================





export const AdminSubtabMyAccount = inject("AdminMobx", "DatabaseMobx")(observer(
class AdminSubtabMyAccount extends Component { //props: none
  componentDidMount() {
    this.props.AdminMobx.a_my_account_load_stripe_data();
  }

  render() {
    const o_myAccountStripeDataLoadingTF = this.props.AdminMobx.o_myAccountStripeDataLoadingTF;
    const o_myAccountStripeDataErrorMessageOrUndefined = this.props.AdminMobx.o_myAccountStripeDataErrorMessageOrUndefined;
    const o_stripeCustomerDataObjOrUndefined = this.props.DatabaseMobx.o_stripeCustomerDataObjOrUndefined;

    if(o_myAccountStripeDataLoadingTF) {
      return("Loading...");
    }

    if(o_myAccountStripeDataErrorMessageOrUndefined !== undefined) {
      return("Error loading account data: " + o_myAccountStripeDataErrorMessageOrUndefined);
    }

    if(o_stripeCustomerDataObjOrUndefined === undefined) {
      return("Error loading account data.");
    }

    const initialPurchaseDateTimeUtc = o_stripeCustomerDataObjOrUndefined.initialPurchaseDateTimeUtc;
    const numLicensesPurchased = o_stripeCustomerDataObjOrUndefined.numLicensesPurchased;
    const currentPeriodStartDateTimeUtc = o_stripeCustomerDataObjOrUndefined.currentPeriodStartDateTimeUtc;
    const currentPeriodEndDateTimeUtc = o_stripeCustomerDataObjOrUndefined.currentPeriodEndDateTimeUtc;
    const upcomingInvoiceObj = o_stripeCustomerDataObjOrUndefined.upcomingInvoiceObj;
    const pastInvoicesArrayOfObjs = o_stripeCustomerDataObjOrUndefined.pastInvoicesArrayOfObjs;

    return(
      <div className="medFullMargin border1bbb medFullPad" style={{maxWidth:"40em"}}>
        <LibraryReact.DivFont p_class="smallBottomMargin" p_fontClass="font11 fontItalic">
          {"Upcoming Invoice"}
        </LibraryReact.DivFont>
        <div className="displayFlexRow borderB1ddd tbPad">
          <div className="flex11a lrPad">
            <font className="">
              {upcomingInvoiceObj.periodStartDateTimeUtc}
            </font>
          </div>
          <div className="flex11a lrPad">
            <font className="">
              {upcomingInvoiceObj.chargeDateTimeUtc}
            </font>
          </div>
          <div className="flex11a lrPad">
            <font className="">
              {upcomingInvoiceObj.totalDueFormatted}
            </font>
          </div>
          <div className="flex11a lrPad">
            <font className="">
              {upcomingInvoiceObj.paid01String}
            </font>
          </div>
        </div>
        <LibraryReact.DivFont p_class="hugeTopMargin smallBottomMargin" p_fontClass="font11 fontItalic">
          {"Past Invoices"}
        </LibraryReact.DivFont>
        {pastInvoicesArrayOfObjs.map((m_pastInvoiceObj) =>
          <div className="displayFlexRow borderB1ddd tbPad">
            <div className="flex11a lrPad">
              <font className="">
                {m_pastInvoiceObj.periodStartDateTimeUtc}
              </font>
            </div>
            <div className="flex11a lrPad">
              <font className="">
                {m_pastInvoiceObj.chargeDateTimeUtc}
              </font>
            </div>
            <div className="flex11a lrPad">
              <font className="">
                {m_pastInvoiceObj.totalDueFormatted}
              </font>
            </div>
            <div className="flex11a lrPad">
              <font className="">
                {m_pastInvoiceObj.paid01String}
              </font>
            </div>
          </div>
        )}
      </div>
    );
  }
}));






//=================================================================================================================================================================
//=================================================================================================================================================================
//=================================================================================================================================================================
//=================================================================================================================================================================
//=================================================================================================================================================================
//=================================================================================================================================================================
//=================================================================================================================================================================
//=================================================================================================================================================================
//=================================================================================================================================================================
//=================================================================================================================================================================




const AdminCaptureTypeSelectionBoxes = inject("AdminMobx", "DatabaseMobx")(observer(
class AdminCaptureTypeSelectionBoxes extends Component { //props: none
render() {
  this.props.AdminMobx.a_ensure_selected_capture_type_exists_or_select_first_capture_type();

  const c_adminCaptureTypesWithMatchingCapturesArrayOfObjs = this.props.AdminMobx.c_adminCaptureTypesWithMatchingCapturesArrayOfObjs;

  const atLeast1CaptureTypeTF = (c_adminCaptureTypesWithMatchingCapturesArrayOfObjs.length > 0);

  return (
    <div className="flex00a displayFlexRowVc border bevelBorderColors" style={{background:"#f3e0cb"}}>
      <div className="flex00a tbPad lrMedPad">
        <font className="font12 fontTextLight fontItalic">
          <div>{"Capture Type"}</div>
          <div>{"Selected for Editing"}</div>
        </font>
      </div>
      {(!atLeast1CaptureTypeTF) ? (
        <div className="flex11a smallFullPad">
          <font className="fontItalic fontTextLighter">
            {"--There are 0 created Capture Types in the system. Use the Admin System Setup subtab 'Capture Types' to create one--"}
          </font>
        </div>
      ) : (
        <div className="flex11a displayFlexRow tbPad xyScroll">
          {c_adminCaptureTypesWithMatchingCapturesArrayOfObjs.map((m_captureTypeObj) =>
            <AdminCaptureTypeSelectionSingleBox
              key={m_captureTypeObj.id}
              p_captureTypeObj={m_captureTypeObj}
            />
          )}
        </div>
      )}
    </div>
  );
}
}));

const AdminCaptureTypeSelectionSingleBox = inject("AdminMobx")(observer(
class AdminCaptureTypeSelectionSingleBox extends Component { //props: p_captureTypeObj
  onclick_capture_type_box = () => {
    const p_captureTypeObj = this.props.p_captureTypeObj;
    this.props.AdminMobx.a_fields_set_highlighted_field_id(undefined);
    this.props.AdminMobx.a_set_selected_capture_type_id(p_captureTypeObj.id);
  }

  render() {
    const p_captureTypeObj = this.props.p_captureTypeObj;

    const o_selectedCaptureTypeID = this.props.AdminMobx.o_selectedCaptureTypeID;

    const isSelectedTF = (p_captureTypeObj.id === o_selectedCaptureTypeID);

    return(
      <div
        className={"flex00a displayFlexRowVc lrMargin lrMedPad border bevelBorderColors textCenter " + ((isSelectedTF) ? ("bgOrangeGradient") : ("bgLightGrayGradient hoverLighterBlueGradient cursorPointer"))}
        style={{height:"3.8em", width:"11em"}}
        title={p_captureTypeObj.name}
        onClick={((isSelectedTF) ? (undefined) : (this.onclick_capture_type_box))}>
        <LibraryReact.MaxHeightWrap p_maxHeight="3.7em" p_fontClass={"font11 fontBold " + ((isSelectedTF) ? ("") : ("fontTextLighter"))}>
          {p_captureTypeObj.name}
        </LibraryReact.MaxHeightWrap>
      </div>
    );
  }
}));



const BlueItemCollectionShell = inject("AdminMobx")(observer(
class BlueItemCollectionShell extends Component { //props: p_isReceivingTF, p_title, p_dropUniqueString, p_dropNotAllowedDraggerIDsArray, p_dropMessage, p_dropAllowDropMessage, p_dropNotAllowDropMessage, f_onClickSetAsReceiving, f_onDrop, f_onRemoveAllItems, children
  render() {
    const p_isReceivingTF = this.props.p_isReceivingTF;
    const p_title = this.props.p_title;
    const p_dropUniqueString = this.props.p_dropUniqueString;
    const p_dropNotAllowedDraggerIDsArray = this.props.p_dropNotAllowedDraggerIDsArray;
    const p_dropMessage = this.props.p_dropMessage;
    const p_dropAllowDropMessage = this.props.p_dropAllowDropMessage;
    const p_dropNotAllowDropMessage = this.props.p_dropNotAllowDropMessage;
    const f_onClickSetAsReceiving = this.props.f_onClickSetAsReceiving;
    const f_onDrop = this.props.f_onDrop;
    const f_onRemoveAllItems = this.props.f_onRemoveAllItems;
    const children = this.props.children;

    const c_selectedCaptureTypeExistsTF = this.props.AdminMobx.c_selectedCaptureTypeExistsTF;

    return(
      <div
        className={"medTopMargin smallTopPad lrMedPad " + ((p_isReceivingTF) ? ("bgAdminCaptureTypeTableReceiving") : ("bgAdminCaptureTypeTable"))}
        style={{border:"solid 1px #ddd", borderRadius:"1em"}}>
        {(c_selectedCaptureTypeExistsTF) ? (
          <>
            <div className="displayFlexRow">
              <div className="flex11a">
                <font className="font12">
                  {p_title}
                </font>
              </div>
              {(JSFUNC.is_function(f_onRemoveAllItems)) &&
                <div className="flex00a displayFlexColumnHcVc" style={{height:"1.2em"}}>
                  <CEGeneralReact.DeleteMenu
                    p_message={["Are you sure you want to remove all items in this group?", "[This performs the same action as clicking the 'x' next to every item within this group]"]}
                    p_menuItemText="Remove All Items"
                    f_onDelete={f_onRemoveAllItems}
                  />
                </div>
              }
            </div>
            <div className="displayFlexRowVc tbMargin">
              <div className="flex00a" style={{flexBasis:"15em"}}>
                {(p_isReceivingTF) ? (
                  <LibraryReact.DivFont p_class="" p_fontClass="fontItalic fontTextLighter">
                    {"Receiving Added Items"}
                  </LibraryReact.DivFont>
                ) : (
                  <CEGeneralReact.CEButton
                    p_type="gray"
                    p_text="Set as Receiving"
                    f_onClick={f_onClickSetAsReceiving}
                  />
                )}
              </div>
              <div className="flex11a" style={{margin:"0 5%"}}>
                <BlueItemCollectionShellDropZone
                  p_dropUniqueString={p_dropUniqueString}
                  p_dropNotAllowedDraggerIDsArray={p_dropNotAllowedDraggerIDsArray}
                  p_dropMessage={p_dropMessage}
                  p_dropAllowDropMessage={p_dropAllowDropMessage}
                  p_dropNotAllowDropMessage={p_dropNotAllowDropMessage}
                  f_onDrop={f_onDrop}
                />
              </div>
            </div>
            {children}
          </>
        ) : (
          <LibraryReact.DivFont p_class="bigTopMargin bigBottomMargin textCenter" p_fontClass="font12 fontItalic fontTextLight">
            {"--A Capture Type must be created and selected (using the 'Capture Types' subtab) before adding these items to it--"}
          </LibraryReact.DivFont>
        )}
      </div>
    );
  }
}));

const BlueItemCollectionShellDropZone = inject("CaptureExecMobx")(observer(
class BlueItemCollectionShellDropZone extends Component { //props: p_dropUniqueString, p_dropNotAllowedDraggerIDsArray, p_dropMessage, p_dropAllowDropMessage, p_dropNotAllowDropMessage, f_onDrop
  render() {
    const p_dropUniqueString = this.props.p_dropUniqueString;
    const p_dropNotAllowedDraggerIDsArray = this.props.p_dropNotAllowedDraggerIDsArray;
    const p_dropMessage = this.props.p_dropMessage;
    const p_dropAllowDropMessage = this.props.p_dropAllowDropMessage;
    const p_dropNotAllowDropMessage = this.props.p_dropNotAllowDropMessage;
    const f_onDrop = this.props.f_onDrop;

    const o_ceDraggedItemObjOrUndefined = this.props.CaptureExecMobx.o_ceDraggedItemObjOrUndefined;

    //allow a drop from matching uniqueString dragged items that have an itemID not already added to this blue item collection
    var allowDropTF = false;
    if(o_ceDraggedItemObjOrUndefined !== undefined) {
      allowDropTF = ((p_dropUniqueString === o_ceDraggedItemObjOrUndefined.uniqueString) && !JSFUNC.in_array(o_ceDraggedItemObjOrUndefined.itemID, p_dropNotAllowedDraggerIDsArray));
    }

    const dragOverMatchingItemMessage = ((allowDropTF) ? (p_dropAllowDropMessage) : (p_dropNotAllowDropMessage));

    return(
      <CEGeneralReact.CEDropZone
        p_width="100%"
        p_heightEm={3}
        p_allowDropTF={allowDropTF}
        p_uniqueString={p_dropUniqueString}
        p_fileUploadIsProcessingTF={false}
        p_message={p_dropMessage}
        p_dragOverMatchingItemMessage={dragOverMatchingItemMessage}
        f_onDropMatchingItem={f_onDrop}
      />
    );
  }
}));




const TeamCompContactExtraFieldColumnManipulationTable = inject("ContactsMobx", "DatabaseMobx")(observer(
class TeamCompContactExtraFieldColumnManipulationTable extends Component { //props: p_tblName
  render() {
    const p_tblName = this.props.p_tblName;

    const o_tbl_a_teammates_extra_fields = this.props.DatabaseMobx.o_tbl_a_teammates_extra_fields;
    const o_tbl_a_competitors_extra_fields = this.props.DatabaseMobx.o_tbl_a_competitors_extra_fields;
    const c_contactsPersonsExtraFieldsArrayOfObjs = this.props.DatabaseMobx.c_contactsPersonsExtraFieldsArrayOfObjs;
    const c_contactsCompaniesExtraFieldsArrayOfObjs = this.props.DatabaseMobx.c_contactsCompaniesExtraFieldsArrayOfObjs;
    const c_companyTeammatesAllocOfCovAltFieldDisplayName = this.props.DatabaseMobx.c_companyTeammatesAllocOfCovAltFieldDisplayName;
    const c_companyTeammatesWorkshareTypeAltFieldDisplayName = this.props.DatabaseMobx.c_companyTeammatesWorkshareTypeAltFieldDisplayName;
    const c_companyTeammatesWorkshareNumFtesAltFieldDisplayName = this.props.DatabaseMobx.c_companyTeammatesWorkshareNumFtesAltFieldDisplayName;
    const c_companyTeammatesWorkshareNotesAltFieldDisplayName = this.props.DatabaseMobx.c_companyTeammatesWorkshareNotesAltFieldDisplayName;
    const c_fieldMapOfContractOverallValue = this.props.DatabaseMobx.c_fieldMapOfContractOverallValue;
    const c_teammatesAllocOfCovFieldDisplayName = this.props.DatabaseMobx.c_teammatesAllocOfCovFieldDisplayName;
    const c_teammatesWorkshareTypeFieldDisplayName = this.props.DatabaseMobx.c_teammatesWorkshareTypeFieldDisplayName;
    const c_teammatesWorkshareNumFtesFieldDisplayName = this.props.DatabaseMobx.c_teammatesWorkshareNumFtesFieldDisplayName;
    const c_teammatesWorkshareNotesFieldDisplayName = this.props.DatabaseMobx.c_teammatesWorkshareNotesFieldDisplayName;

    var renameSystemFieldDisplayNamesComponent = undefined;
    var aedTableLabel = "";
    var itemName = "";
    var hasFieldHoverTextColumnTF = false;
    var customFieldsArrayOfObjs = [];
    var alterDbTblColumnOnAddOrDeleteForTblName = undefined;
    var bgClass = "bgLighterGray";
    var titleComponent = null;
    var allFieldsArrayOfObjs = [];
    if(p_tblName === "tbl_a_contacts_persons_extra_fields" || p_tblName === "tbl_a_contacts_companies_extra_fields") {
      const isPersonTF = (p_tblName === "tbl_a_contacts_persons_extra_fields");
      const personCompanyString = ((isPersonTF) ? ("Person") : ("Company"));
      itemName = "Contact " + personCompanyString + " Custom Field";
      aedTableLabel = "Custom Contact " + personCompanyString + " Fields";
      hasFieldHoverTextColumnTF = false;
      customFieldsArrayOfObjs = ((isPersonTF) ? (c_contactsPersonsExtraFieldsArrayOfObjs) : (c_contactsCompaniesExtraFieldsArrayOfObjs));
      alterDbTblColumnOnAddOrDeleteForTblName = ((isPersonTF) ? ("tbl_g_contacts_persons") : ("tbl_g_contacts_companies"));
      bgClass = "bgContactsLighterYellow";
      titleComponent = (
        <div className="displayFlexRowVc smallBottomPad" style={{borderBottom:"solid 1px #ddd"}}>
          <div className="flex00a lrMedPad">
            <ContactsReact.CompanyOrPersonIcon p_isPersonTF={isPersonTF} p_sizeEm={3} />
          </div>
          <div className="flex11a lrMedPad">
            <font className="font12">
              {"All fields (system + custom) for a Contact " + personCompanyString}
            </font>
          </div>
        </div>
      );

      const contactFieldsArrayOfObjs = this.props.ContactsMobx.contact_fields_arrayOfObjs(isPersonTF);
      for(let contactFieldObj of contactFieldsArrayOfObjs) {
        if(contactFieldObj.db_name !== "tree_id") {
          allFieldsArrayOfObjs.push(contactFieldObj);
        }
      }
    }
    else if(p_tblName === "tbl_a_teammates_extra_fields") {
      renameSystemFieldDisplayNamesComponent = (
        <>
          <div className="microBottomMargin">
            <font className="font13 fontItalic">
              {"Teammate System Fields - Optional Alternative Display Names"}
            </font>
          </div>
          <div className="hugeBottomMargin border1bbb borderRadius15 bgAddEditDeleteTable tbBigPad lrMedPad" style={{maxWidth:"56em"}}>
            <div className="smallBottomMargin">
              <font className="fontItalic">
                {"Give optional alternative names to specific system Teammate fields [When left blank, the default name of the field is used]"}
              </font>
            </div>
            <div className="border1bbb bgLightestestGray smallFullPad">
              <TeammateRenameableSystemFieldRow
                p_companyRenameableTeammateAltFieldDbName="teammates_alloc_of_cov_alt_field_display_name"
                p_companyTeammatesAltFieldDisplayName={c_companyTeammatesAllocOfCovAltFieldDisplayName}
                p_teammateSystemFieldDisplayName={"Allocation % of " + c_fieldMapOfContractOverallValue.get("display_name")}
              />
              <TeammateRenameableSystemFieldRow
                p_companyRenameableTeammateAltFieldDbName="teammates_workshare_type_alt_field_display_name"
                p_companyTeammatesAltFieldDisplayName={c_companyTeammatesWorkshareTypeAltFieldDisplayName}
                p_teammateSystemFieldDisplayName="Workshare Type"
              />
              <TeammateRenameableSystemFieldRow
                p_companyRenameableTeammateAltFieldDbName="teammates_workshare_num_ftes_alt_field_display_name"
                p_companyTeammatesAltFieldDisplayName={c_companyTeammatesWorkshareNumFtesAltFieldDisplayName}
                p_teammateSystemFieldDisplayName="Workshare Number of FTEs"
              />
              <TeammateRenameableSystemFieldRow
                p_companyRenameableTeammateAltFieldDbName="teammates_workshare_notes_alt_field_display_name"
                p_companyTeammatesAltFieldDisplayName={c_companyTeammatesWorkshareNotesAltFieldDisplayName}
                p_teammateSystemFieldDisplayName="Workshare Notes"
              />
            </div>
          </div>
        </>
      );

      itemName = "Teammate Custom Field";
      aedTableLabel = "Custom Teammate Fields";
      hasFieldHoverTextColumnTF = true;
      customFieldsArrayOfObjs = JSFUNC.arrayOfObjs_from_mapOfMaps(o_tbl_a_teammates_extra_fields, "sort", true);
      alterDbTblColumnOnAddOrDeleteForTblName = "tbl_c_teammates";
      titleComponent = (
        <div className="tbMedPad" style={{borderBottom:"solid 1px #ddd"}}>
          <font className="font12">
            {"All fields (system + custom) for a Teammate"}
          </font>
        </div>
      );
      allFieldsArrayOfObjs = [
        {id:-1, display_name:"Teammate (Contact Company)"},
        {id:-2, display_name:"On Team Y/N"},
        {id:-3, display_name:c_teammatesAllocOfCovFieldDisplayName},
        {id:-4, display_name:c_teammatesWorkshareTypeFieldDisplayName},
        {id:-5, display_name:c_teammatesWorkshareNumFtesFieldDisplayName},
        {id:-6, display_name:c_teammatesWorkshareNotesFieldDisplayName},
        {id:-7, display_name:"Teammate Contracts Manager (Contact Person)"},
        {id:-8, display_name:"Teammate Contacts (Multiple Contact Persons)"}
      ];
      for(let teammateExtraFieldObj of customFieldsArrayOfObjs) {
        allFieldsArrayOfObjs.push({id:teammateExtraFieldObj.id, display_name:teammateExtraFieldObj.display_name});
      }
    }
    else if(p_tblName === "tbl_a_competitors_extra_fields") {
      itemName = "Competitor Custom Field";
      aedTableLabel = "Custom Competitor Fields";
      hasFieldHoverTextColumnTF = true;
      customFieldsArrayOfObjs = JSFUNC.arrayOfObjs_from_mapOfMaps(o_tbl_a_competitors_extra_fields, "sort", true);
      alterDbTblColumnOnAddOrDeleteForTblName = "tbl_c_competitors";
      titleComponent = (
        <div className="tbMedPad" style={{borderBottom:"solid 1px #ddd"}}>
          <font className="font12">
            {"All fields (system + custom) for a Competitor"}
          </font>
        </div>
      );
      allFieldsArrayOfObjs = [
        {id:-1, display_name:"Competitor (Contact Company)"},
        {id:-2, display_name:"Competitor's Teammates (Multiple Contact Companies)"},
        {id:-3, display_name:"Strengths"},
        {id:-4, display_name:"Weaknesses"},
        {id:-5, display_name:"Opportunities"},
        {id:-6, display_name:"Threats"}
      ];
      for(let competitorExtraFieldObj of customFieldsArrayOfObjs) {
        allFieldsArrayOfObjs.push({id:competitorExtraFieldObj.id, display_name:competitorExtraFieldObj.display_name});
      }
    }

    const insertItemFunction = (i_C_CallPhpTblUID, i_dataRowObj) => {
      const newColumnDbName = JSFUNC.db_name_from_display_name(i_dataRowObj.display_name);
      const newColumnFieldTypeObj = this.props.DatabaseMobx.c_genericTextFieldTypeObj;
      i_C_CallPhpTblUID.add_alter_db_tbl_insert_column(alterDbTblColumnOnAddOrDeleteForTblName, newColumnDbName, newColumnFieldTypeObj.mysqlColumnDataType, newColumnFieldTypeObj.blankValue);
    }

    const deleteItemFunction = (i_C_CallPhpTblUID, i_dataRowObj) => {
      i_C_CallPhpTblUID.add_alter_db_tbl_delete_column(alterDbTblColumnOnAddOrDeleteForTblName, i_dataRowObj.db_name);
    }

    const allExistingFieldDbNamesArray = JSFUNC.get_column_vector_from_arrayOfObjs(customFieldsArrayOfObjs, "db_name");

    const inputTypesValueArray = ["text", "textarea", "email", "phone", "website"];
    const inputTypesDisplayArray = ["Text", "Textarea", "Email", "Phone", "Website"];
    const inputTypesSwsOptionsObj = undefined;
    const selectWithSearchDataObj = this.props.DatabaseMobx.create_sws_data_obj_from_value_array_and_display_array("Input Type", inputTypesValueArray, true, inputTypesDisplayArray, inputTypesSwsOptionsObj);
    const selectInputTypeFieldTypeObj = this.props.DatabaseMobx.create_field_type_obj("select", selectWithSearchDataObj);

    var aedTableFieldArrayOfObjs = [];
    aedTableFieldArrayOfObjs.push({width:"150em", dbName:"display_name", displayName:itemName + " Name", fieldTypeObj:this.props.DatabaseMobx.c_genericTextFieldTypeObj, initialValue:"", cellHoverTF:true, requiredNotEmptyTF:true, requiredUniqueDbNameArray:allExistingFieldDbNamesArray, inputMaxChars:60});
    aedTableFieldArrayOfObjs.push({width:"100em", dbName:"input_type", displayName:"Input Type", fieldTypeObj:selectInputTypeFieldTypeObj, initialValue:"text", requiredNotEmptyTF:true});
    if(hasFieldHoverTextColumnTF) {
      aedTableFieldArrayOfObjs.push({width:"100em", dbName:"hover_text", displayName:"Hover Help Text", fieldTypeObj:this.props.DatabaseMobx.c_genericTextFieldTypeObj, initialValue:"", cellHoverTF:true});
    }
    aedTableFieldArrayOfObjs.push({width:"3em", dbName:"sort", displayName:"Sort", fieldTypeObj:this.props.DatabaseMobx.c_genericIntPositiveFieldTypeObj, initialValue:1});

    const aedTableObj = {
      tblName: p_tblName,
      dragToResortFieldDbName: "sort",
      initialSortedFieldDbName: "sort",
      tableWidth: "100%",
      itemName: itemName,
      deleteItemNameFieldDbName: "display_name",
      newItemAddDbNameColumnFromDisplayNameTF: true,
      itemInsertFunctionsArray: [insertItemFunction],
      itemDeleteFunctionsArray: [deleteItemFunction],
      fieldsArrayOfObjs: aedTableFieldArrayOfObjs
    };

    return(
      <div className="displayFlexRow">
        <div className="flex11a medFullMargin" style={{flexBasis:"100em"}}>
          {renameSystemFieldDisplayNamesComponent}
          <div className="microBottomMargin">
            <font className="font13 fontItalic">
              {aedTableLabel}
            </font>
          </div>
          <CEComplexReact.AddEditDeleteTable
            p_dataArrayOfObjs={customFieldsArrayOfObjs}
            p_aedTableObj={aedTableObj}
          />
        </div>
        <div className="flex11a medFullMargin" style={{flexBasis:"100em"}}>
          <div className={"medFullPad " + bgClass} style={{border:"solid 1px #ccc"}}>
            {titleComponent}
            <div className="smallTopMargin" />
            {allFieldsArrayOfObjs.map((m_fieldObj) =>
              <LibraryReact.DivFont p_class="microTopMargin" p_fontClass={"font11 fontItalic " + ((m_fieldObj.id > 0) ? ("fontBold") : (""))}>
                {m_fieldObj.display_name}
              </LibraryReact.DivFont>
            )}
          </div>
        </div>
      </div>
    );
  }
}));


const TeammateRenameableSystemFieldRow = inject("AdminMobx", "DatabaseMobx")(observer(
class TeammateRenameableSystemFieldRow extends Component { //props: p_companyRenameableTeammateAltFieldDbName, p_companyTeammatesAltFieldDisplayName, p_teammateSystemFieldDisplayName
  onsavechanged_teammate_field_alt_display_name = (i_newValueString) => {
    const p_companyRenameableTeammateAltFieldDbName = this.props.p_companyRenameableTeammateAltFieldDbName;
    this.props.AdminMobx.a_update_tbl_a_company_fields(p_companyRenameableTeammateAltFieldDbName, i_newValueString, "s");
  }

  render() {
    const p_companyRenameableTeammateAltFieldDbName = this.props.p_companyRenameableTeammateAltFieldDbName;
    const p_companyTeammatesAltFieldDisplayName = this.props.p_companyTeammatesAltFieldDisplayName;
    const p_teammateSystemFieldDisplayName = this.props.p_teammateSystemFieldDisplayName;

    return(
      <CEGeneralReact.CaptureExecFieldEditSaveCancel
        p_ceEditItemString={"adminTeammateAlt" + p_companyRenameableTeammateAltFieldDbName}
        p_fieldDisplayName={p_teammateSystemFieldDisplayName}
        p_fieldTypeObj={this.props.DatabaseMobx.c_genericTextFieldTypeObj}
        p_valueRaw={p_companyTeammatesAltFieldDisplayName}
        p_valueIsEditableTFU={true}
        p_fieldClass="fontBlue"
        p_fieldWidth="18em"
        f_onSaveChanged={this.onsavechanged_teammate_field_alt_display_name}
      />
    );
  }
}));
